const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "Tsukuyomi Background",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "Failed to publish due to excessive scene assets. Please delete some assets and try again.",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "Currently no permission to access membership-related features",
  T_12_I_GIFT_SENDER_BELL: "Bell",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: `Now you see him, now you don'
t. [FFB300](Hides Helmet)[-]`,
  T_12_L_ACCESSORY_COS_SANTAHEAD: "Old Man's Mask",
  T_12_L_COS_PINKMAN: "Pink Dino",
  T_12_L_COS_POLAR: "Polar Bear",
  T_12_L_COS_RENDER: "Rainbow Dino",
  T_12_L_COS_TIGER: "Tiger Suit",
  T_12_L_MALE_BOTTOM_COS_ELF: "Winter Elf (Bottom)",
  T_12_L_MALE_COS_SANTA: "Grumpy Old Man",
  T_12_L_MALE_HAIR_COS_ELF: "Winter Elf (Head)",
  T_12_L_MALE_SHOE_COS_ELF: "Winter Elf (Shoes)",
  T_12_L_MALE_TOP_COS_ELF: "Winter Elf (Top)",
  T_12_O_CAT_NAME: "Kitty",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014 - Winterlands",
  T_12_O_MACHETE_GOLD_NAME: "Parang - Golden Blade",
  T_12_O_PET_TITLE: "PET",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "Jumping Shoes",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "Shoes made with modern technology. Allows humans to preform double-jumps.",
  T_12_Q_ITEM_FLYSHOE: "Jet Pack Shoes",
  T_12_Q_ITEM_FLYSHOE_DESC: "Shoes that allows the user to fly. Try not to run out of fuel mid air.",
  T_12_Q_ITEM_STOCK1: "Stock Lv. 1",
  T_12_Q_ITEM_STOCK2: "Stock Lv. 2",
  T_12_Q_ITEM_STOCK3: "Stock Lv. 3",
  T_12_Q_ITEM_TREATMENTGUN: "Heal Pistol",
  T_12_Q_ITEM_VEST4: "Vest Lv. 4",
  T_12_R_CHARACTER_GANGLEADER_NAME: "Antonio",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "Wukong",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "Shoot Dance",
  T_12_R_EMOTE_WAVE_NAME: "Arm Wave",
  T_12_R_SKILL_NAME_GANGLEADER: "Gangster's Spirit",
  T_12_R_SKILL_NAME_MONKEYGOD: "Camouflage",
  T_13_I_COLLECTION_V_AMPHIBIAN: "Amphibian",
  T_13_I_COLLECTION_V_JEEP: "Jeep",
  T_13_I_COLLECTION_V_MONSTER: "Monster Truck",
  T_13_I_COLLECTION_V_MOTOBIKE: "Motorbike",
  T_13_I_COLLECTION_V_ROADSTER: "Sports Car",
  T_13_I_COLLECTION_V_SUV: "Pickup Truck",
  T_13_I_COLLECTION_V_TUTU: "Tuk Tuk",
  T_13_L_MALE_ACCESSORY_COS_BJD: "Arctic Blue (Mask)",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "Love in the Air (Bottom)",
  T_13_L_MALE_HAIR_COS_BJD: "Arctic Blue (Head)",
  T_13_L_MALE_TOP_COS_VALENTINE: "Love in the Air (Top)",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "Weapon",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "Pet Skin: Detective Kitty",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR - Cupid",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "Moco",
  T_13_R_EMOTE_BABYSHARK_NAME: "Baby Shark",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "Push-up",
  T_13_R_EMOTE_EGYPT_NAME: "Mummy Dance",
  T_13_R_PVE_WEAPON_SLOT: "Weapon Slot",
  T_13_R_PVE_WEAPONSKIN_RANGE: "Effective Range",
  T_13_R_PVE_WEAPONSKIN_SPEED: "Rate of Fire",
  T_13_R_SKILL_DESC_HACKERGIRL: "Tag hit enemies for [FFB300]{0}s[-]. Info will be shared with teammates.",
  T_13_R_SKILL_NAME_HACKERGIRL: "Hacker's Eye",
  T_13_Z_KICKOFF_BAN: "BAN",
  T_13_Z_ROOM_MORNING: "Day",
  T_13_Z_ROOM_NIGHT: "Night",
  T_14_G_ITEM_KATANA: "Katana",
  T_14_I_HEADPIC_SONGKRAN_NAME: "SPLASH!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "Cubic Bunny",
  T_14_L_COS_EASTER: "Observer 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "Lady of Flame (Shoes)",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "Bunny Warrior (Mask)",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47 - Water Balloon",
  T_14_O_DOG_NAME: "Mechanical Pup",
  T_14_O_PETSKIN_IRON_DOG_NAME: "Pet Skin: Full Steel Pup",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "Pet Skin: Lightning Pup",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "Pet Skin: Magnetic Pup",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "Pet Skin: Night Kitty",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR - Blood Moon",
  T_14_O_SCAR_SHARK_NAME: "SCAR - Shark Attack",
  T_14_Q_ITEM_RGS50: "RGS-50",
  T_14_R_CHARACTER_SAMURAI_NAME: "Hayato",
  T_14_R_SKILL_DESC_SAMURAI: "For every [FFB300]{0}%[-] HP lost, armor penetration increases by [FFB300]{1}%[-].",
  T_14_R_SKILL_NAME_SAMURAI: "Bushido",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "Hunger Strike (Mask)",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "Venom Touch (Mask)",
  T_15_L_MALE_BOTTOM_COS_FAIM: "Hunger Strike (Bottom)",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "Venom Touch (Bottom)",
  T_15_L_MALE_SHOE_COS_FAIM: "Hunger Strike (Shoes)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "Venom Touch (Shoes)",
  T_15_L_MALE_TOP_COS_FAIM: "Hunger Strike (Top)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "Venom Touch (Top)",
  T_15_L_TOP_COS_MOTHERSDAY: "Best Mom",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94 - Cataclysm",
  T_15_O_BASEBALLBAT_VIKING_NAME: "Bat - The Viking",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014 - Cataclysm",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1 - Cataclysm",
  T_15_O_PANTHER_NAME: "Night Panther",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "Pet Skin: Captain",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "Pet Skin: Golden Leopard",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "Pet Skin: Domination",
  T_15_O_SKS_DEATH_NAME: "SKS - Death Wish",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP - Cataclysm",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "Gatling",
  T_15_R_CHARACTER_AGENT_NAME: "Laura",
  T_15_R_EMOTE_LETSGROOVE_NAME: "Shake With Me",
  T_15_R_SKILL_DESC_AGENT: "Accuracy increases by [FFB300]{0}%[-] while scoped in.",
  T_15_R_SKILL_NAME_AGENT: "Sharp Shooter",
  T_15_W_BACKPACK_MECHGIRL_NAME: "Backpack - Purple Wings",
  T_16_B_ITEM_GRAPPLINGHOOK: "Hook",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "Hook Gun",
  T_16_L_MALE_COS_LEGO: "Mad Brickman",
  T_16_L_MALE_SHOE_COS_SUMMER: "Summer Holidays (Shoes)",
  T_16_P_MANUAL_MONSTER: "Monster Truck",
  T_16_P_MANUAL_MUSHROOM1: "Mushroom Lv. 1",
  T_16_P_MANUAL_MUSHROOM2: "Mushroom Lv. 2",
  T_16_P_MANUAL_MUSHROOM3: "Mushroom Lv. 3",
  T_16_P_MANUAL_MUSHROOM4: "Mushroom Lv. 4",
  T_16_P_MANUAL_ROADSTER_DESC: "Stylish sports car. Low HP but has insane max speed. Can carry up to 2 players.",
  T_16_P_MANUAL_STROP: "Zip line",
  T_16_P_MANUAL_SUV: "Pickup Truck",
  T_16_P_MANUAL_SUV_DESC: "Free Fire's signature vehicle. Medium armor and max speed. Can carry up to 2 players.",
  T_16_P_MANUAL_TUTU_DESC: "A vehicle with low HP and slow movement. Can carry up to 3 players.",
  T_16_P_MANUAL_WEAPON_AR: "Rifle",
  T_16_P_MANUAL_WEAPON_BOMB: "Grenades",
  T_16_P_MANUAL_WEAPON_PISTOL: "Pistol",
  T_16_P_MANUAL_WEAPON_SG: "Shotgun",
  T_16_P_MANUAL_WEAPON_SMG: "SMG",
  T_16_P_MANUAL_WEAPON_SR: "Sniper",
  T_16_Q_MINISENTRY: "Mini Turret",
  T_16_Q_MINISENTRY_DESC: "Auto turret made out of modern technology. It will scan and attack enemies near by.",
  T_16_R_EMOTE_DESERT_NAME: "Furious Slam",
  T_16_R_EMOTE_EPHUNTER_NAME: "Battle Dance",
  T_16_R_EMOTE_EPHUNTER2_NAME: "High Five",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "Moon Flip",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "Wiggle walk",
  T_16_W_AK_FIRE_NAME: "AK47 - Flaming Red",
  T_16_W_SCAR_LLENN_NAME: "SCAR - Pink Devil",
  T_16_W_SCAR_WATER_NAME: "SCAR - Water Elemental",
  T_16_Y_CHARACTER_HITMAN_NAME: "Rafael",
  T_16_Y_PANDA_NAME: "Detective Panda",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "Pet Skin: Wild Panda",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "Pet Skin: Skull Panda",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "Pet Skin: Lightning Panda",
  T_17_B_CS_MODE_NAME: "Clash Squad",
  T_17_C_SKILL_NAME_PLAYBOY: "Nutty Movement",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "Royal Jester (Mask)",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "Bloody Mistress (Mask)",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "Bloody Mistress (Bottom)",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "Magical Fox (Head)",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "Bloody Mistress (Shoes)",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "Bloody Mistress (Top)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "Vampire's Revenge (Mask)",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "Street Thug (Bottom)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "Vampire's Revenge (Bottom)",
  T_17_L_MALE_HAIR_COS_FFUNIT: "Purple Shade (Head)",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "The Gentleman (Shoes)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "Vampire's Revenge (Shoes)",
  T_17_L_MALE_TOP_COS_VAMPIRE: "Vampire's Revenge (Top)",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "Golden Shade (Top)",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "Pet Skin: Meow Princess",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "Pet Skin: Golden Tale",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "Pet Skin: Deep Blue",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "Pet Skin: Lucky Green",
  T_17_O_SHIBA_NAME: "Shiba",
  T_17_Q_FOLDWINGS: "Glider",
  T_17_Q_FOLDWINGS_DESC: "Allows you to glide down from elevated terrains.",
  T_17_Q_SUPERHEAT: "PLASMA",
  T_17_R_EMOTE_PARTYDANCE_NAME: "Party Dance",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS - Vampire",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR - Phantom Assassin",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR - Old Fashioned",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "Joseph",
  T_17_Z_CS_NAME: "Name",
  T_17_Z_ROOM_JUMP_SWITCH: "Jump Height",
  T_17_Z_ROOM_SPEED_SWITCH: "Movement Speed",
  T_18_B_THROWINGKNIFE_NAME: "FF Knife",
  T_18_C_DUMMY_NAME: "Decoy Grenade",
  T_18_C_SKILL_DESC_DJMALE: "Creates a [FFB300]{1}m[-] aura that increases movement speed by [FFB300]{3}%[-] and restores [FFB300]{2} HP/s[-] for [FFB300]{0}s[-]. Effects do not stack. Cooldown: [FFB300]{4}s[-].",
  T_18_C_SKILL_NAME_DJMALE: "Drop the Beat",
  T_18_C_SKILL_NAME_JUNKENGINEER: "Gear Recycle",
  T_18_L_COS_INDIANEWYEAR: "Diwali Dino",
  T_18_L_HAIR_COS_HALLOWEEN2019: "Frowny Face",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "Flaming Red (Mask)",
  T_18_O_FOX_NAME: "Spirit Fox",
  T_18_O_PETSKIN_BLACKFOX_NAME: "Pet Skin: Battle Fox",
  T_18_O_PETSKIN_BLUEFOX_NAME: "Pet Skin: Blue Fox",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "Pet Skin: Lava Pumpkin",
  T_18_O_PETSKIN_PINKFOX_NAME: "Pet Skin: Red Fox",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "Pet Skin: Spirit",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1 - Flaming Skull",
  T_18_W_UMP_GEISHA_N: "UMP - Art of War",
  T_18_Y_CHARACTER_DJMALE_N: "Alok",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "Shani",
  T_19_B_HB_NAME: "Electric Surfboard",
  T_19_C_ICE_GUN_NAME: "Ice Gun",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "Explosive weapon damage increases by [FFB300]{0}%[-], damage range increases by [FFB300]{1}%[-].",
  T_19_C_SKILL_DESC_TOMBOY: "When driving, restores [FFB300]{1} HP[-] every [FFB300]{0}s[-] for everyone in the vehicle, up to a maximum of [FFB300]{2}[-] HP.",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "Art of Demolition",
  T_19_C_SKILL_NAME_TOMBOY: "Racer's Blessing",
  T_19_I_EVENT_INFI_ITEM: "Unlimited",
  T_19_L_A_ICEFESTIVAL19_B: "Last Laugh",
  T_19_L_F_S_ICEFESTIVAL: "Snowy Servitude (Shoes)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "Disco Fiasco (Bottom)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "Disco Fiasco (Head)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "Disco Fiasco (Top)",
  T_19_O_PETSKIN_NAME: "Pet Skin: Default",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "Pet Skin: Hiphop Panda",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "Pet Skin: Polar Panda",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "Pet Skin: Pharaoh's Robo",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "Pet Skin: Spring Festival Robo",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "Pet Skin: Snowy Robo",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "Pet Skin: Hiphop Shiba",
  T_19_O_ROBOT_NAME: "Robo",
  T_19_O_TDM_NAME: "Team Deathmatch",
  T_19_R_EMOTE_MIGUEL_NAME: "Break dance",
  T_19_S_SECOND_WEAPON_TITLE: "Secondary weapon",
  T_19_S_VEST_TITLE: "Bulletproof Vest",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "Double Magazine",
  T_19_W_GROZA_TAGGERCREW_N: "Groza - Tagger's Revolt",
  T_19_W_M60_ICEFESTIVAL_N: "M60 - Santa's Choice",
  T_19_W_MP40_PARK_N: "MP40 - Carnival Carnage",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR - Aurous Dragon",
  T_19_X_PVE_SAMURAINAME: "Guardian Samurai",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "Alvaro",
  T_19_Y_CHARACTER_TOMBOY_N: "Notora",
  T_20_C_INHALER_NAME: "Inhaler",
  T_20_C_SKILL_DESC_PARKOURGUY: "When the skill user is using guns, hitting an enemy recovers some HP and knocking down an enemy recovers [FFB300]{0}%[-] HP.",
  T_20_C_SKILL_NAME_GRAFFITIST: "Painted Refuge",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "Deadly Velocity",
  T_20_C_SKILL_NAME_PARKOURGUY: "Sustained Raids",
  T_20_L_A_APRILFOOL2020: "Doggo",
  T_20_L_F_A_METALHEAD_RED: "Ms. Fiery Imp-Head (Mask)",
  T_20_L_F_B_THAIGIRL: "Phoenix Accession (Bottom)",
  T_20_L_F_H_KILLERCUPID: "Sweetheart Cupid (Head)",
  T_20_L_F_H_THAIGIRL: "Phoenix Accession (Head)",
  T_20_L_F_S_THAIGIRL: "Phoenix Accession (Shoes)",
  T_20_L_F_T_METALHEAD_RED: "Ms. Fiery Imp-Head (Top)",
  T_20_L_F_T_THAIGIRL: "Phoenix Accession (Top)",
  T_20_L_JEANDINO: "Denim Dino",
  T_20_L_M_A_METALHEAD_RED: "Mr. Fiery Imp-Head (Mask)",
  T_20_L_M_T_METALHEAD_RED: "Mr. Fiery Imp-Head (Top)",
  T_20_L_M_T_STOCKING: "Gentle-man (Top)",
  T_20_O_PETSKIN_LOVERFOX_NAME: "Pet Skin: Valentine's Fox",
  T_20_P_CHANNEL_G: "Guild",
  T_20_P_WORLD_SSPEAKER: "Loudspeaker",
  T_20_S_CSROOM_COIN: "Default coin",
  T_20_U_SHIELD_GUN_NAME: "Shield Gun",
  T_20_W_AN94_METALHEAD_N: "AN94 - Carrot Imp-Head",
  T_20_W_P90_EVILBONE_N: "P90 - The Punishers",
  T_20_Y_CHARACTER_GRAFFITIST_N: "Steffie",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: 'Kelly "the Swift"',
  T_20_Y_CHARACTER_PARKOURGUY_N: "Jota",
  T_21_B_SMOKEGRENADE_DESC: "Generates smoke, great for screening and flanking maneuvers",
  T_21_B_SMOKEGRENADE_NAME: "Smoke Grenade",
  T_21_C_AUTOPICKUP_AVERAGE: "Default",
  T_21_C_SKILL_DESC_KPOPSINGER: "While helping up a teammate, gives said teammate a [FFB300]{0} HP[-] shield and [FFB300]{1}%[-] movement speed boost. Boost effects reduce within [FFB300]{2}s[-] after successful help-up. Reduces bleeding speed of knocked down teammates by [FFB300]{3}%[-]. Effects do not stack.",
  T_21_C_SKILL_DESC_SOCCERSTAR: "Every elimination increases max. HP by [FFB300]{0}[-]. Max. boost: [FFB300]{1}[-].",
  T_21_C_SKILL_NAME_KPOPSINGER: "Healing Song",
  T_21_C_SKILL_NAME_SOCCERSTAR: "Hat Trick",
  T_21_L_ANGELICAL: "Angel Dino",
  T_21_L_S_VNSLIPPER: "Vietnam Slippers",
  T_21_O_OTTER_NAME: "Ottero",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "Pet Skin: Radioactive Ottero",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "Pet Skin: Sakura Ottero",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "Pet Skin: Neon Ottero",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "Pet Skin: Master of Death",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "Pet Skin: Lightning Bolt",
  T_21_R_EMOTE_SORROW_NAME: "Why? Oh Why?",
  T_21_U_WEAPON_THOMPSON_NAME: "Thompson",
  T_21_W_BACKPACK_SPINE_N: "Backpack - Punkster",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "Death's Final Strike",
  T_21_W_M79_RABBITKILLER_N: "M79 - Hipster Bunny",
  T_21_W_PAN_VOLCANO_N: "Pan - Volcanic Fury",
  T_21_W_XM8_RAINBOW_N: "XM8 - Abyssal",
  T_21_Y_CHARACTER_KPOPSINGER_N: "Kapella",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "Luqueta",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "Locate positions of enemies within [FFB300]{0}m[-] who are not in prone or squat position. Lasts for [FFB300]{1}s[-]. Enemy positions are shared with teammates. Cooldown: [FFB300]{2}s[-].",
  T_22_C_SKILL_NAME_DETECTIVE: "Tracing Steps",
  T_22_C_SKILL_NAME_STREAMERGUY: "Limelight",
  T_22_L_F_H_COLLEGE: "Bloodshot Junior (Head)",
  T_22_L_F_S_SUMMER20: "Summer Darling (Shoes)",
  T_22_L_M_A_GREENCOAT: "Lush Clubber (Mask)",
  T_22_L_M_A_PINKFUR: "Sakura Clubber (Mask)",
  T_22_L_M_A_PLAGUE2: "Plague Phantom (Mask)",
  T_22_L_M_B_FAIM2: "Famine Felon (Bottom)",
  T_22_L_M_B_GREENCOAT: "Lush Clubber (Bottom)",
  T_22_L_M_B_PINKFUR: "Sakura Clubber (Bottom)",
  T_22_L_M_B_PLAGUE2: "Plague Phantom (Bottom)",
  T_22_L_M_B_REDPANTS: "Trendy Clubber (Bottom)",
  T_22_L_M_B_TIGERSTRIPE: "Tiger Clubber (Bottom)",
  T_22_L_M_H_COLLEGE: "Bloodshot Senior (Head)",
  T_22_L_M_H_FAIM2: "Famine Felon (Head)",
  T_22_L_M_H_GREENCOAT: "Lush Clubber (Head)",
  T_22_L_M_H_PINKFUR: "Sakura Clubber (Head)",
  T_22_L_M_H_PLAGUE2: "Plague Phantom (Head)",
  T_22_L_M_H_REDPANTS: "Trendy Clubber(Head)",
  T_22_L_M_H_TIGERSTRIPE: "Tiger Clubber (Head)",
  T_22_L_M_S_FAIM2: "Famine Felon (Shoes)",
  T_22_L_M_S_PLAGUE2: "Plague Phantom (Shoes)",
  T_22_L_M_T_FAIM2: "Famine Felon (Top)",
  T_22_L_M_T_GREENCOAT: "Lush Clubber (Top)",
  T_22_L_M_T_PINKFUR: "Sakura Clubber (Top)",
  T_22_L_M_T_PLAGUE2: "Plague Phantom (Top)",
  T_22_L_M_T_REDPANTS: "Trendy Clubber (Top)",
  T_22_L_M_T_TIGERSTRIPE: "Tiger Clubber (Top)",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98k - Rebel Academy",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "Pan - Watermelon",
  T_22_LC_SCAR_HERMIT_N: "SCAR - Mystic Seeker",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "Heal Pistol - Lifebeam",
  T_22_O_HAWK_NAME: "Falco",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "Pet Skin: Apocalypse Fox",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "Pet Skin: Hellfire Falco",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "Pet Skin: Evergreen Falco",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "Pet Skin: Sunshine Shiba",
  T_22_Q_BOMB_PLIERS: "Defusion Pliers",
  T_22_R_EMOTE_SHIMMY_NAME: "Shimmy",
  T_22_U_GOLD_AWM_N: "AWM-Y",
  T_22_U_WPNSKN_BITE: "Armor Penetration",
  T_22_U_WPNSKN_SPEED_RUN: "Movement Speed",
  T_22_Y_CHARACTER_DETECTIVE_N: "Clu",
  T_22_Y_CHARACTER_STREAMERGUY_N: "Wolfrahh",
  T_23_B_CARDIAC_NAME: "Horizaline",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "Art of Blades",
  T_23_C_SKILL_NAME_SWATGUY: "Raging Reload",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: 'Hayato "Firebrand"',
  T_23_D_CHARACTER_SWATGUY_N: "Jai",
  T_23_L_F_B_GANGSTERRAP_GOLD: "Big Bucks Vibe (Bottom)",
  T_23_L_F_B_MIKOGIRL: "Arcticfire Priestess (Bottom)",
  T_23_L_F_B_NAVYGIRL: "Navy Girl (Bottom)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "Big Bucks Vibe (Head)",
  T_23_L_F_H_MIKOGIRL: "Arcticfire Priestess (Head)",
  T_23_L_F_H_NAVYGIRL: "Navy Girl (Head)",
  T_23_L_F_S_MIKOGIRL: "Arcticfire Priestess (Shoes)",
  T_23_L_F_S_ORDERCHALLENGER: "Heist Mastermind (Shoes)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "Big Bucks Vibe (Top)",
  T_23_L_F_T_MIKOGIRL: "Arcticfire Priestess (Top)",
  T_23_L_F_T_NAVYGIRL: "Navy Girl (Top)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "Big Bucks Rapper (Mask)",
  T_23_L_M_B_FOXGUY: "Arcticfire Priest (Bottom)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "Big Bucks Rapper (Bottom)",
  T_23_L_M_H_FOXGUY: "Arcticfire Priest (Head)",
  T_23_LC_SKS_GEMINI_N: "SKS - Hysteria",
  T_23_O_PENGUIN_NAME: "Mr. Waggor",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "Pet Skin: Party Waggor",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "Pet Skin: Cyber Waggor",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "Pet Skin: Gold Waggor",
  T_23_T_ANNI3_LOBBY_NODENAME20: "Clash Squad",
  T_23_T_ANNI3_LOBBY_NODENAME5: "Character",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "UID",
  T_24_AD_ADSPACE_WARNING: "WARNING",
  T_24_C_FLAMETHROWER_NAME: "Flamethrower",
  T_24_C_SKILL_DESC_PROFESSOR: "Max. EP increases by [FFB300]{0}[-]. Jiu-jitsu Mode: Allies within [FFB300]{2}m[-] get [FFB300]{1}%[-] increase in EP conversion rate. Psychology Mode: Recover [FFB300]{5} EP[-] every [FFB300]{4}s[-], up to [FFB300]{6} EP[-]. Mode switch Cooldown: [FFB300]{3}s[-].",
  T_24_C_SKILL_NAME_PARTYGIRL: "Partying On",
  T_24_C_SKILL_NAME_PROFESSOR: "Master of All",
  T_24_D_CHARACTER_PARTYGIRL_N: "Dasha",
  T_24_D_CHARACTER_PROFESSOR_N: "K",
  T_24_L_B_MAXPANTS: "MAX Pants",
  T_24_L_H_PUMPKIN2020_A: "Twisted Pumpkin (Head)",
  T_24_L_T_TSHIRT_COMEDIAN: "Last Shot Hero",
  T_24_LC_MP5_RICHBOXER_N: "MP5 - Champion Boxer",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR - Party Animal",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD - Swordsman Legends",
  T_24_U_M21A5: "Woodpecker",
  T_24_U_PARAFAL: "PARAFAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "Total Score",
  T_24_V_TRAINING_BOX_ATTACH: "Attachments",
  T_24_V_TRAINING_BOX_WEAPON: "Weapons",
  T_24_W_ARMORY: "Weapon",
  T_24_W_ARMOTY_MELEE: "Melee",
  T_24_W_ARMOTY_PISTOL: "Pistol",
  T_24_W_ARMOTY_RIFLE: "Rifle",
  T_24_W_ARMOTY_SHOTGUN: "Shotgun",
  T_24_W_ARMOTY_SNIPER: "Sniper",
  T_24_W_ARMOTY_SPECIAL: "Others",
  T_24_W_ARMOTY_SUBMACHINE: "Sub-Machine Gun",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "Pet Skin: Booyah Panda",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "Pet Skin: Skeleton Rockie",
  T_24_W_PETSKIN_RACCOON_MECH_N: "Pet Skin: Party Rockie",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "Pet Skin: Undead Rockie",
  T_24_W_RACCOON_N: "Rockie",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "Time Turner",
  T_25_D_CHARACTER_BOUNTY_N: "Chrono",
  T_25_E_HUD_01: "Preset 1",
  T_25_E_HUD_02: "Preset 2",
  T_25_L_F_B_DEMONKILLER: "Frenzy Junior (Bottom)",
  T_25_L_F_H_DEMONKILLER: "Frenzy Junior (Head)",
  T_25_L_F_S_DEMONKILLER: "Frenzy Junior (Shoes)",
  T_25_L_F_T_DEMONKILLER: "Frenzy Junior (Top)",
  T_25_L_HA_FP_EVIL: "Evil (Facepaint)",
  T_25_L_M_H_ANIMEHAIR: "Breezy (Hair)",
  T_25_L_S_MAXSNEAKERS: "MAX Sneakers",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "Bat - Cyber Swing",
  T_25_LC_GLOO_WINTERFEST2020_N: "Gloo Wall - Winterlands 2020",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887 - Winterlands 2020",
  T_25_LC_MACHETE_BOUNTY_N: "Parang - Cyber Blade",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90 - Tune Blaster Green",
  T_25_LC_P90_MUSICFALL_RED_N: "P90 - Tune Blaster Red",
  T_25_LC_PAN_BOUNTY_N: "Pan - Cyber Bounty Hunter",
  T_25_R_LEGEND_REMIND: "Reminder",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "Scythe",
  T_25_U_VECTOR: "Vector",
  T_25_W_BABOON_N: "Beaston",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "Pet Skin: Glacier Beaston",
  T_25_W_PETSKIN_BABOON_HELL_N: "Pet Skin: Blazing Beaston",
  T_25_W_PETSKIN_BABOON_PURE_N: "Pet Skin: Great White Beaston",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "Pet Skin: Snow Panther",
  T_25_Z_R_SIMULATOR_OFF: "Disallow",
  T_26_C_SKILL_DESC_SUPERSTAR: "Unleashes a sonic wave forward for [FFB300]{0}m[-]. The wave explodes and deals damage to Gloo Walls within a [FFB300]{1}m[-] radius for [FFB300]{2}s[-]. Cooldown: [FFB300]{3}s[-].",
  T_26_C_SKILL_NAME_SUPERSTAR: "Riptide Rhythm",
  T_26_D_CHARACTER_DELIVERY_N: "Shirou",
  T_26_D_CHARACTER_SUPERSTAR_N: "Skyler",
  T_26_ET_CELLPHONE_NAME: "UAV-Lite",
  T_26_L_A_FLAMING_PREM: "Infernal Soldier (Mask)",
  T_26_L_A_SANTAMODE: "Snowman Bob (Mask)",
  T_26_L_B_SANTAMODE: "Snowman Bob (Bottom)",
  T_26_L_F_B_WATERFEST21_A: "Summer Breeze (Bottom)",
  T_26_L_F_H_WATERFEST21_A: "Summer Breeze (Head)",
  T_26_L_F_S_WATERFEST21_A: "Summer Breeze (Shoes)",
  T_26_L_F_T_WATERFEST21_A: "Summer Breeze (Top)",
  T_26_L_M_A_EGGDAY2021: "Cyber Bunny (Mask)",
  T_26_L_M_B_EGGDAY2021: "Cyber Bunny (Bottom)",
  T_26_L_M_B_PAIRING: "Dynamic Duo M (Bottom)",
  T_26_L_M_B_WATERFEST21_A: "Summer Wave (Bottom)",
  T_26_L_M_H_EGGDAY2021: "Cyber Bunny (Head)",
  T_26_L_M_H_PAIRING: "Dynamic Duo M (Head)",
  T_26_L_M_H_WATERFEST21_A: "Summer Wave (Head)",
  T_26_L_M_S_EGGDAY2021: "Cyber Bunny (Shoes)",
  T_26_L_M_S_PAIRING: "Dynamic Duo M (Shoes)",
  T_26_L_M_S_WATERFEST21_A: "Summer Wave (Shoes)",
  T_26_L_M_T_EGGDAY2021: "Cyber Bunny (Top)",
  T_26_L_M_T_PAIRING: "Dynamic Duo M (Top)",
  T_26_L_M_T_WATERFEST21_A: "Summer Wave (Top)",
  T_26_L_S_SANTAMODE: "Snowman Bob (Shoes)",
  T_26_L_T_SANTAMODE: "Snowman Bob (Top)",
  T_26_LC_AWM_KOICARP_N: "AWM - Lucky Koi",
  T_26_LC_KATANA_VALENTINE2021_N: "Katana - Season of Pink",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "Sports Car - Cobra",
  T_26_P_SKILL_NAME_DELIVERY: "Damage Delivered",
  T_26_V_TRAINING_BHH: "Fancy Hammer",
  T_26_V_TRAINING_DICE: "Giant Dice",
  T_26_W_DRAGON_N: "Dreki",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "Pet Skin: Splashy Dreki",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "Pet Skin: Zapping Dreki",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "Pet Skin: Galaxy Dreki",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "Pet Skin: Waggor in Love",
  T_26_XL_SETTING_TEAMMATE_INFO: "Teammate Info",
  T_26_YP_HISTORY_WIN: "Victory",
  T_26_YP_SOCIAL_GENDER_FEMALE: "Female",
  T_26_YP_SOCIAL_GENDER_MALE: "Male",
  T_26_YP_SOCIAL_NAME: "Nickname",
  T_27_C_SKILL_DESC__RACERGIRL: "Driving speed increases by [FFB300]{0}%[-]. While in vehicle, character is harder to be targeted at, and damage taken is decreased by [FFB300]{1}%[-].",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "Creates an impenetrable force field that blocks [FFB300]{0} DMG[-]. Unable to attack outside enemies from within the field. All effects last for [FFB300]{1}s[-]. Cooldown: [FFB300]{2}s[-].",
  T_27_C_SKILL_DESC_FALCONER: "Damage increases with distance, up to [FFB300]{0}%[-]. Damage to marked enemies increases by [FFB300]{1}%[-].",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "Awakening: Reduces frontal damage by [FFB300]{1}%[-] for every [FFB300]{0}%[-] HP lost.",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "Awakening: Sprint for [FFB300]{0}s[-] to activate. When activated, first [FFB300]{2}[-] shot on target inflicts [FFB300]{1}%[-] damage. Lasts for [FFB300]{3}s[-].",
  T_27_C_SKILL_NAME_FALCONER: "Falcon Fervor",
  T_27_C_SKILL_NAME_XTREME: "Xtreme Encounter",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: 'Andrew "the Fierce"',
  T_27_D_CHARACTER_FALCONER_N: "Maro",
  T_27_D_CHARACTER_XTREME_N: "Xayne",
  T_27_F_EAP_PKG3_D: "Battle in style!",
  T_27_HYL_SKILLBOARD_HP: "HP",
  T_27_L_A_CARDBOARD_MID2: "Tiger Papercut (Mask)",
  T_27_L_B_CARDBOARD_REG: "Grizzly Papercut (Bottom)",
  T_27_L_M_S_KAZAKHSTAN: "The Baghatur (Shoes)",
  T_27_L_S_CARDBOARD_REG: "Grizzly Papercut (Shoes)",
  T_27_L_T_CARDBOARD_REG: "Grizzly Papercut (Top)",
  T_27_LC_VECTOR_FFWS2021_N: "Vector - FFWS 2021",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "Monster Truck - FFWS 2021",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "Motorbike - K.O. Night",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "Sports Car - Emerald Flash",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "Pickup Truck - Flame Draco",
  T_27_P_SKILL_NAME_HITMAN_RE: "Dead Silent",
  T_27_R_EMOTE_GREETING_NAME: "Greetings",
  T_27_R_VEHICLE_ACCELERATION: "Acceleration",
  T_27_R_VEHICLE_HP: "Durability",
  T_27_R_VEHICLE_SPEED: "Top Speed",
  T_27_U_KORD: "Kord",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "Awakening: Armor damage reduction boosted by [FFB300]{0}%[-]. Additional [FFB300]{1}%[-] damage reduction  for each teammate within [FFB300]{2}m[-].",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "Wolf Pack",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "Moony",
  T_27_W_ARMOTY_DMR: "Marksman Rifle",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "Pet Skin: Crystal Moony",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "Pet Skin: Gamer Moony",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "Pet Skin: Hipster Moony",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "Pet Skin: FFWS 2021 Pup",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "Pet Skin: FFWS 2021 Panda",
  T_27_XC_REPLAY_DIE: "Death",
  T_27_XC_REPLAY_KILL: "Elimination",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "Repair",
  T_28_C_G_ICE_NAME: "Flash Freeze",
  T_28_C_SKILL_DESC_STREETBEAT: "When firing while moving, movement speed increases by [FFB300]{0}%[-], accuracy increases by [FFB300]{1}%[-].",
  T_28_C_SKILL_NAME_STREETBEAT: "Bullet Beats",
  T_28_D_CHARACTER_STREETBEAT_N: "D-bee",
  T_28_HI_UZI: "Mini Uzi",
  T_28_L_B_BRJERSEY_A: "No.23 Soccer Jersey (Bottom)",
  T_28_L_B_BRJERSEY_B: "No.10 Soccer Jersey (Bottom)",
  T_28_L_B_BRJERSEY_C: "No.24 Soccer Jersey (Bottom)",
  T_28_L_B_BRJERSEY_D: "No.30 Soccer Jersey (Bottom)",
  T_28_L_B_BRJERSEY_E: "No.1 Soccer Jersey (Bottom)",
  T_28_L_B_BRJERSEY_F: "No.20 Soccer Jersey (Bottom)",
  T_28_L_F_B_FOURSYMBOLS_C: "Vermilion Whirlwind (Bottom)",
  T_28_L_F_H_FOURSYMBOLS_C: "Vermilion Whirlwind (Head)",
  T_28_L_F_HA_FOURSYMBOLS_C: "Vermilion Whirlwind (Facepaint)",
  T_28_L_F_S_FOURSYMBOLS_C: "Vermilion Whirlwind (Shoes)",
  T_28_L_F_T_FOURSYMBOLS_C: "Vermilion Whirlwind (Top)",
  T_28_L_HA_THUNDER: "Lightning Eye (Facepaint)",
  T_28_L_M_A_SPORTSUIT: "Ballsy Skaterboi (Mask)",
  T_28_L_M_B_FOURSYMBOLS_D: "Shadow Earthshaker (Bottom)",
  T_28_L_M_B_SPORTSUIT: "Ballsy Skaterboi (Bottom)",
  T_28_L_M_H_FOURSYMBOLS_D: "Shadow Earthshaker (Head)",
  T_28_L_M_H_SPORTSUIT: "Ballsy Skaterboi (Head)",
  T_28_L_M_S_FOURSYMBOLS_D: "Shadow Earthshaker (Shoes)",
  T_28_L_M_S_SPORTSUIT: "Ballsy Skaterboi (Shoes)",
  T_28_L_M_T_FALLWINTER: "Sauce Swagger (Top)",
  T_28_L_M_T_FOURSYMBOLS_D: "Shadow Earthshaker (Top)",
  T_28_L_M_T_SPORTSUIT: "Ballsy Skaterboi (Top)",
  T_28_L_T_BRJERSEY_A: "No.23 Soccer Jersey (Top)",
  T_28_L_T_BRJERSEY_B: "No.10 Soccer Jersey (Top)",
  T_28_L_T_BRJERSEY_C: "No.24 Soccer Jersey (Top)",
  T_28_L_T_BRJERSEY_D: "No.30 Soccer Jersey (Top)",
  T_28_L_T_BRJERSEY_E: "No.1 Soccer Jersey (Top)",
  T_28_L_T_BRJERSEY_F: "No.20 Soccer Jersey (Top)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94 - Ruby Bride",
  T_28_LC_GLOO_FALLWINTER_N: "Gloo Wall - Sauce Swagger",
  T_28_LC_GLOO_FOURSYMBOLS_N: "Gloo Wall - Stormbringer",
  T_28_LC_KORD_SHINOBI_N: "Kord - Killspark Shinobi",
  T_28_LC_M21A5_FANTASYEYE_N: "Woodpecker - Merciless Necromancer",
  T_28_LC_MAG7_WHITESHARK_N: "MAG-7 - Lethal Finstooth",
  T_28_LC_PAN_FOURSYMBOLS_N: "Pan - Earthshaker Stomp",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "Jeep - Stormbringer",
  T_28_T_WS_ITEM1: "Square Box",
  T_28_T_WS_ITEM10: "Hut",
  T_28_T_WS_ITEM11: "Guard Tower",
  T_28_T_WS_ITEM12: "Outpost",
  T_28_T_WS_ITEM13: "House A",
  T_28_T_WS_ITEM14: "House B",
  T_28_T_WS_ITEM15: "House C",
  T_28_T_WS_ITEM16: "Sand Structure",
  T_28_T_WS_ITEM17: "Fountain",
  T_28_T_WS_ITEM18: "Cherry Blossom",
  T_28_T_WS_ITEM19: "Banana Tree",
  T_28_T_WS_ITEM2: "Long Box",
  T_28_T_WS_ITEM20: "Toilet Bowl",
  T_28_T_WS_ITEM21: "Fence",
  T_28_T_WS_ITEM3: "Shrub",
  T_28_T_WS_ITEM4: "Haystack",
  T_28_T_WS_ITEM5: "Car",
  T_28_T_WS_ITEM6: "Bus",
  T_28_T_WS_ITEM7: "Container A",
  T_28_T_WS_ITEM8: "Container B",
  T_28_T_WS_ITEM9: "Container C",
  T_28_T_WS_TYPE1: "Objects",
  T_28_T_WS_TYPE4: "Decorations",
  T_28_W_DUCK_N: "Dr. Beanie",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "Pet Skin: Mythos Dreki",
  T_28_W_PETSKIN_DUCK_ARMY_N: "Pet Skin: Sgt. Beanie",
  T_28_W_PETSKIN_DUCK_BLACK_N: "Pet Skin: Gangster Beanie",
  T_28_W_PETSKIN_DUCK_SHINY_N: "Pet Skin: DJ Beanie",
  T_28_YF_AR15: "Kingfisher",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "Awakening: Markings on hit enemies last longer when enemies move (up to [FFB300]{0}s[-] longer).",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "Enigma's Eye",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "Vital Vibes",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "Healing Heartbeat",
  T_29_D_CHARACTER_AMOCO_N: 'Moco "Enigma"',
  T_29_D_CHARACTER_MUSICBRO1_N: "Dimitri",
  T_29_D_CHARACTER_MUSICBRO2_N: "Thiva",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "Striped Soccer Jersey (Bottom)",
  T_29_L_M_A_FALCONER_C: "Moody Lavisher (Mask)",
  T_29_L_M_A_JUNGLE_GREEN: "Camou War-Turtle (Mask)",
  T_29_L_M_B_FALCONER_C: "Moody Lavisher (Bottom)",
  T_29_L_M_B_JUNGLE_GREEN: "Camou War-Turtle (Bottom)",
  T_29_L_M_H_FALCONER_C: "Moody Lavisher (Head)",
  T_29_L_M_H_JUNGLE_GREEN: "Camou War-Turtle (Head)",
  T_29_L_M_S_FALCONER_C: "Moody Lavisher (Shoes)",
  T_29_L_M_S_JUNGLE_GREEN: "Camou War-Turtle (Shoes)",
  T_29_L_M_T_FALCONER_C: "Moody Lavisher (Top)",
  T_29_L_M_T_JUNGLE_GREEN: "Camou War-Turtle (Top)",
  T_29_L_T_TRJERSEY: "Striped Soccer Jersey (Top)",
  T_29_M_WS_ITEM22: "Rugged Container",
  T_29_M_WS_ITEM23: "Rugged Fence",
  T_29_M_WS_ITEM24: "Spawn Point A",
  T_29_M_WS_ITEM25: "Spawn Point B",
  T_29_M_WS_TYPE5: "Interactives",
  T_29_W_PETSKIN_BROWN_TIGER_N: "Pet Skin: Earth Sensei Tig",
  T_29_W_PETSKIN_FIRE_TIGER_N: "Pet Skin: Fire Sensei Tig",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "Pet Skin: Cyber Falco",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "Pet Skin: Party Panda",
  T_29_W_PETSKIN_WHITE_TIGER_N: "Pet Skin: Ice Sensei Tig",
  T_29_W_TIGER_NINJA_N: "Sensei Tig",
  T_29_YF_MACHETE_MUSICFEST_N: "Parang - Soundwave Thrasher",
  T_29_YF_MAGEZINE_CHAIN_N: "AR Magazine",
  T_29_YF_MUZZLE_CRASH_N: "SMG Muzzle",
  T_29_YF_MUZZLE_WIDE_N: "Shotgun Muzzle",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12 - Cosmic Teleportia",
  T_29_YF_UZI_GOLDENWING_N: "Mini Uzi - Amber Megacypher",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "Monster Truck - Gnawing Rager",
  T_30_AD_RP_ROUNDEND: "END OF ROUND",
  T_30_AD_TRAINING_SNOWBALL: "Snowball",
  T_30_AD_TRAINING_SNOWBALL_DES: "Let's have a snowball fight!",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0}s[-] after being attacked, recover [FFB300]{1}HP[-]/s for [FFB300]{2}s[-]",
  T_30_C_SKILL_NAME_BOOYAHGUY: "Buzzer Beater",
  T_30_C_SKILL_NAME_MUERTOGUY: "Memory Mist",
  T_30_D_CHARACTER_BOOYAHGUY_N: "Leon",
  T_30_D_CHARACTER_MUERTOGUY_N: "Otho",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "Jai's Microchip",
  T_30_L_A_BRMASCOT_ADULT: "Angry Chick Head",
  T_30_L_A_BRMASCOT_KIDS: "Adorable Chick Head",
  T_30_L_A_SUGARSKULL21_BANDANA: "Death Bite Mask",
  T_30_L_B_BRFOOTBALL_BLACK: "CBF Soccer Jersey - Black (Bottom)",
  T_30_L_B_BRFOOTBALL_GREEN: "CBF Soccer Jersey - Green (Bottom)",
  T_30_L_B_BRFOOTBALL_GREY: "CBF Soccer Jersey - Gray (Bottom)",
  T_30_L_B_BRUNIFORM: "Little Canary (Bottom)",
  T_30_L_F_A_SUGARSKULL21: "Goldrim Queen (Mask)",
  T_30_L_F_B_SUGARSKULL21: "Goldrim Queen (Bottom)",
  T_30_L_F_B_THASIAN: "Coral Trouble (Bottom)",
  T_30_L_F_H_CATEARS: "Kawaii Ears",
  T_30_L_F_H_SUGARSKULL21: "Goldrim Queen (Head)",
  T_30_L_F_H_THASIAN: "Coral Trouble (Head)",
  T_30_L_F_S_SUGARSKULL21: "Goldrim Queen (Shoes)",
  T_30_L_F_S_THASIAN: "Coral Trouble (Shoes)",
  T_30_L_F_T_SUGARSKULL21: "Goldrim Queen (Top)",
  T_30_L_F_T_THASIAN: "Coral Trouble (Top)",
  T_30_L_H_CHILDRENSDAY_BLUE: "Dolphin Head",
  T_30_L_H_CHILDRENSDAY_RED: "Elephant Head",
  T_30_L_H_CLOWNHAT: "Circus Hat - Yellow",
  T_30_L_H_ZASCARF: "Bold Gold Scarf",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "Desi Gangster (Mask)",
  T_30_L_M_A_SUGARSKULL21: "Goldrim King (Mask)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "Desi Gangster (Bottom)",
  T_30_L_M_B_PKCRICKET: "Champ In Green (Bottom)",
  T_30_L_M_B_SUGARSKULL21: "Goldrim King (Bottom)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "Wind Racer (Bottom)",
  T_30_L_M_B_THASIAN: "Coral Rebel (Bottom)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "Desi Gangster (Head)",
  T_30_L_M_H_SUGARSKULL21: "Goldrim King (Head)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "Wind Racer (Head)",
  T_30_L_M_H_THASIAN: "Coral Rebel (Head)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "Alpha Flameborn (Facepaint)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "Desi Gangster (Shoes)",
  T_30_L_M_S_PKCRICKET: "Champ In Green (Shoes)",
  T_30_L_M_S_SUGARSKULL21: "Goldrim King (Shoes)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "Wind Racer (Shoes)",
  T_30_L_M_S_THASIAN: "Coral Rebel (Shoes)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "Desi Gangster (Top)",
  T_30_L_M_T_PKCRICKET: "Champ In Green (Top)",
  T_30_L_M_T_SUGARSKULL21: "Goldrim King (Top)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "Wind Racer (Top)",
  T_30_L_M_T_THASIAN: "Coral Rebel (Top)",
  T_30_L_S_BRUNIFORM: "Little Canary (Shoes)",
  T_30_L_T_BRFOOTBALL_BLACK: "CBF Soccer Jersey - Black (Top)",
  T_30_L_T_BRFOOTBALL_GREEN: "CBF Soccer Jersey - Green (Top)",
  T_30_L_T_BRFOOTBALL_GREY: "CBF Soccer Jersey - Gray (Top)",
  T_30_L_T_BRUNIFORM: "Little Canary (Top)",
  T_30_M_WS_PARTY_MODE: "Playground",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "BATTLE IN STYLE",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "Challenger",
  T_30_R_EMOTE_MAX_NAME: "Rap Swag",
  T_30_R_LEGEND_HALO_NAME: "Circle of Heat",
  T_30_T_WS_DEFAULTDESCRIPTION: "An exciting map in Free Fire Craftland",
  T_30_T_WS_ITEM26: "Tires",
  T_30_T_WS_ITEM27: "Messy Tires A",
  T_30_T_WS_ITEM28: "Messy Tires B",
  T_30_T_WS_ITEM29: "Messy Tires C",
  T_30_T_WS_ITEM30: "Bumper car",
  T_30_T_WS_ITEM31: "Amphibian Car",
  T_30_T_WS_ITEM32: "Jeep",
  T_30_T_WS_ITEM33: "Trash can",
  T_30_T_WS_ITEM34: "Shade",
  T_30_T_WS_ITEM35: "Medical Tent",
  T_30_T_WS_ITEM36: "Garage",
  T_30_T_WS_ITEM37: "Painted Walls",
  T_30_T_WS_ITEM38: "Torii",
  T_30_T_WS_ITEM39: "Iron Platform",
  T_30_T_WS_ITEM40: "Site Hut",
  T_30_T_WS_ITEM41: "Trailer",
  T_30_T_WS_ITEM42: "Wall A",
  T_30_T_WS_ITEM43: "Wall B",
  T_30_T_WS_ITEM44: "Wall C",
  T_30_T_WS_ITEM45: "Wall D",
  T_30_T_WS_ITEM46: "Wall E",
  T_30_T_WS_ITEM47: "Wall F",
  T_30_U_ATTACHMENT_1: "Shield Booster",
  T_30_U_ATTACHMENT_4: "Vest Enlarger",
  T_30_U_ATTACHMENT_5: "Helmet Thickener",
  T_30_U_ATTACHMENT_6: "Vest Thickener",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "Pet Skin: Skull Beaston",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "Pet Skin: Punk Waggor",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "Pet Skin: Bullseye Agent Hop",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "Pet Skin: Carnival Agent Hop",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "Pet Skin: Cyber Agent Hop",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "Pet Skin: Nazar Robo",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "Pet Skin: Green Freeze Robo",
  T_30_W_RABBIT_N: "Agent Hop",
  T_30_XH_PCMAP_P17: "Factory",
  T_30_YF_GLOO_BOOYAHDAY21_N: "Gloo Wall - BOOYAH DAY 2021",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "Grenade - BOOYAH DAY 2021",
  T_30_YF_Healinggun_Sniper_N: "Heal Sniper",
  T_30_YF_MINI_LIGHTFEST_N: "AC80 - Royal Warrior",
  T_30_YF_PARAFAL_ZATRIBAL_N: "PARAFAL - Crimson Heir",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR - Royal Warrior",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "Thompson- Goldrim Tribute",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "Sports Car - Skull Punker",
  T_31_C_SKILL_NAME_WINTERGUY: "Ice Iron",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "Bat - Winter Basher",
  T_31_HQ_GLOO_EAGLE_N: "Gloo Wall - Heatbound Desert",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "Heal Sniper - Ice Bones",
  T_31_HQ_KATANA_WINTERFEST21_N: "Katana - Snow Doom",
  T_31_HQ_PAN_WINTERFEST21_N: "Pan - Snow Doom",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "Pet Skin: Snow Ottero",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "Pet Skin: Waggor On Ice",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "Pet Skin: Tribal Yeti",
  T_31_HQ_PETSKIN_YETI_RED_N: "Pet Skin: Fiery Yeti",
  T_31_HQ_SICKLE_WINTERFEST21_N: "Scythe - Snow",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "Motorbike - Ice Blossoms",
  T_31_HQ_YETI_N: "Yeti",
  T_31_KK_WINTER_BUJIX: "Supply Crate",
  T_31_KK_WINTER_SANJITOU: "Helmet",
  T_31_L_A_BDCRICKET: "Victory Batter (Mask)",
  T_31_L_A_WINTERFEST21: "Reindeer Cover",
  T_31_L_B_BDCRICKET: "Victory Batter (Bottom)",
  T_31_L_B_MEJERSEY_10: "No. 10 Ruby Jersey (Bottom)",
  T_31_L_B_MEJERSEY_11: "No. 11 Red Jersey (Bottom)",
  T_31_L_B_MEJERSEY_13: "No. 13 White Jersey (Bottom)",
  T_31_L_B_MEJERSEY_18G: "No. 18 Green Jersey (Bottom)",
  T_31_L_B_MEJERSEY_18R: "No. 18 Maroon Jersey (Bottom)",
  T_31_L_B_MEJERSEY_7: "No. 7 Basil Jersey (Bottom)",
  T_31_L_F_B_RUMUSICIAN: "Strapped Trance (Bottom)",
  T_31_L_F_B_THAGENT: "Night Provocateur (Bottom)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "Up Here (F)",
  T_31_L_F_H_RUMUSICIAN: "Strapped Trance (Head)",
  T_31_L_F_H_THAGENT: "Night Provocateur (Head)",
  T_31_L_F_HA_RUMUSICIAN: "Strapped Trance (Facepaint)",
  T_31_L_F_S_RUMUSICIAN: "Strapped Trance (Shoes)",
  T_31_L_F_S_THAGENT: "Night Provocateur (Shoes)",
  T_31_L_F_T_RUMUSICIAN: "Strapped Trance (Top)",
  T_31_L_F_T_THAGENT: "Night Provocateur (Top)",
  T_31_L_HA_RUMUSICIAN_MU: "Strap Trap (Facepaint)",
  T_31_L_HA_WINTERFEST21_BLUE: "Frozen Clown Facepaint",
  T_31_L_HA_WINTERFEST21_PINK: "Pink Firesparks Facepaint",
  T_31_L_M_A_REGGAETON_B: "Everything Goes (Mask)",
  T_31_L_M_A_REGGAETON_P: "Prismatic Energy (Mask)",
  T_31_L_M_A_RUMUSICIAN: "Strapped Trap (Mask)",
  T_31_L_M_A_THAGENT: "Night Scouter (Mask)",
  T_31_L_M_B_PKCOSTUME: "Smart in Green (Bottom)",
  T_31_L_M_B_REGGAETON_B: "Everything Goes (Bottom)",
  T_31_L_M_B_REGGAETON_P: "Prismatic Energy (Bottom)",
  T_31_L_M_B_RUMUSICIAN: "Strapped Trap (Bottom)",
  T_31_L_M_B_THAGENT: "Night Scouter (Bottom)",
  T_31_L_M_H_GREENCAP: "Winner Cap",
  T_31_L_M_H_PKCOSTUME: "Smart in Green (Head)",
  T_31_L_M_H_REGGAETON_B: "Everything Goes (Head)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "Up Here (M)",
  T_31_L_M_H_REGGAETON_P: "Prismatic Energy (Head)",
  T_31_L_M_H_RUMUSICIAN: "Strapped Trap (Head)",
  T_31_L_M_H_THAGENT: "Night Scouter (Head)",
  T_31_L_M_S_PKCOSTUME: "Smart in Green (Shoes)",
  T_31_L_M_S_REGGAETON_B: "Everything Goes (Shoes)",
  T_31_L_M_S_REGGAETON_P: "Prismatic Energy (Shoes)",
  T_31_L_M_S_RUMUSICIAN: "Strapped Trap (Shoes)",
  T_31_L_M_S_THAGENT: "Night Scouter (Shoes)",
  T_31_L_M_T_PKCOSTUME: "Smart in Green (Top)",
  T_31_L_M_T_REGGAETON_B: "Everything Goes (Top)",
  T_31_L_M_T_REGGAETON_P: "Prismatic Energy (Top)",
  T_31_L_M_T_REGGAETON_TATOO: "This Is Me",
  T_31_L_M_T_RUMUSICIAN: "Strapped Trap (Top)",
  T_31_L_M_T_THAGENT: "Night Scouter (Top)",
  T_31_L_S_BDCRICKET: "Victory Batter (Shoes)",
  T_31_L_T_BDCRICKET: "Victory Batter (Top)",
  T_31_L_T_BRBANK: "Maroon Bomber",
  T_31_L_T_MEJERSEY_10: "No. 10 Ruby Jersey (Top)",
  T_31_L_T_MEJERSEY_11: "No. 11 Red Jersey (Top)",
  T_31_L_T_MEJERSEY_13: "No. 13 White Jersey (Top)",
  T_31_L_T_MEJERSEY_18G: "No. 18 Green Jersey (Top)",
  T_31_L_T_MEJERSEY_18R: "No. 18 Maroon Jersey (Top)",
  T_31_L_T_MEJERSEY_7: "No. 7 Basil Jersey (Top)",
  T_31_L_T_PKMOBILE: "Infinix T-shirt",
  T_31_L_T_REGGAETON_HOOD: "For My People",
  T_31_MF_CHARACTER_WINTERGUY_N: "Nairi",
  T_31_R_EMOTE_FALCONER_NAME: "Number 1",
  T_31_RW_COMBINEMACHINE_2: "Akimbo Activator (Advanced)",
  T_31_RW_VIBRATION_EXPLOSION: "Explosions",
  T_31_RW_VIBRATION_MELEEWEAPONS: "Melee weapons",
  T_31_RW_VIBRATION_OTHERWEAPONS: "Other guns",
  T_31_T_WS_1PLAYERTEAM: "Solo",
  T_31_T_WS_2PLAYERTEAM: "Duo",
  T_31_T_WS_3PLAYERTEAM: "Trio",
  T_31_T_WS_4PLAYERTEAM: "Squad",
  T_31_T_WS_5PLAYERTEAM: "Versus 5",
  T_31_T_WS_6PLAYERTEAM: "Versus 6",
  T_31_T_WS_BUFFTIME_TITLE: "Refresh Time (s)",
  T_31_T_WS_BUFFTYPE_AMMO: "Ammo",
  T_31_T_WS_BUFFTYPE_ARMOR: "Armor",
  T_31_T_WS_BUFFTYPE_HP: "HP",
  T_31_T_WS_BUFFTYPE_RANDOM: "Random",
  T_31_T_WS_BUFFTYPE_TITLE: "Buff Type",
  T_31_T_WS_DESC48: "Takes you to another place, within milliseconds",
  T_31_T_WS_DESC49: "Creates the sound of a piano key",
  T_31_T_WS_DESC51: "Creates the sound of a drum",
  T_31_T_WS_DESC53: "Creates the sound of a synthesizer",
  T_31_T_WS_DESC59: "A device that periodically generates a buff. Pick it up to get a corresponding enhancement",
  T_31_T_WS_DRUMTYPE_CLAPS: "Clap",
  T_31_T_WS_DRUMTYPE_HIHATS: "Hi-hat",
  T_31_T_WS_DRUMTYPE_KICK: "Kick Drum",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "Opening Hi-hat",
  T_31_T_WS_DRUMTYPE_RIDES: "Ride Cymbal",
  T_31_T_WS_DRUMTYPE_SNARES: "Snare Drum",
  T_31_T_WS_EARLYSHRINK: "Quick Shrink",
  T_31_T_WS_ITEM48: "Portal",
  T_31_T_WS_ITEM49: "Piano Key",
  T_31_T_WS_ITEM51: "Drum Key",
  T_31_T_WS_ITEM53: "Combo Key A",
  T_31_T_WS_ITEM55: "Combo Key B",
  T_31_T_WS_ITEM57: "Combo Key C",
  T_31_T_WS_ITEM59: "Buff Generator",
  T_31_T_WS_LATESHRINK: "Late Shrink",
  T_31_T_WS_ME_DAMAGE: "Damage Inflicted",
  T_31_T_WS_ME_DAMAGED: "Damage Taken",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "Initial EP Proportion",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "Radius of First Safe Zone",
  T_31_T_WS_ME_EPQUICKRESTORE: "Quick EP Conversion",
  T_31_T_WS_ME_FLOW: "Mode",
  T_31_T_WS_ME_GENERALSETTING: "General",
  T_31_T_WS_ME_INRANDOMSPAWN: "Random spawn point",
  T_31_T_WS_ME_KILLSCORE: "Kill Bonus",
  T_31_T_WS_ME_MAXEP: "Maximum EP",
  T_31_T_WS_ME_MAXHP: "Maximum HP",
  T_31_T_WS_ME_NEARTEAM: "Near teammates",
  T_31_T_WS_ME_REBIRTH: "Respawn Waiting Time",
  T_31_T_WS_ME_REBIRTHLOCATION: "Respawn Location",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "Zone Shrink Start Time",
  T_31_T_WS_ME_WINSCORE: "Winning Score",
  T_31_T_WS_MINIZONE: "Mini Zone",
  T_31_T_WS_MUSICTYPE_TITLE: "Music Type",
  T_31_T_WS_UNLIMITEDAMMO: "Unlimited Ammo",
  T_31_WT_WS_DESC1: "A square wooden box that can be stacked",
  T_31_WT_WS_DESC10: "A run-down hut with wooden stairs to climb up to",
  T_31_WT_WS_DESC11: "Built with multiple windows for shooting purposes",
  T_31_WT_WS_DESC12: "Metal-made and contains doors and windows",
  T_31_WT_WS_DESC13: "A one-story house with doors and windows",
  T_31_WT_WS_DESC14: "A two-story house with a terrace",
  T_31_WT_WS_DESC15: "A two-story house with a sealed roof",
  T_31_WT_WS_DESC16: "Decor - a heart-shaped sand statue",
  T_31_WT_WS_DESC17: "Decor - a fountain of crystal-clear water",
  T_31_WT_WS_DESC18: "Decor - a tree of pink flowers",
  T_31_WT_WS_DESC19: "Decor - a small banana tree with no bananas",
  T_31_WT_WS_DESC2: "A rectangular wooden box that can be stacked",
  T_31_WT_WS_DESC20: "A white bathroom furniture that can be placed indoors",
  T_31_WT_WS_DESC21: "A small fence that can be used to divide areas",
  T_31_WT_WS_DESC22: "This container's side wooden board can be broken by force",
  T_31_WT_WS_DESC23: "A small fence that can be broken down by force",
  T_31_WT_WS_DESC24: "Spawn area for Team A (Only valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_31_WT_WS_DESC25: "Spawn area for Team B (Only valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_31_WT_WS_DESC26: "Bounces players off to the direction they face, for a short distance",
  T_31_WT_WS_DESC27: "Bounces players off to the preset direction, for a short distance",
  T_31_WT_WS_DESC28: "Bounces players off to the preset direction, for a medium distance",
  T_31_WT_WS_DESC29: "Bounces players off to the preset direction, for a long distance",
  T_31_WT_WS_DESC3: "Adorned with red and yellow blossoms that can light up your battlefield",
  T_31_WT_WS_DESC30: "A bumper car that can be driven",
  T_31_WT_WS_DESC31: "An amphibian car that can be driven",
  T_31_WT_WS_DESC32: "A jeep that can be driven",
  T_31_WT_WS_DESC33: "Filled with trash. Shorter than a human but can provide some cover",
  T_31_WT_WS_DESC34: "An open-air, metallic race track shelter",
  T_31_WT_WS_DESC35: "A medium-sized tent with two doors but no windows",
  T_31_WT_WS_DESC36: "A large garage built of bricks",
  T_31_WT_WS_DESC37: "A large brick wall that can be used to divide areas",
  T_31_WT_WS_DESC38: "A useful landmark",
  T_31_WT_WS_DESC39: "A large metallic platform that can be used as the main fighting pit",
  T_31_WT_WS_DESC4: "Taller than a human and can therefore act as cover",
  T_31_WT_WS_DESC40: "Looks like a recreational vehicle and has multiple doors and windows",
  T_31_WT_WS_DESC41: "Looks like a recreational vehicle and has one door and multiple windows",
  T_31_WT_WS_DESC42: "A one-sided wall with an entrance",
  T_31_WT_WS_DESC43: "A regular one-sided wall",
  T_31_WT_WS_DESC44: "A wall corner",
  T_31_WT_WS_DESC45: "An uneven wall corner",
  T_31_WT_WS_DESC46: "An uneven wall corner",
  T_31_WT_WS_DESC47: "A wall corner with windows",
  T_31_WT_WS_DESC5: "An abandoned car that is slightly shorter than a human but can provide some cover",
  T_31_WT_WS_DESC6: "Taller than a human and can therefore act as cover",
  T_31_WT_WS_DESC7: "Open on both ends and can be arranged to form pathways or to divide areas",
  T_31_WT_WS_DESC8: "Open on one end and can be used to divide areas",
  T_31_WT_WS_DESC9: "Sealed on both ends and can be used to divide areas",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "Vehicle",
  T_31_Z_OB_UAV: "UAV",
  T_32_C_SKILL_DESC_YAKUZA: "Dashes forward at a rapid speed for [FFB300]{0}s[-]. This skill can be accumulated for up to [FFB300]{2} uses[-], with a [FFB300]{3}s[-] cooldown between each use. Dash replenish time: [FFB300]{1}s[-].",
  T_32_C_SKILL_NAME_YAKUZA: "Rebel Rush",
  T_32_HQ_AUG_VNSTREET_N: "AUG - Roaring Gunfighter",
  T_32_HQ_BACKPACK_REDDRAGON_N: "Backpack - Dawnlit Drago",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B - Vampire Malevolence",
  T_32_HQ_GLOO_DUNHUANG_N: "Gloo Wall - Frozen Platinum",
  T_32_HQ_GLOO_HURRICANE_2_N: "Gloo Wall - Aurora Core",
  T_32_HQ_GRENADE_HURRICANE_N: "Grenade - Brassy Mic",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10 - Frozen Platinum",
  T_32_HQ_PETSKIN_DUCK_RED_N: "Pet skin: Red Beanie",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "Pet Skin: Cyber Flash",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "Pet Skin: Gamer Flash",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "Pet Skin: Festive Flash",
  T_32_HQ_TORTOISE_N: "Flash",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "Sports Car - Buried Purpledust",
  T_32_L_F_A_PHARAOH: "Goldcoated Cleo (Mask)",
  T_32_L_F_B_PHARAOH: "Goldcoated Cleo (Bottom)",
  T_32_L_F_H_PHARAOH: "Goldcoated Cleo (Head)",
  T_32_L_F_HA_PHARAOH: "Goldcoated Cleo (Facepaint)",
  T_32_L_F_S_PHARAOH: "Goldcoated Cleo (Shoes)",
  T_32_L_F_T_PHARAOH: "Goldcoated Cleo (Top)",
  T_32_L_M_A_JUNKFOOD: "Burger Lad (Mask)",
  T_32_L_M_A_PHARAOH: "Goldlined Mummy (Mask)",
  T_32_L_M_B_JUNKFOOD: "Burger Lad (Bottom)",
  T_32_L_M_B_PHARAOH: "Goldlined Mummy (Bottom)",
  T_32_L_M_H_JUNKFOOD: "Burger Lad (Head)",
  T_32_L_M_H_PHARAOH: "Goldlined Mummy (Head)",
  T_32_L_M_S_JUNKFOOD: "Burger Lad (Shoes)",
  T_32_L_M_S_PHARAOH: "Goldlined Mummy (Shoes)",
  T_32_L_M_T_JUNKFOOD: "Burger Lad (Top)",
  T_32_L_M_T_PHARAOH: "Goldlined Mummy (Top)",
  T_32_L_T_WHITESWEATER: "White Turtleneck",
  T_32_LC_NEWVAULT_EMOTE: "Emote",
  T_32_LO_WS_IMMORTAL: "Immortal Zone",
  T_32_LO_WS_ITEM60: "Pipe",
  T_32_LO_WS_ITEM60_DESC: "A walkable tunnel",
  T_32_LO_WS_ITEM61: "T Pipe",
  T_32_LO_WS_ITEM61_DESC: "A walkable T tunnel",
  T_32_LO_WS_ITEM62: "Pipe Intersection",
  T_32_LO_WS_ITEM62_DESC: "A walkable intersecting tunnel",
  T_32_LO_WS_ITEM63: "Pipe Corner",
  T_32_LO_WS_ITEM63_DESC: "A walkable angled tunnel",
  T_32_LO_WS_ITEM64: "Food Truck",
  T_32_LO_WS_ITEM64_DESC: "Stop here to grab a bite",
  T_32_LO_WS_ITEM65: "Mush Shade",
  T_32_LO_WS_ITEM65_DESC: "A large mushroom that can carry a human",
  T_32_LO_WS_ITEM66: "Hanger",
  T_32_LO_WS_ITEM66_DESC: "Commonly seen in residential areas",
  T_32_LO_WS_ITEM67: "Wooden Plank",
  T_32_LO_WS_ITEM67_DESC: "Use to make a simple wooden bridge",
  T_32_LO_WS_ITEM68: "Lattice Screen",
  T_32_LO_WS_ITEM68_DESC: "An oriental feel",
  T_32_LO_WS_ITEM69: "Pillar",
  T_32_LO_WS_ITEM69_DESC: "Commonly seen on construction sites",
  T_32_LO_WS_ITEM70: "Cactus",
  T_32_LO_WS_ITEM70_DESC: "Mighty big but doesn't sting",
  T_32_LO_WS_ITEM71: "Leafless Tree",
  T_32_LO_WS_ITEM71_DESC: "A tree that has lived for centuries",
  T_32_LO_WS_ITEM72: "Stone Lantern",
  T_32_LO_WS_ITEM72_DESC: "Scenic decoration in imperial gardens",
  T_32_LO_WS_ITEM73: "Streetlamp",
  T_32_LO_WS_ITEM73_DESC: "Commonly seen on the streets",
  T_32_LO_WS_ITEM74: "Solar Panel",
  T_32_LO_WS_ITEM74_DESC: "Absorbs energy from sunlight",
  T_32_LO_WS_ITEM75: "Air Conditioner A",
  T_32_LO_WS_ITEM75_DESC: "Stay cool in the heat",
  T_32_LO_WS_ITEM76: "Fan",
  T_32_LO_WS_ITEM77: "Fly Pan",
  T_32_LO_WS_ITEM78: "Cube",
  T_32_LO_WS_ITEM79: "Ring",
  T_32_LO_WS_ITEM80: "Hammer",
  T_32_LO_WS_ITEM81: "Board",
  T_32_LO_WS_ITEM82: "Shooting Target",
  T_32_LO_WS_ITEM83: "Flex Wall",
  T_32_LO_WS_ITEM84AMMO: "Ammo Loot Point",
  T_32_LO_WS_ITEM84AMMO_DESC: "When placed, selected ammo type(s) will spawn there",
  T_32_LO_WS_ITEM84AR: "Armor Loot Point",
  T_32_LO_WS_ITEM84AR_DESC: "When placed, selected armor type(s) will spawn there",
  T_32_LO_WS_ITEM84ARLV1: "Armor Lv. 1",
  T_32_LO_WS_ITEM84ARLV2: "Armor Lv. 2",
  T_32_LO_WS_ITEM84ARLV3: "Armor Lv. 3",
  T_32_LO_WS_ITEM84CO: "Consumables Loot Point",
  T_32_LO_WS_ITEM84CO_DESC: "When placed, selected consumable type(s) will spawn there",
  T_32_LO_WS_ITEM84JA: "Throwables Loot Point",
  T_32_LO_WS_ITEM84JA_DESC: "When placed, selected throwable type(s) will spawn there",
  T_32_LO_WS_ITEM84TE: "Scopes Loot Point",
  T_32_LO_WS_ITEM84TE_DESC: "When placed, selected scope type(s) will spawn there",
  T_32_LO_WS_ITEM84W: "Weapon Loot Point",
  T_32_LO_WS_ITEM84W_DESC: "When placed, selected weapon type(s) will spawn there",
  T_32_LO_WS_ITEM85: "Doom/Immortal Zone",
  T_32_LO_WS_ITEM85_DESC: "When placed, players who enter the trigger zone will experience a specified effect of either immortal or doom. (Not valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_32_LO_WS_ITEM85CP: "Checkpoint",
  T_32_LO_WS_ITEM85CP_DESC: "An item used to build the gameplay in Parkour mode. For the final checkpoint to appear, players must pass by each checkpoint one by one. When eliminated and respawned, player can choose to respawn at the last checkpoint they had passed. (Not valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_32_LO_WS_ITEM85TM: "Finishing Point",
  T_32_LO_WS_ITEM85TM_DESC: "An item used to build the gameplay in Parkour mode. Players must arrive inside the finishing line for the goal to be completed. (Not valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_32_LO_WS_ITEM86: "Spawn Point",
  T_32_LO_WS_ITEM86_DESC: "No specific team will be assigned to this point. When placed, a random team will spawn here. (Not valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_32_LO_WS_ITEM86L: "Large Spawn Point",
  T_32_LO_WS_ITEM86L_DESC: "A large spawn point recommended for Parkour mode, where all players will spawn in a row. (Not valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_32_LO_WS_ITEM87: "Block",
  T_32_LO_WS_ITEM87_DESC: "Enables size customization",
  T_32_LO_WS_ITEM88: "Cuboid & Slope",
  T_32_LO_WS_ITEM88_DESC: "A cuboid or slope whose size can be adjusted",
  T_32_LO_WS_ITEMLINE: "Shift",
  T_32_LO_WS_ITEMMOVE: "Trigger Settings",
  T_32_LO_WS_ITEMROT: "Transform",
  T_32_LO_WS_ITEMSCALE: "Scale",
  T_32_LO_WS_KILLZONE: "Doom Zone",
  T_32_LO_WS_LOOT_AMMOTYPE: "Bullet",
  T_32_LO_WS_LOOT_ARTYPE: "Armor",
  T_32_LO_WS_LOOT_COTYPE: "Consumable",
  T_32_LO_WS_LOOT_JATYPE: "Throwable",
  T_32_LO_WS_LOOT_RANDOM: "Random",
  T_32_LO_WS_LOOT_TETYPE: "Scope",
  T_32_LO_WS_LOOT_WEAPONTYPE: "Weapon",
  T_32_LO_WS_SCALEX: "Length",
  T_32_LO_WS_SCALEY: "Height",
  T_32_LO_WS_SCALEZ: "Width",
  T_32_LO_WS_TRIGGERH: "Hide",
  T_32_LO_WS_TRIGGERHORP: "Show/Hide Triggers",
  T_32_LO_WS_TRIGGERP: "Show",
  T_32_LO_WS_TRIGGERTYPE: "Trigger Type",
  T_32_M_WS_MODE_ANNIHILATE: "Wipe Out",
  T_32_M_WS_MODE_SCORE: "Points Grab",
  T_32_M_WS_MODE_SPEED: "Parkour",
  T_32_M_WS_MULTIPLETEAMS: "Multi-Team Combat",
  T_32_M_WS_ROUNDS: "Rounds",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "Switching Steps",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "Danger Zone",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "Damage",
  T_32_T_WS_ME_BLUECIRCLESETTING: "Danger Zone",
  T_32_T_WS_ME_CUSTOM: "Customize",
  T_32_T_WS_ME_ENDTYPE1: "Wipe Out",
  T_32_T_WS_ME_ENDTYPE2: "Points Grab",
  T_32_T_WS_ME_ENDTYPE3: "Parkour",
  T_32_T_WS_ME_ENDTYPEDESC1: "Be the last team to survive",
  T_32_T_WS_ME_ENDTYPEDESC2: `A point-based mode where the first team to hit the target score wins.
You can set the gameplay rules and edit the gameplay parameters as you like, including setting the score awarded for eliminations.`,
  T_32_T_WS_ME_ENDTYPEDESC3: `A parkour mode where the first team to have all members reach the finishing point wins.
You can set the gameplay rules and the objects of the paths and the finishing line as you like.`,
  T_32_T_WS_ME_MATCHTIME: "Round Match Time",
  T_32_T_WS_ME_MECHANIC: "Mechanism",
  T_32_T_WS_ME_NEARCHECKPOINT: "Near checkpoint",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "Unable to have more than 12 players in total",
  T_32_T_WS_ME_PREGAMETIME: "Round Preparation Time",
  T_32_T_WS_ME_RESPAWN: "Respawns",
  T_32_T_WS_ME_RESPAWNSETTING: "Respawns",
  T_32_T_WS_ME_ROUNDNUM: "Number of rounds",
  T_32_T_WS_ME_ROUNDOPEN: "Enable multiple rounds",
  T_32_T_WS_ME_ROUNDRESET: "Round Resets",
  T_32_T_WS_ME_ROUNDSETTING: "Rounds",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "Zone Shrink Duration",
  T_32_T_WS_ME_SCORESETTING: "Score",
  T_32_T_WS_ME_TEAMMATENUM: "Members per team",
  T_32_T_WS_ME_TEAMNUM: "Number of teams",
  T_32_T_WS_ME_TEAMSETTING: "Team",
  T_32_U_ATTACHMENT_8: "Bag Pouch",
  "T_32_U_GOLD_FAMAS-I": "FAMAS-I",
  "T_32_U_GOLD_FAMAS-II": "FAMAS-II",
  "T_32_U_GOLD_FAMAS-III": "FAMAS-III",
  T_32_U_GOLD_HEATGUN_I: "PLASMA-I",
  T_32_U_GOLD_HEATGUN_II: "PLASMA-II",
  T_32_U_GOLD_HEATGUN_III: "PLASMA-III",
  T_32_U_GOLD_KAR98K_I: "Kar98k-I",
  T_32_U_GOLD_KAR98K_II: "Kar98k-II",
  T_32_U_GOLD_KAR98K_III: "Kar98k-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "Upgrade Chip",
  T_32_WT_WS_BARRIER: "Barriers",
  T_32_WT_WS_BDS: "Buildings",
  T_32_WT_WS_MMINVALIDERROR: "Invalid map code",
  T_32_WT_WS_TRGS: "Triggers",
  T_32_YF_CHARGESHOT_N: "Charge Buster",
  T_32_YF_GOLD_GROZA_N: "Groza-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "Extra Damage",
  T_32_YS_WEAPON_TAG_3: "Rate of Fire",
  T_32_YS_WEAPON_TAG_36: "Armor Piercing",
  T_32_YS_WEAPON_TAG_39: "Supports Akimbo",
  T_32_YS_WEAPON_TAG_42: "Ice Wall",
  T_33_C_SKILL_DESC_GRAFFITIST: "Creates a [FFB300]{0}m[-] area, where throwables are invalid. Allies in the area will restore [FFB300]{1}%[-]  armor durability per second and damage from ammo will reduce by [FFB300]{2}%[-] . Lasts for [FFB300]{3}s[-] . Effects do not stack. Cooldown: [FFB300]{4}s[-] .",
  T_33_C_SKILL_DESC_HITMAN: "When using Snipers and Marksman Rifles, firing sound is silenced and enemies knocked down by the user bleed [FFB300]{0}%[-] faster.",
  T_33_C_SKILL_DESC_KENTA: "Forms a shield of [FFB300]{0}m[-] width that reduces [FFB300]{1}%[-] weapon damage coming from the front. When firing, the shield's damage reduction reduces to [FFB300]{2}%[-]. Lasts for [FFB300]{3}s[-]. Cooldown: [FFB300]{4}s[-].",
  T_33_C_SKILL_DESC_MADEMANA: "Unleashes an electromagnetic wave with a diameter of [FFB300]{0}m[-] that disables enemies' skill activation, inflicts [FFB300]{3} DMG[-], and interrupts their interaction countdown. Lasts for [FFB300]{1}s[-]. Cooldown: [FFB300]{2}s[-].",
  T_33_C_SKILL_NAME_BODYGUARD: "Firearms Expert",
  T_33_C_SKILL_NAME_KENTA: "Swordsman's Wrath",
  T_33_C_SKILL_NAME_MADEMANA: "Thrill of Battle",
  T_33_DY_AXOLOTL_N: "Zasil",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "Pet Skin: Fruity Zasil",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "Pet skin: FFWS Beanie",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "Pet skin: Blooming Falco",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "Bat - Deadly Baguette",
  T_33_HQ_EMOTE_SONGKRAN_N: "Come and Dance",
  T_33_HQ_G18_CYBERTHIEF_N: "G18 - Hypercore Blues",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "Grenade - Hypercore Blues",
  T_33_HQ_M14_SPIDERLILY_N: "M14 - Burning Lily",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7 - Shadow Rogue",
  T_33_HQ_MP40_FFWS03_N: "MP40 - Haven Warrior",
  T_33_HQ_SCAR_FFWS03_N: "SCAR - Haven Warrior",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "Scythe - Emerald Power",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "Dagger - Haven Warrior",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "Vector - Hypercore Blues",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "Jeep - Emerald Shimmer",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "Monster Truck - Bonebruiser Scorch",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "Pickup Truck - Haven Guardian",
  T_33_LO_WS_BHPARA_A: "Active",
  T_33_LO_WS_BHPARA_ATKMODE: "Attack type",
  T_33_LO_WS_BHPARA_GROUP: "Faction",
  T_33_LO_WS_BHPARA_NA: "No attack",
  T_33_LO_WS_BHPARA_P: "Passive",
  T_33_LO_WS_DICE_DESC: "A dice that enhances your jumps and can be used in various gameplay",
  T_33_LO_WS_DICEVXZ: "Horizontal Speed",
  T_33_LO_WS_DICEVY: "Vertical Speed",
  T_33_LO_WS_DTOWER: "Tower",
  T_33_LO_WS_DTOWER_DESC: "Automatically attacks enemies who are within a certain distance from the defensive structure. Destroyed if its HP reaches zero. (Not valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_33_LO_WS_FORT: "Fortress",
  T_33_LO_WS_FORT_DESC: "Automatically attacks enemies who are within a certain distance from the critical structure. Destroyed if its HP reaches zero. (Not valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_33_LO_WS_ITEM89: "Refinery Tank",
  T_33_LO_WS_ITEM89_DESC: "A water-storing structure",
  T_33_LO_WS_ITEM90: "Dog House",
  T_33_LO_WS_ITEM90_DESC: "A home for puppies",
  T_33_LO_WS_ITEM91: "Bus Stop",
  T_33_LO_WS_ITEM91_DESC: "A common bus stop",
  T_33_LO_WS_ITEM92: "Graffiti Wall",
  T_33_LO_WS_ITEM92_DESC: "A wall adorned with spraypaint",
  T_33_LO_WS_ITEM93: "Stable",
  T_33_LO_WS_ITEM93_DESC: "Basic hay-made structure",
  T_33_LO_WS_ITEM94: "Bench",
  T_33_LO_WS_ITEM94_DESC: "A park bench",
  T_33_LO_WS_ITEM95: "Stone Bridge",
  T_33_LO_WS_ITEM95_DESC: "A bridge built with stones",
  T_33_LO_WS_ITEM96: "Sun Shade",
  T_33_LO_WS_ITEM96_DESC: "Prevent sun-burn under the umbrella",
  T_33_LO_WS_ITEM97: "Finish Line Arch",
  T_33_LO_WS_ITEM97_DESC: "Indicate the finishing line",
  T_33_LO_WS_ITEM98: "Ad Board",
  T_33_LO_WS_ITEM98_DESC: "A regular banner for ads",
  T_33_LO_WS_PARA_DM: "Damage",
  T_33_LO_WS_PARA_HP: "HP",
  T_33_LO_WS_PARA_RANGE: "Enemy scan distance",
  T_33_LO_WS_PARA_SP: "Speed",
  T_33_LO_WS_ZBPARA_AMOUNT: "Zombies per wave",
  T_33_LO_WS_ZBPARA_INTERVAL: "Wave interval (s)",
  T_33_LO_WS_ZBPARA_ROUND: "# of waves",
  T_33_LO_WS_ZBSPAWNER: "Zombie Spawn",
  T_33_LO_WS_ZBSPAWNER_DESC: "Automatically spawns zombies according to configurations. Their behavior can be configured using the drop-down menu. (Not valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_33_MF_CHARACTER_BLACKSMITH_N: "Kenta",
  T_33_PD_ZOMBIE_LEVELUP: "Level up",
  T_33_RW_SKILL_DESC_GANGGIRL: "Increases firing rate by [FFB300]{0}%[-]. When user hits an enemy, a maximum of [FFB300]{1}%[-] of the firing rate converts into movement speed, and the conversion resets when user survives the combat.",
  T_33_RW_SKILL_NAME_GANGGIRL: "Fight-or-Flight",
  T_33_WT_WS_BASICSET1: "Basic",
  T_33_WT_WS_QCEPRTIP: "Convert EP into HP faster",
  T_33_WT_WS_SKILLSET_TAG: "Unlimited skill",
  T_33_WT_WS_SKILLSET1: "Skills Settings",
  T_33_WT_WS_SKILLSET10: "Time Turner (Chrono)",
  T_33_WT_WS_SKILLSET11: "Riptide Rhythm (Skyler)",
  T_33_WT_WS_SKILLSET12: "Xtreme Encounter (Xayne)",
  T_33_WT_WS_SKILLSET13: "Healing Heartbeat (Dimitri)",
  T_33_WT_WS_SKILLSET2: "Passive Skills",
  T_33_WT_WS_SKILLSET2_TIP: "Turn on/off passive skills",
  T_33_WT_WS_SKILLSET3: "Active Skills (turn on to adjust cooldown time below)",
  T_33_WT_WS_SKILLSET3_TIP: "Turn active skills on/off. If on, cooldown time of various active skills can be configured below.",
  T_33_WT_WS_SKILLSET4: "Camouflage (Wukong)",
  T_33_WT_WS_SKILLSET5: "Thrill of Battle (A124)",
  T_33_WT_WS_SKILLSET6: "Drop the Beat (Alok)",
  T_33_WT_WS_SKILLSET7: "Painted Refuge (Steffie)",
  T_33_WT_WS_SKILLSET8: "Tracing Steps (Clu)",
  T_33_WT_WS_SKILLSET9: "Master of All (K)",
  T_33_WT_WS_UNIT_HPSECOND: "HP/s",
  T_33_WT_WS_UNIT_METER: "m",
  T_33_WT_WS_UNIT_SECOND: "sec",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "Raindoll (Bottom)",
  T_33_YS_H_ONIGIRI: "Onigiri Hood",
  T_33_YS_H_RAINCOAT: "Raindoll (Head)",
  T_33_YS_HA_CRYINGFACE: "Crying Emote (Facepaint)",
  T_33_YS_M_H_FROGKING: "Frog King Cap",
  T_33_YS_S_RAINCOAT: "Raindoll (Shoes)",
  T_33_YS_T_BLACKHOLE: "The Doppler Shift Hoodie",
  T_33_YS_T_RAINCOAT: "Raindoll (Top)",
  T_33_YS_T_SOCCER_GREEN: "Electrified Kick (Jersey)",
  T_33_YS_T_SOCCER_YELLOW: "Energized Kick (Jersey)",
  T_33_YS_T_WIFI: "Net n' Next T-shirt",
  T_34_C_SKILL_DESC_STREAMERGUY: "Every elimination or spectator grants one stack of the effect. Each stack reduces headshot damage received by [FFB300]{0}%[-] (max. [FFB300]{1}%[-] in total) and increases headshot damage to enemies by [FFB300]{2}%[-] (max. [FFB300]{3}%[-] in total).",
  T_34_C_SKILL_DESC_TRACKER: "Releases a drone towards the nearest enemy within a [FFB300]100m[-] frontal distance, creating a [FFB300]{5}m-diameter[-] pulse explosion which reduces movement speed by [FFB300]{0}%[-] and firing speed by [FFB300]{1}%[-]. Lasts for [FFB300]{3}s[-]. Deals [FFB300]{2} DMG[-]. Cooldown: [FFB300]{4}s[-].",
  T_34_C_SKILL_NAME_TRACKER: "Senses Shockwave",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "Pet Skin: Angry Surfer Finn",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "Pet Skin: Deep Ocean Finn",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "Pet Skin: Thunderstorm Finn",
  T_34_DY_PETSKIN_TIGER_BIS_N: "Pet Skin: Digital Tig",
  T_34_DY_SURFSHARK_N: "Finn",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "Great Conductor",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "Energetic",
  T_34_HQ_EMOTE_RIDICULE_N: "Ridicule",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "Pickup Truck - Evil Engineer",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "Tuk Tuk - Husky Pup",
  T_34_JL_EAGLE_RAMPAGE4_N: "Desert Eagle - Hybrid Explosion",
  T_34_JL_G36_MADBIONIC_N: "G36 - Flaring Bionica",
  T_34_JL_GRENADE_BIS_N: "Grenade - Soldier Pixel",
  T_34_JL_MACHETE_RAMPAGE4_N: "Parang - Night Blade",
  T_34_JL_THROWINGKNIFE_BANANA_N: "Dagger - Banana",
  T_34_JL_UMP45_BIS_N: "UMP - Digital Dasher",
  T_34_LY_WS_ABS_DESC: "Get the absolute value of this number",
  T_34_LY_WS_ADD_DESC: "Add a new element to the end of a list",
  T_34_LY_WS_AUTO_A: "Auto Scan Enemies",
  T_34_LY_WS_BOT: "Regular",
  T_34_LY_WS_BOT_PATH: "Path",
  T_34_LY_WS_BOT_TYPE: "Type",
  T_34_LY_WS_BOT4: "Axe",
  T_34_LY_WS_BOT5: "Tossing",
  T_34_LY_WS_BOT6: "Self-explode",
  T_34_LY_WS_BOT8: "Shielded",
  T_34_LY_WS_COL_DESC: "Select a color",
  T_34_LY_WS_DEL_DESC: "Delete the corresponding element of a designated index in a list",
  T_34_LY_WS_DF_PER: "Defense %",
  T_34_LY_WS_FORT_INTERVAL: "Attack interval time (s)",
  T_34_LY_WS_GET: "Obtain",
  T_34_LY_WS_GET_DESC: "Get the corresponding element of a designated index in a list",
  T_34_LY_WS_GLEN_ARR_DESC: "Get the number of elements in the current list",
  T_34_LY_WS_GLEN_DESC: "Obtain the length of this string of text",
  T_34_LY_WS_GVX: "Get x vector component",
  T_34_LY_WS_GVX_DESC: "Get the first component of a vector",
  T_34_LY_WS_GVY: "Get y vector component",
  T_34_LY_WS_GVY_DESC: "Get the second component of a vector",
  T_34_LY_WS_GVZ: "Obtain z vector component",
  T_34_LY_WS_GVZ_DESC: "Get the third component of a vector",
  T_34_LY_WS_INDEX: "Index",
  T_34_LY_WS_JOIN: "Connect",
  T_34_LY_WS_NEG_DESC: "Get the negative value of this number",
  T_34_LY_WS_PATH: "Path Setter",
  T_34_LY_WS_PATH_DESC: "Use to add/delete traveling paths of special living items. (Not valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_34_LY_WS_POINT: "Marker",
  T_34_LY_WS_POINT_DESC: "Use to mark out the coordinates of the current location. (Not valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_34_LY_WS_RANGE_F: "Far",
  T_34_LY_WS_RANGE_M: "Medium",
  T_34_LY_WS_RANGE_N: "Near",
  T_34_LY_WS_RNDF_DESC: "Generate a random float from an interval",
  T_34_LY_WS_RNDI_DESC: "Generate a random integer from an interval",
  T_34_LY_WS_SET: "Set",
  T_34_LY_WS_SET_DESC: "Set the corresponding element of a designated index in a list",
  T_34_LY_WS_SQRT_DESC: "Obtain the square root of this number",
  T_34_LY_WS_STRC_DESC: "Connect two strings of texts",
  T_34_LY_WS_SVX: "Set x vector component",
  T_34_LY_WS_SVX_DESC: "Set the first component of a vector",
  T_34_LY_WS_SVY: "Set y vector component",
  T_34_LY_WS_SVY_DESC: "Set the second component of a vector",
  T_34_LY_WS_SVZ: "Set z vector component",
  T_34_LY_WS_SVZ_DESC: "Set the third component of a vector",
  T_34_LY_WS_VADD: "Vector addition",
  T_34_LY_WS_VADD_DESC: "Add two vectors",
  T_34_LY_WS_VAL_DESC: "Input an integer or float according to the scenario",
  T_34_LY_WS_VANG_DESC: "Calculate the angle between two vectors",
  T_34_LY_WS_VCP: "Cross product",
  T_34_LY_WS_VCP_DESC: "Calculate the cross product of two vectors",
  T_34_LY_WS_VDIS_DESC: "Calculate the distance between two vectors",
  T_34_LY_WS_VDP: "Dot product",
  T_34_LY_WS_VDP_DESC: "Calculate the dot product of two vectors",
  T_34_LY_WS_VFX1: "Spherical",
  T_34_LY_WS_VFX2: "Cylindrical",
  T_34_LY_WS_VFX3: "Ring",
  T_34_LY_WS_VFX4: "Boom",
  T_34_LY_WS_VFX5: "Pixels",
  T_34_LY_WS_VFX6: "Sparks",
  T_34_LY_WS_VMOD_DESC: "Calculate the magnitude of a vector",
  T_34_LY_WS_VMUL: "Vector multiplication",
  T_34_LY_WS_VMUL_DESC: "Multiply two vectors",
  T_34_LY_WS_VNOR_DESC: "Normalize a vector",
  T_34_LY_WS_VSUB: "Vector subtraction",
  T_34_LY_WS_VSUB_DESC: "Subtract two vectors",
  T_34_M_WS_ANGLE: "Rotate angle",
  T_34_M_WS_ARRAY: "List",
  T_34_M_WS_ATT: "Property",
  T_34_M_WS_BOOL: "Boolean",
  T_34_M_WS_COLORARRAY: "Color array",
  T_34_M_WS_COLOUR: "Color",
  T_34_M_WS_CONFRONBANNER: "Battle banner",
  T_34_M_WS_COORDINATE: "Coordinates",
  T_34_M_WS_CUSTOMINF: "Custom HUD",
  T_34_M_WS_CUSTOMMODEDESC: `An empty and fully customizable mode with no preset gameplay, where you can create and play by your own rules.
A little tricky for beginner map creators.`,
  T_34_M_WS_DAMAGETYPE: "Damage type",
  T_34_M_WS_DAMAGETYPEDESC: "The type of damage currently set by the system",
  T_34_M_WS_DESCTEXT: "Descriptive text",
  T_34_M_WS_DURACTION: "Duration",
  T_34_M_WS_ECAMODE: "Customize Mode",
  T_34_M_WS_ENDPHASEDESC: "Immediately end the current phase and proceed to the next one",
  T_34_M_WS_ENTITY: "Entity",
  T_34_M_WS_FLOAT: "Float",
  T_34_M_WS_GAME: "Game",
  T_34_M_WS_GAMERESULTS: "Match result",
  T_34_M_WS_GETCONTROL2: "Get a control entity from players interface to edit the entity's properties (including design, color, content, etc.)",
  T_34_M_WS_HEIGHT: "Height",
  T_34_M_WS_HUDBUTTONWIDGET: "Button control",
  T_34_M_WS_HUDEMPTYWIDGET: "Empty pivot",
  T_34_M_WS_HUDIMAGEWIDGET: "Image control",
  T_34_M_WS_HUDINPUTWIDGET: "Text box control",
  T_34_M_WS_HUDLABELWIDGET: "Text control",
  T_34_M_WS_ICON: "Icon",
  T_34_M_WS_ICON_AIM: "Aim",
  T_34_M_WS_ICON_ARROW: "Arrow",
  T_34_M_WS_ICON_BLAST: "Blast",
  T_34_M_WS_ICON_CIRCULAR: "Circle",
  T_34_M_WS_ICON_CLOTH: "Palm",
  T_34_M_WS_ICON_COLLIMATION: "Crosshair",
  T_34_M_WS_ICON_CORPSE: "Zombie",
  T_34_M_WS_ICON_CROSS: "Cross",
  T_34_M_WS_ICON_DAY: "Sun",
  T_34_M_WS_ICON_DEFENSE: "Shield",
  T_34_M_WS_ICON_DIALOGUE: "Dialogue",
  T_34_M_WS_ICON_DIAMONDS: "Diamond",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "Exclamation mark",
  T_34_M_WS_ICON_FLAG: "Flag",
  T_34_M_WS_ICON_FOLDER: "Folder",
  T_34_M_WS_ICON_GLASSES: "Eye",
  T_34_M_WS_ICON_GUN: "Gun",
  T_34_M_WS_ICON_HEART: "Heart",
  T_34_M_WS_ICON_HEXAGON: "Hexagon",
  T_34_M_WS_ICON_HOURGLASS: "Hourglass",
  T_34_M_WS_ICON_HOUSE: "House",
  T_34_M_WS_ICON_KEY: "Key",
  T_34_M_WS_ICON_LIGHTNING: "Lightning",
  T_34_M_WS_ICON_LOCK: "Lock",
  T_34_M_WS_ICON_LOOP: "Loop",
  T_34_M_WS_ICON_MAGNIFIER: "Magnifying glass",
  T_34_M_WS_ICON_MONEY: "Money",
  T_34_M_WS_ICON_MONTH: "Moon",
  T_34_M_WS_ICON_OPENFOLDER: "Open folder",
  T_34_M_WS_ICON_PLUS: "Plus",
  T_34_M_WS_ICON_QUADRI: "Quadrilateral",
  T_34_M_WS_ICON_QUESTIONMARK: "Question mark",
  T_34_M_WS_ICON_RECYCLING: "Recycle",
  T_34_M_WS_ICON_REFRESH: "Refresh",
  T_34_M_WS_ICON_REST: "Rest",
  T_34_M_WS_ICON_RETURN: "Back",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "Right trapezoid",
  T_34_M_WS_ICON_SCISSORS: "Scissors",
  T_34_M_WS_ICON_SETUP: "Setting",
  T_34_M_WS_ICON_SIGN: "Mark",
  T_34_M_WS_ICON_SIGNOUT: "Exit",
  T_34_M_WS_ICON_SQUARE: "Square",
  T_34_M_WS_ICON_STAR: "Star",
  T_34_M_WS_ICON_STONE: "Stone",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "Swim ring",
  T_34_M_WS_ICON_TAGGING: "Pin",
  T_34_M_WS_ICON_THESWORD: "Sword",
  T_34_M_WS_ICON_TRAPEZOID: "Trapezoid",
  T_34_M_WS_ICON_TRASHCAN: "Trash can",
  T_34_M_WS_ICON_TRIANGLE: "Triangle",
  T_34_M_WS_ICON_TROPHY: "Trophy",
  T_34_M_WS_ICON_UP: "Thumbs up",
  T_34_M_WS_ICON_WRONG: "Wrong",
  T_34_M_WS_ICON_YES: "Right",
  T_34_M_WS_ICONNAME: "Icon name",
  T_34_M_WS_INT: "Integer",
  T_34_M_WS_KILLZONE: "Doom Zone",
  T_34_M_WS_LEFTCOLOR: "Left color",
  T_34_M_WS_LEFTTEAMINDEX: "Left team index",
  T_34_M_WS_LEFTTEAMSCORE: "Left team score",
  T_34_M_WS_LOCSWITCH: "Localization switch",
  T_34_M_WS_MAX: "Maximum",
  T_34_M_WS_MIN: "Minimum",
  T_34_M_WS_NUMBER: "Number",
  T_34_M_WS_OBJECT: "Entity",
  T_34_M_WS_OPEN: "On",
  T_34_M_WS_OPENSATUS: "Turn on status",
  T_34_M_WS_PICTURE: "Graphics",
  T_34_M_WS_RANKARRAY: "Rank array",
  T_34_M_WS_RESULTS: "Results",
  T_34_M_WS_RIGHTCOLOR: "Right color",
  T_34_M_WS_RIGHTTEAMINDEX: "Right team index",
  T_34_M_WS_RIGHTTEAMSCORE: "Right team score",
  T_34_M_WS_ROUNDBANNER: "Round banner",
  T_34_M_WS_ROUNDDESC: "Round description",
  T_34_M_WS_ROUNDHUD: "Round number",
  T_34_M_WS_ROUNDPARAMS: "Round number array",
  T_34_M_WS_SAME_NAME: "Repeated name. Please try a new one.",
  T_34_M_WS_SCOREARRAY: "Score array",
  T_34_M_WS_SCORINGTYPE: "Score type",
  T_34_M_WS_SCORINGTYPEDECS: "The type of score players could get. Supports score customization.",
  T_34_M_WS_SCUFFLESCORING: "Multi-team score",
  T_34_M_WS_SETATTRIBUTES: "Property settings",
  T_34_M_WS_SHUT: "Off",
  T_34_M_WS_SOUND: "Sound effects",
  T_34_M_WS_SOUNDCLICK: "Clicking",
  T_34_M_WS_SOUNDDD: "Countdown",
  T_34_M_WS_SOUNDFEMALEA: "Injured (Female)",
  T_34_M_WS_SOUNDM: "Gunfire",
  T_34_M_WS_SOUNDMALEA: "Injured (Male)",
  T_34_M_WS_SOUNDUAV: "Explosion",
  T_34_M_WS_ST_ASSISTCOUNT: "Assists",
  T_34_M_WS_ST_CHECKPROGRESS: "Checkpoint progress",
  T_34_M_WS_ST_DAMAGESUM: "Damage",
  T_34_M_WS_ST_FINISHCOUNT: "Amount of goals achieved",
  T_34_M_WS_ST_FINISHORDER: "Order of goals achieved",
  T_34_M_WS_ST_FINISHTIME: "Time of goals achieved",
  T_34_M_WS_ST_KILLCOUNT: "Eliminations",
  T_34_M_WS_ST_MAINSCORE: "Target score",
  T_34_M_WS_ST_RANKSCORE: "Rank score",
  T_34_M_WS_ST_SURVIVALDURACTION: "Survival time",
  T_34_M_WS_ST_UNKOWN: "Unknown",
  T_34_M_WS_STARTBANNER: "Start banner",
  T_34_M_WS_STARTTIME: "Start time",
  T_34_M_WS_STRING: "Text",
  T_34_M_WS_STUDIO: "STUDIO",
  T_34_M_WS_TEAMARRAY: "Team array",
  T_34_M_WS_TEXTCONTENT: "Content",
  T_34_M_WS_THEMECOLOR: "Theme color",
  T_34_M_WS_TIME: "Countdown HUD",
  T_34_M_WS_TITLETEXT: "Title text",
  T_34_M_WS_TYPE: "Type",
  T_34_M_WS_UODATETYPE: "Update type",
  T_34_M_WS_VARNAME: "Variable name",
  T_34_M_WS_VECTOR: "Vector",
  T_34_M_WS_VFX: "Visual effects",
  T_34_M_WS_WIDTH: "Width",
  T_34_MF_CHARACTER_TRACKER_N: "Homer",
  T_34_PD_FlagBattle_HYPE_1: "Fire",
  T_34_SP_WS_BLOCK1_NAME: "Switch phase",
  T_34_SP_WS_BLOCK1_NAMEDESC: "Switch the phase of a match to enter into a desired phase (or round). Rounds also have phase indices and are a special type of phase.",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "The index of the target phase",
  T_34_SP_WS_BLOCK10_NAME: "Create visual effects",
  T_34_SP_WS_BLOCK10_NAMEDESC: "Create an icon using designated visual effects. More properties of the visual effect can be configured by adjusting the properties of the visual effects entity.",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "Visual effect",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "The kinds of visual effects that can be applied",
  T_34_SP_WS_BLOCK12_NAME: "Delete visual effects",
  T_34_SP_WS_BLOCK12_NAMEDESC: "Delete the designated visual effect",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "Visual effects entity",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "The visual effect entity to be deleted",
  T_34_SP_WS_BLOCK13_NAMEDESC: "Order the client to play the visual effect",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "Players list",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "The players who will receive the message",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "Resource path",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "System resource path is in:path. Custom resource path is out:path. Empty by default.",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "RGBA channel, with each channel taking a value between 0 and 255 saved in int32. Default color is white (255,255,255,255).",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "Zoom",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "Zoom scale; default is 1",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "Position of display expressed in global coordinates. Vector3(0) by default.",
  T_34_SP_WS_BLOCK14_NAME: "Play sound effect",
  T_34_SP_WS_BLOCK14_NAMEDESC: "Order the client to play the sound effect",
  T_34_SP_WS_BLOCK15_NAME: "Output log",
  T_34_SP_WS_BLOCK15_NAMEDESC: "Output content onto the log interface",
  T_34_SP_WS_BLOCK2_NAMEDESC: "Turn on to enable damage to players outside the Safe Zone",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "The center point of the Safe Zone",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "Radius",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "The radius of the Safe Zone",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "The countdown for the Safe Zone to start shrinking",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "The duration of the Safe Zone shrink",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "The amount of damage taken when outside the Safe Zone",
  T_34_SP_WS_BLOCK3_NAMEDESC: "When Danger Zone is turned off, players outside the Safe Zone will not receive damage",
  T_34_SP_WS_BLOCK4_NAMEDESC: "Use to delay a subsequent action for a designated time",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "The duration of the wait, measured in milleseconds",
  T_34_SP_WS_BLOCK5_NAMEDESC: "Use to postpone a subsequent action to the next frame",
  T_34_SP_WS_BLOCK6_NAME: "Create custom HUD",
  T_34_SP_WS_BLOCK6_NAMEDESC: "Create a designated custom HUD",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "A name that is used for creating a HUD entity. The local variable it corresponds to is the entity of the HUD being created.",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "Player",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "The entity of a specific player. Only visible to said player.",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "The unique index of a HUD",
  T_34_SP_WS_BLOCK7_NAMEDESC: "Create a default HUD, which is only visible for designated players",
  T_34_SP_WS_BLOCK8_NAMEDESC: "When deleted, the default HUD will not be seen on the client (either hidden or discarded)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "HUD entity",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "The HUD entity to be deleted",
  T_34_SP_WS_BLOCK9_NAMEDESC: "When deleted, the custom HUD will not be seen on the client (either hidden or discarded)",
  T_34_T_WS_BLOCK1_NAMEDESC: "Incident triggers when the match begins",
  T_34_T_WS_BLOCK10_NAMEDESC: "Incident triggers when a player is eliminated",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "The eliminated player who will trigger the incident",
  T_34_T_WS_BLOCK13_NAMEDESC: "Incident triggers when a player assists another player",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "The player who is eliminated",
  T_34_T_WS_BLOCK14_NAMEDESC: "Incident triggers when a player deals damage",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "The player who receives the damage",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "The type of damage being inflicted",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "The amount of damage inflicted",
  T_34_T_WS_BLOCK15_NAMEDESC: "Incident triggers when a player eliminates another player",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "The player who is eliminated",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "The type of damage that cause the elimination",
  T_34_T_WS_BLOCK16_NAMEDESC: "Incident triggers when a player joins the match",
  T_34_T_WS_BLOCK17_NAMEDESC: "Incident triggers when a player is revived",
  T_34_T_WS_BLOCK18_NAMEDESC: "Incident triggers when a team is removed",
  T_34_T_WS_BLOCK19_NAMEDESC: "Incident triggers when a team is added",
  T_34_T_WS_BLOCK2_NAMEDESC: "Incident triggers when the match ends",
  T_34_T_WS_BLOCK20_NAMEDESC: "Incident triggers when a team is wiped out",
  T_34_T_WS_BLOCK3_NAMEDESC: "Incident triggers when each round begins",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "The round number starts from 0",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "Round index",
  T_34_T_WS_BLOCK4_NAMEDESC: "Incident triggers when each round ends",
  T_34_T_WS_BLOCK5_NAMEDESC: "Incident triggers when the phase begins",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "The phase number starts from 0",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "Phase entity",
  T_34_T_WS_BLOCK6_NAMEDESC: "Incident triggers when the phase ends",
  T_34_T_WS_BLOCK7_NAMEDESC: "Incident triggers when a player exits the match",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "The player who will trigger the incident",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "Triggering player",
  T_34_T_WS_BLOCK8_NAMEDESC: "Incident triggers when a player's score changes",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "The type of the changed score",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "The score value after the change",
  T_34_T_WS_BLOCK9_NAMEDESC: "Incident triggers when a team's score changes",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "The team who will trigger the incident",
  T_34_WT_WS_BORNENTITY_PARAM1: "Spawn point",
  T_34_WT_WS_BORNENTITY_PARAM2: "Available coordinates",
  T_34_WT_WS_BORNENTITY_PARAM3: "Set as default spawn point",
  T_34_WT_WS_BORNENTITY_PARAM4: "Glowing boundaries",
  T_34_WT_WS_BORNENTITY_PARAM5: "In use or not",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "Checkpoint HUD",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "Open status",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "Status trigger",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "Elimination trigger or not",
  T_34_WT_WS_ENTITY_PARAM1: "Game entity",
  T_34_WT_WS_ENTITY_PARAM10: "# of teams",
  T_34_WT_WS_ENTITY_PARAM11: "# of team members",
  T_34_WT_WS_ENTITY_PARAM12: "Equipment reset each round",
  T_34_WT_WS_ENTITY_PARAM13: "Enable out-of-zone damage",
  T_34_WT_WS_ENTITY_PARAM14: "Zone size",
  T_34_WT_WS_ENTITY_PARAM15: "Zone shrink start time",
  T_34_WT_WS_ENTITY_PARAM16: "Zone shrink duration",
  T_34_WT_WS_ENTITY_PARAM17: "Out-of-zone damage",
  T_34_WT_WS_ENTITY_PARAM18: "Target score",
  T_34_WT_WS_ENTITY_PARAM19: "Elimination score",
  T_34_WT_WS_ENTITY_PARAM2: "Invalid status",
  T_34_WT_WS_ENTITY_PARAM20: "Revival type",
  T_34_WT_WS_ENTITY_PARAM21: "Round score ranking criteria (player)",
  T_34_WT_WS_ENTITY_PARAM22: "Criteria importance (player)",
  T_34_WT_WS_ENTITY_PARAM23: "Round score ranking criteria (team)",
  T_34_WT_WS_ENTITY_PARAM24: "Criteria importance (team)",
  T_34_WT_WS_ENTITY_PARAM25: "Score ranking criteria (MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "Criteria importance (MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "Round ranking score",
  T_34_WT_WS_ENTITY_PARAM28: "Show criteria on results page",
  T_34_WT_WS_ENTITY_PARAM29: "Total # of rounds",
  T_34_WT_WS_ENTITY_PARAM3: "Game time",
  T_34_WT_WS_ENTITY_PARAM4: "Current round index",
  T_34_WT_WS_ENTITY_PARAM5: "Current phase index",
  T_34_WT_WS_ENTITY_PARAM6: "Mode template ID",
  T_34_WT_WS_ENTITY_PARAM7: "Enable player revival",
  T_34_WT_WS_ENTITY_PARAM8: "Enable bot revival",
  T_34_WT_WS_ENTITY_PARAM9: "Revival time",
  T_34_WT_WS_ENTITY1_NAME: "Current entity",
  T_34_WT_WS_ENTITY1_NAMEDESC: "Return to current entity",
  T_34_WT_WS_ENTITY10_NAME: "Remove icon",
  T_34_WT_WS_ENTITY10_NAMEDESC: "Remove a designated icon",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "Select the icon you wish to remove",
  T_34_WT_WS_ENTITY11_NAME: "Remove text",
  T_34_WT_WS_ENTITY11_NAMEDESC: "Remove a text entity",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "Select the text you wish to remove",
  T_34_WT_WS_ENTITY12_NAMEDESC: "Add an item for a designated player",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "Player(s) who will receive the item",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "The specific item ID to be got",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "The amount of items to be given",
  T_34_WT_WS_ENTITY12_PARAM3: "Quantity",
  T_34_WT_WS_ENTITY13_PARAM1: "Type",
  T_34_WT_WS_ENTITY13_PARAM2: "Location",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "The coordinates of the object's spawn location",
  T_34_WT_WS_ENTITY13_PARAM4: "Object",
  T_34_WT_WS_ENTITY14_NAME: "Remove object",
  T_34_WT_WS_ENTITY14_NAMEDESC: "Remove a designated object",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "Delete the object",
  T_34_WT_WS_ENTITY15_NAMEDESC: "Acquire all player entities",
  T_34_WT_WS_ENTITY16_NAMEDESC: "Acquire all team entities",
  T_34_WT_WS_ENTITY17_NAMEDESC: "Recover a designated amount of HP for designated players. If the recovery amount exceeds the maximum HP, the HP will only recover to the maximum.",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "Player(s) whose HP fluctuation(s) are being configured",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "The designated amount of HP to be recovered",
  T_34_WT_WS_ENTITY18_NAME: "Get random spawn coordinates",
  T_34_WT_WS_ENTITY18_NAMEDESC: "Configure the location for designated players to spawn from and return to",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "Player(s) who will randomly spawn from this location",
  T_34_WT_WS_ENTITY18_RETURNDESC: "The coordinates of the location where the player will be assigned",
  T_34_WT_WS_ENTITY19_NAME: "Get player score",
  T_34_WT_WS_ENTITY19_NAMEDESC: "Acquire certain scores of designated players",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "Acquire the score entity of this player(s)",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "Acquire the type of score",
  T_34_WT_WS_ENTITY19_RETURNDESC: "The specific score value to be got",
  T_34_WT_WS_ENTITY2_NAME: "Set property",
  T_34_WT_WS_ENTITY2_NAMEDESC: "Configure the value of a property, where the property type has already been selected",
  T_34_WT_WS_ENTITY2_PARAM1: "Entity",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "The property value of the game entity",
  T_34_WT_WS_ENTITY2_PARAM3: "Property",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "A certain property of this game entity",
  T_34_WT_WS_ENTITY2_PARAM4: "Value",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "A specific value of a property. Make sure that the property type aligns with the one selected and matches the type  configured in related blocks.",
  T_34_WT_WS_ENTITY20_NAMEDESC: "Configure certain scores of designated players",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "Configure the score entity of this player(s)",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "Configure the type of score",
  T_34_WT_WS_ENTITY20_PARAM3: "Score",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "The specific score value being set",
  T_34_WT_WS_ENTITY21_NAME: "Get team total score",
  T_34_WT_WS_ENTITY21_NAMEDESC: "Acquire a certain kind of total scores of designated teams",
  T_34_WT_WS_ENTITY21_PARAM1: "Team",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "Get the score entity of this team(s)",
  T_34_WT_WS_ENTITY22_NAME: "Set team current round score",
  T_34_WT_WS_ENTITY22_NAMEDESC: "Configure a certain kind of current round scores of designated teams",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "Configure the score(s) of this team(s)",
  T_34_WT_WS_ENTITY23_NAME: "Obtain player round score",
  T_34_WT_WS_ENTITY23_NAMEDESC: "Acquire certain scores of a certain round for designated players",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "Acquire the round score(s) of this player(s)",
  T_34_WT_WS_ENTITY23_PARAM2: "Round",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "Get the score from this round",
  T_34_WT_WS_ENTITY24_NAME: "Get team round score",
  T_34_WT_WS_ENTITY24_NAMEDESC: "Acquire certain scores of a certain round for designated teams",
  T_34_WT_WS_ENTITY25_NAME: "Teleport",
  T_34_WT_WS_ENTITY25_NAMEDESC: "Teleport designated players to a designated location",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "Player(s) who will be teleported",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "Coordinates of where the player(s) will be teleported",
  T_34_WT_WS_ENTITY26_NAMEDESC: "Enable designated players to cause damage to designated targets. If no attacking player is selected, designated targets will receive damage from the system.",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "Entities who will receive the damage",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "The amount of damage dealt",
  T_34_WT_WS_ENTITY28_NAMEDESC: "Revive designated players",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "Player entities who can be revived",
  T_34_WT_WS_ENTITY3_NAMEDESC: "Configure the type of the block",
  T_34_WT_WS_ENTITY3_PARAM1: "as",
  T_34_WT_WS_ENTITY4_NAME: "Get property",
  T_34_WT_WS_ENTITY4_NAMEDESC: "Get a specific property of an entity",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "Get the specific game entity of the property value",
  T_34_WT_WS_ENTITY4_RETURNDESC: "The specific property value to be got",
  T_34_WT_WS_ENTITY5_NAMEDESC: "Configure the ability to move for all players",
  T_34_WT_WS_ENTITY6_NAME: "Create Icon",
  T_34_WT_WS_ENTITY6_PARAM1: "Icon",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "An image displayed on the HUD. Select from various designs.",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "Select the icon on which the design should be applied",
  T_34_WT_WS_ENTITY7_NAMEDESC: "Create a HUD icon for designated players. If no player entity is selected, the HUD will be created for all players.",
  T_34_WT_WS_ENTITY7_PARAM1: "Player",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "Create a HUD icon for select player(s)",
  T_34_WT_WS_ENTITY8_NAME: "Create text",
  T_34_WT_WS_ENTITY8_PARAM1: "Text",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "The specific text content to be created from this command",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "The text entity that is currently being created",
  T_34_WT_WS_ENTITY9_NAMEDESC: "Add a line of HUD text for designated players. If no player entity is selected, the text will be created on the HUD of all players.",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "Add a HUD text for select player(s)",
  T_34_WT_WS_ICONENTITY_PARAM1: "Icon entity",
  T_34_WT_WS_ICONENTITY_PARAM2: "Design",
  T_34_WT_WS_ICONENTITY_PARAM3: "Color",
  T_34_WT_WS_ICONENTITY_PARAM4: "Scale",
  T_34_WT_WS_ICONENTITY_PARAM5: "Position of display",
  T_34_WT_WS_ICONENTITY_PARAM6: "Follow target",
  T_34_WT_WS_ICONENTITY_PARAM7: "Visible through walls",
  T_34_WT_WS_ICONENTITY_PARAM8: "Always on screen",
  T_34_WT_WS_ONETEAM_TAG: "Single Team",
  T_34_WT_WS_PHASEENTITY_PARAM1: "Phase entity",
  T_34_WT_WS_PHASEENTITY_PARAM2: "Phase index",
  T_34_WT_WS_PHASEENTITY_PARAM3: "Start time",
  T_34_WT_WS_PHASEENTITY_PARAM4: "End time",
  T_34_WT_WS_PHASEENTITY_PARAM5: "Duration",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "Player entity",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "Revival point",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "Damage ratio",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "Character 3D model",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "Identity",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "Current HP",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "Max. HP",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "AI",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "Player status",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "Survival time",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "Invulnerable",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "Team",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "Target checkpoint ID",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "Spawn point",
  T_34_WT_WS_PROCIRCLE_ICON: "Icon",
  T_34_WT_WS_PVEDESC1: "If at least one player reaches the finishing line before time runs out, team wins. If all players are eliminated at the same time, game over.",
  T_34_WT_WS_PVEDESC2: "Survive for a designated time to win. If all players are eliminated at the same time, game over.",
  T_34_WT_WS_PVENAME1: "Rush",
  T_34_WT_WS_PVENAME2: "Endurance",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "Current checkpoint ID",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "Parkour mode checkpoint number",
  T_34_WT_WS_SKILLSET14: "Swordsman's Wrath (Kenta)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "Team entity",
  T_34_WT_WS_TEAMENTITY_PARAM2: "Ace",
  T_34_WT_WS_TEAMENTITY_PARAM3: "All members",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "Regular trigger",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "Appearance type",
  T_34_WT_WS_TXTENTITY_PARAM1: "Text entity",
  T_34_WT_WS_TXTENTITY_PARAM2: "Content",
  T_34_WT_WS_VFXENTITY_PARAM1: "Visual effects entity",
  T_34_WZ_WS_LOGIC10_NAME: "Continue to next",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "Skip the current loop iteration and execute the next",
  T_34_WZ_WS_LOGIC11_NAME: "Return",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "Terminates the current execution and returns to the main program. Allows sending back data when returning.",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "Return value",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "The data to be sent back to the main program",
  T_34_WZ_WS_LOGIC2_NAME: "Compare",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "Compare 2 values using a designated operator",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "Left value",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "The left side value used for the comparison",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "Comparison function",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "Select how you want the values compared. Supported operators are: >, ≥, ==, ≠, ≤, <, AND (Boolean only), OR (Boolean only)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "Right value",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "The right side value used for the comparison",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "Result of the comparison",
  T_34_WZ_WS_LOGIC3_NAME: "NOT",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "Gives the reverse of a logical value",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "The value you wish to use the NOT operator on",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "Result of the NOT operation",
  T_34_WZ_WS_LOGIC4_NAME: "Check null",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "Check whether an entity is null",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "Entity",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "The entity to check emptiness for",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "Whether or not the entity is empty",
  T_34_WZ_WS_LOGIC5_NAME: "If",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "Executes according to whether conditions are being met. The sub-processes are the same as the subsequent logic branches.",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "Value",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "The number of conditions and the number of sub-processes (logic branches) must be the same",
  T_34_WZ_WS_LOGIC6_NAME: "Loop of integer range",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "Loop from x to y by a step of z. The sub-process is the loop itself.",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "The name of the loop index that can be used to extract the value of a local variable's loop index",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "Start value",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "The value at which the loop begins",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "End value",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "The value at which the loop ends",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "Step",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "The step of each loop. When the start value is less than the end value, step should be greater than 0. When the start value is greater than the end value, step should be less than 0.",
  T_34_WZ_WS_LOGIC7_NAME: "Loop every element",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "Enables traversal of a data container to extract each sub-element in it. The sub-process is the loop itself.",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "Element",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "Traversing to this name will extract the value of the local variable's sub-element",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "Data container",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "The data container to traverse. Currently supports list types.",
  T_34_WZ_WS_LOGIC8_NAME: "Conditional loop",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "A conditional loop repeats until a condition is met. The loop stops when condition is False.",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "Condition",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "Repeats loop if condition is True and stops until condition is False",
  T_34_WZ_WS_LOGIC9_NAME: "Break loop",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "Stops the current loop process and jumps out of the loop",
  T_34_Y_B_DINOSAURS: "Dinosaur Illusion (Bottom)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "Pure Angel (F)",
  T_34_YS_F_B_PANDACATTLE: "Moo Zoo (Bottom)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "Aqua Rogue (Bottom)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "Aqua Rogue (Head)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "Aqua Rogue (Facepaint)",
  T_34_YS_F_S_PANDACATTLE: "Moo Zoo (Shoes)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "Aqua Rogue (Shoes)",
  T_34_YS_F_T_PANDACATTLE: "Moo Zoo (Top)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "Aqua Rogue (Top)",
  T_34_YS_M_B_ANGEL_BW: "Pure Angel (M)",
  T_34_YS_M_B_PANDACATTLE: "Panda Pyjamas (Bottom)",
  T_34_YS_M_H_PANDACATTLE: "Panda Pyjamas (Head)",
  T_34_YS_M_S_PANDACATTLE: "Panda Pyjamas (Shoes)",
  T_34_YS_M_T_PANDACATTLE: "Panda Pyjamas (Top)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "A-Patroa",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "Gain [FFB300]{0} EP[-] by knocking down an enemy.",
  T_35_DY_PET_OWL_N: "Hoot",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "Pet Skin: Spaceship Moony",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "Pet Skin: Azulcrema Trace Zasil",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "Pet Skin: Agui Blue",
  T_35_DY_PETSKIN_OWL_FIRE_N: "Pet Skin: Hoot On Fire",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "Pet Skin: Nocturnal Hoot",
  T_35_DY_PETSKIN_OWL_STORM_N: "Pet Skin: Frosty Hoot",
  T_35_JL_KNOCKEDDOWN: "is knocked down",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "For [FFB300]{1}s[-], successfully firing at a Gloo Wall will mark enemies within [FFB300]{3}m[-] of it and penetrate the Gloo Wall to cause damage to marked enemies (damage inflicted will be lower than usual). Effective on [FFB300]{0}[-] Gloo Walls max. Cooldown: [FFB300]{2}s[-].",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "Wall Brawl",
  T_35_KY_INFECTION_MAPNAME: "Wasteland",
  T_35_M_WS_BUTTONCLICKDESC: "Triggers this incident when the corresponding button is tapped. The trigger player can be obtained using parameters.",
  T_35_M_WS_GETTEAMMATEPOS: "Obtain nearby teammates' locations",
  T_35_M_WS_ROUND2: "Current wave",
  T_35_PD_Infection_HUMANSELECT: "Select a weapon",
  T_35_PD_INFECTION_MODENAME: "Droid Apocalypse",
  T_35_QX_WS_ICONTYPE_ITEM: "Object",
  T_35_QX_WS_ICONTYPE_NATURE: "Shapes of Nature",
  T_35_QX_WS_ICONTYPE_SHAPE: "Geometric",
  T_35_QX_WS_ICONTYPE_SYMBOL: "Symbol",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "Weapon",
  T_35_R_EMOTE_TAG_MUSIC_N: "Music",
  T_35_RW_SKILL_DESC_Singers: "Skill user and allies within [FFB300]{0}m[-] can block [FFB300]{1}%[-] DMG using EP. In this case, the amount of EP deducted from allies will be added to the skill user's EP.",
  T_35_RW_SKILL_NAME_Singers: "Silent Sentinel",
  T_35_SP_WS_COMMENTKEY_01: "Suitable Difficulty",
  T_35_SP_WS_COMMENTKEY_02: "Creative",
  T_35_SP_WS_COMMENTKEY_03: "Interesting Gameplay",
  T_35_SP_WS_COMMENTKEY_04: "Can Be Played Repeatedly",
  T_35_SP_WS_COMMENTKEY_05: "Intriguing storyline",
  T_35_SP_WS_COMMENTKEY_06: "Well-Balanced",
  T_35_SP_WS_COMMENTKEY_07: "Pleasant Experience",
  T_35_SP_WS_COMMENTKEY_08: "Flexible",
  T_35_SP_WS_COMMENTKEY_09: "Aesthetically pleasing",
  T_35_SP_WS_COMMENTKEY_10: "Too Difficult",
  T_35_SP_WS_COMMENTKEY_11: "Too Easy",
  T_35_SP_WS_COMMENTKEY_12: "Boring",
  T_35_SP_WS_COMMENTKEY_13: "Too Long",
  T_35_SP_WS_COMMENTKEY_14: "Imbalanced",
  T_35_SP_WS_COMMENTKEY_15: "Unpleasant Experience",
  T_35_SP_WS_IMAGE03: "Texture",
  T_35_SP_WS_IMAGE04: "Frame",
  T_35_SY_CHARGESHOT_TEARS_N: "Charge Buster - Lava Lustre",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "Grenade - Crystal Eerie",
  T_35_SY_GRENADE_PIRATES_N: "Grenade - Rowdy Searuler",
  T_35_SY_GRENADE_RIDERS_N: "Grenade - Grim Rider",
  T_35_SY_M24_KUN_N: "M24 - Riverdust Splasher",
  T_35_SY_SCAR_PARKOUR_N: "SCAR - Gusto Freerunner",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "Jeep - Monochrome Jigsaw",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "Enjoy the celebration!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "Motorbike - Crystal Symmetry",
  T_35_WT_WS_PREFAB_MENUBAR_1: "Structure & Decor",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "Structures",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "Others",
  T_35_WT_WS_PREFAB_MENUBAR_2: "Architecture",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "Large Buildings",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "Mid-Sized Buildings",
  T_35_WT_WS_PREFAB_MENUBAR_3: "Functional Objects",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "Mode Essentials",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "Music",
  T_35_WT_WS_PVEMODE_TAG: "Survival Mode",
  T_35_WZY_WS_BECRE_NAMEDESC: "Triggers when this entity is created",
  T_35_WZY_WS_BEKILL_NAMEDESC: 'Triggers when this entity is eliminated. The source of attack can be identified using "Trigger Entity" and the type of attack can be identified using "Damage Type".',
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "The entity who triggers the incident",
  T_35_WZY_WS_CREPROP_NAMEDESC: "Create a type of item or a set of items at a specific location. When creating one type of item, the amount is the number of that item. When creating a set of items, the amount is the amount list that corresponds to the item list. The created items will depend on the map's units.",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "A list that contains the items that will be created. It can also consist of a single item.",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "An amount list that corresponds to the item list. It may only contain the amount of one item type.",
  T_35_WZY_WS_DAMTYPE_CAR: "Vehicle",
  T_35_WZY_WS_DAMTYPE_FALL: "Fall",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "Gun",
  T_35_WZY_WS_DAMTYPE_GRENADE: "Grenade",
  T_35_WZY_WS_DAMTYPE_MELEE: "Melee",
  T_35_WZY_WS_DAMTYPE_ZONE: "Out-of-zone",
  T_35_WZY_WS_DELPROP_NAMEDESC: "Delete a specified number of items of specific players",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "Enter trigger area",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: 'Triggers when a "Trigger Entity" enters a trigger area',
  T_35_WZY_WS_ENTITYPLAYER_DESC: "The player to get the entity. When linked with the player, the entity's info will only be updated for said player. When no player is linked, all players will receive the entity info.",
  T_35_WZY_WS_FIGHTENTITY_NAME: "Battle Entity",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "Get all objects of a specified type. The result returned is a list.",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "Object type",
  T_35_WZY_WS_HUDWIDGET_NAME: "UI Control",
  T_35_WZY_WS_HURT_NAMEDESC: 'Triggers when this entity takes damage. The source of attack can be identified using "Trigger Entity".',
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "The type of item",
  T_35_WZY_WS_LEVELOBJECT_NAME: "Level Object",
  T_35_WZY_WS_OBKILL_NAMEDESC: 'Triggers when this entity eliminates another entity. The type of entity being eliminated can be identified using "Eliminated Entity".',
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "The entity who is eliminated",
  T_35_WZY_WS_ONHURT_NAMEDESC: "Triggers when an entity causes damage",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "The entity that is dealing damage",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "Target entity",
  T_35_WZY_WS_PREFABID_NAME: "Template ID",
  T_35_WZY_WS_PROPERTY_EPNOW: "Current EP",
  T_35_WZY_WS_PROPERTY_JUMP: "Jump height",
  T_35_WZY_WS_QUITTRIGGER_NAME: "Exit trigger area",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: 'Triggers when a "Trigger Entity" exits a trigger area',
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "Remove a specific element from an list. [List] is the list in which the element lies. [Element] is the element to be removed.",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "Element value",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "The value of the element to be removed",
  T_35_WZY_WS_ROUNDENTITY_NAME: "Round Entity",
  T_35_WZY_WS_TOWER_PARAM1: "Tower and Fortress",
  T_35_WZY_WS_TOWER_PARAM2: "Team ID",
  T_35_WZY_WS_TOWER_PARAM3: "Current HP",
  T_35_WZY_WS_TOWER_PARAM4: "Max. HP",
  T_35_WZY_WS_TOWER_PARAM5: "Damage",
  T_35_WZY_WS_TOWER_PARAM6: "Attack interval",
  T_35_WZY_WS_TOWER_PARAM7: "Range of attack",
  T_35_WZY_WS_TOWER_PARAM8: "Defense %",
  T_35_XYL_PDM_REVENGE: "Avenged",
  T_35_XYL_WS_BISPARTERRE: "Graffiti Flowerbed",
  T_35_XYL_WS_BISPARTERRE_DESC: "A Battle-In-Style-themed stone flowerbed",
  T_35_XYL_WS_BISWALL: "Graffiti Wall",
  T_35_XYL_WS_BISWALL_DESC: "A Battle-In-Style-themed wall that can be combined",
  T_35_XYL_WS_BOTDROP: "Turn on/off loot drop",
  T_35_XYL_WS_CUSTOMTRIGGER: "Custom trigger",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "Place an object that triggers a certain customized special effect when a player activates it. The effect must be configured in the script. (Only in Customize mode.)",
  T_35_XYL_WS_DOUBLEDOOR: "Gate",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "A gate that's cracked open",
  T_35_XYL_WS_RESET: "Reset every round",
  T_35_XYL_WS_RESETN: "No",
  T_35_XYL_WS_RESETY: "Yes",
  T_35_XYL_WS_ROADBLOCK: "Roadblock A",
  T_35_XYL_WS_ROADBLOCK_DESC: "Prevents from passing through",
  T_35_XYL_WS_STAIRS: "Stairs",
  T_35_XYL_WS_STAIRS_DESC: "Stairs that can be combined with landings",
  T_35_XYL_WS_STAIRSL: "Landing B",
  T_35_XYL_WS_STAIRSL_DESC: "A platform that can be combined with stairs",
  T_35_XYL_WS_STAIRSZ: "Landing A",
  T_35_XYL_WS_STAIRSZ_DESC: "A platform that can be combined with stairs",
  T_35_XYL_WS_TBOOTH: "Phone Booth",
  T_35_XYL_WS_TBOOTH_DESC: "Commonly seen on the streets",
  T_35_YF_PP19_N: "Bizon",
  T_35_YS_A_CATEAM_HW: "Agui",
  T_35_YS_A_CUBBY: "Cub Mask",
  T_35_YS_F_A_PANTOMIME: "Two-toned Grief (Mask)",
  T_35_YS_F_A_RIDERS: "Fatal Rider (Mask)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "Beauty Reuniter (Bottom)",
  T_35_YS_F_B_GOLDCHAIN: "Armor of Riches (Bottom)",
  T_35_YS_F_B_PANTOMIME: "Two-toned Grief (Bottom)",
  T_35_YS_F_B_RIDERS: "Fatal Rider (Bottom)",
  T_35_YS_F_H_BEAR_HW: "Cub Cap",
  T_35_YS_F_H_DIGITALUNIVERSE2: "Beauty Reuniter (Head)",
  T_35_YS_F_H_GOLDCHAIN: "Armor of Riches (Head)",
  T_35_YS_F_H_PANTOMIME: "Two-toned Grief (Head)",
  T_35_YS_F_H_RIDERS: "Fatal Rider (Head)",
  T_35_YS_F_HA_GOLDCHAIN: "Armor of Riches (Facepaint)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "Beauty Reuniter (Shoes)",
  T_35_YS_F_S_GOLDCHAIN: "Armor of Riches (Shoes)",
  T_35_YS_F_S_PANTOMIME: "Two-toned Grief (Shoes)",
  T_35_YS_F_S_RIDERS: "Fatal Rider (Shoes)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "Beauty Reuniter (Top)",
  T_35_YS_F_T_GOLDCHAIN: "Armor of Riches (Top)",
  T_35_YS_F_T_PANTOMIME: "Two-toned Grief (Top)",
  T_35_YS_F_T_RIDERS: "Fatal Rider (Top)",
  T_35_YS_ITEM_SUPERFAK: "Super Med",
  T_35_YS_M_A_GOLDCHAIN: "Chainz of Lux (Mask)",
  T_35_YS_M_A_RIDERS: "Grim Rider (Mask)",
  T_35_YS_M_B_GOLDCHAIN: "Chainz of Lux (Bottom)",
  T_35_YS_M_B_RIDERS: "Grim Rider (Bottom)",
  T_35_YS_M_H_BEAR_HW: "Cub Cap",
  T_35_YS_M_H_GOLDCHAIN: "Chainz of Lux (Head)",
  T_35_YS_M_H_RIDERS: "Grim Rider (Head)",
  T_35_YS_M_S_GOLDCHAIN: "Chainz of Lux (Shoes)",
  T_35_YS_M_S_RIDERS: "Grim Rider (Shoes)",
  T_35_YS_M_T_GOLDCHAIN: "Chainz of Lux (Top)",
  T_35_YS_M_T_RIDERS: "Grim Rider (Top)",
  T_35_YS_T_CHAMPION: "Champion Tee",
  T_35_YS_T_PAINTING: "Squeeze Tee",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "Iris",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "Get coins when match begins",
  T_36_JH_WS_CESAYCLOSE: "Disable manual closing or not",
  T_36_JH_WS_CHOOSEEDITSHOP: "Select a store to edit",
  T_36_JH_WS_CHOOSESHOP: "Select a store",
  T_36_JH_WS_COINCOUNT: "Currency amount",
  T_36_JH_WS_COINHUD: "Display coin amount or not",
  T_36_JH_WS_CRAFTSHOP: "Edit store",
  T_36_JH_WS_CREATEGOLD: "Coin Generator",
  T_36_JH_WS_CSHOPENTITY: "Bind store entity",
  T_36_JH_WS_CSHOPHUD: "Store interface",
  T_36_JH_WS_CURRENTLIMIT: "Remaining purchase limit",
  T_36_JH_WS_ECONOMIC: "Economy",
  T_36_JH_WS_INGAMEECONOMI: "Game economy",
  T_36_JH_WS_ITEMINDEXID: "Merchandise number",
  T_36_JH_WS_KILLMONEY: "Get coins for eliminating",
  T_36_JH_WS_KILLMONEYTIP: "The amount of coins to earn for eliminating zombies in Rush mode and Endurance mode",
  T_36_JH_WS_LISTINDEX: "List of merchandise types",
  T_36_JH_WS_NULL: "Null",
  T_36_JH_WS_NUMBER: "Amount",
  T_36_JH_WS_OPTIONNAME: "Droid Apocalypse Mode Exclusive",
  T_36_JH_WS_REALSHOPENTITY: "Store entity",
  T_36_JH_WS_SEEORHIDE: "Display vending machine",
  T_36_JH_WS_SHOPFRONT: "Store",
  T_36_JH_WS_SHOPITEMLIST: "Merchandise type",
  T_36_JH_WS_SHOPOPENCON: "Open status",
  T_36_JH_WS_SSHOPNAME: "Store name",
  T_36_JH_WS_TOTALLIMIT: "Purchase limit",
  T_36_JH_WS_TRIGGERWIDE: "Trigger range",
  T_36_JH_WS_VENDMACHINE: "Vending Machine",
  T_36_JH_WS_WINMONEY: "Get coins for victory",
  T_36_JH_WS_WORTH: "Worth",
  T_36_JL_FOREGRIP_MR_N: "Marksman Grip",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "Shotgun Stock",
  T_36_JL_STOCK_SR_N: "Sniper Stock",
  T_36_KK_WS_MONTSTERDES: "A 4-seater truck with high durability and can travel through tough terrains",
  T_36_M_WS_SETTEMPVAR: "Set temporary variable",
  T_36_M_WS_TEMPVAR: "Temporary variable",
  T_36_SY_AK47_MAMBAS_N: "AK47 - Mamba Gnaw",
  T_36_SY_AN94_MAMBAS_N: "AN94 - Mamba Gnaw",
  T_36_SY_AR15_MAMBAS_N: "Kingfisher - Mamba Gnaw",
  T_36_SY_AUG_MAMBAS_N: "AUG - Mamba Gnaw",
  T_36_SY_AWM_MAMBAS_N: "AWM - Mamba Gnaw",
  T_36_SY_BLT_MAMBAS_N: "M82B - Mamba Gnaw",
  T_36_SY_CHARGESHOT_MAMBAS_N: "Charge Buster - Mamba Gnaw",
  T_36_SY_EAGLE_MAMBAS_N: "Desert Eagle - Mamba Gnaw",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS - Mamba Gnaw",
  T_36_SY_G18_MAMBAS_N: "G18 - Mamba Gnaw",
  T_36_SY_G36_MAMBAS_N: "G36 - Mamba Gnaw",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "Grenade - Navy Festivity",
  T_36_SY_GROZA_MAMBAS_N: "Groza - Mamba Gnaw",
  T_36_SY_HAND_CANNON_MAMBAS_N: "Hand Cannon - Mamba Gnaw",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "Heal Sniper - Mamba Gnaw",
  T_36_SY_ICE_GUN_MAMBAS_N: "Ice Gun - Mamba Gnaw",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k - Mamba Gnaw",
  T_36_SY_KORD_MAMBAS_N: "Kord - Mamba Gnaw",
  T_36_SY_M1014_MAMBAS_N: "M1014 - Mamba Gnaw",
  T_36_SY_M14_MAMBAS_N: "M14 - Mamba Gnaw",
  T_36_SY_M1873_MAMBAS_N: "M1873 - Mamba Gnaw",
  T_36_SY_M1887_MAMBAS_N: "M1887 - Mamba Gnaw",
  T_36_SY_M1917_MAMBAS_N: "M1917 - Mamba Gnaw",
  T_36_SY_M21A5_MAMBAS_N: "Woodpecker - Mamba Gnaw",
  T_36_SY_M24_MAMBAS_N: "M24 - Mamba Gnaw",
  T_36_SY_M249_MAMBAS_N: "M249 - Mamba Gnaw",
  T_36_SY_M4A1_MAMBAS_N: "M4A1 - Mamba Gnaw",
  T_36_SY_M500_MAMBAS_N: "M500 - Mamba Gnaw",
  T_36_SY_M60_MAMBAS_N: "M60 - Mamba Gnaw",
  T_36_SY_M79_MAMBAS_N: "M79 - Mamba Gnaw",
  T_36_SY_MAC10_MAMBAS_N: "MAC10 - Mamba Gnaw",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7 - Mamba Gnaw",
  T_36_SY_MINI_MAMBAS_N: "AC80 - Mamba Gnaw",
  T_36_SY_MP40_MAMBAS_N: "MP40 - Mamba Gnaw",
  T_36_SY_MP5_MAMBAS_N: "MP5 - Mamba Gnaw",
  T_36_SY_P90_MAMBAS_N: "P90 - Mamba Gnaw",
  T_36_SY_PARAFAL_MAMBAS_N: "PARAFAL - Mamba Gnaw",
  T_36_SY_PP19_MAMBAS_N: "Bizon - Mamba Gnaw",
  T_36_SY_PP19_POLICEMAN_N: "Bizon - Wraith Patrol",
  T_36_SY_SCAR_MAMBAS_N: "SCAR - Mamba Gnaw",
  T_36_SY_SKS_MAMBAS_N: "SKS - Mamba Gnaw",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12 - Mamba Gnaw",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "PLASMA - Mamba Gnaw",
  T_36_SY_SVD_MAMBAS_N: "SVD - Mamba Gnaw",
  T_36_SY_THOMPSON_MAMBAS_N: "Thompson - Mamba Gnaw",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "Dagger - Mamba",
  T_36_SY_THROWINGKNIFE_MENA_N: "Dagger - Boho",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "Heal Pistol - Mamba Gnaw",
  T_36_SY_UMP45_MAMBAS_N: "UMP - Mamba Gnaw",
  T_36_SY_USP45_MAMBAS_N: "USP - Mamba Gnaw",
  T_36_SY_UZI_MAMBAS_N: "Mini Uzi - Mamba Gnaw",
  T_36_SY_VECTOR_MAMBAS_N: "Vector - Mamba Gnaw",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "Monster Truck - Blinding Gold",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "Motorbike - Spectral Ride",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "Sports Car - Speed Acer",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "Tuk Tuk - Netherworld Ride",
  T_36_SY_VSS_MAMBAS_N: "VSS - Mamba Gnaw",
  T_36_SY_XM8_MAMBAS_N: "XM8 - Mamba Gnaw",
  T_36_WZY_AFTERACCUMULATOR: "Back accumulator",
  T_36_WZY_AVAILAB: "Enabled",
  T_36_WZY_BACKANDFORTH: "Round-trip",
  T_36_WZY_BASEMULTIPLIER: "Basic multiplier",
  T_36_WZY_BASIC: "Basic type",
  T_36_WZY_BEFORACCUMULATOR: "Front accumulator",
  T_36_WZY_CYLIC: "Circle-back",
  T_36_WZY_GUNPRO_PARAM1: "Basic damage",
  T_36_WZY_GUNPRO_PARAM10: "Bullet spread start",
  T_36_WZY_GUNPRO_PARAM11: "Max. spread area",
  T_36_WZY_GUNPRO_PARAM12: "Burst",
  T_36_WZY_GUNPRO_PARAM2: "Bullets in magazine",
  T_36_WZY_GUNPRO_PARAM3: "Initial magazine number",
  T_36_WZY_GUNPRO_PARAM4: "Firing interval",
  T_36_WZY_GUNPRO_PARAM7: "Distance for max. damage",
  T_36_WZY_GUNPRO_PARAM8: "Distance for min. damage",
  T_36_WZY_GUNPRO_PARAM9: "Minimum damage",
  T_36_WZY_MULTIPLIR: "Multiplier",
  T_36_WZY_PRICE: "Price",
  T_36_WZY_SUMMULTIPLIER: "Multiplier accumulator",
  T_36_WZY_WS_3DZOOM: "3D Zoom",
  T_36_WZY_WS_ABSRES: "Absolute value result",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "Add all the elements from the [Source list] to the bottom of the [Target list]",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "The target list to add the elements",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "The list that contains the elements to be added",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "Add a certain amount of designated currency into a designated wallet",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "Wallet",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "The wallet to add currency into",
  T_36_WZY_WS_ADDSUB: "Add or subtract values",
  T_36_WZY_WS_AIENTITY: "AI entity",
  T_36_WZY_WS_ALLSHOP_DESC: "A list that consists of store entities",
  T_36_WZY_WS_ANGLE_DESC: "The measurement of the angle",
  T_36_WZY_WS_ANYTYPE: "Any type",
  T_36_WZY_WS_ARILEFT: "Left value in the operation",
  T_36_WZY_WS_ARIRES: "Operation result",
  T_36_WZY_WS_ARIRIGHT: "Right value in the operation",
  T_36_WZY_WS_ARITHMETIC_NAME: "4 arithmetic operations",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "The basic integer operations support addition, subtraction, multiplication, division, and remainder. The float operations support addition, subtraction, multiplication, and division.",
  T_36_WZY_WS_ARRAY_DESC: "The target list",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "Check whether a list contains a designated element. The value returned is Boolean.",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "The designated list",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "The element to look for in the list",
  T_36_WZY_WS_ARRCONELERES: "The result of whether a designated element exists in a list. The value is Boolean.",
  T_36_WZY_WS_ATTACK: "Patrol and attack",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "Triggers when the player is knocked down",
  T_36_WZY_WS_BIGFLOAT: "Big decimal",
  T_36_WZY_WS_BIGTOYBALL: "Dice",
  T_36_WZY_WS_BOOLLIST: "Boolean list",
  T_36_WZY_WS_CEIL_NAME_DESC: "Round a value to the smallest integer larger than itself",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "The value to round up",
  T_36_WZY_WS_CEILRES: "Result of rounding up",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "The selected AI will chase this entity regardless of distance. [Chased entity] can be any entity. When the [Chased entity] does not have a HP property, then the AI entity will not inflict any damage.",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "The entity that is doing the chasing",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "The target entity that is being chased. It can be any entity.",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "The template for cloning objects. Select using the cursor. The property and script of the clone will be the same as those of the object chosen.",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "The object entity to be cloned",
  T_36_WZY_WS_CONDITION: "Condition",
  T_36_WZY_WS_CONDITIONLIST: "Condition list",
  T_36_WZY_WS_CONOFHUD: "The HUD entity that the control exists in",
  T_36_WZY_WS_CONTROL_DESC: "The only index of a control",
  T_36_WZY_WS_COS_NAMEDESC: "Find the cosine of an angle",
  T_36_WZY_WS_COSRES: "Cosine of the angle",
  T_36_WZY_WS_CREABLEOB: "Creatable object",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "Create an object entity at a designated location. (Test version)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "The coordinates of the object to be created",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "The type of the object to be created",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "The entity of the object to be created",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "Currency",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "Merchandise entity",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "Create a merchandise entity",
  T_36_WZY_WS_CREWALL_NAMEDESC: "Create a wallet entity. [Bind player] is the player who can see this wallet. [Owner] is the player to whom the wallet belongs. Invalid if a wallet already exists.",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "Bound player",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "The player to which the wallet is visible. If no settings are configured, the wallet will be visible to all.",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "The owner of the wallet",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "Wallet entity",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "The wallet entity created",
  T_36_WZY_WS_CURRAMT: "Currency amount",
  T_36_WZY_WS_DATA_TYPE1: "Added parameter",
  T_36_WZY_WS_DATA_TYPE2: "Basic and logic calculation",
  T_36_WZY_WS_DATA_TYPE3: "List manipulation",
  T_36_WZY_WS_DATA_TYPE4: "Vector calculation",
  T_36_WZY_WS_DESTITEM_NAME: "Destroy player item",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "Destroy a designated type of item for a designated player",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "Items that can be destroyed are weapons, vests, and helmets",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "The slot index of the type of item selected. Weapon index is [1,3] and Vest and Helmet is 1 by default.",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "Lose equipment upon elimination",
  T_36_WZY_WS_DESTOBJ: "Destroyable objects",
  T_36_WZY_WS_DIRPOINT: "Direction point",
  T_36_WZY_WS_DIRPOINTDESC: "The direction point to be created",
  T_36_WZY_WS_ELEFINDRES: "Index of an element's first position",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: 'Obtain the index of the first position of an element in a list. If the target element does not exist in the list, the result will return "-1".',
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "The element to look for in the list",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: 'Get the index of the last position of an element in a list. If the target element does not exist in the list, the result will return "-1".',
  T_36_WZY_WS_ELELINDRES: "Index of an element's last position",
  T_36_WZY_WS_ELEMENTSNUM: "# of elements in the list",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "Triggers when the [Triggering entity] collides with this trigger",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "The entity that this trigger collides with",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "Triggers when a [Triggering entity] drives the vehicle",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "The entity that is driving the vehicle",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "Triggers when the player enters the trigger",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "The trigger to enter",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "Triggers when a [Triggering entity] exits the vehicle",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "The entity that exits the vehicle",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "Triggers when a [Triggering entity] enters the vehicle",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "The entity that enters the vehicle",
  T_36_WZY_WS_ENTITY_TYPE1: "Commonly used",
  T_36_WZY_WS_ENTITY_TYPE2: "Properties",
  T_36_WZY_WS_ENTITY_TYPE3: "Objects and items",
  T_36_WZY_WS_ENTITY_TYPE4: "AI",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "The element value to be changed",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "Target player",
  T_36_WZY_WS_ENTITYLIST: "Entity list",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "Triggers when a [Triggering entity] bounces off the tire",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "The entity that bounces off the tire",
  T_36_WZY_WS_ENTTP_NAMEDESC: "Triggers when a [Triggering entity] enters the portal and is teleported",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "The entity that is teleported",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "The type of armor equipped, including vest, helmet, and backpack",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "Triggers when a player successfully equips a weapon. [Triggering player] is the player who successfully equips a weapon. [Weapon entity] is the weapon entity that the player equipped.",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "The weapon entity equipped",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "Weapon type",
  T_36_WZY_WS_EULERANGLE: "Euler angles",
  T_36_WZY_WS_FACECAMERA: "Always face camera",
  T_36_WZY_WS_FLOATLIST: "Float list",
  T_36_WZY_WS_FLOOR_NAME_DESC: "Round a value to the largest integer smaller than itself",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "The value to round down",
  T_36_WZY_WS_FLOORRES: "Result of rounding down",
  T_36_WZY_WS_FORMUENT: "Property formulate-able entity",
  T_36_WZY_WS_FORMUFACT: "Type of property formula factor",
  T_36_WZY_WS_GAME_TYPE2: "Gameplay",
  T_36_WZY_WS_GAME_TYPE3: "Special effects",
  T_36_WZY_WS_GENENT_NAMEDESC: "Triggers when a generator spawns units. [Unit entity list] is the list of units spawned by the generator. [# of waves] is the number of waves spawned by the generation.",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "Unit entity",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "A list that consists of unit entities spawned by a generator",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "The number of waves that a generator spawns",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "Obtain all the stores in the match. The value returned is a list that consists of store entities.",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "Use the RGB to obtain a color",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "Get the amount of a certain currency in a specific wallet",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "The wallet from which to get the currency amount",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "The currency type of the currency amount to be obtained",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "Get the entity type of a target entity",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "The entity whose type to get",
  T_36_WZY_WS_GETENTTYPERES: "Entity type of target entity",
  T_36_WZY_WS_GETFOR_NAME: "Get direction coordinates",
  T_36_WZY_WS_GETFOR_NAMEDESC: "Get the vector of a designated direction point",
  T_36_WZY_WS_GETFORRES: "Vector of direction point",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "Obtain the currency entity of a certain currency type in the wallet",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "The wallet in which the currency entity is",
  T_36_WZY_WS_GETPOS_NAME: "Get coordinates",
  T_36_WZY_WS_GETPOS_NAMEDESC: "Get the coordinates of a designated direction point",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "The designated direction point",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "Equipment type",
  T_36_WZY_WS_GETWALLET_NAME: "Obtain wallet",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "Obtain the wallet of the selected owner",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "Whether a bound wallet exists",
  T_36_WZY_WS_GETWALLETRES: "Owner's wallet entity",
  T_36_WZY_WS_HUDCONTROL_DESC: "The control entity of a HUD",
  T_36_WZY_WS_HUDTYPE: "HUD type",
  T_36_WZY_WS_INCIDENT_TYPE1: "Global incident",
  T_36_WZY_WS_INCIDENT_TYPE2: "Entity incident",
  T_36_WZY_WS_INDEX_DESC: "An index value of a list. Starts from 0.",
  T_36_WZY_WS_INTLIST: "Integer list",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "Check whether an entity type belongs to a certain sub-category. The result returned is Boolean.",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "The parent category to check whether the entity belongs in",
  T_36_WZY_WS_JENTSUBCLRES: "Result of parent category check",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "Check whether an entity belongs to a certain entity type. The result returned is Boolean.",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "The entity to check",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "Means that it is the same as the entity type",
  T_36_WZY_WS_JENTTYPERES: "Result of entity check",
  T_36_WZY_WS_JUSTPATROL: "Patrol only",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "Triggers when the player exits the trigger",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "The trigger to exit",
  T_36_WZY_WS_LEVELOBLIST: "Object list",
  T_36_WZY_WS_LEVOBJSLIST: "A list of all the map objects in this match",
  T_36_WZY_WS_LEVOBTYPE: "Object type",
  T_36_WZY_WS_LISTT: "Any list",
  T_36_WZY_WS_LOGCONTEXT_DESC: "The content to be printed",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "The left string to be connected",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "The right string to be connected",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "The element value to be added",
  T_36_WZY_WS_LOGOPER: "When conducting logic operations (and & or): if using the and operation and the two Boolean values are TRUE, the result is TRUE, and if using the or operation and one of the Boolean values is TRUE, the result is TRUE.",
  T_36_WZY_WS_LOOTPOINT: "Loot point",
  T_36_WZY_WS_MAINWEAP: "Current weapon",
  T_36_WZY_WS_MAX_DESC: "The upper range of the generated integer (open interval)",
  T_36_WZY_WS_MIN_DESC: "The lower range of the generated integer (closed interval)",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "Weapon entity",
  T_36_WZY_WS_MONENT: "Currency entity",
  T_36_WZY_WS_MONTYPE: "Currency type",
  T_36_WZY_WS_MOVETO_NAMEDESC: "Make the AI move towards a target point. Use [Return or not] to select whether the AI will return to its original position. Use [Attack or not] to select whether the AI will scan for enemies on its way.",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "The AI entity that will travel",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "The destination",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "Use to set whether the AI will return to original location after arriving to the destination. TRUE means return; FALSE means do not return.",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "Attack or not",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "Use to set whether the AI will attack nearby enemies along the way. TRUE means scan for enemies; FALSE means do not scan for enemies.",
  T_36_WZY_WS_MULVALUE: "Scalar",
  T_36_WZY_WS_MULVEC: "Scalar multiplication vector",
  T_36_WZY_WS_NEGRES: "Negative value result",
  T_36_WZY_WS_NEUTRAL: "Neutral",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "Forces the designated generator to spawn the next wave. Generators include Zombie Spawns and item spawns.",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "Generator entity",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "The designated generator entity, such as Zombie Spawns and item spawns",
  T_36_WZY_WS_OBJENT: "Object entity",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "Triggers when an item is obtained. [Item type] is the type of item that is obtained.",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "Triggers when a weapon is got. [Weapon entity] is the weapon obtained.",
  T_36_WZY_WS_ONEWAY: "One-way",
  T_36_WZY_WS_OPENSTATE: "Status",
  T_36_WZY_WS_OPERMETHOD_NAME: "Operation",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "The basic arithmetic operations. Currently, integer operations include addition, subtraction, multiplication, division, and remainder, and the float operations include addition, subtraction, multiplication, and division. ",
  T_36_WZY_WS_OWNERENT_DESC: "The entity whose wallet to obtain",
  T_36_WZY_WS_PERCENTAGE: "Percentage adjustment",
  T_36_WZY_WS_PLACOLLIDE_NAME: "When player collides with trigger",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "Triggers when the [Triggering player] collides with the trigger",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "The player that collides with the trigger",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "The object entity that the player collides with",
  T_36_WZY_WS_PLADRIVEH_NAME: "When player drives vehicle",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "Triggers when the [Triggering player] drives a vehicle",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "The player that is driving the vehicle",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "The vehicle entity that the player is driving",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "When player exits vehicle",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "Triggers when the [Triggering player] exits a vehicle",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "The player that is exiting the vehicle",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "The vehicle entity that the player is exiting",
  T_36_WZY_WS_PLAGETONVEH_NAME: "When player enters vehicle",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "Triggers when the [Triggering player] enters a vehicle",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "The vehicle entity that the player is entering",
  T_36_WZY_WS_PLAKNOFLY_NAME: "When player bounces off tire",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "Triggers when the [Triggering player] bounces off a tire",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "The player that bounces off a tire",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "The object entity on which the player bounces off",
  T_36_WZY_WS_PLATP_NAME: "After player is teleported",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "The player that uses a portal",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "The portal entity that the player used",
  T_36_WZY_WS_PLAYERLIST_DESC: "A list of all the players in this match",
  T_36_WZY_WS_POINTPICKER: "Path pivot",
  T_36_WZY_WS_PORTALENT: "Portal entity",
  T_36_WZY_WS_PREFAB: "Template",
  T_36_WZY_WS_PRODLIST: "Merchandise list",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "Sort order",
  T_36_WZY_WS_PROPMOD: "Method of property change",
  T_36_WZY_WS_RANKABLEE: "Rank-able entity",
  T_36_WZY_WS_REDCURR_NAMEDESC: "Consume a certain amount of designated currency in a designated wallet",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "The wallet that spends the currency",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "The type of currency consumed",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "The amount of currency consumed",
  T_36_WZY_WS_RNDFRES: "Generated random float",
  T_36_WZY_WS_RNDIRES: "Result of random integer generation",
  T_36_WZY_WS_ROUND_NAME_DESC: "Round a value to the nearest integer",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "The value to round",
  T_36_WZY_WS_ROUNDRES: "Result of rounding",
  T_36_WZY_WS_RUNAI_NAMEDESC: "The behavior tree that the selected AI will execute",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "The unit entity that stops/runs a default behavior tree",
  T_36_WZY_WS_SCOREABLEE: "Score-able entity",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "Triggers when score changes. [Score type] is the type of score that changed. [Score] is the new score.",
  T_36_WZY_WS_SETDIRPOINT_NAME: "Create a direction point",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "Get a newly created direction point. Use [Location] to set the point's coordinates and [Direction] to set the vector of the direction.",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "The coordinates of the direction point",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "Direction",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "The vector of the direction point",
  T_36_WZY_WS_SETPATH_NAMEDESC: "AI entities will travel according to the order set here. Available travel types are circle-back, one-way, and round-trip. You can also select whether the AI will scan for enemies on its way.",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "A list that consists of the points to which the AI should travel",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "Travel type",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "These are the travel types. One-way is for the AI to stop traveling once it arrives at the destination. Circle-back is for the AI to search for a way back once it arrives at the destination. Round-trip is for the AI the return to original location according to the backwards order of the path list.",
  T_36_WZY_WS_SHOPECON: "Store and economy",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "Use to display notifications that float on the screen. Configure the content using [Text], the text color using [Color], and the display duration using [Duration] (the unit is milleseconds).",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "The content of the floating notification",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "The color of the floating notification",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "The display duration of the floating notification, in milleseconds",
  T_36_WZY_WS_SIN_NAMEDESC: "Find the sine of an angle",
  T_36_WZY_WS_SINRES: "Sine of the angle",
  T_36_WZY_WS_SKIPKNODOWN: "Whether eliminate upon knockdown",
  T_36_WZY_WS_SQRTRES: "Square root result",
  T_36_WZY_WS_STRCONRES: "Result of string connection",
  T_36_WZY_WS_STRINGLIST: "String list",
  T_36_WZY_WS_STRLEN: "String length",
  T_36_WZY_WS_STRVAL: "String result",
  T_36_WZY_WS_TAN_NAMEDESC: "Find the tangent of an angle",
  T_36_WZY_WS_TANRES: "Tangent of the angle",
  T_36_WZY_WS_TEAMLIST: "Team list",
  T_36_WZY_WS_TEAMLIST_DESC: "A list of all the teams in this match",
  T_36_WZY_WS_TIMETWEENTIPS: "Countdown notification entity",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "Convert the target value into a string",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "The target value to convert into a string",
  T_36_WZY_WS_TOSTRINGRES: "Result of string conversion",
  T_36_WZY_WS_TOWERCAMP_DESC: "The side number and team number are the same. Neutral towers and fortresses attack all players and AIs within range.",
  T_36_WZY_WS_TRACURR_NAMEDESC: "Tranfer a certain amount of designated currency from one wallet to another",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "The wallet to transfer the currency out of",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "The type of currency in the transaction",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "The amount of currency in the transaction",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "The wallet to transfer the currency into",
  T_36_WZY_WS_TWEENTIPS: "Floating notification entity",
  T_36_WZY_WS_TYPEENUM: "Enum type",
  T_36_WZY_WS_USEPROP_NAMEDESC: "Triggers when a player uses an item. [Triggeri player] is the player who uses an item. [Item type] is the item that the player used.",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "The type of item used by the player",
  T_36_WZY_WS_VECADDLEFT: "Left value of vector addition",
  T_36_WZY_WS_VECADDRES: "Vector addition result",
  T_36_WZY_WS_VECADDRIGHT: "Right value of vector addition",
  T_36_WZY_WS_VECANGLEFT: "Left value of vectors angle",
  T_36_WZY_WS_VECANGRES: "Angle between 2 vectors",
  T_36_WZY_WS_VECANGRIGHT: "Right value of vectors angle",
  T_36_WZY_WS_VECCROLEFT: "Left value of cross product",
  T_36_WZY_WS_VECCRORES: "Result of cross product",
  T_36_WZY_WS_VECCRORIGHT: "Right value of cross product",
  T_36_WZY_WS_VECDISLEFT: "Left value of vectors distance",
  T_36_WZY_WS_VECDISRES: "Distance between 2 vectors",
  T_36_WZY_WS_VECDISRIGHT: "Right value of vectors distance",
  T_36_WZY_WS_VECDOCLEFT: "Left value of dot product",
  T_36_WZY_WS_VECDOCRES: "Result of dot product",
  T_36_WZY_WS_VECDOCRIGHT: "Right value of dot product",
  T_36_WZY_WS_VECMULRES: "Result of scalar multiplication",
  T_36_WZY_WS_VECNORRES: "Normalized vector",
  T_36_WZY_WS_VECSIZERES: "Magnitude of a vector",
  T_36_WZY_WS_VECSUBLEFT: "Left value of vector subtraction",
  T_36_WZY_WS_VECSUBRES: "Vector subtraction result",
  T_36_WZY_WS_VECSUBRIGHT: "Right value of vector subtraction",
  T_36_WZY_WS_VECTORLIST: "Vector list",
  T_36_WZY_WS_VECX: "x component",
  T_36_WZY_WS_VECY: "y component",
  T_36_WZY_WS_VECZ: "z component",
  T_36_WZY_WS_VEHENT: "Vehicle entity",
  T_36_WZY_WS_WALLCONT: "Wallet content",
  T_36_WZY_WS_ZOMBIESPERWAVE: "Continuous",
  T_36_XYL_WS_AIBOT: "Unit",
  T_36_XYL_WS_AIGENERATOR: "Unit Generator",
  T_36_XYL_WS_AIGENERATOR_DESC: "A generator that can continuously generate designated units (e.g. zombies)",
  T_36_XYL_WS_AIWAVE: "# of units per wave",
  T_36_XYL_WS_ARROW: "Direction Sign",
  T_36_XYL_WS_ARROW_DESC: "A sign that points to a direction",
  T_36_XYL_WS_BREAKBOX: "Breakable Box",
  T_36_XYL_WS_BREAKBOX_DESC: "A wooden box that can be broken when attacked",
  T_36_XYL_WS_FENCE: "Iron Fence",
  T_36_XYL_WS_FENCE_DESC: "A fence that enables bullets to fly through",
  T_36_XYL_WS_STAIRI: "Landing C",
  T_36_XYL_WS_STAIRI_DESC: "A platform that can be combined with stairs",
  T_36_XYL_WS_ZOMBIEAI: "Zombie",
  T_36_XYL_WS_ZOMBIEAI_DESC: "A zombie that can be customized and be an obtained and duplicated subject in the Unit Generator",
  T_36_YF_CORRODE_GRENADE_N: "Gloo Melter",
  T_36_YF_SETTING_TYPE3: "Preset 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "CBF Ocean Jersey (Bottom)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "CBF Sunshine Jersey (Bottom)",
  T_36_YS_F_A_GHOSTHUNTER: "Fiendish Foxtail (Mask)",
  T_36_YS_F_B_GHOSTHUNTER: "Fiendish Foxtail (Bottom)",
  T_36_YS_F_H_GHOSTHUNTER: "Fiendish Foxtail (Head)",
  T_36_YS_F_S_GHOSTHUNTER: "Fiendish Foxtail (Shoes)",
  T_36_YS_SETTING_GRENADE: "Throwables",
  T_36_YS_SETTING_MOVE: "Movement",
  T_36_YS_T_BRFOOTBALL_BLUE01: "CBF Ocean Jersey (Top)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "CBF Sunshine Jersey (Top)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "Luna",
  T_36_YZY_CHARACTER_YAKUZA_N: "Tatsuya",
  T_36_YZY_PET_WOLF_N: "Fang",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "Pet skin: Purple Zasil",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "Pet skin: Lightning Falco",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "Pet skin: Lava Fang",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "Pet skin: Spectral Guide",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "Pet Skin: Arctic Fang",
  T_37_B_WS_HIDE: "Hide N Seek",
  T_37_HZ_WS_CATMODEDESC1: "Hide N Seek",
  T_37_JH_WS_CREATEGOLD_DESC: "A Vending Machine from which players can buy items. (Not valid in Clash Squad, Team Deathmatch, Playground, and Droid Apocalypse modes)",
  T_37_JH_WS_NAME1: "FF Knife (Droid Apocalypse)",
  T_37_JH_WS_NAME10: "M1887-X (Droid Apocalypse)",
  T_37_JH_WS_NAME11: "SPAS12 (Droid Apocalypse)",
  T_37_JH_WS_NAME12: "M1014 (Droid Apocalypse)",
  T_37_JH_WS_NAME13: "MP40 (Droid Apocalypse)",
  T_37_JH_WS_NAME14: "MP5-III (Droid Apocalypse)",
  T_37_JH_WS_NAME15: "P90 (Droid Apocalypse)",
  T_37_JH_WS_NAME16: "M60-III (Droid Apocalypse)",
  T_37_JH_WS_NAME17: "Thompson (Droid Apocalypse)",
  T_37_JH_WS_NAME18: "UMP (Droid Apocalypse)",
  T_37_JH_WS_NAME19: "SVD (Droid Apocalypse)",
  T_37_JH_WS_NAME2: "Groza (Droid Apocalypse)",
  T_37_JH_WS_NAME20: "AWM (Droid Apocalypse)",
  T_37_JH_WS_NAME21: "M82B (Droid Apocalypse)",
  T_37_JH_WS_NAME22: "M249-X (Droid Apocalypse)",
  T_37_JH_WS_NAME23: "Kar98k-III (Droid Apocalypse)",
  T_37_JH_WS_NAME3: "AK47 (Droid Apocalypse)",
  T_37_JH_WS_NAME4: "M4A1-III (Droid Apocalypse)",
  T_37_JH_WS_NAME5: "SCAR (Droid Apocalypse)",
  T_37_JH_WS_NAME6: "M14-III (Droid Apocalypse)",
  T_37_JH_WS_NAME7: "PARAFAL (Droid Apocalypse)",
  T_37_JH_WS_NAME8: "XM8 (Droid Apocalypse)",
  T_37_JH_WS_NAME9: "MAG-7 (Droid Apocalypse)",
  T_37_JH_WS_VENDMACHINE_DESC: "Gold that can be picked up around the map. (Not valid in Clash Squad, Team Deathmatch, Playground, and Droid Apocalypse modes)",
  T_37_JH_WS_X: "X Axis",
  T_37_JH_WS_Y: "Y Axis",
  T_37_JH_WS_Z: "Z Axis",
  T_37_JL_FOOTBALL_TIE: "Tie",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "Trogon",
  T_37_KK_WS_SNOWMAN: "Waggor Snowman",
  T_37_LC_BP_ENTRANCE_GIFT: "Gift!",
  T_37_M_WS_MISSING: "Missing source",
  T_37_M_WS_NAMEERROR: "Contains sensitive characters. Please change.",
  T_37_PD_HuntingGround_BOSSTITLE: "The Butcher",
  T_37_QL_JUMPPAD_DES: "Creates a jump pad on the ground. It can be used to jump high in the air and enables air firing.",
  T_37_QL_JUMPPAD_NAME: "Trampoline",
  T_37_R_TAILOR_LIMIT: "Limited Time",
  T_37_RW_LOADOUT_BORNFIRETAG: "Get 2 Bonfires at the start of the match. Bonfire [FFBA00]regenerates 5 HP and 20 EP per second[-] (up to 10 seconds) for you and your teammates within the area. Bonfire effects do not stack.",
  T_37_RW_PROPCATAPULT_DESC: "When inflated, the launch pad can be used to project a player into the air. But make sure to stay in the Safe Zone!",
  T_37_RW_PROPCATAPULT_NAME: "Launch Pad",
  T_37_SP_WS_COLOR_02: "Color",
  T_37_SP_WS_COLOR_03: "Appearance",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "The entity is null when getting or setting its property",
  T_37_SP_WS_LOG_PHASE_END: "Phase {0} ended.",
  T_37_SP_WS_LOG_PHASE_START: "Phase {0} begins",
  T_37_SP_WS_LOG_ROUND_END: "Round {0} ended.",
  T_37_SP_WS_LOG_ROUND_START: "Round {0} started.",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "Mismatched type when assigning a value to the variable. Required type: {0}. Current type: {1}.",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "Undefined or out-of-scope local variable {0}",
  T_37_SP_WS_MAPACCESS_08: "Edit",
  T_37_SP_WS_RACEMODE_01: "Countdown Mode",
  T_37_SP_WS_RACEMODE_02: "Countdown Time",
  T_37_SP_WS_RACEMODE_04: "When on, there will be a countdown when an entire team reaches the finishing point. The game ends when the countdown ends.",
  T_37_SY_AR15_KABUKI_N: "Kingfisher - Song of Hana",
  T_37_SY_BACKPACK_STRAW_N: "Backpack - Straw Hat",
  T_37_SY_GRENADE_FFWS2022_01_N: "Grenade - Navy Starsea",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "Black Hole",
  T_37_SY_M1216_MAMBAS_N: "Trogon - Mamba Gnaw",
  T_37_SY_PET_FLYINGCREATURE_N: "Arvon",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "Pet Skin: Glamstar Beanie",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "Pet Skin: Ash Arvon",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "Pet skin: Galaxy Arvon",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "Pet skin: Firemyth Arvon",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "Pet Skin: Footie Flash",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "Pet Skin: Winterlands Yeti",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "Jeep - Rockin' Festival Ride",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "Pickup Truck - Starsea Beast",
  T_37_WT_WS_PVE2DESC: `A zombie survival mode where players eliminate a certain number of zombies within time limit or survive till the end.
You can set the gameplay rules and adjust the settings of zombies as you like, including the target number of zombies to be eliminated.`,
  T_37_WT_WS_RULEDESC: "Eliminate the target number of zombies to win.",
  T_37_WT_WS_RULETITLE: "Goal",
  T_37_WT_WS_TXT1: "Eliminate zombies",
  T_37_WT_WS_TXT1DESC: "When on, players win by eliminating the specified number of zombies. When off, players win by surviving till the end.",
  T_37_WT_WS_TXT2: "Elimination amount",
  T_37_WZY_FRIDPLA: "Friendly player",
  T_37_WZY_FRIDSIDE: "Friendly faction",
  T_37_WZY_FRIDTEAM: "Friendly team",
  T_37_WZY_HOSTPLA: "Enemy player",
  T_37_WZY_HOSTSIDE: "Enemy faction",
  T_37_WZY_WS_ACCFRAMES: "Accumulated frames",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "Add items to a merchandise. You can add a single item or a group of items. The amount can be either the number of the individual items or a list that consists of items of this amount.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "The merchandise entity to add items to",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "The items to add. You can add a single item or a group of items.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "The amount of the individual items to add or a list that consists of items of this amount.",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "Add a tag for the selected entity",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "The entity to add the tag to",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "The text content to add",
  T_37_WZY_WS_AIMABLEENT: "Aim-able entity",
  T_37_WZY_WS_AIMASSISTTYPE: "Aim assist type",
  T_37_WZY_WS_ALLOWDROP_NAME: "Enable/disable item drop",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "Whether a player can drop items",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "The player entity to configure whether to drop items",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "Whether a player can drop items. This is Boolean value.",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "Enable/disable item pick up",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "Whether a player can pick up items",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "The player entity to configure whether to pick up items",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "Whether a player can pick up items. This is Boolean value.",
  T_37_WZY_WS_AMBIENTCOLOR: "Ambience light color",
  T_37_WZY_WS_AMRORTOOL: "Repair armor",
  T_37_WZY_WS_ATTACK: "Attack",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "Cancel the player's disguise so that they will return to their normal appearance",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "The player entity whose disguise to cancel",
  T_37_WZY_WS_BALLADDV_NAMEDES: "Boost the speed of a football",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "The football to boost speed for",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "The speed vector of the boost",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "Triggers when the football is hit by the Football Shooter. [Player entity] is the player who owns the Football Shooter. [Speed boost] is the added speed of the football after being hit.",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "The player who owns the Football Shooter",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "The speed vector of the football after it has been hit",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "Triggers when the football collides with an entity and the ball's speed increases. [Colliding entity] is the entity that collides with the football. [Speed boost] is the added speed of the football after the collision.",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "The entity that collides with the football",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "The speed vector that is added to the football upon collision",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "Triggers when the entity is being aimed at by a player",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "The player who is aiming at the entity",
  T_37_WZY_WS_BEHAVIORSTAT: "Player behavior status",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "The weapon entity that hits this entity",
  T_37_WZY_WS_BLOODBARENT: "Health bar entity",
  T_37_WZY_WS_BOMBEND: "Prior to explosion",
  T_37_WZY_WS_BOMBSTART: "Bomb indication",
  T_37_WZY_WS_CHANENT: "Channel entity",
  T_37_WZY_WS_CHEER: "Cheer",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "Check whether a selected entity contains designated tags",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "The entity to check whether it contains tags",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "The tag to check",
  T_37_WZY_WS_CHELABELRES: "The result of the tag check. This is a Boolean value.",
  T_37_WZY_WS_CJERSEY_NAME: "Change jersey",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "The player whose jersey to change",
  T_37_WZY_WS_CJERSEY_PARAM2: "Jersey design",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "The design to change to",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "The color of part 1 on the jersey",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "The color of part 2 on the jersey",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "The color of part 3 on the jersey",
  T_37_WZY_WS_CJERSEYTYPE1: "Design 1",
  T_37_WZY_WS_CJERSEYTYPE2: "Design 2",
  T_37_WZY_WS_CJERSEYTYPE3: "Design 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "Clear all the elements in the list",
  T_37_WZY_WS_CREABLEOB_DESC: "The object type that can be created using blocks",
  T_37_WZY_WS_CREPROD_NAMEDESC: "Create a customizable merchandise and return a merchandise entity. The merchanise content can be configured through property settings.",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "Create a customizable merchandise list and return a merchandise list entity. The content of this list can be changed through property settings.",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "The merchandise list entity to be created",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "Create a faction entity",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "The faction entity to be created",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "Create a customizable store and return a store entity. The content of the store can be changed through property settings.",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "The store entity created",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "Change the environment of the sky in the game. Options include day, dusk, and night.",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "The type of sky to change to. Options include day, dusk, and night.",
  T_37_WZY_WS_DARKNESS: "Overall darkness",
  T_37_WZY_WS_DELENT_NAMEDESC: "Delete a designated entity. Currently supports icon entity, text entity, HUD entity, visual effects entity, weapon entity, and other object entities.",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "The entity to delete",
  T_37_WZY_WS_DROP: "Mistake",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "Triggers when the player drops an item. [Item type] is the ID of the item type dropped.",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "The type ID of the dropped item",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "Triggers when the player drops a weapon. [Weapon entity] is the weapon being dropped.",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "The weapon that is dropped",
  T_37_WZY_WS_DUMMYLEOBJ: "Regular level object",
  T_37_WZY_WS_DUST: "Dusk",
  T_37_WZY_WS_EMPTYCH: "Default empty channel",
  T_37_WZY_WS_EMPTYCH1: "Empty channel 1",
  T_37_WZY_WS_EMPTYCH2: "Empty channel 2",
  T_37_WZY_WS_EMPTYCH3: "Empty channel 3",
  T_37_WZY_WS_EMPTYCH4: "Empty channel 4",
  T_37_WZY_WS_EMPTYCH5: "Empty channel 5",
  T_37_WZY_WS_EMPTYCH6: "Empty channel 6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: 'Obtain a list that contains all entities that satisfy the 3 conditions. The content inserted for "Includes all", "Excludes", and "Includes" is a single component type or a list of component types. The result returned is a list of entities that satisfy the conditions.',
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "The entities filtered out must contain all the components from this array",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "The entities filtered out must not contain designated component(s) from this array",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "The entities filtered out must contain at least one component from this array",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "The property type of this entity to change",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "The property value to change to",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "Let the player leave the current channel so that they will not be in any channel",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "The player to leave the channel",
  T_37_WZY_WS_FAKEENT: "Disguise entity",
  T_37_WZY_WS_FIND_STR_DESC: "Find the location of a designated text within a string",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "The character to find",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "Find a string from the starting location, which begins from 0.",
  T_37_WZY_WS_FINDSTRRES: "The first location that the string appears. Starts from 0.",
  T_37_WZY_WS_FOGCOLOR: "Fog color",
  T_37_WZY_WS_FRICTIONCON: "Regular friction multiplier",
  T_37_WZY_WS_FRICTIONIMP: "Collision friction multiplier",
  T_37_WZY_WS_FROMDEATH: "Revival",
  T_37_WZY_WS_FROMKNODOWN: "Help up",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "Get the channel that the designated player is in",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "The player entity whose channel to get",
  T_37_WZY_WS_GETCHANRES: "The channel that the player is currently in",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "According channel ID 1 to 8, get the empty channel that was created by default at the start of the game",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "ID of the default empty channel",
  T_37_WZY_WS_GETEMPTYCH_RES: "The obtained channel entity",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "Obtain the disguise entity of a player",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "The object whose disguise entity to obtain",
  T_37_WZY_WS_GETGAMEENT_NAME: "Get global",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "Get the game entity of this match",
  T_37_WZY_WS_GETHOSTPLA_NAME: "Get attackable player",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "Faction entity",
  T_37_WZY_WS_GOAL_NAMEDESC: "Triggers when a football enters the goal. [Goal] is the goal that this football enters. [Scorer] is the last player to have come in contact with the ball. [Assist] is the second-to-last player to have come in contact with the ball.",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "The goal that this football enters",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "The last player to have come in contact with the ball",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "The second-to-last player to have come in contact with the ball",
  T_37_WZY_WS_HEARTBEAT: "Heartbeat",
  T_37_WZY_WS_HEAVYWEAPON: "Heavy weapon",
  T_37_WZY_WS_HIHGSHOOTANGLE: "Smallest volley angle",
  T_37_WZY_WS_HOSTPLA: "A list of attackable players",
  T_37_WZY_WS_HOSTSIDE: "A list of attackable factions",
  T_37_WZY_WS_HOSTTEAM: "A list of attackable teams",
  T_37_WZY_WS_ICON_CLOCK: "Countdown",
  T_37_WZY_WS_ICON_CLOTHES: "Clothes",
  T_37_WZY_WS_ICON_QUIT: "Exit",
  T_37_WZY_WS_INSERT_ARR_DESC: "Insert a new element to a designated location in the list",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "Extract a string of a designated length, starting from the index location. If extraction length exceeds string length, it will extract content until the end of the string.",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "Length of the extraction",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "The string that was extracted",
  T_37_WZY_WS_INTORINTL: "Integer or integer list",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "Let a player join a designated faction",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "The faction for the player to join",
  T_37_WZY_WS_JUMP: "Jump",
  T_37_WZY_WS_LABEL: "Tag",
  T_37_WZY_WS_LENSFLARE: "Lens flare",
  T_37_WZY_WS_LENTH: "Length",
  T_37_WZY_WS_LIGHTATTACK: "Successful hit",
  T_37_WZY_WS_LIGHTCOLOR: "Light source color",
  T_37_WZY_WS_LIGHTINTENSITY: "Light source brightness",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "Load a new scenery",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "The name of the scenery to load",
  T_37_WZY_WS_MOROBJECT: "Disguise object",
  T_37_WZY_WS_MOVEAXISX: "Move along x axis",
  T_37_WZY_WS_MOVEAXISY: "Move along y axis",
  T_37_WZY_WS_MOVEAXISZ: "Move along z axis",
  T_37_WZY_WS_MOVEDISTITLE: "Distance of movement",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "Quick messages on-off toggle",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "Turn quick messages on or off. When off, the quick message HUD cannot be used and players will not be able to send or receive quick messages.",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "The player to turn on/off quick messages for",
  T_37_WZY_WS_MUTEVOICE_NAME: "Voice chat on-off toggle",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "Turn voice chat on or off. When off, the voice HUD cannot be used and players will not be able to send or receive voice messages.",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "The player to turn on/off voice chat for",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "Boolean. True means off; False means on.",
  T_37_WZY_WS_NIGHTMODE: "Night mode",
  T_37_WZY_WS_ONAIM_NAMEDESC: "Triggers when the player is aiming at an aim-able entity. [Target entity] is the entity being aimed. When there is no entity being aimed, the return value is null.",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "Aimed entity",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "The entity that the weapon has hit",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "Triggers when the scenery successfully loads",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "The name of the scenery to load. This is a string.",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "Triggers when the scenery successfully switches",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "The name of the new scenery. This is a string.",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "Restore the player's clothing to its default look",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "The player whose default clothing to restore",
  T_37_WZY_WS_PETSET: "Pet settings",
  T_37_WZY_WS_PETSKILL: "Pet skills",
  T_37_WZY_WS_PETSWITCH2: "Whether pet skills can be used",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "Whether to enable player movement. This is a Boolean value.",
  T_37_WZY_WS_PLAYERBEHAVIOR: "Player behavior type",
  T_37_WZY_WS_PRESS: "Gentle click",
  T_37_WZY_WS_PROGRESS: "Current progress",
  T_37_WZY_WS_PROGRESSBAR: "Progress HUD entity",
  T_37_WZY_WS_RANKDOWN: "Rank down",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "Remove a tag for the selected entity",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "The text content to remove",
  T_37_WZY_WS_REPLACE_STR_DESC: "Replace the content of a string with a designated content",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "The character to be replaced",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "The new character to replace with",
  T_37_WZY_WS_REVERSE_ARR_DESC: "Reverse all the elements in this list",
  T_37_WZY_WS_REVIVEHERE: "The player who is reviving teammates at this revival point",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "Triggers when a player is reviving teammates at this revival point",
  T_37_WZY_WS_REVIVEWAYDESC: "The method by which a player is revived or helped up from being eliminated or knocked down",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "Configure the status of different behaviors for players. When disabled, the corresponding buttons on the HUD cannot be used, and manual and automatic movements are not allowed. When hidden, the corresponding buttons will not be displayed on the HUD, and manual movements are not allowed while automatic movements are allowed. When enabled, the corresponding buttons will be displayed on the HUD, and manual and automatic movements are allowed.",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "The player to set behavior status for",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "The player's behavior, including moving, attacking, jumping, and sprinting",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "Status includes disabled, hidden, and enabled. When hidden, the corresponding buttons will not be displayed on the HUD, and manual movements are not allowed while automatic movements are allowed. When enabled, the corresponding buttons will be displayed on the HUD, and manual and automatic movements are allowed.",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "The coordinates of the football",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "Whether the football should maintain its pre-configuration speed. This is a Boolean value.",
  T_37_WZY_WS_SETPLAHOST_NAME: "Player attack setting",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "Configure whether [Setting player] can attack [Target player]. The default setting is based on whether the target player belongs to a team and faction that can be attacked. This setting is of a higher priority than the team/faction setting.",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "The player to configure enemies for",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "The player who is the enemy",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "Attackable or not",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: '"Yes" means attackable; "No" means not attackable. The default setting is based on whether the target player belongs to a team and faction that can be attacked.',
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: '"Yes" means attackable; "No" means not attackable',
  T_37_WZY_WS_SHADOWSTRENGTH: "Shadows",
  T_37_WZY_WS_SHOOTANGLE: "Smallest shooting angle",
  T_37_WZY_WS_SKYBOX: "Sky",
  T_37_WZY_WS_SKYBOXENT: "Sky entity",
  T_37_WZY_WS_SKYBOXTYPE: "Basic sky types",
  T_37_WZY_WS_STEPPED: "Step on trigger",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "Switch the voice chat channel of the player",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "The player to switch channels for",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "The channel to switch to",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "Switch to a designated scenery",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "The name of the scenery to switch to",
  T_37_WZY_WS_TARGETSTR_DESC: "Target string",
  T_37_WZY_WS_TEAMASIDE: "Team and Faction",
  T_37_WZY_WS_TELEPORTN_AUTO: "Automatic",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "Teleportable or not",
  T_37_WZY_WS_TELEPORTN_MANUAL: "Manual",
  T_37_WZY_WS_TELEPORTN_NO: "No",
  T_37_WZY_WS_TELEPORTN_TITLE: "Teleport method",
  T_37_WZY_WS_TELEPORTN_YES: "Yes",
  T_37_WZY_WS_TERRAINWET: "Terrain moisture",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "Substitute the appearance of a [Player entity] with the appearance of a [Scenery object]",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "The player entity whose appearance to change",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "The player whose disguise entity to obtain",
  T_37_WZY_WS_TRANSP: "Transparency",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "Uninstall a designated scenery",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "The name of the scenery to uninstall",
  T_37_WZY_WS_VFX1: "Symbolic",
  T_37_WZY_WS_VFX2: "Smokey",
  T_37_WZY_WS_VFX3: "Curse Explosion",
  T_37_WZY_WS_VFX5: "Frozen",
  T_37_WZY_WS_VFX6: "Spotlight",
  T_37_WZY_WS_VFX7: "Upward Turbulence",
  T_37_WZY_WS_VFX8: "Atmosphere Explosion",
  T_37_WZY_WS_VISABLE: "Visibility",
  T_37_WZY_WS_WEAOPEN: "Show or not",
  T_37_WZY_WS_WEAPONENT: "Weapon entity",
  T_37_WZY_WS_WEATARGETED: "Whether can be targetted by aim assist",
  T_37_XYL_CUSTOMJERSEY: "Jersey Machine",
  T_37_XYL_CUSTOMJERSEY_DESC: "Use the Jersey Machine to create your ideal jersey",
  T_37_XYL_FOOTGUN: "Football Shooter",
  T_37_XYL_SOCCER: "Football",
  "T_37_XYL_SOCCER_ RADIUS": "Radius",
  T_37_XYL_SOCCER_DESC: "A football whose properties can be customized",
  T_37_XYL_SOCCER_HIGHT1: "Regular angle",
  T_37_XYL_SOCCER_HIGHT2: "Volley angle",
  T_37_XYL_SOCCER_RESET: "Reset time after a goal (s)",
  T_37_XYL_SOCCER_RESIST1: "Friction (Kick Mode)",
  T_37_XYL_SOCCER_RESIST2: "Friction (Gun Mode)",
  T_37_XYL_SOCCERGOAL: "Goal",
  T_37_XYL_SOCCERGOAL_DESC: "This is the goal. Shoot the football into the goal to score. (Only valid in Points Grab.)",
  T_37_XYL_SOCCERITEM: "Item Spawn",
  T_37_XYL_SOCCERITEM_DESC: "When placed, it will generate the selected item",
  T_37_XYL_SPAWN_PEOPLE: "# of players",
  T_37_XYL_WS_AIRCONDITIONER001: "Air Conditioner B",
  T_37_XYL_WS_AMMUCHEST: "War Chest A",
  T_37_XYL_WS_BAFFLE001: "Barrier A",
  T_37_XYL_WS_BARREL001: "Barrels",
  T_37_XYL_WS_BARREL001_DES: "Commonly seen circular wooden barrels",
  T_37_XYL_WS_BOARD001: "Ad Board B",
  T_37_XYL_WS_BOOK001: "Pile of Books A",
  T_37_XYL_WS_BOOK002: "Board Game A",
  T_37_XYL_WS_BOUGAINVILLEA: "Bougainvillea",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "Decor - brightens up the place!",
  T_37_XYL_WS_BOX001: "Pile of Boxes A",
  T_37_XYL_WS_BOX002: "Small Box",
  T_37_XYL_WS_BUSHCOVER: "Bush",
  T_37_XYL_WS_BUSHCOVER_DES: "A bush that can be used to hide in",
  T_37_XYL_WS_CABINET001: "Drawers A",
  T_37_XYL_WS_CHAIR001: "Chair A",
  T_37_XYL_WS_COCONUTTREE: "Coconut Tree",
  T_37_XYL_WS_COCONUTTREE_DES: "Decor - For a beachy vibe!",
  T_37_XYL_WS_COMPUTER001: "Computer A",
  T_37_XYL_WS_DAMAGERATIO: "Damage Ratio",
  T_37_XYL_WS_FIREEX: "Fire Extinguisher",
  T_37_XYL_WS_GUIDEPOSE: "Direction Post",
  T_37_XYL_WS_HUGEHOUSE001: "3-Story House B",
  T_37_XYL_WS_HUGEHOUSE002: "2-Story House B",
  T_37_XYL_WS_JACKSTRAW: "Scarecrow",
  T_37_XYL_WS_LADDER001: "Ladder A",
  T_37_XYL_WS_OILDRUM: "Jerry Can",
  T_37_XYL_WS_ORNAMENT001: "Vase A",
  T_37_XYL_WS_PACKBOX: "Supply Container",
  T_37_XYL_WS_PILLA001: "Concrete Pillar",
  T_37_XYL_WS_PRESENT: "Gift Box",
  T_37_XYL_WS_PRESENT_DES: "Contains holiday gifts",
  T_37_XYL_WS_PUMPKIN: "Square Jack-O'-Lantern",
  T_37_XYL_WS_PUMPKINCUT: "Jack-O'-Lantern",
  T_37_XYL_WS_PUMPKINCUT_DES: "A commonly decoration for a spooky festival",
  T_37_XYL_WS_ROADBLOCK001: "Roadblock B",
  T_37_XYL_WS_SHELF001: "Bookshelf A",
  T_37_XYL_WS_SOFA001: "Sofa A",
  T_37_XYL_WS_SPAWNTEAM: "All teams",
  T_37_XYL_WS_SUPPLYBOX: "Ammo Crate",
  T_37_XYL_WS_TABLE001: "Table A",
  T_37_XYL_WS_TABLE002: "Table B",
  T_37_XYL_WS_TARGET001: "Target",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "Portal Finish Point",
  T_37_XYL_WS_TELEPORTNEW: "Portal A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "A portal that can teleport the player to the finishing point of the portal",
  T_37_XYL_WS_TIRES001: "Tire A",
  T_37_XYL_WS_TOOLRACK: "Tool Shelf",
  T_37_XYL_WS_WALL001: "Wall",
  T_37_XYL_WS_WOOD001: "Chopped Wood",
  T_37_XYL_WS_YELLOWDUCK001: "Ducky Float",
  T_37_XYL_WS_YELLOWDUCK001_DES: "An inflated swim ring in the shape of a duck",
  T_37_YM_BOMBSQUAD_DEFUSER: "Defuser",
  T_37_YS_B_BRFOOTBALL_WHITE: "CBF White Jersey (Bottom)",
  T_37_YS_F_B_VN_STREET: "Crimson Auspicion (Bottom)",
  T_37_YS_F_H_VN_STREET: "Crimson Auspicion (Head)",
  T_37_YS_F_S_VN_STREET: "Crimson Auspicion (Shoes)",
  T_37_YS_F_T_VN_STREET: "Crimson Auspicion (Top)",
  T_37_YS_M_A_CRICKET_BLACK: "Bumblebee Cricketer (Mask)",
  T_37_YS_M_A_THKOL: "Blaze Banish (Mask)",
  T_37_YS_M_B_CRICKET_BLACK: "Bumblebee Cricketer (Bottom)",
  T_37_YS_M_B_SILVERERA: "Fearless Greyguard (Bottom)",
  T_37_YS_M_B_THKOL: "Blaze Banish (Bottom)",
  T_37_YS_M_H_SILVERERA: "Fearless Greyguard (Head)",
  T_37_YS_M_H_THKOL: "Blaze Banish (Head)",
  T_37_YS_M_S_CRICKET_BLACK: "Bumblebee Cricketer (Shoes)",
  T_37_YS_M_S_SILVERERA: "Fearless Greyguard (Shoes)",
  T_37_YS_M_S_THKOL: "Blaze Banish (Shoes)",
  T_37_YS_M_T_CRICKET_BLACK: "Bumblebee Cricketer (Top)",
  T_37_YS_M_T_SILVERERA: "Fearless Greyguard (Top)",
  T_37_YS_M_T_THKOL: "Blaze Banish (Top)",
  T_37_YS_T_BRFOOTBALL_WHITE: "CBF White Jersey (Top)",
  T_37_ZF_ROOM_UGC_MINPLAYER: "Minimum players",
  T_38_BQ_SKILL_NAME_DUMMY1: "Stunt Double",
  T_38_BQ_SKILL_NAME_DUMMY2: "Shape Splitter",
  T_38_CJ_F_B_STREAMER_MUSIC: "e-Heartseeker (Bottom)",
  T_38_CJ_F_H_STREAMER_MUSIC: "e-Heartseeker (Head)",
  T_38_CJ_F_S_STREAMER_MUSIC: "e-Heartseeker (Shoes)",
  T_38_CJ_F_T_STREAMER_MUSIC: "e-Heartseeker (Top)",
  T_38_JH_WS_CM1: "Clear Rules",
  T_38_JH_WS_CM2: "Unclear Rules",
  T_38_JH_WS_CM3: "Frequent Quit Outs",
  T_38_JL_M79_AMMO_N: "M79 Ammo",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "J.Biebs' Microchip",
  T_38_M_WS_VECTOR2: "2D Vector",
  T_38_R_TACTICS_N: "Preset",
  T_38_RW_NIW_NIWNAME: "Gloo Maker",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "Too many layers of blocks. Current: {0}. Max.: {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "Number of items you've created ({0}) has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "Number of incidents received in the same frame ({0}) has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "Per-frame dynamic entity creation limit reached ({0}); {1} creation attempt(s) refused.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "Length of the initialized list ({0}) has exceeded the limit ({1}). Auto-creates a max capacity list.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "Number of loops ({0}) has exceeded the limit ({1}). Loop interrupted",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "The number of concurrent coroutines  ({0}) in the coroutine scope has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "Failed to add element to the list. List {0} is empty",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "Mismatched value types when executing the basic arithmetic operation. The left value type is {0} and the right value type is {1}.",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "Repeated temporary variable definition. Variable name: {0}.",
  T_38_SP_WS_REVIEW_01: "Toxic",
  T_38_SP_WS_REVIEW_02: "Vulgar",
  T_38_SP_WS_REVIEW_03: "Insulting",
  T_38_SP_WS_REVIEW_04: "Extremely Toxic",
  T_38_SP_WS_REVIEW_05: "Threatening",
  T_38_SP_WS_REVIEW_06: "Disrespectful",
  T_38_SP_WS_REVIEW_07: "Under Review",
  T_38_SP_WS_REVIEW_08: "{0} name {1} does not comply with the rules. {2}.",
  T_38_SP_WS_REVIEW_09: "String",
  T_38_SP_WS_REVIEW_10: "Store",
  T_38_SP_WS_REVIEW_11: "Variable",
  T_38_SP_WS_REVIEW_12: "Function",
  T_38_SP_WS_REVIEW_13: "Object",
  T_38_SP_WS_REVIEW_14: "Go to definition.",
  T_38_SP_WS_REVIEW_15: "Go to Manage Objects.",
  T_38_SP_WS_REVIEW_16: "No redirection.",
  T_38_SP_WS_REVIEW_17: "Map Name",
  T_38_SP_WS_REVIEW_18: "Description",
  T_38_SP_WS_REVIEW_19: "Cover Image",
  T_38_SP_WS_REVIEW_20: "Text contains sensitive words.",
  T_38_SP_WS_REVIEW_21: "Save failed. Unable to be reviewed.",
  T_38_SP_WS_REVIEW_22: "Review under cooldown.",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "Bat - Mayhem",
  T_38_SY_CHARACTER_DESIGNER_N: "Santino",
  T_38_SY_PET_CACTUS_N: "Kactus",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "Pet Skin: Ghost Kactus",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "Pet Skin: Neon Kactus",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "Pet Skin: Palm Dream Kactus",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "Pet Skin: Party Arvon",
  T_38_SY_PETSKIN_RACCOON_MO_N: "Pet Skin: Trendy Rockie",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR - Nightfire Kami",
  T_38_SY_SICKLE_ES_N: "Scythe - Pop-Pow",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "Pickup Truck - Mochi Food Truck",
  T_38_WT_WS_MUITLEVEL: "Multi-Level",
  T_38_WT_WS_SKILLSET15: "Thrill of Battle (A124)",
  T_38_WT_WS_SKILLSET16: "Senses Shockwave (Homer)",
  T_38_WT_WS_SKILLSET17: "Wall Brawl (Iris)",
  T_38_WT_WS_SKILLSET18: "Rebel Rush (Tatsuya)",
  T_38_WZY_WS_ACTIVEA: "Active in scenery or not",
  T_38_WZY_WS_ACTIVEB: "Turn on logic refresh or not",
  T_38_WZY_WS_ACTIVEVALUE: "Activity status",
  T_38_WZY_WS_AIR: "Air",
  T_38_WZY_WS_ALLOWMOVE: "Moveable or not",
  T_38_WZY_WS_AMMOAMOUNT: "Ammo amount",
  T_38_WZY_WS_AMMONAME: "Ammo Entity",
  T_38_WZY_WS_ARMOR_DAMRED: "DMG reduction multiplier",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "Explosion DMG reduction multiplier",
  T_38_WZY_WS_ARMOR_DURABILITY: "Current durability",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "Max. durability",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "Damageable or not",
  T_38_WZY_WS_ARMOR_ISDESTROY: "Destructible or not",
  T_38_WZY_WS_ARMOR_LEVEL: "Level",
  T_38_WZY_WS_ASSCONZOM: "Zombie elimination assist.",
  T_38_WZY_WS_BAGNAME: "Backpack Entity",
  T_38_WZY_WS_BAGSPACEEX: "Additional backpack space",
  T_38_WZY_WS_BRIDGING: "Bridge render component",
  T_38_WZY_WS_BUBBLE: "Bubble",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "Clear all items in the [player entity's] backpack",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "Clear the unwanted items lying around the map, such as loot, throwable residue, and loot boxes",
  T_38_WZY_WS_CLEARPRO: "Clear single property factor",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "Clone a [scenery object] entity at the location of a [player entity] and return the [disguise entity]",
  T_38_WZY_WS_COMPONENT: "Component",
  T_38_WZY_WS_COSTAMMO: "Consume ammo",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "Create a camera and return a [camera entity], whose properties can be modified through property settings",
  T_38_WZY_WS_CYCLES: "Times played",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "Check whether an [entity] is inside the scope of a circular pole. The [center] is the center of the pole, the [radius] is the radius of the circular surface, the [height] is the height of the pole, the [Euler angles] are the angles of the 3D orientation of the pole.",
  T_38_WZY_WS_CYLINDERJUD_RES: "The result of the circular pole scope check. This is a Boolean value.",
  T_38_WZY_WS_DAMSUMZOM: "DMG to zombies",
  T_38_WZY_WS_DARKNESS: "Darkness",
  T_38_WZY_WS_DIFCOLOR: "Surface color",
  T_38_WZY_WS_DIFTEXTURE: "Surface texture",
  T_38_WZY_WS_DRUMMUSIC: "Component type: drums",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "The player that was disconnected",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "The player that is reconnecting",
  T_38_WZY_WS_EUIANCHOR: "HUD anchor type enumeration",
  T_38_WZY_WS_FEATHER: "Feather",
  T_38_WZY_WS_FLAMEAMMO: "Flamethrower Ammo",
  T_38_WZY_WS_FLOWER: "Flower",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "Set the [entity] to always follow the [followed entity]. [Offset coordinates] is the distance between the two entities.",
  T_38_WZY_WS_FOLLOWENT: "Followed entity",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "Get the camera entity that is currently being used by a [player entity]",
  T_38_WZY_WS_GETCURCAMDESC: "The camera that is currently being used by the player",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "Get the amount of an item in the [designated item type] that a [player] owns",
  T_38_WZY_WS_GETITEMNUM_RES: "The amount of the designated item that the player owns",
  T_38_WZY_WS_GETVEC_NAME: "Get vector",
  T_38_WZY_WS_GETVEC_NAMEDESC: "Get a vector using the x, y, and z components of a set of coordinates",
  T_38_WZY_WS_GETVECRES: "The vector got from the x, y, and z components",
  T_38_WZY_WS_GHOST: "Ghost",
  T_38_WZY_WS_GRENADEFROZENNAME: "Flash Freeze Entity",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "Freeze zone radius",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "Freeze duration",
  T_38_WZY_WS_GRENADENAME: "Grenade Entity",
  T_38_WZY_WS_GRENADEPARAM1: "Min. DMG",
  T_38_WZY_WS_GRENADEPARAM2: "Max. DMG",
  T_38_WZY_WS_GRENADEPARAM4: "Explosion range",
  T_38_WZY_WS_GRENADEPARAM5: "Throwing speed",
  T_38_WZY_WS_GRENADEPARAM6: "Explosion delay",
  T_38_WZY_WS_GRENADEPARAM7: "Self DMG multiplier",
  T_38_WZY_WS_GRENADEPARAM8: "Ally DMG multiplier",
  T_38_WZY_WS_GRENADEPARAM9: "Vehicle DMG multiplier",
  T_38_WZY_WS_GUNFIRE: "Gunfire",
  T_38_WZY_WS_GUNPRO_PARAM2: "Reload Speed",
  T_38_WZY_WS_GUNPRO_PARAM3: "Body shots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM4: "Headshots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM5: "Limb shots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM7: "Extra DMG",
  T_38_WZY_WS_HELMET_NAME: "Helmet Entity",
  T_38_WZY_WS_ICON1: "Crown",
  T_38_WZY_WS_ICON2: "Duel",
  T_38_WZY_WS_INITPOS: "Initial location",
  T_38_WZY_WS_ISRESET: "Reciprocating Motion",
  T_38_WZY_WS_KILLCONZOM: "No. of zombies eliminated",
  T_38_WZY_WS_KILLENT_NAMEDESC: "Eliminate the chosen [entity], which must be a battle entity type. Ignores the invulnerable status.",
  T_38_WZY_WS_LABELPARAM: "Text content parameter list",
  T_38_WZY_WS_LEADMUSICA: "Component type: piano (treble)",
  T_38_WZY_WS_LEADMUSICB: "Component type: piano (alto)",
  T_38_WZY_WS_LEADMUSICC: "Component type: piano (bass)",
  T_38_WZY_WS_LINE: "Line",
  T_38_WZY_WS_LIQUID: "Liquid",
  T_38_WZY_WS_LOCALKEY: "Localized key",
  T_38_WZY_WS_LOCALPOS: "Relative location",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "Set an [entity] to aways face the [aimed entity]. [Offset coordinates] is the difference in coordinates of the aimed point and the entity's position.",
  T_38_WZY_WS_MAINWEAPONA: "Main Weapon 1",
  T_38_WZY_WS_MAINWEAPONB: "Main Weapon 2",
  T_38_WZY_WS_MOTIONTIME: "Movement duration",
  T_38_WZY_WS_MOTIONTYPE: "Movement method",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "Modified EP",
  T_38_WZY_WS_MUSHROOMNAME: "Mushroom Entity",
  T_38_WZY_WS_OBFACTION: "Spectating faction",
  T_38_WZY_WS_OBGLOBAL: "Spectate all",
  T_38_WZY_WS_OBSERVER: "Spectator Options",
  T_38_WZY_WS_OBTEAM: "Spectating team",
  T_38_WZY_WS_OFFSETVEC: "Offset coordinates",
  T_38_WZY_WS_ONBUY_NAMEDESC: "Triggers when a player is buying items from this Vending Machine. [Player entity] is the player that makes the purchase. [Merchandise entity] is the item bought.",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "Triggers when equipped by a [player entity]",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "Triggers when the player completes the jumping action",
  T_38_WZY_WS_ONLIE_NAMEDESC: "Triggers when the player completes the prone position",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "Triggers when the weapon reloads",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "Triggers when the player completes the sprinting action",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "Triggers when the player completes the crouching action",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "Triggers when the weapon eliminates a unit. [Eliminated entity] is the unit that was eliminated.",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "Triggers when the weapon inflicts damage to a battle entity. [Hit target] is the battle entity that damage was inflicted on. [Damage] is the damage being inflicted.",
  T_38_WZY_WS_OWNER: "Owner",
  T_38_WZY_WS_PARAMLIST: "Parameter list",
  T_38_WZY_WS_PARTICALMAP: "Particle Mapping",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: 'Pause or resume the current emote for a [player entity]. [Pause or not] is a Boolean value. "Yes" means pause. "No" means resume.',
  T_38_WZY_WS_PLAENTTRI_DESC: "Activated by player entering the trigger",
  T_38_WZY_WS_PLAQUITTRI_DESC: "Activated by player leaving the trigger",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "Force the [player entity] to play the designated [emote] once and return to original position when finished",
  T_38_WZY_WS_PLAYSPEED: "Playback speed percentage",
  T_38_WZY_WS_PREHUD_NAME: "Preset icon",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "Let the [player entity] leave its current faction",
  T_38_WZY_WS_RESETENT: "Reset components every round",
  T_38_WZY_WS_RESUUID: "Resource UUID",
  T_38_WZY_WS_RIMCOLOR: "Border color",
  T_38_WZY_WS_RIMTEXTURE: "Border texture",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "Check whether an [entity] is inside a cone. The [center] and [radius] are the center and radius of the cone. The [extracted radius] is the radius of the smaller sector within the cone. The height is the height of the 3D structure. The [angle] is the central angle of the cone. The [direction angle] is the direction vector of the central axis.",
  T_38_WZY_WS_SECTORJUD_RES: "The result of the fan-shaped scope check. This is a Boolean value.",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "Set the activity status of a [target entity]. [Activity status] is a Boolean value and affects the availability, visibility, and collidability of the entity.",
  T_38_WZY_WS_SETROUNDSCORE: "Set player's round score",
  T_38_WZY_WS_SHOOTANGMAX: "Max. shooting angle",
  T_38_WZY_WS_SHOWMAPINFO: "Display map info for same faction",
  T_38_WZY_WS_SHOWNAMEHUD: "Display name HUD for same faction",
  T_38_WZY_WS_SOUND1: "Acceleration",
  T_38_WZY_WS_SOUND10: "Phase Start",
  T_38_WZY_WS_SOUND11: "Zombies",
  T_38_WZY_WS_SOUND12: "Horror",
  T_38_WZY_WS_SOUND13: "Transformation",
  T_38_WZY_WS_SOUND14: "Pounding Heart",
  T_38_WZY_WS_SOUND15: "Medium Heartbeat",
  T_38_WZY_WS_SOUND16: "Slow Heartbeat",
  T_38_WZY_WS_SOUND17: "Rush Time",
  T_38_WZY_WS_SOUND18: "Click",
  T_38_WZY_WS_SOUND19: "Skill Recover",
  T_38_WZY_WS_SOUND2: "Disappear Notification",
  T_38_WZY_WS_SOUND20: "Join A Game",
  T_38_WZY_WS_SOUND3: "Visual Effects",
  T_38_WZY_WS_SOUND4: "Night Chirps",
  T_38_WZY_WS_SOUND5: "Hit (Blunt)",
  T_38_WZY_WS_SOUND6: "Reaction",
  T_38_WZY_WS_SOUND7: "Surprise Find",
  T_38_WZY_WS_SOUND8: "Apparition",
  T_38_WZY_WS_SOUNDENT: "Music entity",
  T_38_WZY_WS_SPAWNPOS: "Old Spawn Point",
  T_38_WZY_WS_SPHERENAME: "Basic sphere",
  T_38_WZY_WS_SPHERERADIUS: "Sphere radius",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "Check whether an [entity] is inside a spherical scope. The [center] and [radius] is the center and radius of the spherical structure.",
  T_38_WZY_WS_SPHERICALJUD_RES: "The result of the spherical scope check. This is a Boolean value.",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "Check whether an [entity] is inside the scope of a cube. The [center] is the center of the cube, the [length], [width], and [height] are the length, width, and height of the cube, and the [Euler angles] are the angles of the 3D orientation of the cube.",
  T_38_WZY_WS_SQUAREJUD_RES: "The result of the cubic scope check. This is a Boolean value.",
  T_38_WZY_WS_STARTGENTIME: "Spawn start time",
  T_38_WZY_WS_STAYTIME: "Pause duration",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "Switch a player's camera to the [camera entity]. [Switch mode] can be either no animation or progressive movement. [Switch time] is the time of switching during progressive mode.",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "Switch the camera mode. You can select between No Animation and Progressive Movement.",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: 'The switch time during progressive movement mode. When selected "no animation", this setting is void.',
  T_38_WZY_WS_TEXTHUD: "HUD text component",
  T_38_WZY_WS_TEXTTYPE: "Font Size",
  T_38_WZY_WS_TEXTUREID: "Texture type",
  T_38_WZY_WS_TRANDIST: "Max. distance",
  T_38_WZY_WS_TWEENERENABLED: "Turn on UITweener script or not",
  T_38_WZY_WS_TYPELIST: "Type list",
  T_38_WZY_WS_TYPELISTORLIST: "Type or type list",
  T_38_WZY_WS_VEST_NAME: "Vest Entity",
  T_38_WZY_WS_VFX1: "Hider Elimination",
  T_38_WZY_WS_VFX10: "Cyclic Combustion",
  T_38_WZY_WS_VFX11: "Poison Gas",
  T_38_WZY_WS_VFX13: "Heart",
  T_38_WZY_WS_VFX15: "Door",
  T_38_WZY_WS_VFX2: "Rampage",
  T_38_WZY_WS_VFX3: "Clone Elimination",
  T_38_WZY_WS_VFX4: "Hit Feedback",
  T_38_WZY_WS_VFX5: "Clone",
  T_38_WZY_WS_VFX6: "Disguise",
  T_38_WZY_WS_VFX7: "Flashbang Sparks",
  T_38_WZY_WS_VFX8: "Motion Trail",
  T_38_WZY_WS_VFX9: "Fire Charge",
  T_38_WZY_WS_VFXENT: "VFX Instance",
  T_38_WZY_WS_VFXTYPEA_NAME: "Customizable mapping VFX",
  T_38_WZY_WS_VFXTYPEB_NAME: "Non-customizable mapping VFX",
  T_38_WZY_WS_VISIBILITY: "Visibility type",
  T_38_WZY_WS_VOLUME: "Volume",
  T_38_WZY_WS_WEAPONGEN: "Weapon Generator",
  T_38_WZY_WS_WHECYCLE: "Replay",
  T_38_XXJ_WS_BLOCKMODE: "Blocked Mode",
  T_38_XXJ_WS_CUSTOMCAMARA: "Custom Camera",
  T_38_XXJ_WS_FFCLASSIC: "Classic FF (Shooting)",
  T_38_XXJ_WS_FOV: "Field of View",
  T_38_XXJ_WS_FOVDESC: "The field of view is the observable range of the camera.",
  T_38_XXJ_WS_FPS: "First Person (Shooting)",
  T_38_XXJ_WS_HORIZONTALANGLE: "Horizontal Angle",
  T_38_XXJ_WS_INVISICAM: "Semi-Transparent",
  T_38_XXJ_WS_OFFSET: "Offset",
  T_38_XXJ_WS_ORTHOGRAPHIC: "Orthographic",
  T_38_XXJ_WS_PERSPECTIVE: "Perspective",
  T_38_XXJ_WS_PROJECTIONMODE: "Projection Mode",
  T_38_XXJ_WS_STABLE: "Fixed",
  T_38_XXJ_WS_STARTCAMERA: "Default Camera",
  T_38_XXJ_WS_STARTCAMERAMODE: "Default Camera Mode",
  T_38_XXJ_WS_THIRD: "Chase Camera",
  T_38_XXJ_WS_TOPVIEW: "High Angle",
  T_38_XXJ_WS_TPS: "Third Person",
  T_38_XXJ_WS_TRANSVERSE: "Horizontal Movement",
  T_38_XXJ_WS_VERTICALANGLE: "Vertical Angle",
  T_38_XXJ_WS_ZOOM: "Zoom",
  T_38_XYL_WS_AISTARTTIME: "Start time (s)",
  T_38_XYL_WS_ARMORDESTROY: "Armor DMG multiplier",
  T_38_XYL_WS_BONFIRE: "Bonfire",
  T_38_XYL_WS_CANDLE01: "Candle A",
  T_38_XYL_WS_CANNON01: "Mechanical Cannon",
  T_38_XYL_WS_CLIPAMMOSIZE: "Magazine Storage",
  T_38_XYL_WS_DAMAGEDTRUCK: "Damaged Truck",
  T_38_XYL_WS_DOLL01: "Eerie Doll",
  T_38_XYL_WS_ENTERANCEHOUSE01: "Brick House A",
  T_38_XYL_WS_FENCE002: "Iron Fence B",
  T_38_XYL_WS_FIREWORK01: "Fireworks A",
  T_38_XYL_WS_GENERATOR: "Generator",
  T_38_XYL_WS_GRAVITY: "Gravitational Acceleration",
  T_38_XYL_WS_GRAVITYAREA: "Abnormal Grav Zone",
  T_38_XYL_WS_GRAVITYAREA_DESC: "A zone where players can change gravity",
  T_38_XYL_WS_HOLDWEAPON: "Weapon Hold",
  T_38_XYL_WS_INDOORFURNITURE: "Indoor Furniture",
  T_38_XYL_WS_LIGHTTUBE001: "Tube Light A",
  T_38_XYL_WS_LOVEBALLOON01: "Valentine Balloon A",
  T_38_XYL_WS_LOVELAMP01: "Heart Streetlight",
  T_38_XYL_WS_LOVESIGN01: "Love Neonlights",
  T_38_XYL_WS_OILDRUM_DAMAGE: "Oil Barrel Damage Ratio",
  T_38_XYL_WS_OUTDOORPROPS: "Outdoor Items",
  T_38_XYL_WS_PIPEANDBOX: "Pipes and Containers",
  T_38_XYL_WS_PLANT: "Plants",
  T_38_XYL_WS_ROSE01: "Rose",
  T_38_XYL_WS_ROSEN: "Rose Bouquet",
  T_38_XYL_WS_SMALLBUILDING: "Small Buildings",
  T_38_XYL_WS_SOFA002: "Sofa B",
  T_38_XYL_WS_TOWNHOUSE01: "Old 2-Story House",
  T_38_XYL_WS_TV001: "Old TV",
  T_38_ZP_CC_EXCHANGESTATUS: "Status",
  T_39_BQ_SKILL_NAME_VILLAIN: "Crimson Crush",
  T_39_CJ_A_BURN: "Victory Glintmark",
  T_39_HJ_WS_Arrow002: "Arrow 2",
  T_39_HJ_WS_LIKERATE2: "{0} min",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} min",
  T_39_HJ_WS_SOUND10: "Step",
  T_39_HJ_WS_SOUND11: "Mission Complete 1",
  T_39_HJ_WS_SOUND13: "Danger Alert 1",
  T_39_HJ_WS_SOUND14: "Danger Alert 2",
  T_39_HJ_WS_SOUND15: "Countdown 3",
  T_39_HJ_WS_SOUND16: "Tips Sound",
  T_39_HJ_WS_SOUND17: "Crow Caw",
  T_39_HJ_WS_SOUND18: "Sound of teleporting to a wrong area",
  T_39_HJ_WS_SOUND19: "Sound of teleporting to a correct area",
  T_39_HJ_WS_SOUND2: "Countdown 1",
  T_39_HJ_WS_SOUND20: "Teleport",
  T_39_HJ_WS_SOUND21: "Electric Shock",
  T_39_HJ_WS_SOUND23: "Get Item",
  T_39_HJ_WS_SOUND24: "Electronic & Cute BGM",
  T_39_HJ_WS_SOUND25: "Casual Game BGM",
  T_39_HJ_WS_SOUND4: "Mechanical Device Echo",
  T_39_HJ_WS_SOUND5: "Mosquito",
  T_39_HJ_WS_SOUND6: "Ding Ding Ding 1",
  T_39_HJ_WS_SOUND7: "Ding Ding Ding 2",
  T_39_HJ_WS_SOUND8: "Gear Switched On",
  T_39_HJ_WS_SOUND9: "Charge 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "Unlimited Gloo Walls",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "Unlimited Throwables",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "Special Firing Sound",
  T_39_HQ_UGC_CUSTOMRES: "Custom Resources",
  T_39_M_ACCOUNTID: "Account",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "Execute after double click",
  T_39_MF_SKILLTAG_4: "Movement",
  T_39_PD_HuntingGroundSnow_MYNAME: "Mr. V",
  T_39_QL_SKILL_OTHO_DES: "After knocking down an enemy, marks their teammates within [FFB300]{0}m[-] from them and slows down their movement speed by [FFB300]{1}%[-]. Lasts for [FFB300]{2}s[-]. When knocked down by a nearby enemy, marks and slows down the attacker and their teammates.",
  T_39_QL_SKILL_WOLFRAHH_DES: "After knocking down an enemy, enter Highlight mode, which increases rate of fire by [FFB300]{0}%[-] and movement speed by [FFB300]{1}%[-] but then decays quickly. Lasts for [FFB300]{2}s[-]. During Highlight mode, consecutively knocking down enemies will reset countdown and further boost rate of fire by [FFB300]{3}%[-] and movement speed by [FFB300]{4}%[-].",
  T_39_QL_SKILL_XAYNE_DES1: "Xtreme Mode: Get [FFB300]{0} temporary HP[-] for [FFB300]{1}s[-]. During this time, HP-healing effects are enhanced by [FFB300]{2}%[-]. Cooldown: [FFB300]{3}s[-].",
  T_39_RW_GM_DEFEAT: "Failed",
  T_39_RW_SKILL_DESC_FORD: "Gain [FFB300]{1} HP/s[-] for [FFB300]{0}s[-] when taking damage. After releasing an active skill, this passive skill will reset immediately. Cooldown: [FFB300]{2}s[-].",
  T_39_SP_WS_ITEMENTITY_01: "Item entity",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: 'Alvaro "Rageblast"',
  T_39_SY_CHARACTER_VILLAIN_N: "Orion",
  T_39_SY_KATANA_FASTBREAKING23_N: "Katana - 1001 Nights",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "Pet skin: Green Imp Arvon",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "Pet Skin: Royal Tig",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "Pet Skin: Scorpio Fang",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "Monster Truck - Green Giant",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "Tuk Tuk - Floral Chariot",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "Awakening: [FFB300]{0}s[-] before detonating, grenade produces [FFB300]{1}[-] extra grenades, which can cause [FFB300]{2}%[-] damage of their original.",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "Split Blitz",
  T_39_WT_WS_EMPTYMAP_TAG: "Empty space",
  T_39_WT_WS_FEMAPMODE: "Mode Title",
  T_39_WT_WS_FEMAPTAG: "Map Tag",
  T_39_WT_WS_MAPPLAYER: "Number of Players",
  T_39_WT_WS_MEDENTERNUM: "Mid-game joining player limit",
  T_39_WT_WS_MIDENTER: "Mid-game joining",
  T_39_WT_WS_MIDENTERCOUNT: "Quota of joining mid-game",
  T_39_WT_WS_MIDENTERTIME1: "Time limit of mid-game joining",
  T_39_WT_WS_MIDENTERTIME2: "Duration of mid-game joining",
  T_39_WT_WS_MIDENTERTIMETIP: "When the map player number limit is not reached, enable players to join in within N sec after match starts. Players cannot join in after N sec.",
  T_39_WT_WS_MIDENTERTIP: "When enabled, players can join this map mid-game.",
  T_39_WT_WS_PLAYERCOUNT: "Initial player number",
  T_39_WT_WS_PLAYERCOUNTTIP: "The player number when the match starts. More players can join mid-game until it reaches the map's limit.",
  T_39_WT_WS_TAG1: "Free For All",
  T_39_WT_WS_TAG10: "Easy",
  T_39_WT_WS_TAG11: "Medium",
  T_39_WT_WS_TAG12: "Hard",
  T_39_WT_WS_TAG13: "Very Challenging",
  T_39_WT_WS_TAG14: "Escape",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "Custom Resources",
  T_39_WT_WS_TAG18: "Puzzles",
  T_39_WT_WS_TAG19: "Racing",
  T_39_WT_WS_TAG2: "Gun Fight",
  T_39_WT_WS_TAG20: "Music",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "Adventure",
  T_39_WT_WS_TAG23: "Zombie Hunt",
  T_39_WT_WS_TAG24: "PvP",
  T_39_WT_WS_TAG25: "Party Game",
  T_39_WT_WS_TAG26: "Team Deathmatch",
  T_39_WT_WS_TAG27: "Turret Defense",
  T_39_WT_WS_TAG28: "Training",
  T_39_WT_WS_TAG3: "Gun King",
  T_39_WT_WS_TAG4: "Respawn",
  T_39_WT_WS_TAG5: "Sniper",
  T_39_WT_WS_TAG6: "Survival",
  T_39_WT_WS_TAG7: "Solo",
  T_39_WT_WS_TAG8: "Horror",
  T_39_WT_WS_TAG9: "Casual",
  T_39_WT_WS_TAGMAXTIP: "Select up to {0} tags",
  T_39_WT_WS_TAGTYPE1: "Gameplay Type",
  T_39_WT_WS_TAGTYPE2: "Map Type",
  T_39_WT_WS_TAGTYPE3: "Mode Type",
  T_39_WT_WS_TAGTYPE4: "Team Size",
  T_39_WZY_WS_ACCSPEED: "Acceleration",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "Add script [Script Name] for [Entity]",
  T_39_WZY_WS_ASC: "Ascending",
  T_39_WZY_WS_ASCIGZERO: "Ignore zero using Ascending",
  T_39_WZY_WS_BALLISTMOVENT: "Ballistic Motion Entity",
  T_39_WZY_WS_BEUSED_NAMEDESC: "Triggers incident when the item is used by [Player Entity]",
  T_39_WZY_WS_BODYSCALE: "Body scale",
  T_39_WZY_WS_BRAKETORQUE: "Brake Horsepower",
  T_39_WZY_WS_CAMTRANTYPE: "Camera transition type",
  T_39_WZY_WS_CARVEHICLE: "4-Wheeler",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "Check if a specified script [Script Name] exists in [Entity]. (The returned value should be Boolean)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "Check if the entity has a result of the specified script (Boolean)",
  T_39_WZY_WS_COMBINEALL: "Dual-wielding (Different guns)",
  T_39_WZY_WS_COMBINESELF: "Dual-wielding (Same gun)",
  T_39_WZY_WS_CONENAME: "Basic Cone",
  T_39_WZY_WS_COORSYS: "Coordinate system",
  T_39_WZY_WS_CRASHMAXD: "Max Crash Damage",
  T_39_WZY_WS_CRASHMIND: "Minimum Crash Damage",
  T_39_WZY_WS_CRAWLSPEED: "Mvmt. spd. percentage (Prone)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "Create Ballistic Motion for [Target Entity]. Can edit [Initial Speed], [Acceleration], and [Max Distance] accumulated in the direction of initial speed for the target entity, and return [Ballistic Motion Entity]",
  T_39_WZY_WS_CRETWEEN_NAME: "Create Interpolation Motion",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "Create an Interpolation Motion for [Entity], with [Attributes] of the entity moving smoothly from [Start Value] to [Target Value] within [Time]. [Method] represents the way of motion, including [One-way], [PingPong], [Cycle]. [Curve] is the curve of motion. And [Interpolation Motion Entity] will be returned after creating the motion.",
  T_39_WZY_WS_CURVE: "Curve",
  T_39_WZY_WS_CUSTRESULT: "Custom Match Result",
  T_39_WZY_WS_CYLINDERNAME: "Basic Cylinder",
  T_39_WZY_WS_DEFAULT: "No animation (Default)",
  T_39_WZY_WS_DESC: "Descending",
  T_39_WZY_WS_DIFFUSEALPHA: "Surface Transparency",
  T_39_WZY_WS_DISCONNECT: "Disconnect",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "Energy recovery per sec",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "Consume Energy",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "Max second jump height",
  T_39_WZY_WS_ENABLEJOIN: "Allow joining midway",
  T_39_WZY_WS_ENDPOS: "End point coordinates",
  T_39_WZY_WS_ENGINETORQUE: "Engine Horsepower",
  T_39_WZY_WS_EXPLODED: "Explosion Damage",
  T_39_WZY_WS_FEELDSPEED: "Mvmt. spd. percentage (Downed)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "Center flash time",
  T_39_WZY_WS_FLASH_CRANGE: "Center range",
  T_39_WZY_WS_FLASH_EFLASHTIME: "Edge flash time",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "Flashbomb hit effect",
  T_39_WZY_WS_FLASH_RANGE: "Explosion range",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "Descending speed",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "Max. altitude",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "Horizontal glide speed",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "Vertical glide speed",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "Minimum end height",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "Minimum takeoff height",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "Descent speed after super high",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "Turning speed",
  T_39_WZY_WS_FOLMOVENT: "Position Following Motion Entity",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "Get Skill List of [Player Entity]",
  T_39_WZY_WS_HB_BOOSTCD: "Sprint cooldown",
  T_39_WZY_WS_HB_BOOSTDURATION: "Sprint duration",
  T_39_WZY_WS_HB_BOOSTINITIAL: "Sprint cooldown on Skyboard",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "Sprint cooldown on Skyboard",
  T_39_WZY_WS_HB_BOOSTSPEED: "Sprint speed",
  T_39_WZY_WS_HB_HOVERBCD: "Skyboard cooldown",
  T_39_WZY_WS_HB_JUMPCD: "Jump cooldown",
  T_39_WZY_WS_HB_JUMPH: "Skyboard jump height",
  T_39_WZY_WS_HEADSCALE: "Head scale",
  T_39_WZY_WS_HEADSHOTDESCALE: "Headshot damage reduction",
  T_39_WZY_WS_INTITALSPEED: "Initial Speed",
  T_39_WZY_WS_INVENTORYBASE: "Basic item types",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "Energy cost per sec",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "Basic horizontal speed",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "Basic vertical speed",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "Dash energy cost per sec",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "Sprint horizontal speed",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "Sprint distance",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "Rush energy cost per sec",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "Sprint vertical speed",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "Upward energy cost per sec",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "Attackable",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "Self-triggerable",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "Whether can be triggered by allies",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "Triggerable by vehicle",
  T_39_WZY_WS_LANDMINE_LIFETIME: "Duration",
  T_39_WZY_WS_LANDMINE_STARTTIME: "Activation time",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "Trigger radius",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "Trigger time",
  T_39_WZY_WS_LEAVE: "Quit",
  T_39_WZY_WS_LIMBSCALE: "Limbs scale",
  T_39_WZY_WS_LISTLOCSTR: "Localized text list",
  T_39_WZY_WS_LOADRESULT_NAME: "Upload battle result",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "Upload battle result of [Player], including [Rank], [Result], [Score Name], [Score Value]. The result type is an integer. 1 for victory, 2 for defeat, 3 for Booyah, and 4 for a draw.",
  T_39_WZY_WS_LOOKMOVENT: "Gaze-following Motion Entity",
  T_39_WZY_WS_MAXCOUNT: "Maximum Quantity",
  T_39_WZY_WS_MAXDISTANCE: "Max. Distance",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "Turret Depression Angle",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "Turret Angular Speed",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "Turret Elevation Angle",
  T_39_WZY_WS_MINISENTRY_DAM: "Turret Damage",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "Damage Reduction Rate",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "Firing Angle",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "Turret Hit Rate",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "Turret Attack Interval",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "Max Turret Number",
  T_39_WZY_WS_MINISENTRY_RANGE: "Turret Attack Range",
  T_39_WZY_WS_MOVEENT: "Motion Entity",
  T_39_WZY_WS_NOCOMBINE: "Not dual-wieldable",
  T_39_WZY_WS_ONCE: "Once",
  T_39_WZY_WS_ONDROP_NAMEDESC: "Triggers incident when the item is discarded by [Player Entity]",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "Triggers incident when the item is equipped by [Player Entity]",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "Triggers incident when Hook Gun fires",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "Triggers incident when Landmine is activated",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "Triggers incident when Landmine is triggered by [Player Enitity]",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "Triggers when entity motion pauses",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "Triggers when entity restarts moving from pause",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "Triggers when entity starts moving",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "Triggers incident when the item is picked up by [Player Entity]",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "Triggers incident when Throwable hits target",
  T_39_WZY_WS_OPENATTACK: "Whether to enable the attack",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "Pause Motion Entity or Motion Entity List",
  T_39_WZY_WS_PAUSESOUND_NAME: "Pause sound effect",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "Pause Sound Entity or Sound Entity List",
  T_39_WZY_WS_PIANOTYPE: "Music Component Type",
  T_39_WZY_WS_PINGPONG: "PingPong",
  T_39_WZY_WS_PLAYABLELIST: "Motion Entity List",
  T_39_WZY_WS_PLAYINGSTATUE: "Status",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "Restore the paused Motion Entity or Motion Entity List. Can choose to resume or restart.",
  T_39_WZY_WS_PLAYSOUND_NAME: "Play sound effect",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "Restore the paused Sound Entity or Sound Entity List. Can choose to resume or restart.",
  T_39_WZY_WS_PROCIRCLE_NAME: "Progress Circle",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "Emits a ray along [Direction] from [Initial Coordinates], detects the first entity hit within [Distance], and returns [List of Entities Hit] and [List of Coordinates Hit]",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "Emits a ray along [Direction] from [Initial Coordinates], detects the first entity hit within [Distance], and returns [Entity Hit] and [Coordinates Hit]",
  T_39_WZY_WS_REAHEALHP: "Armor recovery value",
  T_39_WZY_WS_REAHEALTIME: "In-effect time interval",
  T_39_WZY_WS_RELATCOORSYS: "Relative coordinate system",
  T_39_WZY_WS_REPAIRARM: "Repair Kit",
  T_39_WZY_WS_REVERSE: "Reverse",
  T_39_WZY_WS_RIMALPHA: "Edge Transparency",
  T_39_WZY_WS_SCORENAME: "Score Name",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "Send a signal to Target Entity, the parameters uploaded are defined by predefined signal parameters. The selection of the entity type at the time of definition will generate the corresponding signal accepting event.",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "Create a position following motion for [Target Entity]. [Target Entity] follows [Following Entity]. [Offset Coordinates] is the coordinate offset between [Target Entity] and [Following Entity]. [Coordinate System] can select World Coordinate System and Relative Coordinate System based on the orientation of Following Entity. [Position Following Motion Entity] will be returned after creating the motion.",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "Create a Gaze-following Motion for [Target Entity]. [Target Entity] follows [Following Entity]. [Offset Coordinates] is the coordinate offset between [Target Entity] and [Following Entity]. [Coordinate System] can select World Coordinate System and Relative Coordinate System based on the orientation of Following Entity. [Gaze-following Motion Entity] will be returned after creating the motion.",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "Falling damage percentage",
  T_39_WZY_WS_SHOE_MAXENERGY: "Max. Energy",
  T_39_WZY_WS_SKILLLIST: "Skill List",
  T_39_WZY_WS_SKILLTYPE: "Character skill",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "Smoke effect duration",
  T_39_WZY_WS_SMOOTH: "Camera switch",
  T_39_WZY_WS_SOUNDENTL: "Sound Effect Entity List",
  T_39_WZY_WS_SOUNDENTLORSENT: "Sound Effect Entity or List",
  T_39_WZY_WS_SPRINTSPEED: "Sprint speed percentage",
  T_39_WZY_WS_SQUATSPEED: "Mvmt. spd. percentage (Squat)",
  T_39_WZY_WS_STARTCOO: "Initial Coordinates",
  T_39_WZY_WS_STATE: "Play status",
  T_39_WZY_WS_TARGETVAL: "Target value",
  T_39_WZY_WS_THROWSPEED: "Hook flying speed",
  T_39_WZY_WS_TOWER_PARAM10: "Rotation angle",
  T_39_WZY_WS_TOWER_PARAM11: "Turret status",
  T_39_WZY_WS_TOWER_PARAM12: "Entity ID",
  T_39_WZY_WS_TOWER_PARAM9: "Attack Target",
  T_39_WZY_WS_TOWSPEED: "Player traveling speed",
  T_39_WZY_WS_TWEENCURVE_NAME: "Custom Curve",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "Custom Curve can be used for Interpolation Motion",
  T_39_WZY_WS_TWEENENT: "Interpolation Motion Entity",
  T_39_WZY_WS_TWEENPLAYST_NAME: "Motion Methods",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "Methods of Interpolation Motion",
  T_39_WZY_WS_TWEENSTYLE: "Method",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "Delete script [Script Name] for [Entity]",
  T_39_WZY_WS_UPSET_NAMEDESC: "Randomize listed elements ",
  T_39_WZY_WS_VISIBLEONBACK: "Visible on back",
  T_39_WZY_WS_WEAPCOMBINET: "Dual-Wielding Weapon Type",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "Extra damage on the downed",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "Single shot bullet number",
  T_39_WZY_WS_WEAREPLAY: "Restart motion?",
  T_39_WZY_WS_WORLDCOORSYS: "World coordinate system",
  T_39_XXJ_WS_ADDFRIEND: "Add friend",
  T_39_XXJ_WS_ALLOWZ: "Enable player x-axis movement",
  T_39_XXJ_WS_BLOCKMODEDESC: "Camera's motion when there's an object between the camera and target",
  T_39_XXJ_WS_CAMERADISTANCE: "Distance from target",
  T_39_XXJ_WS_CAMERATYPEDESC: "Multiple types of preset and custom camera are provided",
  T_39_XXJ_WS_CAMERAUSER: "Camera user",
  T_39_XXJ_WS_CURENTCAMERA: "Camera used",
  T_39_XXJ_WS_DETAILS: "Match Details",
  T_39_XXJ_WS_FFECONOMY: "Economy",
  T_39_XXJ_WS_FOCUSTARGET: "Target observed",
  T_39_XXJ_WS_FOLLOWTARGET: "Target followed",
  T_39_XXJ_WS_GAMERESULT: "Match Result",
  T_39_XXJ_WS_GAMETITLE1: "Match 1",
  T_39_XXJ_WS_GAMETITLE2: "Match 2",
  T_39_XXJ_WS_GIFT: "Gift",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "Camera's horizontal rotation angle",
  T_39_XXJ_WS_INVISICAM: "Translucent",
  T_39_XXJ_WS_INVISICAMDESC: "Object between the camera and target becomes translucent",
  T_39_XXJ_WS_LEFTSCORE: "Left Team Score",
  T_39_XXJ_WS_LIKE: "Like",
  T_39_XXJ_WS_LOBBY: "Lobby",
  T_39_XXJ_WS_MAINSCORENAME: "Total Score Name",
  T_39_XXJ_WS_MAINSCORENUM: "Total Score Number",
  T_39_XXJ_WS_MAPEVALUATE: "Map Rating",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "Result of Multiple Teams",
  T_39_XXJ_WS_MVP1: "MVP 1",
  T_39_XXJ_WS_MVP2: "MVP 2",
  T_39_XXJ_WS_OFFSET2: "Observation point offset",
  T_39_XXJ_WS_OFFSET2DESC: "Typically refers to the offset of camera focus point relative to the player's original position. (Meaning varies by camera type)",
  T_39_XXJ_WS_OFFSETDESC: "Typically refers to the offset of camera position relative to the player's original position. (Meaning varies by camera type)",
  T_39_XXJ_WS_ORTHOGONAL: "Orthogonal",
  T_39_XXJ_WS_ORTHOGONALDESC: "Camera portrays distant and nearer targets as the same size",
  T_39_XXJ_WS_PERSPECTIVE: "Perspective",
  T_39_XXJ_WS_PERSPECTIVEDESC: "Camera uses perspective projection to observe the target",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "Camera's image formation when rendering",
  T_39_XXJ_WS_RANK1: "Team Rank",
  T_39_XXJ_WS_RANK2: "Player Rank",
  T_39_XXJ_WS_REPORT: "Report",
  T_39_XXJ_WS_REVIEW: "Replay",
  T_39_XXJ_WS_RIGHTSCORE: "Right Team Score",
  T_39_XXJ_WS_SCORENUM1: "Score 1",
  T_39_XXJ_WS_SCORENUM2: "Score 2",
  T_39_XXJ_WS_SCORENUM3: "Score 3",
  T_39_XXJ_WS_SCORENUM4: "Score 4",
  T_39_XXJ_WS_SCORENUM5: "Score 5",
  T_39_XXJ_WS_SCORETITLELIST: "Score Name List",
  T_39_XXJ_WS_SHARE: "Share",
  T_39_XXJ_WS_SPECTATORSWITCH: "Spectator",
  T_39_XXJ_WS_STABLE: "Stable",
  T_39_XXJ_WS_STABLEDESC: "Camera remains stable if there's an object in between the camera and the followed entity",
  T_39_XXJ_WS_TEAMNAME1: "Left Team Name",
  T_39_XXJ_WS_TEAMNAME2: "Right Team Name",
  T_39_XXJ_WS_TEAMRANK: "Team Rank",
  T_39_XXJ_WS_TRANSITIONTIME: "Camera transition time",
  T_39_XXJ_WS_TRANSITIONTYPE: "Camera transition type",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "Result of 2 Teams",
  T_39_XXJ_WS_VERTICALANGLEDESC: "Camera's vertical rotation angle",
  T_39_XXJ_WS_ZOOM: "Zoom",
  T_39_XXJ_WS_ZOOMDESC: "Camera zooms in if there's an object in between the camera and the followed entity",
  T_39_XYL_WS_LIGHTINTENSITY: "Light intensity",
  T_39_XYL_WS_LIGHTRANGE: "Light range",
  T_39_XYL_WS_POINTLIGHT: "Pointlight",
  T_39_XYL_WS_WATERZONE: "Custom water zone",
  T_40_B_DISABLE_RECONNECT: "Disable Auto-reconnection",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "Midnight Jersey",
  T_40_CJ_T_SHUTTLECOCK_RED2: "Arctic Blaze Jersey",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "Cherry Coal Jersey",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "Sunny Sky Jersey",
  T_40_CJ_T_SPORTSWEAR_FIRE: "Flame Up Jersey",
  T_40_DYEING_CLEAR: "Clear Coloring Status",
  T_40_HJ_WS_EFFECT32: "Sneakers",
  T_40_HJ_WS_EFFECT33: "Explosion",
  T_40_HJ_WS_EFFECT34: "Spawnpoint",
  T_40_HJ_WS_EFFECT35: "Laser",
  T_40_HJ_WS_EFFECT36: "Ammo",
  T_40_HJ_WS_EFFECT37: "Hit Effect",
  T_40_HJ_WS_EFFECT38: "Firing Effect",
  T_40_HJ_WS_EFFECT43: "Spider Web",
  T_40_HJ_WS_EFFECT44: "Releasing a Skill",
  T_40_HJ_WS_SOUND69: "Opening a Box",
  T_40_HJ_WS_SOUND70: "Level Up",
  T_40_HJ_WS_SOUND71: "Level Maxed",
  T_40_HJ_WS_SOUND72: "Tapping a Button",
  T_40_HJ_WS_SOUND73: "Countdown 1",
  T_40_HJ_WS_SOUND74: "Whistle",
  T_40_HJ_WS_SOUND75: "Game Over",
  T_40_HJ_WS_SOUND76: "Forward",
  T_40_HJ_WS_SOUND77: "Booyah",
  T_40_HJ_WS_SOUND78: "Checkpoint",
  T_40_HJ_WS_SOUND79: "Countdown 2",
  T_40_HJ_WS_SOUND80: "Game Starts",
  T_40_HJ_WS_SOUND81: "Obtained Many Coins",
  T_40_HJ_WS_SOUND82: "Obtained Coins",
  T_40_HJ_WS_SOUND83: "Obtained Some Coins",
  T_40_HJ_WS_SOUND84: "Joined the Game",
  T_40_HJ_WS_SOUND85: "Opening Guild Supply",
  T_40_HJ_WS_SOUND86: "Horn",
  T_40_HJ_WS_SOUND87: "Eliminated a Boss",
  T_40_HJ_WS_SOUND88: "Opening War Chest",
  T_40_HJ_WS_SOUND89: "Explosive Paint Skill",
  T_40_HJ_WS_SOUND90: "Bullet Hitting",
  T_40_HJ_WS_SOUND91: "Paint Shield Skill",
  T_40_HJ_WS_SOUND92: "Tapping a Disabled Button",
  T_40_HJ_WS_SOUND93: "Skill Charging Complete",
  T_40_HJ_WS_SOUND95: "Laser Skill",
  T_40_HJ_WS_SOUND96: "Get Item 2",
  T_40_HJ_WS_SOUND97: "Game Over 2",
  T_40_HJ_WS_SOUND98: "Elimination Notification",
  T_40_HJ_WS_SOUNDTYPE_BMG: "Background Music",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "In-Match Sound Effect",
  T_40_HJ_WS_SOUNDTYPE_UI: "UI Widget Sound Effect",
  T_40_JH_WS_MAPTAG1: "Color Game",
  T_40_JH_WS_MAPTAG10: "Color Hide N Seek",
  T_40_JH_WS_MAPTAG11: "Anniversary",
  T_40_JH_WS_MAPTAG12: "Role Play",
  T_40_JH_WS_MAPTAG13: "Simulation",
  T_40_JH_WS_MAPTAG14: "Asymmetrical",
  T_40_JH_WS_MAPTAG15: "Resource Battle",
  T_40_JH_WS_MAPTAG16: "Cart Escort",
  T_40_JH_WS_MAPTAG17: "Official Map",
  T_40_JH_WS_MAPTAG18: "Mini Game",
  T_40_JH_WS_MAPTAG19: "Speed Challenge",
  T_40_JH_WS_MAPTAG2: "Color Spray",
  T_40_JH_WS_MAPTAG20: "Roguelike",
  T_40_JH_WS_MAPTAG3: "Color Fight",
  T_40_JH_WS_MAPTAG4: "Color Fight",
  T_40_JH_WS_MAPTAG5: "Color Playground",
  T_40_JH_WS_MAPTAG6: "Playground Color",
  T_40_JH_WS_MAPTAG7: "Color Party",
  T_40_JH_WS_MAPTAG8: "Color Parkour",
  T_40_JH_WS_MAPTAG9: '"Spider-Verse" Parkour',
  T_40_JH_WS_TAG30: "Tycoon",
  T_40_JH_WS_TAG31: "Home-Wreck Havoc",
  T_40_JH_WS_TAG32: "Mystery Town",
  T_40_JH_WS_TAG33: "Dawn Crisis",
  T_40_JH_WS_TAG34: "Death Uprising",
  T_40_JH_WS_TAG35: "Fist Fight",
  T_40_JH_WS_TAG36: "Old Factory Roof",
  T_40_JH_WS_UGCTOKENNAME: "Craftland Token",
  T_40_L_QUICKMESSAGE_MODE2: "Clash Squad",
  T_40_M_WS_HIS: "of",
  T_40_SP_WS_DYEING: "Color",
  T_40_SP_WS_DYEING_AREA: "Area Coloring",
  T_40_SP_WS_DYEING_COLOR: "Color number",
  T_40_SP_WS_DYEING_COUNT: "Coloring Count",
  T_40_SP_WS_DYEING_DIR: "Coloring Direction",
  T_40_SP_WS_DYEING_DIS: "Coloring Distance",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "Fixed Coloring Area",
  T_40_SP_WS_DYEING_NORMAL: "Normal",
  T_40_SP_WS_DYEING_PLANE: "Plane Area Coloring",
  T_40_SP_WS_DYEING_POSITION: "Coordinate",
  T_40_SP_WS_DYEING_RANDOMDECAY: "Random Coloring Rate Decay",
  T_40_SP_WS_DYEING_RANDOMRATIO: "Random Coloring Rate",
  T_40_SP_WS_DYEING_RANGE: "Coloring Area",
  T_40_SP_WS_DYEING_STATE: "Coloring Status",
  T_40_SP_WS_FACTIONTIPS_11: "Purple",
  T_40_SP_WS_SHOE_CURENERGY: "Current Energy",
  T_40_SW_SKILL_Name_Nanoscientist: "Nano Lifeshield",
  T_40_SY_AK47_PENGUIN_W_N: "AK47 - Waggor's Wonder",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Awakened Alok",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "Sonia",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS - Waggor's Wonder",
  T_40_SY_M1014_PENGUIN_W_N: "M1014 - Waggor's Wonder",
  T_40_SY_M24_PENGUIN_W_N: "M24 - Waggor's Wonder",
  T_40_SY_MINI_PENGUIN_W_N: "AC80 - Waggor's Wonder",
  T_40_SY_PET_PUG_N: "Pug",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: 'Pet Skin: "Spider-Verse" Moony',
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "Pet Skin: Electric Arvon",
  T_40_SY_PETSKIN_PUG_BLACK_N: "Pet Skin: Laser Eyes Pug",
  T_40_SY_PETSKIN_PUG_GREEN_N: "Pet Skin: Aloha Pug",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "Pet Skin: Tigerstripe Pug",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR - Waggor's Wonder",
  T_40_SY_THOMPSON_PENGUIN_W_N: "Thompson - Waggor's Wonder",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP - Waggor's Wonder",
  T_40_SY_USP45_PENGUIN_W_N: "USP - Waggor's Wonder",
  T_40_SY_UZI_PENGUIN_W_N: "Mini Uzi - Waggor's Wonder",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "Activate Text Content",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "Placeholder Text Content",
  T_40_W_DJMALE_AWAKENING_D: "Awakening: While the aura is active, music notes that last for [FFB300]{2}s[-] will be dropped [FFB300]{1}m[-] behind the skill user every [FFB300]{0}s[-]. Teammates who pick up the music note will receive the same effect as the aura.",
  T_40_W_DJMALE_AWAKENING_N: "Party Remix",
  T_40_W_NURSE_D: "Spread [FFB300]{0}%[-] of the user's single-target healing effects (skill, Med Kit, heal gun, etc.) to teammates within [FFB300]{1}m[-] of the user.",
  T_40_WH_MP_BOXING_NAME: "Boxing Match",
  T_40_WH_MP_C_PACK: "Unlawful Backpack",
  T_40_WH_MP_EXCH_COIN: "Cash",
  T_40_WH_MP_EXCH_TEMPCOIN: "Unlawful Money",
  T_40_WH_MP_PAYCHECK: "Wages",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "The speed of helping up teammates is increased by [FFB300]{0}%[-]. Cooldown: [FFB300]{3}s[-]. The helped up teammate recovers [FFB300]{2} HP[-] in [FFB300]{1}s[-].",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "Creates a [FFB300]{0}m-radius[-] healing zone. Inside, user and allies recover [FFB300]{1} HP/s[-]. Help up will be automatically triggered when needed. Zone lasts for [FFB300]{2}s[-]. The effects of helping up teammates can be enhanced by other skills. Cooldown: [FFB300]{3}s[-].",
  T_40_WT_WS_ICONENTITY_PARAM6: "Method of display",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "Capsule",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "Height",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "Radius",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "Sphere",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "Simplified Arabic",
  T_40_WZY_WS_FONT_SUPERMARKET: "Supermarket",
  T_40_WZY_WS_ICONENTITY_COLOR: "Color",
  T_40_WZY_WS_ICONENTITY_FILLED: "Progressive",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "Image Resources",
  T_40_WZY_WS_ICONENTITY_NAME: "Icon object",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "Method of display",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "Simple",
  T_40_WZY_WS_ICONENTITY_SLICED: "9-Grid",
  T_40_WZY_WS_ICONENTITY_TILED: "Tiles",
  T_40_WZY_WS_NEWMAPTAG: "New Map Icon",
  T_40_WZY_WS_NEWVFX1: "Halo",
  T_40_WZY_WS_NEWVFX10: "Curse",
  T_40_WZY_WS_NEWVFX11: "Freeze Zone",
  T_40_WZY_WS_NEWVFX12: "Cold Air",
  T_40_WZY_WS_NEWVFX13: "Snowflake",
  T_40_WZY_WS_NEWVFX14: "Flame",
  T_40_WZY_WS_NEWVFX15: "Light Beam",
  T_40_WZY_WS_NEWVFX16: "Spread of Poison Gas",
  T_40_WZY_WS_NEWVFX17: "Poison Gas",
  T_40_WZY_WS_NEWVFX18: "Explosive Blaze",
  T_40_WZY_WS_NEWVFX19: "Light Effect",
  T_40_WZY_WS_NEWVFX2: "Bubble",
  T_40_WZY_WS_NEWVFX20: "Star",
  T_40_WZY_WS_NEWVFX3: "Ash",
  T_40_WZY_WS_NEWVFX4: "Stone Splash",
  T_40_WZY_WS_NEWVFX5: "Line",
  T_40_WZY_WS_NEWVFX6: "Flicker",
  T_40_WZY_WS_NEWVFX7: "Ring",
  T_40_WZY_WS_NEWVFX8: "Rising Particle",
  T_40_WZY_WS_NEWVFX9: "Smoke",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "Font Size",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "Font Style",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "Font",
  T_40_WZY_WS_TEXTENTITY_NAME: "Text object",
  T_40_WZY_WS_UIFONT_LATIN: "Agency FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "Interaction button HUD component",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: 'Whether it can be used in the scenery. This is read only and depends on "Parent available or not" and "Activity status".',
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "Whether all parents are active. This is read only and not visible to players.",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "Parent available or not",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "Display when the open status is true, otherwise closed",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: 'Whether it can be active on self. To use in the scenery, you must use "Active in scenery or not". This is read only and configured using an API.',
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "Whether the camera's cullingMask is visible to a certain layer",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "Generate tokens at a certain place",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "The lootable item to give to the player",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "Current orientation of the player",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "Direction",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "The AI is attacking the entity",
  T_40_XXJ_WS_AITARGET_DESCKEY: "The attacking AI",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "The align style",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "Horizontal align",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "Vertical align",
  T_40_XXJ_WS_ALPHA_DESCKEY: "Transparency",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "The remaining ammo count",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "Remaining ammo",
  T_40_XXJ_WS_ANCHORMAX: "Maximum Anchor",
  T_40_XXJ_WS_ANCHORMIN: "Minimum Anchor",
  T_40_XXJ_WS_APOSITION_DESCKEY: "Current position of the player",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "Position",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "Armor HUD switch",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "Configured asset ID",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "Asset ID",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "Target of attack",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "Attack throwables",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "The entity that is being attacked by the AI",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "Target attacked",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "The available coordinates of spawnpoints",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "Available coordinates",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "The bottom image",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "Background",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "Backpack",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "Background transparency",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "Background color",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "Background color",
  T_40_XXJ_WS_BGFILL_DESCKEY: "Whether to fill the background",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "Background fill",
  T_40_XXJ_WS_BGNAME_DESCKEY: "Background name",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "Background name",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "Background size delta",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "Background size delta",
  T_40_XXJ_WS_BLUE: "Blue",
  T_40_XXJ_WS_BODY_DESCKEY: "Torso",
  T_40_XXJ_WS_BODY_NAMEKEY: "Torso",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "Skeleton scale",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "The player's spawnpoint",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "Spawn point",
  T_40_XXJ_WS_BOTH: "Either",
  T_40_XXJ_WS_BUTTONNAME: "Button component name",
  T_40_XXJ_WS_CAMERA_DESCKEY: "Camera",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "The direction that the client camera is facing",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "The location of the client camera",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "Detect the camera line of the client",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "Camera ray detection",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "Stop dragging when coinciding with the viewport",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "Exit drag after fit",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "The distance between the center of the semicircles of the pill shape. It cannot be smaller than twice the radius of the sphere.",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "Cell size",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "Child cell height",
  T_40_XXJ_WS_CELLVALUE: "Read the content of a certain cell and return an object",
  T_40_XXJ_WS_CENTER_DESCKEY: "The world coordinates that corresponds to the minimap's center. 0 by default.",
  T_40_XXJ_WS_CENTER_NAMEKEY: "Minimap center",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "The offset of the button's position",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "Position offset",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "The center of mass relative to the local coordinates",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "Center of mass",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "Whether to display the middle line",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "Display middle line or not",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "Middle line position [0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "Middle line position",
  T_40_XXJ_WS_CHASERANGE: "Chase Vicinity",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "The entity that is being chased by the AI",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "Target chased",
  T_40_XXJ_WS_CHILD_DESCKEY: "Child entity",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "Parent's children",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "The point that is hit by the camera line",
  T_40_XXJ_WS_CHOOSECARHUD: "Select card HUD entity",
  T_40_XXJ_WS_CLAMP_DESCKEY: "If the parameter is within the numerical range between the minimum and maximum values, the function will return the value of the parameter; if the parameter is greater than the range, the function will return the maximum value; if the argument is less than the range, the function will return the minimum value",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "The size of the click area",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "Click size",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "Clipping type",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "Clipping type",
  T_40_XXJ_WS_CLONEENT_D: "Clone the selected entity and its attributes while keeping the original parent. If Level Object is selected, it will be based on Create Level Object.",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "The list of outfits",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "The outfit ID",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "Outfit ID",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "The outfit ID",
  T_40_XXJ_WS_COL_DESC: "The column to read.",
  T_40_XXJ_WS_COLNAME_DESC: "The name of the column to be read.",
  T_40_XXJ_WS_COLOR_DESCKEY: "Color",
  T_40_XXJ_WS_COLOR_NAMEKEY: "Value",
  T_40_XXJ_WS_COLOR1_DESCKEY: "Add color layers using the RGBA color channel. A channel value lies in between 0 and 255 and is stored in an Int32. White (255, 255, 255, 255) by default.",
  T_40_XXJ_WS_COLOR2_DESCKEY: "Color of the progress bar",
  T_40_XXJ_WS_COLOR3_DESCKEY: "The type of the RGBA color channel, which ranges from 0 to 255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "The color of the text",
  T_40_XXJ_WS_COLOR5_DESCKEY: "The color of the HUD",
  T_40_XXJ_WS_COLOR6_DESCKEY: "The color of the lighting",
  T_40_XXJ_WS_COLORA_DESCKEY: "The A color value",
  T_40_XXJ_WS_COLORB_DESCKEY: "The B color value",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "Progress bar color",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "Color barrel",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "Color Barrel",
  T_40_XXJ_WS_COLORG_DESCKEY: "The G color value",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "Obtain the RGBA channel",
  T_40_XXJ_WS_COLORGUN: "Rainbow Spray Rifle",
  T_40_XXJ_WS_COLORGUN_01: "Rainbow Spray Rifle (Red)",
  T_40_XXJ_WS_COLORGUN_02: "Rainbow Spray Rifle (Yellow)",
  T_40_XXJ_WS_COLORGUN_03: "Rainbow Spray Rifle (Blue)",
  T_40_XXJ_WS_COLORGUN_04: "Rainbow Spray Rifle (Green)",
  T_40_XXJ_WS_COLORGUN_05: "Rainbow Spray Rifle (Purple)",
  T_40_XXJ_WS_COLORR_DESCKEY: "The R color value",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "Text color",
  T_40_XXJ_WS_COLVALUE: "Column Content",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "The HUD entity of a general HUD switch",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "HUD entity of general HUD switch",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "Constraint",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "Constraint",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "The number of constraints",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "Constraint count",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "Original content",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "Default direction",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "The starting point of the scroll. Upper left corner by default.",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "Generate a static pixel for a certain object in the map. The pixel will not move with the object.",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "Create a minimap icon",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "Define a localized string for a timestamp",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "Create a custom UI component at the designated custom HUD and parent component",
  T_40_XXJ_WS_CREEP_NAMEKEY: "Crawl",
  T_40_XXJ_WS_CROUCH_DESCKEY: "Display when true, otherwise closed",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "Crouch",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "This is the camera's cullingMask render layer. You can filter the render entity using the level of the visible layer.",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "CullingMask",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "The top ID",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "Top",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "Facepaint ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "The shoes ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "Shoes",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "The head ID",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "Head",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "The facepaint ID",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "Mask",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "The bottom ID",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "Bottom",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "Facepaint",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "The bundle ID",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "Onesie",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "The drag amount in the xy direction",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "XY drag",
  T_40_XXJ_WS_DB: "Read Table Value",
  T_40_XXJ_WS_DB_DESC: "Read the corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DBDELETE_DESC: "Delete a corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DBKEY_DESCKEY: "A custom name used to identify data",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "Identifier",
  T_40_XXJ_WS_DBTABLENAME: "Database Table Name",
  T_40_XXJ_WS_DBTABLENAME_DESC: "The name of a table in a database.",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "The value to write",
  T_40_XXJ_WS_DBWRITE: "Write Table Value",
  T_40_XXJ_WS_DBWRITE_DESC: "Write a corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "Defense throwables",
  T_40_XXJ_WS_DEFULT: "Default",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "Delete a corresponding value of a certain key on a certain leaderboard table in the database.",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "Delete a corresponding value of a certain rank on a certain leaderboard table in the database.",
  T_40_XXJ_WS_DEPTH: "HUD layer",
  T_40_XXJ_WS_DEPTH_D: "The basic layer of the HUD",
  T_40_XXJ_WS_DICTANDLIST: "List and Dictionary",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "The value of the targeted dictionary",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "The transparency of the surface",
  T_40_XXJ_WS_DIR_DESCKEY: "Vector",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "A point that is provided and can be used as a revival points, etc.",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "Coordinates",
  T_40_XXJ_WS_DISABLEALL: "Deselect All",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "Disabled color",
  T_40_XXJ_WS_DISTANT_DESCKEY: "The distance of the camera line detection",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "Projecting distance",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "Supports multiple dragging directions",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "Drag effect",
  T_40_XXJ_WS_DRIVER_DESCKEY: "The driver of the vehicle",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "Driver",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "Modify a value",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "Display special effects",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "Display special effects",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "Effects color",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "The special effects entity represents the special effect to be displayed",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "The special effects object",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "Emoji HUD switch",
  T_40_XXJ_WS_ENABLEALL: "Select all",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "Whether to turn on logic update. When off, the blocks on this entity will stop updating every frame.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "When written into the weapon attributes, the weapon's basic statistics will be affected by the weapon skin",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "Write weapon skin attribute",
  T_40_XXJ_WS_ENTITY_DESCKEY: "An entity is a vessel that holds all components, which must be added to entities in order to be activated",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "Entity type",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "The basic component of an entity. All components will combine this component.",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "The entity to transform into",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "The parameter name used in the code to represent the entity of the newly added custom UI control. Its corresponding local variable value is the entity of the newly added custom UI control.",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "The name of the entity variable",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "The parameter name used in the code to represent the entity of the created icon. Its corresponding local variable value is the entity of the created icon.",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "EP bar HUD switch",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "Euler angles",
  T_40_XXJ_WS_FACINFECTION: "Faction (Droid Apocalyse)",
  T_40_XXJ_WS_FACINFECTION_DESC: "Faction of the player. 1 = Human, 2 = Droid.",
  T_40_XXJ_WS_FEMALE: "Female",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "Fill direction",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "Sort direction",
  T_40_XXJ_WS_FIRE_NAMEKEY: "Fire",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "The value of the float",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "The target entity to follow. Empty by default.",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "The size of the text",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "Font size",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "The font style",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "Football Gloo Wall",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "The formatting style",
  T_40_XXJ_WS_FORWARD_DESCKEY: "The direction of the player",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "The direction to teleport",
  T_40_XXJ_WS_FREE_DESCKEY: "A camera that is controllable by the player and can be moved freely",
  T_40_XXJ_WS_FREE_NAMEKEY: "Free Camera",
  T_40_XXJ_WS_GENDER: "Gender",
  T_40_XXJ_WS_GENDER_DESCKEY: "Gender",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "Gender enum",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "Obtain the camera's cullingMask",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Obtain the player's outfit ID",
  T_40_XXJ_WS_GETPLAYERRANK: "Get Player Rank",
  T_40_XXJ_WS_GETPLAYERRANK_D: "Get Player Total Rank",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "Get Player Round Rank",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "Get Player Specific Round Rank",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "Search for data of the player's token",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Obtain the player's weapon skin",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "Obtain a set of coordinates that has not been occupied by random spawnpoints",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "Obtain the sky box of a scenery",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "Obtain the region of a server",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "Obtain the timestamp of a server",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "Obtain a location near the teammate, avoiding areas where players cannot stand on",
  T_40_XXJ_WS_GETTEAMRANK: "Get Team Rank",
  T_40_XXJ_WS_GETTEAMRANK_D: "Get Team Total Rank",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "Get Team Round Rank",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "Get Team Specific Round Rank",
  T_40_XXJ_WS_GREEN: "Green",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "Half of the dimensions of a 3-dimensional shape",
  T_40_XXJ_WS_HEAD_DESCKEY: "Head",
  T_40_XXJ_WS_HEAD_NAMEKEY: "Head",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "The heartbeat effect entity",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "Heartbeat effect entity",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "The height",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "Hint button",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "Tips button",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "The entity to be displayed at the target location",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "Entity targeted",
  T_40_XXJ_WS_HITPOS_DESCKEY: "The spot that is hit",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "The horizontal display type",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "Horizontal display type",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "The entity that is following another entity",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "The entity that is looking at another entity",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "Health bar HUD switch",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "The HUD insertion entity. This is the HUD that players modify from the editor.",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "Empty HUD panel component",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "The HUD entity it belongs to",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "HUD grid component",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "HUD panel component",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "HUD scroll view component",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "Human model ID",
  T_40_XXJ_WS_ICON_DESCKEY: "The resource name of the icon",
  T_40_XXJ_WS_ICON_NAMEKEY: "Icon",
  T_40_XXJ_WS_ICON1_DESCKEY: "Select an icon",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "The icon entity represents the icon to be displayed",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "A resource path. Built-in resource is in:path. Custom resource is out:path. Empty by default.",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "Icon name",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "Icon name",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "The resource path. Empty by default.",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "Whether it can scan for triggers",
  T_40_XXJ_WS_INDEX_DESCKEY: "The child's index under the parent",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "Initial value [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "The value of the integer",
  T_40_XXJ_WS_IS3D: "3D sound effect",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "Always facing the camera",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "Bold",
  T_40_XXJ_WS_ISBYORDER_D: "Detect whether players should trigger level objects in chronological order",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "Is FirEditor button",
  T_40_XXJ_WS_ISHIT_DESCKEY: "Whether the camera line has hit the entity",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "Whether it is visible to a certain layer",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "Italic",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "Whether marked by scan",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "Scanned or not",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "Whether marked by the pin button",
  T_40_XXJ_WS_ISTRIGGER: "Is trigger",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "Underlined",
  T_40_XXJ_WS_ITEMID_DESCKEY: "The entity's corresponding item ID",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "Item ID",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "The item ID (only weapon ID available in the current version)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "The item ID of the weapon",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "Item ID",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "Metropolis area",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "Metropolis area",
  T_40_XXJ_WS_JUMP_NAMEKEY: "Jump",
  T_40_XXJ_WS_KEY_DESCKEY: "The value of the key",
  T_40_XXJ_WS_KEY_NAMEKEY: "Key",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "The name of the key to traverse. You can use this to obtain the value of a key in a local variable.",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "Elimination announcement",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "Text color",
  T_40_XXJ_WS_LANDMINEOBJ: "Entity after landmine creation",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "The mask of the collide layer. Layers not selected will not be included in the scan. When empty, all layers will be included in the scan.",
  T_40_XXJ_WS_LAYERSEDIT: "Edit Layers",
  T_40_XXJ_WS_LAYERSETTING: "Visible layer settings",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "The collision layer of the camera line detection",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "Layer",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "Layout type",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "Layout type",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "Scoreboard HUD component",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "The HUD entity of the scoreboard. Modifying the entity's properties will affect the content to be displayed on the corresponding UI.",
  T_40_XXJ_WS_LEADERBOARDNAME: "Leaderboard Name",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "The name of the leaderboard table in the database.",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "The acceleration upon swinging",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "Leave acceleration",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "Left arm",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "Left arm",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "The left color",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "Left color",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "Whether to display the special effects on the left",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "Display left effect or not",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "Left foot",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "Left foot",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "Left hand",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "Left hand",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "Left icon",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "Left icon",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "Left leg",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "Left leg",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "Left score text",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "Left score text",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "Left text",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "Left text",
  T_40_XXJ_WS_LERP_DESCKEY: 't lies in between 0 and 1. When t=0, return "from". When t=1, return "to". When t=0.5, return the average of the values of "from" and "to".',
  T_40_XXJ_WS_LEVELOBJECT: "Level Object",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "Line spacing",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "Compare the values in a list and return the largest one",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "Compare the values in a list and return the smallest one",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "List or Dict",
  T_40_XXJ_WS_LOCALPOSITION: "Local position",
  T_40_XXJ_WS_LOCALROTA: "Local Euler angles",
  T_40_XXJ_WS_LOCALROTATIONQ: "Local quaternion rotation",
  T_40_XXJ_WS_LOCALSACLE: "Local scale",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "Localization switch",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "The container to traverse",
  T_40_XXJ_WS_MALE: "Male",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "Remove the dictionary",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "Obtain the length of the dictionary",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "Obtain the value of the designated key in the dictionary element",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "Remove the designated key-value pair in the dictionary",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "Configure the value of a designated key in the dictionary",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "The size of the minimap. Its width and height are equal.",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "Map size",
  T_40_XXJ_WS_MAPT: "Dict template",
  T_40_XXJ_WS_MAPT_D: "The data template for dict. You may designate the content type through T1 and T2.",
  T_40_XXJ_WS_MAPVALUE_D: "A data container for dict. The element is a pair that consists of a key and a value.",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "The target dictionary",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "Dict",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "The mask type is the image name used when masking",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "Mask name",
  T_40_XXJ_WS_MASS_DESCKEY: "Mass (in kg)",
  T_40_XXJ_WS_MASS_NAMEKEY: "Mass (kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "Compare 2 values and return the larger one",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "Max. length",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "The maximum value",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "The biggest component ID",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "Max. widget ID",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "Healing items",
  T_40_XXJ_WS_MIN_DESCKEY: "Compare 2 values and return the smaller one",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "Minimap component",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "Minimap pixel",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "Minimap icon",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "Minimap",
  T_40_XXJ_WS_MINNUM_DESCKEY: "The minimum value",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "The factor of the momentum. The larger the value, the bigger the momentum while scrolling.",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "Momentum factor",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "Movement joystick",
  T_40_XXJ_WS_MRESULT_DESCKEY: "Match result",
  T_40_XXJ_WS_NEWENTITY_D: "The new item entity after creation (may be null)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "Create a new dictionary",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "New Dict",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "The normal of the hit",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "HUD position [0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "HUD position",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "The list to convert indices into numbers",
  T_40_XXJ_WS_OBJECT_DESCKEY: "The object that the spray gun hits",
  T_40_XXJ_WS_OBSOLETE: "Deleted, for safety reasons please replace this block.",
  T_40_XXJ_WS_OFFSET_DESCKEY: "The display position. When there is a followed target, it is the offset between the new position and the original position. When there is no followed target, it is the screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "The screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "The display position. When there is a followed target, it is the offset between the new position and the original position. When there is no followed target, it is the screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "Display position (the anchor is on the top right corner)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "Horizontal offset",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "Horizontal offset",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "The vertical offset",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "Vertical offset",
  T_40_XXJ_WS_OK_DESCKEY: "Conversion successful",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "Trigger this event when the entity enters the attack vicinity",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "Trigger this event when the entity enters the chase vicinity",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "Trigger this event when the entity leaves the attack vicinity",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "Trigger this event when the entity leaves the chase vicinity",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "Trigger a camera line detection through the client",
  T_40_XXJ_WS_ONCOLLISION_D: "Only entities with the Collider component attached support this event",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "Trigger this event when the spray gun hits an entity",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "When the firing stops",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "When a player switches the scenery area",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "Display when the open status is true, otherwise closed",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "Open status",
  T_40_XXJ_WS_ORANGE: "Orange",
  T_40_XXJ_WS_ORDER_DESC: "The rank on the leaderboard",
  T_40_XXJ_WS_ORDER1: "Starting Rank",
  T_40_XXJ_WS_ORDER2: "Finishing Rank",
  T_40_XXJ_WS_ORIGINAL: "Keep original logic",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "Overflow method",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "When prioritized, the attributes of the player's weapon will replace the weapon's original attributes",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "Prioritize player weapon skin",
  T_40_XXJ_WS_OWNER_DESCKEY: "The player that owns this entity",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "The global UID of the child scenery it belongs to",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "GUID of child scenery",
  T_40_XXJ_WS_PARENT_DESCKEY: "Parent entity",
  T_40_XXJ_WS_PARENT_NAMEKEY: "Parent",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "Parent component entity ID",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "The file ID of the parent component",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "All the passengers in the vehicle",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "Passenger",
  T_40_XXJ_WS_PHYSICALLAYER: "Physical Layer",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "Physical Layer Matrix",
  T_40_XXJ_WS_PHYSICALTIP1: "Name Already Exists",
  T_40_XXJ_WS_PHYSICALTIP2: "Remove a layer name and make it invisible in the Physical Layer Matrix and Layer Enum, but the entity objects within that layer will not be affected.",
  T_40_XXJ_WS_PHYSICS: "Physics",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "Loot list HUD switch",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "A playable entity",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "An entity always faces another entity",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "An entity follows another entity",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "The bullet trail animation is a simulated animation of a bullet trail",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "The player to receive the message",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "The avatar used by the player",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "The outfit equipped by the player",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "Player outfit",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "The player's HUD type",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "Player HUD type",
  T_40_XXJ_WS_PLAYERIDINFAC: "Faction Serial No.",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "The player to record in the log",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "Consume a certain player's token",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "The list of skills of the player",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "The status of a player: alive, knocked down, or eliminated",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "Playback speed",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "Playback speed",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "For example, 1.25 means 25% faster than the original speed",
  T_40_XXJ_WS_POS_DESCKEY: "The coordinates to teleport to",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "The type of special effects sticker",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "Color on press",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "Executes a traversal of a container to obtain the key-value pair. Includes a child process, which is the loop.",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "Loop dict visit",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "Progress [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "Progress [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "The button for the skill progress",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "Skill progress button",
  T_40_XXJ_WS_QUATERNION: "Quaternion rotation",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "Quick msg HUD switch",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "Msgs beside team list",
  T_40_XXJ_WS_RADIUS_DESCKEY: "The radius of the two semicircles of a pill shape",
  T_40_XXJ_WS_READCELL: "Read A Cell",
  T_40_XXJ_WS_READCSV: "Read Table Content",
  T_40_XXJ_WS_READCSV_DESC: "Read the content on the entire table. Return a two-dimensional array.",
  T_40_XXJ_WS_READCSVCELL: "Read by row # and column name",
  T_40_XXJ_WS_READCSVCOL_DESC: "Read a certain column's content on the table. Returns an array.",
  T_40_XXJ_WS_READCSVROW_DESC: "Read a certain row's content on the table. Returns an array.",
  T_40_XXJ_WS_READLEADERBOARD: "Read Leaderboard Value",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "Read a corresponding value of a certain identifier on a leaderboard table in the database.",
  T_40_XXJ_WS_READLEADERBOARD2: "Read By Rank Range",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "Read the value of the difference between a certain rank to a certain rank on the leaderboard in a database.",
  T_40_XXJ_WS_RED: "Red",
  T_40_XXJ_WS_RELOAD: "Reload",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "Method of display",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "Restore the player's default outfit",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "Restore the player's default weapon skin",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "Whether the dragging is constrained to the viewport. Selected by default.",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "Constrain drag or not",
  T_40_XXJ_WS_RESULT_DESCKEY: "The result of the read",
  T_40_XXJ_WS_RESULT_NAMEKEY: "Result",
  T_40_XXJ_WS_RESULT1_DESCKEY: "Whether to find the largest number in the list",
  T_40_XXJ_WS_RESULT2_DESCKEY: "Whether to find the smallest number in the list",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "Find the smallest number in a list",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "Find the largest number in a list",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "The revival point of a player. If there are no checkpoints, use a spawnpoint. Otherwise use checkpoints.",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "Revival point",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "Right arm",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "Right arm",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "The right color",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "Right color",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "Whether to display the special effects on the right",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "Display right effect or not",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "Right foot",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "Right foot",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "Right hand",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "Right hand",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "Right icon",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "Right icon",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "Right leg",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "Right leg",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "Right score text",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "Right score text",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "Right text",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "Right text",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "The component of the rigid body type",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "Rigid body component",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "The enum of the rigid body type",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "Rigid body type enum",
  T_40_XXJ_WS_ROW_DECS: "The row to read.",
  T_40_XXJ_WS_ROWVALUE: "Row Content",
  T_40_XXJ_WS_SCALE_DESCKEY: "Configure the zoom scale of the object",
  T_40_XXJ_WS_SCALE_NAMEKEY: "Scale",
  T_40_XXJ_WS_SCALE0_DESCKEY: "The zoom scale of the coordinate series in the world",
  T_40_XXJ_WS_SCALE1_DESCKEY: "The zoom scale. 1 by default.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "The scale value",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "The name of the area",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "Scorebar",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "Score bar",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "Supports multiple scrolling directions",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "Scroll direction",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "The factor of the scroll. The larger the value, the faster the scrolling.",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "Scroll factor",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "Configure the camera's cullingMask",
  T_40_XXJ_WS_SETGLOBAL: "Set Global",
  T_40_XXJ_WS_SETPARENT_D: "Only supports entities that have the Transform component",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Configure the player's outfit ID",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "Modify multiple player outfits",
  T_40_XXJ_WS_SETPLAYERFORWAR: "Set Player Direction",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "Configure a player's HUD switch",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Configure the player's weapon skin",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "Whether to display entities at the target location",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "Display entity on target",
  T_40_XXJ_WS_SHOWPLAYER: "Display entity",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "Single-player match details HUD entity",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "A HUD entity for single-player matches. Modifying the entity's properties will affect the content to be displayed on the corresponding UI.",
  T_40_XXJ_WS_SIZEDELTA: "Size delta of anchor box and component",
  T_40_XXJ_WS_SKELETON: "Skeleton",
  T_40_XXJ_WS_SKELETON_D: "The pivot used to access the skeleton mask",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "Skeleton part",
  T_40_XXJ_WS_SKILLBUTTONHUD: "Skill button HUD entity",
  T_40_XXJ_WS_SLOT_DESCKEY: "The weapon's slot",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "When selected, there will be a slow movement upon dragging. When unselected, the dragging corresponds to the speed of the mouse.",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "Smooth motion or not",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "Softness",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "Softness",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "Sound entity",
  T_40_XXJ_WS_SPACE_DESCKEY: "Space",
  T_40_XXJ_WS_SPACE_NAMEKEY: "Child cell spacing",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "The coordinates of the AI's spawnpoint",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "Spawn point coordinates",
  T_40_XXJ_WS_SPEED_DESCKEY: "Speed",
  T_40_XXJ_WS_SPEED_NAMEKEY: "Speed",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "Sprint",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "The radius of the sphere",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "The color of the spray",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "Spray color",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "The spray result",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "Spray result",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "The spray gun (assault rifle)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "Spray Rifle",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "Initial Velocity",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "Flip sticker",
  T_40_XXJ_WS_SPRITEID: "Sprite asset ID",
  T_40_XXJ_WS_SPRITEID_D: "The ID used to describe the sprite asset",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "Sticker type",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "The target entity to generate into a static pixel",
  T_40_XXJ_WS_STARTPOSITION_D: "The coordinates of the shape's geometrical center",
  T_40_XXJ_WS_STAY_D: "Retain the current world position, rotation, and scaling of the child? This is generally set to true, and UI settings are ineffective for this option.",
  T_40_XXJ_WS_STRING_NAMEKEY: "String",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "Convert a string to a float",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "Convert a string to an integer",
  T_40_XXJ_WS_STYLE_DESCKEY: "The play method of the interpolation. Options include play once, loop, and play again.",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "Switch the player's area",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "Switch value",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "Switch weapons according to the player's slot",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "Switch the item slot",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "Item switch",
  T_40_XXJ_WS_TABLENAME_DESC: "Displayed as the table name but is actually the UID",
  T_40_XXJ_WS_TABLEVALUE: "Table content",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "The list of tags",
  T_40_XXJ_WS_TARGET_DESCKEY: "The target entity to generate map pixel. Empty by default.",
  T_40_XXJ_WS_TARGET_NAMEKEY: "Entity to create map pixel",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "Attack target",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "The target entity",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "Entity",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "The entity where the customized function is at",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "The entity that is attacked by the AI",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "The target entity to follow",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "The item entity (can be empty)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "The target entity to look at",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "The sound entity to pause",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "The sound entity to play after the pause",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "The sound entity to delete",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "Teammates info",
  T_40_XXJ_WS_TELEPORTA_D: "Teleport the player to a designated spot with a set direction",
  T_40_XXJ_WS_TEXT_NAMEKEY: "Tip text",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "Notification text color",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "The text entity represents the text to be displayed",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "The text keys to display",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "Text key",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "The timestamp",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "The display style of a localized string",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "Timestamp display style",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "The localized string for a timestamp",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "Loc string timestamp",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "Hint",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "Tip",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "The amount of lootable item",
  T_40_XXJ_WS_TOKENID_DESCKEY: "The ID of a lootable item",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "The tow speed of a player",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "Translation type",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "The interpolation animation entity",
  T_40_XXJ_WS_TYPE_DESCKEY: 'This is the type of the description. Using "typeof" will return its type.',
  T_40_XXJ_WS_TYPE_NAMEKEY: "Rigid body type",
  T_40_XXJ_WS_TYPE2_DESCKEY: "Different types of rigid bodies have different functions",
  T_40_XXJ_WS_TYPE3_DESCKEY: "Only basic currencies supported in the current version",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "Whether to enable minimap depth display",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "Use depth map",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "Whether it follows the gravitational law",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "Gravitational or not",
  T_40_XXJ_WS_UUID_DESCKEY: "The unique identifier of a player",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "The value",
  T_40_XXJ_WS_VALUE_NAMEKEY: "Value",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "Value [0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "The first value",
  T_40_XXJ_WS_VALUE2_DESCKEY: "The second value",
  T_40_XXJ_WS_VALUE6_DESCKEY: "Value [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "The starting value",
  T_40_XXJ_WS_VALUEB_DESCKEY: "The target value",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "The name of the value to traverse. You can use this to obtain the value in a local variable.",
  T_40_XXJ_WS_VALUET_DESCKEY: "The interpolation progress. Lies in between 0 and 1.",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "Variable type",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "The vertical display type",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "Vertical display type",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "The level of an object's visibility",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "Visible layer",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "Outfits include bundle, head, mask, facepaint, top, bottom, and shoes",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "Outfit type",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "Outfit slot",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "Weapons",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "The weapon skin ID",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "Weapon skin ID",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "The ID of the weapon skin",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "The player's weapon skin",
  T_40_XXJ_WS_WIDGETTYPEENUM: "Component type enum",
  T_40_XXJ_WS_WIDTH_DESCKEY: "The width",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "Word Wrap",
  T_40_XXJ_WS_WRITELEADERBOARD: "Write Leaderboard Value",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "Write a corresponding value of a certain key on a certain leaderboard table in the database.",
  T_40_XYL_WS_BUMPERFACTORY: "Bumper Car Factory",
  T_40_XYL_WS_BURNDAMAGE: "Combustion Damage",
  T_40_XYL_WS_BURNINTERVAL: "Combustion Damage Interval (s)",
  T_40_XYL_WS_BURNTIME: "Combustion Time After Explosion",
  T_40_XYL_WS_COLORFULSKY: "Colorful Sky",
  T_40_XYL_WS_CRANEMACHINE: "Claw Crane",
  T_40_XYL_WS_CRASHMAXDAMAGE: "Maximum Crash Damage",
  T_40_XYL_WS_CRASHMAXSPEED: "Maximum Crash Damage Speed Limit",
  T_40_XYL_WS_CRASHMESS: "Mass Parameter During Crash",
  T_40_XYL_WS_CRASHMINDAMAGE: "Min. Crash Damage",
  T_40_XYL_WS_DISPLAYBOARD: "Billboard",
  T_40_XYL_WS_EXPLODEDAMAGE: "Explosion Damage",
  T_40_XYL_WS_EXPLODEDELAY: "Explosion Delay Time",
  T_40_XYL_WS_EXPLODERANGE: "Explosion Range",
  T_40_XYL_WS_FERRISWHEEL: "Ferris Wheel",
  T_40_XYL_WS_FOODTRUCK002: "Food Truck B",
  T_40_XYL_WS_GEARSHIFTDELAY: "Gear Changing Time (s)",
  T_40_XYL_WS_ICAROUSEL001: "Merry-Go-Round Component A",
  T_40_XYL_WS_ICAROUSEL002: "Merry-Go-Round Component B",
  T_40_XYL_WS_ICAROUSEL003: "Merry-Go-Round",
  T_40_XYL_WS_ICEDANCEDOOL: "Blue Doll",
  T_40_XYL_WS_IDLEBRAKEINPUT: "Uncontrolled Parking Horsepower Ratio",
  T_40_XYL_WS_LOLLIPOP: "Giant Lollipop",
  T_40_XYL_WS_NEWHOOKGUN: "Super Hook Gun",
  T_40_XYL_WS_OPENSWING: "Swing button",
  T_40_XYL_WS_OPENTRACTION: "Tow button",
  T_40_XYL_WS_PODIUM: "Podium",
  T_40_XYL_WS_SKYCITY: "City",
  T_40_XYL_WS_SKYSCRAPER_A001: "Skyscraper A Component A",
  T_40_XYL_WS_SKYSCRAPER_A002: "Skyscraper A Component B",
  T_40_XYL_WS_SKYSCRAPER_A003: "Skyscraper A Component C",
  T_40_XYL_WS_SKYSCRAPER_B001: "Skyscraper B Component A",
  T_40_XYL_WS_SKYSCRAPER_B002: "Skyscraper B Component B",
  T_40_XYL_WS_SKYSCRAPER_B003: "Skyscraper B Component C",
  T_40_XYL_WS_SKYSCRAPER_C001: "Skyscraper C Component A",
  T_40_XYL_WS_SKYSCRAPER_C002: "Skyscraper C Component B",
  T_40_XYL_WS_SKYSCRAPER_C003: "Skyscraper C Component C",
  T_40_XYL_WS_SKYSCRAPER_D001: "Skyscraper D Component A",
  T_40_XYL_WS_SKYSCRAPER_D002: "Skyscraper D Component B",
  T_40_XYL_WS_SKYSCRAPER_D003: "Skyscraper D Component C",
  T_40_XYL_WS_SKYSCRAPER_E001: "Skyscraper E Component A",
  T_40_XYL_WS_SKYSCRAPER_E002: "Skyscraper E Component B",
  T_40_XYL_WS_SKYSCRAPER_E003: "Skyscraper E Component C",
  T_40_XYL_WS_STEERANGLE: "High-speed Turning Radius",
  T_40_XYL_WS_STEERSPEED: "Maximum Speed During High-speed Turning",
  T_40_XYL_WS_SWINGSPEED: "Swing speed",
  T_40_XYL_WS_TARGETOBJECT: "Motion Anchor",
  T_40_XYL_WS_TRACTIONSPEED: "Tow speed",
  T_40_XYL_WS_TRIGGERCAPSULE: "Custom Capsule Trigger",
  T_40_XYL_WS_TRIGGERSPHERE: "Custom Sphere Trigger",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "Custom Object",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "An empty object component that can be used with the render component and collision component.",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "Custom Render Component",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "A custom rendering component, used for rendering with custom model resources.",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "Your enemy markings have bounty value. Anyone on ally team who eliminates a marked enemy will earn [FFB300]{0} in-match currency[-]. You will earn an extra [FFB300]100[-] for eliminating an enemy. Receive extra [FFB300]{1} FF Coins[-] from Coin Machines in BR matches.",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "Money Mark",
  T_41_CJ_A_ESPORTS_TH: "FFTC The Pro (Mask)",
  T_41_CJ_B_ESPORTS_TH: "FFTC The Pro (Bottom)",
  T_41_CJ_H_ESPORTS_TH: "FFTC The Pro (Head)",
  T_41_CJ_S_ESPORTS_TH: "FFTC The Pro (Shoes)",
  T_41_CJ_T_ESPORTS_TH: "FFTC The Pro (Top)",
  T_41_CJ_T_FFSI: "FFSI Champion Jersey",
  T_41_CJ_T_FOOTBALL_EU01: "Sunburst Jersey",
  T_41_CJ_T_FOOTBALL_EU02: "Bold Red Jersey",
  T_41_CJ_T_FOOTBALL_EU03: "Majestic Crown Jersey",
  T_41_CJ_T_FOOTBALL_EU04: "Regal Titan Jersey",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "Suzy",
  T_41_LXW_TabName_Items: "Item",
  T_41_R_CD_COIL: "Zone Shrink",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "Whether to activate this device",
  T_41_SJ_WS_SPECIALITEM_NAME: "Device",
  T_41_SW_SKILL_DESC_DELIVERY: "When hit by an enemy from within [FFB300]{0}m[-], said attacker is marked for [FFB300]{1}s[-] (intel is shared with teammates). Max. [FFB300]{2} markings[-].",
  T_41_SW_SKILL_DESC_GANGLEADER: "Get [FFB300]{0} extra Shield Points[-] at the start of the match. Recovers Shield Points after surviving combat.",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "When using an active skill, gives [FFB300]{1} Shield Points[-] to self and teammates within [FFB300]{0}m[-]. The Shield Points decay after [FFB300]{2}s[-], after which players can obtain the effects again. Cooldown: [FFB300]{3}s[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "Deployed Gloo Walls restore [FFB300]{0}[-] durability per second when hit, during which teammates within [FFB300]{1}m[-] restore [FFB300]{2} HP/s[-]. Max. [FFB300]{3} HP[-] per teammate from each Gloo Wall.",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "Pet Skin: Recollective Kactus",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "Pet Skin: Inked Falco",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "Type",
  T_41_WT_SKILL_DESC_FIREBOY: "Deploys a [FFB300]{1}m[-]-wide flaming screen that lasts [FFB300]{0}s[-] and moves forward at [FFB300]{2}m/s[-] for up to [FFB300]{3}s[-]. While in effect, use the skill again to stop the screen. [FFB300]Enemies (or Gloo Walls)[-] that get in touch with it will instantly take [FFB300]{4} (or {5}) DMG[-], and then take [FFB300]{6} (or {7}) DMG/s[-]. Lasts [FFB300]{8}s[-]. Cooldown: [FFB300]{9}s[-]. Up to [FFB300]{10}[-] skill uses can be stored, with a [FFB300]{11}s[-] cooldown between each use.",
  T_41_WT_SKILL_NAME_FIREBOY: "Flame Mirage",
  T_41_WZY_WS_CHARGEMAX: "Max. Gloo Maker charge",
  T_41_WZY_WS_CROSSBOWNAME: "Crossbow",
  T_41_WZY_WS_DECELERATIONRATIO: "Deceleration % in water",
  T_41_WZY_WS_DEICEWALLPARAM1: "Radius of melt area",
  T_41_WZY_WS_DEICEWALLPARAM2: "Duration of melt",
  T_41_WZY_WS_EXPPERCHIP: "EXP from Gloo Chip",
  T_41_WZY_WS_EXPPERDAMAGE: "EXP from dealing DMG",
  T_41_WZY_WS_EXPPERMOVEMILE: "EXP from each meter traveled",
  T_41_WZY_WS_EXPPERSECOND: "EXP per second",
  T_41_WZY_WS_GRENADEEXPTIME: "Explosion delay",
  T_41_WZY_WS_GRENADELAUNCHNAME: "Explosives",
  T_41_WZY_WS_GRENADEMAX: "Maximum DMG",
  T_41_WZY_WS_GRENADEMIN: "Minimum DMG",
  T_41_WZY_WS_GRENADERANGE: "Explosion range",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "DMG coefficient on vehicles",
  T_41_WZY_WS_GRENADERATIOSELF: "DMG coefficient on self",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "DMG coefficient on teammates",
  T_41_WZY_WS_GRENADTHROWSPEED: "Explosive travel speed",
  T_41_WZY_WS_HANDCANNONNAME: "Hand Cannon",
  T_41_XXJ_WS_ACCELERATION: "Acceleration",
  T_41_XXJ_WS_ACCELERATION_D: "Create a designated acceleration effect",
  T_41_XXJ_WS_ACTION: "Action node",
  T_41_XXJ_WS_ACTION_D: "Action Pivot",
  T_41_XXJ_WS_ADDHP: "Healing Items",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "Add max. HP",
  T_41_XXJ_WS_AICASTSKILL_D: "AI release skill",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "Aim assist center offset",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "Aim assist distance",
  T_41_XXJ_WS_AIMASSISTENTITY: "Aim assist entity",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "Entity that can be aim assisted",
  T_41_XXJ_WS_AISKILLTYPE: "Zombie skill type",
  T_41_XXJ_WS_AISKILLTYPE_D: "Zombie skill type",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "All items",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "All items",
  T_41_XXJ_WS_AMMOCLIPSIZE: "Modify magazine size",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "Bullets in the magazine",
  T_41_XXJ_WS_ANCHORPOSITION_D: "The anchor coordinates in relation to the parent",
  T_41_XXJ_WS_ANGLE_D: "The z axis rotation angle",
  T_41_XXJ_WS_ANGULARDRAG: "Angular drag",
  T_41_XXJ_WS_ANGULARVELOCITY: "Angular velocity",
  T_41_XXJ_WS_ANIMATIONCLIP: "Animation state",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "Animation Controller",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "Animation entity",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "The file and resource used to manage the animation controller",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "Animation controller resource UUID",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "Loop type enum",
  T_41_XXJ_WS_ANIMATIONSTATE: "Animation state",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "Operation, where all types of value assignment are supported, and digital types also support self-increment, self-subtraction, self-multiplication, and self-division",
  T_41_XXJ_WS_ATTACHMENT: "Attachment",
  T_41_XXJ_WS_ATTACHMENT_D: "Attachment",
  T_41_XXJ_WS_ATTACHTARGET: "Linked entity",
  T_41_XXJ_WS_BAG: "Backpack",
  T_41_XXJ_WS_BAG_D: "Backpack Component",
  T_41_XXJ_WS_BANNERID: "Banner ID",
  T_41_XXJ_WS_BANNERID_D: "Banner ID",
  T_41_XXJ_WS_BEHAVIOURTREE: "Behavior tree",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "Behavior Tree",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "Behavior-mountable tree entity",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "A behavior tree entity that can be mounted",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "Behavior tree custom node",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "Behavior Tree Custom Pivot",
  T_41_XXJ_WS_BODY: "Body",
  T_41_XXJ_WS_BORDERLR: "Border (left & right)",
  T_41_XXJ_WS_BORDERLR_D: "The left and right border",
  T_41_XXJ_WS_BORDERTB: "Border (top & bottom)",
  T_41_XXJ_WS_BORDERTB_D: "The top and bottom border",
  T_41_XXJ_WS_BRPEAKRANK: "Highest BR rank",
  T_41_XXJ_WS_BRPEAKRANK_D: "Highest BR rank",
  T_41_XXJ_WS_BRRANK: "BR rank",
  T_41_XXJ_WS_BRRANK_D: "BR Rank",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "Behavior tree node type",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "Behavior Tree Pivot Type",
  T_41_XXJ_WS_BTREE: "Behavior tree",
  T_41_XXJ_WS_BTREENODESTATE: "Behavior tree node state",
  T_41_XXJ_WS_BTREENODESTATE_D: "Behavior Tree Pivot Operating Status",
  T_41_XXJ_WS_BUFFABLEENTITY: "Buff-enabled entity",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "Enables adding buffs, removing buffs, and getting added buff lists",
  T_41_XXJ_WS_BUILDINGICEWALL: "Gloo Wall",
  T_41_XXJ_WS_CAMOUFLAGE: "Functional items",
  T_41_XXJ_WS_CAMOUFLAGE_D: "Skyboard, Camouflage...",
  T_41_XXJ_WS_CAPICITY_D: "Initial Capacity",
  T_41_XXJ_WS_CENTERINVISIBLE: "Invisible to center",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "Not visible to center",
  T_41_XXJ_WS_COLOR: "Color",
  T_41_XXJ_WS_COLOR_D: "The color",
  T_41_XXJ_WS_CONDITION: "Condition node",
  T_41_XXJ_WS_CONDITION_D: "Conditions are a special Boolean type",
  T_41_XXJ_WS_CONDITION1_D: "Condition Pivot",
  T_41_XXJ_WS_CONSTRAIN: "RigidBody constraint",
  T_41_XXJ_WS_CONSTRAIN_D: "Add constraints to the RigidBody. This is a compilation of RigidBody Constraint Type.",
  T_41_XXJ_WS_COUNT_D: "Amount",
  T_41_XXJ_WS_CROSSBOW_D: "Crossbow",
  T_41_XXJ_WS_CSPEAKRANK: "Highest CS rank",
  T_41_XXJ_WS_CSPEAKRANK_D: "Highest CS rank",
  T_41_XXJ_WS_CSRANK: "CS rank",
  T_41_XXJ_WS_CSRANK_D: "CS Rank",
  T_41_XXJ_WS_CSVNAME_D: "The csv file under SceneData that corresponds to the mode. Ends in .csv. Headers are written in lower case letters.",
  T_41_XXJ_WS_CURCAPACITY: "Used capacity",
  T_41_XXJ_WS_CURPROGRESS: "Current progress",
  T_41_XXJ_WS_CURRENTCLIP: "Current clip",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "Current clip progress",
  T_41_XXJ_WS_CURRENTSTATE: "Current state",
  T_41_XXJ_WS_CUSTOMHUDID: "Custom HUD ID",
  T_41_XXJ_WS_CUSTOMHUDID_D: "The ID used to describe a custom HUD asset",
  T_41_XXJ_WS_DASHATTACK: "Dash attack",
  T_41_XXJ_WS_DEBUG: "Start debugging",
  T_41_XXJ_WS_DEBUG_D: "Fix",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "Deceleration %: The deceleration when an object is in the water (range temporarily set as 0-100)",
  T_41_XXJ_WS_DEPTH_D: "The depth",
  T_41_XXJ_WS_DRAG: "Drag coefficient",
  T_41_XXJ_WS_DRAG_D: "The larger the coefficient, the faster the movement speed deceleration",
  T_41_XXJ_WS_DUMMY: "Dummy",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "Enable low-graphics mode",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "When low fps is on, the game will run on 15 fps; or else 30 fps",
  T_41_XXJ_WS_ENTITYLIST: "Return entity list created",
  T_41_XXJ_WS_ENTITYNAME: "Object name",
  T_41_XXJ_WS_ENTITYNAME_D: "The object name customized by the player",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "Logical Entity or Prefab ID",
  T_41_XXJ_WS_EQUIPANDBAG: "Armor and Backpack",
  T_41_XXJ_WS_EQUIPMENTSLOT: "Equipment slot enum",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "Equipment Slot Enum",
  T_41_XXJ_WS_EXPLODE: "Self-explode",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "Explosive Weapon",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "Auto reload speed",
  T_41_XXJ_WS_FILEID: "Internal ID",
  T_41_XXJ_WS_FILEID_D: "The internal ID of the control in the prefab",
  T_41_XXJ_WS_FILLAMOUNT: "Fill amount",
  T_41_XXJ_WS_FILLAMOUNT_D: "The fill value",
  T_41_XXJ_WS_FILLDIR: "Fill direction",
  T_41_XXJ_WS_FILLDIR_D: "The direction of the fill",
  T_41_XXJ_WS_FILLDIR_D1: "Fill direction enum",
  T_41_XXJ_WS_FILLTYPE: "Fill type",
  T_41_XXJ_WS_FILLTYPE_D: "The fill type",
  T_41_XXJ_WS_FILLTYPE_D1: "Fill type enum",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "Find path",
  T_41_XXJ_WS_FINISH: "Complete",
  T_41_XXJ_WS_FIREINTERVAL: "Firing interval",
  T_41_XXJ_WS_FIREINTERVAL_D: "Attack Interval",
  T_41_XXJ_WS_FLIP: "Flip method",
  T_41_XXJ_WS_FLIP_D: "The flip method",
  T_41_XXJ_WS_FLYBOMBBEE: "Flying Zombie",
  T_41_XXJ_WS_FORCE: "Force",
  T_41_XXJ_WS_FORCE_D: "Create a force of a designated intensity",
  T_41_XXJ_WS_FORCETYPE: "Force type",
  T_41_XXJ_WS_FORCETYPE_D: "The different types of forces on the RigidBody. P.S. Only effective on dynamic RigidBody types.",
  T_41_XXJ_WS_FREEZEALL: "Freeze movement and rotation",
  T_41_XXJ_WS_FREEZEPOSITION: "Freeze linear movement",
  T_41_XXJ_WS_FREEZEPOSITIONX: "Freeze x axis",
  T_41_XXJ_WS_FREEZEPOSITIONY: "Freeze y axis",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "Freeze z axis",
  T_41_XXJ_WS_FREEZEROTATION: "Freeze all rotation",
  T_41_XXJ_WS_FREEZEROTATIONX: "Freeze x rotation",
  T_41_XXJ_WS_FREEZEROTATIONY: "Freeze y rotation",
  T_41_XXJ_WS_FREEZEROTATIONZ: "Freeze z rotation",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "Distance for max. damage",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "Distance for max. damage",
  T_41_XXJ_WS_GAMEID_D: "Mission ID",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "Give a Metropolis item",
  T_41_XXJ_WS_GRADIENT: "Gradient",
  T_41_XXJ_WS_GRADIENT_D: "The gradient",
  T_41_XXJ_WS_GRADIENTBOTTOM: "Gradient at bottom",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "The gradient at the bottom",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "Transparency at bottom",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "Bottom Transparency",
  T_41_XXJ_WS_GRADIENTTOP: "Gradient at top",
  T_41_XXJ_WS_GRADIENTTOP_D: "The gradient at the top",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "Transparency at top",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "Top Transparency",
  T_41_XXJ_WS_GRAPHID: "Script ID",
  T_41_XXJ_WS_GRAPHID_D: "The ID used to describe a script asset",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "Gloo Melter Component",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "Explosion Delay",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "Throwable",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "Max. DMG",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "Min. DMG",
  T_41_XXJ_WS_GRENADERANGE_D: "Explosion Range",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "Self DMG multiplier",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "Ally DMG multiplier",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "Vehicle DMG multiplier",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "Throwing Speed",
  T_41_XXJ_WS_GRENADEWEAPON: "Throwable category",
  T_41_XXJ_WS_GRENADEWEAPON_D: "Basic Throwable Types",
  T_41_XXJ_WS_HANDCANNON_D: "Throwables",
  T_41_XXJ_WS_HEAD: "Head",
  T_41_XXJ_WS_HEADID: "Avatar ID",
  T_41_XXJ_WS_HEADID_D: "Avatar ID",
  T_41_XXJ_WS_HEAVYWEAPON_D: "Heavy Weapon",
  T_41_XXJ_WS_HELMET_D: "The current helmet",
  T_41_XXJ_WS_HELMET1_D: "Helmet",
  T_41_XXJ_WS_HELMET2_D: "Helmet Entity",
  T_41_XXJ_WS_HITBODYPART_D: "The body part that is hit",
  T_41_XXJ_WS_HITBPDYPART: "Hit body part",
  T_41_XXJ_WS_HITENTITY_D: "Hit Entity",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "The HUD entity it belongs to",
  T_41_XXJ_WS_HUD3DCONTAINER: "3D content container",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "The HUD 3D container entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDGRID: "Custom Layout(Panel) control",
  T_41_XXJ_WS_HUDLAYOUT: "Layout control",
  T_41_XXJ_WS_HUDLAYOUT_D: "The HUD insertion entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDPROFILEINFO: "Custom avatar control",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "The HUD profile info entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDTEXTURE: "Texture control",
  T_41_XXJ_WS_HUDTEXTURE_D: "The HUD texture entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDTRANSFORM: "UITransform control component",
  T_41_XXJ_WS_HUDTRANSFORM_D: "The UITransform control entity",
  T_41_XXJ_WS_IMPULSE: "Strike",
  T_41_XXJ_WS_IMPULSE_D: "Create a strike of a designated intensity",
  T_41_XXJ_WS_INITIALWORLDPOS: "Initial world coordinates",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "Buff enum",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "Corresponds to the ID column in the BuffData.csv. Before adding new content, please first check compatability with GPP.",
  T_41_XXJ_WS_INVERTFILL: "Invert fill",
  T_41_XXJ_WS_INVERTFILL_D: "Invert the fill",
  T_41_XXJ_WS_ISLOOP: "Is loop",
  T_41_XXJ_WS_ISLOOP_D: "Whether or not to loop. Default is false.",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "Static NavMesh generation",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "Only used to check for static NavMesh generation when static loading objects",
  T_41_XXJ_WS_ISSUCCESS_D: "Destructed or not",
  T_41_XXJ_WS_ITEMENTITY_D: "Item Entity",
  T_41_XXJ_WS_ITEMID: "Item ID",
  T_41_XXJ_WS_ITEMID_D: "Item ID",
  T_41_XXJ_WS_ITEMID_D1: "The corresponding item ID of the attachment",
  T_41_XXJ_WS_ITEMLIST: "Item list",
  T_41_XXJ_WS_ITEMTYPE_D: "Item Type",
  T_41_XXJ_WS_JUMPATTACK: "Jump attack",
  T_41_XXJ_WS_LANDMINE: "Landmine",
  T_41_XXJ_WS_LENGTH: "Clip length",
  T_41_XXJ_WS_LENGTH_D: "The length of the progress bar. The default value is the length on the prefab UI.",
  T_41_XXJ_WS_LIMB: "Limbs",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "Failed to add element since list length has exceeded capacity",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "Buff list",
  T_41_XXJ_WS_LOOP: "Loop",
  T_41_XXJ_WS_LOOP_D: "Loop",
  T_41_XXJ_WS_MAXCAPACITY: "Capacity",
  T_41_XXJ_WS_MAXCAPACITY_D: "The backpack capacity",
  T_41_XXJ_WS_MAXPROGRESS: "Max. progress",
  T_41_XXJ_WS_MELEEWEAPON_D: "Melee Weapon",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "Distance for min. damage",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "Distance for min. damage",
  T_41_XXJ_WS_MINISENTRY: "Auto Turret",
  T_41_XXJ_WS_NAME: "Name",
  T_41_XXJ_WS_NAME_D: "The name of the skill button. Used for parameter sending during OnClick incidents, so uniqueness must be guaranteed.",
  T_41_XXJ_WS_NAME1_D: "Merchandise Name",
  T_41_XXJ_WS_NAME2_D: "Merchandise List Name",
  T_41_XXJ_WS_NAME3_D: "Vending Machine Name",
  T_41_XXJ_WS_NICKNAME: "Nickname",
  T_41_XXJ_WS_NICKNAME_D: "Player Name",
  T_41_XXJ_WS_NOCHANGE: "No changes",
  T_41_XXJ_WS_NONE: "No constraints",
  T_41_XXJ_WS_NONE1: "None",
  T_41_XXJ_WS_OFFSET: "Offset",
  T_41_XXJ_WS_OFFSET_D: "Offset",
  T_41_XXJ_WS_OFFSET1_D: "Written Offset Value",
  T_41_XXJ_WS_ONCE: "Once",
  T_41_XXJ_WS_ONCE_D: "Once",
  T_41_XXJ_WS_ONHIDE: "When interface is closed",
  T_41_XXJ_WS_ONHIDE_D: "When the interface is closed",
  T_41_XXJ_WS_ONNODEENTER_D: "When the pivot is entering",
  T_41_XXJ_WS_ONSHOW: "When interface is open",
  T_41_XXJ_WS_ONSHOW_D: "When the interface is open",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "Triggers when the text box has changed",
  T_41_XXJ_WS_PERSONALUAV: "UAV-Lite",
  T_41_XXJ_WS_PINID: "Pin ID",
  T_41_XXJ_WS_PINID_D: "Pin ID",
  T_41_XXJ_WS_PLAYERBAG: "Player backpack entity",
  T_41_XXJ_WS_PLAYERBAG_D: "The player's backpack entity",
  T_41_XXJ_WS_PLAYERBAGENTITY: "Player backpack",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "Player's backpack",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "Modified coefficient of speed while scoped in",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "Impact of movement speed while firing",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "Impact of movement speed while firing",
  T_41_XXJ_WS_PREFABID: "Prefab ID",
  T_41_XXJ_WS_PREFABID_D: "The ID used to describe a prefab asset",
  T_41_XXJ_WS_PREFABID1_D: "The HUD template entity that this ID represents",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "Main Weapon 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "Main Weapon 2",
  T_41_XXJ_WS_PROFILEINFO: "Player profile",
  T_41_XXJ_WS_PROFILEINFO_D: "Player bio",
  T_41_XXJ_WS_PROGRESSICON_D: "The progress icon",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "Progress icon name",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "Quit the Metropolis minigame",
  T_41_XXJ_WS_RANGE: "Firing range",
  T_41_XXJ_WS_RANGE_D: "Attack Range",
  T_41_XXJ_WS_RANGE_D1: "Explosion Range",
  T_41_XXJ_WS_RANGE_D2: "Turret Range",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "Read the content on the entire table. Return a two-dimensional array.",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "Read the content of a certain cell",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "Read a certain column's content. Returns an array.",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "Read a certain row's content. Returns an array.",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "Read accumulated database",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "Read the value corresponding to a key in a table in the accumulated database",
  T_41_XXJ_WS_RECOVERPLAYERHP: "Continuously recover HP",
  T_41_XXJ_WS_RELOADSPEED: "Reload speed",
  T_41_XXJ_WS_RELOADSPEED_D: "Reload Speed (Basic Speed x Multiplier)",
  T_41_XXJ_WS_RESOURCEID: "Resource UUID",
  T_41_XXJ_WS_RESOURCEID_D: "Resource UUID",
  T_41_XXJ_WS_RESUUID: "Resource ID",
  T_41_XXJ_WS_RESUUID_D: "The designated resource UUID to render",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "RigidBody constraint type",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "Each constraint is defined by a bit marking and can be used as a combination",
  T_41_XXJ_WS_ROTATION: "Rotation",
  T_41_XXJ_WS_ROTATION_D: "The rotation angle in the world coordinates. x, y, z refers to the yaw, pitch, and roll, respectively.",
  T_41_XXJ_WS_ROTATION1_D: "The rotation",
  T_41_XXJ_WS_RUNNING: "Running",
  T_41_XXJ_WS_SCALE: "Scale",
  T_41_XXJ_WS_SCALE_D: "Scale",
  T_41_XXJ_WS_SCALE1_D: "Scales along a certain axis. Can be a combination of three axes.",
  T_41_XXJ_WS_SCATTERMAX: "Max. bullet scatter",
  T_41_XXJ_WS_SCATTERMAX_D: "The value at which bullet spread begins",
  T_41_XXJ_WS_SCATTERMOVE1: "Spread size when moving",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "Speed of spread recovery",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "Speed of spread recovery",
  T_41_XXJ_WS_SCATTERSPEED: "Speed of spread increase",
  T_41_XXJ_WS_SCATTERSPEED_D: "Speed of spread increase (0.1 = The crosshair enlarges 10% for every one burst increase)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "Less spread on prone and crouch",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "Secondary Weapon",
  T_41_XXJ_WS_SHADERNAME: "Shader name",
  T_41_XXJ_WS_SHADERNAME_D: "The shader name",
  T_41_XXJ_WS_SHIELDBROKEN: "Shield-shatter attack",
  T_41_XXJ_WS_SHIELDUP: "Shield attack",
  T_41_XXJ_WS_SHOCKWAVE: "Shockwave",
  T_41_XXJ_WS_SHOWNAME: "Display nickname",
  T_41_XXJ_WS_SHOWNAME_D: "Display Nickname",
  T_41_XXJ_WS_SHOWPIN: "Display pin",
  T_41_XXJ_WS_SHOWPIN_D: "Display Pin",
  T_41_XXJ_WS_SHOWRANK: "Display rank",
  T_41_XXJ_WS_SHOWRANK_D: "Display Rank",
  T_41_XXJ_WS_SHOWTYPE: "Design",
  T_41_XXJ_WS_SHOWTYPE_D: "Type",
  T_41_XXJ_WS_SHRINKSPEED: "Shrink speed",
  T_41_XXJ_WS_SIGHTAIMASSIST: "Enable aim assist on scope",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "Aim assist crosshair sensitivity with distance (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "Coefficient when prioritizing distance for aim assist (≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "Max. distance to prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "Min. distance to prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "Prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "Aim assist crosshair sensitivity (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "Scope zoom in factor",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "FOV zoom in factor",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "Scope rotation sensitivity coefficient",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "Modified coefficient x of min. scoped in DMG",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "Scoped in firing UI zoom in time (s)",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "Scoped in firing UI zoom in factor",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "Scoped in firing UI resume time (s)",
  T_41_XXJ_WS_SPEED: "Playback speed",
  T_41_XXJ_WS_SPEEQUIP: "Functional equipment",
  T_41_XXJ_WS_SPEITEM: "Devices",
  T_41_XXJ_WS_STATICGRAPHID: "Static script ID",
  T_41_XXJ_WS_STATICGRAPHID_D: "The ID used to describe a static script asset",
  T_41_XXJ_WS_STATICWAINING: "Failed to modify static Rigidbody type",
  T_41_XXJ_WS_TARGETTREE: "Behavior tree entity",
  T_41_XXJ_WS_TARGETTREE_D: "The behavior tree entity",
  T_41_XXJ_WS_TEAMINDEX: "Team serial no.",
  T_41_XXJ_WS_TEAMINDEX_D: "The team index, which coincides with the team index in the room",
  T_41_XXJ_WS_TEAMINDEX_D1: "Team Faction Number",
  T_41_XXJ_WS_TEMPLATEPREFABID: "Template prefab ID",
  T_41_XXJ_WS_TEXT_D: "Content",
  T_41_XXJ_WS_TEXTURENAME: "Texture name",
  T_41_XXJ_WS_TEXTURENAME_D: "The texture name",
  T_41_XXJ_WS_THROWATTACK: "Grenade",
  T_41_XXJ_WS_TICKINTERVAL: "Refresh interval",
  T_41_XXJ_WS_TICKINTERVAL_D: "Refresh interval. The larger the number, the longer the refresh takes.",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "Enable special devices in the player's backpack",
  T_41_XXJ_WS_UVRECTWH: "UV width & height",
  T_41_XXJ_WS_UVRECTWH_D: "The UV width and height",
  T_41_XXJ_WS_UVRECTXY: "UV offset",
  T_41_XXJ_WS_UVRECTXY_D: "The UV offset",
  T_41_XXJ_WS_VELOCITY: "Velocity",
  T_41_XXJ_WS_VELOCITY_D: "Refrain from directly changing the RigidBody's speed. You may change it using related APIs.",
  T_41_XXJ_WS_VEST_D: "The current vest",
  T_41_XXJ_WS_VEST1_D: "Vest",
  T_41_XXJ_WS_WIDGETID: "Control ID",
  T_41_XXJ_WS_WIDGETID_D: "The ID used to describe a control in the interface assets. It must be paired with a custom HUD ID in order to ensure that it corresponds to a unique control ID.",
  T_41_XXJ_WS_WINDATTACK: "Tornado attack",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "Write accumulated database offset",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "Write the offset corresponding to a key in a table in the accumulated database",
  T_41_XXJ_WS_ZONEDURATION_D: "Freeze duration",
  T_41_XXJ_WS_ZONEDURATION1_D: "Gloo Melter Duration",
  T_41_XXJ_WS_ZONERADIUS_D: "Freeze zone radius",
  T_41_XXJ_WS_ZONERADIUS1_D: "Gloo Melter Radius",
  T_41_XYL_WS_BOT12: "Earth Driller",
  T_41_XYL_WS_BOT9: "Mutated Tossing Zombie",
  T_41_XYL_WS_ITEM262: "Frozen Steel Panel A",
  T_41_XYL_WS_ITEM263: "Frozen Container A",
  T_41_XYL_WS_ITEM264: "Frozen Supply Container",
  T_41_XYL_WS_ITEM265: "Frozen Metal Gate",
  T_41_XYL_WS_ITEM266: "Frozen Container B",
  T_41_XYL_WS_ITEM267: "Frozen Stone A",
  T_41_XYL_WS_ITEM268: "Frozen Stone B",
  T_41_XYL_WS_ITEM269: "Frozen Stone C",
  T_41_XYL_WS_ITEM270: "Frozen Stone D",
  T_41_XYL_WS_ITEM271: "Abandoned Subway Car",
  T_41_XYL_WS_MODELMATCHNAME: "Contest Canvas",
  T_41_XYL_WS_NAVMESH: "Dynamic navmesh",
  T_41_XYL_WS_REFCUBE: "Reflective Cube",
  T_41_XYL_WS_SNOWSKY: "Frost Galaxy",
  T_41_XYL_WS_TOYCUBE: "Play Cube",
  T_42_CJ_F_B_VOCATIONAL: "Gearing Blueprint (Bottom)",
  T_42_CJ_F_H_VOCATIONAL: "Gearing Blueprint (Head)",
  T_42_CJ_F_S_VOCATIONAL: "Gearing Blueprint (Shoes)",
  T_42_CJ_F_T_VOCATIONAL: "Gearing Blueprint (Top)",
  T_42_CJ_HA_THUNDER_GOLD: "Lightning Facepaint",
  T_42_CJ_M_B_VOCATIONAL: "Mechanic Masterplan (Bottom)",
  T_42_CJ_M_H_VOCATIONAL: "Mechanic Masterplan (Head)",
  T_42_CJ_M_S_VOCATIONAL: "Mechanic Masterplan (Shoes)",
  T_42_CJ_M_T_VOCATIONAL: "Mechanic Masterplan (Top)",
  T_42_H_CHARACTER_SUPERTEEN_N: "Ignis",
  T_42_H_GLOO_EVOTIGER_N: "Gloo Wall - Tiger's Fury",
  T_42_H_GRENADE_SMUDGE_N: "Grenade - Feline Shadow",
  T_42_H_M1917_EMPIRE_N: "M1917 - Crowned Conqueror",
  T_42_HJ_WS_VFX_INK: "Ink",
  T_42_JH_WS_BANMATCHMAKING: "Matchmaking not allowed for this map",
  T_42_JH_WS_BANROOMCREATE: "Unable to create a room",
  T_42_JH_WS_FPS: "FPS",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "Party Remix (Alok)",
  T_42_JH_WS_SKILLSETFIREWALL: "Wall of Flame (Ignis)",
  T_42_JH_WS_SKILLSETSANTINO: "Shape Splitter (Santino)",
  T_42_JH_WS_SKILLSETSONIA: "Nano Lifeshield (Sonia)",
  T_42_JH_WS_TAG1: "Frost Brawl",
  T_42_JH_WS_TAG10: "Infinity Racer",
  T_42_JH_WS_TAG11: "Race Rush",
  T_42_JH_WS_TAG12: "Car Racing",
  T_42_JH_WS_TAG13: "Exclude from Popular",
  T_42_JH_WS_TAG14: "Frontline",
  T_42_JH_WS_TAG15: "Zombie War",
  T_42_JH_WS_TAG16: "Legacy Legend",
  T_42_JH_WS_TAG2: "Social Island 1.0",
  T_42_JH_WS_TAG3: "Social Island 2.0",
  T_42_JH_WS_TAG4: "Play Together",
  T_42_JH_WS_TAG5: "Ruin Survivor",
  T_42_JH_WS_TAG6: "Preying Party",
  T_42_JH_WS_TAG7: "Preying Party",
  T_42_JH_WS_TAG8: "Fort Feud 2.0",
  T_42_JH_WS_TAG9: "Bounty Hunting",
  T_42_RW_PORTALSFORPERSONAL_DESC: "Place a portal anywhere and teleport away!",
  T_42_RW_PORTALSPERSONAL_NAME: "Portal Go",
  T_42_SJ_WS_ACCESSORIESITEM: "Equip attachment",
  T_42_SJ_WS_AUTOPLAY: "Auto play",
  T_42_SJ_WS_CLIMB: "Climb over",
  T_42_SJ_WS_CLOCK_EVENTS: "Event compilation",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "Countdown or not",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "Loops",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "Pause event",
  T_42_SJ_WS_CLOCK_START_EVENT: "Start event",
  T_42_SJ_WS_CLOCK_START_TIME: "Countdown start time",
  T_42_SJ_WS_CLOCK_STATE: "Stopwatch status",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "Stop event",
  T_42_SJ_WS_DAMRATIOHEAD: "Headshot DMG coefficient change",
  T_42_SJ_WS_DAMRATIOLIMB: "Limb DMG coefficient change",
  T_42_SJ_WS_DAMREDUCEXPLODE: "Reduction coefficient from explosive DMG",
  T_42_SJ_WS_DRIVE: "Drive",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "Display layers",
  T_42_SJ_WS_EXTRABAGCAPACITY: "Extra backpack capacity",
  T_42_SJ_WS_EXTRAHPRATIO: "HP ratio",
  T_42_SJ_WS_GETOFF_DRIVE: "Exit vehicle",
  T_42_SJ_WS_GETON_DRIVE: "Enter vehicle",
  T_42_SJ_WS_KNIFEITEM: "Dagger",
  T_42_SJ_WS_KNIFEITEMPICK: "Dagger (ground loot)",
  T_42_SJ_WS_MARKBTNHUD: "The pin button on the HUD",
  T_42_SJ_WS_MARKBTNHUD_D: "You can enable or disable the pin button",
  T_42_SJ_WS_MAXDISTANCE: "Max. distance",
  T_42_SJ_WS_MAXDURARATIO: "Max. durability ratio",
  T_42_SJ_WS_MICBTNHUD: "The mic switch on the HUD",
  T_42_SJ_WS_MICBTNHUD_D: "You can enable or disable the mic button",
  T_42_SJ_WS_MINDISTANCE: "Min. distance",
  T_42_SJ_WS_OPE_VEHICLE: "Operate vehicle",
  T_42_SJ_WS_PLANE_DESC: "A basic mesh whose size can be freely adjusted",
  T_42_SJ_WS_PLANENAME: "Basic Plane",
  T_42_SJ_WS_PRIORITY: "Priority",
  T_42_SJ_WS_REPLACEPRIORITY: "Replace priority",
  T_42_SJ_WS_SETBTNHUD: "The settings button on the HUD",
  T_42_SJ_WS_SETBTNHUD_D: "You can enable or disable the settings button",
  T_42_SJ_WS_SIGNALBTNHUD: "The network connection button on the HUD",
  T_42_SJ_WS_SIGNALBTNHUD_D: "You can enable or disable the network connection button",
  T_42_SJ_WS_SPEAKERBTNHUD: "The horn button on the HUD",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "You can enable or disable the vehicle horn button",
  T_42_SJ_WS_START_TIME: "Start time (s)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "Get an additional [FFB300]{0}[-] backpack capacity for ammo, excluding Grenade Launcher. ([FFB300]{1}[-] AR Ammo, [FFB300]{2}[-] SMG Ammo, [FFB300]{3}[-] Sniper Ammo, [FFB300]{4}[-] SG Ammo)",
  T_42_SW_SKILL_DESC_Bodyguard: "Reload speed increases by [FFB300]{0}%[-]. Every time the skill user hits an enemy, said target will get a [FFB300]{1}%[-] healing deduction that lasts for [FFB300]{3}s[-] (max. deduction: [FFB300]{2}%[-]).",
  T_42_SW_SKILL_DESC_Playboy: "Become immune from disruptive effects (e.g. slowdown, marking, skill-silencing) and have a [FFB300]{1}%[-] movement speed boost for [FFB300]{2}s[-]. Cooldown: [FFB300]{0}s[-].",
  T_42_SW_SKILL_DESC_SwatGuy: "After knocking down an enemy or using an active skill, [FFB300]{0}%[-] of the gun's magazine reloads automatically.",
  T_42_SW_SKILL_NAME_Playboy: "Silver Spoon",
  T_42_SY_BACKPACK_EMPIRE_N: "Backpack - Crowned Roar",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "Pet Skin: Icy Hop",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "Motorbike - Urban Scooter",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Aventador Ultimae Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Aventador Ultimae Grigio Nimbus",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "Veneno Nero Nemesis",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "Veneno Rosso Efesto",
  T_42_TYC_CST_LOSE_MONEY_1: "Amount of CS Cash obtained after losing a round",
  T_42_TYC_CST_LOSE_MONEY_2: "Amount of CS Cash obtained upon a 2-round losing streak",
  T_42_TYC_CST_LOSE_MONEY_3: "Amount of CS Cash obtained upon a 3-round losing streak",
  T_42_WH_ITEM_HEALUAV: "Heal UAV-Lite",
  T_42_WH_ITEM_HEALUAV_DESC: "Deploys a UAV-Lite that flies forward and continuously heals teammates within the range below",
  T_42_WH_ITEM_SKILLCARD: "Skill: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `Use to release the active skill of [ffba00]{0}[-]: [ffba00]{1}[-].
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "Ammo Type",
  T_42_XXJ_WS_AMMOTYPE_D: "Ammo Type",
  T_42_XXJ_WS_ASSETCONFIGID: "Skin ID",
  T_42_XXJ_WS_ASSETCONFIGID_D: "Skin",
  T_42_XXJ_WS_ATTACKSTATUS: "Attack status",
  T_42_XXJ_WS_AUTOPLAY: "Auto play",
  T_42_XXJ_WS_AUTOPLAY_D: "Auto play",
  T_42_XXJ_WS_AVATARABLE: "Modifiable appearance component",
  T_42_XXJ_WS_AVATARABLE_D: "Change appearance according to the parts",
  T_42_XXJ_WS_AVATARRESUUID: "Appearance resource UUID",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "Convert the axis-angle representation of a rotation into Quaternions",
  T_42_XXJ_WS_B_D: "The B color value",
  T_42_XXJ_WS_BASEVALUE_D: "Base of logarithm",
  T_42_XXJ_WS_BEZIERCURVE: "Bézier curve",
  T_42_XXJ_WS_BEZIERCURVE_D: "The Bézier curve",
  T_42_XXJ_WS_BOTDIFFICULTY: "Bot Difficulty",
  T_42_XXJ_WS_BOUNCE_COMBINE: "Combination Method of Bounciness",
  T_42_XXJ_WS_BOUNCINES: "Bounciness",
  T_42_XXJ_WS_BTREEID: "Behavior tree ID",
  T_42_XXJ_WS_BTREEID_D: "Behavior tree ID",
  T_42_XXJ_WS_CANPURCHAS: "Purchasable or Not",
  T_42_XXJ_WS_CANPURCHAS_D: "Purchasable or not",
  T_42_XXJ_WS_CLIMBSTATUS: "Climbing behavior",
  T_42_XXJ_WS_CLOCK: "Timer Object",
  T_42_XXJ_WS_CLOCK_D: "Timer Object",
  T_42_XXJ_WS_CLOCK_D1: "Timer",
  T_42_XXJ_WS_CONTAINER: "Container",
  T_42_XXJ_WS_CONTROLPOINTS: "Control points",
  T_42_XXJ_WS_CONTROLPOINTS_D: "The control points",
  T_42_XXJ_WS_COROUTINEID: "Coroutine handle",
  T_42_XXJ_WS_COROUTINEID_D: "The Coroutine ID refers to the handle of a specific coroutine. It allows for various operations to be performed on the handle.",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "Create a self-relative",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "Create a self-relative",
  T_42_XXJ_WS_CREATESOUND: "Create Sound Effect",
  T_42_XXJ_WS_CREATESOUND_D: "Play the designated sound effect. If there are more properties to set, you can do so by configuring its entity properties.",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "Complete custom mission",
  T_42_XXJ_WS_DAMAGELIST_D: "DMG increment list",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "Headshot DMG ratio",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "Explosion DMG reduction multiplier",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "Default Physics Material",
  T_42_XXJ_WS_DEFAULTFIST_D: "Default fist",
  T_42_XXJ_WS_DELTA: "Delta",
  T_42_XXJ_WS_DELTA_D: "Delta",
  T_42_XXJ_WS_DELTATIME: "Logic frame interval",
  T_42_XXJ_WS_DELTATIME_D: "The interval between the 2 logic frame updates of the GS",
  T_42_XXJ_WS_DEPTH: "Layer",
  T_42_XXJ_WS_DEPTH_D: "Display layers on the icon",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "List of disabled ground loot",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "The list of items that are not ground loot",
  T_42_XXJ_WS_DRIVER: "Driver's seat",
  T_42_XXJ_WS_DRIVINGSTATUS: "Drive",
  T_42_XXJ_WS_DURATION_D1: "The countdown duration in seconds",
  T_42_XXJ_WS_DURATION_D2: "The duration in seconds",
  T_42_XXJ_WS_DURATION_D3: "The duration",
  T_42_XXJ_WS_DURATION_D4: "The duration of invulnerability in seconds",
  T_42_XXJ_WS_DURATIONTIMES: "Time Duration",
  T_42_XXJ_WS_DURATIONTIMES_D: "The duration in seconds",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "Dynamic Friction",
  T_42_XXJ_WS_EASY: "Very Easy",
  T_42_XXJ_WS_ENDTIMES: "End Time",
  T_42_XXJ_WS_ENDTIMES_D: "The end time on the timer in seconds",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "Global Energy Threshold",
  T_42_XXJ_WS_ENTITYVARNAME_D: "The self-relative entity",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "Equip attachment",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "Convert the given Euler angles into Quaternions",
  T_42_XXJ_WS_EXPONENTIATION_D: "Exponentiation",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "Extra backpack capacity",
  T_42_XXJ_WS_FIST: "Fist",
  T_42_XXJ_WS_FONTTYPE: "Font enum",
  T_42_XXJ_WS_FONTTYPE_D: "Font enum",
  T_42_XXJ_WS_FORCESYNCVALUE: "Force sync GS status",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "The force sync value",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "The location info. from the GS force sync",
  T_42_XXJ_WS_FORCESYNCVALUE1: "Location info from force sync",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "An entity that can formulate properties",
  T_42_XXJ_WS_FORWARD_D: "Direction vector",
  T_42_XXJ_WS_FRICTION_COMBINE: "Method of Friction Combination",
  T_42_XXJ_WS_FUNCPOINT: "Function Pointer",
  T_42_XXJ_WS_FUNCPOINT_D: "A pointer that points to an instance of a function. It is used to implement virtual functions or delegate mechanisms.",
  T_42_XXJ_WS_GETMAPID_D: "Get Map ID",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "Exit vehicle",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "Enter vehicle (driver)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "Enter vehicle (passenger)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "Search for today's player token data",
  T_42_XXJ_WS_GRAVITY: "Global Gravity",
  T_42_XXJ_WS_HANDHELDITEM: "Current handheld",
  T_42_XXJ_WS_HANDHELDITEM_D: "The current handheld",
  T_42_XXJ_WS_HARD: "Hard",
  T_42_XXJ_WS_HASCOMPONENT_D: "Whether there exists a component",
  T_42_XXJ_WS_HEIGHTLIST_D: "Height increment list",
  T_42_XXJ_WS_INDEXLIST_D: "Access the index list of the string",
  T_42_XXJ_WS_INSCENE: "In scene",
  T_42_XXJ_WS_INSCENE_D: "In scene",
  T_42_XXJ_WS_IS3D_D: "Whether it is a 3D music",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "Countdown or stopwatch",
  T_42_XXJ_WS_ISLOOP: "Loop or not",
  T_42_XXJ_WS_ISLOOP_D: "The IsLoop command",
  T_42_XXJ_WS_ISREPLAY_D: "Whether or not to start from the beginning",
  T_42_XXJ_WS_ISSWITCH_D: "When set to true, it can be combined with relative motion. When set to false, it can be combined with absolute motion.",
  T_42_XXJ_WS_JEEP: "Jeep",
  T_42_XXJ_WS_JUMPSTATUS: "Jump status",
  T_42_XXJ_WS_LEFTVALUE: "Left Value",
  T_42_XXJ_WS_LEFTVALUE_D: "Base",
  T_42_XXJ_WS_LOGARITHM_D: "Logarithm",
  T_42_XXJ_WS_LOOPABLE: "Loopable",
  T_42_XXJ_WS_LOOPABLE_D: "Loopable",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "Get all keys from the dict",
  T_42_XXJ_WS_MAPVALUE_D: "Target Dict",
  T_42_XXJ_WS_MARKBTNHUD: "The pin button on the HUD",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "The maximum distance",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "The mic switch on the HUD",
  T_42_XXJ_WS_MINDISTANCE_D: "The minimum distance",
  T_42_XXJ_WS_MISSIONID_D: "Mission ID",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "Progress (cannot be a negative number)",
  T_42_XXJ_WS_MODERATE: "Moderate",
  T_42_XXJ_WS_MONSTERTRUCK: "Monster Truck",
  T_42_XXJ_WS_MOTORBIKE: "Motor Bike",
  T_42_XXJ_WS_MOVEMENTSTATUS: "Movement status",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "Multiplication of two quaternions (representing rotation superposition)",
  T_42_XXJ_WS_NORMAL: "Normal",
  T_42_XXJ_WS_OBSOLETE: "Discarded",
  T_42_XXJ_WS_OPENPLAYERVIEW: "Enable player perspective",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "Enable player perspective",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "Weapon Type",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "Weapon Type",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "Prioritize Player Config.",
  T_42_XXJ_WS_PARAMSARRAY: "Parameters Array",
  T_42_XXJ_WS_PARAMSARRAY_D: "Parameters Array is a list of parameters involved in output. It needs to match the number of %v in the format description.",
  T_42_XXJ_WS_PARAMSARRAY_D1: "The list of actual parameters passed to the custom functions.",
  T_42_XXJ_WS_PARTVISABLEMASK1: "Part visibility mask 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "Part visibility mask 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "Part visibility mask 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "Part visibility mask 4",
  T_42_XXJ_WS_PASSENGER1: "Passenger seat 1",
  T_42_XXJ_WS_PASSENGER2: "Passenger seat 2",
  T_42_XXJ_WS_PASSENGER3: "Passenger seat 3",
  T_42_XXJ_WS_PHYMAT: "Physical Material",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "Entity",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "Self-relative motion in each frame",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "Self-relative motion every frame",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "Self-relative motion",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "The self-relative motion",
  T_42_XXJ_WS_PLAYER_D: "The player that needs to enter the vehicle",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "Entity of player behavior property sync",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "The entity of the player behavior property sync",
  T_42_XXJ_WS_PRIORITY_D: "Priority",
  T_42_XXJ_WS_PROPID_D: "The property ID",
  T_42_XXJ_WS_QUATERNION: "Quaternion",
  T_42_XXJ_WS_QUATERNION_D: "Quaternion is a special four-dimensional vector used only to represent a rotation",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "Convert the given Quaternions to axis-angle representation",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "Convert the given Quaternions to Euler angles. If the Quaternions do not meet the standard, return (0,0,0).",
  T_42_XXJ_WS_REPEATTIMES_D: "The number of times played. Default is 1.",
  T_42_XXJ_WS_RESETPLAYABLE_D: "Reset",
  T_42_XXJ_WS_RIGHTVALUE: "Right Value",
  T_42_XXJ_WS_RIGHTVALUE_D: "Power",
  T_42_XXJ_WS_SEATTYPE: "Vehicle seat enum",
  T_42_XXJ_WS_SEPSTR_D: "String used for separation",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "Set player fall DMG",
  T_42_XXJ_WS_SETTINGSBTNHUD: "The settings button on the HUD",
  T_42_XXJ_WS_SHOWPOSITION: "Show Location",
  T_42_XXJ_WS_SHOWPOSITION_D: "Show Location",
  T_42_XXJ_WS_SIGNALICOHUD: "The network connection button on the HUD",
  T_42_XXJ_WS_SIMPLE: "Easy",
  T_42_XXJ_WS_SLERPQUATERNION_D: "Spherical quaternion interpolation from A to B",
  T_42_XXJ_WS_SOUNDENTITY_D: "The sound effect entity represents a sound effect that is being played",
  T_42_XXJ_WS_SPEAKERBTNHUD: "The horn button on the HUD",
  T_42_XXJ_WS_SPLITSTRING_D: "Use a certain string as a delimiter to split the string into a slice",
  T_42_XXJ_WS_SPORTSCAR: "Sports Car",
  T_42_XXJ_WS_SPRINTSTATUS: "Sprint status",
  T_42_XXJ_WS_SRCVAL_D: "The source value",
  T_42_XXJ_WS_STARTTICKCOUNT: "The moment when the GS starts to tick",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "The moment when GS starts to tick",
  T_42_XXJ_WS_STARTTIME_D: "Time of start",
  T_42_XXJ_WS_STARTTIME_D1: "Time of start",
  T_42_XXJ_WS_STATE_D: "A player's status: active, knocked down, or eliminated",
  T_42_XXJ_WS_STATE_D1: "Check whether this sound effect is playing",
  T_42_XXJ_WS_STATIC_FRICTION: "Static Friction",
  T_42_XXJ_WS_STRELEMS_D: "Target string set",
  T_42_XXJ_WS_STRINGFINDAT_D: "Return the final combined string according to the index list",
  T_42_XXJ_WS_STRINGJOIN_D: "Join strings using a specified identifier",
  T_42_XXJ_WS_STRINGLOWER_D: "Convert all characters in the string to lowercase",
  T_42_XXJ_WS_STRINGSTRIP_D: "Remove whitespace characters from both sides of the string",
  T_42_XXJ_WS_STRINGUPPER_D: "Convert all characters in the string to uppercase",
  T_42_XXJ_WS_STYLE_D: "How it is played",
  T_42_XXJ_WS_SUV: "Pickup Truck",
  T_42_XXJ_WS_SWITCH: "Switch",
  T_42_XXJ_WS_SWITCH_D: "When set to true, it can be combined with relative motion. When set to false, it must be combined with absolute motion, otherwise the properties won't take effect correctly.",
  T_42_XXJ_WS_TARGETENTITY_D: "The target entity",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "Team Round Score Banner",
  T_42_XXJ_WS_TEAMSEQ_D: "The team serial number that corresponds to the serial number property of the team entity",
  T_42_XXJ_WS_TEMPORARYSHIELD: "Temporary shield points",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "Temporary shield points",
  T_42_XXJ_WS_TEXT_D: "The original text to perform a profanity filter on",
  T_42_XXJ_WS_THREESTATESWITCH: "3-Status Switch",
  T_42_XXJ_WS_THROWINGKNIFE_D: "Dagger (ground loot)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "Dagger",
  T_42_XXJ_WS_TUKTUK: "Tuk Tuk",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "Teams Match Details",
  T_42_XXJ_WS_UNIQUEID: "Unique ID",
  T_42_XXJ_WS_UNIQUEID_D: "Unique ID",
  T_42_XXJ_WS_VALUE_D: "The value",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "Direction vector to Euler angles",
  T_42_XXJ_WS_VEHICLEID: "Vehicle ID",
  T_42_XXJ_WS_VEHICLESKINID: "Vehicle skin ID",
  T_42_XXJ_WS_VERYHARD: "Very Hard",
  T_42_XXJ_WS_VOLUME_D: "The sound volume. Default is 50.",
  T_42_XXJ_WS_WEAPONTYPE_D: "Weapon's Main Type",
  T_42_XXJ_WS_WORKSHOPCODE: "Map code",
  T_42_XXJ_WS_WORKSHOPCODE_D: "The map code that corresponds to a data in the database",
  T_42_XXJ_WS_WORLDPOSITION: "World coordinates",
  T_42_XXJ_WS_WORLDPOSITION_D: "World coordinates",
  T_42_XYL_WS_ITEM275: "Fuel Tank",
  T_42_XYL_WS_ITEM276: "Sand Bag A",
  T_42_XYL_WS_ITEM277: "Sand Bag B",
  T_42_XYL_WS_ITEM278: "Sand Bag C",
  T_42_XYL_WS_ITEM279: "Sand Bag",
  T_42_XYL_WS_ITEM280: "Double Deck Villa",
  T_42_XYL_WS_ITEM281: "Arms Factory",
  T_42_XYL_WS_ITEM282: "Stone Wall A",
  T_42_XYL_WS_ITEM283: "Stone Wall B",
  T_42_XYL_WS_ITEM284: "Stone Wall C",
  T_42_XYL_WS_ITEM285: "Stone Wall D",
  T_42_XYL_WS_ITEM286: "Military Supply Box A",
  T_42_XYL_WS_ITEM287: "Copper Coin",
  T_42_XYL_WS_ITEM288: "Silver Coin",
  T_42_XYL_WS_ITEM289: "Gold Coin",
  T_42_XYL_WS_ITEM290: "Diamond",
  T_42_XYL_WS_ITEM291: "Diamond Shards",
  T_42_XYL_WS_ITEM292: "Ruby",
  T_42_XYL_WS_ITEM293: "Emerald",
  T_42_XYL_WS_ITEM294: "Sapphire",
  T_42_XYL_WS_ITEM295: "Warning Sign",
  T_42_XYL_WS_ITEM297: "Ruin",
  T_42_XYL_WS_ITEM297TRUE: "Control Device",
  T_42_XYL_WS_ITEM298: "Supply Container B",
  T_42_XYL_WS_ITEM299: "Snow Pile",
  T_42_XYL_WS_ITEM300: "High-Tech Wall A",
  T_42_XYL_WS_ITEM301: "High-Tech Wall B",
  T_42_XYL_WS_ITEM302: "Frozen Stone F",
  T_42_XYL_WS_ITEM303: "Frozen Stone E",
  T_42_XYL_WS_ITEM304: "High-Tech Platform A",
  T_42_XYL_WS_ITEM305: "High-Tech Staircase A",
  T_42_XYL_WS_ITEM306: "Exploration Lamp A",
  T_42_XYL_WS_ITEM307: "Ruin Baffle A",
  T_42_XYL_WS_ITEM308: "Ruin Baffle B",
  T_42_XYL_WS_ITEM309: "Ruin Steel Bracket A",
  T_42_XYL_WS_ITEM310: "Ruin Stone A",
  T_42_XYL_WS_ITEM311: "Ruin Stone B",
  T_42_XYL_WS_ITEM312: "Ruin Stone C",
  T_42_XYL_WS_ITEM313: "Flashlight A",
  T_42_XYL_WS_ITEM314: "Ruin Rebar A",
  T_42_XYL_WS_LOGICALOBJECT: "Logic",
  T_42_XYL_WS_THEMEHIGHTECH: "Futuristic",
  T_42_XYL_WS_THEMEICE: "Icy",
  T_42_XYL_WS_THEMEMILITARY: "Military",
  T_42_XYL_WS_THEMEOBJECTS: "Themed Object",
  T_42_XYL_WS_TIMERCONTINUE: "Timer Resuming Incident",
  T_42_XYL_WS_TIMERCYCLE: "Loop Count",
  T_42_XYL_WS_TIMERDOWN: "Countdown",
  T_42_XYL_WS_TIMEREND: "Timer ending incident",
  T_42_XYL_WS_TIMEREVENT: "Customized Timer Incident",
  T_42_XYL_WS_TIMEREVENT1: "Control Timer",
  T_42_XYL_WS_TIMEREVENT2: "Set Timer Incidents",
  T_42_XYL_WS_TIMERORDER: "Timing Method",
  T_42_XYL_WS_TIMERPAUSE: "Timer Pausing Incident",
  T_42_XYL_WS_TIMERSTART1: "Timer Start Time",
  T_42_XYL_WS_TIMERSTART2: "Timer Starting Incident",
  T_42_XYL_WS_TIMERUP: "Count Up",
  T_42_XYL_WS_TRIGGERTIME_MS: "Trigger Time (in milliseconds)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "A skywing that can hold multiple players.",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "Individual Score",
  T_42_ZZ_GUILDWAR_SCORE: "Score",
  T_43_B_SKILL_DESC_MONKEYGOD: "Transforms into a bush for [FFB300]{1}s[-] . Cooldown: [FFB300]{0}s[-]. Attacking others or being attacked will return Wukong to his original state. CD resets when taking down an enemy.",
  T_43_B_SKILL_DESC_Nanoscientist: "After taking fatal damage, enter an invulnerable and immobile state for [FFB300]{0}s[-]. Then, gain a [FFB300]{1} HP shield[-] that lasts for [FFB300]{2}s[-]. The skill user will be eliminated when the shield disappears. Cooldown: [FFB300]{3}s[-].",
  T_43_B_SKILL_DESC_ORION: "Replaces EP with [FFB300]{0} Crimson Energy[-]. Consumes [FFB300]{1} Crimson Energy[-] to activate its protection, during which you cannot take damage or attack enemies and will absorb [FFB300]{4} HP[-] (ignoring enemy Shield Points) from foes within [FFB300]{3}m[-]. Lasts for [FFB300]{2}s[-], during which your movement speed will decrease by [FFB300]{6}%[-]. Cooldown: [FFB300]{5}s[-].",
  T_43_CJ_F_A_RACER: "Velocity Racer (Mask)",
  T_43_CJ_F_B_RACER: "Velocity Racer (Bottom)",
  T_43_CJ_F_H_RACER: "Velocity Racer (Head)",
  T_43_CJ_F_HA_RACER: "Velocity Racer (Facepaint)",
  T_43_CJ_F_S_RACER: "Velocity Racer (Shoes)",
  T_43_CJ_F_T_RACER: "Velocity Racer (Top)",
  T_43_CJ_M_A_RACER: "Turbo Racer (Mask)",
  T_43_CJ_M_B_MACHINERY: "Turquoise Tech (Bottom)",
  T_43_CJ_M_B_RACER: "Turbo Racer (Bottom)",
  T_43_CJ_M_H_MACHINERY: "Turquoise Tech (Head)",
  T_43_CJ_M_H_RACER: "Turbo Racer (Head)",
  T_43_CJ_M_HA_MACHINERY: "Turquoise Tech (Facepaint)",
  T_43_CJ_M_S_MACHINERY: "Turquoise Tech (Shoes)",
  T_43_CJ_M_S_RACER: "Turbo Racer (Shoes)",
  T_43_CJ_M_T_MACHINERY: "Turquoise Tech (Top)",
  T_43_CJ_M_T_RACER: "Turbo Racer (Top)",
  T_43_H_CHARACTER_GEEK_N: "Ryden",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - Mamba Gnaw",
  T_43_HJ_WS_OPTION8: "Other",
  T_43_HJ_WS_TEXTURE_BAMBOO: "Bamboo",
  T_43_HJ_WS_TEXTURE_BEACH: "Beach",
  T_43_HJ_WS_TEXTURE_BRICK1: "Brick Wall A",
  T_43_HJ_WS_TEXTURE_BRICK2: "Brick Wall B",
  T_43_HJ_WS_TEXTURE_BRICK3: "Brick Wall C",
  T_43_HJ_WS_TEXTURE_CEMENT: "Concrete Floor",
  T_43_HJ_WS_TEXTURE_CEMENT2: "Concrete",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "Crystal",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "Grass A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "Grass B",
  T_43_HJ_WS_TEXTURE_ICE: "Ice Block",
  T_43_HJ_WS_TEXTURE_IRON: "Metal Floor",
  T_43_HJ_WS_TEXTURE_IRON2: "Container",
  T_43_HJ_WS_TEXTURE_LAVA: "Lava",
  T_43_HJ_WS_TEXTURE_MARBLE: "Marble Floor",
  T_43_HJ_WS_TEXTURE_NONE: "Empty",
  T_43_HJ_WS_TEXTURE_STONE: "Stone",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "Tablecloth A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "Tablecloth B",
  T_43_HJ_WS_TEXTURE_WOOD: "Wood",
  T_43_HJ_WS_TEXTURE_WOODEN: "Wooden Floor A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "Wooden Floor B",
  T_43_JH_WS_MAPTAG1: "Newbie-Friendly",
  T_43_JH_WS_MAPTAG10: "Boring new content",
  T_43_JH_WS_MAPTAG11: "Little sense of reward",
  T_43_JH_WS_MAPTAG12: "Reward imbalance",
  T_43_JH_WS_MAPTAG13: "Weak sense of progress",
  T_43_JH_WS_MAPTAG14: "Newbie-Unfriendly",
  T_43_JH_WS_MAPTAG15: "Confusing tutorial",
  T_43_JH_WS_MAPTAG16: "Lack of tutorials",
  T_43_JH_WS_MAPTAG17: "Players quit a lot",
  T_43_JH_WS_MAPTAG18: "Complicated controls",
  T_43_JH_WS_MAPTAG19: "Cluttered UI",
  T_43_JH_WS_MAPTAG2: "Preferred new content",
  T_43_JH_WS_MAPTAG20: "Poor map design",
  T_43_JH_WS_MAPTAG21: "Thrilling Shooter",
  T_43_JH_WS_MAPTAG22: "Fast-paced",
  T_43_JH_WS_MAPTAG23: "Open World",
  T_43_JH_WS_MAPTAG24: "Story-rich",
  T_43_JH_WS_MAPTAG25: "Progression",
  T_43_JH_WS_MAPTAG26: "Sports Simulation",
  T_43_JH_WS_MAPTAG27: "Co-op Mission",
  T_43_JH_WS_MAPTAG28: "Social",
  T_43_JH_WS_MAPTAG29: "Diverse Instances",
  T_43_JH_WS_MAPTAG3: "Active players",
  T_43_JH_WS_MAPTAG30: "Free Exploration",
  T_43_JH_WS_MAPTAG31: "Ranking Challenge",
  T_43_JH_WS_MAPTAG32: "Achievement",
  T_43_JH_WS_MAPTAG33: "Currency Redeem",
  T_43_JH_WS_MAPTAG4: "Well-Designed Map",
  T_43_JH_WS_MAPTAG40: "Numerous rewards",
  T_43_JH_WS_MAPTAG41: "Satisfying progression",
  T_43_JH_WS_MAPTAG42: "Popular Training Grounds",
  T_43_JH_WS_MAPTAG43: "Popular Solo Tower",
  T_43_JH_WS_MAPTAG44: "Popular War Zone",
  T_43_JH_WS_MAPTAG5: "Stuttering",
  T_43_JH_WS_MAPTAG6: "Hard co-op",
  T_43_JH_WS_MAPTAG7: "Buggy",
  T_43_JH_WS_MAPTAG8: "Few updates",
  T_43_JH_WS_MAPTAG9: "Boring in-match events",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "Spider Trap (Ryden)",
  T_43_SJ_WS_AIRDROP_ITEMS: "Drop Items",
  T_43_SJ_WS_AIRDROP_NAME: "Airdrop",
  T_43_SJ_WS_AIRDROP_TIME: "Start Drop Time",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "Drop Items",
  T_43_SJ_WS_ANITRIGGER_AUTO: "Is Auto-Play",
  T_43_SJ_WS_ANITRIGGER_CENTER: "Is Center Position",
  T_43_SJ_WS_ANITRIGGER_CLIP: "Animation Clip ID",
  T_43_SJ_WS_ANITRIGGER_LOOP: "Is Loop",
  T_43_SJ_WS_ANITRIGGER_NAME: "Animation Trigger HUD",
  T_43_SJ_WS_RESET_ROUND: "Reset per Round",
  T_43_SJ_WS_START_DROPTIME: "Start Drop Time (ms)",
  T_43_SJ_WS_TRIGGER_ANIMA: "Animation Trigger",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "Pet Skin: Meow Meow Zasil",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "Motorbike - Incarnational Speed",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "Contains essential battle supplies such as ammo and medical items",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "Supply Box",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "Spawn a [FFB300]{1} HP[-] mannequin that autonomously travels for [FFB300]{0}s[-]. When the mannequin is within [FFB300]{3}m[-], use the skill again to switch positions with it. You can only switch once within [FFB300]{4}s[-], up to [FFB300]{2} time(s)[-] in total. The player who destroys the mannequin will be marked for [FFB300]{5}s[-]. Cooldown: [FFB300]{6}s[-].",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "Active Skill",
  T_43_XXJ_WS_AIRDROP: "Airdrop and Zombie",
  T_43_XXJ_WS_ALPHA: "Alpha",
  T_43_XXJ_WS_ALPHA_D: "The overall transparency of the HUD, with a range from 0 to 1.",
  T_43_XXJ_WS_ANIMATIONCTRLID: "Animation Controller ID",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "The ID used to describe an animation controller asset",
  T_43_XXJ_WS_AUDIOID: "Audio ID",
  T_43_XXJ_WS_AUDIOID_D: "The ID used to describe an audio asset",
  T_43_XXJ_WS_BACKGRCOLOR: "Background Color",
  T_43_XXJ_WS_BACKGRCOLOR_D: "The color of the health bar boarder and the blurred background",
  T_43_XXJ_WS_BURNING: "Burning",
  T_43_XXJ_WS_CSVID: "CSV ID",
  T_43_XXJ_WS_CSVID_D: "The ID used to describe a configuration table asset",
  T_43_XXJ_WS_CURRENTHP: "Current HP",
  T_43_XXJ_WS_CURRENTHP_D: "Current HP value",
  T_43_XXJ_WS_DAMAGEMAKER_D: "The game entity that deals damage",
  T_43_XXJ_WS_DAMAGEZONE: "Damage Zone",
  T_43_XXJ_WS_DEFAULT: "Default",
  T_43_XXJ_WS_DEFAULT_D: "Default",
  T_43_XXJ_WS_EFFECTID: "Effect ID",
  T_43_XXJ_WS_EFFECTID_D: "The ID used to describe a special effect asset",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "An entity that can fight (e.g. launch attacks, be attacked, or get eliminated)",
  T_43_XXJ_WS_FOLLOWTARGET: "Follow Target",
  T_43_XXJ_WS_FOLLOWTARGET_D: "Must follow an entity with a Transform component",
  T_43_XXJ_WS_GAINHPCOLOR: "Gain HP Color",
  T_43_XXJ_WS_GAINHPCOLOR_D: "The increased portion of HP will show in this color for a short time",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "Is No Fall Damage",
  T_43_XXJ_WS_ISOPENTWEEN: "Is Open Tween",
  T_43_XXJ_WS_ISOPENTWEEN_D: "Enable this to show HP changes in different colors",
  T_43_XXJ_WS_KNOCKDOWN_D1: "The player is in the knockdown state",
  T_43_XXJ_WS_KNOCKDOWN_D2: "Settings for the response to the knockdown state when eliminated",
  T_43_XXJ_WS_KNOCKDOWN_D3: "The revival source type. A player can be revived while  knocked down.",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "Knockdown State",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "Knockdown State Type",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "The response to the knockdown state: maintain default logic, skip the knockdown state, or force into knockdown.",
  T_43_XXJ_WS_LEVEL: "Level",
  T_43_XXJ_WS_LEVEL_D: "Level",
  T_43_XXJ_WS_LEVEL_D1: "The current zombie level",
  T_43_XXJ_WS_LINESPACING: "Line Spacing",
  T_43_XXJ_WS_LINESPACING_D: "Does not display when the segmented HP between two dividers ≤ 0",
  T_43_XXJ_WS_LOSEHPCOLOR: "Lose HP Color",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "The reduced portion of HP will show in this color for a short time",
  T_43_XXJ_WS_MAINCOLOR: "Main Color",
  T_43_XXJ_WS_MAINCOLOR_D: "The color for HP, levels, and outlines",
  T_43_XXJ_WS_MINISENTRY: "Turret",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "The enum for the types of targets a turret can attack",
  T_43_XXJ_WS_MISSILEEXPLODE: "Missile Explode",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "Must Knockdown",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "Forced knockdown",
  T_43_XXJ_WS_OFFSET: "Offset",
  T_43_XXJ_WS_OFFSET_D: "Offset relative to the target followed",
  T_43_XXJ_WS_OILDRUMEXPLODE: "Oil Drum Explode",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "Only triggered when the controller initiates movement",
  T_43_XXJ_WS_PLAYER_D: "The in-game player entity. Each player has one.",
  T_43_XXJ_WS_PLAYERHEADHUD: "Player Head HUD",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "The information displayed above the player's head",
  T_43_XXJ_WS_PLAYERNAME: "Player Name",
  T_43_XXJ_WS_PLAYERNAME_D: "Displays the name of the current health bar owner",
  T_43_XXJ_WS_PLAYERORVEHICLE: "Player or Vehicle",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "The alias for the player/vehicle entity type",
  T_43_XXJ_WS_SCALE: "Scale",
  T_43_XXJ_WS_SCALE_D: "Determines the overall HUD scale size, with the font scaled to match.",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "Show Damage Number",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "True by default. Displays damage number.",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "Skip Knockdown",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "Skip the knockdown state and get eliminated instantly",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "Is Skip Stagger Animation",
  T_43_XXJ_WS_TEAM_D: "(Deprecated. Please use Team ID.)",
  T_43_XXJ_WS_TERRAIN: "Terrain",
  T_43_XXJ_WS_TERRAIN_D: "A terrain component of which attributes cannot be modified. Used to test functions only.",
  T_43_XXJ_WS_TOTALHP: "Total HP",
  T_43_XXJ_WS_TOTALHP_D: "Total HP value",
  T_43_XXJ_WS_TWEENENTITY: "Tween Entity",
  T_43_XXJ_WS_VEHICLEEXPLODE: "Vehicle Explode",
  T_43_XXJ_WS_WIDTH: "Width",
  T_43_XXJ_WS_WIDTH_D: "The width of the displayed health bar",
  T_43_XXJ_WS_ZOMBIE: "Zombie",
  T_43_XYL_WS_DROIDFIST: "Fist (Droid Apocalypse)",
  T_43_XYL_WS_DROIDFLAME: "Flamethrower (Droid Apocalypse)",
  T_43_XYL_WS_JAPANESE: "Japanese-Style",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "Customize match event logs. Used for user experience analysis.",
  T_43_YU_WS_AIRDROPSTATE: "Airdrop State",
  T_43_YU_WS_AIRDROPSTATE_D: "Airdrop state (1: ready, 2: dropping, 3: landed)",
  T_43_YU_WS_ANIMATIONCLIPID: "Animation Clip ID",
  T_43_YU_WS_ANIMATIONCLIPID_D: "Customize animation clip ID",
  T_43_YU_WS_ASKBUYTARGET: "Ask Buy Target",
  T_43_YU_WS_ASKBUYTARGET_D: "Specifies the target and sends purchase request",
  T_43_YU_WS_ASKEDLIST: "Asked List",
  T_43_YU_WS_ASKEDLIST_D: "The list of requested items",
  T_43_YU_WS_BACKGROUNDCOLOR1: "Background Color 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "The upper background color",
  T_43_YU_WS_BACKGROUNDCOLOR2: "Background Color 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "The bottom background color",
  T_43_YU_WS_BATCHCOMBINERENDER: "Batch Combine Render",
  T_43_YU_WS_BINDMONEYENTITYLIST: "Bind Money Entity List",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "The list of bound currency entities",
  T_43_YU_WS_BINDWALLETENTITYID: "Bind Wallet Entity ID",
  T_43_YU_WS_BINDWALLETENTITYID_D: "The ID of the bound wallet entity",
  T_43_YU_WS_CENTEROFFSET: "Center Offset",
  T_43_YU_WS_CENTEROFFSET_D: "The offset value for the capsule collider",
  T_43_YU_WS_COLLECTIONID: "Collection ID",
  T_43_YU_WS_COLLECTIONID_D: "The Collection ID used for asset information collection",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "Create an airdrop",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "Create a damage number",
  T_43_YU_WS_CROSSPLATFORM_D: "When selected, send to the client if called on the server and vice versa.",
  T_43_YU_WS_CSROUNDRESULTHUD: "CS Round Result HUD",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "Results displayed at the end of each round",
  T_43_YU_WS_CURRENTEMOTECLIP: "Current Emote Clip",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "ID of the current emote clip",
  T_43_YU_WS_DAMAGE_D: "The out-of-zone damage",
  T_43_YU_WS_DICTIONARY: "Dictionary",
  T_43_YU_WS_DIRECTIONRULERHUD: "Direction Ruler HUD",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "The compass on the top",
  T_43_YU_WS_DOTWEEN_D: "Whether to perform tween animations",
  T_43_YU_WS_DROPITEMS_D: "Items in the airdrop",
  T_43_YU_WS_DURATION: "Duration",
  T_43_YU_WS_ENERGY: "Energy",
  T_43_YU_WS_ENERGY_D: "EP modification value",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "Prone",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "Crouch",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "Sprinting",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "Stand",
  T_43_YU_WS_EVENTID: "Event ID",
  T_43_YU_WS_EVENTID_D: "Represents an event",
  T_43_YU_WS_FACTION: "Faction",
  T_43_YU_WS_FACTION_D: "The faction entity",
  T_43_YU_WS_FACTION_D1: "Ask the faction for help with purchase",
  T_43_YU_WS_FINALRADIUS_D: "The final radius of the safe zone",
  T_43_YU_WS_FIRSTAIDKIT: "MedKit",
  T_43_YU_WS_FIRSTAIDKIT_D: "Med Kit",
  T_43_YU_WS_FIRSTPERSONMODEL: "First Person Model",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "The first-person camera",
  T_43_YU_WS_FONTCOLOR_D: "The font color",
  T_43_YU_WS_FONTSIZE_D: "The font size",
  T_43_YU_WS_FORBIDEN: "Forbidden",
  T_43_YU_WS_FORBIDEN_D: "Disable the HUD for purchase request",
  T_43_YU_WS_FREEZINGTIME: "Freezing Time",
  T_43_YU_WS_FREEZINGTIME_D: "The duration for which the hit target stays frozen",
  T_43_YU_WS_GRAVITY: "Gravity",
  T_43_YU_WS_GRAVITY_D: "The gravitational acceleration. Only affects the player controller.",
  T_43_YU_WS_HANDCATAPULT: "Launch Pad",
  T_43_YU_WS_HANDCATAPULT_D: "Launch Pad",
  T_43_YU_WS_HEALTH: "Health",
  T_43_YU_WS_HEALTH_D: "The recovery value of armor durability",
  T_43_YU_WS_HEIGHT: "Height",
  T_43_YU_WS_HELPEDPLAYER_D: "The player who is helped",
  T_43_YU_WS_HELPPLAYER_D: "The player who helps with the purchase",
  T_43_YU_WS_HORIZONTALMAXANGLE: "Horizontal Max. Angle",
  T_43_YU_WS_HORIZONTALMINANGLE: "Horizontal Min Angle",
  T_43_YU_WS_HUDTOGGLE: "HUD Toggle",
  T_43_YU_WS_HUDTOGGLE_D: "The HudToggle entity that players can edit in the HUD editor",
  T_43_YU_WS_INHALER: "Inhaler",
  T_43_YU_WS_INHALER_D: "Inhaler",
  T_43_YU_WS_INITRADIUS_D: "The initial radius of the safe zone",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "A 64-bit signed integer",
  T_43_YU_WS_ISAPPLYSHADOW: "Is Apply Shadow",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "Is Bottom Colliding",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "Is Current Emote Loop",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "Whether to set the current Emote animation to loop",
  T_43_YU_WS_ISSIDECOLLIDING: "Is Side Colliding",
  T_43_YU_WS_ISSLIDING: "Is Sliding",
  T_43_YU_WS_ISTOPCOLLIDING: "Is Top Colliding",
  T_43_YU_WS_ITEM331: "Futuristic Device A",
  T_43_YU_WS_ITEM332: "Glowing Rock A",
  T_43_YU_WS_ITEM333: "Futuristic Screen A",
  T_43_YU_WS_ITEM334: "Futuristic Container A",
  T_43_YU_WS_ITEM335: "Futuristic Container A",
  T_43_YU_WS_ITEM336: "Stone Sofa A",
  T_43_YU_WS_ITEM337: "Futuristic Switch A",
  T_43_YU_WS_ITEM338: "Futuristic Pipe A",
  T_43_YU_WS_ITEM339: "Metal Platform A",
  T_43_YU_WS_ITEM340: "Futuristic Table A",
  T_43_YU_WS_ITEM341: "Futuristic Table B",
  T_43_YU_WS_ITEM342: "Futuristic Table C",
  T_43_YU_WS_ITEM343: "Futuristic Computer A",
  T_43_YU_WS_ITEM344: "Stone A",
  T_43_YU_WS_ITEM345: "Stone B",
  T_43_YU_WS_ITEM346: "Stone C",
  T_43_YU_WS_ITEM347: "Stone D",
  T_43_YU_WS_ITEM348: "Stone E",
  T_43_YU_WS_ITEM349: "Stone F",
  T_43_YU_WS_ITEM350: "Stone G",
  T_43_YU_WS_ITEM351: "Japanese-Style Curtain A",
  T_43_YU_WS_ITEM352: "Japanese-Style Curtain B",
  T_43_YU_WS_ITEM353: "Japanese-Style Curtain C",
  T_43_YU_WS_ITEM354: "Japanese-Style Stairs A",
  T_43_YU_WS_ITEM355: "Japanese-Style Fence A",
  T_43_YU_WS_ITEM356: "Japanese-Style Fence B",
  T_43_YU_WS_ITEM357: "Japanese-Style Fence C",
  T_43_YU_WS_ITEM358: "Japanese-Style Platform A",
  T_43_YU_WS_ITEM359: "Japanese-Style Wall B",
  T_43_YU_WS_ITEM360: "Japanese-Style Gate B",
  T_43_YU_WS_ITEM361: "Futuristic Wall D",
  T_43_YU_WS_ITEM362: "Futuristic Wall B",
  T_43_YU_WS_ITEM363: "Futuristic Angled Baseboard",
  T_43_YU_WS_LEFTCOLOR: "Left Color",
  T_43_YU_WS_LEFTCOLOR_D: "The left side color",
  T_43_YU_WS_LEFTPLAYERARRAY: "Left Player Array",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "The left player array",
  T_43_YU_WS_LEFTSCORE: "Left Score",
  T_43_YU_WS_LEFTSCORE_D: "The left side score",
  T_43_YU_WS_LEFTSCOREAFTER: "Left Score After",
  T_43_YU_WS_LEFTSCOREAFTER_D: "The final score of the left side. Used in score transition animations.",
  T_43_YU_WS_LEVELOBJECTID: "Level Object ID",
  T_43_YU_WS_LEVELOBJECTID_D: "Describes the object type. Requires parsing through the SceneEditPrefab configuration table before loading.",
  T_43_YU_WS_LOCALPOSITION_D: "Coordinates in the local coordinate system",
  T_43_YU_WS_LOCALPOSITION_D1: "The relative position",
  T_43_YU_WS_LOCALPOSITION_D2: "The position relative to the bottom right anchor",
  T_43_YU_WS_LOCALPOSITION_D3: "The position relative to the anchor",
  T_43_YU_WS_LOCALROTATION_D: "Rotation angles in the local coordinate system (X: yaw, Y: pitch, and Z: roll)",
  T_43_YU_WS_LOCALROTATIONQ_D: "The quaternion in the local coordinate system",
  T_43_YU_WS_LOCALSCALE_D: "The scale size in the world coordinate system",
  T_43_YU_WS_MASS: "Mass",
  T_43_YU_WS_MATERIALS: "Materials",
  T_43_YU_WS_MATERIALS_D: "The list of materials used for rendering",
  T_43_YU_WS_MAXSPEED: "Max. Speed",
  T_43_YU_WS_MAXSPEED_D: "No more horsepower will be generated after the max speed is reached, but the vehicle speed may go over the limit (e.g. through acceleration when going down a hill).",
  T_43_YU_WS_MESHID: "Mesh ID",
  T_43_YU_WS_MESHID_D: "Describes the mesh type",
  T_43_YU_WS_MESHID1: "Mesh ID",
  T_43_YU_WS_MESHID1_D: "The mesh to be used for rendering",
  T_43_YU_WS_MINMOVEDISTANCE: "Min. Move Distance",
  T_43_YU_WS_MINMOVEDISTANCE_D: "Movement with a distance shorter than this value will not be executed. It is recommended to set it to 0 unless there are special requirements.",
  T_43_YU_WS_MODULE_AI: "AI",
  T_43_YU_WS_MODULE_AIRDROP: "Airdrop",
  T_43_YU_WS_MODULE_ANIMATION: "Animation",
  T_43_YU_WS_MODULE_AVATAR: "Avatar",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "Base Attributes",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "Behavior Tree",
  T_43_YU_WS_MODULE_BUFF: "Buff",
  T_43_YU_WS_MODULE_CAMERA: "Camera",
  T_43_YU_WS_MODULE_CHATCHANNEL: "Chat Channel",
  T_43_YU_WS_MODULE_CHECKPOINT: "Checkpoint",
  T_43_YU_WS_MODULE_COLLECTION: "Collection",
  T_43_YU_WS_MODULE_COMBAT: "Combat",
  T_43_YU_WS_MODULE_COMPONENT: "Component",
  T_43_YU_WS_MODULE_CONVERT: "Convert",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "Customize Room Parameters",
  T_43_YU_WS_MODULE_DATABASE: "Data Storage",
  T_43_YU_WS_MODULE_DYEING: "Dyeing",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "Dynamic NavMesh",
  T_43_YU_WS_MODULE_ECONOMY: "Economy",
  T_43_YU_WS_MODULE_FF_PLATFORM: "FF Platform",
  T_43_YU_WS_MODULE_FOOTBALL: "Football",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "Frame Rate Mode",
  T_43_YU_WS_MODULE_GAMERESULT: "Game Results",
  T_43_YU_WS_MODULE_GLOBAL: "Global",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "Global Scripts",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK & Cheating",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "Input System",
  T_43_YU_WS_MODULE_ITEMS: "Items",
  T_43_YU_WS_MODULE_LEVELOBJECT: "Level Object",
  T_43_YU_WS_MODULE_LIST: "List",
  T_43_YU_WS_MODULE_MAP: "Map",
  T_43_YU_WS_MODULE_MATCHING: "Match",
  T_43_YU_WS_MODULE_MATH: "Math",
  T_43_YU_WS_MODULE_MECHANISM: "Mechanism Parameters",
  T_43_YU_WS_MODULE_MINIMAP: "Minimap",
  T_43_YU_WS_MODULE_MORPH: "Morph",
  T_43_YU_WS_MODULE_OTHER: "Other",
  T_43_YU_WS_MODULE_PET: "Pet",
  T_43_YU_WS_MODULE_PHYSICS: "Physics",
  T_43_YU_WS_MODULE_PLAYABLE: "Playable",
  T_43_YU_WS_MODULE_PLAYER: "Player",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "Player Scripts",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "Preset Character",
  T_43_YU_WS_MODULE_PROFILE: "Profile",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "Property Formula",
  T_43_YU_WS_MODULE_SAFEZONE: "Safe Zone",
  T_43_YU_WS_MODULE_SCENE: "Scene",
  T_43_YU_WS_MODULE_SKILL: "Skill",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "Static Scripts",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "Report",
  T_43_YU_WS_MODULE_STDLIBRARY: "STD Library",
  T_43_YU_WS_MODULE_STRINGS: "Strings",
  T_43_YU_WS_MODULE_TEAM: "Team",
  T_43_YU_WS_MODULE_WORKFLOW: "Workflow",
  T_43_YU_WS_MONEYICON: "Money Icon",
  T_43_YU_WS_MONEYICON_D: "The currency icon",
  T_43_YU_WS_MONEYICONCOLOR: "Money Icon Color",
  T_43_YU_WS_MONEYICONCOLOR_D: "The currency icon color",
  T_43_YU_WS_MOVESAFEZONE_D: "Smoothly moves the safe zone from its start position to the end position. Players outside the zone will take a certain amount of damage.",
  T_43_YU_WS_NEWVECTOR2: "New Vector2",
  T_43_YU_WS_NEWVECTOR2_D: "Gets a new 2D vector",
  T_43_YU_WS_OFFSET_D: "The world position offset relative to the target entity",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "When the player purchase request is met",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "When a player requests for help with purchase in the store",
  T_43_YU_WS_ONTOGGLECHANGE_D: "Trigger when the Toggle component state changes",
  T_43_YU_WS_OPENSTATE: "Open State",
  T_43_YU_WS_OPENSTATE_D: "Displays when set to true and hides if not",
  T_43_YU_WS_PACEMAKER: "Horizaline",
  T_43_YU_WS_PACEMAKER_D: "Horizaline",
  T_43_YU_WS_PARAMS_D: "The list of parameters",
  T_43_YU_WS_PARENT_D: "The entity ID recorded during serialization",
  T_43_YU_WS_PHYSICALCCT: "Physical CCT",
  T_43_YU_WS_PHYSICALCCT_D: "The player controller with physical effects",
  T_43_YU_WS_PLAYER_D: "The purchasing player",
  T_43_YU_WS_PLAYERDATAID: "Player Data ID",
  T_43_YU_WS_PLAYERDATAID_D: "Customize character asset ID",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "Player PhysX Pose Type",
  T_43_YU_WS_POSITION: "Position",
  T_43_YU_WS_POSITION_D: "Coordinates in the world coordinate system",
  T_43_YU_WS_POSITION_D1: "Coordinates in the world coordinate system. Only effective for 3D music.",
  T_43_YU_WS_PRESSEDSPRITE: "Pressed Sprite",
  T_43_YU_WS_PRESSEDSPRITE_D: "The pressed sprite",
  T_43_YU_WS_PRESSEDSPRITETYPE: "Pressed Sprite Type",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "The pressed sprite type",
  T_43_YU_WS_PRETIME: "Pretime",
  T_43_YU_WS_RADIUS: "Radius",
  T_43_YU_WS_RANDOMRANGE_D: "Correct the set position based on a random range",
  T_43_YU_WS_REQUESTPURCHASETYPE: "Request Purchase Type",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "Purchase request in the store",
  T_43_YU_WS_REQUESTTYPE: "Request Type",
  T_43_YU_WS_REQUESTTYPE_D: "The type of the target requested by the current HUD player",
  T_43_YU_WS_RESPLAYERUUID: "Preset Player Type",
  T_43_YU_WS_RESPLAYERUUID_D: "The player asset ID",
  T_43_YU_WS_RESUUID: "Asset UUID",
  T_43_YU_WS_RESUUID_D: "Specifies the UUID of the Batch asset to be rendered",
  T_43_YU_WS_RIGHTCOLOR: "Right Color",
  T_43_YU_WS_RIGHTCOLOR_D: "The right side color",
  T_43_YU_WS_RIGHTPLAYERARRAY: "Right Player Array",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "The right player array",
  T_43_YU_WS_RIGHTSCORE: "Right Score",
  T_43_YU_WS_RIGHTSCORE_D: "The right side score",
  T_43_YU_WS_RIGHTSCOREAFTER: "Right Score After",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "The final score of the right side. Used in score transition animations.",
  T_43_YU_WS_ROTATIONQ_D: "The quaternion in the world coordinate system",
  T_43_YU_WS_ROUNDINFOHUD: "Round Info HUD",
  T_43_YU_WS_ROUNDINFOHUD_D: "Information displayed at the start of a round",
  T_43_YU_WS_SELECTEDCOLOR: "Selected Color",
  T_43_YU_WS_SELECTEDCOLOR_D: "The selected sprite color",
  T_43_YU_WS_SELECTEDSPRITE: "Selected Sprite",
  T_43_YU_WS_SELECTEDSPRITE_D: "The selected sprite",
  T_43_YU_WS_SELECTEDTYPE: "Selected Type",
  T_43_YU_WS_SELECTEDTYPE_D: "The selected sprite type",
  T_43_YU_WS_SHADOWCOLOR: "Shadow Color",
  T_43_YU_WS_SHADOWOFFSET: "Shadow Offset",
  T_43_YU_WS_SHOWTAG: "Show Tag",
  T_43_YU_WS_SHOWTAG_D: "Show team/faction markings",
  T_43_YU_WS_SHRINKDURATION_D: "The shrinking duration of the safe zone",
  T_43_YU_WS_SIMPLERENDER_D: "The bridging rendering component used for rendering with built-in models",
  T_43_YU_WS_SKINWIDTH: "Skin Width",
  T_43_YU_WS_SKINWIDTH_D: "The depth of penetration into the capsule to prevent the character from getting stuck or jittering",
  T_43_YU_WS_SLOPELIMIT: "Slope Limit",
  T_43_YU_WS_SLOPELIMIT_D: "Objects placed on the slope exceeding this angle will slide down",
  T_43_YU_WS_SPEED: "Speed",
  T_43_YU_WS_STARTDROPTIME_D: "The airdrop arrival time in milliseconds",
  T_43_YU_WS_STARTPOS_D: "The start position of the safe zone",
  T_43_YU_WS_STATICICONCOLORS: "Static Icon Colors",
  T_43_YU_WS_STATICICONCOLORS_D: "Icon colors shown on the ruler",
  T_43_YU_WS_STATICICONS: "Static Icons",
  T_43_YU_WS_STATICICONS_D: "The icons shown on rulers",
  T_43_YU_WS_STEPOFFSET: "Step Offset",
  T_43_YU_WS_STEPOFFSET_D: "Only obstacles exceeding this height will have a blocking effect",
  T_43_YU_WS_SUBTITLE: "SubTitle",
  T_43_YU_WS_SUBTITLE_D: "The subtitle",
  T_43_YU_WS_TARGET: "Target",
  T_43_YU_WS_TARGET_D: "The target entity for the displayed damage number",
  T_43_YU_WS_TARGETICONCOLORS: "Target Icon Colors",
  T_43_YU_WS_TARGETICONCOLORS_D: "Colors of the icon shown by the marked target",
  T_43_YU_WS_TARGETICONS: "Target Icons",
  T_43_YU_WS_TARGETICONS_D: "The icons shown by the marked targets",
  T_43_YU_WS_TARGETPOS_D: "The target end position of the safe zone",
  T_43_YU_WS_TEAM: "Team",
  T_43_YU_WS_TEAM_D: "The team entity in the game. Each team has one entity.",
  T_43_YU_WS_TEAM_D1: "Ask the team for help with purchase",
  T_43_YU_WS_TIMEOFSTAY_D: "The display duration in milliseconds",
  T_43_YU_WS_TITLE: "Title",
  T_43_YU_WS_TITLE_D: "The main title",
  T_43_YU_WS_TRANSFORM_D: "Rotation, scaling, and parent-child record",
  T_43_YU_WS_UNSELECTEDCOLOR: "Unselected Color",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "The unselected sprite color",
  T_43_YU_WS_UNSELECTEDSPRITE: "Unselected Sprite",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "The unselected sprite",
  T_43_YU_WS_UNSELECTEDTYPE: "Unselected Type",
  T_43_YU_WS_UNSELECTEDTYPE_D: "Unselected sprite type",
  T_43_YU_WS_USEPHYSICALCCT: "Use Physical CCT",
  T_43_YU_WS_VALUE_D: "The displayed content",
  T_43_YU_WS_VECTOR2ADD: "Vector2 Add",
  T_43_YU_WS_VECTOR2GETX: "Vector2 Get X",
  T_43_YU_WS_VECTOR2GETY: "Vector2 Get Y",
  T_43_YU_WS_VECTOR2SCALE: "Vector2 Scale",
  T_43_YU_WS_VECTOR2SETX: "Vector2 Set X",
  T_43_YU_WS_VECTOR2SETY: "Vector2 Set Y",
  T_43_YU_WS_VECTOR2SUB: "Vector2 Sub",
  T_43_YU_WS_VELOCITY: "Velocity",
  T_43_YU_WS_VERTICALMAXANGLE: "Vertical Max Angle",
  T_43_YU_WS_VERTICALMINANGLE: "Vertical Min. Angle",
  T_43_YU_WS_VISIBILITY_D: "Indicates whether visibility can be set",
  T_43_YU_WS_VISIBLE_D: "The visibility setting. If set to invisible, the client stops rendering the target.",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "Futuristic Wall A",
  T_43_ZY_WS_ITEM320: "Futuristic Wall C",
  T_43_ZY_WS_ITEM321: "Futuristic Window",
  T_43_ZY_WS_ITEM322: "Futuristic Door",
  T_43_ZY_WS_ITEM323: "Futuristic Angled Roof",
  T_43_ZY_WS_ITEM324: "Futuristic Circular Roof",
  T_43_ZY_WS_ITEM325: "Futuristic Baseboard",
  T_43_ZY_WS_ITEM326: "Futuristic Circular Baseboard",
  T_43_ZY_WS_ITEM327: "Futuristic Stairs",
  T_43_ZY_WS_ITEM328: "Futuristic Decoration A",
  T_43_ZY_WS_ITEM329: "Futuristic Building A",
  T_43_ZY_WS_ITEM330: "Futuristic Building B",
  T_44_CJ_M_B_SPORT_TH: "Gym Uniform (Bottom)",
  T_44_CJ_M_H_SPORT_TH: "Gym Uniform (Head)",
  T_44_CJ_M_S_SPORT_TH: "Gym Uniform (Shoes)",
  T_44_CJ_M_T_SPORT_TH: "Gym Uniform (Top)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "Kairos",
  T_44_H_M24_ONIMUSHA_N: "M24 - Attack-o'-the-Wisp",
  T_44_H_USP45_CARNIVORE_N: "USP - Poison Tooth",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "Motorbike - Thunderstrokes",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "Force Start with Min. Players",
  T_44_JH_WS_HALFWAYKEY1: "Prioritize Start with Full Team",
  T_44_PD_PVE_DRAGON_NAME: "Mechadrake",
  T_44_QL_GRENADE_DRAGON: "Dragon Freeze",
  T_44_QL_GRENADE_DRAGON_DES: "An upgraded Flash Freeze that will detonate three times consecutively upon impact",
  T_44_QL_JUMPSHOESX: "Dragon Sprinters",
  T_44_QL_JUMPSHOESX_DES: "A pair of special jumping shoes that allow for sprinting in the air during a double jump",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "Safe Zone Close Time",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "Time when the Safe Zone disappears. If the Safe Zone Close Time is less than Safe Zone Start Time, no Safe Zone will be generated.",
  T_44_SJ_WS_SAFEZONE_COLOR: "Safe Zone Color",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "Damage Interval",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "Damage interval",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "Damage Value",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "The damage dealt to a player out-of-zone in a single instance",
  T_44_SJ_WS_SAFEZONE_DESC: "A placeable out-of-zone object",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "Out-of-Zone End Radius",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "End radius of the out-of-zone area",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "Safe Zone Player List",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "Get the list of players in the Safe Zone",
  T_44_SJ_WS_SAFEZONE_NAME: "The out-of-zone area",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "Shrink Duration (s)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "Length of time the zone shrinking takes",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "Out-of-Zone Initial Radius",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "Initial radius of the out-of-zone area",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "Start Shrink Time",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "Time when the zone shrinking starts",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "Safe Zone Start Time",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "Time when the safe zone appears each round in-match. Default is 0.",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "PLASMA-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "Activated Alpha",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "Activated alpha",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "Active Skill Button HUD",
  T_44_XXJ_WS_ADDCOMPONENT_D: "Add a component to an entity. Only supports custom components. (A component will not be added again if it already exists.)",
  T_44_XXJ_WS_ALLMEMBERS: "All Members",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "Allow Pressed Outside",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "Allow triggering outside the designated area",
  T_44_XXJ_WS_ARROWIMAGE: "Arrow Image",
  T_44_XXJ_WS_ARROWIMAGE_D: "Arrow image",
  T_44_XXJ_WS_ARROWOFFSET: "Arrow Offset",
  T_44_XXJ_WS_ARROWOFFSET_D: "Arrow offset",
  T_44_XXJ_WS_ARROWSIZE: "Arrow Size",
  T_44_XXJ_WS_ARROWSIZE_D: "Arrow size",
  T_44_XXJ_WS_AUTOPLAY_D: "Automatically play upon creation",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "Background Image",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "Base image",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "Background Radius",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "Base radius",
  T_44_XXJ_WS_BAGSKINID: "Backpack Skin ID",
  T_44_XXJ_WS_BAGSKINID_D: "The backpack skin ID",
  T_44_XXJ_WS_BONEPOSITION: "Bone Position",
  T_44_XXJ_WS_BONEPOSITION_D: "World coordinates of the bone node",
  T_44_XXJ_WS_CCTMOVE: "Move CCT",
  T_44_XXJ_WS_COLLIDER: "Collider",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "Collider Collection",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "The component used to describe the collision shape",
  T_44_XXJ_WS_COLOR: "Color",
  T_44_XXJ_WS_CONTENT: "Content",
  T_44_XXJ_WS_CONTENT_D: "Wallet content is a collection of currencies",
  T_44_XXJ_WS_CONTEXT_D: "Content to be printed",
  T_44_XXJ_WS_CROSSHAIRSHUD: "Crosshairs HUD",
  T_44_XXJ_WS_CURVE_D: "Curve",
  T_44_XXJ_WS_EFFECTCOLOR_D: "Color of the surface texture",
  T_44_XXJ_WS_ENABLE: "Enable",
  T_44_XXJ_WS_ENTITY_D: "Entity",
  T_44_XXJ_WS_GETBAGSKINID_D: "Get player backpack skin configuration",
  T_44_XXJ_WS_GETFACTION_D: "Get faction",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "Get the loaded scenes that have not been uninstalled",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "Get the local player",
  T_44_XXJ_WS_GROUPID: "Group ID",
  T_44_XXJ_WS_GROUPID_D: "For internal logic",
  T_44_XXJ_WS_HUDJOYSTICK: "HUD Joystick Widget",
  T_44_XXJ_WS_HUDJOYSTICK_D: "Joystick entity. Players can edit the HUD via the HUD Editor.",
  T_44_XXJ_WS_HUDTOUCHPAD: "HUD Touchpad Widget",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "The HUD Touchpad widget that players can edit in the HUD editor",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "Custom HUD or HUD Widget",
  T_44_XXJ_WS_ICON: "Icon",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "Always Show Mark",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "Always show marks on the compass",
  T_44_XXJ_WS_INACTIVATEDALPHA: "Unactivated Alpha",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "Unactivated alpha",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "When calling, the number of actual parameters does not match that of formal parameters. The expected number is {0}, while the actual is {1}.",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "Is Dynamic Obstacle",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "Is a dynamic obstacle for NavMesh",
  T_44_XXJ_WS_ISEND: "Is End",
  T_44_XXJ_WS_ISEND_D: "IsEnd",
  T_44_XXJ_WS_ISSERVERDRIVEN: "Is Server-Driven",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "If false, then custom objects cannot be controlled by the APIs.",
  T_44_XXJ_WS_ISSUC_D: "Return execution result",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "Joystick Drag Radius",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "Joystick drag radius",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "Joystick Image",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "Joystick image",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "Joystick Radius",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "Joystick radius",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "Character Skill ID List",
  T_44_XXJ_WS_LOOPTYPE_D: "Loop type",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "Quit Midway Config",
  T_44_XXJ_WS_MOUNTABLE: "Hierarchical",
  T_44_XXJ_WS_MOUNTABLE_D: "Entity capable of mounting child nodes",
  T_44_XXJ_WS_MOVEMENT: "Movement",
  T_44_XXJ_WS_NAME_D: "Name",
  T_44_XXJ_WS_NATURALCONST: "Natural Constant",
  T_44_XXJ_WS_NATURALCONST_D: "Enum of natural constants to reduce redundant definitions",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "Play icon animation",
  T_44_XXJ_WS_OFFSET_D: "Default base offset",
  T_44_XXJ_WS_ONFIRE_D: "Triggers the event each time the player shoots, attacks with fists, or attacks with melee weapons.",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "Trigger the event when the player stands up from prone/crouching",
  T_44_XXJ_WS_ONSTARTFIRE_D: "Trigger the event when the player taps the fire button",
  T_44_XXJ_WS_OPTION: "Options",
  T_44_XXJ_WS_PASSIVESKILLHUD: "Passive Skill HUD",
  T_44_XXJ_WS_PHYSICALMOVER: "Physical Mover",
  T_44_XXJ_WS_PHYSICALMOVER_D: "Players on this platform will automatically follow movement and rotation",
  T_44_XXJ_WS_PHYSICALOBJECT: "Physical Object",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "Can apply force to it",
  T_44_XXJ_WS_PI: "Pi",
  T_44_XXJ_WS_PI_D: "The mathematical constant π (Pi) ",
  T_44_XXJ_WS_PLAYERS: "Player List",
  T_44_XXJ_WS_PLAYERS_D: "Player list",
  T_44_XXJ_WS_PLAYERSKILLID: "Character Skill ID",
  T_44_XXJ_WS_PLAYERSKILLID_D: "The character skill ID in AvatarSkill.csv",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "The previous pose before the player stands up",
  T_44_XXJ_WS_PRINT: "Print",
  T_44_XXJ_WS_PRINTERROR: "Print Error",
  T_44_XXJ_WS_PRINTERROR_D: "Print target data as an error to the console",
  T_44_XXJ_WS_PRINTWARNING: "Print Warning",
  T_44_XXJ_WS_PRINTWARNING_D: "Print target data as a warning to the console",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "Prioritize Player Skin Config",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "Prioritize the out-of-match player skin configuration",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "Read the content in cells of a  row by the column number and key",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "Clear player backpack skin configuration",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "Remove a component from an entity. Only supports custom components.",
  T_44_XXJ_WS_RESETBAGSKINID_D: "Reset player backpack skin configuration to its out-of-match configuration",
  T_44_XXJ_WS_SETBAGSKINID_D: "Set player backpack skin configuration",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "Entity supporting the Transform, SkeletonPart, Player, and MountPoint components",
  T_44_XXJ_WS_SHOWBACKGROUND: "Show Background",
  T_44_XXJ_WS_SKINID_D: "Backpack skin ID and skin configuration",
  T_44_XXJ_WS_SPEED_D: "Playback speed",
  T_44_XXJ_WS_TARGET: "Target",
  T_44_XXJ_WS_TARGET_D: "Target object",
  T_44_XXJ_WS_TITLE: "Title",
  T_44_XXJ_WS_TYPEID_D: "Component type ID. Only supports custom components.",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "Upload custom match results",
  T_44_XXJ_WS_WARNINGCSVTYPE: "Type mismatch. Unable to read the table content.",
  T_44_XXJ_WS_X_D: "X-axis coordinate",
  T_44_XXJ_WS_Y_D: "Y-axis coordinate",
  T_44_XYL_WS_CTZSAFEZONE: "Custom Safe Zone",
  T_44_XYL_WS_CTZSAFEZONEDESC: "Generates the start and end point of a Safe Zone based on the set positions and properties",
  T_44_XYL_WS_HEMISPHERICALSHELL: "Hemispherical Shell",
  T_44_XYL_WS_QUARTERCYLINDER: "Quarter Cylinder",
  T_44_XYL_WS_SQUAREPYRAMID: "Square Pyramid",
  T_44_XYL_WS_TORUS: "Torus",
  T_44_XYL_WS_TRIANGULARPYRAMID: "Triangular Pyramid",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "Add Game Event Log Map",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "Add User Event Log",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "The custom match event log used for UX data analysis",
  T_44_YU_WS_ITEM366: "Military Wall A",
  T_44_YU_WS_ITEM367: "Military Wall B",
  T_44_YU_WS_ITEM368: "Military Wall C",
  T_44_YU_WS_ITEM369: "Military Wall D",
  T_44_YU_WS_ITEM370: "Military Window A",
  T_44_YU_WS_ITEM371: "Military Window B",
  T_44_YU_WS_ITEM372: "Military Window C",
  T_44_YU_WS_ITEM373: "Military Door A",
  T_44_YU_WS_ITEM374: "Military Door B",
  T_44_YU_WS_ITEM375: "Military Angled Roof A",
  T_44_YU_WS_ITEM376: "Military Angled Roof B",
  T_44_YU_WS_ITEM377: "Military Stairs A",
  T_44_YU_WS_ITEM378: "Military Stairs B",
  T_44_YU_WS_ITEM379: "Military Pillar A",
  T_44_YU_WS_ITEM380: "Military Handrail A",
  T_45_C_WEAPON_CUST_ENTRANCE: "Customize",
  T_45_CJ_TREATMENTGUN_Y_N: "Heal Pistol-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "Kassie",
  T_45_H_EMOTE_MVPDANCE_N: "Champion's Walk",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "Inspect",
  T_45_HL_Moderation_fail_1: "Unfortunately, your submitted project did not pass the review.",
  T_45_HL_Moderation_fail_2: "involves",
  T_45_HL_Moderation_fail_3: "Reasons included:",
  T_45_HL_Moderation_fail_Location_1: "Game Content",
  T_45_HL_Moderation_fail_reason_1: "Toxic Content",
  T_45_HL_Moderation_fail_reason_10: "Community Guideline Violation",
  T_45_HL_Moderation_fail_reason_11: "Negative Impacts on In-Game Economies and Virtual Property Infringement",
  T_45_HL_Moderation_fail_reason_2: "Inappropriate Content",
  T_45_HL_Moderation_fail_reason_3: "Politically Sensitivity",
  T_45_HL_Moderation_fail_reason_4: "False Information",
  T_45_HL_Moderation_fail_reason_5: "Copyright Infringement",
  T_45_HL_Moderation_fail_reason_6: "Privacy Violation",
  T_45_HL_Moderation_fail_reason_7: "Security Concerns",
  T_45_HL_Moderation_fail_reason_8: "Hate Speech",
  T_45_HL_Moderation_fail_reason_9: "Spam",
  T_45_HL_Moderation_fail_reason_999: "Other Issues",
  T_45_JH_WS_CLEMPTYOBJECT: "Object Group",
  T_45_JH_WS_PETSWITCH1: "Whether to show pets in the match",
  T_45_QL_CSFPP_DES: "Eliminate all opponents through the first-person perspective in this special CS mode!",
  T_45_QL_CSFPP_NAME: "Clash Squad: FPP",
  T_45_QL_CSFPP_RANKNAME: "First-Person",
  T_45_SJ_WS_REVIEW_23: "Game Content",
  T_45_SJ_WS_REVIEW_24: "{0} involves {1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1} involves {2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]Tap to view details >>[-]",
  T_45_SJ_WS_REVIEW_27: "Not Approved",
  T_45_SJ_WS_REVIEW_28: "Review Feedback",
  T_45_SJ_WS_REVIEW_29: "The content involves {0} violation(s)",
  T_45_SJ_WS_REVIEW_31: "Not Approved",
  T_45_SJ_WS_REVIEW_32: "The review failed due to server exceptions",
  T_45_SJ_WS_REVIEW_TITLE: "Details of Violation",
  T_45_SJ_WS_VAULTTRIGGER_DES: "Triggers vaulting (jumping over obstacles)",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "Vault Distance",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "Modifies the distance of vaulting",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "Vault Height",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "Controls the height of moving up and down when vaulting",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "Vault Trigger",
  T_45_TYC_CL_TEMPLATE_WS: `An elimination mode where players take out all opposing teams in a chaotic battle to win.
You can set the gameplay rules and edit the gameplay parameters as you like.`,
  T_45_W_SPEEDMODE_FLIGHT_N: "Skyblaster",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = auto attack, 1 = defensive attack, 2 = do not attack",
  T_45_XXJ_WS_ADDFRIEND: "Add Friend",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "Auto",
  T_45_XXJ_WS_BASEDATA: "Base Data",
  T_45_XXJ_WS_BOTH: "Both",
  T_45_XXJ_WS_BYHIERARCHY: "By Hierarchy",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "By Priority High to Low",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "By Priority Low to High",
  T_45_XXJ_WS_CAMERA: "Camera",
  T_45_XXJ_WS_CAMERATYPE: "Camera Type",
  T_45_XXJ_WS_CENTERINVISIBLE: "Center Invisible",
  T_45_XXJ_WS_CLIENT: "Client",
  T_45_XXJ_WS_COLLIDERID: "Collider ID",
  T_45_XXJ_WS_COLLIDERID_D: "The collider ID",
  T_45_XXJ_WS_COMPONENT: "Component",
  T_45_XXJ_WS_CURRENTCAMERA: "Current Camera",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "Custom Push Force",
  T_45_XXJ_WS_DOUBLE: "Double",
  T_45_XXJ_WS_DUMP: "Throw",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "Enable Move in Midair",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "Enable Rotate with Gravity",
  T_45_XXJ_WS_ENUM: "Enum",
  T_45_XXJ_WS_EVENT: "Event",
  T_45_XXJ_WS_FILLAMOUNT: "Fill Amount",
  T_45_XXJ_WS_FILLDIR: "Fill Direction",
  T_45_XXJ_WS_FIRETYPE: "Fire Type",
  T_45_XXJ_WS_FIRETYPE_D: "The firing type",
  T_45_XXJ_WS_FIXEDDELTATIME: "Fixed Delta Time",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "The fixed time interval for frame updates in milliseconds",
  T_45_XXJ_WS_FORWARD: "Forward",
  T_45_XXJ_WS_FORWARD_D: "The direction of the z-axis in the local coordinate system",
  T_45_XXJ_WS_FUNCTIONTYPE: "Function Type",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "The function type",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "The aiming direction of the local player",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "Get the local timestamp",
  T_45_XXJ_WS_GRADIENT: "Gradient",
  T_45_XXJ_WS_GRADIENTBOTTOM: "Gradient Bottom",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "Gradient Bottom Alpha",
  T_45_XXJ_WS_GRADIENTTOP: "Gradient Top",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "Gradient Top Alpha",
  T_45_XXJ_WS_HITPOSITION_D: "The world position of the target hit by bullets",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "UI Social Button Widget",
  T_45_XXJ_WS_INVERTFILL: "Invert Fill",
  T_45_XXJ_WS_ISGROUNDED: "Is Grounded",
  T_45_XXJ_WS_ISSILENCE: "Is Silence",
  T_45_XXJ_WS_ISSILENCE_D: "If it is silenced or not",
  T_45_XXJ_WS_ISSINGLESHOT: "Is Single Shot",
  T_45_XXJ_WS_ISSINGLESHOT_D: "If it is single-shot or not",
  T_45_XXJ_WS_JUMPHEIGHT: "Jump Height",
  T_45_XXJ_WS_JUMPHEIGHT_D: "The jump height",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "Layout Sort Type",
  T_45_XXJ_WS_LIGHT_D: "Lights",
  T_45_XXJ_WS_LOCAL: "Local",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "Max. Jump Count",
  T_45_XXJ_WS_MODULE: "Module",
  T_45_XXJ_WS_NONE: "None",
  T_45_XXJ_WS_ONBEFOREHURT_D: "Execute the command each time before the entity deals damage",
  T_45_XXJ_WS_ONDISABLE_D: "Execute when the entity is disabled",
  T_45_XXJ_WS_ONEACHLOOP_D: "Execute each time Playable is looped. Only effective on the client side for entities such as Sound Effect and Special Effect.",
  T_45_XXJ_WS_ONENABLE_D: "Execute when the entity is enabled",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "When entering a frame at a fixed rate of 30 FPS",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "Trigger the client event when the player adds or deletes a friend",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "Trigger the event when the game is paused due to the called API",
  T_45_XXJ_WS_ONGAMERESUME_D: "Trigger the event when the game resumes due to the called API",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "When the player stops sprinting",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "When the player stops surfing",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "When the player is surfing",
  T_45_XXJ_WS_PHYSICALLAYER_D: "The custom physical layer within a range of 0 to 31",
  T_45_XXJ_WS_PLATFORMTYPE: "Platform Type",
  T_45_XXJ_WS_PLATFORMTYPE_D: "The platform type",
  T_45_XXJ_WS_PLAYER: "Player",
  T_45_XXJ_WS_PLAYERCCT: "Player CCT",
  T_45_XXJ_WS_PLAYERCCT_D: "A character controller with physical effects and used for Free Fire characters only",
  T_45_XXJ_WS_PRIORITY: "Priority",
  T_45_XXJ_WS_REMAINMULTINUM: "Remain Jump Count",
  T_45_XXJ_WS_REPORT: "Report",
  T_45_XXJ_WS_RIGHT: "Right",
  T_45_XXJ_WS_RIGHT_D: "The direction of the x-axis in the local coordinate system",
  T_45_XXJ_WS_SERVER: "Server",
  T_45_XXJ_WS_SINGLE: "Single",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "Social Button Style Type",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "The social button style",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "Social Button Type",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "The social button type",
  T_45_XXJ_WS_SORTTYPE_D: "Sort types: non-zero ascending, descending, and ascending",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "Move Speed While ADS",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "The movement speed while aiming down sight",
  T_45_XXJ_WS_STRINGORLOCSTRING: "String or Localized String",
  T_45_XXJ_WS_TRIPLE: "Triple",
  T_45_XXJ_WS_UP: "Up",
  T_45_XXJ_WS_UP_D: "The direction of the y-axis in the local coordinate system",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "Use Custom Push Force",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "Throw a signal flare towards the designated area to summon a random vehicle",
  T_45_ZD_VEHICLEDROP_R_NAME: "Mystery Vehicle",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "Lila",
  T_46_HJ_SHARE_GAMEDURATION: "Time Played",
  T_46_HJ_WS_SHAREBY: "By {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "Game Mode",
  T_46_HJ_WS_SHARETEAM: "Team",
  T_46_HJ_WS_SHARETEAMVS: "{0} vs {1}",
  T_46_HX_B_SCHOOL_VN: "Top of Class (Bottom)",
  T_46_HX_H_SCHOOL_VN: "Top of Class (Head)",
  T_46_HX_S_SCHOOL_VN: "Top of Class (Shoes)",
  T_46_HX_T_SCHOOL_VN: "Top of Class (Top)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "Tutorial",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "Others",
  T_46_XXJ_WS_ACTUALPOSITION: "Actual Position",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "Add the object to monitor with AOI synchronization beyond line of sight",
  T_46_XXJ_WS_APPEARANCE: "Appearance",
  T_46_XXJ_WS_APPEARANCERES: "Appearance Resource",
  T_46_XXJ_WS_BECOME: "Activate",
  T_46_XXJ_WS_BRAKETORQUE_D: "The horsepower given to the vehicle when Brake/Reverse is used",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Camera Rotate Angle Restriction Type",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "Clear all monitored objects of the target",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "The maximum crash damage used for damage calculation",
  T_46_XXJ_WS_CRASHMAXSPEED: "Crash Max. Speed",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "Used for crash damage calculation. Once exceeding this speed, no more damage will be added.",
  T_46_XXJ_WS_CRASHMESSFACTOR: "Crash Mass Factor",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "A parameter used in the damage formula for crash damage calculation",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "The minimum crash damage used for damage calculation",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "Read and write limit of data storage has been exceeded",
  T_46_XXJ_WS_DB_PARAMERROR_D: "Parameter exception",
  T_46_XXJ_WS_DB_TIMEOUT_D: "Data storage timeout. Mainly applies to read and write now.",
  T_46_XXJ_WS_DELTA: "Delta",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "Edit Appearance",
  T_46_XXJ_WS_ENDVALUE_D: "The destination value",
  T_46_XXJ_WS_ENGINETORQUE_D: "The horsepower given to the vehicle when the gas pedal is used",
  T_46_XXJ_WS_ERRORCODE_D: "The error code enum",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "Euler Angle to Vector3",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "Convert the Eular angle to a 3D vector",
  T_46_XXJ_WS_EXPIRE: "Expire",
  T_46_XXJ_WS_FEMALEAVATAR: "Female Character",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "Get Membership Expire Date",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "If the observer is monitoring an object or not",
  T_46_XXJ_WS_HELICOPTER: "Skyblaster",
  T_46_XXJ_WS_HELICOPTER_D: "A type of flying vehicle",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "High-Speed Steer Restriction",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "The maximum steering angle while in a high-speed state",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "High-Speed Steer Angle at Speed",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "The speed threshold for the maximum high-speed steering angle",
  T_46_XXJ_WS_IDLE: "Idle Animation",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "Idle Brake Input",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "When not driving a vehicle, decelerate it by (Idle Brake Input) x (Brake Torque).",
  T_46_XXJ_WS_INTTOFLOAT: "Int to Float",
  T_46_XXJ_WS_INTTOFLOAT_D: "Convert an integer to a floating-point number",
  T_46_XXJ_WS_ISPREMIUM: "Is Membership",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "The leaderboard name in the database",
  T_46_XXJ_WS_MALEAVATAR: "Male Character",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "AI Persona",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "New UMA Appearance",
  T_46_XXJ_WS_NONE_D: "No error",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "The NPC object",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "Tips: Humanoid NPCs usually have a collision model with a capsule that is 1.4m tall and 0.25m in radius. Pet NPCs usually have a collision model with a capsule that is 1m tall and 0.4m in radius.",
  T_46_XXJ_WS_OBSERVER_D: "The observer that is monitoring objects",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "On Enter Craftland Membership",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "On Quit Craftland Membership",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "Open Craftland Membership",
  T_46_XXJ_WS_PERSONA: "Persona",
  T_46_XXJ_WS_PERSONACENTER: "Persona Center",
  T_46_XXJ_WS_PET: "Pet",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "Player or Transform",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "An alias for the Player and Transform entity",
  T_46_XXJ_WS_PREMIUM: "Membership",
  T_46_XXJ_WS_PREMIUMSTATUS: "Membership Status",
  T_46_XXJ_WS_PROXYOBSERVER: "Proxy Observer",
  T_46_XXJ_WS_PROXYOBSERVER_D: "The proxy observer",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "Remove the monitored object and cancel the AOI synchronization beyond line of sight",
  T_46_XXJ_WS_RENEWAL: "Renew",
  T_46_XXJ_WS_ROTATEVECTOR: "Rotate Vector",
  T_46_XXJ_WS_ROTATEVECTOR_D: "Rotate a vector based on quaternions",
  T_46_XXJ_WS_SKIN: "Gear",
  T_46_XXJ_WS_STARTVALUE_D: "The source value",
  T_46_XXJ_WS_STATUS: "Status",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "Switch the proxy observer of the User",
  T_46_XXJ_WS_TARGET_D: "The target that is monitored",
  T_46_XXJ_WS_USER_D: "The user",
  T_46_XXJ_WS_VALUE: "Value",
  T_46_XXJ_WS_VALUE_D: "Vector",
  T_46_XYL_WS_CTZSAFEZONEEND: "Safe Zone End Point",
  T_46_XYL_WS_RESOURCETYPE1: "Basic Structures",
  T_46_XYL_WS_RESOURCETYPE1_1: "Geometrics",
  T_46_XYL_WS_RESOURCETYPE1_2: "Visual & Audio",
  T_46_XYL_WS_RESOURCETYPE2: "Scene Items",
  T_46_XYL_WS_RESOURCETYPE2_2: "Battle Supplies",
  T_46_XYL_WS_RESOURCETYPE3: "Nature",
  T_46_XYL_WS_RESOURCETYPE4: "Modular Component",
  T_46_XYL_WS_TYPEOTHERPROP: "Miscellaneous",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "Containers & Boxes",
  T_47_CJ_FOREGRIP_SOFT_N: "Light Foregrip",
  T_47_CJ_MAGEZINE_FAST_N: "Fast Mag",
  T_47_CJ_STOCK_FAST_N: "Power Stock",
  T_47_GT_WS_USERMANUAL: "User Manual",
  T_47_HJ_WS_VFX_FOG: "Fog VFX",
  T_47_HJ_WS_VFX_LIGHTING: "Lighting VFX",
  T_47_HJ_WS_VFX_TRAILING: "Trailing VFX",
  T_47_HL_CL_CREATOR_LABEL1: "Community Talent",
  T_47_HL_CL_MAP_LABEL1: "Selected Works by Community Talents",
  T_47_JH_WS_MODERATION_REASON12: "Gambling-related",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "NARUTO SHIPPUDEN collaboration",
  T_47_SD_RES_MATERIAL: "Material file",
  T_47_SD_RES_MESH: "Mesh",
  T_47_SD_WS_MAPTAG_AI: "AI Map Generate",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "A special knife that sticks to the point of impact after being thrown, triggering a fiery explosion after a short delay to deal burn damage.",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "Fiery Kunai",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "A special knife that sticks to the point of impact after being thrown, triggering a Lightning strike after a short delay to paralyze the target.",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "Lightning Kunai",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "A special knife that sticks to the point of impact after being thrown, triggering a windstorm after a short delay to slow down the target moving towards its center.",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "Wind Kunai",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "A type of shuriken suitable for mid-to-long-range combat. One throw launches one piece quickly, dealing a great amount of damage.",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "Heavy Shuriken",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "A type of shuriken suitable for close-to-mid-range combat with two attack modes. One throw launches three pieces, dealing a small amount of damage.",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "Light Shuriken",
  T_47_XXJ_WS_ACTION: "Action",
  T_47_XXJ_WS_AOISETTING: "AOI Setting",
  T_47_XXJ_WS_BAGSKINTYPE: "Backpack Skin Type",
  T_47_XXJ_WS_CLEARMEMORY: "Clear Memory",
  T_47_XXJ_WS_CLNPC: "Advanced NPC",
  T_47_XXJ_WS_CLOTHTYPE: "Outfit Skin Type",
  T_47_XXJ_WS_COMMON_ERROR: "Common Error",
  T_47_XXJ_WS_CONTENT: "Content",
  T_47_XXJ_WS_CREATERANDOMSEED: "Create Random Seed",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "Elapsed Percentage",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "Enable Fog Feature",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "Enable Light Rotation Feature",
  T_47_XXJ_WS_ERRORCODE: "Error Code",
  T_47_XXJ_WS_EXPONENTIAL: "Exponential",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "Exponential Squared",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "Failed to create room: no valid Persona IDs",
  T_47_XXJ_WS_FOG: "Fog",
  T_47_XXJ_WS_FOGDENSITY: "Fog Density",
  T_47_XXJ_WS_FOGENDDISTANCE: "Fog End Distance",
  T_47_XXJ_WS_FOGMODE: "Fog Mode",
  T_47_XXJ_WS_FOGMODETYPE: "Fog Mode Type",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "Fog Start Distance",
  T_47_XXJ_WS_HEIGHTSCALE: "Height Scale",
  T_47_XXJ_WS_ISVISIBLE: "Is Visible",
  T_47_XXJ_WS_JOINNEWTEAM: "Join New Team",
  T_47_XXJ_WS_JOINTEAM: "Join Team",
  T_47_XXJ_WS_LIGHTROTATE: "Light Rotation",
  T_47_XXJ_WS_LINEAR: "Linear",
  T_47_XXJ_WS_LLMCHATHUD: "UI Persona Chat",
  T_47_XXJ_WS_NEWTEAM: "New Team",
  T_47_XXJ_WS_NEXT: "Next",
  T_47_XXJ_WS_NPC_TIP: "You can edit NPC's appearance and make NPC play animation",
  T_47_XXJ_WS_OBSERVERS: "Observers",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "On Player Send Message by UI Persona Chat",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "On Membership Status Changed",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "On Receive Action From Persona",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "On Receive Content From Persona",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "On Receive Finish From Persona",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "On Receive Status From Persona",
  T_47_XXJ_WS_PARTICLESID: "Particles ID",
  T_47_XXJ_WS_PERSONAAVATAR: "Persona Avatar",
  T_47_XXJ_WS_PERSONAID: "Persona ID",
  T_47_XXJ_WS_PERSONANICKNAME: "Persona Nickname",
  T_47_XXJ_WS_PLAYERORNPC: "Player or NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "Membership Closed",
  T_47_XXJ_WS_RANDOM: "Random",
  T_47_XXJ_WS_SEED: "Seed",
  T_47_XXJ_WS_SENDER: "Sender",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "Set Persona Observer",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "Set Player Can Quit Midway",
  T_47_XXJ_WS_SHOULDREPLY: "Should Reply",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "Show System Reply",
  T_47_XXJ_WS_SPOTANGLE: "Spot Angle",
  T_47_XXJ_WS_SPOTLIGHT: "Spotlight",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "Send System Message To Persona",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "Stream System Messages to Persona",
  T_47_XXJ_WS_TARGETTEAM: "Target Team",
  T_47_XXJ_WS_THISENTITY: "This Entity",
  T_47_XXJ_WS_USERAVATAR: "User Avatar",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "Send User Message To Persona",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "Stream User Messages to Persona",
  T_47_XXJ_WS_USERNICKNAME: "User Nickname",
  T_47_XXJ_WS_VEHICLESKINTYPE: "Vehicle Skin Type",
  T_47_XXJ_WS_WEAPONSKINTYPE: "Weapon Skin Type",
  T_47_XYL_NB_UGC_EFFECT001: "Rasengan VFX",
  T_47_XYL_NB_UGC_EFFECT002: "Chidori VFX",
  T_47_XYL_NB_UGC_EFFECT003: "Cherry Blossom Clash VFX",
  T_47_XYL_NB_UGC_EFFECT004: "Fireball Jutsu VFX",
  T_47_XYL_NB_UGC_EFFECT005: "Water Dragon Jutsu VFX",
  T_47_XYL_NB_UGC_EFFECT006: "Great Breach VFX",
  T_47_XYL_NB_UGC_EFFECT007: "Tailed Beast Bomb VFX",
  T_47_XYL_NB_UGC_EFFECT008: "Reanimation Curse Mark VFX",
  T_47_XYL_UGC_CRAFTLANDSHOP: "Asset Store",
  T_47_XYL_UGC_DONKEYCART: "Donkey Cart",
  T_47_XYL_UGC_SPOTLIGHT: "Spotlight",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "Spotlight Angle",
  T_48_H_EMOTE_WATERFEST25_N: "Swift Steps",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "Motorbike - Sea Foam",
  T_48_HJ_AC_STATENOTEXIST: "The state {0} does not exist in the animation controller",
  T_48_HL_CODESCRIPT: "Code Script",
  T_48_HL_GLOBAL_VAR: "Global Variable Name",
  T_48_HL_GRAPH: "Block",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "Leaderboard",
  T_48_HL_LOCAL_VAR: "Local Variable Name",
  T_48_HL_LOCALIZATION: "Localization Name",
  T_48_HL_OPEN_ATTRIBUTES: "Open Attribute Name",
  T_48_HX_A_WATERFEST25: "Sea Foam (Mask)",
  T_48_HX_B_WATERFEST25: "Sea Foam (Bottom)",
  T_48_HX_F_B_BLACKDRESS: "Antimatter (Bottom)",
  T_48_HX_F_H_BLACKDRESS: "Antimatter (Head)",
  T_48_HX_F_HA_BLACKDRESS: "Antimatter (Facepaint)",
  T_48_HX_F_S_BLACKDRESS: "Antimatter (Shoes)",
  T_48_HX_F_T_BLACKDRESS: "Antimatter (Top)",
  T_48_HX_H_WATERFEST25: "Sea Foam (Head)",
  T_48_HX_HA_WATERFEST25: "Sea Foam (Facepaint)",
  T_48_HX_M_A_BLACKDRESS: "Dark Matter (Mask)",
  T_48_HX_M_B_BLACKDRESS: "Dark Matter (Bottom)",
  T_48_HX_M_H_BLACKDRESS: "Dark Matter (Head)",
  T_48_HX_M_HA_BLACKDRESS: "Dark Matter (Facepaint)",
  T_48_HX_M_S_BLACKDRESS: "Dark Matter (Shoes)",
  T_48_HX_M_T_BLACKDRESS: "Dark Matter (Top)",
  T_48_HX_S_WATERFEST25: "Sea Foam (Shoes)",
  T_48_HX_T_WATERFEST25: "Sea Foam (Top)",
  T_48_JH_WS_STRINGDESC: "Enter a paragraph of text or other strings. Some widgets can display rich text. Add color to text with rich text using the following format: [#XXXXXX] text text [-]. “#XXXXXX” is the color you wish to display. Please note that the text color of the related widget must be set to white.",
  T_48_M_WS_P_ICON: "Avatar",
  T_48_META_API_10001: "Find Entity by ID",
  T_48_META_API_10001_P0: "Entity ID",
  T_48_META_API_1098: "Batch Read Database Sheet Value",
  T_48_META_API_1098_D: "Batch read multiple data entries from a specified database sheet, where the entries of the unique player ID list correspond one-to-one with those of the key list.",
  T_48_META_API_1098_P1: "Account IDs",
  T_48_META_API_1098_P1_D: "The list of unique player IDs, which reads the data corresponding to the keys at the same index in the key list.",
  T_48_META_API_1098_P2: "Keys",
  T_48_META_API_1098_P2_D: "The list of keys, which reads the data corresponding to the unique player IDs at the same index in the ID list.",
  T_48_META_API_1098_P5: "Status Codes",
  T_48_META_API_1098_P5_D: "The list of status codes",
  T_48_META_API_1105: "Notify Start Plot",
  T_48_META_API_1105_D: "Start playing the specified plot for the triggering player",
  T_48_META_API_1105_P1_D: "The plot ID",
  T_48_META_API_1108: "Get Local Language",
  T_48_META_API_1500_P0: "Vector",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "Set Body Part Weight",
  T_48_META_API_3300_D: "Set the weight of the target body part when blending it with other lower-priority animations",
  T_48_META_API_3300_P0_D: "The addable animation controller component that the body part belongs to",
  T_48_META_API_3300_P1: "Body Part Name",
  T_48_META_API_3300_P1_D: "The body part name",
  T_48_META_API_3300_P2: "Weight",
  T_48_META_API_3300_P2_D: "Weight with a value range of [0, 1], representing the degree of blending with lower-priority animations.",
  T_48_META_API_3315: "Play Character Animation Clip Override",
  T_48_META_API_3315_D: "Play a character animation clip with the option to override the game's default animation",
  T_48_META_API_3315_P3: "Override Gameplay Control",
  T_48_META_API_3315_P3_D: "Whether to override the default animation of the game",
  T_48_META_API_3316: "Stop Animation",
  T_48_META_API_3316_D: "Stop playing the animation for the target in the specified status",
  T_48_META_API_90_P1: "Can Quit Midway",
  T_48_META_API_93: "Create Along Path Motion",
  T_48_META_API_93_D: "Create an interpolated movement along a path to make the object move along the specified path",
  T_48_META_API_93_P1: "Path",
  T_48_META_API_93_P1_D: "The path of motion",
  T_48_META_API_93_P3_D: "The magnitude of velocity",
  T_48_META_API_93_P4: "Tangent Facing",
  T_48_META_API_93_P4_D: "Whether the object is facing the direction of movement. This property remains unchanged even if the object's orientation is forcibly modified by other means.",
  T_48_META_API_96: "Instantiate Prefab",
  T_48_META_API_96_D: "Create a prefab instance with the option to process it asynchronously",
  T_48_META_API_96_P2: "Async Load",
  T_48_META_API_96_P2_D: "Whether loading is asynchronous",
  T_48_META_EVT_3140: "On Change Team",
  T_48_META_EVT_3140_D: "Triggers when the team of the current entity changes",
  T_48_META_EVT_3140_P0: "Former Team",
  T_48_META_EVT_3140_P0_D: "The team one belonged to before the change",
  T_48_META_EVT_3140_P1: "Current Team",
  T_48_META_EVT_3140_P1_D: "The team one belongs to after the change",
  T_48_META_EVT_3141: "On Plot Start",
  T_48_META_EVT_3141_D: "Triggers when the plot starts to play",
  T_48_META_EVT_3141_P1: "Plot ID",
  T_48_META_EVT_3141_P1_D: "The plot ID",
  T_48_META_EVT_3142: "On Plot End",
  T_48_META_EVT_3142_D: "Triggers when the plot ends",
  T_48_META_EVT_3142_P0_D: "The triggering player",
  T_48_META_EVT_3142_P1_D: "The plot ID",
  T_48_META_EVT_3143: "On Trigger Plot Option",
  T_48_META_EVT_3143_D: "Triggers when an option is selected in the plot",
  T_48_META_EVT_3143_P1_D: "The plot ID",
  T_48_META_EVT_3143_P2: "Option ID",
  T_48_META_EVT_3143_P2_D: "The ID of the option selected",
  T_48_META_TYP_409_I10: "Change Team Failed_Invalid Team",
  T_48_META_TYP_409_I11: "Change Team Failed_Eliminated",
  T_48_META_TYP_409_I12: "Change Team Failed_In Vehicle",
  T_48_META_TYP_409_I7: "Change Team Failed_Not Supported",
  T_48_META_TYP_409_I8: "Change Team Failed_Already In Team",
  T_48_META_TYP_409_I9: "Change Team Failed_Invalid Target",
  T_48_META_TYP_41_I19: "Disable Collider",
  T_48_META_TYP_417: "Particles",
  T_48_META_TYP_428: "Player Transform or NPC Outfit",
  T_48_META_TYP_431: "Along Path Motion",
  T_48_META_TYP_431_I1: "Path",
  T_48_META_TYP_432: "Custom Curve Path Waypoint",
  T_48_META_TYP_432_I0: "Roll",
  T_48_META_TYP_432_I1: "Tangent",
  T_48_META_TYP_433: "Custom Curve Path Type",
  T_48_META_TYP_433_I0: "Linear",
  T_48_META_TYP_433_I1: "Smooth",
  T_48_META_TYP_433_I2: "Custom",
  T_48_META_TYP_434: "Custom Curve Path",
  T_48_META_TYP_434_I2: "Closed Loop",
  T_48_META_TYP_434_I3: "Waypoints",
  T_48_META_TYP_437_I5: "Score Type Names",
  T_48_META_TYP_437_I6: "Left Score Content",
  T_48_META_TYP_437_I7: "Right Score Content",
  T_48_META_TYP_438_I1: "Players",
  T_48_META_TYP_438_I2: "Ranks",
  T_48_META_TYP_438_I3: "Total Scores",
  T_48_META_TYP_438_I4: "Score Type Names",
  T_48_META_TYP_438_I5: "Colors",
  T_48_META_TYP_438_I6: "Scores",
  T_48_META_TYP_439: "Group",
  T_48_META_TYP_442_I1: "Left Score",
  T_48_META_TYP_442_I10: "Right Eliminated Icon",
  T_48_META_TYP_442_I2: "Right Score",
  T_48_META_TYP_442_I3: "Left Alive Number",
  T_48_META_TYP_442_I4: "Right Alive Number",
  T_48_META_TYP_442_I5: "Left Eliminated Number",
  T_48_META_TYP_442_I6: "Right Eliminated Number",
  T_48_META_TYP_442_I7: "Left Alive Icon",
  T_48_META_TYP_442_I8: "Right Alive Icon",
  T_48_META_TYP_442_I9: "Left Eliminated Icon",
  T_48_META_TYP_444: "Language Type",
  T_48_META_TYP_444_I0: "English",
  T_48_META_TYP_444_I1: "Simplified Chinese",
  T_48_META_TYP_444_I10: "French",
  T_48_META_TYP_444_I11: "German",
  T_48_META_TYP_444_I12: "Turkish",
  T_48_META_TYP_444_I13: "Hindi",
  T_48_META_TYP_444_I14: "Japanese",
  T_48_META_TYP_444_I15: "Romanian",
  T_48_META_TYP_444_I16: "Arabic",
  T_48_META_TYP_444_I17: "Burmese",
  T_48_META_TYP_444_I18: "Urdu",
  T_48_META_TYP_444_I19: "Bengali",
  T_48_META_TYP_444_I2: "Traditional Chinese",
  T_48_META_TYP_444_I3: "Thai",
  T_48_META_TYP_444_I4: "Vietnamese",
  T_48_META_TYP_444_I5: "Indonesian",
  T_48_META_TYP_444_I6: "Portuguese",
  T_48_META_TYP_444_I7: "Spanish",
  T_48_META_TYP_444_I8: "Russian",
  T_48_META_TYP_444_I9: "Korean",
  T_48_SD_ERROR_DIVISOR: "Divisor cannot be 0",
  T_48_SD_ERROR_KEY_NOTINMAP: "The specified key does not exist in map: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "List index out of range: {0}",
  T_48_SD_SK_WARNING: "Did not found {1} in {0}",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: 'Since the attribute "IsServerDriven" of the Craftland character controller {0} is disabled, the related server API does not take effect.',
  T_48_XXJ_WS_PARENTERROR: "Failed to set parent",
  T_48_XXJ_WS_PERFORMANCE: "Performance",
  T_48_XXJ_WS_TANGENT: "Tangent",
  T_48_XXJ_WS_WAYPOINT: "Waypoint",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "List of objects",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "Use Custom Minimap",
  T_48_XYL_UGC_HIDEMINIMAP: "Hide Minimap HUD",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "Basic Custom Surface",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "Cylinder Cutout",
  T_48_XYL_WS_BASICHEMISPHERE: "Basic Hemisphere",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "Quarter Torus",
  T_48_XYL_WS_BASICQUARTERTORUS: "Quarter Square Torus",
  T_48_XYL_WS_BASICROUNDEDTORUS: "Torus",
  T_48_XYL_WS_BASICTRIANGLE: "Triangle Surface",
  T_48_XYL_WS_MAPPLAYERSTIPS: "Match players = Number of teams x Number of players per team. The more match players, the longer the matchmaking time",
  T_48_XYL_WS_MAPPLAYERSWARNING: "A high number of match players may lead to longer matchmaking time",
  T_49_HL_CL_CREATOR_LABEL2: "Craftland Community Talent",
  T_49_HL_CL_MAPS_LABEL2: "Map Winner",
  T_49_HL_CL_MAPS_LABEL3: "Gameplay Winner",
  T_49_HX_T_TUNG: "Tung Tung Tung",
  T_49_HZY_CONTROLLER_TRAJECTORY: "Trajectory",
  T_49_JH_WS_SKILLKASSIE: "Electro Therapy (Kassie)",
  T_49_JH_WS_SKILLKODA: "Aurora Vision (Koda)",
  T_49_JH_WS_SKILLOSCAR: "Valiant Dash (Oscar)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "Generate with AI",
  T_49_META_API_10065: "Switch Custom Camera",
  T_49_META_API_10067: "Get Current Custom Camera",
  T_49_META_API_10069: "Create Custom Camera",
  T_49_META_API_10070: "Set Custom Camera Culling Mask",
  T_49_META_API_10070_D: "Set the culling mask of the target camera to control visibility across all layers",
  T_49_META_API_10071: "Get Custom Camera Culling Mask",
  T_49_META_API_10071_D: "Get the culling mask of the target camera",
  T_49_META_API_10072: "Set Custom Camera Culling Mask Layer",
  T_49_META_API_10072_D: "Set the visibility of the target camera for a specific layer",
  T_49_META_API_10073: "Capture Screenshot",
  T_49_META_API_10073_D: "Capture screenshot (for internal testing)",
  T_49_META_API_106: "Get Server Timestamp (ms)",
  T_49_META_API_106_D: "Get the server timestamp with millisecond precision",
  T_49_META_API_107: "Timestamp to Localized String (ms)",
  T_49_META_API_107_D: "Convert timestamps (in ms) into strings based on certain formats",
  T_49_META_API_107_P0: "Timestamp (ms)",
  T_49_META_API_107_P0_D: "A timestamp in millisecond",
  T_49_META_API_108: "Lerp Vector3",
  T_49_META_API_108_D: "Perform linear interpolation from the 3D vector A to vector B",
  T_49_META_API_1089_P2: "Request ID",
  T_49_META_API_109: "Update Context to Persona",
  T_49_META_API_109_D: "Update the model context of a specified persona in the current room and overwrite the original context after execution.The context will influence the persona's interpretation of the background, history, or certain parameters for the current dialogue.",
  T_49_META_API_109_P1: "Context",
  T_49_META_API_109_P1_D: "Details of the context",
  T_49_META_API_110: "Feedback on Persona Response",
  T_49_META_API_110_D: "Submit feedback on the response content of a persona, which will be used to optimize our model.",
  T_49_META_API_110_P1: "Is Liked",
  T_49_META_API_110_P1_D: "Whether the response is liked or not. True = like.",
  T_49_META_API_1109: "Set Local Player Position",
  T_49_META_API_1109_D: "When the player is using classic game characters, this API can set the player's position.",
  T_49_META_API_1109_P0_D: "The target position",
  T_49_META_API_111: "Slerp Vector3",
  T_49_META_API_111_D: "Perform spherical interpolation from the 3D vector A to vector B for smooth rotation",
  T_49_META_API_1110: "Set Local Player Forward",
  T_49_META_API_1110_D: "When the player is using classic game characters, this API can set the direction the player is facing.",
  T_49_META_API_1110_P0_D: "The forward vector",
  T_49_META_API_112: "Roll Back Persona Memory",
  T_49_META_API_112_D: "Roll back the memory of a persona to before the specific response ID. All memory of the dialogues including and after the response will be cleared.",
  T_49_META_API_113: "Play One-Shot Sound",
  T_49_META_API_113_D: "Play a one-shot sound effect with adjustable volume",
  T_49_META_API_113_P0_D: "The sound effect resource ID to be played",
  T_49_META_API_113_P1: "Volume",
  T_49_META_API_113_P1_D: "The playback volume for the sound effect, ranging from 0 to 1.",
  T_49_META_API_97: "Create Skeleton Part Look-at Controller",
  T_49_META_API_97_D: "After creating a skeleton part look-at controller entity, you can use this entity to control the specified skeleton part and make it always face a specific target.",
  T_49_META_API_97_P0_D: "The skeleton part look-at controller entity. If the entity is destroyed, the look-at functionality will cease.",
  T_49_META_API_97_P1_D: "The skeleton part that is being controlled",
  T_49_META_API_97_P2_D: "The target that is being looked at",
  T_49_META_API_98: "Projection",
  T_49_META_API_98_D: "Calculate the projection of vector A onto vector B",
  T_49_META_API_99: "Get Local Timestamp (ms)",
  T_49_META_API_99_D: "Get the local timestamp with millisecond precision",
  T_49_META_EVT_16_P1_D: "Starting from 0, each outgoing request will consume a sequential numeric ID, such as for creating a room and clearing memory.",
  T_49_META_EVT_16_P2: "Response ID",
  T_49_META_EVT_16_P2_D: "Each complete response will have a unique ID",
  T_49_META_TYP_122_I19: "Custom Material",
  T_49_META_TYP_122_I19_D: "Allow for replacing the skybox with a custom material",
  T_49_META_TYP_14_I78_D: "Get or set the camera entity that is currently rendering the scene on the player's client. Note: The camera entity essentially represents the configuration data for controlling the client-side camera.",
  T_49_META_TYP_335_I9: "Elapsed Time (ms)",
  T_49_META_TYP_335_I9_D: "The playback duration of the sound effect in milliseconds. This property can only be accessed on the client side.",
  T_49_META_TYP_409_I13: "LLM_OK",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_Failed",
  T_49_META_TYP_409_I14_D: "LLM_Failed",
  T_49_META_TYP_409_I15: "LLM_Timeout",
  T_49_META_TYP_409_I15_D: "LLM_Timeout",
  T_49_META_TYP_409_I16: "LLM_Invalid_Persona",
  T_49_META_TYP_409_I16_D: "LLM_Invalid_PersonaOrRoom",
  T_49_META_TYP_409_I17: "LLM_Token_Limit",
  T_49_META_TYP_409_I17_D: "LLM_Token_Limit",
  T_49_META_TYP_409_I18: "LLM_Violation",
  T_49_META_TYP_409_I18_D: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19_D: "LLM_Frequent_Request",
  T_49_META_TYP_441: "Performance ID",
  T_49_META_TYP_445: "Playable Controller ID",
  T_49_META_TYP_446: "Playable Controller Attachable",
  T_49_META_TYP_446_I0: "Playable Controller",
  T_49_META_TYP_447: "Skeleton Part Controller",
  T_49_META_TYP_448: "Skeleton Part Look-at Controller",
  T_49_META_TYP_448_I0: "Controlled Target",
  T_49_META_TYP_448_I1: "Look-at Target",
  T_49_META_TYP_449: "Custom Camera",
  T_49_META_TYP_449_I2: "Orthographic Size",
  T_49_META_TYP_449_I2_D: "Control the size of the area visible to the camera",
  T_49_META_TYP_450: "Timestamp Localized String (ms)",
  T_49_META_TYPE_449_D: "A custom camera is fully controlled by the developer and determines what the player sees during gameplay",
  T_49_META_TYPE_450_D: "Format a millisecond-level timestamp into a readable text format",
  T_49_SD_SEARCH_ICONDESC: "Smart Association",
  T_49_SD_SEARCHKEY_ACTION: "Action",
  T_49_SD_SEARCHKEY_ANICLIPID: "Animation clip ID",
  T_49_SD_SEARCHKEY_AS: "As",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "Attachment ID",
  T_49_SD_SEARCHKEY_AUDIOENUM: "Sound effect type",
  T_49_SD_SEARCHKEY_BAGSKINID: "Backpack skin ID",
  T_49_SD_SEARCHKEY_BEZIER: "Bezier curve",
  T_49_SD_SEARCHKEY_BOOL: "Boolean",
  T_49_SD_SEARCHKEY_BREAK: "Break",
  T_49_SD_SEARCHKEY_BTREEID: "Behavior Tree ID",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "On button clicked",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "On button double clicked",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "On Button pressed",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "On button release",
  T_49_SD_SEARCHKEY_CLOTHENUM: "Outfit type",
  T_49_SD_SEARCHKEY_COLOR: "Color",
  T_49_SD_SEARCHKEY_COMMENT: "Comment note",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "Component enum",
  T_49_SD_SEARCHKEY_CONCANT: "Connect",
  T_49_SD_SEARCHKEY_CONTINUE: "Continue",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "Custom HUD",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "Custom hud widget",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "dynamic create level object type",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "Visual effects type",
  T_49_SD_SEARCHKEY_ENTITY: "Select scene object",
  T_49_SD_SEARCHKEY_FLOAT: "Float",
  T_49_SD_SEARCHKEY_FOR: "For index",
  T_49_SD_SEARCHKEY_FOREACH: "For each",
  T_49_SD_SEARCHKEY_FUNCTION: "Function",
  T_49_SD_SEARCHKEY_GETCSV: "Get CSV",
  T_49_SD_SEARCHKEY_GETREGISTERED: "Get registered asset by key",
  T_49_SD_SEARCHKEY_GETVALUE: "Get property value",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "Get global variable",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "Set Global Variable",
  T_49_SD_SEARCHKEY_IF: "If",
  T_49_SD_SEARCHKEY_IFELSE: "If else",
  T_49_SD_SEARCHKEY_IMGENUM: "Sprite Type",
  T_49_SD_SEARCHKEY_INT: "Integer",
  T_49_SD_SEARCHKEY_INTERNALHUD: "HUD type",
  T_49_SD_SEARCHKEY_ITEMENUM: "Item Type",
  T_49_SD_SEARCHKEY_LISTAPPEND: "List append",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "List append range",
  T_49_SD_SEARCHKEY_LISTCLEAR: "List clear",
  T_49_SD_SEARCHKEY_LISTCLONE: "List clone",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "List contain",
  T_49_SD_SEARCHKEY_LISTCREATE: "List create",
  T_49_SD_SEARCHKEY_LISTDELETE: "Delete List",
  T_49_SD_SEARCHKEY_LISTGET: "Get list",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "List index of",
  T_49_SD_SEARCHKEY_LISTINSERT: "List insert",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "List last index of",
  T_49_SD_SEARCHKEY_LISTLENGTH: "List length",
  T_49_SD_SEARCHKEY_LISTREVERSE: "List reverse",
  T_49_SD_SEARCHKEY_LISTSET: "Set list",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "List shuffle",
  T_49_SD_SEARCHKEY_LOCALKEY: "Localized key",
  T_49_SD_SEARCHKEY_LOCALVAR: "Local variable",
  T_49_SD_SEARCHKEY_LOGICAL: "And or",
  T_49_SD_SEARCHKEY_LOGINFO: "Log info print",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "dict get all keys map get all keys",
  T_49_SD_SEARCHKEY_MAPCLEAR: "clear dict clear map",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "dict contain key map contain key",
  T_49_SD_SEARCHKEY_MAPCREATE: "create dict create map",
  T_49_SD_SEARCHKEY_MAPGET: "get dict value by key get map value by key",
  T_49_SD_SEARCHKEY_MAPLENGTH: "dict length map length",
  T_49_SD_SEARCHKEY_MAPREMOVE: "remove dict remove map",
  T_49_SD_SEARCHKEY_MAPSET: "set dict value set map value",
  T_49_SD_SEARCHKEY_MATH: "add subtract multiply divide",
  T_49_SD_SEARCHKEY_NEWLIST: "New list",
  T_49_SD_SEARCHKEY_NULL: "Null",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "Number to string",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "Particles properties",
  T_49_SD_SEARCHKEY_PERSONA: "Persona",
  T_49_SD_SEARCHKEY_PI: "PI",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "Player Data ID",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "Character skill type",
  T_49_SD_SEARCHKEY_PREEFFECT: "Special sticker type",
  T_49_SD_SEARCHKEY_PREFAB: "Prefab",
  T_49_SD_SEARCHKEY_RAWID: "Raw ID",
  T_49_SD_SEARCHKEY_READSTATIS: "Read accumulated data",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "Resource uuid",
  T_49_SD_SEARCHKEY_RETURN: "Return",
  T_49_SD_SEARCHKEY_SCENEENUM: "Scene file",
  T_49_SD_SEARCHKEY_SCRIPTID: "Script",
  T_49_SD_SEARCHKEY_SETVALUE: "Set property value",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "Special item ID type",
  T_49_SD_SEARCHKEY_TEXT: "Text",
  T_49_SD_SEARCHKEY_TEXTUREID: "Texture type",
  T_49_SD_SEARCHKEY_THISENTITY: "This Entity",
  T_49_SD_SEARCHKEY_TIMELINE: "Timeline",
  T_49_SD_SEARCHKEY_TYPEENUM: "Any type",
  T_49_SD_SEARCHKEY_V2VCREATE: "Create Vector2",
  T_49_SD_SEARCHKEY_V2VGET: "Get Vector2 components",
  T_49_SD_SEARCHKEY_V2VOPERATION: "Vector2 operation add subtract multiply dot product  distance angle",
  T_49_SD_SEARCHKEY_V2VSET: "Set Vector2 components",
  T_49_SD_SEARCHKEY_V3VCREATE: "Create Vector3",
  T_49_SD_SEARCHKEY_V3VGET: "Get Vector3 components",
  T_49_SD_SEARCHKEY_V3VOPERATION: "Vector3 operation add subtract multiply dot product cross product distance angle",
  T_49_SD_SEARCHKEY_V3VSET: "Set Vector3 components",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "Vehicle skin ID",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "Weapon Skin ID",
  T_49_SD_SEARCHKEY_WHILE: "While",
  T_49_SD_SEARCHKEY_WRITESTATIS: "Write accumulated database offset",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "Write accumulated database offset by map code",
  T_49_XXJ_WS_DURATIONS: "Duration (s)",
  T_49_XXJ_WS_EDITPERFORMANCE: "Edit Performance",
  T_49_XXJ_WS_PERFORMANCE: "Performance",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "Delete Performance",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "Deleted performance cannot be restored, continue?",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "Editing {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "This name has already been used, please change it and try again",
  T_49_XXJ_WS_PERFORMANCENAME: "Performance Name",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "Add Key Frame",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "Add Sub-Track",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "Add Track",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "Delete Track",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "Actor Track",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "Event Track",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "Key Frame already exists",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "The corresponding actor track already exists",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "Content",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "Duplicate track names detected. Please change them and try again.",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "Please start recording or choose a key frame first",
  T_49_XXJ_WS_TIMELINE_RECORDING: "Recording...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "Delete Key Frame",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "Scene View",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "Select an object to create a track or tap the add-track button directly",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "Tap the add-track button to create a new track",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "Sub-Track",
  T_49_XXJ_WS_TIMELINE_TRACK: "Track",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "Track View",
  T_49_XYL_WS_DAILYPROPS: "Basic",
  T_49_XYL_WS_STOREGAMPLAY: "Gameplay",
  T_49_YU_QCITEM_ALL_11: "Tung Tung Tung Sahur!",
  T_50_H_M4A1_VA_N: "M4A1 - Trouble Academy",
  T_50_H_MACHETE_VA_N: "Parang - Trouble Academy",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "Leaderboard Fields",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "Overflow",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "Wrap around",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "Shrink font",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "Create Tuple",
  T_50_HJ_SEARCHKEY_TUPLEGET: "Get Tuple",
  T_50_HJ_SEARCHKEY_TUPLESET: "Set Tuple",
  T_50_HJ_TEXTOBGJ_H: "Height",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "Overflow Options",
  T_50_HJ_TEXTOBGJ_W: "Width",
  T_50_HZY_REVIEW_TEXTOBJ: "Text object content",
  T_50_JH_WS_HIDEMAPERROR: "Cannot hide minimap without a custom cover image",
  T_50_JH_WS_HIDEMAPTIP: "When minimap is hidden, it will no longer be used as the cover image",
  T_50_JH_WS_HIDEMINIMAP: "Hide Minimap",
  T_50_META_API_10073_P0: "File Name",
  T_50_META_API_10073_P0_D: "The file name",
  T_50_META_API_10073_P1_D: "The result of the execution. Check the Status Code enum.",
  T_50_META_API_1102: "Read Database Sheet Column Value",
  T_50_META_API_1102_D: "Read the value of a specific column for a given key from a standard database table",
  T_50_META_API_1102_P3: "Column Index",
  T_50_META_API_1102_P3_D: "The column index of the database table (0 = the first column)",
  T_50_META_API_1106: "Create Performance",
  T_50_META_API_1106_D: "Create a performance entity",
  T_50_META_API_1106_P0_D: "The performance asset",
  T_50_META_API_1111: "Read Database Leaderboard Association Value",
  T_50_META_API_1111_D: "Read the combination of values from a leaderboard table and its associated table in the database",
  T_50_META_API_1111_P5: "Association Status Code",
  T_50_META_API_1111_P5_D: "Association Error Code",
  T_50_META_API_1112: "Read Database Leaderboard Association Values by Range",
  T_50_META_API_1112_D: "Read values from the leaderboard table within a specified rank range, read the corresponding values by retrieved keys from the associated table, and combine them.",
  T_50_META_API_1112_P6: "Association Status Code",
  T_50_META_API_1112_P6_D: "Association Error Code",
  T_50_META_API_1113: "Write Database Leaderboard Association Value",
  T_50_META_API_1113_D: "Write the value for a given key into the leaderboard table and its related table in the database",
  T_50_META_API_1113_P5: "Association Status Code",
  T_50_META_API_1113_P5_D: "Association Error Code",
  T_50_META_API_114_D: "Create custom UI",
  T_50_META_API_114_P0_D: "The code is used as the parameter name for creating a UI entity, and its corresponding local variable value represents the created UI entity.",
  T_50_META_API_114_P1_D: "The player entity it belongs to, only visible to the player.",
  T_50_META_API_114_P2: "UI Asset ID",
  T_50_META_API_114_P2_D: "The custom UI asset ID",
  T_50_META_API_115_D: "Create the specified custom UI",
  T_50_META_API_116: "Set Level Object Highlight",
  T_50_META_API_116_D: "Set the highlight status of the object. It may be affected by other in-game logics.",
  T_50_META_API_116_P0_D: "Target Object",
  T_50_META_API_116_P1_D: "Highlight status",
  T_50_META_API_117: "Bitwise Common",
  T_50_META_API_117_D: "Bitwise and/or/xor/left shift/right shift",
  T_50_META_API_117_P0_D: "Left value",
  T_50_META_API_117_P1_D: "Right value",
  T_50_META_API_117_P2_D: "Operation Type",
  T_50_META_API_118: "Bitwise Not",
  T_50_META_API_118_D: "Bitwise NOT, also known as bitwise complement.",
  T_50_META_API_118_P0_D: "Value",
  T_50_META_API_119: "Bitwise List to Int",
  T_50_META_API_119_D: "Perform bitwise OR operation on all list elements and transform the output to an integer value.",
  T_50_META_API_119_P0: "Bit Array",
  T_50_META_API_119_P0_D: "Bitwise array",
  T_50_META_API_120: "Bitwise Int to List",
  T_50_META_API_120_D: "Covert the decimal values represented by bits at position 1 of an integer in its binary form to a list",
  T_50_META_API_120_P0_D: "Integer",
  T_50_META_API_121: "Quaternion Angle",
  T_50_META_API_121_D: "Calculate the angle between two quaternions",
  T_50_META_API_121_P0_D: "Quaternion 1",
  T_50_META_API_121_P1_D: "Quaternion 2",
  T_50_META_API_122: "Quaternion Dot",
  T_50_META_API_122_D: "Calculate the dot product of two quaternions",
  T_50_META_API_123: "Quaternion Inverse",
  T_50_META_API_123_D: "Calculate the inverse of a quaternion",
  T_50_META_API_123_P0_D: "Quaternion",
  T_50_META_API_124: "Quaternion From To Rotation",
  T_50_META_API_124_D: 'Calculate rotation quaternion from "from" to "to"',
  T_50_META_API_124_P0_D: "The start point",
  T_50_META_API_124_P1_D: "The end point",
  T_50_META_API_125: "Quaternion Rotate Towards",
  T_50_META_API_125_D: 'Calculate the rotation quaternion from "from" to "to". Max Degrees Delta is the max. rotation angle.',
  T_50_META_API_125_P0: "From",
  T_50_META_API_125_P0_D: "Initial quaternion",
  T_50_META_API_125_P1: "To",
  T_50_META_API_125_P1_D: "The target quaternion",
  T_50_META_API_125_P2: "Max. Degree Delta",
  T_50_META_API_125_P2_D: "The max. rotation angle",
  T_50_META_API_126: "Get Gyroscope Orientation",
  T_50_META_API_126_D: "Device orientation in 3D space, representing rotation angles around the three axes.",
  T_50_META_API_127: "Get Gyroscope Gravity",
  T_50_META_API_127_D: "The gravity component detected by the sensor on your device",
  T_50_META_API_128: "Get Gyroscope Rotation Rate",
  T_50_META_API_128_D: "This refers to the rotation rate of a device. It is a term related to the gyroscope sensors that describes the device's rotational movement speed in a three-dimensional space.",
  T_50_META_API_129: "Get Gyroscope Rotation Unbiased",
  T_50_META_API_129_D: "Describes the device's rotation rate and provides a more precise result by compensating for the noise or bias of the device's sensors.",
  T_50_META_API_130: "Get Gyroscope User Acceleration",
  T_50_META_API_130_D: "The part of the device's acceleration with the gravity component removed, which is the acceleration caused by user actions or external forces.",
  T_50_META_API_131: "Get Touch Info",
  T_50_META_API_131_D: "Get the specified index screen touch information (including position,  displacement, and change time).",
  T_50_META_API_131_P0_D: "Distribute touch point IDs, starting from 0",
  T_50_META_API_131_P1_D: "Touch position",
  T_50_META_API_131_P2: "Delta Position",
  T_50_META_API_131_P2_D: "The shift in position compared to the last frame",
  T_50_META_API_131_P3: "Delta Time",
  T_50_META_API_131_P3_D: "Time elapsed since last frame",
  T_50_META_API_132: "Get Screen Touch Count",
  T_50_META_API_132_D: "Get the current number of touch points on the screen",
  T_50_META_API_133: "Vibrate Device",
  T_50_META_API_133_D: "Make the device vibrate once",
  T_50_META_API_134_D: "Notify the target player device to play the audio",
  T_50_META_API_134_P0_D: "The target player",
  T_50_META_API_134_P1_D: "The audio asset",
  T_50_META_API_134_P2_D: "The playback speed (valid range: 0.1~3.0; 1 = normal, <1 = slow down, >1 = speed up)",
  T_50_META_API_135_D: "Play the one-time audio file",
  T_50_META_API_135_P0_D: "Audio resources",
  T_50_META_API_135_P1_D: "Play Speed",
  T_50_META_API_136: "Format String",
  T_50_META_API_136_D: "Format the strings",
  T_50_META_API_136_P0_D: "Formatted strings that use Go formatting verb controls",
  T_50_META_API_136_P1: "Parameters Array",
  T_50_META_API_136_P1_D: "Parameter List",
  T_50_META_API_137: "Paste Component",
  T_50_META_API_137_D: "Copy or add component data",
  T_50_META_API_137_P0: "Source",
  T_50_META_API_137_P0_D: "The source entity",
  T_50_META_API_137_P1_D: "Target Entity",
  T_50_META_API_137_P2: "Component Type",
  T_50_META_API_137_P2_D: "Component Type",
  T_50_META_API_137_P3: "Is Success",
  T_50_META_API_137_P3_D: "Whether it is successful or not",
  T_50_META_API_138: "Revive At Next Frame",
  T_50_META_API_138_D: "Revive at the next frame",
  T_50_META_API_139: "Eliminate at Next Frame",
  T_50_META_API_139_D: "Eliminate the battle entity at the next frame",
  T_50_META_API_139_P0_D: "The battle entity",
  T_50_META_API_140: "Quit Game at Next Frame",
  T_50_META_API_140_D: "Exit the game at the next frame",
  T_50_META_API_141: "Get Microphone Volume",
  T_50_META_API_141_D: "Get the microphone volume. Return the status when the player's microphone is off or no access is granted.",
  T_50_META_API_141_P0: "Volume",
  T_50_META_API_141_P0_D: "The microphone volume",
  T_50_META_API_141_P1_D: "Microphone is turned on or off",
  T_50_META_API_142: "Get Render Quality",
  T_50_META_API_142_D: "Get the current rendering quality (enum: Low/Medium/High/Ultra)",
  T_50_META_API_143: "Get Render Resolution",
  T_50_META_API_143_D: "Get the current render resolution",
  T_50_META_API_144: "Bind Custom Player",
  T_50_META_API_144_D: "Dynamically set the target that this player binds to that will override existing bindings. Returns false if failed.",
  T_50_META_API_144_P0: "Custom Player",
  T_50_META_API_144_P0_D: "After binding this Custom Player to the player, data such as position and direction will be automatically synced",
  T_50_META_API_144_P1_D: "Target Player",
  T_50_META_API_145: "Unbind Custom Player",
  T_50_META_API_145_D: "Cancel the binding. Returns false if failed.",
  T_50_META_API_145_P0: "Custom Player",
  T_50_META_API_145_P0_D: "Clear all bindings for this target. After unbinding, data such as position and direction will no longer be automcatically synced.",
  T_50_META_API_146_P0_D: "A custom player",
  T_50_META_API_147: "Set Custom Player State",
  T_50_META_API_147_D: "Automatically upload to the sever and sync with all clients. Returns false if failed.",
  T_50_META_API_147_P0: "Custom Player",
  T_50_META_API_147_P1: "State",
  T_50_META_API_147_P1_D: "Usually used to save the animation states. Get the synced state with Get Custom Player State.",
  T_50_META_API_148: "Get Custom Player State",
  T_50_META_API_148_D: "The state data is automatically synced to the server. Returns false if failed.",
  T_50_META_API_148_P0: "Custom Player",
  T_50_META_API_148_P1: "State",
  T_50_META_API_148_P1_D: "Set the state with Set Custom Player State",
  T_50_META_API_149: "Set Distance Volumes",
  T_50_META_API_149_D: "Set the distance ranges between players to dynamically set audio volume.",
  T_50_META_API_149_P0: "Distance List",
  T_50_META_API_149_P0_D: "A list of distance ranges, each corresponding to an element in the volume list.",
  T_50_META_API_149_P1: "Volume List",
  T_50_META_API_149_P1_D: "A list of volumes, each corresponding to an element in the distance list.",
  T_50_META_API_150: "Get Friends",
  T_50_META_API_150_D: "Get the list of the player's friend IDs",
  T_50_META_API_151: "Get Default UI Info",
  T_50_META_API_151_D: "Get the default UI location of the player",
  T_50_META_API_151_P0_D: "The default interface",
  T_50_META_API_151_P1_D: "Status",
  T_50_META_API_151_P2_D: "UI Position",
  T_50_META_API_151_P3: "Size",
  T_50_META_API_151_P3_D: "UI Size",
  T_50_META_API_152: "Broadcast Custom Event",
  T_50_META_API_152_D: "Broadcast a custom event for any entity to receive (listen to) this event",
  T_50_META_API_153: "Dispatch Event to Entity",
  T_50_META_API_153_D: "Send the custom event to the target entity",
  T_50_META_EVT_17: "On Screen Touch Begin",
  T_50_META_EVT_17_D: "Start the event when the screen is touched",
  T_50_META_EVT_17_P0: "Touch Index",
  T_50_META_EVT_17_P0_D: "Touch point index",
  T_50_META_EVT_17_P1_D: "Touch position",
  T_50_META_EVT_18: "On Screen Touch End",
  T_50_META_EVT_18_D: "End the event when the screen is touched",
  T_50_META_EVT_18_P0: "Touch Index",
  T_50_META_EVT_18_P0_D: "Touch point index",
  T_50_META_EVT_18_P1_D: "Touch positions on the screen",
  T_50_META_EVT_19: "On Receive Persona Create Room Result",
  T_50_META_EVT_19_D: "Receive the corresponding result when failed to create the persona chat room",
  T_50_META_EVT_19_P1: "Room ID",
  T_50_META_EVT_19_P1_D: "The room ID",
  T_50_META_EVT_20: "On User Quit or User Match End",
  T_50_META_EVT_20_D: "Trigger when the user quits the match or when the match ends",
  T_50_META_TYP_11_I44: "Distance Volumes",
  T_50_META_TYP_11_I44_D: "Dynamically adjust the audio volume based on the distance between players",
  T_50_META_TYP_22_I9_D: "The asset ID used to create the UI",
  T_50_META_TYP_244_I12_D: "The text box width",
  T_50_META_TYP_244_I13_D: "The text box height",
  T_50_META_TYP_244_I14_D: "The overflow type",
  T_50_META_TYP_335_I10_D: "The playback speed (valid value > 0, default = 1)",
  T_50_META_TYP_409_I20: "IO_Create_File_Failed",
  T_50_META_TYP_409_I20_D: "IO operation failed: an error occurred while creating the file.",
  T_50_META_TYP_409_I21: "IO_Invalid_File_Name",
  T_50_META_TYP_409_I21_D: "IO operation failed. Invalid file name.",
  T_50_META_TYP_448_I0_D: "The controlled skeleton part",
  T_50_META_TYP_448_I1_D: "The target that the skeleton part is looking at",
  T_50_META_TYP_451: "Overflow Type",
  T_50_META_TYP_451_D: "The method for handling text overflow",
  T_50_META_TYP_452: "Custom UI Asset ID",
  T_50_META_TYP_452_D: "The ID that describes the custom HUD asset",
  T_50_META_TYP_453: "Render Quality Type",
  T_50_META_TYP_453_D: "The rendering quality enum",
  T_50_META_TYPE_448_D: "This entity is used to control the skeleton part to look at a target",
  T_50_SD_WS_MAPTAG_AI3DGEN: "3D Object Generate Map",
  T_50_SD_WS_MAPTAG_AIRACING: "Racing AI Generate Map",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "Animation state name enum",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "Disable Footsteps Vibration",
  T_50_XXJ_WS_NOPERFORMANCE: "No performance file yet",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "Beta version",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "Dear creators, the performance editor is still in the testing phase. It may contain bugs or lack essential features. Please use it with caution.",
  T_50_XXJ_WS_PERFORMANCE_NEW: "Add Performance",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "Add Key Clip",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "Along Path Track",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "Animation",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "Animation Track",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "Audio Track",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "Hold",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "Loop Forever",
  T_50_XXJ_WS_TIMELINE_DURATION: "Duration: {0}s",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "Mismatch between animation and model",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "Key clip overlap",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "Bound entity missing",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "The track name cannot be empty",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "NPC Track",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "Property Track",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "Remove Key Clip",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0}s",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "Track count limit exceeded",
  T_50_XYL_WS_AIGETERATESHOW: "Building Blocks",
  T_50_YU_F_B_VA_WITCH: "Mystic Trouble (Bottom)",
  T_50_YU_F_H_VA_WITCH: "Mystic Trouble (Head)",
  T_50_YU_F_HA_VA_WITCH: "Mystic Trouble (Facepaint)",
  T_50_YU_F_S_VA_WITCH: "Mystic Trouble (Shoes)",
  T_50_YU_F_T_VA_WITCH: "Mystic Trouble (Top)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "Custom Event",
  T_51_GT_WS_BASIC: "Basic",
  T_51_GT_WS_GLOBALEVENT: "Global Event",
  T_51_GT_WS_PRIVATEEVENT: "Private Event",
  T_51_GT_WS_STORY: "Story",
  T_51_GT_WS_UI: "UI",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "User Message To Persona Voice Response",
  T_51_META_API_1114_D: "Send persona user's message and get a voice response from persona",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "System Message To Persona Voice Response",
  T_51_META_API_1115_D: "Send persona system message and get a voice response from persona",
  T_51_META_API_1116: "Play Stored Voice From Persona",
  T_51_META_API_1116_D: "Play stored voice reponses from persona. Can store up to 10 responses.",
  T_51_META_API_144_P2_D: "Whether the execution is successful",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Return the name of the target object's type",
  T_51_META_API_154_P0_D: "The target object to get type name for",
  T_51_META_API_155: "Get Bounding Box",
  T_51_META_API_155_D: "Get the Bounding Box of the scene object",
  T_51_META_API_155_P0_D: "The scene object to get the bounding box for",
  T_51_META_API_155_P1_D: "The center of the bounding box",
  T_51_META_API_155_P2: "Size",
  T_51_META_API_155_P2_D: "The size of the bounding box",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "The target entity to be created",
  T_51_META_API_156_P1_D: "The type of the created custom component",
  T_51_META_API_156_P2_D: "The owner of the entity",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Set Material Property",
  T_51_META_API_157_D: "This API allows you to modify certain properties of an object's material.",
  T_51_META_API_157_P0_D: "The target object to get the material property for",
  T_51_META_API_157_P1: "Property Name",
  T_51_META_API_157_P1_D: "Set the name of the property",
  T_51_META_API_157_P2: "Property Value",
  T_51_META_API_157_P2_D: "Set the value of the property",
  T_51_META_API_157_P3: "Success",
  T_51_META_API_157_P3_D: "Set whether it's successful or not",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "The target object to clear the material property for",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "When a monitored custom property changes, this event will trigger. Note: if a custom property is modified multiple times within a single frame, this event is only triggered once. When the server modifies a custom property, the event is sent to both endpoints; when a client modifies a local entity's custom property, the event is only delivered locally.",
  T_51_META_EVT_21_P0: "Property Index",
  T_51_META_EVT_21_P0_D: "The property's index",
  T_51_META_EVT_21_P1_D: "The property's new value",
  T_51_META_EVT_22: "On Custom Player State Changed",
  T_51_META_EVT_22_D: "This event will trigger when the state of the custom player changes",
  T_51_META_EVT_22_P0: "Custom Player State",
  T_51_META_EVT_22_P0_D: "The state of the custom player",
  T_51_META_EVT_23: "On Receive Voice Response From Persona",
  T_51_META_EVT_23_D: "Trigger this event when persona's voice response is received",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "Trigger this event when persona's voice response has finished playing",
  T_51_META_TYP_14_I79: "Bound Custom Player",
  T_51_META_TYP_14_I79_D: "When bound to a Custom Player, the classic character model is hidden, and the target object's position, rotation (facing), and other data are synchronized to it.",
  T_51_META_TYP_15_I6: "Is Show Teammate Name",
  T_51_META_TYP_15_I6_D: "Whether to show teammates' names on the top of their heads",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "Give Up",
  T_51_META_TYP_247_I32_D: "Give Up",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Out-of-zone damage per second",
  T_51_META_TYP_409_I22: "Parameter Error",
  T_51_META_TYP_409_I22_D: "Parameter error",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "Use to set the material property for an object",
  T_51_META_TYP_455: "Entity Flag",
  T_51_META_TYP_455_D: "The property flag for a specific entity, can be used in combination",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "Static",
  T_51_META_TYP_455_I1_D: "Static entity",
  T_51_META_TYP_455_I2: "Local",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "Render Only",
  T_51_META_TYP_455_I3_D: "Render only",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Raining",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Lightning",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Unboxing",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Set Entity Outline",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value between 0 and 1 (0 = fully transparent,1 = fully opaque)",
  T_51_TYC_API_OUTLINE_COLOR: "Outline Color",
  T_51_TYC_API_OUTLINE_COLOR_D: "The color used for drawing the outline",
  T_51_TYC_API_OUTLINE_D: "Specifies an entity to highlight its edges. Supported types include Player, Custom Render, NPC, Appearance, and Basic Appearance.",
  T_51_TYC_API_OUTLINE_TARGET: "Target Entity",
  T_51_TYC_API_OUTLINE_TARGET_D: "The entity to be outlined",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value between 0 and 1 (0 = no outline, 1 = max. outline thickness)",
  T_51_XJ_WS_BASIC_SETTING: "Basic Settings",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Second",
  T_51_XJ_WS_GMSTART_TIME: "Preparation time before game starts",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "Read-only Property",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "Black Leather Jacket (Female)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "Mushroom hunter",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "Black Activewear (Shoes)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "GW2018 Hotpants (Female)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "GW2018 Skirt (Female)",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "Black Activewear (Hoodie)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "Songkran Top (black)",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "Plumber top (female)",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "GW2018 Singlet (Female)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "White Prosperity (Bottom)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "Black Trackpants (Male)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "Poacher",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "Survivor Pants",
  TXT_AVATAR_MALE_PANTS_MARIO: "Mamamia",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "Survivor Shoes",
  TXT_AVATAR_MALE_SHOE_RED: "Red Boots (Male)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "White Prosperity (Top)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "Black Baseball Jersey (Male)",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "Rebel Hoodie",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "Cool Activewear (Hoodie)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "Skull King Vest",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "Survivor Shirt",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "Plumber top (male)",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "Racer Jacket (Female)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "Night Clown (Head)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "Racer Jacket (Male)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "Sleeveless Jacket (Green)",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "Mr. Squido",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "Zombified Samurai (Mask)",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "Full Arm Tattoo",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "Embrace",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "Victoria",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Stylish & Retro",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "Kitsune Bottom",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "Kitsune Footwear",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "Sports Shoes (Blue)",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "Denim Shorts (Female)",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "Kitsune Robe",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "Combat Pants (Male)",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Angelic pants",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "Bushido Bottom",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "Grey Zipper Hoodie",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "Hipster shoes",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "Bushido Footwear",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "Astro shoes",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "Denim Shorts (Male)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "Combat Vest (Male)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "Hipster Top",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "Way of the Bushido",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "White Hurricane",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "Baseballer (Tights)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "Rider Jacket (Female)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "Baseballer (Jacket)",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "Cool Captain (Pants)",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "The Streets (Head)",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "Cool Captain (Shoes)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "Rider Jacket (Male)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "Cool Captain (Jacket)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "Dino",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "Silver Boot",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "Three Lions",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "Tuxedo (Mask)",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "Tuxedo (Head)",
  TXT_AVATAR_PARACHUTE_8: "Parachute - Smiley",
  TXT_AVATAR_SHIRT_PLAID_2: "Programmers' Favorite (Red)",
  TXT_AVATAR_SHOES_1: "Sneakers (White)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "Schoolgirl (Orange)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "Schoolgirl (Red)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "Schoolgirl (Yellow)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "Schoolgirl (Pink)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "Schoolgirl (Jasmine)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "Schoolgirl (Blue)",
  TXT_AVATAR_TSHIRT_WEEK_007: "STARRY SUN",
  TXT_BANNER_NAME_MISHA: "Speed",
  TXT_CHARACTER_ADAM_NAME: "Primis",
  TXT_CHARACTER_BODYGUARD_NAME: "Nikita",
  TXT_CHARACTER_COP_NAME: "Andrew",
  TXT_CHARACTER_EVA_NAME: "Nulla",
  TXT_CHARACTER_NURSE_NAME: "Olivia",
  TXT_CHARACTER_RACERGIRL_NAME: "Misha",
  TXT_CHARACTER_RUNNER_NAME: "Kelly",
  TXT_CHARACTER_SEAMAN_NAME: "Ford",
  TXT_CLAN_NAME: "Name",
  TXT_COLLECTION_DESCRIPTION: "Description",
  TXT_COLLECTION_HEADPORTRAIT: "Avatar",
  TXT_INVENTORY_TITLE_EQUIPMENT: "Equipment",
  TXT_ITEM_AK: "AK47",
  TXT_ITEM_ARAMMO: "AR Ammo",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "Bag Lv. 1",
  TXT_ITEM_BAG2: "Bag Lv. 2",
  TXT_ITEM_BAG3: "Bag Lv. 3",
  TXT_ITEM_BASEBALLPOLE: "Bat",
  TXT_ITEM_BOWAMMO: "Crossbow Bolt",
  TXT_ITEM_CHANGUO: "Pan",
  TXT_ITEM_CROSSBOW: "Crossbow",
  TXT_ITEM_DESC_FLASH: "An explosive device that can disorient enemy's senses temporarily.",
  TXT_ITEM_EAGLE: "Desert Eagle",
  TXT_ITEM_FAK: "Med Kit",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "Fist",
  TXT_ITEM_FLASH: "Flashbang",
  TXT_ITEM_FOREGRIP1: "Foregrip Lv. 1",
  TXT_ITEM_FOREGRIP2: "Foregrip Lv. 2",
  TXT_ITEM_FOREGRIP3: "Foregrip Lv. 3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "Grenade",
  TXT_ITEM_GROZA: "Groza",
  TXT_ITEM_HANDCANNON: "Hand Cannon",
  TXT_ITEM_HEATSIGHT: "Thermal Scope",
  TXT_ITEM_HELMET1: "Helmet Lv. 1",
  TXT_ITEM_HELMET2: "Helmet Lv. 2",
  TXT_ITEM_HELMET3: "Helmet Lv. 3",
  TXT_ITEM_HGAMMO: "HG Ammo",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "40mmSR",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "Parang",
  TXT_ITEM_MAGEZINE1: "Magazine Lv. 1",
  TXT_ITEM_MAGEZINE2: "Magazine Lv. 2",
  TXT_ITEM_MAGEZINE3: "Magazine Lv. 3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "Muzzle Lv. 1",
  TXT_ITEM_MUZZLE2: "Muzzle Lv. 2",
  TXT_ITEM_MUZZLE3: "Muzzle Lv. 3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "SG Ammo",
  TXT_ITEM_SIGHT2: "2x Scope",
  TXT_ITEM_SIGHT4: "4x Scope",
  TXT_ITEM_SILENCER1: "Silencer",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "SMG Ammo",
  TXT_ITEM_SNAMMO: "Sniper Ammo",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "Vest Lv. 1",
  TXT_ITEM_VEST2: "Vest Lv. 2",
  TXT_ITEM_VEST3: "Vest Lv. 3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "Result",
  TXT_MESSAGEBOX_ERROR: "Error",
  TXT_OB10_HQW_ITEM_BIPOD: "Bipod",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "Oil Barrel",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "Miguel",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "Crazy Slayer",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "Bat - Mexican Grilled Corn",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "Explosion Range",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "Parang - The Executioner",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "Landmine",
  TXT_OB11_HQW_LANDMINE_DESC: "A mine that can be deployed on the ground. Warning, do not step on it yourself!",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "Caroline",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "Applause",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "Dab",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "Chicken",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "Hello!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "LOL",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "Provoke",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "When holding a shotgun, movement speed increases by [FFB300]{0}%[-].",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "Agility",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "Cheetah: Fang",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "Futuristic",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "Repair Kit",
  TXT_OB5_HISTORY_HEADSHOOT: "Headshots",
  TXT_OB5_HISTORY_LIVE: "Survival",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "Maxim",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "Eating mushrooms and using Med Kits faster by [FFB300]{0}%[-].",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "Gluttony",
  TXT_OB7_ZC_CLAN_NICKNAME: "Nickname",
  TXT_OB7_ZJS_HISTORY_TIME: "Time",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "Bonfire",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "Parachute - Bolt",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "Kla",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "Fist damage increases by [FFB300]{0}%[-]",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "Muay Thai",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "Purple Meadows",
  TXT_OB8_ZXR_G18_CAMO_NAME: "Atom Splitter",
  TXT_OB8_ZXR_M249_CAMO_NAME: "Withered",
  TXT_OB8_ZXR_M79_CAMO_NAME: "Skysplitter",
  TXT_OB8_ZXR_USP_CAMO_NAME: "Snow Leopard",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "Paloma",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "Arms-dealing",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "Skyboard - Green Star",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "Gloo Wall",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "Digital Camouflage",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "Bloody Mary",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "Desert Hunter",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "Blueflame",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "Purple Parade",
  TXT_OB9_ZXR_M14_CAMO_NAME: "Lifestream",
  TXT_OB9_ZXR_M1873_NAME: "Deep Blue Sea",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "Parang - Swordfish",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "Harvester",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "Purple Quartz",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "Scorched Earth",
  TXT_OPTION_HIGH_BRIGHTNESS: "Bright",
  TXT_PLAYER_RANK: "RANK",
  TXT_ROOM_LOBBY_ID: "ID",
  TXT_ROOM_MAP_PARADISE: "Bermuda",
  TXT_SETTING_CHANGEWEAPON: "Quick Weapon Switch Button",
  TXT_SETTING_OB4_NOTREAL: "Dark",
  TXT_SKILL_DESC_COP: "Armor durability loss decreases by [FFB300]{0}%[-].",
  TXT_SKILL_DESC_RUNNER: "Sprinting speed increases by [FFB300]{0}%[-].",
  TXT_SKILL_NAME_COP: "Armor Specialist",
  TXT_SKILL_NAME_NURSE: "Healing Touch",
  TXT_SKILL_NAME_RACERGIRL: "Afterburner",
  TXT_SKILL_NAME_RUNNER: "Dash",
  TXT_SKILL_NAME_SEAMAN: "Iron Will",
  TXT_TUTORIAL_HUD: "HUD",
  TXT_TUTORIAL_HUD_LABEL10: "Sprint",
  TXT_TUTORIAL_PICKUP_LABEL0: "Weapon",
  T_34_M_WS_VFXTYPE: "VFX Type",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "Target of attack",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "Player UI type",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "Monster Skill Type",
  T_45_META_WS_DESCRIPTIVECOLOR: "Descriptive Color",
  T_45_META_WS_GAMETIME: "Game Time",
  T_45_META_WS_PROPERTY: "Property",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "UI Social Button Style Type",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "UI Social Button Type",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "Acceleration",
  T_46_META_WS_A_ACCOUNTID: "Account Id",
  T_46_META_WS_A_ACTIONTYPE: "Action Type",
  T_46_META_WS_A_ACTIVE: "Active",
  T_46_META_WS_A_ANGLE: "Angle",
  T_46_META_WS_A_ANY: "Any",
  T_46_META_WS_A_APPEARANCEGROUP: "Appearance Group",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "Assertion Expression",
  T_46_META_WS_A_ATTACHMENT: "Attachment",
  T_46_META_WS_A_ATTACHMENTS: "Attachments",
  T_46_META_WS_A_ATTACKABLE: "Attackable",
  T_46_META_WS_A_ATTACKER: "Attacker",
  T_46_META_WS_A_ATTACKTARGET: "Attack Target",
  T_46_META_WS_A_AUTOPLAY: "Auto Play",
  T_46_META_WS_A_AXIS: "Axis",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "Base",
  T_46_META_WS_A_BOUNDTARGET: "Bound Target",
  T_46_META_WS_A_BTREE: "Behavior Tree",
  T_46_META_WS_A_BUFF: "Buff",
  T_46_META_WS_A_CAMERA: "Camera",
  T_46_META_WS_A_CAPICITY: "Capacity",
  T_46_META_WS_A_CENTER: "Center",
  T_46_META_WS_A_CHANGEROTATION: "Change Rotation",
  T_46_META_WS_A_CHANNEL: "Channel",
  T_46_META_WS_A_CHASEENEMY: "Chase Enemy",
  T_46_META_WS_A_CHILD: "Child",
  T_46_META_WS_A_COLOR: "Color",
  T_46_META_WS_A_COLUMN: "Column",
  T_46_META_WS_A_COLUMNNAME: "ColumnName",
  T_46_META_WS_A_COMEBACK: "Come Back",
  T_46_META_WS_A_COMPONENT: "Component",
  T_46_META_WS_A_CONTENT: "Content",
  T_46_META_WS_A_COORDINATESYSTEM: "Coordinate System",
  T_46_META_WS_A_COUNT: "Count",
  T_46_META_WS_A_COUNTS: "Counts",
  T_46_META_WS_A_CREATEDENTITY: "Created Entity",
  T_46_META_WS_A_CROSSPLATFORM: "Cross Platform",
  T_46_META_WS_A_CULLINGMASK: "Culling Mask",
  T_46_META_WS_A_CURVE: "Curve",
  T_46_META_WS_A_CUSTOMTAG: "Custom Tag",
  T_46_META_WS_A_CUTRADIUS: "Cut Radius",
  T_46_META_WS_A_DAMAGE: "Damage",
  T_46_META_WS_A_DAMAGESEGMENTS: "Damage Segments",
  T_46_META_WS_A_DEGREE: "Degree",
  T_46_META_WS_A_DELTA: "Delta",
  T_46_META_WS_A_DEPTH: "Depth",
  T_46_META_WS_A_DESTVAL: "Destination Value",
  T_46_META_WS_A_DIFFICULTY: "Difficulty",
  T_46_META_WS_A_DIRECTION: "Direction",
  T_46_META_WS_A_DISABLE: "Is Disabled",
  T_46_META_WS_A_DISPLACEMENT: "Displacement",
  T_46_META_WS_A_DISTANCE: "Distance",
  T_46_META_WS_A_DIVINGMAXSPEED: "Diving Max. Speed",
  T_46_META_WS_A_DOTWEEN: "Do Tween",
  T_46_META_WS_A_DURATION: "Duration (s)",
  T_46_META_WS_A_EMOTE: "Emote",
  T_46_META_WS_A_ENABLE: "Enable",
  T_46_META_WS_A_ENDAREACENTER: "End Area Center",
  T_46_META_WS_A_ENDAREARANGE: "End Area Range",
  T_46_META_WS_A_ENDPOSITION: "End Position",
  T_46_META_WS_A_ENDRANK: "End Rank",
  T_46_META_WS_A_EQUIPMENTS: "Equipments",
  T_46_META_WS_A_EVENTID: "Event ID",
  T_46_META_WS_A_EXPONENT: "Exponent",
  T_46_META_WS_A_FACTION: "Faction",
  T_46_META_WS_A_FACTORTYPE: "FactorType",
  T_46_META_WS_A_FILTERTYPE: "Filter Type",
  T_46_META_WS_A_FINALRADIUS: "Final Radius",
  T_46_META_WS_A_FINDVALUE: "Find Value",
  T_46_META_WS_A_FIXEDRANGE: "Fixed Range",
  T_46_META_WS_A_FOLLOWTARGET: "Follow Target",
  T_46_META_WS_A_FONTCOLOR: "Font Color",
  T_46_META_WS_A_FONTSIZE: "Font Size",
  T_46_META_WS_A_FOOTBALL: "Football",
  T_46_META_WS_A_FORCE: "Force",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "Forced Parachute Height",
  T_46_META_WS_A_FORCEMODE: "ForceMode",
  T_46_META_WS_A_FORWARD: "Forward",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "Game ID",
  T_46_META_WS_A_HALFEXTENTS: "Half Extents",
  T_46_META_WS_A_HEIGHT: "Height",
  T_46_META_WS_A_HEIGHTSEGMENTS: "Height Segments",
  T_46_META_WS_A_HITDISTANCE: "Hit Distance",
  T_46_META_WS_A_HITDISTANCES: "Hit Distances",
  T_46_META_WS_A_HITENTITIES: "Hit Entities",
  T_46_META_WS_A_HITENTITY: "Hit Entity",
  T_46_META_WS_A_HITNORMAL: "Hit Normal",
  T_46_META_WS_A_HITNORMALS: "Hit Normals",
  T_46_META_WS_A_HITPOINTS: "Hit Points",
  T_46_META_WS_A_HITPOSITION: "Hit Position",
  T_46_META_WS_A_INCLUDETRIGGER: "Include Trigger",
  T_46_META_WS_A_INDEX: "Index",
  T_46_META_WS_A_INDEXS: "Indexs",
  T_46_META_WS_A_INITIALVELOCITY: "Initial Velocity",
  T_46_META_WS_A_INITRADIUS: "Initial Radius",
  T_46_META_WS_A_INWALLET: "InWallet",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "Is Bottom Colliding",
  T_46_META_WS_A_ISEXIST: "IsExist",
  T_46_META_WS_A_ISLOOP: "Is Loop",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "Is Mapped In Screen",
  T_46_META_WS_A_ISPAUSE: "Is Pause",
  T_46_META_WS_A_ISSIDECOLLIDING: "Is Side Colliding",
  T_46_META_WS_A_ISSUCCESS: "Is Success",
  T_46_META_WS_A_ISTOPCOLLIDING: "Is Top Colliding",
  T_46_META_WS_A_ITEM: "Item",
  T_46_META_WS_A_ITEMID: "Item ID",
  T_46_META_WS_A_ITEMS: "Items",
  T_46_META_WS_A_ITEMTYPE: "Item Type",
  T_46_META_WS_A_JERSEYTYPE: "Jersey Type",
  T_46_META_WS_A_KEEPVELOCITY: "Keep Velocity",
  T_46_META_WS_A_KEY: "Key",
  T_46_META_WS_A_KEYCOLUMN: "KeyColumn",
  T_46_META_WS_A_KEYS: "Keys",
  T_46_META_WS_A_LAYER: "Layer",
  T_46_META_WS_A_LAYERMASK: "Layer Mask",
  T_46_META_WS_A_LEFT: "Left",
  T_46_META_WS_A_LEFTVALUE: "Left Value",
  T_46_META_WS_A_LENGTH: "Length",
  T_46_META_WS_A_LEVELOBJECT: "Level Object",
  T_46_META_WS_A_LOG: "Log",
  T_46_META_WS_A_LOOKATTARGET: "Look At Target",
  T_46_META_WS_A_LOOPTYPE: "Loop Type",
  T_46_META_WS_A_MAINCOLOR1: "Main Color1",
  T_46_META_WS_A_MAINCOLOR2: "Main Color2",
  T_46_META_WS_A_MAPCODE: "Map Code",
  T_46_META_WS_A_MAPPEDPOSITION: "Mapped Position",
  T_46_META_WS_A_MAX: "Max",
  T_46_META_WS_A_MAXDISPLACEMENT: "Max. Displacement",
  T_46_META_WS_A_MAXDISTANCE: "Max. Distance",
  T_46_META_WS_A_MIN: "Min",
  T_46_META_WS_A_MISSIONID: "Mission ID",
  T_46_META_WS_A_MISSIONPROGRESS: "MissionProgress",
  T_46_META_WS_A_MODIFYTYPE: "ModifyType",
  T_46_META_WS_A_MONEYTYPE: "Money Type",
  T_46_META_WS_A_MUST: "Must",
  T_46_META_WS_A_NAME: "Name",
  T_46_META_WS_A_NEWVALUE: "New Value",
  T_46_META_WS_A_NODE: "Node",
  T_46_META_WS_A_NORMAL: "Normal",
  T_46_META_WS_A_NOT: "Not",
  T_46_META_WS_A_OBSERVER: "Observer",
  T_46_META_WS_A_OFFSET: "Offset",
  T_46_META_WS_A_OLDVALUE: "Old Value",
  T_46_META_WS_A_OPERATIOMETHOD: "Operation Method",
  T_46_META_WS_A_OPTIONS: "Options",
  T_46_META_WS_A_OTHERCOLOR: "Other Color",
  T_46_META_WS_A_OUTFIT: "Outfit",
  T_46_META_WS_A_OUTFITS: "Outfits",
  T_46_META_WS_A_OUTWALLET: "Out Wallet",
  T_46_META_WS_A_OWNER: "Owner",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "Parachuting Max. Speed",
  T_46_META_WS_A_PARAMS: "Params",
  T_46_META_WS_A_PARENT: "Parent",
  T_46_META_WS_A_PARENTWIDGET: "Parent Widget",
  T_46_META_WS_A_PATH: "Path",
  T_46_META_WS_A_PATHPOINTS: "Path Points",
  T_46_META_WS_A_PHASEINDEX: "Phase Index",
  T_46_META_WS_A_PLATFORM: "Platform",
  T_46_META_WS_A_PLAYER: "Player",
  T_46_META_WS_A_PLAYSPEED: "Play Speed",
  T_46_META_WS_A_POSITION: "Position",
  T_46_META_WS_A_POSITIONS: "Positions",
  T_46_META_WS_A_POSTION: "Postion",
  T_46_META_WS_A_PREFAB: "Prefab",
  T_46_META_WS_A_PROPERTY: "Property",
  T_46_META_WS_A_PROPERTYID: "PropertyID",
  T_46_META_WS_A_PURSUITTARGET: "Pursuit Target",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "Radius",
  T_46_META_WS_A_RANDOMDECAY: "Random Decay",
  T_46_META_WS_A_RANDOMRANGE: "Random Range",
  T_46_META_WS_A_RANDOMRATIO: "Random Ratio",
  T_46_META_WS_A_RANGE: "Range",
  T_46_META_WS_A_RANK: "Rank",
  T_46_META_WS_A_REALCOIN: "Real Coin",
  T_46_META_WS_A_REALNUMBER: "Real Number",
  T_46_META_WS_A_RESET: "Reset",
  T_46_META_WS_A_RESOURCE: "Resource",
  T_46_META_WS_A_RESULT: "Result",
  T_46_META_WS_A_RIGHT: "Right",
  T_46_META_WS_A_RIGHTVALUE: "Right Value",
  T_46_META_WS_A_ROTATION: "Rotation",
  T_46_META_WS_A_ROW: "Row",
  T_46_META_WS_A_SAMPLEPOINT: "Sample Point",
  T_46_META_WS_A_SCALE: "Scale",
  T_46_META_WS_A_SCENEID: "SceneID",
  T_46_META_WS_A_SCORE: "Score",
  T_46_META_WS_A_SCORENAME: "Score Name",
  T_46_META_WS_A_SCREENPOSITION: "Screen Position",
  T_46_META_WS_A_SCRIPT: "Script",
  T_46_META_WS_A_SEAT: "Seat",
  T_46_META_WS_A_SEP: "Sep",
  T_46_META_WS_A_SEPSTR: "Separator",
  T_46_META_WS_A_SHEETNAME: "SheetName",
  T_46_META_WS_A_SHOPITEM: "Shop Item",
  T_46_META_WS_A_SHOWBACKGROUND: "ShowBackground",
  T_46_META_WS_A_SHOWMATCHRESULT: "Show Game Result",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "Show Message When Cancel",
  T_46_META_WS_A_SKILL: "Skill",
  T_46_META_WS_A_SKILLS: "Skills",
  T_46_META_WS_A_SKILLTARGET: "Skill Target",
  T_46_META_WS_A_SKIN: "Backpack Skin",
  T_46_META_WS_A_SLOT: "Slot",
  T_46_META_WS_A_SRCVAL: "Source Value",
  T_46_META_WS_A_SRCVALUE: "Source Value",
  T_46_META_WS_A_STARTAREACENTER: "Start Area Center",
  T_46_META_WS_A_STARTAREARANGE: "Start Area Range",
  T_46_META_WS_A_STARTINDEX: "Start Index",
  T_46_META_WS_A_STARTPOSITION: "Start Position",
  T_46_META_WS_A_STARTRANK: "Start Rank",
  T_46_META_WS_A_STATE: "State",
  T_46_META_WS_A_STATUS: "Status",
  T_46_META_WS_A_STATUSCODE: "Status Code",
  T_46_META_WS_A_STYLE: "Style",
  T_46_META_WS_A_SURFINGMAXSPEED: "Surfing Max. Speed",
  T_46_META_WS_A_TARGET: "Target",
  T_46_META_WS_A_TARGETPOSITION: "Target Position",
  T_46_META_WS_A_TEAMSEQ: "Team Sequency",
  T_46_META_WS_A_THRESHOLD: "Threshold",
  T_46_META_WS_A_TIMESTAMP: "Timestamp",
  T_46_META_WS_A_TIPS: "Tips",
  T_46_META_WS_A_TITLE: "Title",
  T_46_META_WS_A_TOKENCOUNT: "TokenCount",
  T_46_META_WS_A_TOKENID: "Token ID",
  T_46_META_WS_A_TORQUE: "Torque",
  T_46_META_WS_A_TOUCHPOINT: "Touch Point",
  T_46_META_WS_A_TRANSITIONTIME: "Transition Time (ms)",
  T_46_META_WS_A_TRANSITIONTYPE: "Transition Type",
  T_46_META_WS_A_TRIGGER: "Trigger",
  T_46_META_WS_A_TYPE: "Type",
  T_46_META_WS_A_UI: "UI",
  T_46_META_WS_A_UIID: "UI ID",
  T_46_META_WS_A_UPWARD: "Upward",
  T_46_META_WS_A_VALUE: "Value",
  T_46_META_WS_A_VALUEA: "ValueA",
  T_46_META_WS_A_VALUEB: "ValueB",
  T_46_META_WS_A_VALUES: "Values",
  T_46_META_WS_A_VALUET: "ValueT",
  T_46_META_WS_A_VALUETYPE: "Value Type",
  T_46_META_WS_A_VEHICLE: "Vehicle",
  T_46_META_WS_A_VEHICLESKIN: "Vehicle Skin",
  T_46_META_WS_A_VELOCITY: "Velocity",
  T_46_META_WS_A_VELOCITYXZ: "Velocity XZ",
  T_46_META_WS_A_VELOCITYY: "Velocity Y",
  T_46_META_WS_A_VISIBLE: "Visible",
  T_46_META_WS_A_WAITTIME: "Wait Time (s)",
  T_46_META_WS_A_WALLET: "Wallet",
  T_46_META_WS_A_WEAPON: "Weapon",
  T_46_META_WS_A_WEAPONSKIN: "Weapon Skin",
  T_46_META_WS_A_WIDGETID: "Widget ID",
  T_46_META_WS_A_WIDGETTYPE: "Widget Type",
  T_46_META_WS_A_WIDTH: "Width",
  T_46_META_WS_A_WORLDPOSITION: "World Position",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "World Position Stays",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "Abs",
  T_46_META_WS_ACOS: "ACos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "Add AOI Special Follow",
  T_46_META_WS_ADDATTACHMENTS: "Add Attachments",
  T_46_META_WS_ADDBUFF: "Add Buff",
  T_46_META_WS_ADDCOMPONENT: "Add Component",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "Add Football Velocity",
  T_46_META_WS_ADDFORCE: "Add Force",
  T_46_META_WS_ADDFORCEATPOSITION: "Add Force At Position",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "Add Formula Property Factor",
  T_46_META_WS_ADDGAMEEVENTLOG: "Add Game Event Log",
  T_46_META_WS_ADDHP: "Add HP",
  T_46_META_WS_ADDITEM: "Add Item",
  T_46_META_WS_ADDITEMINSCENE: "Create Item In Scene",
  T_46_META_WS_ADDITEMTOSHOPITEM: "Add Item To Shop Item",
  T_46_META_WS_ADDMONEY: "Add Money",
  T_46_META_WS_ADDSCRIPT: "Add Script",
  T_46_META_WS_ADDTAG: "Add Tag",
  T_46_META_WS_ADDTOKEN: "Add Token",
  T_46_META_WS_ADDTORQUE: "Add Torque",
  T_46_META_WS_ADDUSEREVENTLOG: "Add User Event Log",
  T_46_META_WS_ANGEL: "Angle",
  T_46_META_WS_APPEND: "Append",
  T_46_META_WS_APPENDRANGE: "Append Range",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "Apply Quit Midway UI Config",
  T_46_META_WS_ASIN: "ASin",
  T_46_META_WS_ASSERT: "Assert",
  T_46_META_WS_ASSISTPLAYER: "Assist Player",
  T_46_META_WS_ATAN2: "ATan2",
  T_46_META_WS_ATTACKER: "Attacker",
  T_46_META_WS_ATTACKTARGET: "Attack Target",
  T_46_META_WS_AXISANGLETOQUATERNION: "Axis Angle To Quaternion",
  T_46_META_WS_BOXCAST: "Box Cast",
  T_46_META_WS_BOXOVERLAP: "Box Overlap",
  T_46_META_WS_BUTTONNAME: "Button Name",
  T_46_META_WS_C_ACTIONTYPE: "Action Type",
  T_46_META_WS_C_AIMABLE: "Aimable",
  T_46_META_WS_C_AIMASSISTABLE: "Aim Assistable",
  T_46_META_WS_C_AIMASSISTTYPE: "Aim Assist Type",
  T_46_META_WS_C_AIRDROP: "Airdrop",
  T_46_META_WS_C_AMMO: "Ammo",
  T_46_META_WS_C_AMMOTYPE: "Ammo Type",
  T_46_META_WS_C_AMPHIBIAN: "Amphibian",
  T_46_META_WS_C_ANIMATIONCLIP: "Animation Clip",
  T_46_META_WS_C_ANIMATIONCLIPID: "Animation Clip ID",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "Animation Controller",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "Animation Controller Attachable",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "Animation Controller ID",
  T_46_META_WS_C_ANIMATIONSTATE: "Animation State",
  T_46_META_WS_C_ANIMATIONTRIGGER: "AnimationTrigger",
  T_46_META_WS_C_APPEARENCE: "Appearance",
  T_46_META_WS_C_ASSETCONFIGID: "Asset Config ID",
  T_46_META_WS_C_ASSETID: "Asset ID",
  T_46_META_WS_C_ATTACHMENT: "Attachment",
  T_46_META_WS_C_ATTACKABLETYPE: "Attackable Type",
  T_46_META_WS_C_AUDIOID: "Audio ID",
  T_46_META_WS_C_BACKPACK: "Backpack",
  T_46_META_WS_C_BACKPACKSKINID: "Backpack Skin ID",
  T_46_META_WS_C_BASEDATAALIAS: "Base Data Alias",
  T_46_META_WS_C_BASICAPPEARANCE: "Basic Appearance",
  T_46_META_WS_C_BASICCYLINDER: "Basic Cylinder",
  T_46_META_WS_C_BASICSCALABLE: "Basic Scalable",
  T_46_META_WS_C_BASICSPHERE: "Basic Sphere",
  T_46_META_WS_C_BATCHCOMBINERENDER: "Batch Combine Render",
  T_46_META_WS_C_BEVTREE: "Behavior Tree",
  T_46_META_WS_C_BEVTREEATTACHABLE: "Behavior Tree Attachable",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "Behavior Tree Custom Node",
  T_46_META_WS_C_BEVTREEID: "Behavior Tree ID",
  T_46_META_WS_C_BEVTREENODESTATUS: "Behavior Tree Node Status",
  T_46_META_WS_C_BEVTREENODETYPE: "Behavior Tree Node Type",
  T_46_META_WS_C_BEZIERCURVE: "Bezier Curve",
  T_46_META_WS_C_BOOL: "Bool",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "Bot Difficulty Type",
  T_46_META_WS_C_BOUNCINGTIRE: "Bouncing Tire",
  T_46_META_WS_C_BUFFABLE: "Buffable",
  T_46_META_WS_C_BUFFGENERATOR: "Buff Generator",
  T_46_META_WS_C_BUFFTYPE: "Buff Type",
  T_46_META_WS_C_BUILTINRENDER: "Built-In Render",
  T_46_META_WS_C_BUILTINUI: "Built-In UI",
  T_46_META_WS_C_BUILTINUITYPE: "Built-In UI Type",
  T_46_META_WS_C_CAMERA: "Camera",
  T_46_META_WS_C_CAMERABLOCKMODE: "Camera Block Mode",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "Camera Projection Mode",
  T_46_META_WS_C_CAMERARAYCASTUI: "Camera RayCast UI",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "Camera Transition Type",
  T_46_META_WS_C_CAMERATYPE: "CameraType",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Camera Viewing Angle Restriction Type",
  T_46_META_WS_C_CAPSULETRIGGER: "Capsule Trigger",
  T_46_META_WS_C_CAR: "Car",
  T_46_META_WS_C_CHARACTERCONTROLLER: "Character Controller",
  T_46_META_WS_C_CHATCHANNEL: "ChatChannel",
  T_46_META_WS_C_CHATCHANNELTYPE: "Chat Channel Type",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "Check Point Trigger",
  T_46_META_WS_C_COINGENERATOR: "Coin Generator",
  T_46_META_WS_C_COLLECTIONID: "Collection ID",
  T_46_META_WS_C_COLLIDER: "Collider",
  T_46_META_WS_C_COLLIDERCOLLECTION: "Collider Collection",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "Collider Collection ID",
  T_46_META_WS_C_COLORDRUM: "Color Drum",
  T_46_META_WS_C_COMBATABLE: "Combatable",
  T_46_META_WS_C_COMPONENT: "Component",
  T_46_META_WS_C_CONDITION: "Condition",
  T_46_META_WS_C_CONTAINER: "Container",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "Coordinate System Type",
  T_46_META_WS_C_CROSSBOW: "Grenade CrossBow",
  T_46_META_WS_C_CSVID: "CSV ID",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "Customize Trigger",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "Custom Object",
  T_46_META_WS_C_CUSTOMPATH: "Custom Path",
  T_46_META_WS_C_CUSTOMUI: "Custom UI",
  T_46_META_WS_C_CUSTOMUIID: "Custom UI ID",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "Custom UI or Widget",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "Custom UI Widget ID",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "Damaged Body Part Type",
  T_46_META_WS_C_DAMAGETYPE: "Damage Type",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "Death or Invincibility Trigger",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "Destructible Object",
  T_46_META_WS_C_DICE: "Dice",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "Double Jump Shoes",
  T_46_META_WS_C_DRUMMUSIC: "Drum Music",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "Dual-Wield Weapon Type",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "Common Level Object",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "Dynamic Create Level Object Type",
  T_46_META_WS_C_DYNAMICFENCE: "Dynamic Fence",
  T_46_META_WS_C_EFFECT: "Effect",
  T_46_META_WS_C_EFFECTCONTAINER: "Effect Container",
  T_46_META_WS_C_EFFECTID: "Effect ID",
  T_46_META_WS_C_EMOTETYPE: "Emote Type",
  T_46_META_WS_C_ENDPOINTTRIGGER: "End Point Trigger",
  T_46_META_WS_C_ENTITY: "entity",
  T_46_META_WS_C_ENTITYORPREFABID: "Entity or Prefab ID",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "Equipment Accessory",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "Equipment Slot Type",
  T_46_META_WS_C_EQUIPMENTTYPE: "Equipment Type",
  T_46_META_WS_C_EVENTID: "Event ID",
  T_46_META_WS_C_FACTION: "Faction",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "Fill Direction Type",
  T_46_META_WS_C_FILLTYPE: "Fill Type",
  T_46_META_WS_C_FIRETYPE: "Fire Type",
  T_46_META_WS_C_FLOAT: "Float",
  T_46_META_WS_C_FOLDWING: "Fold Wing",
  T_46_META_WS_C_FOLLOW: "Follow",
  T_46_META_WS_C_FONTTYPE: "Font Type",
  T_46_META_WS_C_FOOTBALL: "Football",
  T_46_META_WS_C_FORCETYPE: "Force Type",
  T_46_META_WS_C_FORMULABLE: "Formulable",
  T_46_META_WS_C_FRAMESELFRELATIVE: "Frame Self Relative",
  T_46_META_WS_C_GAMERESULTTYPE: "Game Result Type",
  T_46_META_WS_C_GENDERTYPE: "Gender Type",
  T_46_META_WS_C_GENERALSPAWNPOINT: "General Spawn Point",
  T_46_META_WS_C_GRENADEDEICEWALL: "Grenade DeIce Wall",
  T_46_META_WS_C_GRENADEFLASHBANG: "Flashbang",
  T_46_META_WS_C_GRENADEFROZEN: "Freezing Grenade",
  T_46_META_WS_C_GRENADELAUNCHER: "Grenade Launcher",
  T_46_META_WS_C_GRENADESMOKE: "Smoke Grenade",
  T_46_META_WS_C_GRENADEWEAPON: "Grenade Base",
  T_46_META_WS_C_GRID: "Grid",
  T_46_META_WS_C_HANDCANNON: "Grenade HandCannon",
  T_46_META_WS_C_HELMET: "Helmet",
  T_46_META_WS_C_HIERARCHICAL: "Hierarchical",
  T_46_META_WS_C_HOOKGUN: "Hook Gun",
  T_46_META_WS_C_HORIZALINE: "Horizaline",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "UI Transformrt",
  T_46_META_WS_C_HUMANMODELID: "Human Model ID",
  T_46_META_WS_C_ICEWALL: "Gloo Wall",
  T_46_META_WS_C_ICEWALLCREATED: "Ice Wall Created",
  T_46_META_WS_C_ICEWALLMAKER: "Gloo Maker",
  T_46_META_WS_C_ICON: "Icon Entity",
  T_46_META_WS_C_ICONTYPE: "Icon Type",
  T_46_META_WS_C_INHALER: "Inhaler",
  T_46_META_WS_C_INT: "Int",
  T_46_META_WS_C_INT64: "Int64",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "Integer Map Template",
  T_46_META_WS_C_INTORINTLIST: "Int or Int List",
  T_46_META_WS_C_INVENTORYTYPE: "Inventory Type",
  T_46_META_WS_C_ITEMBASE: "Item Base",
  T_46_META_WS_C_ITEMCONTAINER: "Item Container",
  T_46_META_WS_C_ITEMID: "Item ID",
  T_46_META_WS_C_ITEMIDTYPE: "Item ID Type",
  "T_46_META_WS_C_JERSEY STYLE": "Jersey Style",
  T_46_META_WS_C_JERSEYMACHINE: "JerseyMachine",
  T_46_META_WS_C_JETSHOES: "Jet Shoes",
  T_46_META_WS_C_KEYBOARD: "Keyboard",
  T_46_META_WS_C_KNOCKDOWNTYPE: "Knock-down Type",
  T_46_META_WS_C_LANDMINE: "Landmine",
  T_46_META_WS_C_LANDMINECREATED: "Landmine Created",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "Launch Pad Level Object",
  T_46_META_WS_C_LAUNCHPAD: "Launch Pad",
  T_46_META_WS_C_LAYOUTSORTTYPE: "Layout Sort Type",
  T_46_META_WS_C_LEAD1MUSIC: "Lead1 Music",
  T_46_META_WS_C_LEAD2MUSIC: "Lead2 Music",
  T_46_META_WS_C_LEAD3MUSIC: "Lead3 Music",
  T_46_META_WS_C_LEVELOBJECTID: "Level Object ID",
  T_46_META_WS_C_LEVELOBJECTTYPE: "Level Object Type",
  T_46_META_WS_C_LIST: "List",
  T_46_META_WS_C_LISTORMAP: "List or Map",
  T_46_META_WS_C_LISTT: "List Template",
  T_46_META_WS_C_LISTT_BOOL: "Bool List",
  T_46_META_WS_C_LISTT_CONDITION: "Condition List",
  T_46_META_WS_C_LISTT_ENTITY: "Entity List",
  T_46_META_WS_C_LISTT_FLOAT: "Float List",
  T_46_META_WS_C_LISTT_INT: "Int List",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "Item List",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "Level Object List",
  T_46_META_WS_C_LISTT_LOCKEY: "Localization Key List",
  T_46_META_WS_C_LISTT_PLAYABLE: "Playable List",
  T_46_META_WS_C_LISTT_PLAYER: "Player List",
  T_46_META_WS_C_LISTT_SKILLID: "Skill ID List",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "Sound Effect List",
  T_46_META_WS_C_LISTT_STRING: "String List",
  T_46_META_WS_C_LISTT_TEAM: "Team List",
  T_46_META_WS_C_LISTT_TYPE: "Type List",
  T_46_META_WS_C_LISTT_VECTOR3: "Vector3 List",
  T_46_META_WS_C_LOCKEY: "Localization Key",
  T_46_META_WS_C_LOOKAT: "LookAt",
  T_46_META_WS_C_LOOPABLE: "Loopable",
  T_46_META_WS_C_LOOPTYPE: "LoopType",
  T_46_META_WS_C_LOOTAMMOTYPE: "Loot Ammo Type",
  T_46_META_WS_C_LOOTARMOR: "Loot Armor",
  T_46_META_WS_C_LOOTARMORTYPE: "Loot Armor Type",
  T_46_META_WS_C_LOOTCONSUMABLE: "Loot Consumable",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "Loot Consumable Type",
  T_46_META_WS_C_LOOTIAMMO: "Loot Ammo",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "Loot Soccer Item Box",
  T_46_META_WS_C_LOOTSCOPE: "Loot Scope",
  T_46_META_WS_C_LOOTSCOPETYPE: "Loot Scope Type",
  T_46_META_WS_C_LOOTSOCCERTYPE: "Loot Soccer Type",
  T_46_META_WS_C_LOOTTHROWABLE: "Loot Throwable",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "Loot Throwable Type",
  T_46_META_WS_C_LOOTWEAPON: "Loot Weapon",
  T_46_META_WS_C_LOOTWEAPONTYPE: "Loot Weapon Type",
  T_46_META_WS_C_LOWGRAVITY: "Low-Gravity Area",
  T_46_META_WS_C_MAP: "Map",
  T_46_META_WS_C_MAPT: "Map Template",
  T_46_META_WS_C_MATERIALID: "Material ID",
  T_46_META_WS_C_MEDKIT: "MedKit",
  T_46_META_WS_C_MESHID: "Mesh ID",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "Mid-Game Exit Configuration",
  T_46_META_WS_C_MINIMAP: "Minimap",
  T_46_META_WS_C_MINIMAPICON: "Minimap Icon",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "Minimap Pixel Renderer",
  T_46_META_WS_C_MINISENTRY: "Mini Sentry",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "Mini Sentry Attack Range Type",
  T_46_META_WS_C_MINISENTRYCREATED: "Mini Sentry Created",
  T_46_META_WS_C_MONEY: "Money",
  T_46_META_WS_C_MONEYTYPE: "Money Type",
  T_46_META_WS_C_MONSTER: "Monster",
  T_46_META_WS_C_MONSTERSPAWN: "Monster Spawn",
  T_46_META_WS_C_MONSTERTYPE: "Monster Type",
  T_46_META_WS_C_MORPHABLEOBJECT: "Morphable Object",
  T_46_META_WS_C_MORPHOBJECT: "Morph Object",
  T_46_META_WS_C_MOTOBIKE: "Motorbike",
  T_46_META_WS_C_MOVEPLATFORM: "Moving Platform",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "Movable Platform Type",
  T_46_META_WS_C_MUSHROOM: "Mushroom",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "Natural Constant Type",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "Number",
  T_46_META_WS_C_OBJECT: "Object",
  T_46_META_WS_C_OILDRUM: "Oil Drum",
  T_46_META_WS_C_OUTFITID: "Outfit ID",
  T_46_META_WS_C_OUTFITSLOTTYPE: "Outfit Slot Type",
  T_46_META_WS_C_PATHPOINT: "Path Point",
  T_46_META_WS_C_PATROLSTYLETYPE: "Patrol Style Type",
  T_46_META_WS_C_PATROLTYPE: "Patrol Type",
  T_46_META_WS_C_PERSONA: "Persona",
  T_46_META_WS_C_PHASE: "Phase",
  T_46_META_WS_C_PHYSICALMOVER: "Physical Mover",
  T_46_META_WS_C_PHYSICALOBJECT: "Physical Object",
  T_46_META_WS_C_PLATFORMTYPE: "Platform Type",
  T_46_META_WS_C_PLAYABLE: "Playable",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "PlayableOrPlayables",
  T_46_META_WS_C_PLAYER: "Player",
  T_46_META_WS_C_PLAYERBACKPACK: "Player Backpack",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "Player Behavior Status Type",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "Player Behavior Type",
  T_46_META_WS_C_PLAYERCCT: "Player CCT",
  T_46_META_WS_C_PLAYERDATAID: "Preset Character Type",
  T_46_META_WS_C_PLAYERORTRANSFORM: "Player or Transform",
  T_46_META_WS_C_PLAYERORVEHICLE: "Player or Vehicle",
  T_46_META_WS_C_PLAYEROUTFIT: "Player Outfit",
  T_46_META_WS_C_PLAYERPOSETYPE: "Player Pose Type",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "Player Revival Source Type",
  T_46_META_WS_C_PLAYERSTATETYPE: "Player State Type",
  T_46_META_WS_C_POINTLIGHT: "Pointlight",
  T_46_META_WS_C_PORTAL: "Portal",
  T_46_META_WS_C_PREFABID: "Prefab ID",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "PresentEffectGenerator",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "Effect Texture Type",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "Profile Picture Widget",
  T_46_META_WS_C_PROPERTY: "Property",
  T_46_META_WS_C_PROPERTYFORMULA: "Property Formula",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "Property Formula Factor type",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "Property Modify Type",
  T_46_META_WS_C_QUATERNION: "Quaternion",
  T_46_META_WS_C_RANKABLE: "Rankable",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "Ray Cast Layer Type",
  T_46_META_WS_C_REPAIRKIT: "Repair Kit",
  T_46_META_WS_C_RESETABLE: "Resetable",
  T_46_META_WS_C_RIGIDBODY: "Rigidbody",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "Rigidbody Constrain Type",
  T_46_META_WS_C_RIGIDBODYTYPE: "Rigidbody Type",
  T_46_META_WS_C_ROUND: "Round",
  T_46_META_WS_C_SAFEZONE: "Safe Zone",
  T_46_META_WS_C_SCOREABLE: "Scoreable",
  T_46_META_WS_C_SCRIPTID: "Script ID",
  T_46_META_WS_C_SEATTYPE: "Seat Type",
  T_46_META_WS_C_SELFRELATIVE: "Self-Relative",
  T_46_META_WS_C_SHOP: "Shop",
  T_46_META_WS_C_SHOPITEM: "Shop Item",
  T_46_META_WS_C_SHOPSHELF: "Shop Shelf",
  T_46_META_WS_C_SKATEBOARD: "Skateboard",
  T_46_META_WS_C_SKELETON: "Skeleton",
  T_46_META_WS_C_SKELETONPART: "Skeleton Part",
  T_46_META_WS_C_SKILLID: "Skill ID",
  T_46_META_WS_C_SKYBLASTER: "Skyblaster",
  T_46_META_WS_C_SKYBOX: "Skybox",
  T_46_META_WS_C_SKYBOXTYPE: "SkyboxType",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "Social Island Snowball",
  T_46_META_WS_C_SORTTYPE: "Sort Type",
  T_46_META_WS_C_SOUNDDRUMTYPE: "Sound Drum Type",
  T_46_META_WS_C_SOUNDEFFECT: "Sound Effect",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "Sound Effect or Sound Effect List",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "SoundEffect Type",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "Sound Lead1 Type",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "Sound Lead2 Type",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "Sound Lead3 Type",
  T_46_META_WS_C_SOUNDPIANOTYPE: "Sound Piano Type",
  T_46_META_WS_C_SPAWN: "Spawn",
  T_46_META_WS_C_SPAWNABLE: "Spawnable",
  T_46_META_WS_C_SPAWNBOX: "Spawn Zone",
  T_46_META_WS_C_SPAWNPOSITION: "Spawn Point",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "Special Item ID Type",
  T_46_META_WS_C_SPHERETRIGGER: "Sphere Trigger",
  T_46_META_WS_C_SPORTSCAR: "Sports Car",
  T_46_META_WS_C_SPRAYCOLOR: "Spray Color",
  T_46_META_WS_C_SPRAYGUN: "Spray Gun",
  T_46_META_WS_C_SPRAYRESULTUI: "Spray Result UI",
  T_46_META_WS_C_SPRAYRIFLE: "Spray Rifle",
  T_46_META_WS_C_SPRITEID: "Sprite ID",
  T_46_META_WS_C_STATICSCRIPTID: "Static Script ID",
  T_46_META_WS_C_STRING: "String",
  T_46_META_WS_C_STRINGORLOCSTRING: "String or Localization String",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "Supply Box Trigger",
  T_46_META_WS_C_SWINGGUN: "Swing Gun",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "Switch Equip Slot",
  T_46_META_WS_C_TEAM: "Team",
  T_46_META_WS_C_TERRAIN: "Terrain",
  T_46_META_WS_C_TEXT: "Text Entity",
  T_46_META_WS_C_TEXTUREID: "Texture ID",
  T_46_META_WS_C_TEXTURETYPE: "Object Texture",
  T_46_META_WS_C_TIMER: "Timer",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "Timestamp Format Style Type",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "Timestamp Localization String",
  T_46_META_WS_C_TRAJECTORY: "Trajectory",
  T_46_META_WS_C_TRANSFORM: "Transform",
  T_46_META_WS_C_TUKTUK: "Tuk Tuk",
  T_46_META_WS_C_TURRET: "Turret",
  T_46_META_WS_C_TWEEN: "Tween",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "Tween Curve",
  T_46_META_WS_C_TWEENSTYLE: "Tween Style Type",
  T_46_META_WS_C_TYPE: "Type",
  T_46_META_WS_C_TYPEENUM: "Type Enum",
  T_46_META_WS_C_TYPEORTYPELIST: "Type or Type List",
  T_46_META_WS_C_UIADDSCORE: "UI Add Score",
  T_46_META_WS_C_UIANITRIGGERHUD: "UI Animation Trigger HUD",
  T_46_META_WS_C_UIBUILTINSWITCH: "UI Built-In Switch",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "UI Built-In UI Switch Controller",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "UI Card Selection Panel",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "UI Check Point Indicator",
  T_46_META_WS_C_UICOMPASS: "UI Compass",
  T_46_META_WS_C_UICOUNTDOWN5: "UI Countdown 5s",
  T_46_META_WS_C_UICOUNTDOWNHINT: "UI Countdown Hint",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "UI Countdown Reminder",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "UI Follow Health Bar",
  T_46_META_WS_C_UIHEALTHBAR: "UI Health Bar",
  T_46_META_WS_C_UIHEARTBEAT: "UI Heartbeat",
  T_46_META_WS_C_UIICONNOTIFICATION: "UI Icon Notification",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "UI Identity Notification",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "UI Interaction Button",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "UI Leaderboard Button",
  T_46_META_WS_C_UIMATCHSUBTITLE: "UI Match Subtitle",
  T_46_META_WS_C_UIMONSTERLEVEL: "UI Monster Level",
  T_46_META_WS_C_UIMONSTERUI: "UI Monster UI",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "UI Multi-Team Leaderboard",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "UI Multi-Team Result Panel",
  T_46_META_WS_C_UIOPENINGBANNER: "UI Opening Banner",
  T_46_META_WS_C_UIPANEL: "UI Panel",
  T_46_META_WS_C_UIPANELEMPTY: "UI Panel Empty",
  T_46_META_WS_C_UIPHASETIMER: "UI Phase Timer",
  T_46_META_WS_C_UIPROGRESSBAR: "UI Progress Bar",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "UI Progress Circle",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "UI Progress Skill Button",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "UI Request Purchase Type",
  T_46_META_WS_C_UIROUNDINFOBANNER: "Round Info HUD",
  T_46_META_WS_C_UIROUNDNUMBER: "UI Round Number",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "UI Round Result Banner",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "UI Round Start Banner",
  T_46_META_WS_C_UIROUNDTRANSITION: "UI Round Transition",
  T_46_META_WS_C_UISCOREBAR: "UI Score Bar",
  T_46_META_WS_C_UISCROLLPANEL: "UI Scroll Panel",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "UI Simple Round Score Banner",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "UI Simple Round Start Banner",
  T_46_META_WS_C_UISIMPLETIP: "UI Simple Tip",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "UI Simple Versus Banner",
  T_46_META_WS_C_UISKILLBUTTON: "UI Skill Button",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "UI Social Button Widget",
  T_46_META_WS_C_UISOLOLEADERBOARD: "UI Solo Leaderboard",
  T_46_META_WS_C_UISTORE: "UI Store",
  T_46_META_WS_C_UITEAMMATCHINFO: "UI Team Match Info",
  T_46_META_WS_C_UITEXTTIP: "UI Text Tip",
  T_46_META_WS_C_UITIMERINFO: "UI Timer Info",
  T_46_META_WS_C_UITIPBUTTON: "UI Tip Button",
  T_46_META_WS_C_UITITLEBANNER: "UI Title Banner",
  T_46_META_WS_C_UITWEENTIP: "UI Tween Tip",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "UI Two-Team Brief Info",
  T_46_META_WS_C_UITWOTEAMINFO: "UI Two-Team Info",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "UI Two-Team Leaderboard",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "UI Two-Team Result Panel",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "UI Two-Team Round Score Banner",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "UI Two Team Score Panel",
  T_46_META_WS_C_UIVERSUSBANNER: "UI Versus Banner",
  T_46_META_WS_C_UIWIDGET: "UI Widget",
  T_46_META_WS_C_UIWIDGETBUTTON: "UI Widget Button",
  T_46_META_WS_C_UIWIDGETCONTAINER: "UI Widget Container",
  T_46_META_WS_C_UIWIDGETEMPTY: "UI Widget Empty",
  T_46_META_WS_C_UIWIDGETIMAGE: "UI Widget Image",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "UI Widget Input Label",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "UI Widget Joystick",
  T_46_META_WS_C_UIWIDGETLABEL: "UI Widget Label",
  T_46_META_WS_C_UIWIDGETLAYOUT: "UI Widget Layout",
  T_46_META_WS_C_UIWIDGETPROFILE: "UI Widget Profile",
  T_46_META_WS_C_UIWIDGETTEXTURE: "UI Widget Texture",
  T_46_META_WS_C_UIWIDGETTOGGLE: "UI Widget Toggle",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "UI Widget Touchpad",
  T_46_META_WS_C_UIWINORLOSEBANNER: "UI Win-or-Lose Banner",
  T_46_META_WS_C_UNITSPAWN: "Unit Spawn",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "Window Climbing Logic Object",
  T_46_META_WS_C_VECTOR2: "Vector2",
  T_46_META_WS_C_VECTOR3: "Vector3",
  T_46_META_WS_C_VEHICLE: "Vehicle",
  T_46_META_WS_C_VEHICLEIDTYPE: "Vehicle ID Type",
  T_46_META_WS_C_VEHICLESKINID: "Vehicle Skin ID",
  T_46_META_WS_C_VENDINGMACHINE: "Vending Machine",
  T_46_META_WS_C_VEST: "Vest",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "VFX Replaceable Texture Entity",
  T_46_META_WS_C_VFXTEXTURE: "VFX Texture",
  T_46_META_WS_C_VISIBILITY: "Visibility",
  T_46_META_WS_C_WALLET: "Wallet",
  T_46_META_WS_C_WALLETHUD: "Wallet UI",
  T_46_META_WS_C_WATERZONE: "Water Zone",
  T_46_META_WS_C_WAVECOUNTTYPE: "Wave Count Type",
  T_46_META_WS_C_WAVEINTERVALTYPE: "Wave Interval Type",
  T_46_META_WS_C_WEAPON: "Weapon",
  T_46_META_WS_C_WEAPONGENERATOR: "Weapon Generator",
  T_46_META_WS_C_WEAPONSKINID: "Weapon Skin ID",
  T_46_META_WS_C_WEAPONTYPE: "Weapon Type",
  T_46_META_WS_C_WIDGETTYPE: "Widget Type",
  T_46_META_WS_C_ZIPLINE: "Zip Line",
  T_46_META_WS_CAMERADIRECTION: "Camera Direction",
  T_46_META_WS_CAMERAPOSITION: "Camera Position",
  T_46_META_WS_CAPSULECAST: "Capsule Cast",
  T_46_META_WS_CAPSULEOVERLAP: "Capsule Overlap",
  T_46_META_WS_CEIL: "Ceil",
  T_46_META_WS_CHATCHANNEL: "Chat Channel",
  T_46_META_WS_CHECKTRIGGERBYORDER: "Check Trigger By Order",
  T_46_META_WS_CLAMP: "Clamp",
  T_46_META_WS_CLEAR: "Clear",
  T_46_META_WS_CLEARALLCHILDREN: "Clear All Children",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "Clear AOI Special Follow",
  T_46_META_WS_CLEARBACKPACK: "Clear Backpack",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "Clear Formula Property Factor",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "Clear Residual Level Objects",
  T_46_META_WS_CLIPNAME: "Clip Name",
  T_46_META_WS_CLONE: "Clone",
  T_46_META_WS_COLLIDEDENTITY: "CollidedEntity",
  T_46_META_WS_COLORGET: "Color Get",
  T_46_META_WS_COMPLETECUSTOMMISSION: "Complete Custom Mission",
  T_46_META_WS_CONNECT: "Connect",
  T_46_META_WS_CONSUMABLEID: "ConsumableID",
  T_46_META_WS_CONTAIN: "Contain",
  T_46_META_WS_CONTAINKEY: "Contain Key",
  T_46_META_WS_COPYTOMORPH: "Copy To Morph",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "Cost Money",
  T_46_META_WS_COSTTOKEN: "Cost Token",
  T_46_META_WS_CREATEAIRDROP: "Create Air Drop",
  T_46_META_WS_CREATEBOT: "Create Bot",
  T_46_META_WS_CREATEBUILTINUI: "Create Built In UI",
  T_46_META_WS_CREATEBUILTINUICLIENT: "Create Built In UI",
  T_46_META_WS_CREATECAMERA: "Create Camera",
  T_46_META_WS_CREATECURVE: "CreateCurve",
  T_46_META_WS_CREATECUSTOMUI: "Create Custom UI",
  T_46_META_WS_CREATECUSTOMUICLIENT: "Create Custom UI",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "Create Custom UI Widget",
  T_46_META_WS_CREATEDAMAGENUM: "Create Damage Num",
  T_46_META_WS_CREATEEFFECT: "Create Effect",
  T_46_META_WS_CREATEEFFECTCLIENT: "CreateEffect",
  T_46_META_WS_CREATEFACTION: "Create Faction",
  T_46_META_WS_CREATEFOLLOW: "Create Follow",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "Create Frame Self Relative",
  T_46_META_WS_CREATEFROMPREFAB: "Create From Prefab",
  T_46_META_WS_CREATELEVELOBJECT: "Create Level Object",
  T_46_META_WS_CREATELOOKAT: "Create Look At",
  T_46_META_WS_CREATEMINIMAPICON: "Create Mini Map Icon",
  T_46_META_WS_CREATEMINIMAPPIXEL: "Create Mini Map Pixel",
  T_46_META_WS_CREATEMONSTER: "Create Monster",
  T_46_META_WS_CREATEMORPH: "Create Morph",
  T_46_META_WS_CREATESELFRELATIVE: "Create Self Relative",
  T_46_META_WS_CREATESHOP: "Create Shop",
  T_46_META_WS_CREATESHOPITEM: "Create Shop Item",
  T_46_META_WS_CREATESHOPSHELF: "Create Shop Shelf",
  T_46_META_WS_CREATESOUND: "Create Sound",
  T_46_META_WS_CREATESOUNDCLIENT: "Create Sound",
  T_46_META_WS_CREATETOKENINSCENE: "Create Token In Scene",
  T_46_META_WS_CREATETRAJECTORY: "Create Trajectory",
  T_46_META_WS_CREATETWEEN: "Create Tween",
  T_46_META_WS_CREATEWALLET: "Create Wallet",
  T_46_META_WS_CROSS: "Cross",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "CSV Column Name To Int",
  T_46_META_WS_CURRENTAMMOCOUNT: "Current Ammo Count",
  T_46_META_WS_DAMAGE: "Damage",
  T_46_META_WS_DAMAGEDBODYPART: "Damaged Body Part",
  T_46_META_WS_DAMAGEDPLAYERS: "DamagedPlayers",
  T_46_META_WS_DAMAGETYPE: "Damage Type",
  T_46_META_WS_DEALDAMAGE: "Deal Damage",
  T_46_META_WS_DELETE: "Remove",
  T_46_META_WS_DELETEAT: "Remove At",
  T_46_META_WS_DELETECUSTOMUI: "Remove Custom UI",
  T_46_META_WS_DELETEFROMDATABASE: "Remove From Database",
  T_46_META_WS_DELETEFROMDATASTORE: "Remove From Data Store",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "Remove From Leadboard Database By Key",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "Remove From Leadboard Database By Rank",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "Remove From Leadboard Data Store By Key",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "Remove From Leadboard Data Store By Rank",
  T_46_META_WS_DELETETAG: "Remove Tag",
  T_46_META_WS_DELTA: "Delta",
  T_46_META_WS_DESTROY: "Destroy",
  T_46_META_WS_DESTROYBOT: "Destroy Bot",
  T_46_META_WS_DESTROYBUILTINUI: "Destroy Built In UI",
  T_46_META_WS_DESTROYEQUIPMENT: "Destroy Equipment",
  T_46_META_WS_DESTROYITEM: "Destroy Item",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "Direction To Euler Angle",
  T_46_META_WS_DISABLESAFEZONE: "Disable Safe Zone",
  T_46_META_WS_DISPATCHEVENT: "Dispatch Event",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "Dispatch Event With Platform",
  T_46_META_WS_DISTANCE: "Distance",
  T_46_META_WS_DOT: "Dot",
  T_46_META_WS_DROPITEM: "Drop Item",
  T_46_META_WS_DYEATAREA: "Dye At Area",
  T_46_META_WS_DYEATPLANE: "Dye At Plane",
  T_46_META_WS_DYEATPOSITION: "Dye At Position",
  T_46_META_WS_E_ABNORMALGRAVZONE: "Low-Gravity Area",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "Acceleration",
  T_46_META_WS_E_ACTIONNODE: "Action Node",
  T_46_META_WS_E_ACTIVE: "Active",
  T_46_META_WS_E_ACTIVESKILL: "Active Skill",
  T_46_META_WS_E_ADBOARD: "Ad Board",
  T_46_META_WS_E_ADD: "Add",
  T_46_META_WS_E_ADDFRIEND: "Add Friend",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "Aim",
  T_46_META_WS_E_AIR: "Air",
  T_46_META_WS_E_AIRCONDITIONERA: "Air Conditioner",
  T_46_META_WS_E_AIRDROP: "Airdrop, Zombie Suicide",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "Alive",
  T_46_META_WS_E_AMMO: "Bullet VFX",
  T_46_META_WS_E_AMPHIBIANCAR: "Amphibious Vehicle",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "Apparition",
  T_46_META_WS_E_AR: "Rifle",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "AR Ammo",
  T_46_META_WS_E_ARMAGAZINE: "ARMagazine",
  T_46_META_WS_E_ARMOR: "Armor",
  T_46_META_WS_E_ARMORBUFF: "Armor Buff",
  T_46_META_WS_E_ARMORLV1: "Armor Lv1",
  T_46_META_WS_E_ARMORLV2: "Armor Lv2",
  T_46_META_WS_E_ARMORLV3: "Armor Lv3",
  T_46_META_WS_E_ARMORPIERCING: "Shatter Armor",
  T_46_META_WS_E_ARMORSPECIALIST: "Skill 1",
  T_46_META_WS_E_ARROW: "Arrow",
  T_46_META_WS_E_ASC: "Ascending Order",
  T_46_META_WS_E_ASCIGNOREZERO: "Ascending Order Excludes Zeroes",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "Gas Explosion",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "Attachment1ForCompatibility",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "Attachment4ForCompatibility",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "Attachment5ForCompatibility",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "Attachment6ForCompatibility",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "Attachment8ForCompatibility",
  T_46_META_WS_E_ATTACK: "Attack",
  T_46_META_WS_E_ATTACKGRENADE: "Attack Grenade",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "Auto",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "Return",
  T_46_META_WS_E_BACKANDFORTH: "Back And Forth",
  T_46_META_WS_E_BAG: "Backpack",
  T_46_META_WS_E_BAG1: "Bag1",
  T_46_META_WS_E_BAG2: "Bag2",
  T_46_META_WS_E_BAG3: "Bag3",
  T_46_META_WS_E_BAMBOOA: "Bamboo A",
  T_46_META_WS_E_BANANATREE: "Banana Tree",
  T_46_META_WS_E_BASEBALLPOLE: "BaseballPole",
  T_46_META_WS_E_BASECOEFFICIENT: "Base Coefficient",
  T_46_META_WS_E_BASIC: "Basic",
  T_46_META_WS_E_BASICCONE: "Basic Cone",
  T_46_META_WS_E_BASICCYLINDER: "Basic Cylinder",
  T_46_META_WS_E_BASICSPHERE: "Basic Sphere",
  T_46_META_WS_E_BATTLEINSTYLE: "Battle In Style",
  T_46_META_WS_E_BELL: "Bell",
  T_46_META_WS_E_BENCH: "Bench",
  T_46_META_WS_E_BIGHEADHAMMER: "Fancy Hammer",
  T_46_META_WS_E_BILLBOARD: "Large Screen",
  T_46_META_WS_E_BIPOD: "Bipod",
  T_46_META_WS_E_BISGRAFFITIWALL: "BIS Themed Wall",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "Blackhole Explosion VFX",
  T_46_META_WS_E_BLACKHOLEBOOM: "Crystal Ball VFX",
  T_46_META_WS_E_BLAST: "Explosion",
  T_46_META_WS_E_BLOCK: "Square",
  T_46_META_WS_E_BLOODBALL: "Blackhole VFX",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "Blue",
  T_46_META_WS_E_BLUEDOLL: "Ice Doll",
  T_46_META_WS_E_BOARD: "Moving Platform",
  T_46_META_WS_E_BODY: "Body",
  T_46_META_WS_E_BOMBINDICATION: "Bomb Warning",
  T_46_META_WS_E_BOMBPLIERS: "BombPliers",
  T_46_META_WS_E_BONFIRE: "Blazing Bonfire",
  T_46_META_WS_E_BOOM: "Boom",
  T_46_META_WS_E_BOOYAH: "Victory",
  T_46_META_WS_E_BOTH: "Both",
  T_46_META_WS_E_BOUNCETIRE: "Tire",
  T_46_META_WS_E_BOWAMMO: "Bow Ammo",
  T_46_META_WS_E_BREAKABLEBOX: "Destructible Wooden Crate",
  T_46_META_WS_E_BREAKABLECONTAINER: "Destructible Container",
  T_46_META_WS_E_BREAKABLEFENCE: "Destructible Fence",
  T_46_META_WS_E_BRICKA: "Brick A",
  T_46_META_WS_E_BRICKB: "Brick B",
  T_46_META_WS_E_BRICKC: "Brick C",
  T_46_META_WS_E_BRICKHOUSEA: "Small House A",
  T_46_META_WS_E_BRIGHT: "Light",
  T_46_META_WS_E_BUBBLE: "Bubble",
  T_46_META_WS_E_BUFFGENERATOR: "Buff Generator",
  T_46_META_WS_E_BULLETBUFF: "Bullet Buff",
  T_46_META_WS_E_BULLETHITTING: "Bullet Hit",
  T_46_META_WS_E_BUMPERCAR: "Bumper Car",
  T_46_META_WS_E_BUMPERCARFACTORY: "Bumper Car Manufacturer",
  T_46_META_WS_E_BURNING: "Burning Damage on Vehicle Explosion",
  T_46_META_WS_E_BUSHES: "Bushes",
  T_46_META_WS_E_BUSSTOP: "Bus Stop",
  T_46_META_WS_E_BUTTOM: "Bottom Wear",
  T_46_META_WS_E_BUTTONWIDGET: "Button Widget",
  T_46_META_WS_E_BYHIERARCHY: "By Hierarchy",
  T_46_META_WS_E_CABINET: "Cabinet",
  T_46_META_WS_E_CACTUS: "Cactus",
  T_46_META_WS_E_CAMOUFLAGE: "Skill 6",
  T_46_META_WS_E_CAPSULETRIGGER: "Capsule Trigger",
  T_46_META_WS_E_CARDIOTONIC: "Cardiotonic",
  T_46_META_WS_E_CASUALGAMEBGM: "Leisure Game BGM",
  T_46_META_WS_E_CEMENTA: "Cement A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "ChannelA",
  T_46_META_WS_E_CHANNELB: "ChannelB",
  T_46_META_WS_E_CHANNELC: "ChannelC",
  T_46_META_WS_E_CHANNELD: "ChannelD",
  T_46_META_WS_E_CHANNELE: "ChannelE",
  T_46_META_WS_E_CHANNELF: "ChannelF",
  T_46_META_WS_E_CHARACTERSKILL: "Character Skill",
  T_46_META_WS_E_CHARACTOR: "Character",
  T_46_META_WS_E_CHARGE: "Charge 1",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "Checkpoint",
  T_46_META_WS_E_CHEER: "Cheer",
  T_46_META_WS_E_CHERRYBLOSSOM: "Cherry Blossom",
  T_46_META_WS_E_CIRCLE: "Circle",
  T_46_META_WS_E_CIRCLEBACK: "Loop",
  T_46_META_WS_E_CIRCLEOFHEAT: "Foot Beam",
  T_46_META_WS_E_CITY: "City",
  T_46_META_WS_E_CLAPS: "Claps",
  T_46_META_WS_E_CLEAR: "Clear",
  T_46_META_WS_E_CLIENT: "Client",
  T_46_META_WS_E_CLONE: "Look Changer",
  T_46_META_WS_E_CLONEKILL: "Clone Death",
  T_46_META_WS_E_CLOSE: "Close",
  T_46_META_WS_E_CLOTHES: "Clothes",
  T_46_META_WS_E_COINGENERATOR: "Coin Generator",
  T_46_META_WS_E_COLDAIR: "Fog",
  T_46_META_WS_E_COLORBLOCK: "Dyed Block",
  T_46_META_WS_E_COLOROILBARREL: "Dyed Oil Drum",
  T_46_META_WS_E_COMBINEALL: "CombineAll",
  T_46_META_WS_E_COMBINESELF: "CombineSelf",
  T_46_META_WS_E_COMBOKEYA1: "Musical Notes - Synthesizer A",
  T_46_META_WS_E_COMBOKEYA2: "Musical Notes - Synthesizer A",
  T_46_META_WS_E_COMBOKEYB1: "Musical Notes - Synthesizer B",
  T_46_META_WS_E_COMBOKEYB2: "Musical Notes - Synthesizer B",
  T_46_META_WS_E_COMBOKEYC1: "Musical Notes - Synthesizer C",
  T_46_META_WS_E_COMBOKEYC2: "Musical Notes - Synthesizer C",
  T_46_META_WS_E_CONCRETEPILLAR: "Concrete Pillar",
  T_46_META_WS_E_CONDITIONNODE: "Condition Node",
  T_46_META_WS_E_CONTAINERA: "Container A",
  T_46_META_WS_E_CONTAINERB: "Shipping Container B",
  T_46_META_WS_E_CONTAINERC: "Shipping Container C",
  T_46_META_WS_E_CONTAINERWIDGET: "Container Widget",
  T_46_META_WS_E_CONTINUOUS: "Continuous",
  T_46_META_WS_E_COUNTDOWN: "Countdown",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "Countdown",
  T_46_META_WS_E_COUNTDOWNDIDI: "Countdown Beep",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "Countdown",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "Countdown 3",
  T_46_META_WS_E_CROSS: "Cross",
  T_46_META_WS_E_CROSSBOW: "Crossbow",
  T_46_META_WS_E_CROSSHAIR: "Crosshairs",
  T_46_META_WS_E_CROSSHAIRS: "Crosshair",
  T_46_META_WS_E_CROUCH: "Crouch",
  T_46_META_WS_E_CROUCHING: "Crouching",
  T_46_META_WS_E_CROWCAW: "Crow Caw",
  T_46_META_WS_E_CROWN: "Crown",
  T_46_META_WS_E_CUBE: "Block Mechanism",
  T_46_META_WS_E_CURSE: "Talisman",
  T_46_META_WS_E_CURSEEXPLOSION: "Talisman Explosion",
  T_46_META_WS_E_CUSTOM: "Custom",
  T_46_META_WS_E_CUSTOMTRIGGER: "Custom Trigger",
  T_46_META_WS_E_CUSTOMWATERZONE: "Custom Water Body",
  T_46_META_WS_E_CYCLICCOMBUSTION: "Burning in a Loop",
  T_46_META_WS_E_CYLIC: "Cylic",
  T_46_META_WS_E_DAGGER: "Throwing Knife",
  T_46_META_WS_E_DAMAGEDTRUCK: "Damaged Truck",
  T_46_META_WS_E_DAMAGEZONE: "Damage Zone",
  T_46_META_WS_E_DANGERALARM: "Danger 2",
  T_46_META_WS_E_DANGERVIBRATING: "Danger 1",
  T_46_META_WS_E_DARK: "Dark",
  T_46_META_WS_E_DARKNESS: "Darkness",
  T_46_META_WS_E_DASHATTACK: "Dash Attack",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "Data Storage Limit Exceeded",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "Data Storage Parameter Error",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "Data Storage Timeout",
  T_46_META_WS_E_DATETIME: "Date Time",
  T_46_META_WS_E_DAY: "Daytime",
  T_46_META_WS_E_DEAD: "Dead",
  T_46_META_WS_E_DEATH: "Dead",
  T_46_META_WS_E_DEFAULT: "Default",
  T_46_META_WS_E_DEFAULTFIST: "Fist",
  T_46_META_WS_E_DEFENCEGRENADE: "Defence Grenade",
  T_46_META_WS_E_DESC: "Descending Order",
  T_46_META_WS_E_DIALOGUE: "Dialogue",
  T_46_META_WS_E_DIAMOND: "Diamond",
  T_46_META_WS_E_DIRECTIONSIGN: "Sign",
  T_46_META_WS_E_DIRVEVEHICLE: "Dirve Vehicle",
  T_46_META_WS_E_DISABLE: "Disable",
  T_46_META_WS_E_DISABLED: "Disabled",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "Disappearance Prompt",
  T_46_META_WS_E_DISCONNECT: "Disconnect",
  T_46_META_WS_E_DISGUISE: "Clone",
  T_46_META_WS_E_DOGHOUSE: "Dog House",
  T_46_META_WS_E_DOOR: "Door",
  T_46_META_WS_E_DOUBLE: "Double",
  T_46_META_WS_E_DOUBLEDOOR: "Double Door",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "DoubleJumpShoe",
  T_46_META_WS_E_DOUBLEMAGEZINE: "DoubleMagezine",
  T_46_META_WS_E_DRAW: "Draw",
  T_46_META_WS_E_DRILLZOMBIE: "Drill Zombie",
  T_46_META_WS_E_DRIVE: "Drive",
  T_46_META_WS_E_DRIVER: "Driver",
  T_46_META_WS_E_DROPBEAT: "Skill 4",
  T_46_META_WS_E_DRUMKEY1: "Musical Notes - Drum",
  T_46_META_WS_E_DRUMKEY2: "Musical Notes - Drum",
  T_46_META_WS_E_DUEL: "Battle",
  T_46_META_WS_E_DUMMY: "Dummy",
  T_46_META_WS_E_DUMMYGRENADE: "DummyGrenade",
  T_46_META_WS_E_DUMP: "Dump",
  T_46_META_WS_E_DUSK: "Dusk",
  T_46_META_WS_E_DUST: "Smoke and Dust",
  T_46_META_WS_E_DYNAMIC: "Dynamic",
  T_46_META_WS_E_E: "Natural Constant",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "Easy",
  T_46_META_WS_E_ELECTRICSHOCK: "Electric Shock",
  T_46_META_WS_E_ELECTRICSURFBOARD: "Electric Surfboard",
  T_46_META_WS_E_ELECTRICZONE: "ElectricZone",
  T_46_META_WS_E_ELECTRONICBGM: "Cute Electronic Fantasy BGM",
  T_46_META_WS_E_ELIMINATEDBOSS: "Impeach Guild Leader",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "Elimination Prompt",
  T_46_META_WS_E_EMOTE: "Emote",
  T_46_META_WS_E_ENABLE: "Enable",
  T_46_META_WS_E_ENERGETIC: "Energetic",
  T_46_META_WS_E_ENTERVEHICLE: "Enter Vehicle",
  T_46_META_WS_E_EP: "EP",
  T_46_META_WS_E_EXCLAMATIONMARK: "Exclamation Mark",
  T_46_META_WS_E_EXIT: "Exit",
  T_46_META_WS_E_EXITVEHICLE: "Exit Vehicle",
  T_46_META_WS_E_EXPLODE: "Self-Destruct",
  T_46_META_WS_E_EXPLOSION: "Explosion VFX",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "Explosion Flames",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "Energy Orb Skill",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "Self-Explode Zombie",
  T_46_META_WS_E_EYE: "Glasses",
  T_46_META_WS_E_FACEPAINT: "Facepaint",
  T_46_META_WS_E_FACTION: "Faction",
  T_46_META_WS_E_FALLING: "Falling",
  T_46_META_WS_E_FALLINGSTAR: "Get Consumable",
  T_46_META_WS_E_FALSE: "No",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "Propeller Mechanism",
  T_46_META_WS_E_FAR: "Far",
  T_46_META_WS_E_FEATHER: "Feather",
  T_46_META_WS_E_FEMALE: "Female",
  T_46_META_WS_E_FENCE: "Fence",
  T_46_META_WS_E_FGL24: "FGL-24",
  T_46_META_WS_E_FIGHTINGENTITY: "FightingEntity",
  T_46_META_WS_E_FILLED: "Filled",
  T_46_META_WS_E_FINISH: "Finish",
  T_46_META_WS_E_FINISHINGPOINT: "Endpoint",
  T_46_META_WS_E_FINISHLINEARCH: "Finish Banner",
  T_46_META_WS_E_FIRE: "Fire",
  T_46_META_WS_E_FIRECHARGE: "Fireball",
  T_46_META_WS_E_FIREWORK: "Fireworks",
  T_46_META_WS_E_FIRINGEFFECT: "Shooting VFX",
  T_46_META_WS_E_FIRSTPERSON: "First-Person",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "First-Person Classic",
  T_46_META_WS_E_FIST: "Fist",
  T_46_META_WS_E_FIT: "Fit",
  T_46_META_WS_E_FLAG: "Flag",
  T_46_META_WS_E_FLAME: "Fire",
  T_46_META_WS_E_FLAMEGUN: "FlameGun",
  T_46_META_WS_E_FLAMETHROWER: "Flamethrower",
  T_46_META_WS_E_FLASH: "Flashbang",
  T_46_META_WS_E_FLASHBANG: "Flashbang",
  T_46_META_WS_E_FLASHBANGSPARKS: "Flashbang Smoke",
  T_46_META_WS_E_FLASHFREEZE: "Flash Freeze",
  T_46_META_WS_E_FLEXWALL: "Retractable Wall",
  T_46_META_WS_E_FLICKER: "Flicker",
  T_46_META_WS_E_FLOWER: "Flower",
  T_46_META_WS_E_FLYBOMBBEE: "Fly Bomb Bee",
  T_46_META_WS_E_FLYPAN: "Frying Pan Mechanism",
  T_46_META_WS_E_FLYSHOE: "Flyshoe",
  T_46_META_WS_E_FOLDER: "Folder",
  T_46_META_WS_E_FOLDWINGS: "Foldwings",
  T_46_META_WS_E_FOODTRUCK: "Food Truck",
  T_46_META_WS_E_FOODTRUCKB: "Food Truck B",
  T_46_META_WS_E_FOOTBALL: "Soccer",
  T_46_META_WS_E_FOOTBALLGUN: "Football Gun",
  T_46_META_WS_E_FOOTBALLICE: "FootballIce",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "Football Shooter",
  T_46_META_WS_E_FORCE: "Force",
  T_46_META_WS_E_FOREGRIP_MR: "FOREGRIP_MR",
  T_46_META_WS_E_FOREGRIP1: "Foregrip1",
  T_46_META_WS_E_FOREGRIP2: "Foregrip Lv.2",
  T_46_META_WS_E_FOREGRIP3: "Foregrip3",
  T_46_META_WS_E_FORWARD: "Forward",
  T_46_META_WS_E_FOUNTAIN: "Fountain",
  T_46_META_WS_E_FREE: "Free",
  T_46_META_WS_E_FREEZEALL: "Freeze All",
  T_46_META_WS_E_FREEZEPOSITION: "Freeze Position",
  T_46_META_WS_E_FREEZEPOSITIONX: "Freeze Position X",
  T_46_META_WS_E_FREEZEPOSITIONY: "Freeze Position Y",
  T_46_META_WS_E_FREEZEPOSITIONZ: "Freeze Position Z",
  T_46_META_WS_E_FREEZEROTATION: "Freeze Rotation",
  T_46_META_WS_E_FREEZEROTATIONX: "Freeze Rotation X",
  T_46_META_WS_E_FREEZEROTATIONY: "Freeze Rotation Y",
  T_46_META_WS_E_FREEZEROTATIONZ: "Freeze Rotation Z",
  T_46_META_WS_E_FREEZEZONE: "Frozen Area",
  "T_46_META_WS_E_FROST GALAXY": "Frost Galaxy",
  T_46_META_WS_E_FROZEN: "Freeze",
  T_46_META_WS_E_FROZENGRENADE: "Freezing Grenade",
  T_46_META_WS_E_FUNCTIONALITEMS: "Functional Items",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "Game",
  T_46_META_WS_E_GAMEOVER: "Game Over 2",
  T_46_META_WS_E_GAMESTART: "Game Start",
  T_46_META_WS_E_GARAGE: "Garage",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "Mechanism Activated",
  T_46_META_WS_E_GENTLETAP: "Gentle Tap",
  T_46_META_WS_E_GETITEM: "Get Consumable 2",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "Ghost",
  T_46_META_WS_E_GIANTDICE: "Dice",
  T_46_META_WS_E_GIANTLOLLIPOP: "Giant Lollipop",
  T_46_META_WS_E_GIFT: "Gift",
  T_46_META_WS_E_GLOOWALL: "Gloo Wall",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "BIS Themed Flower Bed",
  T_46_META_WS_E_GRAFFITIWALL: "Graffiti Wall",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "Hook Gun",
  T_46_META_WS_E_GREATCONDUCTOR: "GreatConductor",
  T_46_META_WS_E_GREEN: "Green",
  T_46_META_WS_E_GRENADE: "Grenade",
  T_46_META_WS_E_GRID: "Grid",
  T_46_META_WS_E_GROZA: "Groza",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "Turret",
  T_46_META_WS_E_GUILD: "Guild",
  T_46_META_WS_E_GUN: "Gun",
  T_46_META_WS_E_GUNFIRE: "Gunfire",
  T_46_META_WS_E_HALO: "Halo",
  T_46_META_WS_E_HAMMER: "Giant Hammer Mechanism",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "Drying Rack",
  T_46_META_WS_E_HARD: "Hard",
  T_46_META_WS_E_HATTRICK: "Skill 8",
  T_46_META_WS_E_HAYSTACK: "Haystack",
  T_46_META_WS_E_HEAD: "Headwear",
  T_46_META_WS_E_HEADSHOOT: "Headshot",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "HealingPistol_X",
  T_46_META_WS_E_HEALPISTOL: "Healing Gun",
  T_46_META_WS_E_HEART: "Heart",
  T_46_META_WS_E_HEARTBEAT: "Heartbeat",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "HeavyWeapon",
  T_46_META_WS_E_HELL: "Very Hard",
  T_46_META_WS_E_HELMET: "Helmet",
  T_46_META_WS_E_HELMET1: "Helmet1",
  T_46_META_WS_E_HELMET2: "Helmet2",
  T_46_META_WS_E_HELMET3: "Helmet3",
  T_46_META_WS_E_HEXAGON: "Hexagon",
  T_46_META_WS_E_HGAMMO: "HG Ammo",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "Hide-and-seek Flamethrower",
  T_46_META_WS_E_HIDERKILL: "Hider Eliminated",
  T_46_META_WS_E_HIHATS: "Hihats",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "Dull Hit",
  T_46_META_WS_E_HITEFFECT: "Bullet Hit VFX",
  T_46_META_WS_E_HITFEEDBACK: "Shooting Feedback",
  T_46_META_WS_E_HOOK: "Hook",
  T_46_META_WS_E_HOOKGUN: "Hook Gun",
  T_46_META_WS_E_HOOKGUNAMMO: "Hook",
  T_46_META_WS_E_HORIZALINE: "Horizaline",
  T_46_META_WS_E_HORIZONTAL: "Horizontal",
  T_46_META_WS_E_HORN: "Speaker",
  T_46_META_WS_E_HORROR: "Horror",
  T_46_META_WS_E_HOURGLASS: "Hourglass",
  T_46_META_WS_E_HOUSE: "House",
  T_46_META_WS_E_HOUSEA: "One-Story House",
  T_46_META_WS_E_HOUSEB: "Two-Story House",
  T_46_META_WS_E_HOUSEC: "Three-Story House",
  T_46_META_WS_E_HP: "HP",
  T_46_META_WS_E_HPBUFF: "HP Buff",
  T_46_META_WS_E_HUT: "Cabin",
  T_46_META_WS_E_ICEA: "Ice A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "Gloo Maker",
  T_46_META_WS_E_ICONOBJECT: "Icon",
  T_46_META_WS_E_IMAGEWIDGET: "Image Widget",
  T_46_META_WS_E_IMPULSE: "Impulse",
  T_46_META_WS_E_INHALER: "Inhaler",
  T_46_META_WS_E_INJUREDFEMALE: "Female Screaming on Hit",
  T_46_META_WS_E_INJUREDMALE: "Male Screaming on Hit",
  T_46_META_WS_E_INK: "Ink VFX",
  T_46_META_WS_E_INPUTLABLEWIDGET: "Input Label Widget",
  T_46_META_WS_E_INSECTCHIRPING: "Insect Chirping",
  T_46_META_WS_E_INTERVAL10SECONDS: "10s",
  T_46_META_WS_E_INTERVAL15SECONDS: "15s",
  T_46_META_WS_E_INTERVAL30SECONDS: "30s",
  T_46_META_WS_E_INTERVAL3SECONDS: "3s",
  T_46_META_WS_E_INTERVAL5SECONDS: "5s",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999s",
  T_46_META_WS_E_INVISIBLE: "Invisible",
  T_46_META_WS_E_IPIPE: "I Pipe",
  T_46_META_WS_E_IRONFENCE: "Fence",
  T_46_META_WS_E_IRONFENCEB: "Fence B",
  T_46_META_WS_E_IRONPLATFORM: "Iron Platform",
  T_46_META_WS_E_ITEMENTITY: "Consumable Generator",
  T_46_META_WS_E_JEEP: "Jeep",
  T_46_META_WS_E_JERRYCAN: "Oil Drum",
  T_46_META_WS_E_JERSEYMACHINE: "Jersey Machine",
  T_46_META_WS_E_JOINEDGAMEDULL: "Join the Fray",
  T_46_META_WS_E_JOINGAME: "Join Game",
  T_46_META_WS_E_JOYSTICKWIDGET: "Joystick Widget",
  T_46_META_WS_E_JUMP: "Jump",
  T_46_META_WS_E_JUMPATTACK: "Jump Attack",
  T_46_META_WS_E_JUSTPATROL: "JustPatrol",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "Key",
  T_46_META_WS_E_KICK: "Kick",
  T_46_META_WS_E_KILLINGTIPS: "Killing Tips",
  T_46_META_WS_E_KILLZONE: "KillZone",
  T_46_META_WS_E_KINEMATIC: "Kinematic",
  T_46_META_WS_E_KNIFE: "Knife",
  T_46_META_WS_E_KNOCKDOWN: "Knocked Down",
  T_46_META_WS_E_KNOCKEDDOWN: "Knocked Down",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "Label Widget",
  T_46_META_WS_E_LANDINGA: "Stair Landing A",
  T_46_META_WS_E_LANDINGB: "Stair Landing B",
  T_46_META_WS_E_LANDINGC: "Stair Landing C",
  T_46_META_WS_E_LANDMINE: "Landmine",
  T_46_META_WS_E_LANUNCHERAMMO: "LanuncherAMMO",
  T_46_META_WS_E_LASER: "Laser VFX",
  T_46_META_WS_E_LASERSKILL: "Laser Skill",
  T_46_META_WS_E_LATTICESCREEN: "Lattice Screen",
  T_46_META_WS_E_LAWNA: "Lawn A",
  T_46_META_WS_E_LAWNB: "Lawn B",
  T_46_META_WS_E_LAYOUTWIDGET: "Layout Widget",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "Dead Wood",
  T_46_META_WS_E_LEVELMAXED: "Max. Level",
  T_46_META_WS_E_LEVELUP: "Level Up",
  T_46_META_WS_E_LEVELUPDISCARDED: "Rank Up",
  T_46_META_WS_E_LIGHTBEAM: "Light Beam",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "Light Beam",
  T_46_META_WS_E_LIGHTEFFECT: "Light Effect",
  T_46_META_WS_E_LIGHTNING: "Lightning",
  T_46_META_WS_E_LIMB: "Limb",
  T_46_META_WS_E_LINE: "Line",
  T_46_META_WS_E_LIQUID: "Liquid",
  T_46_META_WS_E_LOCAL: "Local",
  T_46_META_WS_E_LOCALPOSITION: "Local Position",
  T_46_META_WS_E_LOCK: "Lock",
  T_46_META_WS_E_LONGBOX: "Long Wooden Crate",
  T_46_META_WS_E_LOOP: "Loop",
  T_46_META_WS_E_LOOTITEMBOX: "Loot Weapon",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "Loot Ammo",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "Loot Armor",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "Loot Consumable",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "Loot Throwable",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "Loot Scope",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Loot Soccer",
  T_46_META_WS_E_LOOTSOCCERICE: "Loot Soccer Ice",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "Loot Soccer Random",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "Loot Soccer Shield",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "Random Weapon Loot",
  T_46_META_WS_E_LOSE: "Defeat",
  T_46_META_WS_E_LOUDSPEAKER: "Speaker",
  T_46_META_WS_E_LOWFALLING: "Lowfalling",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "M79 Grenade",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "M79 Specialized Grenade",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Parang",
  T_46_META_WS_E_MACHINEGUN: "SMG",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "Magazine 1",
  T_46_META_WS_E_MAGEZINE2: "Magezine2",
  T_46_META_WS_E_MAGEZINE3: "Magezine3",
  T_46_META_WS_E_MAGMAA: "Magma A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "Magnifier",
  T_46_META_WS_E_MALE: "Male",
  T_46_META_WS_E_MARK: "Mark",
  T_46_META_WS_E_MARKER: "Mark",
  T_46_META_WS_E_MASK: "Facepaint",
  T_46_META_WS_E_MAXVALUE: "Max Value",
  T_46_META_WS_E_MECHANICAL: "Rapid Clinking 2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "Mechanical Device Echo",
  T_46_META_WS_E_MEDICALPROPS: "Medical Items",
  T_46_META_WS_E_MEDICALTENT: "Medical Tent",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "Medium Heartbeat",
  T_46_META_WS_E_MEDKIT: "MedKit",
  T_46_META_WS_E_MELEE: "Melee",
  T_46_META_WS_E_MELEEWEAPONS: "Melee Weapon",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "Microphone",
  T_46_META_WS_E_MIDDLE: "Middle",
  T_46_META_WS_E_MINIHANDLE: "MiniHandle",
  T_46_META_WS_E_MINIMAP: "Mini Map",
  T_46_META_WS_E_MINISENTRY: "Mini Sentry",
  T_46_META_WS_E_MINVALUE: "Min Value",
  T_46_META_WS_E_MISSILEEXPLODE: "Missile-Type Weapon",
  T_46_META_WS_E_MISSIONCOMPLETE: "Mission Success 1",
  T_46_META_WS_E_MISTAKE: "Mistake",
  T_46_META_WS_E_MODERATE: "Moderate",
  T_46_META_WS_E_MONEY: "Money",
  T_46_META_WS_E_MONSTER: "Zombie",
  T_46_META_WS_E_MONSTERSPAWN: "Monster Spawn Point",
  T_46_META_WS_E_MONSTERTRUCK: "Monster_Truck",
  T_46_META_WS_E_MOON: "Moon",
  T_46_META_WS_E_MOSQUITO: "Mosquito",
  T_46_META_WS_E_MOTIONTRAIL: "Motion Trail",
  T_46_META_WS_E_MOTOBIKE: "Motobike",
  T_46_META_WS_E_MOTORBIKE: "Motorbike",
  T_46_META_WS_E_MOVE: "Move",
  T_46_META_WS_E_MOVEMENT: "Move",
  T_46_META_WS_E_MOVINGJOYSTICK: "Moving Joystick",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "MrV",
  T_46_META_WS_E_MULTIPLIER: "Multiplier",
  T_46_META_WS_E_MULTIPLY: "Multiply",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "Multiply Accumulate",
  T_46_META_WS_E_MUSHROOM1: "Mushroom 1",
  T_46_META_WS_E_MUSHROOM2: "Mushroom2",
  T_46_META_WS_E_MUSHROOM3: "Mushroom3",
  T_46_META_WS_E_MUSHROOM4: "Mushroom4",
  T_46_META_WS_E_MUSHSHADE: "Giant Mushroom Cluster",
  T_46_META_WS_E_MUSIC: "Music",
  T_46_META_WS_E_MUZZLE1: "Muzzle1",
  T_46_META_WS_E_MUZZLE2: "Muzzle2",
  T_46_META_WS_E_MUZZLE3: "Muzzle3",
  T_46_META_WS_E_NEAR: "Near",
  T_46_META_WS_E_NIGHT: "Night",
  T_46_META_WS_E_NOATTACK: "No Attack",
  T_46_META_WS_E_NODUALWIELDING: "No Akimbo",
  T_46_META_WS_E_NOERROR: "No Error",
  T_46_META_WS_E_NONE: "None",
  T_46_META_WS_E_NORMAL: "Normal",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "No Skip Knockdown",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "Skill 7",
  T_46_META_WS_E_OBTAINEDCOINS: "Get Medium Gold",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "Get Big Gold",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "Get Small Gold",
  T_46_META_WS_E_OILDRUMEXPLODE: "Oil Drum Explosion",
  T_46_META_WS_E_ONCE: "Once",
  T_46_META_WS_E_ONEWAY: "One Way",
  T_46_META_WS_E_OPENFOLDER: "Open Folder",
  T_46_META_WS_E_OPENHIHATS: "OpenHihats",
  T_46_META_WS_E_OPENINGBOX: "Open Box",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "Guild Supply",
  T_46_META_WS_E_OPENINGWARCHEST: "Save Warehouse",
  T_46_META_WS_E_ORANGE: "Orange",
  T_46_META_WS_E_ORTHOGONAL: "Orthogonal",
  T_46_META_WS_E_OUTPOST: "Guardhouse",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "Painted Wall",
  T_46_META_WS_E_PAINTSHIELDSKILL: "Crimson Pool Skill",
  T_46_META_WS_E_PALM: "Paper",
  T_46_META_WS_E_PANEL: "Panel",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "Passenger A",
  T_46_META_WS_E_PASSENGERB: "Passenger B",
  T_46_META_WS_E_PASSENGERC: "Passenger C",
  T_46_META_WS_E_PASSIVE: "Passive",
  T_46_META_WS_E_PASSIVESKILL: "Passive Skill",
  T_46_META_WS_E_PATROLWHILEATTACK: "Patrol While Attack",
  T_46_META_WS_E_PERSONALUAV: "Personal UAV",
  T_46_META_WS_E_PERSPECTIVE: "Perspective",
  T_46_META_WS_E_PETTABBG: "Pet",
  T_46_META_WS_E_PHASESTART: "Phase Start",
  T_46_META_WS_E_PHONEBOOTH: "Phone Booth",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "Musical Notes - Piano",
  T_46_META_WS_E_PIANOKEY2: "Musical Notes - Piano",
  T_46_META_WS_E_PICKUPS: "Pickups",
  T_46_META_WS_E_PICKUPTRUCK: "SUV",
  T_46_META_WS_E_PILLAR: "Concrete Column",
  T_46_META_WS_E_PIN: "Callout",
  T_46_META_WS_E_PINGPONG: "Ping Pong",
  T_46_META_WS_E_PIPECORNER: "Elbow Pipe",
  T_46_META_WS_E_PIPEINTERSECTION: "Cross Pipe",
  T_46_META_WS_E_PISTOL: "Pistol",
  T_46_META_WS_E_PISTOLAMMO: "Pistol Ammo",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "Checkered Amusement Park Block",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "Player",
  T_46_META_WS_E_PLUS: "Plus",
  T_46_META_WS_E_PODIUM: "Podium",
  T_46_META_WS_E_POISONGAS: "Poison Gas",
  T_46_META_WS_E_POISONGASPREDISCARDED: "Poison Gas",
  T_46_META_WS_E_PORTAL: "Portal",
  T_46_META_WS_E_POSTACCUMULATOR: "Post-Accumulator",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "Fast Heartbeat",
  T_46_META_WS_E_PREACCUMULATOR: "Pre-Accumulator",
  T_46_META_WS_E_PRIMARYWEAPONA: "Primary Weapon A",
  T_46_META_WS_E_PRIMARYWEAPONB: "Primary WeaponB",
  T_46_META_WS_E_PRIOREXPLOSION: "Before Bomb Explosion",
  T_46_META_WS_E_PROFILEWIDGET: "Profile Widget",
  T_46_META_WS_E_PRONE: "Prone",
  T_46_META_WS_E_PUMPKIN: "Pumpkin",
  T_46_META_WS_E_PURPLE: "Purple",
  T_46_META_WS_E_QUADRILATERAL: "Quadrilateral",
  T_46_META_WS_E_QUESTIONMARK: "Question Mark",
  T_46_META_WS_E_QUICKCHAT: "Quick Chat",
  T_46_META_WS_E_QUICKCHATSHOW: "Quick Chat Show",
  T_46_META_WS_E_RADIAL180: "Radial 180°",
  T_46_META_WS_E_RADIAL360: "Radial 360°",
  T_46_META_WS_E_RADIAL90: "Radial 90°",
  T_46_META_WS_E_RAMPAGE: "Rampage",
  T_46_META_WS_E_RANDOM: "Random",
  T_46_META_WS_E_RANDOMBUFF: "Random Buff",
  T_46_META_WS_E_RANKDOWN: "Rank Down",
  T_46_META_WS_E_REACTION: "Respond",
  T_46_META_WS_E_RECOVER: "Recover",
  T_46_META_WS_E_RECYCLE: "Recycle",
  T_46_META_WS_E_RED: "Red",
  T_46_META_WS_E_REFINERYTANK: "Refinery Tank",
  T_46_META_WS_E_REFLECTIVECUBE: "Reflective Solid Color Basic Block 1",
  T_46_META_WS_E_REFRESH: "Refresh",
  T_46_META_WS_E_RELEASINGSKILL: "Skill Cast VFX",
  T_46_META_WS_E_RELOAD: "Reload",
  T_46_META_WS_E_REMINDER: "Reminder",
  T_46_META_WS_E_REPAIR: "Repair",
  T_46_META_WS_E_REPAIREQUIP: "Repair Equipment",
  T_46_META_WS_E_REPAIRKIT: "Repair Kit",
  T_46_META_WS_E_REPLACER: "Replacer",
  T_46_META_WS_E_REPORT: "Report",
  T_46_META_WS_E_REST: "Rest",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "Rides",
  T_46_META_WS_E_RIDICULE: "Ridicule",
  T_46_META_WS_E_RIDICULEFUNNY: "RidiculeFunny",
  T_46_META_WS_E_RIFLE: "Rifle",
  T_46_META_WS_E_RIFLEAMMO: "Rifle Ammo",
  T_46_META_WS_E_RIGHT: "Right",
  T_46_META_WS_E_RIGHTTRAPEZOID: "Right-Angled Trapezoid",
  T_46_META_WS_E_RING: "Ring Mechanism",
  T_46_META_WS_E_RINGPREDISCARDED: "RingPreDiscarded",
  T_46_META_WS_E_RIPTIDERHYTHM: "Skill 9",
  T_46_META_WS_E_RISINGPARTICLE: "Rising Particles",
  T_46_META_WS_E_ROADBLOCK: "Barricade",
  T_46_META_WS_E_ROTATE: "Rotation",
  T_46_META_WS_E_RUNNING: "Running",
  T_46_META_WS_E_RUSHTIME: "Rampage",
  T_46_META_WS_E_SAMURAI: "Samurai",
  T_46_META_WS_E_SANDA: "Sand A",
  T_46_META_WS_E_SANDSTRUCTURE: "Sand Sculpture",
  T_46_META_WS_E_SCALE: "Scale",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "Scarecrow",
  T_46_META_WS_E_SCISSORS: "Scissors",
  T_46_META_WS_E_SCOPE2X: "2x Scope",
  T_46_META_WS_E_SCOPE4X: "4x Scope",
  T_46_META_WS_E_SCROLLPANEL: "Scroll Panel",
  T_46_META_WS_E_SECONDARYWEAPON: "Secondary Weapon",
  T_46_META_WS_E_SENSESSHOCKWAVE: "Skill 10",
  T_46_META_WS_E_SERVER: "Server",
  T_46_META_WS_E_SET: "Bodysuit",
  T_46_META_WS_E_SETTING: "Settings",
  T_46_META_WS_E_SETTINGS: "Settings",
  T_46_META_WS_E_SG: "Shotgun",
  T_46_META_WS_E_SGAMMO: "SN Ammo",
  T_46_META_WS_E_SHARPMECHANICAL: "Rapid Clinking 1",
  T_46_META_WS_E_SHIELD: "Defense",
  T_46_META_WS_E_SHIELDBROKEN: "Shield Broken",
  T_46_META_WS_E_SHIELDGUN: "Shield Gun",
  T_46_META_WS_E_SHIELDUP: "Shield Up",
  T_46_META_WS_E_SHOCKWAVE: "Shock Wave",
  T_46_META_WS_E_SHOES: "Shoes",
  T_46_META_WS_E_SHOOTINGTARGET: "Moving Target",
  T_46_META_WS_E_SHORTDATE: "Short Date",
  T_46_META_WS_E_SHORTDATETIME: "Short Date Time",
  T_46_META_WS_E_SHORTTIME: "Short Time",
  T_46_META_WS_E_SHOTGUN: "Shotgun",
  T_46_META_WS_E_SHOTGUNAMMO: "Shotgun Ammo",
  T_46_META_WS_E_SHOTGUNMUZZLE: "ShotgunMuzzle",
  T_46_META_WS_E_SHOW: "Show",
  T_46_META_WS_E_SHRUB: "Bush-Covered Long Wooden Crate",
  T_46_META_WS_E_SICKLE: "Scythe",
  T_46_META_WS_E_SIDESCROLLING: "Side-Scrolling",
  T_46_META_WS_E_SIGNAL: "Signal",
  T_46_META_WS_E_SIGNOUT: "Exit",
  T_46_META_WS_E_SILENCER: "Silencer",
  T_46_META_WS_E_SIMPLE: "Simple",
  T_46_META_WS_E_SIMPLEWIDGET: "Simple Widget",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "SimplifiedArabic",
  T_46_META_WS_E_SINGLE: "Single",
  T_46_META_WS_E_SITEHUT: "Container House",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "Skill Charge Complete",
  T_46_META_WS_E_SKILLRECOVER: "Skill Recovery",
  T_46_META_WS_E_SKIPKNOCKDOWN: "Skip Knockdown",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "Sliced",
  T_46_META_WS_E_SLOPE: "Slope",
  T_46_META_WS_E_SLOWHEARTBEAT: "Slow Heartbeat",
  T_46_META_WS_E_SMG: "SMG",
  T_46_META_WS_E_SMGAMMO: "SMG Ammo",
  T_46_META_WS_E_SMGMUZZLE: "SMGMuzzle",
  T_46_META_WS_E_SMILEY: "Smiling Face",
  T_46_META_WS_E_SMOKE: "Smoke",
  T_46_META_WS_E_SMOKEGRENADE: "Smoke Grenade",
  T_46_META_WS_E_SMOKEY: "Smoke",
  T_46_META_WS_E_SMOOTH: "Smooth",
  T_46_META_WS_E_SNAMMO: "SN Ammo",
  T_46_META_WS_E_SNARES: "Snares",
  T_46_META_WS_E_SNEAKERS: "Running Shoes VFX",
  T_46_META_WS_E_SNIPER: "Sniper Rifle",
  T_46_META_WS_E_SNIPERAMMO: "Sniper Rifle Ammo",
  T_46_META_WS_E_SNOWA: "Snow A",
  T_46_META_WS_E_SNOWFLAKE: "Snowflake",
  T_46_META_WS_E_SOCCER: "Soccer",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "Social Button Widget",
  T_46_META_WS_E_SOLARPANEL: "Solar Panel",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "By Priority High To Low",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "By Priority Low To High",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "Spawn Point VFX",
  T_46_META_WS_E_SPEAKER: "Speaker",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "Special Gun Sound",
  T_46_META_WS_E_SPECIALGUN: "Special Gun",
  T_46_META_WS_E_SPHERE: "Sphere",
  T_46_META_WS_E_SPHERETRIGGER: "Sphere Collision Trigger",
  T_46_META_WS_E_SPIDERWEB: "Skill VFX",
  T_46_META_WS_E_SPORTSCAR: "Sports Car",
  T_46_META_WS_E_SPOTLIGHT: "Light",
  T_46_META_WS_E_SPREADOFPOISONGAS: "Diffusing Poison Gas",
  T_46_META_WS_E_SPRINT: "Dashing",
  T_46_META_WS_E_SQUARE: "Square",
  T_46_META_WS_E_SQUAREBOX: "Square Wooden Crate",
  T_46_META_WS_E_SR: "Sniper Rifle",
  T_46_META_WS_E_STABLE: "Stable",
  T_46_META_WS_E_STAIRS: "Stairs",
  T_46_META_WS_E_STANDING: "Standing",
  T_46_META_WS_E_STAR: "Star",
  T_46_META_WS_E_STATIC: "Static",
  T_46_META_WS_E_STATUSTRIGGER: "Death or Invincibility Trigger",
  T_46_META_WS_E_STEP: "Footstep",
  T_46_META_WS_E_STEPTRIGGER: "Activate Mechanism",
  T_46_META_WS_E_STOCK_S: "STOCK_S",
  T_46_META_WS_E_STOCK_SR: "STOCK_SR",
  T_46_META_WS_E_STOCK1: "Stock1",
  T_46_META_WS_E_STOCK2: "Stock2",
  T_46_META_WS_E_STOCK3: "Stock3",
  T_46_META_WS_E_STONE: "Rock",
  T_46_META_WS_E_STONEBRIDGE: "Stone Arch Bridge",
  T_46_META_WS_E_STONELANTERN: "Stone Lantern",
  T_46_META_WS_E_STONESPLASH: "Flying Debris",
  T_46_META_WS_E_STORE: "Store",
  T_46_META_WS_E_STREETLAMP: "Streetlight",
  T_46_META_WS_E_STYLEA: "Style A",
  T_46_META_WS_E_STYLEB: "Style B",
  T_46_META_WS_E_STYLEC: "Style C",
  T_46_META_WS_E_SUBMACHINEGUN: "SMG",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "SMG Ammo",
  T_46_META_WS_E_SUCCESSFULHIT: "Hit",
  T_46_META_WS_E_SUN: "Sun",
  T_46_META_WS_E_SUNSHADE: "Patio Set With Umbrella",
  T_46_META_WS_E_SUPERCAR: "Sports Car",
  T_46_META_WS_E_SUPERMARKET: "Supermarket",
  T_46_META_WS_E_SURPRISEFIND: "Discover Surprise",
  T_46_META_WS_E_SUV: "SUV",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "Sweap Weapon Quick",
  T_46_META_WS_E_SWIMRING: "Swim Ring",
  T_46_META_WS_E_SWORD: "Sword",
  T_46_META_WS_E_SYMBOLIC: "Ground Marker",
  T_46_META_WS_E_TANKZOMBIE: "Tank Zombie",
  T_46_META_WS_E_TAP: "Tap",
  T_46_META_WS_E_TAPPINGBUTTON: "Tap Button",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "Tap Disable Button",
  T_46_META_WS_E_TEAM: "Team",
  T_46_META_WS_E_TEAMMATESINFO: "Teammates Info",
  T_46_META_WS_E_TELEPORT: "TelePort",
  T_46_META_WS_E_TELEPORTCORRECT: "Correct Destination Beaconing",
  T_46_META_WS_E_TELEPORTWRONG: "Wrong Destination Beaconing",
  T_46_META_WS_E_TEXT: "Text",
  T_46_META_WS_E_TEXTOBJECT: "Text",
  T_46_META_WS_E_TEXTUREWIDGET: "Texture Widget",
  T_46_META_WS_E_THERMALSCOPE: "Thermal Scope",
  T_46_META_WS_E_THIRDPERSON: "Third-Person",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "Third-Person Classic",
  T_46_META_WS_E_THIRDPERSONLOCK: "Third-Person Lock",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "ThowingKnife2ForCompatibility",
  T_46_META_WS_E_THRILLBATTLE: "Skill 5",
  T_46_META_WS_E_THROWATTACK: "Throw Attack",
  T_46_META_WS_E_THROWINGKNIFE: "ThrowingKnife",
  T_46_META_WS_E_THROWREDZOMBIE: "Throw Red Zombie",
  T_46_META_WS_E_THROWZOMBIE: "Tossing Zombie",
  T_46_META_WS_E_THUMBSUP: "Like",
  T_46_META_WS_E_THUNDER: "Electric Shock",
  T_46_META_WS_E_TILEA: "Tile A",
  T_46_META_WS_E_TILEB: "Tile B",
  T_46_META_WS_E_TILEC: "Tile C",
  T_46_META_WS_E_TILED: "Tiled",
  T_46_META_WS_E_TIPSSOUND: "Show Tips",
  T_46_META_WS_E_TOGGLEWIDGET: "Toggle Widget",
  T_46_META_WS_E_TOILETBOWL: "Toilet",
  T_46_META_WS_E_TONEA: "Stone A",
  T_46_META_WS_E_TOP: "Top Wear",
  T_46_META_WS_E_TOPDOWN: "Top-Down",
  T_46_META_WS_E_TORII: "Torii",
  T_46_META_WS_E_TOUCHPADWIDGET: "Touch Pad Widget",
  T_46_META_WS_E_TOWER: "Fortress",
  T_46_META_WS_E_TPIPE: "T Pipe",
  T_46_META_WS_E_TRACINGSTEPS: "Skill 3",
  T_46_META_WS_E_TRAILER: "Trailer",
  T_46_META_WS_E_TRANSFORMATION: "Look Changer",
  T_46_META_WS_E_TRANSPARENT: "Transparent",
  T_46_META_WS_E_TRAPEZOID: "Trapezoid",
  T_46_META_WS_E_TRASHCAN: "Trash Can",
  T_46_META_WS_E_TRIANGLE: "Triangle",
  T_46_META_WS_E_TRIGGERS: "Trigger",
  T_46_META_WS_E_TRIPLE: "3-Round Bursts",
  T_46_META_WS_E_TROPHY: "Trophy",
  T_46_META_WS_E_TRUE: "Yes",
  T_46_META_WS_E_TUKTUK: "Tuk Tuk",
  T_46_META_WS_E_TUTUCAR: "Tuk Tuk",
  T_46_META_WS_E_TYRANTZOMBIE: "Tyrant Zombie",
  T_46_META_WS_E_UAVLITE: "UAVLite",
  T_46_META_WS_E_UIFINISH: "End",
  T_46_META_WS_E_UITAP: "UI Tap",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "Unit Generator",
  T_46_META_WS_E_UPWARDTURBULENCE: "Updraft",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "Window Jump",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "Vehicle",
  T_46_META_WS_E_VEHICLEEXPLODE: "Vehicle Explosion",
  T_46_META_WS_E_VELOCITY: "Velocity",
  T_46_META_WS_E_VENDINGMACHINE: "Vending Machine",
  T_46_META_WS_E_VERTICAL: "Vertical",
  T_46_META_WS_E_VEST: "Vest",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Lv.3 Vest",
  T_46_META_WS_E_VEST4: "Lv.4 Vest",
  T_46_META_WS_E_VISUALEFFECTS: "Visual Effects",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "Wall A",
  T_46_META_WS_E_WALLBRAWL: "Skill 2",
  T_46_META_WS_E_WARNING: "Warning",
  T_46_META_WS_E_WATERRING: "Water Splash",
  T_46_META_WS_E_WAVE1: "Wave1",
  T_46_META_WS_E_WAVE2: "Wave2",
  T_46_META_WS_E_WAVE3: "Wave3",
  T_46_META_WS_E_WEAPONGENERATOR: "Weapon",
  T_46_META_WS_E_WEAPONSLOT: "Weapon Slot",
  T_46_META_WS_E_WHISTLE: "Defeat Enemy",
  T_46_META_WS_E_WIDERANGE: "Wide Range",
  T_46_META_WS_E_WIN: "Victory",
  T_46_META_WS_E_WINDATTACK: "Tornado Attack",
  T_46_META_WS_E_WOODA: "Wood A",
  T_46_META_WS_E_WOODCUTZOMBIE: "Axe Zombie",
  T_46_META_WS_E_WOODENPLANK: "Plank Bridge",
  T_46_META_WS_E_WORLDPOSITION: "World Coordinates",
  T_46_META_WS_E_WRECKEDBUS: "Wrecked Bus",
  T_46_META_WS_E_WRECKEDCAR: "Wrecked Car",
  T_46_META_WS_E_WRONG: "Wrong",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "Zombie",
  T_46_META_WS_E_ZOMBIES: "Zombie",
  T_46_META_WS_E_ZOOM: "Zoom",
  T_46_META_WS_ELIMINATE: "Eliminate",
  T_46_META_WS_ELIMINATEDENTITY: "Eliminated Entity",
  T_46_META_WS_ELIMINATEDPLAYER: "Eliminated Player",
  T_46_META_WS_ENABLEDEFAULTBTREE: "Enable Default Behavour Tree",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "Enable Moving Safe Zone",
  T_46_META_WS_ENABLESAFEZONE: "Enable Safe Zone",
  T_46_META_WS_ENDCURRENTPHASE: "End Current Phase",
  T_46_META_WS_ENDMORPH: "End Morph",
  T_46_META_WS_ENDPOSITION: "End Position",
  T_46_META_WS_ENTERVEHICLE: "Enter Vehicle",
  T_46_META_WS_ENTITY: "Entity",
  T_46_META_WS_EQUIPMENTID: "Equipment ID",
  T_46_META_WS_EULERANGLETOQUATERNION: "Euler Angle To Quaternion",
  T_46_META_WS_EXITVEHICLE: "Exit Vehicle",
  T_46_META_WS_EXPONENTIATION: "Exponentiation",
  T_46_META_WS_FILTERENTITY: "Filter Entity",
  T_46_META_WS_FILTERLEVELOBJECTS: "Filter Level Objects",
  T_46_META_WS_FIND: "Find",
  T_46_META_WS_FINDAT: "Find At",
  T_46_META_WS_FINDPATH: "Find Path",
  T_46_META_WS_FLOOR: "Floor",
  T_46_META_WS_FOOTBALLGOAL: "Football Goal",
  T_46_META_WS_FORMAT: "Format",
  T_46_META_WS_GETALLKEYS: "Get All Keys",
  T_46_META_WS_GETALLPLAYERS: "Get All Players",
  T_46_META_WS_GETALLSHOPS: "Get All Shops",
  T_46_META_WS_GETALLTEAMS: "Get All Teams",
  T_46_META_WS_GETATTACKABLEENTITY: "Get Attack Able Entity",
  T_46_META_WS_GETATTACKABLEFACTIONS: "Get Attackable Factions",
  T_46_META_WS_GETBACKPACKSKIN: "Get Backpack Skin",
  T_46_META_WS_GETBLACKBOARDVALUE: "Get Blackboard Value",
  T_46_META_WS_GETBUFFS: "Get Buffs",
  T_46_META_WS_GETCHATCHANNEL: "Get Chat Channel",
  T_46_META_WS_GETCHILDBYINDEX: "Get Child By Index",
  T_46_META_WS_GETCHILDBYNAME: "Get Child By Name",
  T_46_META_WS_GETCHILDREN: "Get Children",
  T_46_META_WS_GETCOLORCHANNEL: "Get Color Channel",
  T_46_META_WS_GETCONSUMABLES: "Get Consumables",
  T_46_META_WS_GETCULLINGMASK: "Get Culling Mask",
  T_46_META_WS_GETCURRENTCAMERA: "Get Current Camera",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "Get Current Chat Channel",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "Get Custom Mission Progress",
  T_46_META_WS_GETDYEDCOUNT: "Get Dyed Count",
  T_46_META_WS_GETDYEDSTATUS: "Get Dyed Status",
  T_46_META_WS_GETEQUIPMENTS: "Get Equipments",
  T_46_META_WS_GETFACTION: "Get Faction",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "Get Global Sleep Threshold",
  T_46_META_WS_GETITEMCOUNT: "Get Item Count",
  T_46_META_WS_GETLOADEDSCENES: "Get Loaded Scenes",
  T_46_META_WS_GETLOCALAIMDIRECTION: "Get Local Aim Direction",
  T_46_META_WS_GETLOCALPLAYER: "Get Local Player",
  T_46_META_WS_GETLOCALTIMESTAMP: "Get Local Timestamp",
  T_46_META_WS_GETMAPID: "Get Map ID",
  T_46_META_WS_GETMINIMAP: "Get Mini Map",
  T_46_META_WS_GETMONEY: "Get Money",
  T_46_META_WS_GETMONEYCOUNT: "Get Money Count",
  T_46_META_WS_GETMORPH: "Get Morph",
  T_46_META_WS_GETNODEVARIABLE: "Get Node Variable",
  T_46_META_WS_GETOUTFIT: "Get Outfit",
  T_46_META_WS_GETOWNER: "Get Owner",
  T_46_META_WS_GETPARENT: "Get Parent",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "Get Position Near Teammate",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "Get Random Spawn Position",
  T_46_META_WS_GETRESULTFROMCURVE: "Get Result From Curve",
  T_46_META_WS_GETSCENESKYBOX: "Get Scene Skybox",
  T_46_META_WS_GETSERVERREGION: "Get Server Region",
  T_46_META_WS_GETSERVERTIMESTAMP: "Get Server Timestamp",
  T_46_META_WS_GETSKELETONPARTBYNAME: "Get Skeleton Part By Name",
  T_46_META_WS_GETSKILLS: "Get Skills",
  T_46_META_WS_GETSLEEPTHRESHOLD: "Get Sleep Threshold",
  T_46_META_WS_GETTOKENCOUNT: "Get Token Count",
  T_46_META_WS_GETTOKENCOUNTTODAY: "Get Token Count Today",
  T_46_META_WS_GETTYPE: "Get Type",
  T_46_META_WS_GETVEHICLESKIN: "Get Vehicle Skin",
  T_46_META_WS_GETWALLET: "Get Wallet",
  T_46_META_WS_GETWEAPONSKIN: "Get Weapon Skin",
  T_46_META_WS_GETWIDGETBYPATH: "Get Widget By Path",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "Get Widget From Custom UI",
  T_46_META_WS_GIVEJAILBREAKITEM: "Give Jail Break Item",
  T_46_META_WS_GIVEJAILBREAKREWARD: "Give Jail Break Reward",
  T_46_META_WS_HASAOISPECIALFOLLOW: "Has AOI Special Follow",
  T_46_META_WS_HASCOMPONENT: "Has Component",
  T_46_META_WS_HASSCRIPT: "Has Script",
  T_46_META_WS_HASTAG: "Has Tag",
  T_46_META_WS_HELPEDPLAYER: "HelpedPlayer",
  T_46_META_WS_HELPPLAYER: "HelpPlayer",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "Hide Appearance Group",
  T_46_META_WS_HITENTITY: "Hit Entity",
  T_46_META_WS_HITFLY: "Hit Fly",
  T_46_META_WS_HITNORMAL: "Hit Normal",
  T_46_META_WS_HITOBJECT: "Hit Object",
  T_46_META_WS_HITPOSITION: "Hit Position",
  T_46_META_WS_INDEXOF: "Index Of",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "Infection Zombie Grow Up",
  T_46_META_WS_INSERT: "Insert",
  T_46_META_WS_ISATTACKABLE: "Is AttackAble",
  T_46_META_WS_ISCHATCHANNELEMPTY: "Is Chat Channel Empty",
  T_46_META_WS_ISEQUAL: "Is Equal",
  T_46_META_WS_ISFRIEND: "Is Friend",
  T_46_META_WS_ISHIT: "Is Hit",
  T_46_META_WS_ISINSIDEBOX: "Is Inside Box",
  T_46_META_WS_ISINSIDECYLINDER: "Is Inside Cylinder",
  T_46_META_WS_ISINSIDESECTOR: "Is Inside Sector",
  T_46_META_WS_ISINSIDESPHERE: "Is Inside Sphere",
  T_46_META_WS_ISSLEEPING: "Is Sleeping",
  T_46_META_WS_ISSUBTYPEOF: "Is Sub Type Of",
  T_46_META_WS_ITEM: "Item",
  T_46_META_WS_ITEMID: "Item ID",
  T_46_META_WS_JOIN: "Join",
  T_46_META_WS_JOINCHATCHANNEL: "Join Chat Channel",
  T_46_META_WS_JOINFACTION: "Join Faction",
  T_46_META_WS_LASTINDEXOF: "Last Index Of",
  T_46_META_WS_LENGTH: "Length",
  T_46_META_WS_LERP: "Lerp",
  T_46_META_WS_LOADSCENE: "Load Scene",
  T_46_META_WS_LOGARITHM: "Logarithm",
  T_46_META_WS_LOGERROR: "Log Error",
  T_46_META_WS_LOGINFO: "Log Info",
  T_46_META_WS_LOGWARNING: "Log Warning",
  T_46_META_WS_LOOKROTATION: "Look Rotation",
  T_46_META_WS_MAGNITUDE: "Magnitude",
  T_46_META_WS_MAKER: "Maker",
  T_46_META_WS_MAX: "Max",
  T_46_META_WS_MECHANISM: "Mechanism",
  T_46_META_WS_MIN: "Min",
  T_46_META_WS_MONSTERUSESKILL: "Use Skill",
  T_46_META_WS_MORPHOBJECT: "Morph Object",
  T_46_META_WS_MORPHTO: "Morph To",
  T_46_META_WS_MORPHTOBYITEMID: "Morph To By Item ID",
  T_46_META_WS_MOVECCT: "Move CCT",
  T_46_META_WS_MOVEPOSITION: "Move Position",
  T_46_META_WS_MOVEROTATION: "Move Rotation",
  T_46_META_WS_MULTIPLYQUATERNION: "Multiply Quaternion",
  T_46_META_WS_MULTIRAYCAST: "Multi-Raycast",
  T_46_META_WS_NEGATE: "Negate",
  T_46_META_WS_NEW: "New",
  T_46_META_WS_NODENAME: "Node Name",
  T_46_META_WS_NORMALIZE: "Normalize",
  T_46_META_WS_NOTIFYPLAYEFFECT: "Notify Play Effect",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "Notify Play Icon Animation",
  T_46_META_WS_NOTIFYPLAYSOUND: "Notify Play Sound",
  T_46_META_WS_NOTIFYSHOWTIPS: "Notify Show Tips",
  T_46_META_WS_NUMTOSTRING: "Number To String",
  T_46_META_WS_ONACCESSEQUIPMENT: "On Access Equipment",
  T_46_META_WS_ONACCESSITEM: "On Access Item",
  T_46_META_WS_ONACCESSWEAPON: "On Access Weapon",
  T_46_META_WS_ONACE: "On ACE",
  T_46_META_WS_ONAIMED: "On Aimed",
  T_46_META_WS_ONAIMING: "On Aiming",
  T_46_META_WS_ONASSIST: "On Assist",
  T_46_META_WS_ONATTACK: "On Attack",
  T_46_META_WS_ONATTACKSTOP: "On Attack Stop",
  T_46_META_WS_ONAWAKE: "On Awake",
  T_46_META_WS_ONBEKNOCKEDDOWN: "On Be Knocked Down",
  T_46_META_WS_ONBOUNCEDBYTIRE: "On Bounced By Tire",
  T_46_META_WS_ONBOUNCEENTITY: "On Bounce Entity",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "On Built-In UI Button Tapped",
  T_46_META_WS_ONBULLETHIT: "On Bullet Hit",
  T_46_META_WS_ONCAMERARAYCAST: "On Camera Raycast",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "On Character Controller Hit",
  T_46_META_WS_ONCHASE: "On Chase",
  T_46_META_WS_ONCHASESTOP: "On Chase Stop",
  T_46_META_WS_ONCLIPEND: "On Clip End",
  T_46_META_WS_ONCOLLISIONENTER: "On Collision Enter",
  T_46_META_WS_ONCOLLISIONEXIT: "On Collision Exit",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "On Countdown Finished",
  T_46_META_WS_ONCREEP: "On Prone",
  T_46_META_WS_ONCROUCH: "On Crouch",
  T_46_META_WS_ONDEALDAMAGE: "On Deal Damage",
  T_46_META_WS_ONDESTROY: "On Destroy",
  T_46_META_WS_ONDISABLE: "On Disable",
  T_46_META_WS_ONDISCONNECT: "On Disconnect",
  T_46_META_WS_ONDOUBLETAPPED: "On Double-Tapped",
  T_46_META_WS_ONDRAG: "On Drag",
  T_46_META_WS_ONDRAGEND: "On Drag End",
  T_46_META_WS_ONDRAGSTART: "On Drag Start",
  T_46_META_WS_ONDRIVED: "On Drived",
  T_46_META_WS_ONDRIVEVEHICLE: "On Drive Vehicle",
  T_46_META_WS_ONDROPCONSUMABLE: "On Drop Consumable",
  T_46_META_WS_ONDROPPED: "On Dropped",
  T_46_META_WS_ONDROPWEAPON: "On Drop Weapon",
  T_46_META_WS_ONEACHLOOP: "On Each Loop",
  T_46_META_WS_ONELIMINATE: "On Eliminate",
  T_46_META_WS_ONELIMINATED: "On Eliminated",
  T_46_META_WS_ONENABLE: "On Enable",
  T_46_META_WS_ONEND: "On End",
  T_46_META_WS_ONENTERED: "On Entered",
  T_46_META_WS_ONENTERVEHICLE: "On Enter Vehicle",
  T_46_META_WS_ONENTITYENTER: "On Trigger Enter",
  T_46_META_WS_ONENTITYEXIT: "On Trigger Leave",
  T_46_META_WS_ONEQUIPARMOR: "On Equip Armor",
  T_46_META_WS_ONEQUIPED: "On Equiped",
  T_46_META_WS_ONEQUIPWEAPON: "On Equip Weapon",
  T_46_META_WS_ONEXPLODE: "On Explode",
  T_46_META_WS_ONFALL: "On Fall",
  T_46_META_WS_ONFALLSTOP: "On Fall Stop",
  T_46_META_WS_ONFIRE: "On Fire",
  T_46_META_WS_ONFIXEDUPDATE: "On Fixed Update",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "On Football Collided",
  T_46_META_WS_ONFRIENDSUPDATE: "On Friendship Status Update",
  T_46_META_WS_ONGAMEEND: "On Game End",
  T_46_META_WS_ONGAMEPAUSE: "On Game Pause",
  T_46_META_WS_ONGAMERESUME: "On Game Resume",
  T_46_META_WS_ONGAMESTART: "On Game Start",
  T_46_META_WS_ONGOAL: "On Goal",
  T_46_META_WS_ONHITBYBULLET: "On Hit By Bullet",
  T_46_META_WS_ONHITFLY: "On Hit Fly",
  T_46_META_WS_ONHITFLYENTITY: "On Hit Fly Entity",
  T_46_META_WS_ONHOOKGUNFIRE: "On Hook Gun Fire",
  T_46_META_WS_ONIDLE: "On Idle",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "Jail Break Area Begin",
  T_46_META_WS_ONJAILBREAKAREAEND: "Jail Break Area End",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "Jail Break Player Join",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "Jail Break Player Quit",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "On Join Chat Channel Successfully",
  T_46_META_WS_ONJOYSTICKMOVE: "On Joystick Move",
  T_46_META_WS_ONJOYSTICKPRESSED: "On Pressed",
  T_46_META_WS_ONJOYSTICKRELEASED: "On Released",
  T_46_META_WS_ONJUMP: "On Jump",
  T_46_META_WS_ONJUMPSTOP: "On Jump Stop",
  T_46_META_WS_ONLANDMINEACTIVE: "On Landmine Active",
  T_46_META_WS_ONLANDMINETRIGGER: "On Landmine Trigger",
  T_46_META_WS_ONLEAVECHATCHANNEL: "On Leave Chat Channel",
  T_46_META_WS_ONLEAVEVEHICLE: "On Leave Vehicle",
  T_46_META_WS_ONLEFT: "On Left",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "On Level Object Be Morphed",
  T_46_META_WS_ONMOVE: "On Move",
  T_46_META_WS_ONNODEENTER: "On Node Enter",
  T_46_META_WS_ONNODEEXIT: "On Node Exit",
  T_46_META_WS_ONPAUSE: "On Pause",
  T_46_META_WS_ONPHASEEND: "On Phase End",
  T_46_META_WS_ONPHASESTART: "On Phase Start",
  T_46_META_WS_ONPICKEDUP: "On Picked Up",
  T_46_META_WS_ONPLAYERASSIST: "On Player Assist",
  T_46_META_WS_ONPLAYERBEELIMINATED: "On Player Be Eliminated",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "On Player Be Knocked Down",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "On Player Deal Damage",
  T_46_META_WS_ONPLAYERELIMINATE: "On Player Eliminate",
  T_46_META_WS_ONPLAYERENTER: "On Player Enter",
  T_46_META_WS_ONPLAYERJOIN: "On Player Join",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "On Join Chat Channel Failure",
  T_46_META_WS_ONPLAYERLEAVE: "On Player Leave",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "On Player Request Purchase",
  T_46_META_WS_ONPLAYERQUIT: "On Player Quit Midway",
  T_46_META_WS_ONPLAYERRANKCHANGE: "On Player Rank Change",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "On Player Request For Purchase Fulfilled",
  T_46_META_WS_ONPLAYERREVIVED: "On Player Revived",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "On Player Revived In SpawnPos",
  T_46_META_WS_ONPLAYERSCORECHANGE: "On Player Score Change",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "On Player Switch Scene",
  T_46_META_WS_ONPREDEALDAMAGE: "On Pre Deal Damage",
  T_46_META_WS_ONPREPURCHASE: "On Pre Purchase",
  T_46_META_WS_ONPRESSED: "On Pressed",
  T_46_META_WS_ONPRETAKEDAMAGE: "On Pre Take Damage",
  T_46_META_WS_ONPURCHASE: "On Purchase",
  T_46_META_WS_ONRANKCHANGED: "On Entity Rank Change",
  T_46_META_WS_ONRECONNECT: "On Reconnect",
  T_46_META_WS_ONRELEASED: "On Released",
  T_46_META_WS_ONRELOAD: "On Reload",
  T_46_META_WS_ONRESUME: "On Resume",
  T_46_META_WS_ONREVIVED: "On Revived",
  T_46_META_WS_ONROUNDEND: "On Round End",
  T_46_META_WS_ONROUNDSTART: "On Round Start",
  T_46_META_WS_ONSCENELOAD: "On Scene Load",
  T_46_META_WS_ONSCENESWITCH: "On Scene Switch",
  T_46_META_WS_ONSCORECHANGE: "On Entity Score Change",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "On Shot By Football Shooter",
  T_46_META_WS_ONSLEEP: "On Sleep",
  T_46_META_WS_ONSPAWN: "On Spawn",
  T_46_META_WS_ONSPRAY: "On Spray",
  T_46_META_WS_ONSPRAYED: "On Sprayed",
  T_46_META_WS_ONSPRINT: "On Sprint",
  T_46_META_WS_ONSPRINTSTOP: "On Sprint Stop",
  T_46_META_WS_ONSTANDUP: "On Stand Up",
  T_46_META_WS_ONSTART: "On Start",
  T_46_META_WS_ONSTARTFIRE: "On Attack",
  T_46_META_WS_ONSTATEEND: "On State End",
  T_46_META_WS_ONSURFING: "On Surfing",
  T_46_META_WS_ONSURFINGSTOP: "On Surfing Stop",
  T_46_META_WS_ONSWITCHHANDHELD: "On Switch Handheld",
  T_46_META_WS_ONTAKEDAMAGE: "On Take Damage",
  T_46_META_WS_ONTAPPED: "On Tapped",
  T_46_META_WS_ONTEAMACE: "On Team Ace",
  T_46_META_WS_ONTEAMADD: "On Team Add",
  T_46_META_WS_ONTEAMREMOVE: "On Team Remove",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "On Team Round Rank Change",
  T_46_META_WS_ONTEAMSCORECHANGE: "On Team Score Change",
  T_46_META_WS_ONTELEPORTENTITY: "On Teleport Entity",
  T_46_META_WS_ONTEXTCHANGE: "On Text Change",
  T_46_META_WS_ONTHROWABLEEXPLODE: "On Throwable Explode",
  T_46_META_WS_ONTOGGLE: "On Toggle",
  T_46_META_WS_ONTOUCHDOWN: "On Touch Down",
  T_46_META_WS_ONTOUCHUP: "On Touch Up",
  T_46_META_WS_ONUIHIDE: "On UI Hide",
  T_46_META_WS_ONUISHOW: "On UI Show",
  T_46_META_WS_ONUPDATE: "On Update",
  T_46_META_WS_ONUSEAVATARSKILL: "On Use Avatar Skill",
  T_46_META_WS_ONUSECONSUMABLE: "On Use Consumable",
  T_46_META_WS_ONUSED: "On Used",
  T_46_META_WS_ONUSEPORTAL: "On Use Portal",
  T_46_META_WS_ONWAKEUP: "On Wake Up",
  T_46_META_WS_ONWEAPONBEEQUIPED: "On Weapon Be Equiped",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "On Weapon Deal Damage",
  T_46_META_WS_ONWEAPONELIMINATE: "On Weapon Eliminate",
  T_46_META_WS_ONWEAPONSTOPFIRING: "On Weapon Stop Firing",
  T_46_META_WS_OWNER: "Owner",
  T_46_META_WS_P_ACCELERATE: "Accelerate",
  T_46_META_WS_P_ACCELERATION: "Acceleration",
  T_46_META_WS_P_ACCOUNTID: "Account ID",
  T_46_META_WS_P_ACCURACY: "Accuracy",
  T_46_META_WS_P_ACTIONTYPE: "Action Type",
  T_46_META_WS_P_ACTIVATEDALPHA: "Activated Alpha",
  T_46_META_WS_P_ACTIVE: "Active",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "Active in Hierarchy",
  T_46_META_WS_P_ACTIVESELF: "Active Self",
  T_46_META_WS_P_ACTIVETEXT: "Active Text",
  T_46_META_WS_P_ACTUALPOSITION: "Actual Position",
  T_46_META_WS_P_AFTERACCUMULATOR: "AfterAccumulator",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "Aim Assist Center Offset",
  T_46_META_WS_P_AIMASSISTDISTANCE: "Aim Assist Distance",
  T_46_META_WS_P_AIMASSISTTYPE: "Aim Assist Type",
  T_46_META_WS_P_AIRDROPSTATE: "Airdrop State",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "Alignment Horizontal",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "Alignment Vertical",
  T_46_META_WS_P_ALLITEMS: "All Items",
  T_46_META_WS_P_ALLMEMBERS: "All Members",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "Allow Lock by Aim Assist",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "Allow Pressed Outside",
  T_46_META_WS_P_ALLPLAYERS: "All Players",
  T_46_META_WS_P_ALLTEAMMATES: "All Teammates",
  T_46_META_WS_P_ALPHA: "Alpha",
  T_46_META_WS_P_ALWAYSSHOWMARK: "Always Show Mark",
  T_46_META_WS_P_AMBIENTCOLOR: "Ambient Color",
  T_46_META_WS_P_AMMOCLIPSIZE: "Ammo Clip Size",
  T_46_META_WS_P_AMMOMAGSIZE: "Ammo Mag Size",
  T_46_META_WS_P_AMMOPERSHOT: "Ammo per Shot",
  T_46_META_WS_P_AMMOTYPE: "Ammo Type",
  T_46_META_WS_P_ANCHORMAX: "Anchor Max",
  T_46_META_WS_P_ANCHORMIN: "Anchor Min",
  T_46_META_WS_P_ANCHOROBJECT: "Anchor Object",
  T_46_META_WS_P_ANCHORPOSITION: "Anchor Position",
  T_46_META_WS_P_ANCHORTYPE: "Anchor Type",
  T_46_META_WS_P_ANGLE: "Angle",
  T_46_META_WS_P_ANGLEDOWN: "Angle Down",
  T_46_META_WS_P_ANGLEUP: "Angle Up",
  T_46_META_WS_P_ANGULARDRAG: "Angular Drag",
  T_46_META_WS_P_ANGULARSPEED: "Angular Speed",
  T_46_META_WS_P_ANGULARVELOCITY: "Angular Velocity (rad/s)",
  T_46_META_WS_P_ANIMATIONCLIP: "Animation Name",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "Animation Controller",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "Animation Controller Resource ID",
  T_46_META_WS_P_ARMORPENETRATION: "Armor Penetration",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "Armor Penetration Factor",
  T_46_META_WS_P_ARMORTYPE: "Armor Type",
  T_46_META_WS_P_ARROWOFFSET: "Arrow Offset",
  T_46_META_WS_P_ARROWSIZE: "Arrow Size",
  T_46_META_WS_P_ARROWSPRITE: "Arrow Sprite",
  T_46_META_WS_P_ASKBUYTARGET: "Ask Buy Target",
  T_46_META_WS_P_ATTACHTARGET: "Attach Target",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "Attackable Factions",
  T_46_META_WS_P_ATTACKDAMAGE: "Attack Damage",
  T_46_META_WS_P_ATTACKINTERVAL: "Attack Interval",
  T_46_META_WS_P_ATTACKRANGE: "Attack Range",
  T_46_META_WS_P_ATTACKTARGET: "Attack Target",
  T_46_META_WS_P_ATTTACKABLETARGETS: "Attackable Targets",
  T_46_META_WS_P_AUTOPLAY: "Auto-Play Status",
  T_46_META_WS_P_AVAILABLEPOINT: "Available Point",
  T_46_META_WS_P_AVATAR: "Avatar",
  T_46_META_WS_P_AVATARID: "Avatar ID",
  T_46_META_WS_P_BACKGROUND: "Background",
  T_46_META_WS_P_BACKGROUNDALPHA: "Background Alpha",
  T_46_META_WS_P_BACKGROUNDCOLOR: "Background Color",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "Background Color 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "Background Color 2",
  T_46_META_WS_P_BACKGROUNDFILL: "Background Fill",
  T_46_META_WS_P_BACKGROUNDICONNAME: "Background Icon Name",
  T_46_META_WS_P_BACKGROUNDNAME: "Background Name",
  T_46_META_WS_P_BACKGROUNDOFFSET: "Background Offset",
  T_46_META_WS_P_BACKGROUNDRADIUS: "Background Radius",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "Background Size Delta",
  T_46_META_WS_P_BACKGROUNDSPRITE: "Background Sprite",
  T_46_META_WS_P_BACKPACK: "Backpack",
  T_46_META_WS_P_BACKPACKSKINID: "Backpack Skin ID",
  T_46_META_WS_P_BACKWARDSPEED: "Backward Speed",
  T_46_META_WS_P_BANNERID: "Banner ID",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "Base Horizontal Speed",
  T_46_META_WS_P_BASEMULTIPLIER: "BaseMultiplier",
  T_46_META_WS_P_BASETIME: "Base Time",
  T_46_META_WS_P_BASEVERTICALSPEED: "Base Vertical Speed",
  T_46_META_WS_P_BEFOREACCUMULATOR: "BeforeAccumulator",
  T_46_META_WS_P_BEVTREEID: "Behavior Tree ID",
  T_46_META_WS_P_BINDPROPERTYID: "BindPropertyID",
  T_46_META_WS_P_BODY: "Torso",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "Body Damage Factor",
  T_46_META_WS_P_BONEPOSITION: "Bone Position",
  T_46_META_WS_P_BONESCALE: "Skeleton Scale",
  T_46_META_WS_P_BOOSTCD: "Boost CD",
  T_46_META_WS_P_BOOSTDURATION: "Sprint Duration",
  T_46_META_WS_P_BOOSTSPEED: "Sprint Speed",
  T_46_META_WS_P_BORDERLR: "Border Left Right",
  T_46_META_WS_P_BORDERTB: "Border Top Bottom",
  T_46_META_WS_P_BOTTOMALPHA: "Bottom Alpha",
  T_46_META_WS_P_BOUNDWALLET: "Bound Wallet",
  T_46_META_WS_P_BRAKEHORSEPOWER: "Brake Horsepower",
  T_46_META_WS_P_BRAKETORQUE: "BrakeTorque",
  T_46_META_WS_P_BRRANK: "BR Rank",
  T_46_META_WS_P_BUFFTYPE: "Buff Type",
  T_46_META_WS_P_BURNDAMAGE: "Burning Damage",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "Burning Damage Interval",
  T_46_META_WS_P_BURNTIME: "Burning Time",
  T_46_META_WS_P_BUTTOM: "Bottom",
  T_46_META_WS_P_BUTTONCOLORS: "ButtonColors",
  T_46_META_WS_P_BUTTONNAMES: "ButtonNames",
  T_46_META_WS_P_BUTTONSTYLE: "Button Style",
  T_46_META_WS_P_CAMERABLOCKMODE: "Camera Block Mode",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "Camera Projection Mode",
  T_46_META_WS_P_CAMERATYPE: "Camera Type",
  T_46_META_WS_P_CANCELDRAGIFFITS: "Cancel Drag if Fits",
  T_46_META_WS_P_CANCOSTDURABILITY: "Can Cost Durability",
  T_46_META_WS_P_CANDAMAGED: "Can Damaged",
  T_46_META_WS_P_CANDESTROY: "Can Destroy",
  T_46_META_WS_P_CANDESTROYED: "Can Destroyed",
  T_46_META_WS_P_CANSELFTRIGGER: "Can Self Trigger",
  T_46_META_WS_P_CANTEAMTRIGGER: "Can Teammates Trigger",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "Can Triggered by Self",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "Can Triggered by Team",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "Can Triggered by Vehicle",
  T_46_META_WS_P_CANVEHICLETRIGGER: "Can Vehicle Trigger",
  T_46_META_WS_P_CELLSIZE: "Cell Size",
  T_46_META_WS_P_CELLSPACE: "Cell Space",
  T_46_META_WS_P_CENTER: "Center",
  T_46_META_WS_P_CENTERINVISIBLE: "Center Invisible",
  T_46_META_WS_P_CENTEROFFSET: "Center Offset",
  T_46_META_WS_P_CENTEROFMASS: "Center of Mass",
  T_46_META_WS_P_CENTERRANGE: "Center Range",
  T_46_META_WS_P_CENTRALFLASHTIME: "Central Flash Time",
  T_46_META_WS_P_CENTRALLINEACTIVE: "Central Line Active",
  T_46_META_WS_P_CENTRALLINEPOSITION: "CentralLine Position",
  T_46_META_WS_P_CHANNELID: "Chat Channel ID",
  T_46_META_WS_P_CHARGEMAX: "Charge Max",
  T_46_META_WS_P_CHASETARGET: "Chase Target",
  T_46_META_WS_P_CHATCHANNEL: "Chat Channel",
  T_46_META_WS_P_CHECKPOINTID: "Checkpoint ID",
  T_46_META_WS_P_CHILDINDEX: "Child Index",
  T_46_META_WS_P_CHIPEXP: "Chip Exp",
  T_46_META_WS_P_CLICKSIZE: "Click Size",
  T_46_META_WS_P_CLIPLENGTH: "Clip Length",
  T_46_META_WS_P_CLIPPINGTYPE: "Clipping Type",
  T_46_META_WS_P_COLLIDERID: "ColliderID",
  T_46_META_WS_P_CONSTRAIN: "Constrain",
  T_46_META_WS_P_CONSTRAINT: "Constraint",
  T_46_META_WS_P_CONSTRAINTCOUNT: "Constraint Count",
  T_46_META_WS_P_CONSUMABLETYPE: "Consumable Type",
  T_46_META_WS_P_CONTENT: "Content",
  T_46_META_WS_P_CONTENTORIGIN: "Content Origin",
  T_46_META_WS_P_CONTROLPOINTS: "Control Points",
  T_46_META_WS_P_COORDINATESYSTEM: "Coordinate System",
  T_46_META_WS_P_COUNT: "Count",
  T_46_META_WS_P_COUNTDOWNENDTIME: "Countdown End Time (s)",
  T_46_META_WS_P_COUNTDOWNKEY: "Count Down Key",
  T_46_META_WS_P_COUNTDOWNTIME: "Countdown Time",
  T_46_META_WS_P_COUNTPERWAVE: "Count per Wave",
  T_46_META_WS_P_CRASHMAXDAMAGE: "CrashMaxDamage",
  T_46_META_WS_P_CRASHMAXSPEED: "Crash Max. Speed",
  T_46_META_WS_P_CRASHMESSFACTOR: "CrashMessFactor",
  T_46_META_WS_P_CRASHMINDAMAGE: "CrashMinDamage",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "Crawl Speed Scale",
  T_46_META_WS_P_CREATEDENTITY: "Created Entity",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "Crouch-Walk Speed Scale",
  T_46_META_WS_P_CSRANK: "CS Rank",
  "T_46_META_WS_P_CURRENT AMMO": "Current Ammo",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "Current Animation Resource",
  T_46_META_WS_P_CURRENTCLIP: "Current Clip",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "Current Clip Progress",
  T_46_META_WS_P_CURRENTDURABILITY: "Current Durability",
  T_46_META_WS_P_CURRENTENERGY: "Current Energy",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "Current Handheld Item",
  T_46_META_WS_P_CURRENTHP: "Current HP",
  T_46_META_WS_P_CURRENTPHASEINDEX: "Current Phase Index",
  T_46_META_WS_P_CURRENTPROGRESS: "Current Progress",
  T_46_META_WS_P_CURRENTROUNDINDEX: "Current Round Index",
  T_46_META_WS_P_CURRENTSTATE: "Current State",
  T_46_META_WS_P_CURRENTVALUE: "Current Value",
  T_46_META_WS_P_CURRENTWAVE: "Current Wave",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "Custom Character Resource",
  T_46_META_WS_P_CUSTOMGAMERESULT: "Custom Game Result",
  T_46_META_WS_P_CUSTOMGRAVITY: "Custom Gravity",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "Custom Push Force",
  T_46_META_WS_P_CUSTOMXY: "Custom XY",
  T_46_META_WS_P_DAMAGE: "Damage",
  "T_46_META_WS_P_DAMAGE RANGE": "Range",
  T_46_META_WS_P_DAMAGEFACTOR: "Damage Factor",
  T_46_META_WS_P_DAMAGEINTERVAL: "Damage Interval (s)",
  T_46_META_WS_P_DAMAGERADIUS: "Damage Radius",
  T_46_META_WS_P_DAMAGERATIOHEAD: "Headshot DMG Coefficient",
  T_46_META_WS_P_DAMAGERATIOLIMB: "Damage Ratio Limb",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "Damage Reduction Factor",
  T_46_META_WS_P_DAMAGETAKENPCT: "Damage Taken Percentage",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "Damage Taken Percent",
  T_46_META_WS_P_DAMAGEVALUE: "Damage Value",
  T_46_META_WS_P_DARKNESS: "Darkness",
  T_46_META_WS_P_DECELERATIONPERCENT: "Deceleration Percent",
  T_46_META_WS_P_DEFAULTTEXT: "Default Text",
  T_46_META_WS_P_DEFENSE: "Defense Rate",
  T_46_META_WS_P_DEFENSERATE: "Damage Reduction Rate",
  T_46_META_WS_P_DELTA: "Delta",
  T_46_META_WS_P_DELTATIME: "Delta Time",
  T_46_META_WS_P_DELTAVALUE: "Delta Value",
  T_46_META_WS_P_DEPTH: "Depth",
  T_46_META_WS_P_DESC: "Description",
  T_46_META_WS_P_DESCRIPTION: "Description",
  T_46_META_WS_P_DESCRIPTIONKEY: "Description Key",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "Description Params",
  T_46_META_WS_P_DESTVAL: "Dest Val",
  T_46_META_WS_P_DETECTRANGE: "Chase Vicinity",
  T_46_META_WS_P_DIFFUSEALPHA: "Diffuse Alpha",
  T_46_META_WS_P_DIFFUSECOLOR: "Diffuse Color",
  T_46_META_WS_P_DIFFUSETEXTURE: "Diffuse Texture",
  T_46_META_WS_P_DISABLECOLOR: "Disable Color",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "Is No Fall Damage",
  T_46_META_WS_P_DISABLEITEMDROP: "Disable Item Drop",
  T_46_META_WS_P_DISABLEITEMPICKUP: "Disable Item Pickup",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "Disable Manual Closing",
  T_46_META_WS_P_DISABLEQUICKCHAT: "Disable Quick Chat",
  T_46_META_WS_P_DISABLERECIPROCATING: "Disable Reciprocating",
  T_46_META_WS_P_DISABLEVOICECHAT: "Disable Voice Chat",
  T_46_META_WS_P_DISTANCE: "Distance",
  T_46_META_WS_P_DOUBLEGUNTYPE: "Akimbo Type",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "Downed Crawl Speed Scale",
  T_46_META_WS_P_DOWNSPEED: "Down Speed",
  T_46_META_WS_P_DRAG: "Drag",
  T_46_META_WS_P_DRIVER: "Driver",
  T_46_META_WS_P_DROPITEMS: "Drop Items",
  T_46_META_WS_P_DURABILITY: "Durability",
  T_46_META_WS_P_DURABILITYRECOVERY: "Durability Recovery",
  T_46_META_WS_P_DURATION: "Duration",
  T_46_META_WS_P_EDGEFLASHTIME: "Edge Flash Time",
  T_46_META_WS_P_EFFECTACTIVE: "Show Effect",
  T_46_META_WS_P_EFFECTCOLOR: "Effect Color",
  T_46_META_WS_P_EFFECTDURATION: "Effect Duration",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "Effective Time Interval",
  T_46_META_WS_P_EFFECTRESID: "Effect Resource Path",
  T_46_META_WS_P_ENABLE: "Enable",
  T_46_META_WS_P_ENABLEATTACK: "Enable Attack",
  T_46_META_WS_P_ENABLEBOTREVIVE: "Enable Bot Revive",
  T_46_META_WS_P_ENABLEDEPTHMAP: "Enable Depth Map",
  T_46_META_WS_P_ENABLEDROPONDEATH: "Enable Drop on Death",
  T_46_META_WS_P_ENABLELOCALIZATION: "Enable Localization",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "Enable Move In Midair",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "Enable Player Revive",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "Enable Player View",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "Enable Rotate With Gravity",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "Enable Skin Attributes",
  T_46_META_WS_P_ENABLESWINGING: "Enable Swinging",
  T_46_META_WS_P_ENABLETRACTION: "Enable Towing",
  T_46_META_WS_P_ENDPOSITION: "End Position",
  T_46_META_WS_P_ENDRADIUS: "End Radius",
  T_46_META_WS_P_ENDTIME: "End Time (s)",
  T_46_META_WS_P_ENDTIMES: "EndTimeS",
  T_46_META_WS_P_ENDVALUE: "End Value",
  T_46_META_WS_P_ENERGY: "Energy",
  T_46_META_WS_P_ENERGYCOST: "Energy Cost",
  T_46_META_WS_P_ENERGYRECOVERY: "Energy Recovery",
  T_46_META_WS_P_ENGINEHORSEPOWER: "Engine Horsepower",
  T_46_META_WS_P_ENGINETORQUE: "EngineTorque",
  T_46_META_WS_P_EP: "EP",
  T_46_META_WS_P_EPMAX: "Max. EP",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "EP Recovery Amount",
  T_46_META_WS_P_EVENTS: "Events",
  T_46_META_WS_P_EXPLODEDAMAGE: "Explosion Damage",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "Explode Damage Reduction Factor",
  T_46_META_WS_P_EXPLODEDELAY: "Explosion Delay",
  T_46_META_WS_P_EXPLODERANGE: "Explosion Range",
  T_46_META_WS_P_EXPLOSIONDELAY: "Explosion Delay",
  T_46_META_WS_P_EXPLOSIONRANGE: "Explosion Range",
  T_46_META_WS_P_EXPLOSIONTIME: "Explosion Delay",
  T_46_META_WS_P_EXPPERDAMAGE: "Exp Per Damage",
  T_46_META_WS_P_EXPPERMOVEMILE: "Exp Per Move Mile",
  T_46_META_WS_P_EXPPERSECOND: "EXP per Second",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "Extra Backpack Capacity",
  T_46_META_WS_P_EXTRABAGCAPACITY: "Extra Backpack Space",
  T_46_META_WS_P_EXTRAHPRATIO: "Extra HP Ratio",
  T_46_META_WS_P_FACEPAINT: "Facepaint",
  T_46_META_WS_P_FACTION: "Faction",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "Fall Damage Ratio",
  T_46_META_WS_P_FALLSPEED: "Fall Speed",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "Auto Reload Speed",
  T_46_META_WS_P_FILEID: "FileID",
  T_46_META_WS_P_FILL: "Fill",
  T_46_META_WS_P_FILLAMOUNT: "Fill Value",
  T_46_META_WS_P_FILLDIRECTION: "Fill Direction",
  T_46_META_WS_P_FILLTYPE: "Fill Type",
  T_46_META_WS_P_FIREANGLELIMIT: "Fire Angle Limit",
  T_46_META_WS_P_FIRETYPE: "Fire Type",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "First Score Params",
  T_46_META_WS_P_FIRSTSCORETITLE: "First Score Title",
  T_46_META_WS_P_FIRSTSCOREVALUE: "First Score Value",
  T_46_META_WS_P_FIXEDDELTATIME: "Fixed Delta Time",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "Flashbang Hit Effect Switch",
  T_46_META_WS_P_FLIP: "Flip",
  T_46_META_WS_P_FLIPTYPE: "Flip Type",
  T_46_META_WS_P_FLYMAXHEIGHT: "Fly Max. Height",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "Horizontal Glide Speed",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "Vertical Glide Speed",
  T_46_META_WS_P_FOGCOLOR: "Fog Color",
  T_46_META_WS_P_FOLLOWTARGET: "Follow Target",
  T_46_META_WS_P_FONT: "Font",
  T_46_META_WS_P_FONTSIZE: "Font Size",
  T_46_META_WS_P_FONTSTYLE: "Font Style",
  T_46_META_WS_P_FONTTYPE: "Font Type",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "Force Sync to Client",
  T_46_META_WS_P_FORWARD: "Forward",
  T_46_META_WS_P_FORWARDSPEED: "Forward Speed",
  T_46_META_WS_P_FOV: "Field of View",
  T_46_META_WS_P_FREEZEDURATION: "Freeze Duration (s)",
  T_46_META_WS_P_FRIENDFACTIONS: "Friendly Factions",
  T_46_META_WS_P_FRIENDLYPLAYERS: "Friendly Players",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "Full Damage Distance",
  T_46_META_WS_P_FUNCTIONTYPE: "Function Type",
  T_46_META_WS_P_GAINHPCOLOR: "Gain HP Color",
  T_46_META_WS_P_GAMEFRAMECOUNT: "Frame Count",
  T_46_META_WS_P_GAMETIMECOUNT: "Game Time",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "Gear Shifting Delay",
  T_46_META_WS_P_GENDER: "Gender",
  T_46_META_WS_P_GETONBOOSTCD: "Get On Boost CD",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "Get On Boost CD Switch",
  T_46_META_WS_P_GETONSKATEBOARDCD: "Get On Skateboard CD",
  T_46_META_WS_P_GRADIENT: "Gradient",
  T_46_META_WS_P_GRADIENTBOTTOM: "Gradient Bottom",
  T_46_META_WS_P_GRADIENTTOP: "Gradient Top",
  T_46_META_WS_P_GRAVITY: "Gravity",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "Grenade Max Damage",
  T_46_META_WS_P_GRENADEMINDAMAGE: "Grenade Min Damage",
  T_46_META_WS_P_GRENADERANGE: "Grenade Range",
  T_46_META_WS_P_GROUPID: "Group ID",
  T_46_META_WS_P_HEAD: "Head",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "Head Damage Factor",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "Headshot Damage Reduction",
  T_46_META_WS_P_HEIGHT: "Height",
  T_46_META_WS_P_HELMET: "Helmet",
  T_46_META_WS_P_HIGHESTBRRANK: "Highest BR rank",
  T_46_META_WS_P_HIGHESTCSRANK: "Highest CS rank",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "Min. Elevation Angle",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "HighSpeedSteerAngle",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "HighSpeedSteerAngleAtspeed",
  T_46_META_WS_P_HITPOINTEFFECT: "Hit Point Effect",
  T_46_META_WS_P_HORIZONTALBAR: "Horizontal Bar",
  T_46_META_WS_P_HORIZONTALOFFSET: "Horizontal Offset",
  T_46_META_WS_P_HOSTILETEAMS: "Enemy Teams",
  T_46_META_WS_P_HOSTTEAM: "Host Team",
  T_46_META_WS_P_HP: "HP",
  T_46_META_WS_P_HPMAX: "Max. HP",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "HP Recovery Amount",
  T_46_META_WS_P_HPRECOVERYSPEED: "HP Recovery Speed (ms)",
  T_46_META_WS_P_ICON: "Icon",
  T_46_META_WS_P_ICONCOLOR: "Icon Color",
  T_46_META_WS_P_ICONNAME: "Icon Name",
  T_46_META_WS_P_ICONRESOURCE: "Icon Resource",
  T_46_META_WS_P_ID: "ID",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "Damage Interval (s)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "IdleBrakeInput",
  T_46_META_WS_P_INACTIVATEDALPHA: "Inactivated Alpha",
  T_46_META_WS_P_INDEX: "Index",
  T_46_META_WS_P_INITIALMAGCOUNT: "Initial Mag Count",
  T_46_META_WS_P_INITIALSPEED: "Initial Velocity",
  T_46_META_WS_P_INITIALVALUE: "Initial Value",
  T_46_META_WS_P_INITIALWORLDPOSITION: "InitialWorldPosition",
  T_46_META_WS_P_INSCENE: "In Scene",
  T_46_META_WS_P_INSTANCEID: "Instance ID",
  T_46_META_WS_P_INTENSITY: "Intensity",
  T_46_META_WS_P_INVERTFILL: "Invert Fill",
  T_46_META_WS_P_INVINCIBLE: "Invincible",
  "T_46_META_WS_P_IS SHOW": "Is Show",
  T_46_META_WS_P_IS3D: "Is 3D",
  T_46_META_WS_P_ISACE: "Is Team Wipeout",
  T_46_META_WS_P_ISACED: "Is Team Wipeout",
  T_46_META_WS_P_ISAI: "Is AI",
  T_46_META_WS_P_ISALWAYSINSCREEN: "Is Always In Screen",
  T_46_META_WS_P_ISAPPLYSHADOW: "Is Apply Shadow",
  T_46_META_WS_P_ISATTACKABLE: "Is Attackable",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "Is Auto-Chase Enemy",
  T_46_META_WS_P_ISAUTOPLAY: "Is Auto Play",
  T_46_META_WS_P_ISAUTOTELEPORT: "Is Auto Teleport",
  T_46_META_WS_P_ISBILLBOARD: "Always Facing Camera",
  T_46_META_WS_P_ISBOLD: "Is Bold",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "Is Bottom Colliding",
  T_46_META_WS_P_ISCENTERPOS: "Is Center Position",
  T_46_META_WS_P_ISCONSUMEAMMO: "Is Consume Ammo",
  T_46_META_WS_P_ISCONTINUOUS: "Is Continuous",
  T_46_META_WS_P_ISCOUNTDOWN: "Is Countdown",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "Is Current Animation Loop",
  T_46_META_WS_P_ISDEADDROP: "Is Dead Drop",
  T_46_META_WS_P_ISDEATHTRIGGER: "Is Death Trigger",
  T_46_META_WS_P_ISDEBUG: "BTree Enable Debug",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "Is Default Spawn Point",
  T_46_META_WS_P_ISDROPONELIMINATED: "Is Drop on Eliminated",
  T_46_META_WS_P_ISEND: "Is End",
  T_46_META_WS_P_ISFEBUTTON: "Is FE Button",
  T_46_META_WS_P_ISGREY: "Is Gray",
  T_46_META_WS_P_ISGROUNDED: "Is Grounded",
  T_46_META_WS_P_ISIGNOREDEPTH: "Is Ignore Depth",
  T_46_META_WS_P_ISINVINCIBLE: "Is Invincible",
  T_46_META_WS_P_ISITALIC: "Is Italic",
  T_46_META_WS_P_ISLASTROUND: "Is Last Round",
  T_46_META_WS_P_ISLOCALPOS: "Is Local Position",
  T_46_META_WS_P_ISLOOP: "Is Looping",
  T_46_META_WS_P_ISMATCHPOINT: "Is Match Point",
  T_46_META_WS_P_ISMOVEABLE: "Enable Move",
  T_46_META_WS_P_ISOCCUPIED: "Is Occupied",
  T_46_META_WS_P_ISOPENTWEEN: "Is OpenTween",
  T_46_META_WS_P_ISPLAYING: "Is Playing",
  T_46_META_WS_P_ISPURCHASABLE: "Is Purchasable",
  T_46_META_WS_P_ISREVERSE: "Is Reverse",
  T_46_META_WS_P_ISSERVERDRIVEN: "Is Server-Driven",
  T_46_META_WS_P_ISSHOW: "Is Show",
  T_46_META_WS_P_ISSHOWHUDNAME: "Is Show HUD Name",
  T_46_META_WS_P_ISSHOWMAPINFO: "Is Show Map Information",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "Is Show Quick Message",
  T_46_META_WS_P_ISSHOWSCAN: "Is Show Scan",
  T_46_META_WS_P_ISSHOWTAG: "Is Show Tag",
  T_46_META_WS_P_ISSIDECOLLIDING: "Is Side Colliding",
  T_46_META_WS_P_ISSILENCE: "Is Silenced",
  T_46_META_WS_P_ISSINGLESHOT: "Is Single Shot",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "Is Skip Stagger Animation",
  T_46_META_WS_P_ISSLIDING: "Is Sliding",
  T_46_META_WS_P_ISTOPCOLLIDING: "Is Top Colliding",
  T_46_META_WS_P_ISUNDERLINE: "Is Underline",
  T_46_META_WS_P_ISVISIBLE: "Is Visible",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "ItemBackgroundColors",
  T_46_META_WS_P_ITEMBACKGROUNDS: "ItemBackgrounds",
  T_46_META_WS_P_ITEMCOUNTS: "ItemCounts",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "ItemDescriptions",
  T_46_META_WS_P_ITEMICONS: "ItemIcons",
  T_46_META_WS_P_ITEMID: "Weapon ID",
  T_46_META_WS_P_ITEMIDS: "Item IDs",
  T_46_META_WS_P_ITEMNAMES: "ItemNames",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "Item Pickup Banlist",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "Joystick Cap Drag Radius",
  T_46_META_WS_P_JOYSTICKIMAGE: "Joystick Cap Image",
  T_46_META_WS_P_JOYSTICKRADIUS: "Joystick Cap Radius",
  T_46_META_WS_P_JUMPCD: "Jump CD",
  T_46_META_WS_P_JUMPHEIGHT: "Jump Height",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "Jump Height Scale",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "Knockdown Damage Bonus",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "Knockdown Status",
  T_46_META_WS_P_LABEL: "Label",
  T_46_META_WS_P_LABELCOLOR: "Label Color",
  T_46_META_WS_P_LABELKEY: "Label Key",
  T_46_META_WS_P_LABELPARAMS: "Label Params",
  T_46_META_WS_P_LASTCHECKPOINTID: "Current Checkpoint ID",
  T_46_META_WS_P_LASTSURVIVALTIME: "Last Survival Time",
  T_46_META_WS_P_LAYERTYPE: "Layer Type",
  T_46_META_WS_P_LAYOUTTYPE: "Layout Type",
  T_46_META_WS_P_LEFTARM: "Left Arm",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "Left Background Color",
  T_46_META_WS_P_LEFTCOLOR: "LeftColor",
  T_46_META_WS_P_LEFTDESCRIPTION: "Left Description",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "Left Effect Active",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "Left Firing Arc Angle",
  T_46_META_WS_P_LEFTFOOT: "Left Foot",
  T_46_META_WS_P_LEFTHAND: "Left Hand",
  T_46_META_WS_P_LEFTICON: "Left Icon",
  T_46_META_WS_P_LEFTICONNAME: "Left Icon Name",
  T_46_META_WS_P_LEFTLEG: "Left Leg",
  T_46_META_WS_P_LEFTPLAYERS: "Left Players",
  T_46_META_WS_P_LEFTSCORE: "Left Score",
  T_46_META_WS_P_LEFTSCOREAFTER: "Left Final Score",
  T_46_META_WS_P_LEFTSCORETEXT: "Left Score",
  T_46_META_WS_P_LEFTTEAM: "Left Team",
  T_46_META_WS_P_LEFTTEAMINDEX: "Left Team Index",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "Left Teammate Alive Num",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "Left Teammate Flag Count",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "Left Teammate States",
  T_46_META_WS_P_LEFTTEAMNAME: "Left Team Name",
  T_46_META_WS_P_LEFTTEAMSCORE: "Left Team Score",
  T_46_META_WS_P_LEFTTEXT: "Left Text",
  T_46_META_WS_P_LENGTH: "Length",
  T_46_META_WS_P_LENSFLARE: "Lens Flare",
  T_46_META_WS_P_LEVEL: "Level",
  T_46_META_WS_P_LIFETIME: "Life Time (s)",
  T_46_META_WS_P_LIGHTCOLOR: "Light Color",
  T_46_META_WS_P_LIGHTINTENSITY: "Light Source Brightness",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "Limb Damage Factor",
  T_46_META_WS_P_LINESPACING: "Line Spacing",
  T_46_META_WS_P_LOCALPOSITION: "Local Position",
  T_46_META_WS_P_LOCALROTATION: "Local Rotation",
  T_46_META_WS_P_LOCALROTATIONQ: "Local Rotation Quaternion",
  T_46_META_WS_P_LOCALSCALE: "Local Scale",
  T_46_META_WS_P_LOCKEY: "Localization Key",
  T_46_META_WS_P_LOOPCOUNT: "Loop Count",
  T_46_META_WS_P_LOOTSOCCER: "Loot Soccer",
  T_46_META_WS_P_LOSEHPCOLOR: "Lose HP Color",
  T_46_META_WS_P_LOSEMVPS: "Lose MVPs",
  T_46_META_WS_P_LOSETEXT: "Lose Text",
  "T_46_META_WS_P_MAIN CAMERA": "Main Camera",
  T_46_META_WS_P_MAINCOLOR: "Main Color",
  T_46_META_WS_P_MAINSCORELIST: "Main Scores",
  T_46_META_WS_P_MAINSCORETITLE: "Main Score Title",
  T_46_META_WS_P_MAINWEAPON: "Main Weapon",
  T_46_META_WS_P_MAPSIZE: "Map Size",
  T_46_META_WS_P_MASK: "Mask",
  T_46_META_WS_P_MASKNAME: "Mask Name",
  T_46_META_WS_P_MASS: "Mass (kg)",
  T_46_META_WS_P_MATCHTITLELEFT: "Match Title Left",
  T_46_META_WS_P_MATCHTITLERIGHT: "Match Title Right",
  T_46_META_WS_P_MAXCAPACITY: "Max. Capacity",
  T_46_META_WS_P_MAXCOUNT: "Max. Count",
  T_46_META_WS_P_MAXDAMAGE: "Max. Damage",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "Max. Depression Angle",
  T_46_META_WS_P_MAXDISPLACEMENT: "Max. Displacement",
  T_46_META_WS_P_MAXDISTANCE: "Max. Distance",
  T_46_META_WS_P_MAXDURABILITY: "Max. Durability",
  T_46_META_WS_P_MAXDURABILITYRATIO: "Max. Durability Multiplier",
  T_46_META_WS_P_MAXENERGY: "Max. Energy",
  T_46_META_WS_P_MAXEP: "Max EP",
  T_46_META_WS_P_MAXHP: "Max. HP",
  T_46_META_WS_P_MAXJUMPCOUNT: "Max Jump Count",
  T_46_META_WS_P_MAXJUMPHEIGHT: "Max. Double Jump Height",
  T_46_META_WS_P_MAXLENGTH: "Max Length",
  T_46_META_WS_P_MAXPROGRESS: "Max Progress",
  T_46_META_WS_P_MAXSCATTERRATIO: "Max Scatter Ratio",
  T_46_META_WS_P_MAXSPEED: "Max Speed",
  T_46_META_WS_P_MAXTURRETCOUNT: "Max. Turret Count",
  T_46_META_WS_P_MAXVALUE: "Max Value",
  T_46_META_WS_P_MAXWIDGETID: "MaxWidgetID",
  T_46_META_WS_P_MINDAMAGE: "Min. Damage",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "Min. Damage Distance",
  T_46_META_WS_P_MINDISTANCE: "Min. Distance",
  T_46_META_WS_P_MINELEVATIONANGLE: "Min. Elevation Angle",
  T_46_META_WS_P_MINENDHEIGHT: "Min. End Height",
  T_46_META_WS_P_MINFLYHEIGHT: "Min. Fly Height",
  T_46_META_WS_P_MINMOVEDISTANCE: "Min. Move Distance",
  T_46_META_WS_P_MINVALUE: "MinValue",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "Missile Max Damage",
  T_46_META_WS_P_MISSILEMINDAMAGE: "Min. Missile Damage",
  T_46_META_WS_P_MISSILERANGE: "Missile Range",
  T_46_META_WS_P_MODEL: "Model",
  T_46_META_WS_P_MODELVISIBILITY: "Model Visibility",
  T_46_META_WS_P_MODELVISIBLE: "Model Visible",
  T_46_META_WS_P_MONEY: "Money",
  T_46_META_WS_P_MONEYLIST: "Money List",
  T_46_META_WS_P_MONEYS: "Moneys",
  T_46_META_WS_P_MONEYTYPE: "Money Type",
  T_46_META_WS_P_MONSTERTYPE: "Monster Type",
  T_46_META_WS_P_MOTIONTYPE: "Motion Type",
  T_46_META_WS_P_MOTIONVALUEX: "Motion Value X",
  T_46_META_WS_P_MOTIONVALUEY: "Motion Value Y",
  T_46_META_WS_P_MOTIONVALUEZ: "Motion Value Z",
  T_46_META_WS_P_MOVEMENTDURATION: "Movement Duration",
  T_46_META_WS_P_MULTIPLIER: "Multiplier",
  T_46_META_WS_P_MUSICELEMENTTYPE: "Music Element Type",
  T_46_META_WS_P_MUZZLEVELOCITY: "Muzzle Velocity",
  T_46_META_WS_P_MVP: "MVP",
  T_46_META_WS_P_NAME: "Name",
  T_46_META_WS_P_NEXTROUNDINDEX: "Next Round Index",
  T_46_META_WS_P_NICKNAME: "Nickname",
  T_46_META_WS_P_NORMALCOLOR: "Normal Color",
  T_46_META_WS_P_NORMALIZEDPOSITION: "Normalized Position",
  T_46_META_WS_P_NUMBERINFACTION: "Number in Faction",
  T_46_META_WS_P_OBJECTID: "Object ID",
  T_46_META_WS_P_OFFSET: "Offset",
  T_46_META_WS_P_OPTIONS: "Options",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "Other Damage Factor",
  T_46_META_WS_P_OUTFIT: "Outfit",
  T_46_META_WS_P_OVERFLOW: "Overflow",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "Overheight Fall Speed",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "Prioritize Player Configuration",
  T_46_META_WS_P_OWNER: "Owner",
  T_46_META_WS_P_PARAMS: "Params",
  T_46_META_WS_P_PARENT: "Parent",
  T_46_META_WS_P_PARENTID: "ParentID",
  T_46_META_WS_P_PARENTUI: "Parent UI",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "Parent Widget Entity ID",
  T_46_META_WS_P_PARENTWIDGETFILEID: "Parent Widget File ID",
  T_46_META_WS_P_PARTMASKA: "Part Mask 1",
  T_46_META_WS_P_PASSENGERS: "Passengers",
  T_46_META_WS_P_PATHID: "Path ID",
  T_46_META_WS_P_PAUSEEVENT: "Pause Event",
  T_46_META_WS_P_PERSONAID: "Persona ID",
  T_46_META_WS_P_PHASEDURATION: "Duration (ms)",
  T_46_META_WS_P_PHASEENDTIME: "End Time (ms)",
  T_46_META_WS_P_PHYSICALLAYER: "Physical Layer",
  T_46_META_WS_P_PINID: "Pin ID",
  T_46_META_WS_P_PITCH: "Vertical Angle",
  T_46_META_WS_P_PIVOT: "Pivot",
  T_46_META_WS_P_PLAYER: "Player",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "Player Aiming Speed Factor",
  T_46_META_WS_P_PLAYERLIST: "Player List",
  T_46_META_WS_P_PLAYERNAME: "Player Name",
  T_46_META_WS_P_PLAYERRANK: "Player Rank",
  T_46_META_WS_P_PLAYERRANKS: "Player Ranks",
  T_46_META_WS_P_PLAYERS: "Players",
  T_46_META_WS_P_PLAYERSCORETYPES: "Player Score Types",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "Player Speed Factor",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "Player Speed Factor While Firing",
  T_46_META_WS_P_PLAYERSTATUS: "Player Status",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "Player Traction Speed",
  T_46_META_WS_P_PLAYINGSTATUS: "Playing Status",
  T_46_META_WS_P_PLAYSPEED: "Play Speed",
  T_46_META_WS_P_POINTPOSITION: "Point Position",
  T_46_META_WS_P_POINTS: "Points",
  T_46_META_WS_P_POSITION: "Position",
  T_46_META_WS_P_PREFABID: "Prefab ID",
  T_46_META_WS_P_PRESSEDCOLOR: "Pressed Color",
  T_46_META_WS_P_PRESSEDSPRITE: "Pressed Sprite",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "Pressed Sprite Type",
  T_46_META_WS_P_PRICE: "Price",
  T_46_META_WS_P_PRIORITY: "Priority",
  T_46_META_WS_P_PROFILEINFO: "Profile Info",
  T_46_META_WS_P_PROGRESS: "Progress [0,1]",
  T_46_META_WS_P_PROGRESSICON: "Progress Icon",
  T_46_META_WS_P_PROGRESSICONNAME: "Progress Icon Name",
  T_46_META_WS_P_PROPID: "Prop ID",
  T_46_META_WS_P_PURCHASELIMIT: "Purchase Limit",
  T_46_META_WS_P_RADIUS: "Radius",
  T_46_META_WS_P_RANGE: "Range",
  T_46_META_WS_P_RANK: "Rank",
  T_46_META_WS_P_RATIOSELFFACTOR: "Self-Damage Factor",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "Friendly Fire DMG Coeff.",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "Ratio Vehicle Factor",
  T_46_META_WS_P_REFRESHTIME: "Refresh Time (s)",
  T_46_META_WS_P_RELOADSPEED: "Reload Speed",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "Reload Speed Factor",
  T_46_META_WS_P_REMAINJUMPCOUNT: "Remain Jump Count",
  T_46_META_WS_P_REMAINQUANTITY: "Remain Quantity",
  T_46_META_WS_P_RENDERTYPE: "Render Type",
  T_46_META_WS_P_REPEATTIMES: "Times played",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "Replacement Priority",
  T_46_META_WS_P_REQUESTEDITEMLIST: "Requested Item List",
  T_46_META_WS_P_REQUESTTYPE: "Request Type",
  T_46_META_WS_P_RESETPERROUND: "Reset per Round",
  T_46_META_WS_P_RESETPOSITION: "Reset Position",
  T_46_META_WS_P_RESETTIME: "Reset Time",
  T_46_META_WS_P_RESOURCE: "Resource",
  T_46_META_WS_P_RESOURCEID: "Resource ID",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "Restrict Within Panel",
  T_46_META_WS_P_RESULT: "Result",
  T_46_META_WS_P_RESULTTYPE: "Result Type",
  T_46_META_WS_P_REVIVALPOINT: "Revival Point",
  T_46_META_WS_P_REVIVECD: "Revival CD",
  T_46_META_WS_P_RIGHT: "Right",
  T_46_META_WS_P_RIGHTARM: "Right Arm",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "Right Background Color",
  T_46_META_WS_P_RIGHTCOLOR: "RightColor",
  T_46_META_WS_P_RIGHTDESCRIPTION: "Right Description",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "Right Effect Active",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "Right Firing Arc Angle",
  T_46_META_WS_P_RIGHTFOOT: "Right Foot",
  T_46_META_WS_P_RIGHTHAND: "Right Hand",
  T_46_META_WS_P_RIGHTICON: "Right Icon",
  T_46_META_WS_P_RIGHTICONNAME: "Right Icon Name",
  T_46_META_WS_P_RIGHTLEG: "Right Leg",
  T_46_META_WS_P_RIGHTPLAYERS: "Right Players",
  T_46_META_WS_P_RIGHTSCORE: "Right Score",
  T_46_META_WS_P_RIGHTSCOREAFTER: "Right Final Score",
  T_46_META_WS_P_RIGHTSCORETEXT: "Right Score",
  T_46_META_WS_P_RIGHTTEAM: "Right Team",
  T_46_META_WS_P_RIGHTTEAMINDEX: "Right Team Index",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "Right Teammate Alive Num",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "Right Teammate Flag Count",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "Right Teammate States",
  T_46_META_WS_P_RIGHTTEAMNAME: "Right Team Name",
  T_46_META_WS_P_RIGHTTEAMSCORE: "Right Team Score",
  T_46_META_WS_P_RIGHTTEXT: "Right Text",
  T_46_META_WS_P_RIMALPHA: "Rim Alpha",
  T_46_META_WS_P_RIMCOLOR: "Border Color",
  T_46_META_WS_P_RIMTEXTURE: "Border Texture",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "Rolling Friction Coeff",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "Friction Multiplier (Collision)",
  T_46_META_WS_P_ROTATION: "Rotation",
  T_46_META_WS_P_ROTATIONANGLE: "Rotation Angle",
  T_46_META_WS_P_ROTATIONQ: "Rotation Quaternion",
  T_46_META_WS_P_ROUNDINCOME: "Round Income",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "Round Income Detail Nums",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "Round Income Detail Titles",
  T_46_META_WS_P_ROUNDINCOMETITLE: "Round Income Title",
  T_46_META_WS_P_ROUNDNUM: "Round Num",
  T_46_META_WS_P_ROUNDNUMKEY: "Round Num Key",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "Round Num LocKey Params",
  T_46_META_WS_P_RUNSPEED: "Run Speed",
  T_46_META_WS_P_RUNSPEEDSCALE: "Movement Speed Scale",
  T_46_META_WS_P_RUSHDISTANCE: "Sprint Distance",
  T_46_META_WS_P_RUSHENERGYCOST: "Rush Energy Cost",
  T_46_META_WS_P_RUSHVERTICALSPEED: "Rush Vertical Speed",
  T_46_META_WS_P_SCALE: "Scale",
  T_46_META_WS_P_SCATTERINCREASESPEED: "Scatter Increase Speed",
  T_46_META_WS_P_SCATTERMAX: "Max. Spread",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "Scatter Multiplier While Moving",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "Scatter Recover Speed",
  T_46_META_WS_P_SCATTERSPEED: "Scatter Speed",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "Spread Reduction While C",
  T_46_META_WS_P_SCATTERTHRESHOLD: "Scatter Threshold",
  T_46_META_WS_P_SCOPETYPE: "Scope Type",
  T_46_META_WS_P_SCORE: "Score",
  T_46_META_WS_P_SCORES1: "Scores1",
  T_46_META_WS_P_SCORES2: "Scores2",
  T_46_META_WS_P_SCORES3: "Scores3",
  T_46_META_WS_P_SCORES4: "Scores4",
  T_46_META_WS_P_SCORES5: "Scores5",
  T_46_META_WS_P_SCORETEXTKEY: "Score Text Key",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "Score Text Key Params",
  T_46_META_WS_P_SCROLLCONTINUITY: "Scroll Continuity",
  T_46_META_WS_P_SCROLLDIRECTION: "Scroll Direction",
  T_46_META_WS_P_SCROLLEFFECT: "Scroll Effect",
  T_46_META_WS_P_SCROLLWHEELSPEED: "Scroll Wheel Speed",
  T_46_META_WS_P_SECONDSCORETITLE: "Second Score Title",
  T_46_META_WS_P_SECONDSCOREVALUE: "Second Score Value",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "Second Score Value Params",
  T_46_META_WS_P_SELECTEDCOLOR: "Selected Color",
  T_46_META_WS_P_SELECTEDINDEX: "SelectedIndex",
  T_46_META_WS_P_SELECTEDSPRITE: "Selected Sprite",
  T_46_META_WS_P_SELECTEDTYPE: "Selected Type",
  T_46_META_WS_P_SELF: "Self",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "Self-Damage Factor",
  T_46_META_WS_P_SET: "Set",
  T_46_META_WS_P_SHADERNAME: "Shader Name",
  T_46_META_WS_P_SHADOWCOLOR: "Shadow Color",
  T_46_META_WS_P_SHADOWOFFSET: "Shadow Offset",
  T_46_META_WS_P_SHADOWSTRENGTH: "Shadow Strength",
  T_46_META_WS_P_SHELFS: "Shelfs",
  T_46_META_WS_P_SHOES: "Shoes",
  T_46_META_WS_P_SHOOTANGLEMAX: "Max. Shooting Angle",
  T_46_META_WS_P_SHOOTANGLEMIN: "Min. Shooting Angle",
  T_46_META_WS_P_SHOP: "Shop",
  T_46_META_WS_P_SHOPITEMS: "Shop Items",
  T_46_META_WS_P_SHOWADDFRIEND: "Show Add Friend",
  T_46_META_WS_P_SHOWATTACKGRENADE: "Show Attack Grenade",
  T_46_META_WS_P_SHOWBACKGROUND: "Show Background",
  T_46_META_WS_P_SHOWCROUCH: "Show Crouch",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "Show Damage Number",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "Show Defence Grenade",
  T_46_META_WS_P_SHOWECCONOMY: "Show Ecconomy",
  T_46_META_WS_P_SHOWECONOMY: "Show Ecconomy",
  T_46_META_WS_P_SHOWFIRE: "Show Fire",
  T_46_META_WS_P_SHOWFRAME: "Show Frame",
  T_46_META_WS_P_SHOWGIFT: "Show Gift",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "Show Hit Point Effect",
  T_46_META_WS_P_SHOWJUMP: "Show Jump",
  T_46_META_WS_P_SHOWLIKE: "Show Like",
  T_46_META_WS_P_SHOWLOBBY: "Show Lobby",
  T_46_META_WS_P_SHOWMAPEVALUATE: "Show Map Ratings",
  T_46_META_WS_P_SHOWMATCHDETAIL: "Show Match Details",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "Show Moving Joystick",
  T_46_META_WS_P_SHOWNAME: "Show Nickname",
  T_46_META_WS_P_SHOWPIN: "Show Pin",
  T_46_META_WS_P_SHOWPRONE: "Show Prone",
  T_46_META_WS_P_SHOWRANK: "Show Rank",
  T_46_META_WS_P_SHOWREPLAY: "Show Replay",
  T_46_META_WS_P_SHOWREPORT: "Show Report",
  T_46_META_WS_P_SHOWSHARE: "Show Share",
  T_46_META_WS_P_SHOWSPRINT: "Show Sprint",
  T_46_META_WS_P_SHOWTAG: "Show Tag",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "Show Teammates Info",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "Show Teammate State",
  T_46_META_WS_P_SHOWTEAMSCORE: "Show Team Score",
  T_46_META_WS_P_SHOWTIMETYPE: "Show TimeT ype",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "Show Two Team Score",
  T_46_META_WS_P_SHRINKDURATION: "Shrink Duration (ms)",
  T_46_META_WS_P_SHRINKENDTIME: "Shrink End Time (ms)",
  T_46_META_WS_P_SHRINKSPEED: "Shrink Speed",
  T_46_META_WS_P_SHRINKSTARTTIME: "Start Shrink Time (s)",
  T_46_META_WS_P_SIGHTAIMASSIST: "Allow ADS Aim Assist",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "Aim Assist Distance Attenuation Coefficient (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "Aim Assist Distance Priority Impact Coefficient (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "Aim Assist Distance Priority Max. Distance",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "Aim Assist Distance Priority Min. Distance",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "Allow Aim Assist Distance First",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "Aim Assist Crosshairs Screen Range Attraction Ratio (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "Scope Zoom-In Factor",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "FOV Magnification",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "ADS Rotation Sensitivity",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "ADS Min. Damage Distance Correction Coefficient X",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "ADS Magnification Time (s)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "ADS Magnification",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "ADS Recovery Time (s)",
  T_46_META_WS_P_SIZE: "Size",
  T_46_META_WS_P_SIZEDELTA: "Size Delta",
  T_46_META_WS_P_SKELETON: "Skeleton",
  T_46_META_WS_P_SKIN: "Skin",
  T_46_META_WS_P_SKINID: "Skin ID",
  T_46_META_WS_P_SKINWIDTH: "Skin Width",
  T_46_META_WS_P_SKYBOXENV: "Skybox",
  T_46_META_WS_P_SKYBOXRESOURCE: "Skybox Resource",
  T_46_META_WS_P_SLOPELIMIT: "Slope Limit",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "Smooth Scroll Start",
  T_46_META_WS_P_SOFTNESS: "Softness",
  T_46_META_WS_P_SORTTYPE: "Sort Order",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "Spawn Count per Wave",
  T_46_META_WS_P_SPAWNPOINT: "Spawn Point",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "Spawn Point Count",
  T_46_META_WS_P_SPAWNPOSITION: "Spawn Position",
  T_46_META_WS_P_SPEED: "Speed",
  T_46_META_WS_P_SPEEDWHILEAIMING: "ADS Sensitivity Multiplier",
  T_46_META_WS_P_SPRAYCOLOR: "Spray Color",
  T_46_META_WS_P_SPRINTENERGYCOST: "Sprint Energy Cost",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "Sprint Horizontal Speed",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "Sprint Speed Scale",
  T_46_META_WS_P_SPRITENAME: "Sprite Shape",
  T_46_META_WS_P_SPRITERESOURCE: "Sprite Resource",
  T_46_META_WS_P_SRCVAL: "Src Value",
  T_46_META_WS_P_STARTDROPTIME: "Start Drop Time (ms)",
  T_46_META_WS_P_STARTEVENT: "Start Event",
  T_46_META_WS_P_STARTPOSITION: "Start Position",
  T_46_META_WS_P_STARTRADIUS: "Start Radius",
  T_46_META_WS_P_STARTSPAWNTIME: "Start Spawn Time (s)",
  T_46_META_WS_P_STARTTIME: "Start Time (s)",
  T_46_META_WS_P_STARTVALUE: "Start Value",
  T_46_META_WS_P_STATICICONCOLORS: "Static Icon Colors",
  T_46_META_WS_P_STATICICONS: "Static Icons",
  T_46_META_WS_P_STATUS: "Mini Sentry Status",
  T_46_META_WS_P_STEPOFFSET: "Step Offset",
  T_46_META_WS_P_STOPDURATION: "Stop Duration",
  T_46_META_WS_P_STOPEVENT: "Stop Event",
  T_46_META_WS_P_STORE: "Store",
  T_46_META_WS_P_STROPID: "Strop ID",
  T_46_META_WS_P_STYLE: "Style",
  T_46_META_WS_P_SUBTITLE: "Subtitle",
  T_46_META_WS_P_SUMMULTIPLIER: "SumMultiplier",
  T_46_META_WS_P_SWINGEXITACCELERATION: "Swing Exit Acceleration",
  T_46_META_WS_P_SWINGINGSPEED: "Swing Speed",
  T_46_META_WS_P_TAGS: "Tags",
  T_46_META_WS_P_TARGETCHECKPOINTID: "Target Checkpoint ID",
  T_46_META_WS_P_TARGETICONCOLORS: "Target Icon Colors",
  T_46_META_WS_P_TARGETICONS: "Target Icons",
  T_46_META_WS_P_TARGETID: "TargetID",
  T_46_META_WS_P_TARGETITEMID: "TargetItemID",
  T_46_META_WS_P_TARGETROTATION: "TargetRotation",
  T_46_META_WS_P_TARGETSCALE: "TargetScale",
  T_46_META_WS_P_TEAMCOLOR: "Team Color",
  T_46_META_WS_P_TEAMCOLORS: "Team Colors",
  T_46_META_WS_P_TEAMINDEXS: "Team Indexs",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "Ally DMG Multiplier",
  T_46_META_WS_P_TEAMMEMBERNUM: "Team Member Count",
  T_46_META_WS_P_TEAMNUM: "Team Count",
  T_46_META_WS_P_TEAMRANK: "Team Rank",
  T_46_META_WS_P_TEAMRANKDISPLAY: "Team Rank Display",
  T_46_META_WS_P_TEAMRANKS: "Team Ranks",
  T_46_META_WS_P_TEAMSCORES: "Team Scores",
  T_46_META_WS_P_TEAMSEQ: "Team Sequence",
  T_46_META_WS_P_TEMPLATEENTITY: "Template Entity",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "Temporary Shield Points",
  T_46_META_WS_P_TERRAINWETNESS: "Terrain Wetness",
  T_46_META_WS_P_TEXT: "Text",
  T_46_META_WS_P_TEXTCOLOR: "Text Color",
  T_46_META_WS_P_TEXTKEY: "Text Key",
  T_46_META_WS_P_TEXTKEYPARAMS: "Text Key Params",
  T_46_META_WS_P_TEXTURERESOURCE: "Texture Resource",
  T_46_META_WS_P_THEMECOLOR: "Theme Color",
  T_46_META_WS_P_THROWABLETYPE: "Throwable Type",
  T_46_META_WS_P_THROWINGSPEED: "Throw Speed",
  T_46_META_WS_P_THROWSPEED: "Throw Speed",
  T_46_META_WS_P_TICKINTERVAL: "Tick Interval",
  T_46_META_WS_P_TIMEREQUIRED: "Time Required (ms)",
  T_46_META_WS_P_TIPSTYPE: "Tips Type",
  T_46_META_WS_P_TITLE: "Title",
  T_46_META_WS_P_TITLELIST: "Titles",
  T_46_META_WS_P_TITLES: "Titles",
  T_46_META_WS_P_TOP: "Top Wear",
  T_46_META_WS_P_TOPALPHA: "Top Alpha",
  T_46_META_WS_P_TOTALHP: "Total HP",
  T_46_META_WS_P_TOTALLEVEL: "Total Level",
  T_46_META_WS_P_TOTALROUNDCOUNT: "Total Round Count",
  T_46_META_WS_P_TOWSPEED: "Tow Speed",
  T_46_META_WS_P_TRANSITIONSTAGE: "Transition Stage",
  T_46_META_WS_P_TRANSITIONTYPE: "Transition Type",
  T_46_META_WS_P_TRIGGERPLAYERID: "TriggerPlayerID",
  T_46_META_WS_P_TRIGGERRADIUS: "Trigger Range",
  T_46_META_WS_P_TRIGGERRANGE: "Trigger Range",
  T_46_META_WS_P_TRIGGERTIME: "Trigger Time",
  T_46_META_WS_P_TURNSPEED: "Turning Speed",
  T_46_META_WS_P_TWEENERENABLED: "Tweener Enabled",
  T_46_META_WS_P_TWEENSTYLE: "Tween Style",
  T_46_META_WS_P_TYPE: "Type",
  T_46_META_WS_P_UNSELECTEDCOLOR: "Unselected Color",
  T_46_META_WS_P_UNSELECTEDSPRITE: "Unselected Sprite",
  T_46_META_WS_P_UNSELECTEDTYPE: "Unselected Type",
  T_46_META_WS_P_UP: "Up",
  T_46_META_WS_P_UPDATETYPE: "Update Type",
  T_46_META_WS_P_UPENERGYCOST: "UpEnergy Cost",
  T_46_META_WS_P_UPSPEED: "Up Speed",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "Use Custom Push Force",
  T_46_META_WS_P_USECUSTOMRESOURCE: "Use Custom Resource",
  T_46_META_WS_P_USEDCAPACITY: "Used Capacity",
  T_46_META_WS_P_USEGRAVITY: "Use Gravity",
  T_46_META_WS_P_USEPHYSICALCCT: "Use Physical CCT",
  T_46_META_WS_P_USERUID: "User UID",
  T_46_META_WS_P_UVOFFSET: "UV Offset",
  T_46_META_WS_P_UVSIZE: "UV Size",
  T_46_META_WS_P_VALUE: "Value",
  T_46_META_WS_P_VAULTDISTANCE: "Vault Distance",
  T_46_META_WS_P_VAULTHEIGHT: "Vault Height",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "Vehicle Damage Factor",
  T_46_META_WS_P_VEHICLESKINID: "Vehicle Skin ID",
  T_46_META_WS_P_VEHICLESKINIDS: "Vehicle Skin ID",
  T_46_META_WS_P_VELOCITY: "Velocity (m/s)",
  T_46_META_WS_P_VELOCITYXZ: "Velocity XZ",
  T_46_META_WS_P_VELOCITYY: "Velocity Y",
  T_46_META_WS_P_VERTICALBAR: "Vertical Bar",
  T_46_META_WS_P_VERTICALOFFSET: "Vertical Offset",
  T_46_META_WS_P_VEST: "Vest",
  T_46_META_WS_P_VFXTEXTURETYPE: "VFX Texture Type",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "Viewing Angle Restriction",
  T_46_META_WS_P_VISIBILITYLAYER: "Visibility Layer",
  T_46_META_WS_P_VISIBLE: "Visible",
  T_46_META_WS_P_VISIBLEONBACK: "Visible On Back",
  T_46_META_WS_P_VISIBLEPLAYERS: "VisiblePlayers",
  T_46_META_WS_P_VOLUME: "Volume",
  T_46_META_WS_P_WALLETID: "Wallet ID",
  T_46_META_WS_P_WANDERRANGE: "Wander Range",
  T_46_META_WS_P_WAVECOUNT: "Wave Count",
  T_46_META_WS_P_WAVEINTERVAL: "Wave Interval",
  T_46_META_WS_P_WEAPONDAMAGERATE: "Weapon Damage Rate",
  T_46_META_WS_P_WEAPONSKINIDS: "Weapon Skin IDs",
  T_46_META_WS_P_WEAPONSUBTYPE: "Weapon Subtype",
  T_46_META_WS_P_WEAPONTYPE: "Weapon Type",
  T_46_META_WS_P_WIDTH: "Width",
  T_46_META_WS_P_WINMVPS: "Win MVPs",
  T_46_META_WS_P_WINTEXT: "Win Text",
  T_46_META_WS_P_WORDWRAP: "Word Wrap",
  T_46_META_WS_P_WORLDPOSITION: "World Coordinates",
  T_46_META_WS_P_YAW: "Yaw",
  T_46_META_WS_PATROLALONG: "Patrol Along",
  T_46_META_WS_PATROLTO: "Patrol To",
  T_46_META_WS_PAUSE: "Pause",
  T_46_META_WS_PAUSEEMOTE: "Pause Emote",
  T_46_META_WS_PAUSEFIXEDUPDATE: "Pause Fixed Update",
  T_46_META_WS_PHASE: "Phase",
  T_46_META_WS_PLAY: "Play",
  T_46_META_WS_PLAYANIMATION: "Play Animation",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "Play Character Animation Clip",
  T_46_META_WS_PLAYEMOTE: "Play Emote",
  T_46_META_WS_PLAYER: "Player",
  T_46_META_WS_PORTAL: "Portal",
  T_46_META_WS_POSE: "Pose",
  T_46_META_WS_POSITION: "Position",
  T_46_META_WS_PREPOSE: "Pre Pose",
  T_46_META_WS_PROFANITYFILTER: "Profanity Filter",
  T_46_META_WS_PURSUITTARGET: "Pursuit Target",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "Quaternion To Axis Angle",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "Quaternion To Euler Angle",
  T_46_META_WS_QUITCHATCHANNEL: "Quit Chat Channel",
  T_46_META_WS_QUITFACTION: "Quit Faction",
  T_46_META_WS_QUITGAME: "Quit Game",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "Quit Jail Break Mini Game",
  T_46_META_WS_RANDOMFLOAT: "Random Float",
  T_46_META_WS_RANDOMINT: "Random Int",
  T_46_META_WS_RANK: "Rank",
  T_46_META_WS_READCSV: "Read CSV",
  T_46_META_WS_READCSVCELL: "Read CSV Cell",
  T_46_META_WS_READCSVCELLBYNAME: "Read CSV Cell By Name",
  T_46_META_WS_READCSVCELLFROMSERVER: "Read CSV Cell From Server",
  T_46_META_WS_READCSVCOLUMN: "Read CSV Column",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "Read CSV Column From Server",
  T_46_META_WS_READCSVFROMSERVER: "Read CSV From Server",
  T_46_META_WS_READCSVROW: "Read CSV Row",
  T_46_META_WS_READCSVROWBYKEY: "Read CSV Row By Key",
  T_46_META_WS_READCSVROWFROMSERVER: "Read CSV Row From Server",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "Read From Accumulated Data Store",
  T_46_META_WS_READFROMDATASTORE: "Read From Data Store",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "Read From Leadboard Data Store",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "Read From Leadboard Data Store By Rank",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "Remove AOI Special Follow",
  T_46_META_WS_REMOVEBACKPACKSKIN: "Remove Backpack Skin",
  T_46_META_WS_REMOVEBUFF: "Remove Buff",
  T_46_META_WS_REMOVECOMPONENT: "Remove Component",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "Remove Formula Property Factor",
  T_46_META_WS_REMOVEOUTFIT: "Remove Outfit",
  T_46_META_WS_REMOVESCRIPT: "Remove Script",
  T_46_META_WS_REMOVEVEHICLESKIN: "Remove Vehicle Skin",
  T_46_META_WS_REMOVEWEAPONSKIN: "Remove Weapon Skin",
  T_46_META_WS_REPLACE: "Replace",
  T_46_META_WS_REQUESTMATCHMAKING: "Request Match Making",
  T_46_META_WS_RESET: "Reset",
  T_46_META_WS_RESETBACKPACKSKIN: "Reset Backpack Skin",
  T_46_META_WS_RESETDYEING: "Reset Dyeing",
  T_46_META_WS_RESETJERSEY: "Reset Jersey",
  T_46_META_WS_RESETOUTFIT: "Reset Outfit",
  T_46_META_WS_RESETVEHICLESKIN: "Reset Vehicle Skin",
  T_46_META_WS_RESETWEAPONSKIN: "Reset Weapon Skin",
  T_46_META_WS_RESUMEFIXEDUPDATE: "Resume Fixed Update",
  T_46_META_WS_REVERSE: "Reverse",
  T_46_META_WS_REVIVALSOURCE: "Revival Source",
  T_46_META_WS_REVIVE: "Revive",
  T_46_META_WS_ROUND: "Round",
  T_46_META_WS_ROUNDINDEX: "Round Index",
  T_46_META_WS_SAMPLEONCURVE: "Sample On Curve",
  T_46_META_WS_SCENENAME: "Scene Name",
  T_46_META_WS_SCORE: "Score",
  T_46_META_WS_SCORER: "Scorer",
  T_46_META_WS_SCORETYPE: "Score Type",
  T_46_META_WS_SCREENMULTIRAYCAST: "Screen Multi-Raycast",
  T_46_META_WS_SCREENSINGLERAYCAST: "Screen Single Raycast",
  T_46_META_WS_SCREENTOUCHRAY: "Screen Touch Ray",
  T_46_META_WS_SCREENTOWORLDPOINT: "Screen To World",
  T_46_META_WS_SENDEVENT: "Send Event",
  T_46_META_WS_SETACTIVE: "Set Active",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "Set All Players Move Status",
  T_46_META_WS_SETATTACKABLEENTITY: "Set Attackable Entity",
  T_46_META_WS_SETATTACKABLEFACTION: "Set Attackable Faction",
  T_46_META_WS_SETATTACKABLETEAM: "Set Attackable Team",
  T_46_META_WS_SETBACKPACKSKIN: "Set Backpack Skin",
  T_46_META_WS_SETBEHAVIORSTATUS: "Set Behavior Status",
  T_46_META_WS_SETBLACKBOARDVALUE: "Set Blackboard Value",
  T_46_META_WS_SETBUNDLE: "Set Bundle",
  T_46_META_WS_SETCAMERAFOCUS: "Set Camera Focus",
  T_46_META_WS_SETCAMERAFOLLOW: "Set Camera Follow",
  T_46_META_WS_SETCHARACTER: "Set Character",
  T_46_META_WS_SETCULLINGMASK: "Set Culling Mask",
  T_46_META_WS_SETCULLINGMASKLAYER: "Set Culling Mask Layer",
  T_46_META_WS_SETDEFAULTUISTATUS: "Set Default UI Status",
  T_46_META_WS_SETDROPSTATUS: "Set Drop Status",
  T_46_META_WS_SETFALLINGDAMAGE: "Set Falling Damage",
  T_46_META_WS_SETFOOTBALLPOSITION: "Set Football Position",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "Set Formula Property Absolute",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "Set Formula Property Relative",
  T_46_META_WS_SETFORWARD: "Set Forward",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "Set Global Sleep Threshold",
  T_46_META_WS_SETINVINCIBILITY: "Set Invincibility",
  T_46_META_WS_SETJERSEY: "Set Jersey",
  T_46_META_WS_SETOUTFIT: "Set Outfit",
  T_46_META_WS_SETPARENT: "Set Parent",
  T_46_META_WS_SETPARENTCLIENT: "Set Parent",
  T_46_META_WS_SETPICKUPSTATUS: "Set Pickup Status",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "Set Player Quick Message Status",
  T_46_META_WS_SETPLAYERVOICESTATUS: "Set Player Voice Status",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "Set Property Smoothly",
  T_46_META_WS_SETSKILLS: "Set Skills",
  T_46_META_WS_SETSKYBOX: "Set Skybox",
  T_46_META_WS_SETSLEEPTHRESHOLD: "Set Sleep Threshold",
  T_46_META_WS_SETSPECIALITEMSTATUS: "Set Special Item Status",
  T_46_META_WS_SETVEHICLESKIN: "Set Vehicle Skin",
  T_46_META_WS_SETWEAPONSKIN: "Set Weapon Skin",
  T_46_META_WS_SETWIDGETPARENT: "Set Widget Parent",
  T_46_META_WS_SHOPITEM: "Shop Item",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "Show Appearance Group",
  T_46_META_WS_SHUFFLE: "Shuffle",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "Single Raycast",
  T_46_META_WS_SKILL: "Skill",
  T_46_META_WS_SLEEP: "Sleep",
  T_46_META_WS_SLERPQUATERNION: "Slerp Quaternion",
  T_46_META_WS_SPAWNABLES: "Spawnables",
  T_46_META_WS_SPAWNEDITEM: "Spawned Item",
  T_46_META_WS_SPAWNNEXTWAVE: "SpawnNextWave",
  T_46_META_WS_SPHERECAST: "Sphere Cast",
  T_46_META_WS_SPHEREOVERLAP: "Sphere Overlap",
  T_46_META_WS_SPLIT: "Split",
  T_46_META_WS_SQRT: "Sqrt",
  T_46_META_WS_STARTPARACHUTE: "Start Parachute",
  T_46_META_WS_STARTPOSITION: "Start Position",
  T_46_META_WS_STATENAME: "State Name",
  T_46_META_WS_STATUS: "Status",
  T_46_META_WS_STRINGTOFLOAT: "String To Float",
  T_46_META_WS_STRINGTOINT: "String To Int",
  T_46_META_WS_STRIP: "Strip",
  T_46_META_WS_SUB: "Sub",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "Switch AOI Proxy Observer",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "Switch Appearance Group",
  T_46_META_WS_SWITCHAREA: "Switch Area",
  T_46_META_WS_SWITCHCAMERA: "Switch Camera",
  T_46_META_WS_SWITCHPHASE: "Switch Phase",
  T_46_META_WS_SWITCHSCENE: "Switch Scene",
  T_46_META_WS_SWITCHWEAPON: "Switch Weapon",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "Target",
  T_46_META_WS_TEAM: "Team",
  T_46_META_WS_TELEPORT: "Teleport",
  T_46_META_WS_TELEPORTCCT: "Teleport CCT",
  T_46_META_WS_TEXT: "Text",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "Timestamp To Localization String",
  T_46_META_WS_TIRE: "Tire",
  T_46_META_WS_TOLOWER: "To Lower",
  T_46_META_WS_TOSTRING: "To String",
  T_46_META_WS_TOUPPER: "To Upper",
  T_46_META_WS_TRANSFERMONEY: "Transfer Money",
  T_46_META_WS_TRIGGER: "Trigger",
  T_46_META_WS_TYPEIS: "Type Is",
  T_46_META_WS_UNLOADSCENE: "Unload Scene",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "Update Jail Break Mission",
  T_46_META_WS_UPLOADGAMERESULT: "Upload Game Result",
  T_46_META_WS_VALUE: "Damage",
  T_46_META_WS_VECTOR2ANGLE: "Vector2Angle",
  T_46_META_WS_VECTOR2DISTANCE: "Vector2Distance",
  T_46_META_WS_VECTOR2DOT: "Vector2Dot",
  T_46_META_WS_VECTOR2MAGNITUDE: "Vector2Magnitude",
  T_46_META_WS_VECTOR2NORMALIZE: "Vector2Normalize",
  T_46_META_WS_VECTOR2REFLECT: "Vector2Reflect",
  T_46_META_WS_VECTOR2TOVECTOR3: "Vector2 To Vector3",
  T_46_META_WS_VECTOR3REFLECT: "Vector3Reflect",
  T_46_META_WS_VECTOR3TOVECTOR2: "Vector3 To Vector2",
  T_46_META_WS_VEHICLE: "Vehicle",
  T_46_META_WS_VELOCITY: "Velocity",
  T_46_META_WS_WAITFORMILESECOND: "Wait for Millisecond",
  T_46_META_WS_WAITFORNEXTFRAME: "Wait For Next Frame",
  T_46_META_WS_WAKEUP: "Wake Up",
  T_46_META_WS_WAVES: "Waves",
  T_46_META_WS_WEAPON: "Weapon",
  T_46_META_WS_WORLDTOSCREENPOINT: "World To Screen",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "Write To Accumulated Data Store",
  T_46_META_WS_WRITETODATASTORE: "Write To Data Store",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "Write To Leadboard Data Store",
  T_48_META_API_1_D: "Get all the players in the current game, and return a list of players.",
  T_48_META_API_1_R_D: "Player List",
  T_48_META_API_10_D: "Get Scene Objects",
  T_48_META_API_10_P0_D: "What types of Scene objects to filter for",
  T_48_META_API_10_R_D: "Scene Object List",
  T_48_META_API_100_D: "Load Scenes without automatically unloading already loaded Scenes",
  T_48_META_API_100_P0_D: "ID of the Scene to be loaded",
  T_48_META_API_10000_D: "Return the entity bound to the current script",
  T_48_META_API_10000_R_D: "The entity to which the current script is bound",
  T_48_META_API_10001_D: "Use the entity ID to find the corresponding entity, this API is for editor use only. Compatibility is not guaranteed when this API is used from the user side, e.g. Removing or adjusting",
  T_48_META_API_10001_P0_D: "Target entity ID",
  T_48_META_API_10001_R_D: "Entity",
  T_48_META_API_10002_D: "Get the Global entity of that game",
  T_48_META_API_10002_R_D: "Global entity",
  T_48_META_API_10003_D: "Teleport player to specific coordinates (deprecated, use Teleport)",
  T_48_META_API_10003_P0_D: "Teleported players",
  T_48_META_API_10003_P1_D: "Coordinates of the transported point",
  T_48_META_API_10004_D: "Gets the position near teammates, will circumvent the position of players who can't stand (deprecated, please use GetTeammateNearPosition)",
  T_48_META_API_10004_P0_D: "target player",
  T_48_META_API_10004_R_D: "Coordinates near teammates",
  T_48_META_API_10005_D: "Get the player to which the entity belongs",
  T_48_META_API_10005_P0_D: "Target entity, the entity will only synchronize with the player it belongs to",
  T_48_META_API_10005_R_D: "The player to which the target entity belongs",
  T_48_META_API_10006_D: "Make the player invincible",
  T_48_META_API_10006_P0_D: "Target Player",
  T_48_META_API_10006_P1_D: "Duration of invincibility effect, in seconds",
  T_48_META_API_10007_D: "Clone the selected entity and all its properties in the original position",
  T_48_META_API_10007_P0_D: "Created entity",
  T_48_META_API_10007_P1_D: "Entity to be cloned",
  T_48_META_API_10008_D: "Deals damage to the player, if no source of damage is selected, the target takes damage from the system",
  T_48_META_API_10008_P0_D: "Damaged gaming entity",
  T_48_META_API_10008_P1_D: "Game entity that deal damage",
  T_48_META_API_10008_P2_D: "Type of damage",
  T_48_META_API_10008_P3_D: "Amount of damage",
  T_48_META_API_10009_D: "Resurrecting a Designated Player",
  T_48_META_API_10009_P0_D: "Resurrected players",
  T_48_META_API_1001_D: "If the condition is satisfied, the node under IF is run. If the condition is not satisfied, run the node under ELSE if there is an ELSE, otherwise end the IF statement.",
  T_48_META_API_1001_P0_D: "The condition list needs to be consistent with the number of sub-procedure lists (logical branch lists).",
  T_48_META_API_10010_D: "Creates an item or list of items at a specified location.",
  T_48_META_API_10010_P0_D: "Item creation location",
  T_48_META_API_10010_P1_D: "Created items or item lists",
  T_48_META_API_10010_P2_D: "The number of items to be created. When creating an item list, you need to fill in a list of the number of items corresponding to the order of the item list.",
  T_48_META_API_10011_D: "AI entities patrolling to target points",
  T_48_META_API_10011_P0_D: "Targeted AI entities",
  T_48_META_API_10011_P1_D: "Moving target point",
  T_48_META_API_10011_P2_D: "Whether to return to the point of departure",
  T_48_META_API_10011_P3_D: "Whether hostile targets are detected and attacked during patrols",
  T_48_META_API_10012_D: "AI entities patrol in order of the list of coordinates",
  T_48_META_API_10012_P0_D: "Targeted AI entities",
  T_48_META_API_10012_P1_D: "List of Moving Coordinate Points",
  T_48_META_API_10012_P2_D: "Patrol type, with the option of single, round-trip loop or cycle",
  T_48_META_API_10012_P3_D: "Whether hostile targets are detected and attacked during patrols",
  T_48_META_API_10013_D: "The generator immediately spawns the next wave of unit entities",
  T_48_META_API_10013_P0_D: "generator entity",
  T_48_META_API_10014_D: "Increase the computable property calculation factor, the computable property will be calculated by the formula composed of the factor to calculate the final result",
  T_48_META_API_10014_P0_D: "target entity",
  T_48_META_API_10014_P1_D: "Computable property type",
  T_48_META_API_10014_P2_D: "Calculation factor type",
  T_48_META_API_10014_P3_D: "Calculating factor value",
  T_48_META_API_10015_D: "Clearing the computation factor for a computable property",
  T_48_META_API_10015_P0_D: "target entity",
  T_48_META_API_10015_P1_D: "Computable property type",
  T_48_META_API_10016_D: "Clear all computational factors for all computable properties of the target entity",
  T_48_META_API_10016_P0_D: "target entity",
  T_48_META_API_10017_D: "Modify properties",
  T_48_META_API_10017_P0_D: "target entity",
  T_48_META_API_10017_P1_D: "property type",
  T_48_META_API_10017_P2_D: "Modification method",
  T_48_META_API_10017_P3_D: "Value",
  T_48_META_API_10018_D: "Setting the value of a computable property",
  T_48_META_API_10018_P0_D: "target entity",
  T_48_META_API_10018_P1_D: "property type",
  T_48_META_API_10018_P2_D: "Value",
  T_48_META_API_10019_D: "Clearing individual computable property modifications",
  T_48_META_API_10019_P0_D: "target entity",
  T_48_META_API_10019_P1_D: "property type",
  T_48_META_API_1002_D: "The parameter i starts from the minimum value, and every time the node below is run then i increases the step value until i is greater than or equal to the maximum value.",
  T_48_META_API_1002_P0_D: "The name of the cyclic index, which can be used to get the value of the cyclic index on a local variable.",
  T_48_META_API_1002_P1_D: "Cyclic initial value",
  T_48_META_API_1002_P2_D: "Cyclic end value",
  T_48_META_API_1002_P3_D: "Loop step size, when the start value is less than the end value, the step size should be greater than 0; when the start value is greater than the end value, the step size should be less than 0",
  T_48_META_API_10020_D: "Get all the entities in the game that meet the filter criteria",
  T_48_META_API_10020_P0_D: "The filter result must contain the type entered within this parameter",
  T_48_META_API_10020_P1_D: "The filter result must not contain the type entered within this parameter",
  T_48_META_API_10020_P2_D: "The filter results contain at least one of the types entered within this parameter",
  T_48_META_API_10020_R_D: "Filter Resulting Entity List",
  T_48_META_API_10021_D: "Add a velocity to a soccer ball. The velocity changes from the effect of acceleration in the same direction",
  T_48_META_API_10021_P0_D: "Target Soccer",
  T_48_META_API_10021_P1_D: "Added 3D space speed",
  T_48_META_API_10022_D: "Destroy designated entities",
  T_48_META_API_10022_P0_D: "Target entities to be destroyed",
  T_48_META_API_10023_D: "Add labels to entities",
  T_48_META_API_10023_P0_D: "target entity",
  T_48_META_API_10023_P1_D: "Custom labels",
  T_48_META_API_10024_D: "Remove labels for entities",
  T_48_META_API_10024_P0_D: "target entity",
  T_48_META_API_10024_P1_D: "Custom labels",
  T_48_META_API_10025_D: "Determine whether the target entity contains the specified label",
  T_48_META_API_10025_P0_D: "target entity",
  T_48_META_API_10025_P1_D: "Custom labels",
  T_48_META_API_10025_R_D: "Whether to include the specified label",
  T_48_META_API_10026_D: "Setting the soccer ball position",
  T_48_META_API_10026_P0_D: "soccer entity",
  T_48_META_API_10026_P1_D: "Placement",
  T_48_META_API_10026_P2_D: "Maintaining speed",
  T_48_META_API_10027_D: "Get the camera entity currently used by the target player",
  T_48_META_API_10027_P0_D: "Target Player",
  T_48_META_API_10027_R_D: "The currently used camera entity",
  T_48_META_API_10028_D: "Switching the target player's camera to the target camera",
  T_48_META_API_10028_P0_D: "target player",
  T_48_META_API_10028_P1_D: "target camera",
  T_48_META_API_10028_P2_D: "Switching method, you can choose to keep the original logic or progressive",
  T_48_META_API_10028_P3_D: "Switching time is the time to switch cameras in progressive mode",
  T_48_META_API_10029_D: "Create a camera",
  T_48_META_API_10029_P0_D: "Type of camera created",
  T_48_META_API_10029_P1_D: "Created Camera Entity",
  T_48_META_API_1003_D: "Implement a traversal of a data container to get to each sub-element, containing sub-procedures, the loop body is the sub-procedure",
  T_48_META_API_1003_P0_D: "Iterate over the name of the child element, which can be used to get to the value of the child element on the local variable",
  T_48_META_API_1003_P1_D: "The name of the cyclic index, which can be used to get the value of the cyclic index on a local variable.",
  T_48_META_API_1003_P2_D: "The data container to be traversed, currently supports the following types: array type",
  T_48_META_API_10030_D: "Kill combatable entities",
  T_48_META_API_10030_P0_D: "Target entity, must be combatable",
  T_48_META_API_10031_D: "Set the active state of the target entity and its children nodes; availability, visibility, collisions, etc. are turned off for inactive objects",
  T_48_META_API_10031_P0_D: "target entity",
  T_48_META_API_10031_P1_D: "Active or inactive",
  T_48_META_API_10032_D: "Set the position of the camera entity to always follow the target entity",
  T_48_META_API_10032_P0_D: "target camera entity",
  T_48_META_API_10032_P1_D: "Target entity to follow",
  T_48_META_API_10032_P2_D: "Offset from target entity coordinates",
  T_48_META_API_10032_P3_D: "Coordinate system for offsets",
  T_48_META_API_10033_D: "Set the camera entity to always face the target entity",
  T_48_META_API_10033_P0_D: "target camera entity",
  T_48_META_API_10033_P1_D: "target entity",
  T_48_META_API_10033_P2_D: "Offset of the gaze point from the target coordinates",
  T_48_META_API_10033_P3_D: "Coordinate system for offsets",
  T_48_META_API_10034_D: "Create Tween",
  T_48_META_API_10034_P0_D: "target entity",
  T_48_META_API_10034_P1_D: "Property ID",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "DestVal",
  T_48_META_API_10034_P4_D: "Style",
  T_48_META_API_10034_P5_D: "Curve",
  T_48_META_API_10034_P6_D: "Duration",
  T_48_META_API_10034_P7_D: "tween entities",
  T_48_META_API_10035_D: "Setting the parent node requires that both parent and child have the Transform component",
  T_48_META_API_10035_P0_D: "parent node",
  T_48_META_API_10035_P1_D: "child node",
  T_48_META_API_10035_P2_D: "Whether to keep the current world position, rotation and scaling of child nodes, this item is invalid when setting the UI.",
  T_48_META_API_10036_D: "NewCurve (deprecated, use CreateTweenCurve)",
  T_48_META_API_10036_P0_D: "ControlPoints",
  T_48_META_API_10036_R_D: "TwennCurveEntity",
  T_48_META_API_10037_D: "Attempts to play the target entity, which must have a playable component",
  T_48_META_API_10037_P0_D: "target playable entity",
  T_48_META_API_10037_P1_D: `Whether to replay 
true: replay 
false: continue playing`,
  T_48_META_API_10038_D: "Pause playable entities",
  T_48_META_API_10038_P0_D: "target playable entity",
  T_48_META_API_10039_D: "Creating a Trajectory motion will give the target entity an initial velocity and acceleration with direction",
  T_48_META_API_10039_P0_D: "target entity",
  T_48_META_API_10039_P1_D: "initial velocity",
  T_48_META_API_10039_P2_D: "acceleration of motion",
  T_48_META_API_10039_P3_D: "Maximum displacement distance",
  T_48_META_API_10039_P4_D: "Trajectory motion entities created",
  T_48_META_API_10039_P5_D: "Whether the playback starts automatically after creation",
  T_48_META_API_1004_D: "Interrupt the current loop and exit the loop",
  T_48_META_API_10040_D: "Creates a following motion where the target entity follows the specified object.",
  T_48_META_API_10040_P0_D: "target entity",
  T_48_META_API_10040_P1_D: "Object entities that follow the movement",
  T_48_META_API_10040_P2_D: "Offset from the following target coordinates",
  T_48_META_API_10040_P3_D: "Coordinate system used",
  T_48_META_API_10040_P4_D: "Created following motion entity",
  T_48_META_API_10040_P5_D: "Whether the playback starts automatically after creation",
  T_48_META_API_10041_D: "Creates a gaze following motion, where the target entity stays oriented towards the specified object",
  T_48_META_API_10041_P0_D: "target entity",
  T_48_META_API_10041_P1_D: "Gazing target entity",
  T_48_META_API_10041_P2_D: "Offset of the gaze point from the object entity",
  T_48_META_API_10041_P3_D: "Coordinate system used",
  T_48_META_API_10041_P4_D: "Created gaze following motion entity",
  T_48_META_API_10041_P5_D: "Whether the playback starts automatically after creation",
  T_48_META_API_10042_D: "abandoned",
  T_48_META_API_10042_P0_D: "player entity",
  T_48_META_API_10042_P1_D: "results of a competition",
  T_48_META_API_10042_P2_D: "abandoned",
  T_48_META_API_10042_P3_D: "abandoned",
  T_48_META_API_10042_P4_D: "abandoned",
  T_48_META_API_10043_D: "Smoothly sets the properties of the target entity, the properties change immediately, but the client plays a smooth transition performance",
  T_48_META_API_10043_P0_D: "target entity",
  T_48_META_API_10043_P1_D: "A property of the target entity",
  T_48_META_API_10043_P2_D: "The target value, which needs to match the type required when the property was defined",
  T_48_META_API_10044_D: "Perform a ray detection and return the first entity hit in the ray direction. The hit entity needs to have a collision component. If the level parameter is filled in, the terrain can be detected.",
  T_48_META_API_10044_P0_D: "Start position coordinate",
  T_48_META_API_10044_P1_D: "Direction of ray detection",
  T_48_META_API_10044_P2_D: "Ray detection distance, only positive values are accepted",
  T_48_META_API_10044_P3_D: "Ray detection layer mask, only filled layers will participate in the scan, leaving it blank means all layers participate in the scan",
  T_48_META_API_10044_P4_D: "Whether triggers can be detected",
  T_48_META_API_10044_P5_D: "hit entity",
  T_48_META_API_10044_P6_D: "hit point coordinates",
  T_48_META_API_10044_P7_D: "Distance of hit point from start point",
  T_48_META_API_10044_P8_D: "Hit surface normal vector",
  T_48_META_API_10045_D: "Perform a ray detection and return all entities hit in the ray direction from near to far. If the level parameter is filled in, the terrain can be detected.",
  T_48_META_API_10045_P0_D: "Starting position coordinates",
  T_48_META_API_10045_P1_D: "Ray detection direction",
  T_48_META_API_10045_P2_D: "Ray detection distance, only positive values are accepted",
  T_48_META_API_10045_P3_D: "Layer mask, only the filled layers will participate in the scan, leaving it blank means all layers will participate in the scan",
  T_48_META_API_10045_P4_D: "Whether the trigger can be detected",
  T_48_META_API_10045_P5_D: "List of entities hit",
  T_48_META_API_10045_P6_D: "List of hit points",
  T_48_META_API_10045_P7_D: "List of distances from the hit point to the start point",
  T_48_META_API_10045_P8_D: "Hit surface normal vector",
  T_48_META_API_10046_D: "Using prefab as template to create entity",
  T_48_META_API_10046_P0_D: "Created Entity",
  T_48_META_API_10046_P1_D: "Prefab ID",
  T_48_META_API_10047_D: "Dye",
  T_48_META_API_10047_P0_D: "Setting object normal vector",
  T_48_META_API_10047_P1_D: "Set the dye point",
  T_48_META_API_10047_P2_D: "Color",
  T_48_META_API_10048_D: "Dyeing status",
  T_48_META_API_10048_P0_D: "Set the dye point",
  T_48_META_API_10048_P1_D: "Setting Direction",
  T_48_META_API_10048_P2_D: "Setting distance",
  T_48_META_API_10048_R_D: "ColorDesc",
  T_48_META_API_10049_D: "Dyeing statistics",
  T_48_META_API_10049_P0_D: "Color",
  T_48_META_API_10049_R_D: "Number of dyeings",
  T_48_META_API_1005_D: "Skip the remaining loop body, enter the next loop directly",
  T_48_META_API_10050_D: "Plane range dyeing",
  T_48_META_API_10050_P0_D: "Setting object normal vector",
  T_48_META_API_10050_P1_D: "Set the dyeing point",
  T_48_META_API_10050_P2_D: "Set the dyeing range",
  T_48_META_API_10050_P3_D: "Color",
  T_48_META_API_10050_P4_D: "Number of dyeings",
  T_48_META_API_10051_D: "Area dyeing",
  T_48_META_API_10051_P0_D: "Setting object normal vector",
  T_48_META_API_10051_P1_D: "Set the dyeing point",
  T_48_META_API_10051_P2_D: "Set the dyeing range",
  T_48_META_API_10051_P3_D: "Color",
  T_48_META_API_10051_P4_D: "Fix dyeing area",
  T_48_META_API_10051_P5_D: "Random coefficient",
  T_48_META_API_10051_P6_D: "Random decay coefficient",
  T_48_META_API_10051_P7_D: "Number of dyeings",
  T_48_META_API_10052_D: "Get all child nodes of the target parent node entity",
  T_48_META_API_10052_P0_D: "Parent Node Entity",
  T_48_META_API_10052_R_D: "Child node list",
  T_48_META_API_10053_D: "Get the specified child node of the target parent node entity according to the index",
  T_48_META_API_10053_P0_D: "Parent Node Entity",
  T_48_META_API_10053_P1_D: "Child node index",
  T_48_META_API_10053_R_D: "Child node entity",
  T_48_META_API_10054_D: "Get the parent node of the target child node entity",
  T_48_META_API_10054_P0_D: "Child node entity",
  T_48_META_API_10054_R_D: "Parent Node Entity",
  T_48_META_API_10055_D: "Delete all child nodes under the specified parent node entity. The node must have a Transform component.",
  T_48_META_API_10055_P0_D: "Parent Node Entity",
  T_48_META_API_10056_D: "Teleport the target to a specified location",
  T_48_META_API_10056_P0_D: "The unit being teleported",
  T_48_META_API_10056_P1_D: "Teleport point coordinates",
  T_48_META_API_10056_P2_D: "The unit's facing direction after teleporting",
  T_48_META_API_10057_D: "Get the position of a random teammate. If there are no teammates, return the coordinates near yourself. Avoid the position of players who are unable to stand.",
  T_48_META_API_10057_P0_D: "Target Player",
  T_48_META_API_10057_R_D: "Coordinate near the target player's teammate",
  T_48_META_API_10058_D: "Clear dyeing status",
  T_48_META_API_10059_D: "Play the specified sound effect. If there are more properties that need to be set, further set its entity properties through the entity.",
  T_48_META_API_10059_P0_D: "In the code, it is used to indicate the name of the parameter for creating a sound effect entity. The corresponding local variable value is the entity that creates the sound effect.",
  T_48_META_API_10059_P1_D: "The player entity it belongs to, only visible to that player",
  T_48_META_API_10059_P2_D: "Sound effect type, the type of sound effect that players can choose",
  T_48_META_API_1006_D: "End the current execution process and return directly to the calling location. Can return with data",
  T_48_META_API_1006_P0_D: "The data you want to return to the calling location",
  T_48_META_API_10060_D: "Kick the target player out of the game",
  T_48_META_API_10060_P0_D: "Target Player",
  T_48_META_API_10060_P1_D: "Whether to display settlement information",
  T_48_META_API_10061_D: "The target player requests to match the specified map",
  T_48_META_API_10061_P0_D: "Target Player",
  T_48_META_API_10061_P1_D: "Battlefield Code",
  T_48_META_API_10061_P2_D: "Whether a pop-up window appears to prompt you to return to the original game when canceling a match.",
  T_48_META_API_10062_D: "Interrupt the playing sound entity",
  T_48_META_API_10062_P0_D: "The sound entity that needs to be paused",
  T_48_META_API_10063_D: "Continue playing the sound effect, you can choose whether to play from the beginning",
  T_48_META_API_10063_P0_D: "The sound effect entity that needs to continue playing after being paused",
  T_48_META_API_10063_P1_D: "Start from scratch",
  T_48_META_API_10064_D: "Create an airdrop. There are three stages of airdrop: 1. Preparation, 2. Dropping, 3. Landing. The airdrop properties can only be modified in state 1.",
  T_48_META_API_10064_P0_D: "Created airdrop box entity",
  T_48_META_API_1007_D: "Implement a loop that continues to execute based on whether a condition is true, until the condition is false and the loop ends",
  T_48_META_API_1007_P0_D: "If the condition is true, the loop continues; if the condition is false, the loop ends",
  T_48_META_API_1008_D: `Wait until the next logical frame starts
On the server, if you turn on the low frame rate mode, you will wait longer
On the client, the waiting time is affected by the device performance and the complexity of the current frame logic
The function using `,
  T_48_META_API_1009_D: "To wait for a certain period of time, the function using this API needs to be declared as async.",
  T_48_META_API_1009_P0_D: "Waiting time, in milliseconds",
  T_48_META_API_101_D: "Unload the specified scene",
  T_48_META_API_101_P0_D: "The scene ID to unload",
  T_48_META_API_1010: "Event Callback",
  T_48_META_API_1010_D: "Action triggered when an event occurs",
  T_48_META_API_1010_P0: "Event Parameter Names",
  T_48_META_API_1010_P0_D: "The name of the formal parameter of the event parameter, through which the actual parameter value can be obtained on the local variable",
  T_48_META_API_1011: "Code Block",
  T_48_META_API_1011_D: "A code block that carries a combination of a series of APIs",
  T_48_META_API_1011_P0: "Parameter Names",
  T_48_META_API_1011_P0_D: "Parameter names when the code block is a custom function",
  T_48_META_API_1012: "Find and Invoke Custom API with Serial",
  T_48_META_API_1012_D: "Call the custom function in serial mode. If there is a wait in the custom function, the calling position will also wait.",
  T_48_META_API_1012_P0_D: "The entity where the custom function is located",
  T_48_META_API_1012_P1: "Graph ID",
  T_48_META_API_1012_P1_D: "The script ID where the custom function is located",
  T_48_META_API_1012_P2: "Function ID",
  T_48_META_API_1012_P2_D: "ID of the function that the target calls",
  T_48_META_API_1012_P3_D: "List of arguments passed to the custom function",
  T_48_META_API_1013: "Find and Invoke Custom API with Parallel",
  T_48_META_API_1013_D: "Call the custom function in parallel mode. Regardless of whether there is a wait in the custom function, it will immediately return to the calling position and continue to execute.",
  T_48_META_API_1013_P0_D: "The entity where the custom function is located",
  T_48_META_API_1013_P1: "Graph ID",
  T_48_META_API_1013_P1_D: "The script ID where the custom function is located",
  T_48_META_API_1013_P2: "Function ID",
  T_48_META_API_1013_P2_D: "ID of the function that the target calls",
  T_48_META_API_1013_P3_D: "List of arguments passed to the custom function",
  T_48_META_API_1014: "Find and Invoke Self Custom API with Serial",
  T_48_META_API_1014_D: "Call the custom function in the current script in serial mode. If there is a wait in the custom function, the calling position will also wait.",
  T_48_META_API_1014_P0: "Function ID",
  T_48_META_API_1014_P0_D: "ID of the function that the target calls",
  T_48_META_API_1014_P1_D: "List of arguments passed to the custom function",
  T_48_META_API_1015: "Find and Invoke Self Custom API with Parallel",
  T_48_META_API_1015_D: "Call the custom function in parallel. Regardless of whether there is a wait in the custom function, it will immediately return to the calling position and continue to execute.",
  T_48_META_API_1015_P0: "Set Local Variable by Index",
  T_48_META_API_1015_P0_D: "ID of the function that the target calls",
  T_48_META_API_1015_P1_D: "List of arguments passed to the custom function",
  T_48_META_API_1016_D: "Get the target type when calling this API",
  T_48_META_API_1016_P0_D: "The target of the query",
  T_48_META_API_1016_R_D: "Variable Type",
  T_48_META_API_1017_D: "Determine whether the target variable is of the specified type",
  T_48_META_API_1017_P0_D: "The target of the query",
  T_48_META_API_1017_P1_D: "Types being compared",
  T_48_META_API_1017_R_D: "Is it consistent?",
  T_48_META_API_1018_D: "Determines whether the target variable is a subtype of a certain type. The return value is a Boolean value.",
  T_48_META_API_1018_P0_D: "The target variable being queried",
  T_48_META_API_1018_P1_D: "Types being compared",
  T_48_META_API_1018_R_D: "Is it a subclass?",
  T_48_META_API_1019_D: "Make the target entity to trigger a specified custom event",
  T_48_META_API_1019_P0_D: "The custom event ID sent",
  T_48_META_API_1019_P1_D: "Target Entity",
  T_48_META_API_1019_P2_D: "Parameter List",
  T_48_META_API_102_D: "Switching to the specified scene will unload other loaded scenes",
  T_48_META_API_102_P0_D: "The scene ID to switch to",
  T_48_META_API_1020_D: "Implement traversal of a container, obtain each key-value pair, contain sub-processes, and the loop body is the sub-process",
  T_48_META_API_1020_P0_D: "Traverse to the name of the key, and use it to get the key value on the local variable",
  T_48_META_API_1020_P1_D: "Traverse to the name of the value, and use it to get the value of the local variable",
  T_48_META_API_1020_P2_D: "The container to traverse",
  T_48_META_API_1021_D: "Destroy the specified Bot",
  T_48_META_API_1021_P0_D: "The bot player that need to be destroyed",
  T_48_META_API_1022_D: "Force the targeted player to leave the vehicle",
  T_48_META_API_1022_P0_D: "Target Player",
  T_48_META_API_1023_D: "Create damage tick",
  T_48_META_API_1023_P0_D: "Tick content",
  T_48_META_API_1023_P1_D: "Font size",
  T_48_META_API_1023_P2_D: "Font Color",
  T_48_META_API_1023_P3_D: "Dwell time, in milliseconds",
  T_48_META_API_1023_P4_D: "Entity that takes damage",
  T_48_META_API_1023_P5_D: "The offset of the damage tick relative to the target entity's world coordinates",
  T_48_META_API_1023_P6_D: "The range of random position correction at the damage tick position",
  T_48_META_API_1023_P7_D: "Whether to perform interpolation animation",
  T_48_META_API_1024_D: "Deprecated",
  T_48_META_API_1024_P0_D: "Deprecated",
  T_48_META_API_1024_P1_D: "Target Entity",
  T_48_META_API_1024_P2_D: "After selection, if it is called on the server, it will be sent to the client, and if it is called on the client, it will be sent to the server.",
  T_48_META_API_1024_P3_D: "Parameter List",
  T_48_META_API_1025_D: "Query the progress of custom tasks",
  T_48_META_API_1025_P0_D: "Target Player",
  T_48_META_API_1025_P1_D: "Custom task ID",
  T_48_META_API_1025_R_D: "Task Progress",
  T_48_META_API_1026_D: "Get the target player's backpack skin",
  T_48_META_API_1026_P0_D: "Target Player",
  T_48_META_API_1026_R_D: "Backpack Skin ID",
  T_48_META_API_1027_D: "Set the target player's backpack skin",
  T_48_META_API_1027_P0_D: "Target Player",
  T_48_META_API_1027_P1_D: "Backpack Skin ID",
  T_48_META_API_1028_D: "Restore the target player's backpack skin to the default out-of-game configuration",
  T_48_META_API_1028_P0_D: "Target Player",
  T_48_META_API_1029_D: "Clear the target player's backpack skin",
  T_48_META_API_1029_P0_D: "Target Player",
  T_48_META_API_103_D: "Change the game's skybox environment style, you can choose day, dusk, night, etc.",
  T_48_META_API_103_P0_D: "Skybox Type",
  T_48_META_API_1030_D: "Get the bone attachment point by name",
  T_48_META_API_1030_P0_D: "Target Entity",
  T_48_META_API_1030_P1_D: "Bone attachment point name",
  T_48_META_API_1030_R_D: "Bone attachment point",
  T_48_META_API_1031_D: "Set the parent node of the object entity, supporting entities with Transform, SkeletonPart, Player, and MountPoint components mounted on them",
  T_48_META_API_1031_P0_D: "Parent Node",
  T_48_META_API_1031_P1_D: "Child Node",
  T_48_META_API_1031_P2_D: "Whether to keep the current world position, rotation and scale of the child node. This option is invalid in UI settings.",
  T_48_META_API_1032_D: "Play icon animation effect, the icon moves from the starting position to the end position at the play speed",
  T_48_META_API_1032_P0_D: "Icon resource ID",
  T_48_META_API_1032_P1_D: "Color",
  T_48_META_API_1032_P2_D: "Icon Scaling",
  T_48_META_API_1032_P3_D: "Starting position center",
  T_48_META_API_1032_P4_D: "Starting area range",
  T_48_META_API_1032_P5_D: "End Location Center",
  T_48_META_API_1032_P6_D: "End position range",
  T_48_META_API_1032_P7_D: "Playback speed, which is the distance per second that the icon moves",
  T_48_META_API_1033_D: "Perform an inverse tangent operation to obtain the angle",
  T_48_META_API_1033_P0_D: "Y-axis coordinate",
  T_48_META_API_1033_P1_D: "X-axis coordinate",
  T_48_META_API_1033_R_D: "Angle, range (-180, 180]",
  T_48_META_API_1034_D: "Add components to entities. Only custom components created by users are supported",
  T_48_META_API_1034_P0_D: "Target Entity",
  T_48_META_API_1034_P1_D: "Component type ID. Only custom components created by users are supported",
  T_48_META_API_1034_P2_D: "Whether the addition is successful. Existing components or non-custom components will fail to be added.",
  T_48_META_API_1035_D: "Remove component from an entity. Only custom components are supported",
  T_48_META_API_1035_P0_D: "Target Entity",
  T_48_META_API_1035_P1_D: "Component type ID. Only custom components created by users are supported",
  T_48_META_API_1035_P2_D: "Whether the removal is successful. Non-existent components or non-custom components will fail to be removed.",
  T_48_META_API_1036_D: "Customize the interface of player quitting mid-game",
  T_48_META_API_1036_P0_D: "Title",
  T_48_META_API_1036_P1_D: "Content",
  T_48_META_API_1036_P2_D: "Options",
  T_48_META_API_1036_P3_D: "Whether to display the background",
  T_48_META_API_1037_D: "Get all currently loaded scenes",
  T_48_META_API_1037_R_D: "Scene List",
  T_48_META_API_1038_D: "Get the player's local aiming direction",
  T_48_META_API_1038_R_D: "Aiming direction",
  T_48_META_API_1039_D: "Get local timestamp",
  T_48_META_API_1039_R_D: "Timestamp",
  T_48_META_API_104_D: "Switch the player to the specified location of the specified scene. Unloaded scenes will be automatically loaded, and loaded scenes will not be automatically unloaded.",
  T_48_META_API_104_P0_D: "Player",
  T_48_META_API_104_P1_D: "The scene ID to load",
  T_48_META_API_104_P2_D: "The player's position in the new scene",
  T_48_META_API_104_P3_D: "The player's orientation in the new scene",
  T_48_META_API_1040_D: "Pause the fixed frame update of the current platform. After pausing, the fixed frame update event of the platform will no longer be triggered",
  T_48_META_API_1041_D: "Restore the fixed frame update of the current platform. After restoration, the fixed frame update event of the platform will be triggered again.",
  T_48_META_API_1042_D: "Determine the friend relationship between the target player and the current client player. The current client itself is not a friend of the current client.",
  T_48_META_API_1042_P0_D: "Target Player",
  T_48_META_API_1042_R_D: "Whether the current client is a friend",
  T_48_META_API_1043_D: "Trigger custom events",
  T_48_META_API_1043_P0_D: "Custom event ID",
  T_48_META_API_1043_P1_D: "Target Entity",
  T_48_META_API_1043_P2_D: "The operating platform is server or client",
  T_48_META_API_1043_P3_D: "Parameter List",
  T_48_META_API_1044_D: "Start parachuting",
  T_48_META_API_1044_P0_D: "Target Player",
  T_48_META_API_1044_P1_D: "If the altitude is lower than this, the parachute will be forcefully opened.",
  T_48_META_API_1044_P2_D: "The speed when gliding, the X component represents the horizontal speed, and the Y component represents the vertical speed; when the Y component is negative, the player falls downward",
  T_48_META_API_1044_P3_D: "The speed when diving. The X component represents the horizontal speed and the Y component represents the vertical speed. If the Y component is negative, the player falls downward.",
  T_48_META_API_1044_P4_D: "The speed when the parachute is opened. The X component represents the horizontal speed, and the Y component represents the vertical speed. When the Y component is negative, the player falls downward.",
  T_48_META_API_1045_D: "Read the value corresponding to the specified identifier in the data table",
  T_48_META_API_1045_P0_D: "Table name in the database",
  T_48_META_API_1045_P1_D: "Player unique ID",
  T_48_META_API_1045_P2_D: "Specified Identifier",
  T_48_META_API_1045_P3_D: "Read results",
  T_48_META_API_1045_P4_D: "The battlefield code corresponding to the database, which can be filled in blanks, represents the battlefield code of the current map",
  T_48_META_API_1045_P5_D: "Error Code",
  T_48_META_API_1046_D: "Read the value corresponding to the specified identifier in the ranking data table",
  T_48_META_API_1046_P0_D: "The name of the ranking table in the database",
  T_48_META_API_1046_P1_D: "Specified Identifier",
  T_48_META_API_1046_P2_D: "Read result",
  T_48_META_API_1046_P3_D: "The battlefield code corresponding to the database, which can be filled in blanks, represents the battlefield code of the current map",
  T_48_META_API_1046_P4_D: "Error Code",
  T_48_META_API_1047_D: "Read the value of the specified ranking interval in the ranking data table",
  T_48_META_API_1047_P0_D: "The name of the ranking table in the database",
  T_48_META_API_1047_P1_D: "The starting rank must be less than or equal to the ending rank, and the rank starts from 1",
  T_48_META_API_1047_P2_D: "Ending ranking",
  T_48_META_API_1047_P3_D: "Read result",
  T_48_META_API_1047_P4_D: "The battlefield code corresponding to the database, which can be filled in blanks, represents the battlefield code of the current map",
  T_48_META_API_1047_P5_D: "Error Code",
  T_48_META_API_1048_D: "Read the value corresponding to the specified identifier in the cumulative data table",
  T_48_META_API_1048_P0_D: "The name of the cumulative data table in the database",
  T_48_META_API_1048_P1_D: "Specified Identifier",
  T_48_META_API_1048_P2_D: "Read result",
  T_48_META_API_1048_P3_D: "The battlefield code corresponding to the database, which can be filled in blanks, represents the battlefield code of the current map",
  T_48_META_API_1048_P4_D: "Error Code",
  T_48_META_API_1049_D: "Write the value corresponding to the specified identifier in the data table",
  T_48_META_API_1049_P0_D: "Table name in the database",
  T_48_META_API_1049_P1_D: "Player unique ID",
  T_48_META_API_1049_P2_D: "Specified Identifier",
  T_48_META_API_1049_P3_D: "The value written",
  T_48_META_API_1049_P4_D: "The battlefield code corresponding to the database, which can be filled in blanks, represents the battlefield code of the current map",
  T_48_META_API_1049_P5_D: "Error Code",
  T_48_META_API_105_D: "Get the scene's skybox",
  T_48_META_API_105_P0_D: "Scene ID",
  T_48_META_API_105_R_D: "Skybox",
  T_48_META_API_1050_D: "Get the number of elements in the list",
  T_48_META_API_1050_P0_D: "Target List",
  T_48_META_API_1050_R_D: "Number of elements",
  T_48_META_API_1051_D: "Get the value of the element at the specified index in the list",
  T_48_META_API_1051_P0_D: "Target List",
  T_48_META_API_1051_P1_D: "Index value, starting from 0",
  T_48_META_API_1051_R_D: "Element Value",
  T_48_META_API_1052_D: "Set the value of the element corresponding to the specified index in the list",
  T_48_META_API_1052_P0_D: "Target List",
  T_48_META_API_1052_P1_D: "Index value, starting from 0",
  T_48_META_API_1052_P2_D: "Element Value",
  T_48_META_API_1053_D: "Append elements to the end of the list",
  T_48_META_API_1053_P0_D: "Target List",
  T_48_META_API_1053_P1_D: "Elements to add",
  T_48_META_API_1054_D: "Remove the element corresponding to the specified index from the list",
  T_48_META_API_1054_P0_D: "Target List",
  T_48_META_API_1054_P1_D: "Index value, starting from 0",
  T_48_META_API_1055_D: "Clear all elements from a list",
  T_48_META_API_1055_P0_D: "Target List",
  T_48_META_API_1056_D: "Reverse the specified list. The order of elements in the list will be reversed.",
  T_48_META_API_1056_P0_D: "Target List",
  T_48_META_API_1057_D: "Copy a list",
  T_48_META_API_1057_P0_D: "Target List",
  T_48_META_API_1057_R_D: "The new list copied",
  T_48_META_API_1058_D: "Insert a new element at the specified index position in the list. The original elements at and after that index position will move one position backwards one by one",
  T_48_META_API_1058_P0_D: "Target List",
  T_48_META_API_1058_P1_D: "The index position to be inserted, the index starts from 0",
  T_48_META_API_1058_P2_D: "The new element value to insert",
  T_48_META_API_1059_D: "Re-arrange the elements in a list",
  T_48_META_API_1059_P0_D: "Target List",
  T_48_META_API_1060_D: "Compare the two parameters and return true or false",
  T_48_META_API_1060_P0_D: "Lvalue to compare",
  T_48_META_API_1060_P1_D: "Comparison method, supports the following methods: >, >=, ==, !=, <=, <, And (limited to bool type), Or (limited to bool type)",
  T_48_META_API_1060_P2_D: "Lvalue to compare",
  T_48_META_API_1060_R_D: "Comparison results",
  T_48_META_API_1061_D: "The four basic arithmetic operations including addition, subtraction, multiplication, division and remainder. The remainder operation only supports integers, while the remaining operations support integers or decimals.",
  T_48_META_API_1061_P0_D: "Lvalue of the operation",
  T_48_META_API_1061_P1_D: "The types of arithmetic operations including addition, subtraction, multiplication, division, and remainder. The remainder operation does not support decimals.",
  T_48_META_API_1061_P2_D: "Rvalue of the operation",
  T_48_META_API_1061_R_D: "Calculation results",
  T_48_META_API_1062_D: "Generate a random integer between the minimum integer (included) and the maximum integer (not included)",
  T_48_META_API_1062_P0_D: "The left interval of the random range. May randomly get the filled value",
  T_48_META_API_1062_P1_D: "The right interval of the random range. Will not randomly get the filled value",
  T_48_META_API_1062_R_D: "Random result, integer",
  T_48_META_API_1063_D: "Generate a random integer between the minimum integer (included) and the maximum integer (not included)",
  T_48_META_API_1063_P0_D: "The left interval of the random range. May randomly get the filled value",
  T_48_META_API_1063_P1_D: "The right interval of the random range. Will not randomly get the filled value",
  T_48_META_API_1063_R_D: "Random result, decimal, accurate to 7 decimal places",
  T_48_META_API_1064_D: "Determine whether the object is empty",
  T_48_META_API_1064_P0_D: "The object to determine whether it is empty",
  T_48_META_API_1064_R_D: "Is it empty?",
  T_48_META_API_1065_D: "Logical inversion, input value: true or false, return value: false or true",
  T_48_META_API_1065_P0_D: "The value to execute NOT calculation",
  T_48_META_API_1065_R_D: "The result of NOT calculation",
  T_48_META_API_1066_D: "Get the absolute value, support integers and decimals",
  T_48_META_API_1066_P0_D: "The value whose absolute value is required",
  T_48_META_API_1066_R_D: "The result of taking the absolute value",
  T_48_META_API_1067_D: "Calculate square root",
  T_48_META_API_1067_P0_D: "The value for which the square root is required",
  T_48_META_API_1067_R_D: "The result of square root",
  T_48_META_API_1068_D: "Calculate negative values",
  T_48_META_API_1068_P0_D: "The value that needs to calculate negative value",
  T_48_META_API_1068_R_D: "The result of calculating negative value",
  T_48_META_API_1069_D: "Concatenate two strings together",
  T_48_META_API_1069_P0_D: "String lvalue",
  T_48_META_API_1069_P1_D: "String rvalue",
  T_48_META_API_1069_R_D: "String concatenation result",
  T_48_META_API_1070_D: "Get the length of a string",
  T_48_META_API_1070_P0_D: "String",
  T_48_META_API_1070_R_D: "String length",
  T_48_META_API_1071_D: "Round the specified value down to the nearest integer.",
  T_48_META_API_1071_P0_D: "The value to be rounded down",
  T_48_META_API_1071_R_D: "The result of rounding down",
  T_48_META_API_1072_D: "Rounds the specified value up to the nearest integer.",
  T_48_META_API_1072_P0_D: "The value to be rounded up",
  T_48_META_API_1072_R_D: "The result of rounding up",
  T_48_META_API_1073_D: "Round the specified value to the nearest integer.",
  T_48_META_API_1073_P0_D: "The value to be rounded",
  T_48_META_API_1073_R_D: "Rounding result",
  T_48_META_API_1074_D: "After replacing all the specified strings in the target string, output the new string",
  T_48_META_API_1074_P0_D: "Target string",
  T_48_META_API_1074_P1_D: "The old string to replace",
  T_48_META_API_1074_P2_D: "The new string to replace with",
  T_48_META_API_1074_R_D: "The string done replacing",
  T_48_META_API_1075_D: "Re-search for the first occurrence of a specified string in the target string.",
  T_48_META_API_1075_P0_D: "Target string",
  T_48_META_API_1075_P1_D: "The specified string to search for",
  T_48_META_API_1075_P2_D: "Search for a string from the start position, the string position starts at 0",
  T_48_META_API_1075_R_D: "The first occurrence of the specified string in the target string. The string position starts at 0.",
  T_48_META_API_1076_D: "After intercepting a string of a specified length from a specified position, output a new string",
  T_48_META_API_1076_P0_D: "Target string",
  T_48_META_API_1076_P1_D: "The position where the interception starts. The string position is calculated from 0",
  T_48_META_API_1076_P2_D: "The interception length, by default, is intercepted to the end of the string",
  T_48_META_API_1076_R_D: "The intercepted string",
  T_48_META_API_1077_D: "Compares whether the elements of two lists are exactly the same. The list capacity does not affect the comparison result.",
  T_48_META_API_1077_P0_D: "List lvalue to compare",
  T_48_META_API_1077_P1_D: "List rvalue to compare",
  T_48_META_API_1077_R_D: "Comparison result, return True if the contents are the same, and return False if the contents are different",
  T_48_META_API_1078_D: "Use the specified string as the delimiter to cut the target string into several slices and output the new string. N consecutive delimiters will be cut into N-1 half-width spaces as string list elements.",
  T_48_META_API_1078_P0_D: "Target string",
  T_48_META_API_1078_P1_D: "Delimiter string",
  T_48_META_API_1078_R_D: "The output string list, always ends with a half-width space element",
  T_48_META_API_1079_D: "Extract characters according to the string position list and combine them into a new string output",
  T_48_META_API_1079_P0_D: "Target string",
  T_48_META_API_1079_P1_D: "String position list, string position starts from 0",
  T_48_META_API_1079_R_D: "Output string",
  T_48_META_API_1080_D: "Convert all characters in the target string to uppercase",
  T_48_META_API_1080_P0_D: "Target string",
  T_48_META_API_1080_R_D: "Output string",
  T_48_META_API_1081_D: "Convert all characters in the target string to lowercase",
  T_48_META_API_1081_P0_D: "Target string",
  T_48_META_API_1081_R_D: "Output string",
  T_48_META_API_1082_D: "Remove all spaces before the first non-space character and after the last non-space character in the target string",
  T_48_META_API_1082_P0_D: "Target string",
  T_48_META_API_1082_R_D: "Output string",
  T_48_META_API_1083_D: "Output a new string after concatenating with the specified identifier",
  T_48_META_API_1083_P0_D: "Target string list",
  T_48_META_API_1083_P1_D: "The specified identifier used to concatenate strings",
  T_48_META_API_1083_R_D: "Output string",
  T_48_META_API_1084_D: "Write the value corresponding to the specified identifier in the ranking data table",
  T_48_META_API_1084_P0_D: "The name of the ranking table in the database",
  T_48_META_API_1084_P1_D: "Specified Identifier",
  T_48_META_API_1084_P2_D: "The value written",
  T_48_META_API_1084_P3_D: "The battlefield code corresponding to the database, which can be filled in blanks, represents the battlefield code of the current map",
  T_48_META_API_1084_P4_D: "Error Code",
  T_48_META_API_1085_D: "Write the offset value corresponding to the specified identifier in the cumulative data table",
  T_48_META_API_1085_P0_D: "The name of the cumulative data table in the database",
  T_48_META_API_1085_P1_D: "Specified Identifier",
  T_48_META_API_1085_P2_D: "Types of arithmetic operations",
  T_48_META_API_1085_P3_D: "The offset value written",
  T_48_META_API_1085_P4_D: "The battlefield code corresponding to the database, which can be filled in blanks, represents the battlefield code of the current map",
  T_48_META_API_1085_P5_D: "Error Code",
  T_48_META_API_1086_D: "Delete the value corresponding to the specified identifier in the data table",
  T_48_META_API_1086_P0_D: "Table name in the database",
  T_48_META_API_1086_P1_D: "Player unique ID",
  T_48_META_API_1086_P2_D: "Specified Identifier",
  T_48_META_API_1086_P3_D: "The battlefield code corresponding to the database, which can be filled in blanks, represents the battlefield code of the current map",
  T_48_META_API_1086_P4_D: "Error Code",
  T_48_META_API_1087_D: "Delete the value corresponding to the specified identifier in the ranking data table",
  T_48_META_API_1087_P0_D: "The name of the ranking table in the database",
  T_48_META_API_1087_P1_D: "Specified Identifier",
  T_48_META_API_1087_P2_D: "The battlefield code corresponding to the database, which can be filled in blanks, represents the battlefield code of the current map",
  T_48_META_API_1087_P3_D: "Error Code",
  T_48_META_API_1088_D: "Delete the value corresponding to the specified rank in the ranking data table",
  T_48_META_API_1088_P0_D: "The name of the ranking table in the database",
  T_48_META_API_1088_P1_D: "Specified ranking",
  T_48_META_API_1088_P2_D: "The battlefield code corresponding to the database, which can be filled in blanks, represents the battlefield code of the current map",
  T_48_META_API_1088_P3_D: "Error Code",
  T_48_META_API_1089_D: "Send user message to Persona",
  T_48_META_API_1089_P0_D: "Target PersonaID",
  T_48_META_API_1089_P1_D: "Message content",
  T_48_META_API_1090_D: "Send system message to Persona",
  T_48_META_API_1090_P0_D: "Target PersonaID",
  T_48_META_API_1090_P1_D: "Message content",
  T_48_META_API_1091_D: "Clear Persona Memory",
  T_48_META_API_1091_P0_D: "Error Code",
  T_48_META_API_1092_D: "Invoke Member Center",
  T_48_META_API_1092_P0_D: "Error Code",
  T_48_META_API_1093_D: "Get the membership expiration timestamp",
  T_48_META_API_1093_P0_D: "Target Player",
  T_48_META_API_1093_P1_D: "Timestamp",
  T_48_META_API_1093_P2_D: "Error Code",
  T_48_META_API_1094_D: "Determine whether the player is a member",
  T_48_META_API_1094_P0_D: "Error Code",
  T_48_META_API_1094_P1_D: "Is a member or not",
  T_48_META_API_1095_D: "Get the membership expiration timestamp",
  T_48_META_API_1095_P0_D: "Timestamp",
  T_48_META_API_1095_P1_D: "Error Code",
  T_48_META_API_1096_D: "Determine whether the player is a member",
  T_48_META_API_1096_P0_D: "Target Player",
  T_48_META_API_1096_P1_D: "Error Code",
  T_48_META_API_1096_P2_D: "Is a member or not",
  T_48_META_API_1097_D: "Invoke Member Center",
  T_48_META_API_1097_P0_D: "Target Player",
  T_48_META_API_1097_P1_D: "Error Code",
  T_48_META_API_1099_D: "Set up a Persona observer, and the subsequent conversations with the Persona will also be sent to the observer",
  T_48_META_API_1099_P0_D: "Target PersonaID",
  T_48_META_API_1099_P1_D: "Watcher List",
  T_48_META_API_11_D: "End the current stage and enter the next stage",
  T_48_META_API_1100_D: "Send user message to Persona using streaming",
  T_48_META_API_1100_P0_D: "Target PersonaID",
  T_48_META_API_1100_P1_D: "Message content",
  T_48_META_API_1101_D: "Send user message to Persona using streaming",
  T_48_META_API_1101_P0_D: "Target PersonaID",
  T_48_META_API_1101_P1_D: "Message content",
  T_48_META_API_1101_P2_D: "Whether to reply or not",
  T_48_META_API_1103_D: "Create random seed",
  T_48_META_API_1103_P0_D: "Seed",
  T_48_META_API_1103_R_D: "Random Number Generator",
  T_48_META_API_1104_D: "Get the next random number from the specified random number generator, with a maximum value of 32767",
  T_48_META_API_1104_P0_D: "Random Number Generator",
  T_48_META_API_1104_P1_D: "Minimum range",
  T_48_META_API_1104_P2_D: "Maximum range",
  T_48_META_API_1104_R_D: "Random Number",
  T_48_META_API_1108_D: "Get the client language used by the player ",
  T_48_META_API_12_D: "Print logs to the console",
  T_48_META_API_12_P0_D: "Content to be printed",
  T_48_META_API_13_D: "Output a string with parameters",
  T_48_META_API_13_P0_D: "Use the %v placeholder to represent a parameter. The number of %v and the number of parameters must be consistent.",
  T_48_META_API_13_P1_D: "The parameter list involved in the output, needs to be consistent with the number of %v in the format description",
  T_48_META_API_13_R_D: "Output string",
  T_48_META_API_14_D: "Clean up the map object residues, including death boxes, created objects, placed objects, thrown objects residues, etc.",
  T_48_META_API_15_D: "Customize game tracking logs for user experience data analysis",
  T_48_META_API_15_P0_D: "List of field names to report",
  T_48_META_API_15_P1_D: "List of field values to report",
  T_48_META_API_1500_D: "Get the X component of a 3D vector",
  T_48_META_API_1500_P0_D: "Vector3",
  T_48_META_API_1500_R_D: "The X component of a three-dimensional vector",
  T_48_META_API_1501_D: "Get the Y component of a 3D vector",
  T_48_META_API_1501_P0_D: "3D Vector",
  T_48_META_API_1501_R_D: "Y component of a 3D vector",
  T_48_META_API_1502_D: "Get the Z component of a 3D vector",
  T_48_META_API_1502_P0_D: "3D Vector",
  T_48_META_API_1502_R_D: "Z component of a 3D vector",
  T_48_META_API_1503_D: "Set the X component of a 3D vector",
  T_48_META_API_1503_P0_D: "3D Vector",
  T_48_META_API_1503_P1_D: "X Component",
  T_48_META_API_1504_D: "Set the Y component of a 3D vector",
  T_48_META_API_1504_P0_D: "3D Vector",
  T_48_META_API_1504_P1_D: "Y Component",
  T_48_META_API_1505_D: "Set the Z component of a 3D vector",
  T_48_META_API_1505_P0_D: "3D Vector",
  T_48_META_API_1505_P1_D: "Z Component",
  T_48_META_API_1506_D: "Add two 3D vectors",
  T_48_META_API_1506_P0_D: "Lvalue",
  T_48_META_API_1506_P1_D: "Rvalue",
  T_48_META_API_1506_R_D: "Result of adding three-dimensional vectors",
  T_48_META_API_1507_D: "Subtract two 3D vectors",
  T_48_META_API_1507_P0_D: "Lvalue",
  T_48_META_API_1507_P1_D: "Rvalue",
  T_48_META_API_1507_R_D: "The result of subtracting the right value from the left value of a three-dimensional vector",
  T_48_META_API_1508_D: "Scale a 3D vector",
  T_48_META_API_1508_P0_D: "The 3D vector to be scaled",
  T_48_META_API_1508_P1_D: "3D vector scaling",
  T_48_META_API_1508_R_D: "3D vector scaling results",
  T_48_META_API_1509_D: "The dot product of two three-dimensional vectors. The result is a scalar",
  T_48_META_API_1509_P0_D: "Lvalue",
  T_48_META_API_1509_P1_D: "Rvalue",
  T_48_META_API_1509_R_D: "Dot product result",
  T_48_META_API_1510_D: "The result of the cross product of two three-dimensional vectors. The result is a vector perpendicular to the plane where the two vectors are located.",
  T_48_META_API_1510_P0_D: "Lvalue",
  T_48_META_API_1510_P1_D: "Rvalue",
  T_48_META_API_1510_R_D: "The result of the cross product, which is perpendicular to the plane where the two vectors involved in the operation are located.",
  T_48_META_API_1511_D: "Normalize a 3D vector",
  T_48_META_API_1511_P0_D: "3D Vector",
  T_48_META_API_1511_R_D: "Return a new normalized vector. The modulus is 1",
  T_48_META_API_1512_D: "Modulo a 3D vector",
  T_48_META_API_1512_P0_D: "3D Vector",
  T_48_META_API_1512_R_D: "The modulus result, which is the length of the vector modulus",
  T_48_META_API_1513_D: "Calculate the Euclidean distance between two 3D vectors",
  T_48_META_API_1513_P0_D: "Lvalue",
  T_48_META_API_1513_P1_D: "Rvalue",
  T_48_META_API_1513_R_D: "After subtracting two vectors, the modulus of the resulting vector",
  T_48_META_API_1514_D: "Calculate the angle between two 3D vectors",
  T_48_META_API_1514_P0_D: "Lvalue",
  T_48_META_API_1514_P1_D: "Rvalue",
  T_48_META_API_1514_R_D: "Vector angle, angle range 0-180",
  T_48_META_API_1515_D: "Create a 3D vector",
  T_48_META_API_1515_P0_D: "X component of a 3D vector",
  T_48_META_API_1515_P1_D: "Y component of a 3D vector",
  T_48_META_API_1515_P2_D: "Z component of a 3D vector",
  T_48_META_API_1515_R_D: "The three-dimensional vector created",
  T_48_META_API_1516_D: "Get a newly constructed direction point (deprecated, do not use)",
  T_48_META_API_1516_P0_D: "Location",
  T_48_META_API_1516_P1_D: "Orientation",
  T_48_META_API_1516_R_D: "DirectPoint",
  T_48_META_API_1517_D: "Get the direction point position (deprecated, do not use)",
  T_48_META_API_1517_P0_D: "Direction Point",
  T_48_META_API_1517_R_D: "Position",
  T_48_META_API_1518_D: "Get the direction point direction (deprecated, do not use)",
  T_48_META_API_1518_P0_D: "Direction Point",
  T_48_META_API_1518_R_D: "Forward",
  T_48_META_API_1519_D: "Create a list",
  T_48_META_API_1519_P0_D: "The initial length of the list, must be less than or equal to the initial capacity",
  T_48_META_API_1519_P1_D: "The initial capacity of the list, must be greater than or equal to the initial length. The capacity can be expanded dynamically, but doing so will consume some performance. It is recommended to set an appropriate value upon construction",
  T_48_META_API_1519_R_D: "Created list",
  T_48_META_API_1520_D: "Check whether a list contains a specified element",
  T_48_META_API_1520_P0_D: "Target List",
  T_48_META_API_1520_P1_D: "The specified element to check",
  T_48_META_API_1520_R_D: "Whether it contains the specified element",
  T_48_META_API_1521_D: "Append multiple elements to the end of the target list",
  T_48_META_API_1521_P0_D: "Target List",
  T_48_META_API_1521_P1_D: "Append List",
  T_48_META_API_1522_D: "Remove the specified element from the list",
  T_48_META_API_1522_P0_D: "Target List",
  T_48_META_API_1522_P1_D: "The value of the element to be removed",
  T_48_META_API_1523_D: "Get the index of the first occurrence of an element in the list. If there is no target element in the list, return -1",
  T_48_META_API_1523_P0_D: "Target List",
  T_48_META_API_1523_P1_D: "Element Value",
  T_48_META_API_1523_R_D: "Position Index",
  T_48_META_API_1524_D: "Get the index of the last occurrence of an element in the list. If there is no target element in the list, return -1",
  T_48_META_API_1524_P0_D: "Target List",
  T_48_META_API_1524_P1_D: "Element Value",
  T_48_META_API_1524_R_D: "Position Index",
  T_48_META_API_1525_D: "Find the sine of an angle",
  T_48_META_API_1525_P0_D: "Angle, 360 represents 360 degrees",
  T_48_META_API_1525_R_D: "Sine",
  T_48_META_API_1526_D: "Find the cosine of an angle",
  T_48_META_API_1526_P0_D: "Angle, 360 represents 360 degrees",
  T_48_META_API_1526_R_D: "Cosine",
  T_48_META_API_1527_D: "Find the tangent of an angle",
  T_48_META_API_1527_P0_D: "Angle, 360 represents 360 degrees",
  T_48_META_API_1527_R_D: "Tangent",
  T_48_META_API_1528_D: "Construct a color value with a fixed transparency of decimal 255. First, convert the channel to a binary number, with each 8 bits representing a channel. Concatenate the numbers according to R, G, B, and transparency, and then convert the binary number to",
  T_48_META_API_1528_P0_D: "The red channel value of the color, the value range is [0,255], if it exceeds the range, it will be clamped to a legal value",
  T_48_META_API_1528_P1_D: "The green channel value of the color, the value range is [0,255]. If it exceeds the range, it will be clamped to a legal value.",
  T_48_META_API_1528_P2_D: "The blue channel value of the color, the value range is [0,255]. If it exceeds the range, it will be clamped to a legal value.",
  T_48_META_API_1528_R_D: "Constructed color value",
  T_48_META_API_1529_D: "Perform the inverse sine operation to obtain the angle",
  T_48_META_API_1529_P0_D: "The value to be inversely sine calculated, the value range is [-1,1]",
  T_48_META_API_1529_R_D: "Angle",
  T_48_META_API_1530_D: "Perform inverse cosine operation to obtain the angle",
  T_48_META_API_1530_P0_D: "The value to be calculated for the inverse cosine operation, the value range is [-1,1]",
  T_48_META_API_1530_R_D: "Angle",
  T_48_META_API_1531_D: "Perform an inverse tangent operation to obtain the angle",
  T_48_META_API_1531_P0_D: "The value to be inverse tangented",
  T_48_META_API_1531_R_D: "Angle",
  T_48_META_API_1532_D: "Determines whether the target entity is within the specified sphere. If the entity has no position attribute, it will return false.",
  T_48_META_API_1532_P0_D: "Target Entity",
  T_48_META_API_1532_P1_D: "Specify the center of a sphere",
  T_48_META_API_1532_P2_D: "Specify the radius of a sphere",
  T_48_META_API_1532_R_D: "Determination result",
  T_48_META_API_1533_D: "Determine whether the target entity is within the specified cylindrical range. If the entity has no position attribute, it will return false.",
  T_48_META_API_1533_P0_D: "Target Entity",
  T_48_META_API_1533_P1_D: "Specify the center point of the cylinder",
  T_48_META_API_1533_P2_D: "Specify the cross-sectional radius of the cylinder",
  T_48_META_API_1533_P3_D: "Specify the height of the cylinder",
  T_48_META_API_1533_P4_D: "Specify the three-dimensional rotation Euler angle of the cylinder around the center point",
  T_48_META_API_1533_R_D: "Determination result",
  T_48_META_API_1534_D: "Determine whether the target entity is within the specified cube range",
  T_48_META_API_1534_P0_D: "Target Entity",
  T_48_META_API_1534_P1_D: "Specify the center point of the cube",
  T_48_META_API_1534_P2_D: "Specify the length of the cube",
  T_48_META_API_1534_P3_D: "Specify the width of the cube",
  T_48_META_API_1534_P4_D: "Specify the height of the cube",
  T_48_META_API_1534_P5_D: "Specify the Euler angles for the three-dimensional rotation of a cube around its center point",
  T_48_META_API_1534_R_D: "Determination result",
  T_48_META_API_1535_D: "Determine whether the target entity is within the specified fan-shaped cylinder range",
  T_48_META_API_1535_P0_D: "Target Entity",
  T_48_META_API_1535_P1_D: "Specify the center of the mid-section of the sector",
  T_48_META_API_1535_P2_D: "Specify the radius of the mid-section of the sector",
  T_48_META_API_1535_P3_D: "The radius of the section of the sector column that is not to be determined. Using center point as the center, the small sector column area will not be determined, and only the difference between the specified sector column and the small sector column wil",
  T_48_META_API_1535_P4_D: "Specifies the height of the fan-shaped column",
  T_48_META_API_1535_P5_D: "The central angle of the section of the sector cylinder to be tested. When it is greater than 360, it is tested as a cylinder. When it is less than 0, the detection area size is 0.",
  T_48_META_API_1535_P6_D: "Specifies the three-dimensional rotation Euler angle of the fan-shaped cylinder around the center point",
  T_48_META_API_1535_R_D: "Determination result",
  T_48_META_API_1536_D: "Compare the values of two numbers and return the larger one",
  T_48_META_API_1536_P0_D: "Lvalue",
  T_48_META_API_1536_P1_D: "Rvalue",
  T_48_META_API_1536_R_D: "Larger Number",
  T_48_META_API_1537_D: "Return the maximum value in a list",
  T_48_META_API_1537_P0_D: "Target list, only accepts list elements of numeric type",
  T_48_META_API_1537_P1_D: "Compare the results. If there are non-digits in the list, the comparison fails and returns false.",
  T_48_META_API_1537_P2_D: "Returns the largest value in the list if the comparison succeeds, and 0 if the comparison fails",
  T_48_META_API_1538_D: "Compares the values of two numbers and returns the smaller one",
  T_48_META_API_1538_P0_D: "Lvalue",
  T_48_META_API_1538_P1_D: "Rvalue",
  T_48_META_API_1538_R_D: "Smaller Numbers",
  T_48_META_API_1539_D: "Returns the minimum value in a list.",
  T_48_META_API_1539_P0_D: "Target list, only accepts list elements of numeric type",
  T_48_META_API_1539_P1_D: "Compare the results. If there are non-digits in the list, the comparison fails and returns false.",
  T_48_META_API_1539_P2_D: "Returns the smallest value in the list if the comparison succeeds, and 0 if the comparison fails",
  T_48_META_API_1540_D: "Linear interpolation, returns the value corresponding to the interpolation progress between the start value and the target value, the interpolation coefficient is [0,1]",
  T_48_META_API_1540_P0_D: "The starting value of linear interpolation. This value is returned when the interpolation progress is 0",
  T_48_META_API_1540_P1_D: "The target value of linear interpolation. This value is returned when the interpolation progress is 1",
  T_48_META_API_1540_P2_D: "Interpolation progress, the value range is [0,1]. When the value is 0, it returns the start value, when the value is 1, it returns the target value, and when the value is 0.5, it returns the average of the start value and the target value.",
  T_48_META_API_1540_R_D: "Linear interpolation return value",
  T_48_META_API_1541_D: "Limit the range of the target value and obtain the value in the middle of the three input parameters; its function is to limit the target value to the specified range. If the target value is smaller than the minimum value, it returns the minimum value; if",
  T_48_META_API_1541_P0_D: "Target value",
  T_48_META_API_1541_P1_D: "Minimum value of the limited range",
  T_48_META_API_1541_P2_D: "Maximum value of the limited range",
  T_48_META_API_1541_R_D: "Return value after restriction",
  T_48_META_API_1542_D: "Get the channel values of the target color",
  T_48_META_API_1542_P0_D: "Target Color",
  T_48_META_API_1542_P1_D: "The R value of the color, range [0, 255]",
  T_48_META_API_1542_P2_D: "The G value of the color, range [0, 255]",
  T_48_META_API_1542_P3_D: "The B value of the color, range [0 , 255]",
  T_48_META_API_1542_P4_D: "The A value of the color, range [0, 255]",
  T_48_META_API_1543_D: "Exponentiation",
  T_48_META_API_1543_P0_D: "Base",
  T_48_META_API_1543_P1_D: "Index",
  T_48_META_API_1543_R_D: "Calculation results",
  T_48_META_API_1544_D: "Logarithmic Operation",
  T_48_META_API_1544_P0_D: "Base",
  T_48_META_API_1544_P1_D: "True Number",
  T_48_META_API_1544_R_D: "Calculation result",
  T_48_META_API_1545_D: "Direction vector to Euler angle",
  T_48_META_API_1545_P0_D: "Direction Vector",
  T_48_META_API_1545_R_D: "Euler Angle",
  T_48_META_API_1546_D: "Euler angle to direction vector",
  T_48_META_API_1546_P0_D: "Euler Angle",
  T_48_META_API_1546_R_D: "Direction Vector",
  T_48_META_API_1547_D: "Integer to floating point",
  T_48_META_API_1547_P0_D: "Integer",
  T_48_META_API_1547_R_D: "Floating point number",
  T_48_META_API_1548_D: "Rotate the target vector according to the quaternion",
  T_48_META_API_1548_P0_D: "Target vector",
  T_48_META_API_1548_P1_D: "Rotation Quaternion",
  T_48_META_API_1548_R_D: "Rotated vector",
  T_48_META_API_1549_D: "Convert the target number to a string",
  T_48_META_API_1549_P0_D: "The target number to convert to string",
  T_48_META_API_1549_P1_D: "Output digital string format",
  T_48_META_API_1549_R_D: "String",
  T_48_META_API_1598_D: "Get server timestamp",
  T_48_META_API_1598_R_D: "Return the number of seconds since 00:00:00, January 1, 1970",
  T_48_META_API_1599_D: "Get Server Region",
  T_48_META_API_1599_R_D: "Return the region abbreviation (BR,SAC,ID,NA,US,IND,SG,BD,VN,TH,ME,RU,EU,PK,TW)",
  T_48_META_API_16_D: "Customize user embedding logs for user experience data analysis",
  T_48_META_API_16_P0_D: "Players to be reported",
  T_48_META_API_16_P1_D: "List of field names to report",
  T_48_META_API_16_P2_D: "List of field values to report",
  T_48_META_API_1601_D: "Create a dictionary",
  T_48_META_API_1601_R_D: "The created dictionary",
  T_48_META_API_1602_D: "Get the value corresponding to the specified key in the dictionary",
  T_48_META_API_1602_P0_D: "Target dictionary",
  T_48_META_API_1602_P1_D: "Key",
  T_48_META_API_1602_R_D: "Value",
  T_48_META_API_1603_D: "Set the value corresponding to the specified key in the dictionary",
  T_48_META_API_1603_P0_D: "Target dictionary",
  T_48_META_API_1603_P1_D: "Key",
  T_48_META_API_1603_P2_D: "Value",
  T_48_META_API_1604_D: "Remove the specified key-value pair from the dictionary",
  T_48_META_API_1604_P0_D: "Target dictionary",
  T_48_META_API_1604_P1_D: "Key",
  T_48_META_API_1605_D: "Clear all key-value pairs in the dictionary",
  T_48_META_API_1605_P0_D: "Target dictionary",
  T_48_META_API_1606_D: "Get the number of key-value pairs in a dictionary",
  T_48_META_API_1606_P0_D: "Target dictionary",
  T_48_META_API_1606_R_D: "Dictionary length",
  T_48_META_API_1607_D: "Check if a key exists in the dictionary",
  T_48_META_API_1607_P0_D: "Target dictionary",
  T_48_META_API_1607_P1_D: "Key",
  T_48_META_API_1607_R_D: "Exist or not",
  T_48_META_API_1608_D: "Get all the keys of the dictionary and return them as a list",
  T_48_META_API_1608_P0_D: "Target dictionary",
  T_48_META_API_1608_R_D: "List of all key values",
  T_48_META_API_17_D: "Use a box-shaped area with linear motion for detection, and return all entities encountered on the route of the box-shaped area from near to far. If they are initially within the box range, they will not be detected; if the level parameter is filled in, the terrain can be detected",
  T_48_META_API_17_P0_D: "Half the length of the three sides of the box area, only positive values are accepted",
  T_48_META_API_17_P1_D: "Box area center point",
  T_48_META_API_17_P2_D: "Box area rotation",
  T_48_META_API_17_P3_D: "Box area moving direction",
  T_48_META_API_17_P4_D: "Box area traverse distance, only positive values are accepted",
  T_48_META_API_17_P5_D: "Layer mask, only the filled layers will participate in the scan, leaving it blank means all layers will participate in the scan",
  T_48_META_API_17_P6_D: "Whether the trigger can be detected",
  T_48_META_API_17_P7_D: "List of entities hit",
  T_48_META_API_1700_D: "Convert the specified string to an integer",
  T_48_META_API_1700_P0_D: "Target string",
  T_48_META_API_1700_P1_D: "Result integer",
  T_48_META_API_1700_P2_D: "Is the conversion successful?",
  T_48_META_API_1701_D: "Convert the specified string to a floating point number",
  T_48_META_API_1701_P0_D: "Target string",
  T_48_META_API_1701_P1_D: "Result floating point number",
  T_48_META_API_1701_P2_D: "Is the conversion successful?",
  T_48_META_API_18_D: "Use a spherical area with linear motion for detection, and return all entities encountered on the route of the spherical area from near to far. If they are initially in the spherical area, they will not be detected; if the level parameter is filled in, the terrain can be detected",
  T_48_META_API_18_P0_D: "Spherical region radius, only positive values are accepted",
  T_48_META_API_18_P1_D: "Center point of spherical area",
  T_48_META_API_18_P2_D: "Spherical area travel direction",
  T_48_META_API_18_P3_D: "Spherical area travel distance, only positive values are accepted",
  T_48_META_API_18_P4_D: "Layer mask, only the filled layers will participate in the scan, leaving it blank means all layers will participate in the scan",
  T_48_META_API_18_P5_D: "Whether the trigger can be detected",
  T_48_META_API_18_P6_D: "List of entities hit",
  T_48_META_API_19_D: "Use a linear capsule area for detection, returning all entities encountered on the route of the capsule area from near to far. If they are initially in the capsule area, they will not be detected; if the level parameter is filled in, the terrain can be detected",
  T_48_META_API_19_P0_D: "The radius of the hemispheres at both ends of the capsule area. Only positive values are accepted",
  T_48_META_API_19_P1_D: "The distance between the centers of the two hemispheres at both ends of the capsule area. This value must be greater than twice the radius of the two hemispheres.",
  T_48_META_API_19_P2_D: "The center point of the capsule area",
  T_48_META_API_19_P3_D: "Rotation of the capsule area",
  T_48_META_API_19_P4_D: "The direction of travel of the capsule area",
  T_48_META_API_19_P5_D: "The distance traveled in the capsule area, only positive values are accepted",
  T_48_META_API_19_P6_D: "Layer mask, only the filled layers will participate in the scan, leaving it blank means all layers will participate in the scan",
  T_48_META_API_19_P7_D: "Whether the trigger can be detected",
  T_48_META_API_19_P8_D: "List of entities hit",
  T_48_META_API_2_D: "Get all teams in the current game and return the team list.",
  T_48_META_API_2_R_D: "Team List",
  T_48_META_API_20_D: "Use a static box-shaped area for detection and return all entities within the box-shaped area. If the level parameter is filled in, the terrain can be detected.",
  T_48_META_API_20_P0_D: "Half the length of the three sides of the box area, only positive values are accepted",
  T_48_META_API_20_P1_D: "Box area center point",
  T_48_META_API_20_P2_D: "Box area rotation",
  T_48_META_API_20_P3_D: "Layer mask, only the filled layers will participate in the scan, leaving it blank means all layers will participate in the scan",
  T_48_META_API_20_P4_D: "Whether the trigger can be detected",
  T_48_META_API_20_P5_D: "List of entities hit",
  T_48_META_API_2000_D: "Set the attribute value of the target entity. This attribute must have been defined.",
  T_48_META_API_2000_P0_D: "Target Entity",
  T_48_META_API_2000_P1_D: "An attribute of the target entity",
  T_48_META_API_2000_P2_D: "The target value, must conform to the type required when defining the attribute.",
  T_48_META_API_2000_P3_D: "Operation mode, all types support assignment, and numeric types also support self-addition, self-subtraction, self-multiplication, self-division, and self-remainder.",
  T_48_META_API_2001_D: "Get the value of an entity's attribute",
  T_48_META_API_2001_P0_D: "Target Entity",
  T_48_META_API_2001_P1_D: "An attribute ID of the entity",
  T_48_META_API_2001_R_D: "Property Value",
  T_48_META_API_2002: "Set Graph Property",
  T_48_META_API_2002_D: "Set script variable",
  T_48_META_API_2002_P0_D: "Target Entity",
  T_48_META_API_2002_P1: "Graph ID",
  T_48_META_API_2002_P1_D: "Target script ID",
  T_48_META_API_2002_P2: "Property ID",
  T_48_META_API_2002_P2_D: "Member attribute ID defined in the script",
  T_48_META_API_2002_P3: "Property Value",
  T_48_META_API_2002_P3_D: "The target value, must conform to the type required when defining the attribute.",
  T_48_META_API_2002_P4_D: "Operation mode, all types support assignment, and numeric types also support self-addition, self-subtraction, self-multiplication, self-division, and self-remainder.",
  T_48_META_API_2003: "Get Graph Property",
  T_48_META_API_2003_D: "Get script variable",
  T_48_META_API_2003_P0_D: "Target Entity",
  T_48_META_API_2003_P1: "Graph ID",
  T_48_META_API_2003_P1_D: "Target script ID",
  T_48_META_API_2003_P2: "Property ID",
  T_48_META_API_2003_P2_D: "Target attribute ID",
  T_48_META_API_2003_R_D: "Property Value",
  T_48_META_API_2004_D: "Define and initialize a local variable. The scope of the local variable is from the declaration location to the end of the statement block.",
  T_48_META_API_2004_P0_D: "Variable Name",
  T_48_META_API_2004_P1_D: "Variable initial value",
  T_48_META_API_2004_P2_D: "Variable declaration type, the value must match the declared type when assigned",
  T_48_META_API_2005_D: "Set the value of a local variable. The scope of a local variable is from the declaration location to the end of the statement block.",
  T_48_META_API_2005_P0_D: "Variable Name",
  T_48_META_API_2005_P1: "Variable Value",
  T_48_META_API_2005_P1_D: "Variable Value",
  T_48_META_API_2005_P2_D: "Operation mode, all types support assignment, and numeric types also support self-addition, self-subtraction, self-multiplication, self-division, and self-remainder.",
  T_48_META_API_2006: "Get Local Variable",
  T_48_META_API_2006_D: "Get the value of a local variable. The scope of a local variable is from the declaration location to the end of the statement block.",
  T_48_META_API_2006_P0: "Variable Name",
  T_48_META_API_2006_P0_D: "Variable Name",
  T_48_META_API_2006_R_D: "Variable Value",
  T_48_META_API_2009: "Find and Invoke Global Custom API with Serial",
  T_48_META_API_2009_D: "Call the global custom function in serial mode. If there is a wait in the custom function, the calling position will also wait.",
  T_48_META_API_2009_P0: "Graph ID",
  T_48_META_API_2009_P0_D: "The script ID where the custom function is located",
  T_48_META_API_2009_P1: "Function ID",
  T_48_META_API_2009_P1_D: "The ID of the custom function to be called",
  T_48_META_API_2009_P2_D: "List of parameters passed to the custom function",
  T_48_META_API_2010: "Find and Invoke Global Custom API with Parallel",
  T_48_META_API_2010_D: "Call the global custom function in parallel. Regardless of whether there is a wait in the custom function, it will immediately return to the calling position and continue to execute.",
  T_48_META_API_2010_P0: "Graph ID",
  T_48_META_API_2010_P0_D: "The script ID where the custom function is located",
  T_48_META_API_2010_P1: "Function ID",
  T_48_META_API_2010_P1_D: "The ID of the custom function to be called",
  T_48_META_API_2010_P2_D: "List of parameters passed to the custom function",
  T_48_META_API_2013: "Set Self Graph Property",
  T_48_META_API_2013_D: "Set variables for the current script",
  T_48_META_API_2013_P0: "Property ID",
  T_48_META_API_2013_P0_D: "Target attribute ID",
  T_48_META_API_2013_P1: "Property Value",
  T_48_META_API_2013_P1_D: "Target value",
  T_48_META_API_2013_P2_D: "Operation mode, all types support assignment, and numeric types also support self-addition, self-subtraction, self-multiplication, self-division, and self-remainder.",
  T_48_META_API_2014: "Get Self Graph Property",
  T_48_META_API_2014_D: "Get the current script's variables",
  T_48_META_API_2014_P0: "Property ID",
  T_48_META_API_2014_P0_D: "Target attribute ID",
  T_48_META_API_2014_R_D: "Property Value",
  T_48_META_API_21_D: "Use a static spherical area for detection and return all entities in the spherical area. If the level parameter is filled in, the terrain can be detected.",
  T_48_META_API_21_P0_D: "Spherical region radius, only positive values are accepted",
  T_48_META_API_21_P1_D: "Center point of spherical area",
  T_48_META_API_21_P2_D: "Layer mask, only the filled layers will participate in the scan, leaving it blank means all layers will participate in the scan",
  T_48_META_API_21_P3_D: "Whether the trigger can be detected",
  T_48_META_API_21_P4_D: "List of entities hit",
  T_48_META_API_22_D: "Use a static capsule area for detection and return all entities in the capsule area. If the level parameter is filled in, the terrain can be detected.",
  T_48_META_API_22_P0_D: "The radius of the hemispheres at both ends of the capsule area. Only positive values are accepted.",
  T_48_META_API_22_P1_D: "The distance between the centers of the two hemispheres at both ends of the capsule area. This value must be greater than twice the radius of the two hemispheres.",
  T_48_META_API_22_P2_D: "The center point of the capsule area",
  T_48_META_API_22_P3_D: "Rotation of the capsule region",
  T_48_META_API_22_P4_D: "Layer mask, only the filled layers will participate in the scan, leaving it blank means all layers will participate in the scan",
  T_48_META_API_22_P5_D: "Whether the trigger can be detected",
  T_48_META_API_22_P6_D: "List of entities hit",
  T_48_META_API_23_D: "Set the special item status for the player. Special items can only have one",
  T_48_META_API_23_P0_D: "Player",
  T_48_META_API_23_P1_D: "Item ID",
  T_48_META_API_23_P2_D: "Whether to enable this item",
  T_48_META_API_23_P3_D: "Special item entities",
  T_48_META_API_24_D: "Apply a force to the target. The target must be a physical object.",
  T_48_META_API_24_P0_D: "Target physical object",
  T_48_META_API_24_P1_D: "Force Vector",
  T_48_META_API_24_P2_D: "Type of force",
  T_48_META_API_25_D: "Apply a force at a point. The target must be a rigidbody.",
  T_48_META_API_25_P0_D: "Target Rigidbody",
  T_48_META_API_25_P1_D: "Force Vector",
  T_48_META_API_25_P2_D: "Force application position",
  T_48_META_API_25_P3_D: "Type of force",
  T_48_META_API_26_D: "Apply a torque to the target. The target must be a rigidbody.",
  T_48_META_API_26_P0_D: "Target Rigidbody",
  T_48_META_API_26_P1_D: "Torque",
  T_48_META_API_26_P2_D: "Force type",
  T_48_META_API_27_D: "Move the target rigidbody to the specified position",
  T_48_META_API_27_P0_D: "Target Rigidbody",
  T_48_META_API_27_P1_D: "Specify location",
  T_48_META_API_28_D: "Rotate the target rigidbody",
  T_48_META_API_28_P0_D: "Target Rigidbody",
  T_48_META_API_28_P1_D: "Rotation Quaternion",
  T_48_META_API_29_D: "Create interpolated motion, the specified attributes of the target entity will move smoothly according to the settings",
  T_48_META_API_29_P0_D: "Target Entity",
  T_48_META_API_29_P1_D: "The attribute ID that needs movement change",
  T_48_META_API_29_P2_D: "Attribute starting value",
  T_48_META_API_29_P3_D: "Attribute end value",
  T_48_META_API_29_P4_D: `You can choose single, loop and reciprocating. 
 Loop means that after each movement is completed, the entity will move again from the starting value. Reciprocating means that after the movement from the starting value to the target value is completed, the entity will move from the target value to the starting value again, and then repeat the process`,
  T_48_META_API_29_P5_D: "Bezier curve control points",
  T_48_META_API_29_P6_D: "The duration of a change, in milliseconds",
  T_48_META_API_29_P7_D: "Created interpolated motion entity",
  T_48_META_API_29_P8_D: "Whether to automatically start playing after creation",
  T_48_META_API_3_D: "Switches the game to the target phase. The round is also a special phase. When switching to the phase in the round, the round count is 0.",
  T_48_META_API_3_P0_D: "The index of the target round or phase",
  T_48_META_API_30_D: "Forces the target player to enter the specified vehicle",
  T_48_META_API_30_P0_D: "Target Player",
  T_48_META_API_30_P1_D: "Vehicle Entity",
  T_48_META_API_30_P2_D: "Seat Number",
  T_48_META_API_30_P3_D: "Whether makes the player enter the vehicle successfully",
  T_48_META_API_3001_D: "Make the target player drop an item",
  T_48_META_API_3001_P0_D: "Target Players",
  T_48_META_API_3001_P1_D: "Item Entity",
  T_48_META_API_3002_D: "Get the available coordinates of the random spawn point that is currently available but not fully occupied (deprecated, please use GetRandomSpawnPosition)",
  T_48_META_API_3002_P0_D: "Players who need to be assigned a spawn area",
  T_48_META_API_3002_R_D: "Coordinates of random points randomly assigned",
  T_48_META_API_3003_D: "Get the total score of the player's specified score type",
  T_48_META_API_3003_P0_D: "Player",
  T_48_META_API_3003_P1_D: "Points Type",
  T_48_META_API_3003_R_D: "Points",
  T_48_META_API_3004_D: "Set the round score of the player's specified scoring type",
  T_48_META_API_3004_P0_D: "Player Entity",
  T_48_META_API_3004_P1_D: "Points Type",
  T_48_META_API_3004_P2_D: "Points",
  T_48_META_API_3005_D: "Get the total score of the team's specified points type",
  T_48_META_API_3005_P0_D: "Team Entity",
  T_48_META_API_3005_P1_D: "Points Type",
  T_48_META_API_3005_R_D: "Points",
  T_48_META_API_3006_D: "Set the round score of the team's specified scoring type",
  T_48_META_API_3006_P0_D: "Team Entity",
  T_48_META_API_3006_P1_D: "Points Type",
  T_48_META_API_3006_P2_D: "Points",
  T_48_META_API_3007_D: "Get the player's score for a specified round and point type",
  T_48_META_API_3007_P0_D: "Player Entity",
  T_48_META_API_3007_P1_D: "Round Index",
  T_48_META_API_3007_P2_D: "Points Type",
  T_48_META_API_3007_R_D: "Points",
  T_48_META_API_3008_D: "Get the score of the team's specified round and points type",
  T_48_META_API_3008_P0_D: "Team Entity",
  T_48_META_API_3008_P1_D: "Round Index",
  T_48_META_API_3008_P2_D: "Points Type",
  T_48_META_API_3008_R_D: "Points",
  T_48_META_API_3009_D: "Get the player's overall game ranking",
  T_48_META_API_3009_P0_D: "Player Entity",
  T_48_META_API_3009_R_D: "Ranking",
  T_48_META_API_3011_D: "Get the overall ranking of the team game",
  T_48_META_API_3011_P0_D: "Deprecated",
  T_48_META_API_3011_R_D: "Ranking",
  T_48_META_API_3013_D: "Get the player's ranking in a specified round",
  T_48_META_API_3013_P0_D: "Player Entity",
  T_48_META_API_3013_P1_D: "Round Index",
  T_48_META_API_3013_R_D: "Ranking",
  T_48_META_API_3014_D: "Get the team's ranking in a specified round",
  T_48_META_API_3014_P0_D: "Deprecated",
  T_48_META_API_3014_P1_D: "Round Index",
  T_48_META_API_3014_R_D: "Ranking",
  T_48_META_API_3015_D: "Get the wallet of the target entity",
  T_48_META_API_3015_P0_D: "Target Entity",
  T_48_META_API_3015_P1_D: "Whether a wallet exists",
  T_48_META_API_3015_P2_D: "The wallet entity obtained",
  T_48_META_API_3016_D: "Create a wallet for the target player. Ineffective if the player already has a wallet.",
  T_48_META_API_3016_P0_D: "Target Player",
  T_48_META_API_3016_P1_D: "The entity to which the wallet is bound, the owner of the wallet",
  T_48_META_API_3016_P2_D: "Wallet Entity",
  T_48_META_API_3017_D: "Add currency to the specified wallet",
  T_48_META_API_3017_P0_D: "Target wallet",
  T_48_META_API_3017_P1_D: "Added currency type",
  T_48_META_API_3017_P2_D: "Added currency amount",
  T_48_META_API_3018_D: "Reduce currency from specified wallet",
  T_48_META_API_3018_P0_D: "Target wallet",
  T_48_META_API_3018_P1_D: "Reduced currency type",
  T_48_META_API_3018_P2_D: "Reduced currency amount",
  T_48_META_API_3019_D: "Transfer currency from one wallet to another",
  T_48_META_API_3019_P0_D: "The wallet from which the currency is transferred",
  T_48_META_API_3019_P1_D: "Transferred currency type",
  T_48_META_API_3019_P2_D: "Transferred currency amount",
  T_48_META_API_3019_P3_D: "The wallet to which the currency is transferred",
  T_48_META_API_3020_D: "Get the amount of the specified type of currency in the specified wallet",
  T_48_META_API_3020_P0_D: "Target wallet",
  T_48_META_API_3020_P1_D: "Currency type of the query",
  T_48_META_API_3020_R_D: "Amount of currency",
  T_48_META_API_3021_D: "Get the entity of the specified type of currency in the specified wallet",
  T_48_META_API_3021_P0_D: "Target wallet",
  T_48_META_API_3021_P1_D: "The currency type of the query",
  T_48_META_API_3021_R_D: "Currency Entity",
  T_48_META_API_3022_D: "Get all the stores in the game and return them as a list",
  T_48_META_API_3022_R_D: "Store Entity List",
  T_48_META_API_3023_D: "Replace the target player's appearance with the appearance of the specified scene object",
  T_48_META_API_3023_P0_D: "Target Players",
  T_48_META_API_3023_P1_D: "Replaced target scene object",
  T_48_META_API_3023_P2_D: "The player transformation disguise component created after replacement",
  T_48_META_API_3024_D: "Cancel the player's disguise status",
  T_48_META_API_3024_P0_D: "Target Player",
  T_48_META_API_3025_D: "Create a clone with the appearance of scene entity at the position of the target player",
  T_48_META_API_3025_P0_D: "Target Player",
  T_48_META_API_3025_P1_D: "Scene entity used for the clone appearance",
  T_48_META_API_3025_P2_D: "Created clone entity",
  T_48_META_API_3026_D: "Get the player's disguise entity",
  T_48_META_API_3026_P0_D: "Player",
  T_48_META_API_3026_R_D: "Player disguise entity",
  T_48_META_API_3027_D: "Get the chat channel entity by index",
  T_48_META_API_3027_P0_D: "Chat channel index, range [1,8]",
  T_48_META_API_3027_R_D: "Chat Channel Entity",
  T_48_META_API_3028_D: "Get the chat channel entity that the specified player is currently in",
  T_48_META_API_3028_P0_D: "Target Player",
  T_48_META_API_3028_R_D: "Chat Channel Entity",
  T_48_META_API_3029_D: "Makes the player join the specified chat channel. If the player is already in another chat channel, it will switch to the target channel.",
  T_48_META_API_3029_P0_D: "Target Player",
  T_48_META_API_3029_P1_D: "Chat Channel Entity",
  T_48_META_API_3030_D: "Make the player exit the current channel and then be in a state of not being in any chat channel",
  T_48_META_API_3030_P0_D: "Target Player",
  T_48_META_API_3031_D: "Obsoleted",
  T_48_META_API_3031_P0_D: "Chat channel entity, empty if there are no players in the channel",
  T_48_META_API_3032_D: "Set the player's behavior state",
  T_48_META_API_3032_P0_D: "Target Player",
  T_48_META_API_3032_P1_D: "Player behavior type",
  T_48_META_API_3032_P2_D: `Enable: HUD button exists and it can be used normally
Disable: The HUD button is disabled and cannot be actively or passively entered into this behavior state
Block: The HUD button is hidden and cannot be actively entered into this behavior state, but c`,
  T_48_META_API_3033_D: "The player transforms into a designated scene object",
  T_48_META_API_3033_P0_D: "Target Player",
  T_48_META_API_3033_P1_D: "The object to be transformed into",
  T_48_META_API_3033_P2_D: "Entity created after transformation",
  T_48_META_API_3034_D: "The player creates a clone that looks like themselves",
  T_48_META_API_3034_P0_D: "Target Player",
  T_48_META_API_3034_P1_D: "Created clone entity",
  T_48_META_API_3035_D: "Create a custom store, the next level of the store is the shelves",
  T_48_META_API_3035_P0_D: "Created store entity",
  T_48_META_API_3036_D: "Create a custom shelf, the upper level of the shelf is the store, and the lower level is the product",
  T_48_META_API_3036_P0_D: "Created shelf entity",
  T_48_META_API_3037_D: "Create a custom product, you can add items to the product",
  T_48_META_API_3037_P0_D: "Created product entity",
  T_48_META_API_3038_D: "Add item to a product. You can add multiple items to a product by using this block multiple times.",
  T_48_META_API_3038_P0_D: "Product Entity",
  T_48_META_API_3038_P1_D: "Items to add",
  T_48_META_API_3038_P2_D: "Item quantity",
  T_48_META_API_3039_D: "Grant jailbreak reward",
  T_48_META_API_3039_P0_D: "Player Entity",
  T_48_META_API_3039_P1_D: "Quantity",
  T_48_META_API_3039_P2_D: "Real Money",
  T_48_META_API_3040_D: "Update jailbreak task",
  T_48_META_API_3040_P0_D: "Player Entity",
  T_48_META_API_3040_P1_D: "Task ID",
  T_48_META_API_3040_P2_D: "Value",
  T_48_META_API_3041_D: "Get the coordinates of a random spawn point, which will only be randomly selected from available spawn points that are not fully occupied",
  T_48_META_API_3041_P0_D: "Target Player",
  T_48_META_API_3041_R_D: "Random birth point coordinates. If there is no birth point that meets the conditions, a position close to (0, 0, 0) will be returned.",
  T_48_META_API_3042_D: "Exit the jailbreak game",
  T_48_META_API_3042_P0_D: "Player Entity",
  T_48_META_API_3042_P1_D: "Task ID",
  T_48_META_API_3043_D: "Based on jailbreak items",
  T_48_META_API_3043_P0_D: "Player Entity",
  T_48_META_API_3043_P1_D: "Item Type",
  T_48_META_API_3043_P2_D: "Item ID",
  T_48_META_API_31_D: "Create relative self-motion, the target entity changes each time relative to its current attribute value",
  T_48_META_API_31_P0_D: "Target Entity",
  T_48_META_API_31_P1_D: "Attribute that needs movement change",
  T_48_META_API_31_P2_D: "The amount of change per movement",
  T_48_META_API_31_P3_D: "Bezier curve control points",
  T_48_META_API_31_P4_D: `Single: Stop when the property changes by Delta
Loop: Repeat the movement, each time the property changes by Delta`,
  T_48_META_API_31_P5_D: "The duration of a change, in milliseconds",
  T_48_META_API_31_P6_D: "Created entities with relative self-motion",
  T_48_META_API_31_P7_D: "Whether to automatically start playing after creation",
  T_48_META_API_3100_D: "The target plays the animation in the specified state",
  T_48_META_API_3100_P0_D: "The entity component that plays the animation. Can be mounted with an animation controller",
  T_48_META_API_3100_P1_D: "The specified state of the animation controller",
  T_48_META_API_3100_P2_D: "Animation playback speed scaling",
  T_48_META_API_3100_P3_D: "Loop type, you can keep the original logic of the animation, play it only once or repeat",
  T_48_META_API_3101_D: "Play character animations, support custom animation resources",
  T_48_META_API_3101_P0_D: "Target Player",
  T_48_META_API_3101_P1_D: "Custom animation resource ID",
  T_48_META_API_3101_P2_D: "Whether to loop playback",
  T_48_META_API_3102_D: "Sets the character resource of the specified player",
  T_48_META_API_3102_P0_D: "Target Player",
  T_48_META_API_3102_P1_D: "Custom character resource ID",
  T_48_META_API_3109_D: "The safe zone that smoothly moves to the end point when opened",
  T_48_META_API_3109_P0_D: "Safe zone starting position",
  T_48_META_API_3109_P1_D: "Safe zone end position",
  T_48_META_API_3109_P2_D: "Initial radius of safe zone",
  T_48_META_API_3109_P3_D: "Final radius of safe zone",
  T_48_META_API_3109_P4_D: "The time required for the safe zone to reach the final state, in seconds",
  T_48_META_API_3109_P5_D: "The amount of damage per second taken outside the safe zone",
  T_48_META_API_3110_D: "Switch character appearance group",
  T_48_META_API_3110_P0_D: "Target",
  T_48_META_API_3110_P1_D: "Appearance Group",
  T_48_META_API_3111_D: "Show Character Appearance Group",
  T_48_META_API_3111_P0_D: "Target",
  T_48_META_API_3111_P1_D: "Appearance Group",
  T_48_META_API_3112_D: "Hide character appearance group",
  T_48_META_API_3112_P0_D: "Target",
  T_48_META_API_3112_P1_D: "Appearance Group",
  T_48_META_API_3121_D: "Send assertion results to Craftland Studio PC for statistical use",
  T_48_META_API_3121_P0_D: "Assertion Expression",
  T_48_META_API_3121_P1_D: "Hint",
  T_48_META_API_32_D: "Get today's token data of the player",
  T_48_META_API_32_P0_D: "Target Player",
  T_48_META_API_32_P1_D: "tokenID",
  T_48_META_API_32_P2_D: "Token amount",
  T_48_META_API_32_P3_D: "Whether the block is called successfully",
  T_48_META_API_3200_D: "Add items to the player and return the list of items issued",
  T_48_META_API_3200_P0_D: "Player",
  T_48_META_API_3200_P1_D: "Item ID",
  T_48_META_API_3200_P2_D: "Item amount",
  T_48_META_API_3200_P3_D: "A list of items added for the player. Even if only one item is added, it is returned as a list.",
  T_48_META_API_3201_D: "Restore health to the designated player without exceeding the health limit",
  T_48_META_API_3201_P0_D: "Target Player",
  T_48_META_API_3201_P1_D: "The value of restored health to the player, only positive numbers are accepted",
  T_48_META_API_3202_D: "Set the target player's skill list",
  T_48_META_API_3202_P0_D: "Target Player",
  T_48_META_API_3202_P1_D: "Skill List",
  T_48_META_API_3203_D: "Get the target player's skill list",
  T_48_META_API_3203_P0_D: "Target Player",
  T_48_META_API_3203_R_D: "Skill List",
  T_48_META_API_3205_D: "Delete a certain number of items from the player",
  T_48_META_API_3205_P0_D: "Target Player",
  T_48_META_API_3205_P1_D: "The type of item to delete",
  T_48_META_API_3205_P2_D: "The number to be deleted. If it exceeds the number of items held by the player, only the owned items will be deleted.",
  T_48_META_API_3206_D: "Get the number of specified items held by the player",
  T_48_META_API_3206_P0_D: "Target Player",
  T_48_META_API_3206_P1_D: "Item Type",
  T_48_META_API_3206_R_D: "Player holding amount",
  T_48_META_API_3207_D: "Checks whether the player can trigger the current checkpoint",
  T_48_META_API_3207_P0_D: "Target Player",
  T_48_META_API_3207_P1_D: "trigger",
  T_48_META_API_3207_R_D: "True: can be triggered, False: cannot be triggered",
  T_48_META_API_3208_D: "Infection Mode Zombie Evolution",
  T_48_META_API_3208_P0_D: "Target Player",
  T_48_META_API_3209_D: "AI entity stops/executes default behavior tree",
  T_48_META_API_3209_P0_D: "To enable a behavior tree goal",
  T_48_META_API_3209_P1_D: "Whether to execute the default behavior tree",
  T_48_META_API_3210_D: "AI entity chases the designated target",
  T_48_META_API_3210_P0_D: "AI entity that performs pursuit",
  T_48_META_API_3210_P1_D: "The target being pursued",
  T_48_META_API_3211_D: "Destroys player items (deprecated, use DeleteEquipment)",
  T_48_META_API_3211_P0_D: "Player whose item was destroyed",
  T_48_META_API_3211_P1_D: "Type of item destroyed",
  T_48_META_API_3211_P2_D: "Weapon slot, only effective for weapons",
  T_48_META_API_3212_D: "Change jersey",
  T_48_META_API_3212_P0_D: "Target Player",
  T_48_META_API_3212_P1_D: "Clothing Style",
  T_48_META_API_3212_P2_D: "Main color 1",
  T_48_META_API_3212_P3_D: "Main color 2",
  T_48_META_API_3212_P4_D: "Configuration",
  T_48_META_API_3213_D: "Restore the player's jersey to its original state",
  T_48_META_API_3213_P0_D: "Target Player",
  T_48_META_API_3214_D: "Toggle player voice chat",
  T_48_META_API_3214_P0_D: "Target Player",
  T_48_META_API_3214_P1_D: "Whether to turn off voice chat, True: turn off False: turn on",
  T_48_META_API_3215_D: "Toggle player quick chat",
  T_48_META_API_3215_P0_D: "Target Player",
  T_48_META_API_3215_P1_D: "Whether to close quick chat, True: Close False: Open",
  T_48_META_API_3216_D: "Sets whether the target player can pick up items",
  T_48_META_API_3216_P0_D: "Target Player",
  T_48_META_API_3216_P1_D: "Whether to prohibit picking up items, true: prohibit picking up false: allow to pick up",
  T_48_META_API_3217_D: "Set whether the target player can drop items",
  T_48_META_API_3217_P0_D: "Target Player",
  T_48_META_API_3217_P1_D: "Is it forbidden to drop items? True: forbidden to pick up False: allowed to pick up",
  T_48_META_API_3218_D: "Destroys the weapon in the player's specified slot",
  T_48_META_API_3218_P0_D: "Target Player",
  T_48_META_API_3218_P1_D: "Weapon slot to destroy",
  T_48_META_API_3218_P2_D: "The number to destroy",
  T_48_META_API_3218_P3_D: "Whether the destruction is successful. If there is no weapon equipped in the weapon slot, the destruction will fail.",
  T_48_META_API_3219_D: "Clear all items in the target player's backpack, including equipped items",
  T_48_META_API_3219_P0_D: "Target Player",
  T_48_META_API_3220_D: "Set the player's direction",
  T_48_META_API_3220_P0_D: "Target Player",
  T_48_META_API_3220_P1_D: "Player orientation",
  T_48_META_API_3221_D: "(Obsolete, do not use, see the property <Player>:Skeleton for related information)",
  T_48_META_API_3221_P0_D: "Player Entity",
  T_48_META_API_3221_P1_D: "Scaling part",
  T_48_META_API_3221_P2_D: "Scaling value",
  T_48_META_API_3222_D: "Give the player a knock-up effect. The target player will fall at a fixed acceleration, and will be forced to stop after a collision in the air.",
  T_48_META_API_3222_P0_D: "Target Player",
  T_48_META_API_3222_P1_D: "Knockback direction",
  T_48_META_API_3222_P2_D: "Knockback duration",
  T_48_META_API_3222_P3_D: "Initial velocity on the Y axis when knocked back",
  T_48_META_API_3222_P4_D: "Initial velocity in the XZ plane when knocked back",
  T_48_META_API_3222_P5_D: "Whether to change the player's direction",
  T_48_META_API_3223_D: "Get the clothing ID of the target player or NPC",
  T_48_META_API_3223_P0_D: "Target player or NPC",
  T_48_META_API_3223_P1_D: "Clothing Type",
  T_48_META_API_3223_R_D: "Clothing ID",
  T_48_META_API_3224_D: "Set the clothing ID of the target player or NPC",
  T_48_META_API_3224_P0_D: "Target player or NPC",
  T_48_META_API_3224_P1_D: "Clothing ID",
  T_48_META_API_3225_D: "Restore the target player's default clothing. Does not work on NPCs.",
  T_48_META_API_3225_P0_D: "Target Player",
  T_48_META_API_3226_D: "AI entity attacks the specified target",
  T_48_META_API_3226_P0_D: "The AI entity that performs the attack",
  T_48_META_API_3226_P1_D: "Attacked Target",
  T_48_META_API_3227_D: "Switch the player's weapon to the weapon in the specified slot",
  T_48_META_API_3227_P0_D: "Target Player",
  T_48_META_API_3227_P1_D: "The weapon slot to switch to",
  T_48_META_API_3227_P2_D: "Whether the switch is successful. If there is no weapon equipped in the weapon slot, the switch will fail.",
  T_48_META_API_3228_D: "Get the target player or NPC's weapon skin",
  T_48_META_API_3228_P0_D: "Target player or NPC",
  T_48_META_API_3228_P1_D: "Weapon Skin ID",
  T_48_META_API_3228_R_D: "Weapon Skin ID",
  T_48_META_API_3229_D: "Sets the target player's or NPC's weapon skin",
  T_48_META_API_3229_P0_D: "Target player or NPC",
  T_48_META_API_3229_P1_D: "Weapon Skin ID",
  T_48_META_API_3230_D: "Restores the target player's default weapon skin. Does not work on NPC",
  T_48_META_API_3230_P0_D: "Target Player",
  T_48_META_API_3230_P1_D: "Weapon ID",
  T_48_META_API_3231_D: "Set the player's outfit",
  T_48_META_API_3231_P0_D: "Target Player",
  T_48_META_API_3231_P1_D: "Clothing List",
  T_48_META_API_3232_D: "Remove all clothing of the specified clothing type from the target player or NPC",
  T_48_META_API_3232_P0_D: "Target player or NPC",
  T_48_META_API_3232_P1_D: "Clothing Type",
  T_48_META_API_3233_D: "Remove the skin from player's or NPC's specified weapon",
  T_48_META_API_3233_P0_D: "Target player or NPC",
  T_48_META_API_3233_P1_D: "Weapon ID",
  T_48_META_API_3234_D: "Add a buff to the target",
  T_48_META_API_3234_P0_D: "The target entity. It must be an entity that can add buffs",
  T_48_META_API_3234_P1_D: "Buff id",
  T_48_META_API_3235_D: "Removes the Buff from the target",
  T_48_META_API_3235_P0_D: "The target entity. It must be an entity that can add buffs",
  T_48_META_API_3235_P1_D: "Buff id",
  T_48_META_API_3236_D: "Get the target's current Buffs",
  T_48_META_API_3236_P0_D: "The target entity. It must be an entity that can add buffs",
  T_48_META_API_3236_R_D: "Buff List",
  T_48_META_API_3237_D: "Get the consumables in the target player's backpack consumable column",
  T_48_META_API_3237_P0_D: "Target Player",
  T_48_META_API_3237_P1_D: "Consumable List",
  T_48_META_API_3238_D: "Add an accessory to the weapon in the specified slot. Accessory that does not match the slot will fail to be added; matching but duplicate accessory will replace the original accessory, and the original accessory will be sent to the player's backpack. If ",
  T_48_META_API_3238_P0_D: "Target Player",
  T_48_META_API_3238_P1_D: "Equipment slot",
  T_48_META_API_3238_P2_D: "Accessory",
  T_48_META_API_3238_P3_D: `Whether the accessory has been added successfully
True: The accessory has been equipped to the weapon in the corresponding slot
False: The accessory has failed to be added and will not appear in the player's backpack`,
  T_48_META_API_3238_P4_D: "Added accessories, null if failed",
  T_48_META_API_3239_D: "Get the equipment in the backpack equipment column",
  T_48_META_API_3239_P0_D: "Target Player",
  T_48_META_API_3239_P1_D: "Equipment slot",
  T_48_META_API_3239_P2_D: "The equipment in the specified slot. If there is no equipment, it will be null.",
  T_48_META_API_3239_P3_D: "All accessories for this equipment",
  T_48_META_API_3240_D: "Get the X component of a two-dimensional vector",
  T_48_META_API_3240_P0_D: "2D vector",
  T_48_META_API_3240_R_D: "2D vector X component",
  T_48_META_API_3241_D: "Get the Y component of a two-dimensional vector",
  T_48_META_API_3241_P0_D: "2D vector",
  T_48_META_API_3241_R_D: "Y component of a 2D vector",
  T_48_META_API_3242_D: "Set the X component of a two-dimensional vector",
  T_48_META_API_3242_P0_D: "2D vector",
  T_48_META_API_3242_P1_D: "2D vector X component",
  T_48_META_API_3243_D: "Set the Y component of a two-dimensional vector",
  T_48_META_API_3243_P0_D: "2D vector",
  T_48_META_API_3243_P1_D: "Y component of a 2D vector",
  T_48_META_API_3244_D: "Add two 2D vectors",
  T_48_META_API_3244_P0_D: "Lvalue",
  T_48_META_API_3244_P1_D: "Rvalue",
  T_48_META_API_3244_R_D: "Result of adding two-dimensional vectors",
  T_48_META_API_3245_D: "Subtract two 2D vectors",
  T_48_META_API_3245_P0_D: "Lvalue",
  T_48_META_API_3245_P1_D: "Rvalue",
  T_48_META_API_3245_R_D: "Result of two-dimensional vector subtraction",
  T_48_META_API_3246_D: "Multiply a two-dimensional vector",
  T_48_META_API_3246_P0_D: "2D vector",
  T_48_META_API_3246_P1_D: "2D vector scaling value",
  T_48_META_API_3246_R_D: "Result of 2D vector multiplication",
  T_48_META_API_3247_D: "The dot product of two two-dimensional vectors is a scalar, representing the angle between the two vectors.",
  T_48_META_API_3247_P0_D: "Lvalue",
  T_48_META_API_3247_P1_D: "Rvalue",
  T_48_META_API_3247_R_D: "Dot product result",
  T_48_META_API_3248_D: "Calculate the Euclidean distance between two 2D vectors",
  T_48_META_API_3248_P0_D: "Lvalue",
  T_48_META_API_3248_P1_D: "Rvalue",
  T_48_META_API_3248_R_D: "After subtracting two vectors, the modulus of the resulting vector",
  T_48_META_API_3249_D: "Calculate the angle between two 2D vectors",
  T_48_META_API_3249_P0_D: "Lvalue",
  T_48_META_API_3249_P1_D: "Rvalue",
  T_48_META_API_3249_R_D: "Vector angle, angle range 0-180",
  T_48_META_API_3250_D: "Normalize a 2D vector",
  T_48_META_API_3250_P0_D: "2D vector",
  T_48_META_API_3250_R_D: "The normalized result is a vector with a length of 1 in the same direction.",
  T_48_META_API_3251_D: "Modulo a 2D vector",
  T_48_META_API_3251_P0_D: "2D vector",
  T_48_META_API_3251_R_D: "The modulo result. It is the vector length",
  T_48_META_API_3252_D: "Calculate the vector after the two-dimensional vector is reflected by the normal line",
  T_48_META_API_3252_P0_D: "Incident 2D vector",
  T_48_META_API_3252_P1_D: "Normal 2D vector",
  T_48_META_API_3252_R_D: "Reflecting a 2D vector",
  T_48_META_API_3253_D: "Calculate the vector after the three-dimensional vector is reflected by the plane perpendicular to the normal",
  T_48_META_API_3253_P0_D: "Incident 3D vector",
  T_48_META_API_3253_P1_D: "Normal 3D vector",
  T_48_META_API_3253_R_D: "Reflect 3D vector",
  T_48_META_API_3254_D: "Convert a 3D vector to a 2D vector and delete the Z component of the 3D vector",
  T_48_META_API_3254_P0_D: "Target 3D vector",
  T_48_META_API_3254_R_D: "The transformed two-dimensional vector",
  T_48_META_API_3255_D: "Convert a 2D vector to a 3D vector, and set the Z component of the 3D vector to 0",
  T_48_META_API_3255_P0_D: "Target 2D vector",
  T_48_META_API_3255_R_D: "The transformed three-dimensional vector",
  T_48_META_API_3256_D: "Create a 2D vector",
  T_48_META_API_3256_P0_D: "X component of the 2D vector",
  T_48_META_API_3256_P1_D: "Y component of the 2D vector",
  T_48_META_API_3256_R_D: "The two-dimensional vector created",
  T_48_META_API_3257_D: "Customize game tracking logs for user experience data analysis",
  T_48_META_API_3257_P0_D: "log",
  T_48_META_API_3258_D: "Customize game tracking logs for user experience data analysis",
  T_48_META_API_3258_P0_D: "Players to be reported",
  T_48_META_API_3258_P1_D: "log",
  T_48_META_API_33_D: "Dirty word filtering",
  T_48_META_API_33_P0_D: "The original text that needs to be filtered for dirty words",
  T_48_META_API_33_R_D: "Filtered text",
  T_48_META_API_3301_D: "Create a faction entity",
  T_48_META_API_3301_P0_D: "Faction Entity",
  T_48_META_API_3302_D: "The target entity joins the specified faction",
  T_48_META_API_3302_P0_D: "Target Entity",
  T_48_META_API_3302_P1_D: "Faction Entity",
  T_48_META_API_3303_D: "Get the attackable faction of the faction",
  T_48_META_API_3303_P0_D: "Attack faction",
  T_48_META_API_3303_R_D: "List of faction entities",
  T_48_META_API_3304_D: "Set the attackable faction of the faction",
  T_48_META_API_3304_P0_D: "Attack faction",
  T_48_META_API_3304_P1_D: "Target faction",
  T_48_META_API_3304_P2_D: "Attackable or not",
  T_48_META_API_3305_D: "Set attackable players",
  T_48_META_API_3305_P0_D: "Player",
  T_48_META_API_3305_P1_D: "Can attack players",
  T_48_META_API_3305_P2_D: "Is it attackable?",
  T_48_META_API_3306_D: "Set the team's attackable team",
  T_48_META_API_3306_P0_D: "Attacking Team",
  T_48_META_API_3306_P1_D: "Target Team",
  T_48_META_API_3306_P2_D: "Attackable or not",
  T_48_META_API_3307_D: "Deprecated",
  T_48_META_API_3307_P0_D: "Deprecated",
  T_48_META_API_3307_R_D: "List of player entities",
  T_48_META_API_3308_D: "The specified entity exits the current faction",
  T_48_META_API_3308_P0_D: "Target Entity",
  T_48_META_API_3309_D: "Get the target's faction",
  T_48_META_API_3309_P0_D: "Target Entity",
  T_48_META_API_3309_R_D: "Faction Entity",
  T_48_META_API_3310_D: "Determine whether the target can be attacked",
  T_48_META_API_3310_P0_D: "Attacker",
  T_48_META_API_3310_P1_D: "Target Entity",
  T_48_META_API_3310_R_D: "Attackable or not",
  T_48_META_API_3311_D: "Sets the entity's attack target",
  T_48_META_API_3311_P0_D: "Attacker",
  T_48_META_API_3311_P1_D: "Target Entity",
  T_48_META_API_3311_P2_D: "Attackable or not",
  T_48_META_API_3312_D: "Gets the entity's attackable targets",
  T_48_META_API_3312_P0_D: "Attacker",
  T_48_META_API_3312_R_D: "List of attackable entities",
  T_48_META_API_34_D: "Determine if the target entity has a component",
  T_48_META_API_34_P0_D: "Target Entity",
  T_48_META_API_34_P1_D: "Component Type",
  T_48_META_API_34_R_D: "Exist or not",
  T_48_META_API_35_D: "Add Bot",
  T_48_META_API_35_P0_D: "Bot Difficulty Level",
  T_48_META_API_35_P1_D: "Bot's team",
  T_48_META_API_35_P2_D: "Created Bot player entity",
  T_48_META_API_3500_D: "Get player's token data",
  T_48_META_API_3500_P0_D: "Target Player",
  T_48_META_API_3500_P1_D: "TokenID",
  T_48_META_API_3500_P2_D: "Token quantity",
  T_48_META_API_3500_P3_D: "Success or not",
  T_48_META_API_3501_D: "Add token data to the player",
  T_48_META_API_3501_P0_D: "Target Player",
  T_48_META_API_3501_P1_D: "TokenID",
  T_48_META_API_3501_P2_D: "Token quantity",
  T_48_META_API_3501_P3_D: "Whether the primitive is successfully called",
  T_48_META_API_3502_D: "Consume target player token",
  T_48_META_API_3502_P0_D: "Target Player",
  T_48_META_API_3502_P1_D: "TokenID",
  T_48_META_API_3502_P2_D: "Token quantity",
  T_48_META_API_3502_P3_D: "Whether the block is successfully invoked",
  T_48_META_API_3503_D: "Add a token at the specified location",
  T_48_META_API_3503_P0_D: "Location",
  T_48_META_API_3503_P1_D: "TokenID",
  T_48_META_API_3503_P2_D: "Token quantity",
  T_48_META_API_3503_P3_D: "Whether the block is successfully invoked",
  T_48_META_API_3504_D: "Target AI releases certain skill",
  T_48_META_API_3504_P0_D: "Target AI",
  T_48_META_API_3504_P1_D: "Skill",
  T_48_META_API_3504_P2_D: "Skill Target",
  T_48_META_API_3504_P3_D: "Whether the skill is released successfully",
  T_48_META_API_3505_D: "Create a path from the start point to the end point, will avoid obstacles, and can be used for AI pathfinding",
  T_48_META_API_3505_P0_D: "Starting point coordinate",
  T_48_META_API_3505_P1_D: "End point coordinate",
  T_48_META_API_3505_P2_D: "Whether the pathfinding path is successfully established",
  T_48_META_API_3505_P3_D: "Path point collection",
  T_48_META_API_3506_D: "Set the behavior tree blackboard variable",
  T_48_META_API_3506_P0_D: "Target Behavior Tree",
  T_48_META_API_3506_P1_D: "Variable name",
  T_48_META_API_3506_P2_D: "Variable value",
  T_48_META_API_3507_D: "Get the behavior tree blackboard variable",
  T_48_META_API_3507_P0_D: "Target Behavior Tree",
  T_48_META_API_3507_P1_D: "Variable name",
  T_48_META_API_3507_P2_D: "Variable value",
  T_48_META_API_3508_D: "Get the behavior tree node parameter",
  T_48_META_API_3508_P0_D: "Target Behavior Tree Node",
  T_48_META_API_3508_P1_D: "Parameter name",
  T_48_META_API_3508_P2_D: "Parameter value",
  T_48_META_API_3509_D: "Get the target player's vehicle skin",
  T_48_META_API_3509_P0_D: "Target Player",
  T_48_META_API_3509_P1_D: "Vehicle ID",
  T_48_META_API_3509_R_D: "Vehicle Skin",
  T_48_META_API_3510_D: "Set the target player's vehicle skin",
  T_48_META_API_3510_P0_D: "Target Player",
  T_48_META_API_3510_P1_D: "Vehicle Skin ID",
  T_48_META_API_3511_D: "Clear the skin of the target player's specified vehicle",
  T_48_META_API_3511_P0_D: "Target Player",
  T_48_META_API_3511_P1_D: "Vehicle ID",
  T_48_META_API_3512_D: "Restore the target player's default vehicle skin",
  T_48_META_API_3512_P0_D: "Target Player",
  T_48_META_API_3512_P1_D: "Vehicle ID",
  T_48_META_API_36_D: "Sleep target, only available for Dynamic type rigid body",
  T_48_META_API_36_P0_D: "Target Rigidbody",
  T_48_META_API_37_D: "Wake up the target, only available for Dynamic type rigid bodies",
  T_48_META_API_37_P0_D: "Target Rigidbody",
  T_48_META_API_38_D: "Check if the target rigidbody is in sleep state",
  T_48_META_API_38_P0_D: "Target Rigidbody",
  T_48_META_API_38_R_D: "Is in sleep state or not",
  T_48_META_API_39_D: "Setting the sleep threshold",
  T_48_META_API_39_P0_D: "Target Rigidbody",
  T_48_META_API_39_P1_D: "Sleep threshold. When the movement and rotation of a rigid body are less than this value for a period of time, it will enter a sleep state. The rigid body in sleep state will no longer perform physical calculations.",
  T_48_META_API_4_D: "Sets whether all players can move",
  T_48_META_API_4_P0_D: `True: Can be moved
False: Cannot be moved`,
  T_48_META_API_40_D: "Get the sleep threshold",
  T_48_META_API_40_P0_D: "Target Rigidbody",
  T_48_META_API_40_R_D: "Sleep threshold. When the movement and rotation of a rigid body are less than this value for a period of time, it will enter a sleep state. The rigid body in sleep state will no longer perform physical calculations.",
  T_48_META_API_4000_D: "Read the contents of the entire table and return a two-dimensional array in row order",
  T_48_META_API_4000_P0_D: "Table name",
  T_48_META_API_4000_R_D: "Table of Contents",
  T_48_META_API_4001_D: "Read a row of the table and return an array",
  T_48_META_API_4001_P0_D: "Table name",
  T_48_META_API_4001_P1_D: "The number of the line to read, starting from 1",
  T_48_META_API_4001_R_D: "Specifies the contents of a row in the table",
  T_48_META_API_4002_D: "Read the contents of a column in a table and return an array",
  T_48_META_API_4002_P0_D: "Table name",
  T_48_META_API_4002_P1_D: "The number of the column to read, starting from 1",
  T_48_META_API_4002_R_D: "Specifies the contents of a column in the table",
  T_48_META_API_4003_D: "Read the content of a table cell",
  T_48_META_API_4003_P0_D: "Table name",
  T_48_META_API_4003_P1_D: "The number of the line to read, starting from 1",
  T_48_META_API_4003_P2_D: "The number of the column to read, starting from 1",
  T_48_META_API_4003_R_D: "The content of the specified cell of the table",
  T_48_META_API_4004_D: "Read the content of a cell in a table by row number and column name",
  T_48_META_API_4004_P0_D: "Table name",
  T_48_META_API_4004_P1_D: "The number of lines to read, starting from 1",
  T_48_META_API_4004_P2_D: "The name of the column to read",
  T_48_META_API_4004_R_D: "The contents of the specified cell of the table",
  T_48_META_API_4005_D: "Read the contents of the entire table and return a two-dimensional array",
  T_48_META_API_4005_P0_D: "Table name",
  T_48_META_API_4005_R_D: "The contents of the table, a two-dimensional array",
  T_48_META_API_4006_D: "Read a row of the entire table and return an array",
  T_48_META_API_4006_P0_D: "Table name",
  T_48_META_API_4006_P1_D: "The number of the line to read, starting from 1",
  T_48_META_API_4006_R_D: "A table specifies the content of a row, in an array",
  T_48_META_API_4007_D: "Read the contents of a column in the entire table and return an array",
  T_48_META_API_4007_P0_D: "Table name",
  T_48_META_API_4007_P1_D: "The number of the column to read, starting from 1",
  T_48_META_API_4007_R_D: "table specifies the content of a column, in an array",
  T_48_META_API_4008_D: "Read the contents of a table cell",
  T_48_META_API_4008_P0_D: "Table name",
  T_48_META_API_4008_P1_D: "The number of the line to read, starting from 1",
  T_48_META_API_4008_P2_D: "The number of the column to read, starting from 1",
  T_48_META_API_4008_R_D: "The contents of the specified cell of the table",
  T_48_META_API_4009_D: "Find the specified row by column number and cell value",
  T_48_META_API_4009_P0_D: "Table name",
  T_48_META_API_4009_P1_D: "The number of columns to read",
  T_48_META_API_4009_P2_D: "The cell value to be searched",
  T_48_META_API_4009_R_D: "The contents of the found row, in array",
  T_48_META_API_4010_D: "Get column number by column name",
  T_48_META_API_4010_P0_D: "Table name",
  T_48_META_API_4010_P1_D: "The name of the column to be queried",
  T_48_META_API_4010_R_D: "The number of columns, starting from 1",
  T_48_META_API_41_D: "Set the global sleep threshold, which is only valid for newly generated Dynamic rigid bodies.",
  T_48_META_API_41_P0_D: "Sleep threshold. When the movement and rotation of a rigid body are less than this value for a period of time, it will enter a sleep state. The rigid body in sleep state will no longer perform physical calculations.",
  T_48_META_API_42_D: "Get the global sleep threshold",
  T_48_META_API_42_R_D: "The sleep threshold is 0.005 by default. When the rigid body's movement and rotation are less than this value for a period of time, it will enter the sleep state. The rigid body in the sleep state will no longer perform physical calculations.",
  T_48_META_API_43_D: "Convert the given quaternion to Euler angles. The rotation order of Euler angles is YXZ. If the passed quaternion is illegal, return (0,0,0)",
  T_48_META_API_43_P0_D: "Input quaternion",
  T_48_META_API_43_R_D: "The returned Euler angles",
  T_48_META_API_44_D: "Converts the given Euler angle to a quaternion",
  T_48_META_API_44_P0_D: "Input Euler angles",
  T_48_META_API_44_R_D: "The returned quaternion",
  T_48_META_API_45_D: "Convert axis-angle rotation to quaternion",
  T_48_META_API_45_P0_D: "Rotation axis",
  T_48_META_API_45_P1_D: "Angle of rotation clockwise around the axis of rotation",
  T_48_META_API_45_R_D: "The returned quaternion",
  T_48_META_API_46_D: "Convert quaternion to axis-angle representation",
  T_48_META_API_46_P0_D: "Input quaternion",
  T_48_META_API_46_P1_D: "Rotation axis",
  T_48_META_API_46_P2_D: "Angle of rotation clockwise around the axis of rotation",
  T_48_META_API_47_D: "Set custom task completion progress",
  T_48_META_API_47_P0_D: "Target Player",
  T_48_META_API_47_P1_D: "Task ID",
  T_48_META_API_47_P2_D: "Completion progress, negative numbers are not allowed",
  T_48_META_API_48_D: "Creates a Bezier curve that can be used to interpolate motion",
  T_48_META_API_48_P0_D: "Curve Control Points",
  T_48_META_API_48_R_D: "Bezier curve",
  T_48_META_API_49_D: "Get the scene map ID",
  T_48_META_API_49_P0_D: "Scene ID",
  T_48_META_API_49_R_D: "Map ID",
  T_48_META_API_5_D: "Delete the placed objects in the scene (deprecated, please use DeleteEntity)",
  T_48_META_API_5_P0_D: "Object entity to be deleted",
  T_48_META_API_50_D: "Creates relative motion per frame. The target entity changes its own attributes once per frame, each time relative to its current attribute value.",
  T_48_META_API_50_P0_D: "Target Entity",
  T_48_META_API_50_P1_D: "Attributes that need to be moved",
  T_48_META_API_50_P2_D: "The amount of change per movement",
  T_48_META_API_50_P3_D: `Configuration when used in combination with other motion modes
True: Can be used in combination with relative motion
False: Can be used in combination with absolute motion`,
  T_48_META_API_50_P4_D: "Created entitiy with motion relative to their own per frame.",
  T_48_META_API_50_P5_D: "Whether to automatically start playing after creation",
  T_48_META_API_5000_D: "Read the value corresponding to a key in a table in the database",
  T_48_META_API_5000_P0_D: "Table name in the database",
  T_48_META_API_5000_P1_D: "Tagging players and handling concurrency",
  T_48_META_API_5000_P2_D: "A custom name to identify the data",
  T_48_META_API_5000_P3_D: "Returns the read result",
  T_48_META_API_5000_P4_D: "Battlefield code corresponding to the database",
  T_48_META_API_5001_D: "Write the value corresponding to a key in a table in the database",
  T_48_META_API_5001_P0_D: "Table name in the database",
  T_48_META_API_5001_P1_D: "Tagging players and handling concurrency",
  T_48_META_API_5001_P2_D: "A custom name to identify the data",
  T_48_META_API_5001_P3_D: "The value written",
  T_48_META_API_5001_P4_D: "The battlefield code corresponding to the database, which can be filled in blanks, represents the battlefield code of the current map",
  T_48_META_API_5002_D: "Delete the value corresponding to a key in a table in the database",
  T_48_META_API_5002_P0_D: "Table name in the database",
  T_48_META_API_5002_P1_D: "Tagging players and handling concurrency",
  T_48_META_API_5002_P2_D: "A custom name to identify the data",
  T_48_META_API_5002_P3_D: "Battlefield code corresponding to the database",
  T_48_META_API_5003_D: "Read the value corresponding to a key in a ranking table in the database",
  T_48_META_API_5003_P0_D: "The name of the ranking table in the database",
  T_48_META_API_5003_P1_D: "A custom name to identify the data",
  T_48_META_API_5003_P2_D: "Returns the read result",
  T_48_META_API_5003_P3_D: "Battlefield code corresponding to the database",
  T_48_META_API_5004_D: "Write the value corresponding to a key in a ranking table in the database",
  T_48_META_API_5004_P0_D: "The name of the ranking table in the database",
  T_48_META_API_5004_P1_D: "A custom name to identify the data",
  T_48_META_API_5004_P2_D: "The value written",
  T_48_META_API_5004_P3_D: "Battlefield code corresponding to the database",
  T_48_META_API_5005_D: "Delete the value corresponding to a key in a ranking table in the database",
  T_48_META_API_5005_P0_D: "Table name in the database",
  T_48_META_API_5005_P1_D: "A custom name to identify the data",
  T_48_META_API_5005_P2_D: "Battlefield code corresponding to the database",
  T_48_META_API_5006_D: "Delete the value corresponding to a certain rank in a ranking table in the database",
  T_48_META_API_5006_P0_D: "Table name in the database",
  T_48_META_API_5006_P1_D: "Ranking in the leaderboard",
  T_48_META_API_5006_P2_D: "Battlefield code corresponding to the database",
  T_48_META_API_5007_D: "Read the values from a certain ranking to a certain ranking in a ranking table in the database",
  T_48_META_API_5007_P0_D: "Table name in the database",
  T_48_META_API_5007_P1_D: "Starting position",
  T_48_META_API_5007_P2_D: "Ending position",
  T_48_META_API_5007_P3_D: "Returns the read result",
  T_48_META_API_5007_P4_D: "Battlefield code corresponding to the database",
  T_48_META_API_5008_D: "Read the value corresponding to a key in a table in the cumulative database",
  T_48_META_API_5008_P0_D: "Table name in the database",
  T_48_META_API_5008_P1_D: "A custom name to identify the data",
  T_48_META_API_5008_P2_D: "Returns the read result",
  T_48_META_API_5008_P3_D: "Battlefield code corresponding to the database",
  T_48_META_API_5009_D: "Write the offset value corresponding to a key in a table in the cumulative database",
  T_48_META_API_5009_P0_D: "Table name in the database",
  T_48_META_API_5009_P1_D: "A custom name to identify the data",
  T_48_META_API_5009_P2_D: "The types of arithmetic operations currently support the following types: Int type supports addition, subtraction, multiplication, division, and remainder; Float type supports addition, subtraction, multiplication, and division",
  T_48_META_API_5009_P3_D: "The offset value written",
  T_48_META_API_5009_P4_D: "Battlefield code corresponding to the database",
  T_48_META_API_51_D: "Reset the playable entity to restore the playable entity to its initial state.This will not change the playback state",
  T_48_META_API_51_P0_D: "Target Playable Entity",
  T_48_META_API_52_D: "Multiply two quaternions. A*B means rotating A first and then rotating B. Different rotation orders will result in different results.",
  T_48_META_API_52_P0_D: "Lvalue quaternion",
  T_48_META_API_52_P1_D: "Rvalue quaternion",
  T_48_META_API_52_R_D: "The resulting quaternion",
  T_48_META_API_53_D: "Creates a rotation quaternion facing the specified direction",
  T_48_META_API_53_P0_D: "Specify direction",
  T_48_META_API_53_P1_D: "Upward direction",
  T_48_META_API_53_R_D: "The amount of rotation required to align in the specified direction",
  T_48_META_API_54_D: "Quaternion spherical interpolation from A to B",
  T_48_META_API_54_P0_D: "A Value",
  T_48_META_API_54_P1_D: "B value",
  T_48_META_API_54_P2_D: "Interpolation progress, the value range is [0,1]. When the value is 0, it returns the A value, and when the value is 1, it returns the B value.",
  T_48_META_API_54_R_D: "The resulting quaternion",
  T_48_META_API_57_D: "Print the target content to the console as a warning",
  T_48_META_API_57_P0_D: "Content to be printed",
  T_48_META_API_58_D: "Print the target content to the console as an error",
  T_48_META_API_58_P0_D: "Content to be printed",
  T_48_META_API_59_D: "Get the value on the curve",
  T_48_META_API_59_P0_D: "curve",
  T_48_META_API_59_P1_D: "Sampling point, value range [0,1]",
  T_48_META_API_59_R_D: "Result",
  T_48_META_API_6_D: "Create scene object at the specified coordinate",
  T_48_META_API_6_P0_D: "Created scene object entity",
  T_48_META_API_6_P1_D: "The location where the object is spawned",
  T_48_META_API_6_P2_D: "The created object type ID. Need to be registered in the asset registry before using it in the code script.",
  T_48_META_API_60_D: "Interpolate according to the curve",
  T_48_META_API_60_P0_D: "Value Type",
  T_48_META_API_60_P1_D: "Starting value",
  T_48_META_API_60_P2_D: "Target value",
  T_48_META_API_60_P3_D: "curve",
  T_48_META_API_60_P4_D: "Sampling point, value range [0,1]",
  T_48_META_API_60_R_D: "Result",
  T_48_META_API_6000_D: "Add script to target entity",
  T_48_META_API_6000_P0_D: "Target Entity",
  T_48_META_API_6000_P1_D: "Script ID",
  T_48_META_API_6001_D: "Uninstall the script for the target entity",
  T_48_META_API_6001_P0_D: "Target Entity",
  T_48_META_API_6001_P1_D: "Script ID",
  T_48_META_API_6002_D: "Check if the specified script exists on the target entity",
  T_48_META_API_6002_P0_D: "Target Entity",
  T_48_META_API_6002_P1_D: "Script ID",
  T_48_META_API_6002_R_D: "The specified script exists or not",
  T_48_META_API_61_D: "Set the parent node of the UI widget",
  T_48_META_API_61_P0_D: "Parent node, you can specify UI widget or custom UI",
  T_48_META_API_61_P1_D: "Child Node",
  T_48_META_API_62_D: "Deprecated",
  T_48_META_API_62_P0_D: "Deprecated",
  T_48_META_API_62_P1_D: "Deprecated",
  T_48_META_API_62_P2_D: "Deprecated",
  T_48_META_API_62_P3_D: "Deprecated",
  T_48_META_API_62_P4_D: "Deprecated",
  T_48_META_API_63_D: "Creates a ray from the current camera to the touch point on the screen",
  T_48_META_API_63_P0_D: "Screen contacts",
  T_48_META_API_63_P1_D: "Starting point",
  T_48_META_API_63_P2_D: "Ray direction",
  T_48_META_API_64_D: "Upload custom settlement information",
  T_48_META_API_64_P0_D: "Player Entity",
  T_48_META_API_64_P1_D: "Result of the game",
  T_48_META_API_64_P2_D: "Points Title",
  T_48_META_API_64_P3_D: "Points",
  T_48_META_API_65_D: "Play the specified sound effect. If there are more properties that need to be set, you can set its entity properties.",
  T_48_META_API_65_P0_D: "Created sound entity",
  T_48_META_API_65_P1_D: "Target player, only the target player can hear the sound effect",
  T_48_META_API_65_P2_D: "Sound Effect Type",
  T_48_META_API_65_P3_D: "Loop type",
  T_48_META_API_65_P4_D: "Play immediately or not",
  T_48_META_API_66_D: "Create a specified visual effect. If there are more properties that need to be set, you can set its entity properties.",
  T_48_META_API_66_P0_D: "Created special effects entity",
  T_48_META_API_66_P1_D: "Target player, only visible to the target player",
  T_48_META_API_66_P2_D: "Effect type",
  T_48_META_API_66_P3_D: "Loop type",
  T_48_META_API_66_P4_D: "Play immediately",
  T_48_META_API_67_D: "Create a specified sound effect. If there are more properties that need to be set, you can set its entity properties.",
  T_48_META_API_67_P0_D: "Created sound entity",
  T_48_META_API_67_P1_D: "Sound Effect Type",
  T_48_META_API_67_P2_D: "Loop type",
  T_48_META_API_67_P3_D: "Play immediately",
  T_48_META_API_68_D: "Convert world coordinate to screen coordinate",
  T_48_META_API_68_P0_D: "World Coordinates",
  T_48_META_API_68_P1_D: "mapping on the screen or not",
  T_48_META_API_68_P2_D: "Mapping location",
  T_48_META_API_69_D: "Convert screen coordinate to world coordinate",
  T_48_META_API_69_P0_D: "Screen coordinate",
  T_48_META_API_69_P1_D: "Distance from screen",
  T_48_META_API_69_P2_D: "World Coordinate",
  T_48_META_API_7_D: "Convert the target value to a string",
  T_48_META_API_7_P0_D: "The target value to convert to string",
  T_48_META_API_7_R_D: "String",
  T_48_META_API_70_D: "Perform ray detection through screen touch and return the first entity hit",
  T_48_META_API_70_P0_D: "Start screen touch point",
  T_48_META_API_70_P1_D: "Detection distance",
  T_48_META_API_70_P2_D: "Layer mask, only the filled layers will participate in the scan, leaving it blank means all layers will participate in the scan",
  T_48_META_API_70_P3_D: "Whether the trigger can be detected",
  T_48_META_API_70_P4_D: "Entity hit",
  T_48_META_API_70_P5_D: "Hit point coordinate",
  T_48_META_API_70_P6_D: "Distance from hit point to start point",
  T_48_META_API_70_P7_D: "Hit Surface Normal",
  T_48_META_API_71_D: "Perform ray detection through screen touch and return all hit entities",
  T_48_META_API_71_P0_D: "Start screen touch point",
  T_48_META_API_71_P1_D: "Detection distance",
  T_48_META_API_71_P2_D: "Layer mask, only the filled layers will participate in the scan, leaving it blank means all layers will participate in the scan",
  T_48_META_API_71_P3_D: "Whether the trigger can be detected",
  T_48_META_API_71_P4_D: "List of entities hit",
  T_48_META_API_71_P5_D: "Hit point coordinate list",
  T_48_META_API_71_P6_D: "List of distances between the hit point and the start point",
  T_48_META_API_71_P7_D: "List of hit surface normals",
  T_48_META_API_72_D: "Create a specified visual effect. If there are more properties that need to be set, you can set its entity properties.",
  T_48_META_API_72_P0_D: "Created special effect entity",
  T_48_META_API_72_P1_D: "Effect Type",
  T_48_META_API_72_P2_D: "Loop type",
  T_48_META_API_72_P3_D: "Play immediately",
  T_48_META_API_73_D: "Create a built-in UI that will not be synchronized to other clients",
  T_48_META_API_73_P0_D: "Built-in UI entity created",
  T_48_META_API_73_P1_D: "Built-in UI type",
  T_48_META_API_74_D: "Create a custom UI that will not be synchronized to other clients",
  T_48_META_API_74_P0_D: "Created custom UI entity",
  T_48_META_API_74_P1_D: "Custom UI Index",
  T_48_META_API_75_D: "Get the current client's corresponding player",
  T_48_META_API_75_R_D: "Player Entity",
  T_48_META_API_76_D: "Creating an AI Monster",
  T_48_META_API_76_P0_D: "Target AI",
  T_48_META_API_76_P1_D: "Create a location",
  T_48_META_API_76_P2_D: "AI Types",
  T_48_META_API_76_P3_D: "Team",
  T_48_META_API_76_P4_D: "Whether to automatically search for enemies",
  T_48_META_API_76_P5_D: "Attack Mode",
  T_48_META_API_76_P6_D: "Travel path",
  T_48_META_API_77_D: "Set the first component of a vector",
  T_48_META_API_77_P0_D: "Vector",
  T_48_META_API_77_P1_D: "The first component value",
  T_48_META_API_77_R_D: "The vector after modifying the first component",
  T_48_META_API_78_D: "Set the second component of a vector",
  T_48_META_API_78_P0_D: "Vector",
  T_48_META_API_78_P1_D: "The second component value",
  T_48_META_API_78_R_D: "The vector after modifying the second component",
  T_48_META_API_79_D: "Set the third component of a vector",
  T_48_META_API_79_P0_D: "Vector",
  T_48_META_API_79_P1_D: "The third component value",
  T_48_META_API_79_R_D: "The vector after modifying the third component",
  T_48_META_API_8_D: "When turned on, the safety zone will shrink to the center coordinate point",
  T_48_META_API_8_P0_D: "The center of the safety zone",
  T_48_META_API_8_P1_D: "Radius of the safe zone",
  T_48_META_API_8_P2_D: "Waiting time, in seconds. After the end, the safe zone will begin to shrink towards the center point",
  T_48_META_API_8_P3_D: "The time required for the safety zone to shrink to the center point, in seconds",
  T_48_META_API_8_P4_D: "The amount of damage per second taken outside the safe zone",
  T_48_META_API_80_D: "Set the first component of a 2D vector",
  T_48_META_API_80_P0_D: "2D vector",
  T_48_META_API_80_P1_D: "The first component value",
  T_48_META_API_80_R_D: "Two-dimensional vector after modifying the first component",
  T_48_META_API_81_D: "Set the second component of a two-dimensional vector",
  T_48_META_API_81_P0_D: "2D vector",
  T_48_META_API_81_P1_D: "The second component value",
  T_48_META_API_81_R_D: "Two-dimensional vector after modifying the second component",
  T_48_META_API_82_D: "Move the character controller to the specified position. If it acts on the player,the player must turn on the physical CCT for it to take effect.",
  T_48_META_API_82_P0_D: "Target Character Controller",
  T_48_META_API_82_P1_D: "Specify location",
  T_48_META_API_83_D: "Get the specified child node of the target parent node entity by name",
  T_48_META_API_83_P0_D: "Parent node entity",
  T_48_META_API_83_P1_D: "Child node name",
  T_48_META_API_83_R_D: "Child node entity",
  T_48_META_API_84_D: "Added AOI special attention, always synchronized regardless of distance",
  T_48_META_API_84_P0_D: "Target of special concern",
  T_48_META_API_84_P1_D: "Observer",
  T_48_META_API_85_D: "Remove AOI special attention and cancel AOI synchronization outside line of sight",
  T_48_META_API_85_P0_D: "Targets of special concern",
  T_48_META_API_85_P1_D: "Observer",
  T_48_META_API_86_D: "Clear all AOIs of the specified target.",
  T_48_META_API_86_P0_D: "Target of special concern",
  T_48_META_API_87_D: "Determine whether there is AOI of special concern",
  T_48_META_API_87_P0_D: "Target of special concern",
  T_48_META_API_87_P1_D: "Deprecated",
  T_48_META_API_87_R_D: "Exist or not",
  T_48_META_API_88_D: "Toggle the player's proxy observer",
  T_48_META_API_88_P0_D: "Player",
  T_48_META_API_88_P1_D: "Proxy Observer",
  T_48_META_API_89_D: "Displace the character controller once. If it acts on the player,the player must turn on the physical CCT for it to take effect.",
  T_48_META_API_89_P0_D: "The target object, if it is a player, the player must turn on the physical CCT for this to take effect",
  T_48_META_API_89_P1_D: "Displacement Vector",
  T_48_META_API_9_D: "Turn off the safe zone mechanism. When the safe zone is minimized, players outside the safe zone will continue to take damage. After turning off the safe zone mechanism, players will be safe again.",
  T_48_META_API_90_D: "Set whether the player can exit freely",
  T_48_META_API_90_P0_D: "Target Player",
  T_48_META_API_90_P1_D: "Can or cannot exit freely",
  T_48_META_API_9000_D: "Create a built-in UI that only the specified player can see",
  T_48_META_API_9000_P0_D: "Built-in UI entity created",
  T_48_META_API_9000_P1_D: "The player entity to which the UI belongs, The UI is only visible to that player",
  T_48_META_API_9000_P2_D: "Built-in UI type",
  T_48_META_API_9001_D: "Remove built-in UI",
  T_48_META_API_9001_P0_D: "Built-in UI entity to remove",
  T_48_META_API_9002_D: "Create an icon using the specified icon type. If there are more properties to set, further set its entity properties through the entity (deprecated, please use CreateLevelObject)",
  T_48_META_API_9002_P0_D: "The name of the parameter used to create the icon entity in the code, and its corresponding local variable value is the entity that creates the icon",
  T_48_META_API_9002_P1_D: "The player entity it belongs to, only visible to that player",
  T_48_META_API_9002_P2_D: "Resource path, the resource path corresponding to the icon selected by the player",
  T_48_META_API_9003_D: "Remove the specified icon (deprecated, please use DeleteEntity)",
  T_48_META_API_9003_P0_D: "The icon entity to remove",
  T_48_META_API_9004_D: "Create a text with the specified text content. If there are more properties to be set, further set its entity properties through the entity (deprecated, please use CreateLevelObject)",
  T_48_META_API_9004_P0_D: "The code is used to indicate the name of the parameter for creating a text entity. The corresponding local variable value is the entity for creating the text.",
  T_48_META_API_9004_P1_D: "The player entity it belongs to, only visible to that player",
  T_48_META_API_9004_P2_D: "The text content that needs to be presented",
  T_48_META_API_9005_D: "Remove the specified text (deprecated, please use DeleteEntity)",
  T_48_META_API_9005_P0_D: "The text entity to remove",
  T_48_META_API_9006_D: "Create an icon using the specified effect type. If there are more properties to set, further set its entity properties through the entity (deprecated, please use CreateEffect)",
  T_48_META_API_9006_P0_D: "In the code, it is used to indicate the name of the parameter for creating a special effect entity. The corresponding local variable value is the entity that creates the special effect.",
  T_48_META_API_9006_P1_D: "The player entity it belongs to, only visible to that player",
  T_48_META_API_9006_P2_D: "Special effect type, the type of special effect that players can choose",
  T_48_META_API_9007_D: "Remove the specified effect (deprecated, please use DeleteEntity)",
  T_48_META_API_9007_P0_D: "The effect entity to remove",
  T_48_META_API_9008_D: "Create a custom UI that only the specified player can see",
  T_48_META_API_9008_P0_D: "Created custom UI entity",
  T_48_META_API_9008_P1_D: "The player entity to which the UI belongs. The UI is only visible to that player",
  T_48_META_API_9008_P2_D: "Custom UI Index",
  T_48_META_API_9009_D: "Removed custom game UI",
  T_48_META_API_9009_P0_D: "The custom UI entity to remove",
  T_48_META_API_9010_D: "Get UI widget from custom UI",
  T_48_META_API_9010_P0_D: "The player entity to which the UI belongs",
  T_48_META_API_9010_P1_D: "Custom UI Entities",
  T_48_META_API_9010_P2_D: "Widget unique index",
  T_48_META_API_9010_R_D: "UI Widget Entity",
  T_48_META_API_9011_D: "Play the specified sound effect. If there are more properties to set, further set its entity properties through the entity (deprecated, please use CreateSound)",
  T_48_META_API_9011_P0_D: "In the code, it is used to indicate the name of the parameter for creating a sound effect entity. The corresponding local variable value is the entity that creates the sound effect.",
  T_48_META_API_9011_P1_D: "The player entity it belongs to, only visible to that player",
  T_48_META_API_9011_P2_D: "Sound effect type, the type of sound effect that players can choose",
  T_48_META_API_9012_D: "Remove the specified sound effect (deprecated, please use DeleteEntity)",
  T_48_META_API_9012_P0_D: "The sound entity to remove",
  T_48_META_API_9013_D: "Get a UI widget from a custom UI using a path",
  T_48_META_API_9013_P0_D: "The player entity to which the UI belongs",
  T_48_META_API_9013_P1_D: "Custom UI",
  T_48_META_API_9013_P2_D: "Widget Path",
  T_48_META_API_9013_R_D: "UI Widget Entity",
  T_48_META_API_9014_D: "Interrupt the playing sound entity (deprecated, please use PauseSound)",
  T_48_META_API_9014_P0_D: "The sound entity that needs to be paused",
  T_48_META_API_9015_D: "Continue playing the sound effect, you can choose whether to play it from the beginning (deprecated, please use ResumeSound)",
  T_48_META_API_9015_P0_D: "The sound effect entity that needs to continue playing after being paused",
  T_48_META_API_9015_P1_D: "Start from scratch",
  T_48_META_API_9016_D: "Creating Custom UI Widget",
  T_48_META_API_9016_P0_D: "Created Custom Widget Entity",
  T_48_META_API_9016_P1_D: "The type of control created",
  T_48_META_API_9016_P2_D: "UI entity",
  T_48_META_API_9016_P3_D: "The parent control. If not filled, the UI entity will be the parent node.",
  T_48_META_API_9017_D: "Set the target camera layer mask",
  T_48_META_API_9017_P0_D: "Target Camera Entity",
  T_48_META_API_9017_P1_D: "Layer mask, only filled layers will be displayed in the target camera, leaving it blank means all layers will be displayed",
  T_48_META_API_9018_D: "Get the target camera layer mask",
  T_48_META_API_9018_P0_D: "Target Camera Entity",
  T_48_META_API_9018_R_D: "Layer mask, only the layers within the layer mask will be displayed in the target camera",
  T_48_META_API_9019_D: "Set whether the specified layer is visible to the target camera.",
  T_48_META_API_9019_P0_D: "Target Camera Entity",
  T_48_META_API_9019_P1_D: "Visibility Level",
  T_48_META_API_9019_P2_D: "Is Visible",
  T_48_META_API_9020_D: "Set the target player's default interface visibility",
  T_48_META_API_9020_P0_D: "Target Player",
  T_48_META_API_9020_P1_D: "Player interface type. Player interface type is the UI element used to control players and player-related content.",
  T_48_META_API_9020_P2_D: "Switch value, determines the visibility of the player interface",
  T_48_META_API_9021_D: "Create a timestamp localized string",
  T_48_META_API_9021_P0_D: "Timestamp",
  T_48_META_API_9021_P1_D: "Formatting Style",
  T_48_META_API_9021_R_D: "Timestamp localization string",
  T_48_META_API_9022_D: "Creating a Minimap Icon",
  T_48_META_API_9022_P0_D: "The minimap icon entity created",
  T_48_META_API_9022_P1_D: "The Player, the static pixel created is only visible to this player",
  T_48_META_API_9022_P2_D: "Small map icon resource path",
  T_48_META_API_9023_D: "Create an icon using the specified special effect type. If there are more properties that need to be set, further set its entity properties through the entity.",
  T_48_META_API_9023_P0_D: "In the code, it is used to indicate the name of the parameter for creating a special effect entity. The corresponding local variable value is the entity that creates the special effect.",
  T_48_META_API_9023_P1_D: "The player entity it belongs to, only visible to that player",
  T_48_META_API_9023_P2_D: "Special effect type, the type of special effect that players can choose",
  T_48_META_API_9024_D: "Remove the specified effect (deprecated, please use DeleteEntity)",
  T_48_META_API_9024_P0_D: "The effect entity to remove",
  T_48_META_API_9025_D: "Create a static pixel on the map for the target object. The static pixel will not move with the target object.",
  T_48_META_API_9025_P0_D: "Static pixel entity created",
  T_48_META_API_9025_P1_D: "The Player, the static pixel created is only visible to this player",
  T_48_META_API_9025_P2_D: "Target object entity",
  T_48_META_API_9026_D: "Get the target player's minimap entity",
  T_48_META_API_9026_P0_D: "Target Player",
  T_48_META_API_9026_R_D: "Current player’s mini-map",
  T_48_META_API_9027_D: "Set the player's fall damage, and set different damage according to the height segment",
  T_48_META_API_9027_P0_D: "Target Player",
  T_48_META_API_9027_P1_D: "Height Segment List",
  T_48_META_API_9027_P2_D: "Damage Segment list",
  T_48_META_API_91_D: "Making the target join the specified team, this will cause the target to leave the original team",
  T_48_META_API_91_P0_D: "Target to join the team",
  T_48_META_API_91_P1_D: "The team Joined",
  T_48_META_API_91_P2_D: "Success or not",
  T_48_META_API_92_D: "Making the target join a new team,this will cause the target to leave the original team",
  T_48_META_API_92_P0_D: "Target to join the team",
  T_48_META_API_92_P1_D: "New team‘s name",
  T_48_META_API_92_P2_D: "Success or not",
  T_48_META_API_94_D: "Set the value of a local variable by index; before setting, the variable must be defined in the current call process ",
  T_48_META_API_94_P0: "Index",
  T_48_META_API_94_P0_D: "Get a variable by index ",
  T_48_META_API_94_P1: "Variable Value",
  T_48_META_API_94_P1_D: "Target variable value ",
  T_48_META_API_94_P2: "Arithmetic Type",
  T_48_META_API_94_P2_D: "Operation method; all types support assignment, and numeric types also support increment, decrement, multiplication, division, and modulus operations ",
  T_48_META_API_94_P3: "Variable Name",
  T_48_META_API_94_P3_D: "Target variable name. Used only for error output ",
  T_48_META_API_95: "Get Local Variable by Index",
  T_48_META_API_95_D: "Get the value of a local variable; before getting, the variable must be defined in the current call process ",
  T_48_META_API_95_P0: "Index",
  T_48_META_API_95_P0_D: "Variable index ",
  T_48_META_API_95_P1: "Variable Name",
  T_48_META_API_95_P1_D: "Target variable name. Used only for error output ",
  T_48_META_API_9500_D: "Notify the target player's client to play SFX",
  T_48_META_API_9500_P0_D: "Target Player",
  T_48_META_API_9500_P1_D: "SFX resource path",
  T_48_META_API_9500_P2_D: "Color",
  T_48_META_API_9500_P3_D: "Zoom size, default is 1",
  T_48_META_API_9500_P4_D: "Bind the object, the effect will be attached as its child node",
  T_48_META_API_9500_P5_D: "World coordinate offset relative to the bound object",
  T_48_META_API_9501_D: "Notify the target player's client to play the sound effect",
  T_48_META_API_9501_P0_D: "Target Player",
  T_48_META_API_9501_P1_D: "Sound Effect Type",
  T_48_META_API_9502_D: "Notify the target player's client to display Pop-up text",
  T_48_META_API_9502_P0_D: "Target Player",
  T_48_META_API_9502_P1_D: "Pop-up content",
  T_48_META_API_9502_P2_D: "Pop-up color, type is Color",
  T_48_META_API_9502_P3_D: "The duration of pop-up, in milliseconds",
  T_48_META_API_9503_D: "Makes the target unit play an Emote action expression",
  T_48_META_API_9503_P0_D: "Play Emote's target",
  T_48_META_API_9503_P1_D: "Emote Type",
  T_48_META_API_9504_D: "Pause/resume unit's Emote",
  T_48_META_API_9504_P0_D: "Pause/resume Emote's target",
  T_48_META_API_9504_P1_D: "True: Pause playback, False: Resume playback",
  T_48_META_EVT_1_D: "Triggered when the game starts, the server will be ready some time earlier than the client",
  T_48_META_EVT_10_D: "Triggered before the current entity takes damage.",
  T_48_META_EVT_10_P0_D: "The attacker entity, can be null",
  T_48_META_EVT_10_P1_D: "Damage Type",
  T_48_META_EVT_10_P2_D: "Amount of damage caused",
  T_48_META_EVT_10_P3_D: "Hit Body Part",
  T_48_META_EVT_1000_D: "Triggered when the player's score changes",
  T_48_META_EVT_1000_P0_D: "Players with changing points",
  T_48_META_EVT_1000_P1_D: "Types of change integrals",
  T_48_META_EVT_1000_P2_D: "The integral value after the integral changes",
  T_48_META_EVT_1001_D: "Triggered when the team score changes",
  T_48_META_EVT_1001_P0_D: "Teams with changing points",
  T_48_META_EVT_1001_P1_D: "Types of change integrals",
  T_48_META_EVT_1001_P2_D: "The integral value after the integral changes",
  T_48_META_EVT_1002_D: "Fired when a player's rank changes",
  T_48_META_EVT_1002_P0_D: "Players with changing rankings",
  T_48_META_EVT_1002_P1_D: "Ranking after change",
  T_48_META_EVT_1003_D: "Deprecated",
  T_48_META_EVT_1003_P0_D: "Deprecated",
  T_48_META_EVT_1003_P1_D: "Ranking after change",
  T_48_META_EVT_11_D: "Triggered when a player quits midway",
  T_48_META_EVT_11_P0_D: "The player who quit midway",
  T_48_META_EVT_12_D: "Triggered when the player controller touches an entity. This is only triggered when the controller actively moves.",
  T_48_META_EVT_12_P0_D: "Entities encountered",
  T_48_META_EVT_13_D: "Triggered before the current entity deals damage",
  T_48_META_EVT_13_P0_D: "Entity taking damage",
  T_48_META_EVT_13_P1_D: "Damage Type",
  T_48_META_EVT_13_P2_D: "Amount of damage caused",
  T_48_META_EVT_13_P3_D: "Hit Body Part",
  T_48_META_EVT_14_D: "Triggered each time the playable entity loops. This event only takes effect on the client side when the playable entity is a sound effect, special effect, etc.",
  T_48_META_EVT_2_D: "Triggered when a logic frame is updated. The frequency of this event triggering will vary depending on the platform and settings.",
  T_48_META_EVT_2002_D: "Triggered when a player dies",
  T_48_META_EVT_2002_P0_D: "Dead Player",
  T_48_META_EVT_2003_D: "Triggered when a player assists",
  T_48_META_EVT_2003_P0_D: "Player who received assists",
  T_48_META_EVT_2003_P1_D: "Player killed",
  T_48_META_EVT_2004_D: "Triggered when a player deals damage",
  T_48_META_EVT_2004_P0_D: "The player who caused the damage",
  T_48_META_EVT_2004_P1_D: "Player who received damage",
  T_48_META_EVT_2004_P2_D: "Damage Type",
  T_48_META_EVT_2004_P3_D: "Damage",
  T_48_META_EVT_2004_P4_D: "Hit Body Part",
  T_48_META_EVT_2005_D: "Triggered when a player causes a kill",
  T_48_META_EVT_2005_P0_D: "The player who caused the kill",
  T_48_META_EVT_2005_P1_D: "Player killed",
  T_48_META_EVT_2005_P2_D: "Damage Type",
  T_48_META_EVT_2006_D: "Triggered when a player joins the game",
  T_48_META_EVT_2006_P0_D: "Player who joins the game",
  T_48_META_EVT_2007_D: "Triggered when a player is respwaned",
  T_48_META_EVT_2007_P0_D: "Respwaned Player",
  T_48_META_EVT_2007_P1_D: "Respwan Source",
  T_48_META_EVT_2008_D: "Triggered when a player is knocked down",
  T_48_META_EVT_2008_P0_D: "Knocked down player",
  T_48_META_EVT_2008_P1_D: "The attacking player",
  T_48_META_EVT_2009_D: "Triggered when a player disconnects",
  T_48_META_EVT_2009_P0_D: "Disconnected Player",
  T_48_META_EVT_2010_D: "Triggered when a player reconnects",
  T_48_META_EVT_2010_P0_D: "Reconnecting Player",
  T_48_META_EVT_2100_D: "Triggered when a team is removed",
  T_48_META_EVT_2100_P0_D: "Removed Team",
  T_48_META_EVT_2101_D: "Triggered when a team is added",
  T_48_META_EVT_2101_P0_D: "Added Team",
  T_48_META_EVT_2102_D: "Triggered when a team is aced",
  T_48_META_EVT_2102_P0_D: "The aced team",
  T_48_META_EVT_3_D: "Triggered at the end of the game. This event is triggered before the game ends on the server.",
  T_48_META_EVT_30_D: "Triggered when a scene is loaded successfully",
  T_48_META_EVT_30_P0_D: "Scene Name",
  T_48_META_EVT_3000_D: "Triggered after the current entity is created",
  T_48_META_EVT_3001_D: "Triggered before the current entity is destroyed.",
  T_48_META_EVT_3002_D: "Triggered when a player enters the trigger",
  T_48_META_EVT_3002_P0_D: "Player entering the trigger",
  T_48_META_EVT_3003_D: "Triggered when a player leaves the trigger",
  T_48_META_EVT_3003_P0_D: "Player leaving the trigger",
  T_48_META_EVT_3004_D: "Triggered after clicking the UI button control",
  T_48_META_EVT_3004_P0_D: "The player who clicks the UI button",
  T_48_META_EVT_3005_D: "Triggered when a button in the built-in UI is clicked",
  T_48_META_EVT_3005_P0_D: "The name of the button control that was clicked",
  T_48_META_EVT_3006_D: "Triggered when the player uses a wakeboard",
  T_48_META_EVT_3007_D: "Triggered after the current entity becomes available.",
  T_48_META_EVT_3008_D: "Triggered after the current entity becomes unavailable.",
  T_48_META_EVT_3009_D: "Triggered when an entity enters a trigger. When a trigger event is triggered, both parties receive the event. One party must be a rigid body and the other party must be a trigger. In particular, when the trigger is a custom trigger object, only the trigger will receive the event.",
  T_48_META_EVT_3009_P0_D: "The opposing entity when the trigger event occurs",
  T_48_META_EVT_3010_D: "Triggered when the entity leaves the trigger. When the event is triggered, both parties receive the event. One party must be a rigid body and the other party must be a trigger. In particular, when the trigger is a custom trigger object, only the trigger will receive the event.",
  T_48_META_EVT_3010_P0_D: "The opposing entity when the trigger event occurs",
  T_48_META_EVT_3011_D: "Triggered after the current entity is killed.",
  T_48_META_EVT_3011_P0_D: "The attacker entity,can be null",
  T_48_META_EVT_3011_P1_D: "Damage Type",
  T_48_META_EVT_3011_P2_D: "Hit Body Part",
  T_48_META_EVT_3012_D: "Fires after the current entity is attacked.",
  T_48_META_EVT_3012_P0_D: "The attacker entity, can be null",
  T_48_META_EVT_3012_P1_D: "Damage Type",
  T_48_META_EVT_3012_P2_D: "Amount of damage caused",
  T_48_META_EVT_3012_P3_D: "Hit Body Part",
  T_48_META_EVT_3013_D: "Triggered after the current entity deals damage",
  T_48_META_EVT_3013_P0_D: "Entity taking damage",
  T_48_META_EVT_3013_P1_D: "Damage Type",
  T_48_META_EVT_3013_P2_D: "Amount of damage caused",
  T_48_META_EVT_3013_P3_D: "Hit Body Part",
  T_48_META_EVT_3014_D: "Triggered after the current entity kills another entity.",
  T_48_META_EVT_3014_P0_D: "Destroyed Entities",
  T_48_META_EVT_3014_P1_D: "Hit Body Part",
  T_48_META_EVT_3015_D: "Triggered when the player respwans",
  T_48_META_EVT_3015_P0_D: "Player respwan source type",
  T_48_META_EVT_3016_D: "Fired when a spawner spawns an entity.",
  T_48_META_EVT_3016_P0_D: "Generated Entity List",
  T_48_META_EVT_3016_P1_D: "Wave number",
  T_48_META_EVT_3017_D: "Called when the player enters the knockdown kneeling position",
  T_48_META_EVT_3018_D: "Triggered when all team members die",
  T_48_META_EVT_3019_D: "Triggered when equipping a helmet, body armor or backpack",
  T_48_META_EVT_3019_P0_D: "Equipment ID",
  T_48_META_EVT_3020_D: "Triggers when equipping a primary, secondary, or melee weapon, including when switching to fists",
  T_48_META_EVT_3020_P0_D: "The weapon entity that was equipped when triggered",
  T_48_META_EVT_3021_D: "Triggered after item is used. Items that have use duration will trigger this event after they are used.",
  T_48_META_EVT_3021_P0_D: "Item ID",
  T_48_META_EVT_3021_P1_D: "The prop entity, can be null",
  T_48_META_EVT_3021_P2_D: "A new item entity after using an item, can be null",
  T_48_META_EVT_3022_D: "Triggered when an item is obtained",
  T_48_META_EVT_3022_P0_D: "Item Type",
  T_48_META_EVT_3022_P1_D: "Item entity, can be null",
  T_48_META_EVT_3023_D: "Triggered when the entity's points change",
  T_48_META_EVT_3023_P0_D: "Types of change integrals",
  T_48_META_EVT_3023_P1_D: "The integral value after the integral changes",
  T_48_META_EVT_3024_D: "Triggered when the entity's rank changes",
  T_48_META_EVT_3024_P0_D: "Ranking after change",
  T_48_META_EVT_3025_D: "Triggered on assist",
  T_48_META_EVT_3025_P0_D: "Object killed",
  T_48_META_EVT_3026_D: "Fires when an entity enters a vehicle, either as a driver or a passenger",
  T_48_META_EVT_3026_P0_D: "Entities entering the vehicle",
  T_48_META_EVT_3026_P1_D: "Entering vehicle",
  T_48_META_EVT_3027_D: "Fires when an entity leaves a vehicle",
  T_48_META_EVT_3027_P0_D: "Entities leaving the vehicle",
  T_48_META_EVT_3027_P1_D: "Departing vehicle",
  T_48_META_EVT_3028_D: "Triggered when the entity is driving a vehicle, and is the driver in the vehicle",
  T_48_META_EVT_3028_P0_D: "The entity driving the vehicle",
  T_48_META_EVT_3028_P1_D: "Driving vehicle",
  T_48_META_EVT_3029_D: "Triggered when a vehicle is entered by an entity",
  T_48_META_EVT_3029_P0_D: "Trigger Entity",
  T_48_META_EVT_3030_D: "Triggered when a vehicle has an entity leave it",
  T_48_META_EVT_3030_P0_D: "Trigger Entity",
  T_48_META_EVT_3031_D: "Triggered when the vehicle is driven by an entity",
  T_48_META_EVT_3031_P0_D: "Trigger Entity",
  T_48_META_EVT_3032_D: "Fires after an entity uses a portal to teleport (deprecated, please use OnBouncesOffTire)",
  T_48_META_EVT_3032_P0_D: "Entity using portal",
  T_48_META_EVT_3032_P1_D: "Portal used",
  T_48_META_EVT_3033_D: "Fired when an entity bounces",
  T_48_META_EVT_3033_P0_D: "Trigger Entity",
  T_48_META_EVT_3033_P1_D: "Bounce Objects Used",
  T_48_META_EVT_3034_D: "Triggered after a portal causes an entity to teleport.",
  T_48_META_EVT_3034_P0_D: "The entity that teleports",
  T_48_META_EVT_3035_D: "Triggered after a tire has bounced an entity.",
  T_48_META_EVT_3035_P0_D: "The bounced entity",
  T_48_META_EVT_3036_D: "Triggered when a trap knocks out an entity.",
  T_48_META_EVT_3036_P0_D: "Entity that was knocked away",
  T_48_META_EVT_3036_P1_D: "Mechanism Objects",
  T_48_META_EVT_3037_D: "Fires when an entity enters a trigger",
  T_48_META_EVT_3037_P0_D: "Trigger for entering",
  T_48_META_EVT_3038_D: "Triggered when an entity leaves the trigger",
  T_48_META_EVT_3038_P0_D: "Trigger for leaving",
  T_48_META_EVT_3039_D: "Triggered when a weapon entity is obtained",
  T_48_META_EVT_3039_P0_D: "Weapon Entity",
  T_48_META_EVT_3040_D: "Triggered when an entity is knocked away by a trap",
  T_48_META_EVT_3040_P0_D: "Entity that was knocked away",
  T_48_META_EVT_3040_P1_D: "Mechanism Objects",
  T_48_META_EVT_3041_D: "Triggered when targeting a Aimable entity.",
  T_48_META_EVT_3041_P0_D: "Targeted Entity",
  T_48_META_EVT_3042_D: "Triggered when being aimed by a player",
  T_48_META_EVT_3042_P0_D: "The player taking aim",
  T_48_META_EVT_3043_D: "Triggered when the bullet hits the target",
  T_48_META_EVT_3043_P0_D: "The target hit",
  T_48_META_EVT_3043_P1_D: "The world coordinates of the bullet hitting location",
  T_48_META_EVT_3044_D: "Triggered when hit by a weapon",
  T_48_META_EVT_3044_P0_D: "Weapon Entity",
  T_48_META_EVT_3044_P1_D: "World coordinates of the hit location",
  T_48_META_EVT_3045_D: "Triggered when the player chooses to transform into this level object",
  T_48_META_EVT_3045_P0_D: "The player transform entity(not the scene object itself)",
  T_48_META_EVT_3046_D: "Triggered when the player is respwaned at this respwan point",
  T_48_META_EVT_3046_P0_D: "Player who respwans at this resurrection point",
  T_48_META_EVT_3047_D: "Triggered when the player drops a weapon",
  T_48_META_EVT_3047_P0_D: "Discarded weapon entity",
  T_48_META_EVT_3048_D: "Triggered when the player drops an item other than a weapon",
  T_48_META_EVT_3048_P0_D: "Item Type",
  T_48_META_EVT_3048_P1_D: "Item entity, can be null",
  T_48_META_EVT_3049_D: "Triggered when hit by a football gun",
  T_48_META_EVT_3049_P0_D: "Player",
  T_48_META_EVT_3049_P1_D: "Speed after being hit",
  T_48_META_EVT_3050_D: "Fired when the ball collides with an entity",
  T_48_META_EVT_3050_P0_D: "Collision Objects",
  T_48_META_EVT_3050_P1_D: "Speed after collision",
  T_48_META_EVT_3051_D: "Triggered when a player successfully joins a voice channel",
  T_48_META_EVT_3051_P0_D: "Voice Channel Entity",
  T_48_META_EVT_3052_D: "Triggered when a player fails to join a voice channel",
  T_48_META_EVT_3052_P0_D: "Voice Channel Entity",
  T_48_META_EVT_3053_D: "Triggered when a player leaves a voice channel",
  T_48_META_EVT_3053_P0_D: "Voice Channel Entity",
  T_48_META_EVT_3054_D: "Triggered when the ball enters the goal",
  T_48_META_EVT_3054_P0_D: "Goal",
  T_48_META_EVT_3054_P1_D: "Scorer, the last player to touch the ball before scoring",
  T_48_META_EVT_3054_P2_D: "Assist: The second-to-last player to touch the ball before the goal",
  T_48_META_EVT_3055_D: "Triggered when the player presses the fire button",
  T_48_META_EVT_3056_D: "Triggered when the player jumps",
  T_48_META_EVT_3057_D: "Triggered when the player crouches",
  T_48_META_EVT_3058_D: "Triggered when the player goes prone",
  T_48_META_EVT_3059_D: "Triggered when the player sprints",
  T_48_META_EVT_3060_D: "Triggered when a product is successfully purchased in the store",
  T_48_META_EVT_3060_P0_D: "Players who purchased the item",
  T_48_META_EVT_3060_P1_D: "Goods",
  T_48_META_EVT_3061_D: "Triggered when a weapon is equipped by the player",
  T_48_META_EVT_3061_P0_D: "Players with weapons",
  T_48_META_EVT_3062_D: "Triggered when a unit is killed using this weapon",
  T_48_META_EVT_3062_P0_D: "Entity killed",
  T_48_META_EVT_3063_D: "Triggered when this weapon deals damage to a unit.",
  T_48_META_EVT_3063_P0_D: "Entity that is damaged",
  T_48_META_EVT_3063_P1_D: "Damage",
  T_48_META_EVT_3064_D: "Triggered when the weapon changes bullets",
  T_48_META_EVT_3065_D: "Triggered when an entity enters a vehicle, either as a driver or a passenger.",
  T_48_META_EVT_3065_P0_D: "Entering vehicle",
  T_48_META_EVT_3066_D: "Fires when an entity leaves a vehicle.",
  T_48_META_EVT_3066_P0_D: "Departing vehicle",
  T_48_META_EVT_3067_D: "Triggered when the entity is driving a vehicle",
  T_48_META_EVT_3067_P0_D: "Driving vehicle",
  T_48_META_EVT_3068_D: "Fires after an entity uses a portal to teleport.",
  T_48_META_EVT_3068_P0_D: "Portal used",
  T_48_META_EVT_3069_D: "Fires after an entity is bounced by a tire.",
  T_48_META_EVT_3069_P0_D: "Tires used",
  T_48_META_EVT_3070_D: "Triggered when an entity is knocked away by a trap.",
  T_48_META_EVT_3070_P0_D: "Mechanism Objects",
  T_48_META_EVT_3071_D: "Triggered after the UI button control is pressed by the player",
  T_48_META_EVT_3071_P0_D: "Trigger Player",
  T_48_META_EVT_3072_D: "Triggered after the UI button control is lifted",
  T_48_META_EVT_3072_P0_D: "Trigger Player",
  T_48_META_EVT_3073_D: "Triggered after the UI button control is double-clicked by the player",
  T_48_META_EVT_3073_P0_D: "Trigger Player",
  T_48_META_EVT_3074_D: "Jailbreak area starts",
  T_48_META_EVT_3075_D: "Jailbreak Zone Ended",
  T_48_META_EVT_3076_D: "Triggered when the player stops using the wakeboard",
  T_48_META_EVT_3077_D: "Triggered when the text content of the UI input box control is changed by the player",
  T_48_META_EVT_3077_P0_D: "Trigger Player",
  T_48_META_EVT_3077_P1_D: "Changed text content",
  T_48_META_EVT_3078_D: "Fired when a playable entity starts playing",
  T_48_META_EVT_3078_P0_D: "Playable Entity",
  T_48_META_EVT_3079_D: "Triggered when the playable entity finishes playing. This event only takes effect on the client side when the playable entity is a sound effect, special effect, etc.",
  T_48_META_EVT_3079_P0_D: "Playable Entity",
  T_48_META_EVT_3080_D: "Triggered when a playable entity resumes playing",
  T_48_META_EVT_3080_P0_D: "Playable Entity",
  T_48_META_EVT_3081_D: "Triggered when a playable entity is paused",
  T_48_META_EVT_3081_P0_D: "Playable Entity",
  T_48_META_EVT_3082_D: "Jailbreak player joins",
  T_48_META_EVT_3082_P0_D: "Trigger Player",
  T_48_META_EVT_3083_D: "Jailbreak player exits",
  T_48_META_EVT_3083_P0_D: "Trigger Player",
  T_48_META_EVT_3084_D: "Fired when the countdown ends",
  T_48_META_EVT_3084_P0_D: "Belonging Entity",
  T_48_META_EVT_3085_D: "Triggered when an item is picked up",
  T_48_META_EVT_3085_P0_D: "The player who picked up the item",
  T_48_META_EVT_3086_D: "Triggered when an item is dropped",
  T_48_META_EVT_3086_P0_D: "The player who dropped the item",
  T_48_META_EVT_3087_D: "Triggered when this equipment is equipped",
  T_48_META_EVT_3088_D: "Triggered when the object is started after the mine is created",
  T_48_META_EVT_3089_D: "Triggered when the object fires after the mine is created",
  T_48_META_EVT_3089_P0_D: "The target that triggers the created object of mine",
  T_48_META_EVT_3090_D: "Triggered before purchasing goods in the store",
  T_48_META_EVT_3090_P0_D: "Players who purchased goods",
  T_48_META_EVT_3090_P1_D: "Goods",
  T_48_META_EVT_3091_D: "Triggered when this device is used",
  T_48_META_EVT_3092_D: "Triggered when the hook gun is fired",
  T_48_META_EVT_3093_D: "Triggered when a projectile explodes after being thrown.",
  T_48_META_EVT_3093_P0_D: "Explosion Point",
  T_48_META_EVT_3094_D: "Triggered when hit by the Paint Gun",
  T_48_META_EVT_3094_P0_D: "Paint Gun Entity",
  T_48_META_EVT_3094_P1_D: "Hit Point",
  T_48_META_EVT_3094_P2_D: "Hit Normal Line",
  T_48_META_EVT_3095_D: "Triggered when hitting with the paint gun",
  T_48_META_EVT_3095_P0_D: "Object hit",
  T_48_META_EVT_3095_P1_D: "Hit Point",
  T_48_META_EVT_3095_P2_D: "Hit Normal Line",
  T_48_META_EVT_3096_D: "Triggered when a vehicle or dye barrel explodes",
  T_48_META_EVT_3096_P0_D: "The player who caused the explosion",
  T_48_META_EVT_3096_P1_D: "List of players affected by the explosion",
  T_48_META_EVT_3097_D: "Triggered when the weapon stops firing",
  T_48_META_EVT_3097_P0_D: "The current amount of bullets remaining in the magazine when firing stops",
  T_48_META_EVT_3098_D: "Triggered when the pursuit target enters the pursuit range",
  T_48_META_EVT_3099_D: "Triggered when the pursuit target leaves the pursuit range",
  T_48_META_EVT_31_D: "Triggered when the scene switches successfully",
  T_48_META_EVT_31_P0_D: "Scene Name",
  T_48_META_EVT_3100_D: "Triggered when the target enters the attack range",
  T_48_META_EVT_3101_D: "Triggered when the target leaves the attack range",
  T_48_META_EVT_3102_D: "This event is triggered when the camera ray detection is triggered by a client click event",
  T_48_META_EVT_3102_P0_D: "Trigger Player",
  T_48_META_EVT_3102_P1_D: "Whether the camera ray hits the object",
  T_48_META_EVT_3102_P2_D: "Camera ray hit position",
  T_48_META_EVT_3102_P3_D: "Client camera orientation",
  T_48_META_EVT_3102_P4_D: "Client camera position",
  T_48_META_EVT_3102_P5_D: "Hitting an entity",
  T_48_META_EVT_3103_D: "Triggered when the shop interface is opened",
  T_48_META_EVT_3103_P0_D: "Trigger Player",
  T_48_META_EVT_3104_D: "Triggered when the shop interface is closed.",
  T_48_META_EVT_3104_P0_D: "Trigger Player",
  T_48_META_EVT_3105_D: "Triggered when the behavior tree logic enters this node",
  T_48_META_EVT_3105_P0_D: "Node Name",
  T_48_META_EVT_3105_P1_D: "Entity",
  T_48_META_EVT_3106_D: "Triggered when the behavior tree logic exits this node",
  T_48_META_EVT_3106_P0_D: "Node Name",
  T_48_META_EVT_3106_P1_D: "Entity",
  T_48_META_EVT_3107_D: "Triggered when the rigidbody is awakened",
  T_48_META_EVT_3108_D: "Triggered when the rigidbody goes to sleep",
  T_48_META_EVT_3109_D: "Triggered when the player moves",
  T_48_META_EVT_3109_P0_D: "Posture",
  T_48_META_EVT_3110_D: "Triggered when the player is idle",
  T_48_META_EVT_3110_P0_D: "Posture",
  T_48_META_EVT_3111_D: "Triggered when the player uses a skill",
  T_48_META_EVT_3111_P0_D: "Skill Used",
  T_48_META_EVT_3112_D: "Triggered when the player ends a sprint",
  T_48_META_EVT_3113_D: "Triggered when an item corresponding to a slot under the SwitchEquipSlot enumeration is obtained",
  T_48_META_EVT_3113_P0_D: "Obtained item entity",
  T_48_META_EVT_3114_D: "Triggered when switching between held items, including switching to fists",
  T_48_META_EVT_3114_P0_D: "The entity of the item being held after the toggle",
  T_48_META_EVT_3115_D: "Triggered in the store when a player asks others to buy goods",
  T_48_META_EVT_3115_P0_D: "Players who requested to purchase the goods",
  T_48_META_EVT_3115_P1_D: "Goods",
  T_48_META_EVT_3116_D: "Triggered when a player in the store requests others to buy goods and the request is accepted",
  T_48_META_EVT_3116_P0_D: "Help players who purchased",
  T_48_META_EVT_3116_P1_D: "Request help for players who purchased",
  T_48_META_EVT_3116_P2_D: "Goods",
  T_48_META_EVT_3117_D: "Triggered when a fixed frame is updated, the frequency is fixed at 30 times per second",
  T_48_META_EVT_3118_D: "Fired after calling the pause game API",
  T_48_META_EVT_3119_D: "Triggered after calling the resume game API",
  T_48_META_EVT_3120_D: "Triggered when a player adds or deletes a friend",
  T_48_META_EVT_3121_D: "Triggered when receiving Persona information",
  T_48_META_EVT_3121_P0_D: "Information Content",
  T_48_META_EVT_3121_P1_D: "Sender Persona",
  T_48_META_EVT_3122_D: "Triggered when the player finishes jumping.",
  T_48_META_EVT_3123_D: "Triggered when the player falls",
  T_48_META_EVT_3124_D: "Triggered when the player finishes falling.",
  T_48_META_EVT_3125_D: "Triggered when receiving a Persona action",
  T_48_META_EVT_3125_P0_D: "Persona action",
  T_48_META_EVT_3125_P1_D: "Sender Persona",
  T_48_META_EVT_3126_D: "Triggered when member information changes",
  T_48_META_EVT_3126_P0_D: "Member status after change",
  T_48_META_EVT_3127_D: "Triggered when entering the member center",
  T_48_META_EVT_3128_D: "Triggered when leaving the member center",
  T_48_META_EVT_3129_D: "Triggered when the player enters a knockdown state",
  T_48_META_EVT_3129_P0_D: "The attacker entity, can be null",
  T_48_META_EVT_3130_D: "Triggered when a Persona status is received",
  T_48_META_EVT_3130_P0_D: "Sender Persona",
  T_48_META_EVT_3130_P1_D: "Error Code",
  T_48_META_EVT_3131_D: "Triggered when sending a message to Persona through the UI",
  T_48_META_EVT_3131_P0_D: "Information Content",
  T_48_META_EVT_3131_P1_D: "Sender Persona",
  T_48_META_EVT_3132_D: "Triggered when receiving the end from Persona",
  T_48_META_EVT_3132_P0_D: "Sender Persona",
  T_48_META_EVT_3132_P1_D: "Error Code",
  T_48_META_EVT_32_D: "Triggered when the player switches scenes",
  T_48_META_EVT_32_P0_D: "Scene Name",
  T_48_META_EVT_3200_D: "Fired when the animation clip has finished playing",
  T_48_META_EVT_3200_P0_D: "Animation Clip Name",
  T_48_META_EVT_3201_D: "Triggered when the animation state is finished playing",
  T_48_META_EVT_3201_P0_D: "Animation state name",
  T_48_META_EVT_3204_D: "Triggered when the Toggle control state changes",
  T_48_META_EVT_3204_P0_D: "Trigger Player",
  T_48_META_EVT_3204_P1_D: "State",
  T_48_META_EVT_3260_D: "Triggered when the touchpad is pressed by the player",
  T_48_META_EVT_3260_P0_D: "Trigger Player",
  T_48_META_EVT_3260_P1_D: "Press position",
  T_48_META_EVT_3261_D: "Triggered when the touchpad is lifted",
  T_48_META_EVT_3261_P0_D: "Trigger Player",
  T_48_META_EVT_3261_P1_D: "Lift-off position",
  T_48_META_EVT_3262_D: "Triggered when the touchpad starts sliding",
  T_48_META_EVT_3262_P0_D: "Trigger Player",
  T_48_META_EVT_3262_P1_D: "Start sliding position",
  T_48_META_EVT_3263_D: "Triggered when sliding the touchpad. During sliding, this event is triggered once per frame.",
  T_48_META_EVT_3263_P0_D: "Trigger Player",
  T_48_META_EVT_3263_P1_D: "Start sliding position",
  T_48_META_EVT_3263_P2_D: "Displacement",
  T_48_META_EVT_3264_D: "Fired when the touchpad slide ends",
  T_48_META_EVT_3264_P0_D: "Trigger Player",
  T_48_META_EVT_3264_P1_D: "End slide position",
  T_48_META_EVT_3265_D: "Triggered when the JoyStick is pressed",
  T_48_META_EVT_3265_P0_D: "Trigger Player",
  T_48_META_EVT_3266_D: "Triggered when the JoyStick is lifted",
  T_48_META_EVT_3266_P0_D: "Trigger Player",
  T_48_META_EVT_3267_D: "Triggered when using the joystick",
  T_48_META_EVT_3267_P0_D: "Trigger Player",
  T_48_META_EVT_3267_P1_D: "Output Displacement",
  T_48_META_EVT_3268_D: "Triggered when the player stands up from any other posture",
  T_48_META_EVT_3268_P0_D: "The player's posture before standing up",
  T_48_META_EVT_3269_D: "Triggered when the weapon is fired",
  T_48_META_EVT_4_D: "Triggered at the start of each round",
  T_48_META_EVT_4_P0_D: "Round index, starting from 0",
  T_48_META_EVT_5_D: "Triggered at the end of each round",
  T_48_META_EVT_5_P0_D: "Round index, starting from 0",
  T_48_META_EVT_6_D: "Triggered when an entity collides. Only entities with rigidbody components attached support this event.",
  T_48_META_EVT_6_P0_D: "Entities Encountered",
  T_48_META_EVT_7_D: "Triggered at the beginning of each phase",
  T_48_META_EVT_7_P0_D: "Stage Entity",
  T_48_META_EVT_8_D: "Triggered at the end of each phase",
  T_48_META_EVT_8_P0_D: "Stage Entity",
  T_48_META_EVT_9_D: "Triggered when the entity collision ends. Only entities with rigidbody components attached support this event.",
  T_48_META_EVT_9_P0_D: "Entities Encountered",
  T_49_META_TYP_10_I1_D: "Tag List",
  T_49_META_TYP_10_I2_D: "Is it available for itself",
  T_49_META_TYP_10_I3_D: "Available in all parents",
  T_49_META_TYP_10_I4_D: "Whether it is available in the Scene or not",
  T_49_META_TYP_10_I5_D: "Whether logic update is turned on, when it is turned off, the script on this entity stops updating every frame",
  T_49_META_TYP_10_I6_D: "Entity name",
  T_49_META_TYP_10_I7_D: "Region filtering options, 0 for automatic calculation of controlled or uncontrolled, 1 for uncontrolled always synchronized, 2 for controlled",
  T_49_META_TYP_100_I0_D: "Setting the trigger range",
  T_49_META_TYP_100_I1_D: "Model Visibility",
  T_49_META_TYP_101_I0_D: "Player",
  T_49_META_TYP_101_I1_D: "TargetItemID",
  T_49_META_TYP_101_I2_D: "TargetRotation",
  T_49_META_TYP_101_I3_D: "TargetScale",
  T_49_META_TYP_1010_I1_D: "Timing duration in seconds",
  T_49_META_TYP_1010_I2_D: "The start time of the timings, in seconds of the game moment",
  T_49_META_TYP_1010_I3_D: "The update type of the timer, see `EUITimeUpdateType`, can be static, timed, or countdown.",
  T_49_META_TYP_1010_I4_D: "Display position, when there is a target to follow, it is the offset relative to the target origin, when there is no target to follow, it is the screen coordinates.",
  T_49_META_TYP_1011_I10_D: "Progress Icon Name",
  T_49_META_TYP_1011_I2_D: "Theme Color",
  T_49_META_TYP_1011_I3_D: "Whether to enable localized display",
  T_49_META_TYP_1011_I4_D: "Title",
  T_49_META_TYP_1011_I5_D: "Description",
  T_49_META_TYP_1011_I6_D: "Icon resource name",
  T_49_META_TYP_1011_I7_D: "Max Progress",
  T_49_META_TYP_1011_I8_D: "Current Progress",
  T_49_META_TYP_1011_I9_D: "Progress Icon",
  T_49_META_TYP_1012_I1_D: "Enable or disable localization",
  T_49_META_TYP_1012_I2_D: "Number of rounds text",
  T_49_META_TYP_1012_I3_D: "Round Num LocKey Params",
  T_49_META_TYP_1012_I5_D: "LeftColor",
  T_49_META_TYP_1012_I6_D: "RightColor",
  T_49_META_TYP_1013_I2_D: "Round Count Text",
  T_49_META_TYP_1013_I3_D: "Round Num LocKey Params",
  T_49_META_TYP_1014_I2_D: "First Score Title Text",
  T_49_META_TYP_1014_I3_D: "First Score",
  T_49_META_TYP_1014_I4_D: "First Score Params",
  T_49_META_TYP_1014_I5_D: "Title of the second score",
  T_49_META_TYP_1014_I6_D: "Second score value",
  T_49_META_TYP_1014_I7_D: "Second Score Value Params",
  T_49_META_TYP_1016_I1_D: "Show the corresponding status according to the value, Victory (1), Defeat (2), Tie (3), Booyah (4)",
  T_49_META_TYP_1016_I2_D: "Show if the score of 2 teams is true, otherwise hidden",
  T_49_META_TYP_1016_I3_D: "Left Team Score",
  T_49_META_TYP_1016_I4_D: "Right Team Score",
  T_49_META_TYP_1016_I5_D: "Phase end timestamps",
  T_49_META_TYP_1017_I1_D: "Left Team Name",
  T_49_META_TYP_1017_I2_D: "Left Description",
  T_49_META_TYP_1017_I3_D: "Right Team Name",
  T_49_META_TYP_1017_I4_D: "Right Description",
  T_49_META_TYP_1018_I1_D: "Round Num",
  T_49_META_TYP_1018_I4_D: "Left team score",
  T_49_META_TYP_1018_I6_D: "Score of the right team",
  T_49_META_TYP_1019_I1_D: "1 2 3 for win/loss/tie",
  T_49_META_TYP_102_I0_D: "Resurrection source type, player resurrects from death",
  T_49_META_TYP_102_I1_D: "Resurrection source type, player resurrects from downed state",
  T_49_META_TYP_1020_I2_D: "Text key to be displayed",
  T_49_META_TYP_1020_I3_D: "Array of parameters corresponding to the text key",
  T_49_META_TYP_1021_I1_D: "Base time in seconds",
  T_49_META_TYP_1021_I2_D: "Duration in seconds",
  T_49_META_TYP_1021_I3_D: "Display position, when there is a target to follow, it is the offset of the target origin, when there is no target to follow, it is the screen coordinate, default is Vector3(0).",
  T_49_META_TYP_1022_I2_D: "the key of the text to be displayed",
  T_49_META_TYP_1022_I3_D: "Array of parameters corresponding to the text key.",
  T_49_META_TYP_1023_I1_D: "show team score if it is true, otherwise it will be closed.",
  T_49_META_TYP_1023_I4_D: "If the status of the team is true, then display, otherwise it will be closed.",
  T_49_META_TYP_1023_I5_D: "Left player status array, 0: alive, 1: dead, 2: down.",
  T_49_META_TYP_1023_I6_D: "Right player status array, 0: alive, 1: dead, 2: down.",
  T_49_META_TYP_1023_I7_D: "Left Teammate Flag Count",
  T_49_META_TYP_1023_I8_D: "Right Teammate Flag Count",
  T_49_META_TYP_1024_I2_D: "Offset",
  T_49_META_TYP_1024_I3_D: "Rank",
  T_49_META_TYP_1024_I4_D: "Team Color",
  T_49_META_TYP_1024_I5_D: "Icon Name",
  T_49_META_TYP_1024_I6_D: "Displayed if border is true, otherwise it is off.",
  T_49_META_TYP_1024_I7_D: "Score Text Key",
  T_49_META_TYP_1024_I8_D: "Score Text Key Params",
  T_49_META_TYP_1028_I1_D: "Left Teammate Alive Num",
  T_49_META_TYP_1028_I2_D: "Right Teammate Alive Num",
  T_49_META_TYP_1028_I3_D: "Left Background Color",
  T_49_META_TYP_1028_I4_D: "Right Background Color",
  T_49_META_TYP_1028_I5_D: "Left Icon Name",
  T_49_META_TYP_1028_I6_D: "Right Icon Name",
  T_49_META_TYP_1029_I1_D: "Icon Name",
  T_49_META_TYP_1029_I2_D: "Background Icon Name",
  T_49_META_TYP_103_I0_D: "Primary Weapon A",
  T_49_META_TYP_103_I1_D: "Primary WeaponB",
  T_49_META_TYP_103_I10_D: "Freeze Bomb",
  T_49_META_TYP_103_I11_D: "Ice Wall",
  T_49_META_TYP_103_I12_D: "Landmine",
  T_49_META_TYP_103_I13_D: "Auto Turret",
  T_49_META_TYP_103_I14_D: "DummyGrenade",
  T_49_META_TYP_103_I16_D: "Skateboard, Camo ....",
  T_49_META_TYP_103_I2_D: "Secondary Weapon",
  T_49_META_TYP_103_I3_D: "Blast Weapon",
  T_49_META_TYP_103_I5_D: "HeavyWeapon",
  T_49_META_TYP_1030_I3_D: "Left Teammate Alive Num",
  T_49_META_TYP_1030_I4_D: "Right Teammate Alive Num",
  T_49_META_TYP_1030_I5_D: "Left team icon name",
  T_49_META_TYP_1030_I6_D: "Right team icon name",
  T_49_META_TYP_1031_I2_D: "Description of the message",
  T_49_META_TYP_1031_I3_D: "Countdown start timestamp, in seconds",
  T_49_META_TYP_1031_I4_D: "Description Params",
  T_49_META_TYP_1032_I1_D: "Tips Type",
  T_49_META_TYP_1032_I3_D: "Params",
  T_49_META_TYP_1033_I1_D: "Toggles phases, 0 for current round and 1 for next round",
  T_49_META_TYP_1033_I10_D: "Defeat prompt text, not filled in as default",
  T_49_META_TYP_1033_I11_D: "Round Income Title",
  T_49_META_TYP_1033_I12_D: "Round Income",
  T_49_META_TYP_1033_I13_D: "Round Income Detail Titles",
  T_49_META_TYP_1033_I14_D: "Round revenue value detail list, corresponding to the above detail title list one by one",
  T_49_META_TYP_1033_I15_D: "MVP Player Nickname",
  T_49_META_TYP_1033_I16_D: "Next Round Index",
  T_49_META_TYP_1033_I17_D: "Is Match Point",
  T_49_META_TYP_1033_I18_D: "Is Last Round",
  T_49_META_TYP_1033_I6_D: "Left team icon name",
  T_49_META_TYP_1033_I7_D: "Right team icon name",
  T_49_META_TYP_1033_I8_D: "Depending on the value, the corresponding status will be displayed, Victory (1), Defeat (2).",
  T_49_META_TYP_1033_I9_D: "Victory prompt text, default if not filled in",
  T_49_META_TYP_1036_I1_D: "Indicates how many levels there are in total",
  T_49_META_TYP_1036_I2_D: "Indicates the current bot level",
  T_49_META_TYP_1037_I1_D: "Indicates how many points are displayed",
  T_49_META_TYP_1039_I3_D: "Countdown start timestamp, in seconds",
  T_49_META_TYP_104_I0_D: "Style A",
  T_49_META_TYP_104_I1_D: "Style B",
  T_49_META_TYP_104_I2_D: "Style C",
  T_49_META_TYP_1040_I10_D: "ItemDescriptions",
  T_49_META_TYP_1040_I11_D: "Index of the selected item, start from 0, less than 0 means deselected.",
  T_49_META_TYP_1040_I12_D: "ButtonNames",
  T_49_META_TYP_1040_I13_D: "ButtonColors",
  T_49_META_TYP_1040_I2_D: "Count Down Key",
  T_49_META_TYP_1040_I3_D: "Countdown Time",
  T_49_META_TYP_1040_I4_D: "Description Key",
  T_49_META_TYP_1040_I5_D: "Array of description parameters",
  T_49_META_TYP_1040_I6_D: "ItemBackgrounds",
  T_49_META_TYP_1040_I7_D: "ItemBackgroundColors",
  T_49_META_TYP_1040_I8_D: "ItemIcons",
  T_49_META_TYP_1040_I9_D: "ItemNames",
  T_49_META_TYP_1041_I2_D: "Position",
  T_49_META_TYP_1041_I3_D: "Icon",
  T_49_META_TYP_1041_I4_D: "Label",
  T_49_META_TYP_1041_I5_D: "Background Color",
  T_49_META_TYP_1042_I1_D: "Local Position",
  T_49_META_TYP_1043_I4_D: "Color",
  T_49_META_TYP_1043_I5_D: "Label Key",
  T_49_META_TYP_1043_I6_D: "Label Params",
  T_49_META_TYP_1045_I2_D: "Button icon",
  T_49_META_TYP_1045_I3_D: "Icon Color",
  T_49_META_TYP_1045_I4_D: "Size, same width and height",
  T_49_META_TYP_1045_I5_D: "Position of the button relative to the anchor point in the lower right corner.",
  T_49_META_TYP_1045_I6_D: "Number of charge, less than 0 means hidden",
  T_49_META_TYP_1045_I7_D: "CD start time, in milliseconds",
  T_49_META_TYP_1045_I8_D: "CD duration, in milliseconds",
  T_49_META_TYP_1045_I9_D: "True, the button will be grayed out, False, it will be restored.",
  T_49_META_TYP_106_I1_D: "Enable",
  T_49_META_TYP_106_I2_D: "Disable",
  T_49_META_TYP_109_I0_D: "Chat Channel ID",
  T_49_META_TYP_109_I1_D: "Player List",
  T_49_META_TYP_11_I0_D: "Whether the current game is in illegal state, when it is in illegal state, it means the game has lost the value of confrontation, so it is recommended to end the game directly.",
  T_49_META_TYP_11_I1_D: "The length of the current game, in milliseconds.",
  T_49_META_TYP_11_I10_D: "Whether or not to reset equipment every round",
  T_49_META_TYP_11_I11_D: "Whether or not to enable out-of-zone mechanic",
  T_49_META_TYP_11_I12_D: "Safe Zone Size",
  T_49_META_TYP_11_I13_D: "Shrinking Start Time",
  T_49_META_TYP_11_I14_D: "Shrinking Duration",
  T_49_META_TYP_11_I15_D: "Out-of-Zone Damage",
  T_49_META_TYP_11_I18_D: "Revival Type",
  T_49_META_TYP_11_I2_D: "Current round index, through this value you can get the current round entity.",
  T_49_META_TYP_11_I27_D: "Total Round Count",
  T_49_META_TYP_11_I3_D: "Current phase index, by this value you can get the current phase entity.",
  T_49_META_TYP_11_I32_D: "Number of coins gained at the start of the round",
  T_49_META_TYP_11_I33_D: "Number of coins at kill",
  T_49_META_TYP_11_I34_D: "Number of coins when you win",
  T_49_META_TYP_11_I35_D: "Whether to show wallet UI",
  T_49_META_TYP_11_I36_D: "Skybox Entity",
  T_49_META_TYP_11_I37_D: "Cumulative running frames since game start",
  T_49_META_TYP_11_I38_D: "Enable Move",
  T_49_META_TYP_11_I39_D: "Whether to customize the settlement",
  T_49_META_TYP_11_I4_D: "Preset template ID for UGC mode.",
  T_49_META_TYP_11_I40_D: "Whether to allow joining in the middle of the game",
  T_49_META_TYP_11_I41_D: "Enable low frame rate mode, the game will run at 15FPS, otherwise 30FPS",
  T_49_META_TYP_11_I42_D: "Logical frame update interval between two game server updates",
  T_49_META_TYP_11_I43_D: "Fixed frame update interval in milliseconds",
  T_49_META_TYP_11_I5_D: "Disable player resurrection if off",
  T_49_META_TYP_11_I6_D: "Disable Bot resurrection if off",
  T_49_META_TYP_11_I7_D: "Resurrection time in seconds",
  T_49_META_TYP_11_I8_D: "Total number of teams in the game",
  T_49_META_TYP_11_I9_D: "Number of members in each team",
  T_49_META_TYP_110_I0_D: "ChannelA",
  T_49_META_TYP_110_I1_D: "ChannelB",
  T_49_META_TYP_110_I2_D: "ChannelC",
  T_49_META_TYP_110_I3_D: "ChannelD",
  T_49_META_TYP_110_I4_D: "ChannelE",
  T_49_META_TYP_110_I5_D: "ChannelF",
  T_49_META_TYP_111_I1_D: "Sprint",
  T_49_META_TYP_111_I2_D: "Attack",
  T_49_META_TYP_111_I3_D: "Jump",
  T_49_META_TYP_111_I4_D: "Window Jump",
  T_49_META_TYP_111_I5_D: "Drive",
  T_49_META_TYP_111_I6_D: "Enter Vehicle",
  T_49_META_TYP_111_I7_D: "Exit Vehicle",
  T_49_META_TYP_111_I8_D: "Dirve Vehicle",
  T_49_META_TYP_112_I0_D: "Enable",
  T_49_META_TYP_112_I1_D: "Disable",
  T_49_META_TYP_112_I2_D: "Invisible",
  T_49_META_TYP_117_I0_D: "Claps",
  T_49_META_TYP_117_I1_D: "Hihats",
  T_49_META_TYP_117_I2_D: "Kick",
  T_49_META_TYP_117_I3_D: "OpenHihats",
  T_49_META_TYP_117_I4_D: "Rides",
  T_49_META_TYP_117_I5_D: "Snares",
  T_49_META_TYP_118_I0_D: "Whether all members of the camp are in death",
  T_49_META_TYP_118_I1_D: "List of all team members",
  T_49_META_TYP_118_I2_D: "Allied Factions",
  T_49_META_TYP_118_I3_D: "Attackable Factions",
  T_49_META_TYP_118_I4_D: "Whether to show UI name",
  T_49_META_TYP_118_I5_D: "Whether to show map information",
  T_49_META_TYP_118_I6_D: 'Whether to "show" or not',
  T_49_META_TYP_118_I7_D: 'Whether to "show" or not',
  T_49_META_TYP_118_I8_D: "All Members",
  T_49_META_TYP_118_I9_D: "Is Show Quick Message",
  T_49_META_TYP_119_I0_D: "Yes",
  T_49_META_TYP_119_I1_D: "No",
  T_49_META_TYP_120_I1_D: "Target entity to follow, default is empty",
  T_49_META_TYP_120_I2_D: "UI color",
  T_49_META_TYP_120_I3_D: "UI length",
  T_49_META_TYP_120_I4_D: "Current progress value,0 to 1.0",
  T_49_META_TYP_120_I5_D: "Display position, when there is a target to follow, it is the offset relative to the target origin, when there is no target to follow, it is the screen coordinate, default is Vector3(0)",
  T_49_META_TYP_121_I0_D: "3s",
  T_49_META_TYP_121_I1_D: "5s",
  T_49_META_TYP_121_I2_D: "10s",
  T_49_META_TYP_121_I3_D: "15s",
  T_49_META_TYP_121_I4_D: "30s",
  T_49_META_TYP_121_I5_D: "9999s",
  T_49_META_TYP_122_I0_D: "Skybox Resource",
  T_49_META_TYP_122_I1_D: "Light Color",
  T_49_META_TYP_122_I10_D: "The GUID of the sub-scene it belongs to",
  T_49_META_TYP_122_I11_D: "Fog function switch",
  T_49_META_TYP_122_I12_D: "Fog Effect Mode",
  T_49_META_TYP_122_I13_D: "Exponential fog density",
  T_49_META_TYP_122_I14_D: "Start distance of linear fog",
  T_49_META_TYP_122_I15_D: "End distance of linear fog",
  T_49_META_TYP_122_I16_D: "Turn on the fog effect feature",
  T_49_META_TYP_122_I17_D: "Rotation angle of main light source",
  T_49_META_TYP_122_I18_D: "Enable the main light source rotation angle feature",
  T_49_META_TYP_122_I2_D: "Light Intensity",
  T_49_META_TYP_122_I3_D: "Darkness",
  T_49_META_TYP_122_I4_D: "Shadow Strength",
  T_49_META_TYP_122_I5_D: "Terrain Wetness",
  T_49_META_TYP_122_I6_D: "Lens Flare",
  T_49_META_TYP_122_I7_D: "Fog Color",
  T_49_META_TYP_122_I8_D: "Ambient Color",
  T_49_META_TYP_123_I0_D: "Day",
  T_49_META_TYP_123_I1_D: "Night",
  T_49_META_TYP_123_I2_D: "Dusk",
  T_49_META_TYP_123_I3_D: "City View",
  T_49_META_TYP_123_I4_D: "Colorful Sky",
  T_49_META_TYP_123_I5_D: "Frost Moon",
  T_49_META_TYP_124_I0_D: "Close Range",
  T_49_META_TYP_124_I1_D: "Medium Range",
  T_49_META_TYP_124_I2_D: "Long range",
  T_49_META_TYP_125_I0_D: "Diffuse Color",
  T_49_META_TYP_125_I2_D: "Diffuse Texture",
  T_49_META_TYP_125_I4_D: "Diffuse Alpha",
  T_49_META_TYP_126_I1_D: "Name",
  T_49_META_TYP_126_I2_D: "Current progress value",
  T_49_META_TYP_126_I3_D: "Maximum progress value",
  T_49_META_TYP_126_I4_D: "Screen coordinate, default is Vector3(0).",
  T_49_META_TYP_126_I5_D: "length of the progress bar, default is the length of the UI on the prefab.",
  T_49_META_TYP_127_I0_D: "Panning along an axis can be combined with three axes.",
  T_49_META_TYP_127_I1_D: "Rotate along an axis, three combinations possible",
  T_49_META_TYP_127_I2_D: "Zoom along an axis, three combinations possible",
  T_49_META_TYP_128_I0_D: "Bushes",
  T_49_META_TYP_128_I1_D: "Pumpkin",
  T_49_META_TYP_128_I2_D: "Scarecrow",
  T_49_META_TYP_128_I3_D: "Cabinet",
  T_49_META_TYP_129_I0_D: "Random Loot",
  T_49_META_TYP_129_I1_D: "AR Ammo",
  T_49_META_TYP_129_I2_D: "SMG Ammo",
  T_49_META_TYP_129_I3_D: "SN Ammo",
  T_49_META_TYP_129_I4_D: "HG Ammo",
  T_49_META_TYP_129_I5_D: "SG Bullets",
  T_49_META_TYP_129_I6_D: "Bow Ammo",
  T_49_META_TYP_13_I1_D: "Anchor coordinates relative to the parent node.",
  T_49_META_TYP_13_I10_D: "Widget and anchor frame size difference",
  T_49_META_TYP_13_I11_D: "Pivot",
  T_49_META_TYP_13_I12_D: "Depth",
  T_49_META_TYP_13_I14_D: "Order of all children in the same parent node",
  T_49_META_TYP_13_I15_D: "ParentID",
  T_49_META_TYP_13_I16_D: "UniqueID",
  T_49_META_TYP_13_I17_D: "Priority",
  T_49_META_TYP_13_I18_D: "Actual Position",
  T_49_META_TYP_13_I2_D: "Width",
  T_49_META_TYP_13_I4_D: "Z-axis rotation angle",
  T_49_META_TYP_13_I6_D: "Internal ID of the widget in the prefab",
  T_49_META_TYP_13_I7_D: "UI entity where it is located",
  T_49_META_TYP_13_I8_D: "Anchor Min",
  T_49_META_TYP_13_I9_D: "Anchor Max",
  T_49_META_TYP_130_I0_D: "Random Consumable Loot",
  T_49_META_TYP_130_I1_D: "MedKit",
  T_49_META_TYP_130_I2_D: "Repair Kit",
  T_49_META_TYP_130_I3_D: "Horizaline",
  T_49_META_TYP_130_I4_D: "Inhaler",
  T_49_META_TYP_131_I0_D: "Random Armor Loot",
  T_49_META_TYP_131_I1_D: "Level 1 Armor",
  T_49_META_TYP_131_I2_D: "Class II Armor",
  T_49_META_TYP_131_I3_D: "Tier 3 Armor",
  T_49_META_TYP_132_I0_D: "Random Throwing Object Loot",
  T_49_META_TYP_132_I1_D: "Grenade",
  T_49_META_TYP_132_I4_D: "Flash Freeze",
  T_49_META_TYP_133_I0_D: "Random Multiplier Loot",
  T_49_META_TYP_133_I1_D: "2x Scope",
  T_49_META_TYP_133_I2_D: "4x Scope",
  T_49_META_TYP_133_I3_D: "Thermal Scope",
  T_49_META_TYP_134_I0_D: "Random Weapon Loot",
  T_49_META_TYP_134_I5_D: "Shotgun",
  T_49_META_TYP_134_I8_D: "Football Gun",
  T_49_META_TYP_135_I0_D: "Loot bullet points",
  T_49_META_TYP_136_I0_D: "Loot Consumable Points",
  T_49_META_TYP_137_I0_D: "Loot Consumable Points",
  T_49_META_TYP_138_I0_D: "Loot Multiplier Points",
  T_49_META_TYP_139_I0_D: "Loot Armor Points",
  T_49_META_TYP_14_I0_D: "Player's current blood level",
  T_49_META_TYP_14_I1_D: "Player's current blood maximum",
  T_49_META_TYP_14_I11_D: "The player's camp",
  T_49_META_TYP_14_I12_D: "The player's damage multiplier, e.g. 2x configured as 2.0",
  T_49_META_TYP_14_I13_D: "Use the exact same rig as the male or female character, 0 means no model replacement",
  T_49_META_TYP_14_I14_D: "Does not conflict with existing velocity scaling",
  T_49_META_TYP_14_I15_D: "Does not conflict with existing jump height scaling",
  T_49_META_TYP_14_I16_D: "Identity,0 Normal Player,1 Hunter,2 Matrix Zombie,3 Normal Zombie,4 Evolved Zombie Type 1, 5 Evolved Zombie Type 2,6 Evolved Zombie Type 3",
  T_49_META_TYP_14_I17_D: "Zombie level, 1~3",
  T_49_META_TYP_14_I19_D: "Player's nickname",
  T_49_META_TYP_14_I2_D: "Determine the current player is AI player, AI is usually NPC or PVE monster",
  T_49_META_TYP_14_I20_D: "Percentage of damage dealt when taking damage, can be reduced or increased",
  T_49_META_TYP_14_I21_D: "Player's current EP",
  T_49_META_TYP_14_I22_D: "Player's maximum EP",
  T_49_META_TYP_14_I23_D: "Primary weapon currently in hand.",
  T_49_META_TYP_14_I24_D: "Is Drop on Eliminated",
  T_49_META_TYP_14_I26_D: "Aim Assist Type",
  T_49_META_TYP_14_I27_D: "Allow Lock by Aim Assist",
  T_49_META_TYP_14_I28_D: "Switch voice chat on/off: true to turn off voice, false to turn on voice",
  T_49_META_TYP_14_I29_D: "Switch quick chat: trueClose voice, falseOpen voice",
  T_49_META_TYP_14_I3_D: "Player Status",
  T_49_META_TYP_14_I30_D: "Channel",
  T_49_META_TYP_14_I35_D: "Switch pickup: trueCan't pickup, falseCan pickup",
  T_49_META_TYP_14_I36_D: "Toggle Discard Item: trueCan't discard, falseCan discard",
  T_49_META_TYP_14_I37_D: "Attackable Targets",
  T_49_META_TYP_14_I38_D: "Friendly Players",
  T_49_META_TYP_14_I39_D: "Faction",
  T_49_META_TYP_14_I4_D: "The player's survival time, if the player dies, the time will be recalculated.",
  T_49_META_TYP_14_I40_D: "Number in Faction",
  T_49_META_TYP_14_I41_D: "Camera the player is using",
  T_49_META_TYP_14_I42_D: "Custom Gravity",
  T_49_META_TYP_14_I43_D: "Helmet",
  T_49_META_TYP_14_I44_D: "Vest",
  T_49_META_TYP_14_I5_D: "Player's invincibility",
  T_49_META_TYP_14_I52_D: "User UID",
  T_49_META_TYP_14_I53_D: "Headshot Damage Reduction",
  T_49_META_TYP_14_I54_D: "AVATAR the player is bound to",
  T_49_META_TYP_14_I55_D: "Gender",
  T_49_META_TYP_14_I56_D: "Weapon Skin IDs",
  T_49_META_TYP_14_I57_D: "Player's spwan point",
  T_49_META_TYP_14_I58_D: "Player's resurrection point, if no checkpoints are recorded then the spwan point is used, otherwise checkpoints are used",
  T_49_META_TYP_14_I59_D: "Player's current position",
  T_49_META_TYP_14_I6_D: "The entity of the team the player belongs to",
  T_49_META_TYP_14_I60_D: "The player's current orientation",
  T_49_META_TYP_14_I61_D: "The node used to access the skinned rigs",
  T_49_META_TYP_14_I62_D: "Backpack",
  T_49_META_TYP_14_I63_D: "Temporary Shield Points",
  T_49_META_TYP_14_I64_D: "Vehicle Skin ID",
  T_49_META_TYP_14_I65_D: "Is Skip Stagger Animation",
  T_49_META_TYP_14_I66_D: "Is No Fall Damage",
  T_49_META_TYP_14_I67_D: "Current Handheld Item",
  T_49_META_TYP_14_I68_D: "Item Pickup Banlist",
  T_49_META_TYP_14_I69_D: "Player's resource ID",
  T_49_META_TYP_14_I7_D: "Current checkpoint ID",
  T_49_META_TYP_14_I70_D: "The target to which the Request Purchase message was sent",
  T_49_META_TYP_14_I71_D: "The resource ID of the currently playing Emote",
  T_49_META_TYP_14_I72_D: "Whether the currently playing Emote is looping or not",
  T_49_META_TYP_14_I73_D: "Handling of knockdown status",
  T_49_META_TYP_14_I74_D: "Whether to enable damage skipping, the default is True, which means it's enabled.",
  T_49_META_TYP_14_I76_D: "Whether to quit in the middle of the game",
  T_49_META_TYP_14_I77_D: "Clothing information to be kept when the player transforms into another character",
  T_49_META_TYP_14_I8_D: "ID of the checkpoint the target is traveling to",
  T_49_META_TYP_140_I0_D: "Wave 1",
  T_49_META_TYP_140_I1_D: "Wave 2",
  T_49_META_TYP_140_I2_D: "Wave 3",
  T_49_META_TYP_140_I3_D: "Continuous",
  T_49_META_TYP_141_I0_D: "Loot Soccer Random",
  T_49_META_TYP_141_I1_D: "Loot Soccer Shield",
  T_49_META_TYP_141_I2_D: "Freezing Grenade",
  T_49_META_TYP_142_I0_D: "Loot Soccer",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF Classic (Shooting)",
  T_49_META_TYP_147_I1_D: "Third Person",
  T_49_META_TYP_147_I2_D: "First Person (Shooting)",
  T_49_META_TYP_147_I3_D: "Top-down perspective",
  T_49_META_TYP_147_I4_D: "Horizontal Scroll",
  T_49_META_TYP_147_I5_D: "Custom",
  T_49_META_TYP_147_I6_D: "Backchase",
  T_49_META_TYP_147_I7_D: "Player-controlled, free-moving camera",
  T_49_META_TYP_147_I8_D: "New version of the first person view camera",
  T_49_META_TYP_148_I0_D: "Provide many preset camera types and customized camera types.",
  T_49_META_TYP_148_I1_D: "Field of view is the camera's viewing angle",
  T_49_META_TYP_148_I10_D: "Camera Switch Animation Type",
  T_49_META_TYP_148_I11_D: "Transition time to this camera in milliseconds, only if the switch type is smooth.",
  T_49_META_TYP_148_I12_D: "Motion mode of the camera when there is an occlusion between the camera and the target.",
  T_49_META_TYP_148_I13_D: "How the camera renders the screen",
  T_49_META_TYP_148_I14_D: "Follow object offset reference coordinate system",
  T_49_META_TYP_148_I15_D: "Observing object offset reference coordinate system",
  T_49_META_TYP_148_I16_D: "The camera's rendering layer mask, which allows filtering the camera's rendered objects by visibility level",
  T_49_META_TYP_148_I17_D: "Viewing Angle Restriction",
  T_49_META_TYP_148_I2_D: "Generally refers to the offset of the camera's position from the player's home position, with different meanings for different camera types.",
  T_49_META_TYP_148_I3_D: "FOV is the offset of the camera's focus point from the player's home position, which varies by camera type.",
  T_49_META_TYP_148_I4_D: "Angle of rotation of the camera in the vertical direction",
  T_49_META_TYP_148_I5_D: "The angle of rotation of the camera in the horizontal direction.",
  T_49_META_TYP_148_I7_D: "The target that the camera is following",
  T_49_META_TYP_148_I8_D: "The target that the camera is looking at",
  T_49_META_TYP_148_I9_D: "The player who is using the camera",
  T_49_META_TYP_15_I0_D: "Whether all players in the team are currently dead",
  T_49_META_TYP_15_I1_D: "List of all players in the team",
  T_49_META_TYP_15_I3_D: "Hostile team list",
  T_49_META_TYP_15_I4_D: "List of friendly teams",
  T_49_META_TYP_15_I5_D: "Team number",
  T_49_META_TYP_150_I0_D: "Durability",
  T_49_META_TYP_150_I1_D: "The radius of the hemispheres at the ends of the capsule body.",
  T_49_META_TYP_150_I2_D: "Damage Factor",
  T_49_META_TYP_152_I1_D: "Custom Gravity",
  T_49_META_TYP_152_I2_D: "If or not need to show the trigger, True is show.",
  T_49_META_TYP_154_I0_D: "Cannot be dual-wielded",
  T_49_META_TYP_154_I1_D: "Can only be dual-wielded in combination with the same gun",
  T_49_META_TYP_154_I2_D: "Can be combo dual-wielded with another weapon as well as yourself",
  T_49_META_TYP_155_I0_D: "Level",
  T_49_META_TYP_155_I1_D: "Max. Durability",
  T_49_META_TYP_155_I2_D: "Current Durability",
  T_49_META_TYP_155_I3_D: "Damage Reduction Factor",
  T_49_META_TYP_155_I4_D: "Explode Damage Reduction Factor",
  T_49_META_TYP_155_I5_D: "Can Cost Durability",
  T_49_META_TYP_155_I6_D: "Can Destroy",
  T_49_META_TYP_156_I1_D: "Max. Durability",
  T_49_META_TYP_156_I2_D: "Current Durability",
  T_49_META_TYP_156_I3_D: "Damage Reduction Factor",
  T_49_META_TYP_156_I4_D: "Explode Damage Reduction Factor",
  T_49_META_TYP_156_I5_D: "Can Cost Durability",
  T_49_META_TYP_156_I6_D: "Can Destroy",
  T_49_META_TYP_157_I0_D: "No Animation",
  T_49_META_TYP_157_I1_D: "Smooth",
  T_49_META_TYP_158_I2_D: "UI anchor type enumeration, default value is 9 (Center)",
  T_49_META_TYP_158_I6_D: "Label Key",
  T_49_META_TYP_158_I7_D: "Label Params",
  T_49_META_TYP_158_I8_D: "Tweener Enabled",
  T_49_META_TYP_16_I1_D: "Item ID of the entity",
  T_49_META_TYP_16_I2_D: "Only for static loading of objects, to determine if the NavMesh is statically generated.",
  T_49_META_TYP_16_I3_D: "Whether it is dynamic blocking of NavMesh or not",
  T_49_META_TYP_16_I4_D: "Asynchronous loading",
  T_49_META_TYP_160_I0_D: "Brick A",
  T_49_META_TYP_160_I1_D: "Tile A",
  T_49_META_TYP_160_I10_D: "Sand A",
  T_49_META_TYP_160_I11_D: "Snow A",
  T_49_META_TYP_160_I12_D: "Wood A",
  T_49_META_TYP_160_I13_D: "Stone A",
  T_49_META_TYP_160_I14_D: "Lawn B",
  T_49_META_TYP_160_I15_D: "Brick B",
  T_49_META_TYP_160_I16_D: "Brick C",
  T_49_META_TYP_160_I17_D: "Clear",
  T_49_META_TYP_160_I2_D: "Tile B",
  T_49_META_TYP_160_I3_D: "Tile C",
  T_49_META_TYP_160_I4_D: "Bamboo A",
  T_49_META_TYP_160_I5_D: "Cement A",
  T_49_META_TYP_160_I6_D: "Container A",
  T_49_META_TYP_160_I7_D: "Lawn A",
  T_49_META_TYP_160_I8_D: "Ice A",
  T_49_META_TYP_160_I9_D: "Magma A",
  T_49_META_TYP_165_I0_D: "Whether to enable collision",
  T_49_META_TYP_165_I1_D: "Whether or not to act as a trigger",
  T_49_META_TYP_165_I2_D: "Physical layers, configure layers in the physics module, up to 16.",
  T_49_META_TYP_166_I0_D: "Emote1",
  T_49_META_TYP_166_I1_D: "Emote2",
  T_49_META_TYP_166_I2_D: "Emote3",
  T_49_META_TYP_166_I3_D: "Emote4",
  T_49_META_TYP_166_I4_D: "Emote5",
  T_49_META_TYP_167_I0_D: "VFX Texture Type",
  T_49_META_TYP_170_I0_D: "Visible or not, client stops rendering the target when it is not visible.",
  T_49_META_TYP_170_I1_D: "Visibility level, value in the range [0,15], affects the visibility in the camera.",
  T_49_META_TYP_171_I0_D: "Energy",
  T_49_META_TYP_172_I0_D: "Number of bullets",
  T_49_META_TYP_173_I0_D: "Extra Backpack Capacity",
  T_49_META_TYP_173_I1_D: "Priority of Skin configuration outside of the player's station.",
  T_49_META_TYP_173_I2_D: "Skin ID of the backpack, Skin configuration of the backpack itself",
  T_49_META_TYP_174_I2_D: "Max. Damage",
  T_49_META_TYP_174_I4_D: "Throw Speed",
  T_49_META_TYP_174_I5_D: "Explosion delay, in seconds",
  T_49_META_TYP_174_I6_D: "Self-Damage Factor",
  T_49_META_TYP_174_I7_D: "Friendly Fire DMG Coeff.",
  T_49_META_TYP_174_I8_D: "Ratio Vehicle Factor",
  T_49_META_TYP_174_I9_D: "Skin",
  T_49_META_TYP_175_I0_D: "Freeze Zone Radius",
  T_49_META_TYP_175_I1_D: "Frozen area duration in seconds",
  T_49_META_TYP_176_I0_D: "Weapon's primary type",
  T_49_META_TYP_176_I1_D: "Weapon Subtype",
  T_49_META_TYP_177_I0_D: "When there is an obstacle between the camera and the object to be followed, the camera will not change.",
  T_49_META_TYP_177_I1_D: "When there is an obstacle between the camera and the object to follow, the camera will be pushed closer to the object to follow.",
  T_49_META_TYP_177_I2_D: "When there is an occlusion between the camera and the object, the occlusion will become translucent.",
  T_49_META_TYP_178_I0_D: "When the camera looks at the object, the near object is big and the far object is small",
  T_49_META_TYP_178_I1_D: "Near and far objects are the same size when the camera is looking at them.",
  T_49_META_TYP_184_I0_D: "The UUID of the resource to be rendered.",
  T_49_META_TYP_185_I0_D: "Model mesh to use for rendering",
  T_49_META_TYP_185_I1_D: "The list of materials to use for rendering",
  T_49_META_TYP_187_I0_D: "Item ID",
  T_49_META_TYP_190_I0_D: "Open status",
  T_49_META_TYP_190_I1_D: "Match result",
  T_49_META_TYP_190_I10_D: "Scores1",
  T_49_META_TYP_190_I11_D: "Scores2",
  T_49_META_TYP_190_I12_D: "Scores3",
  T_49_META_TYP_190_I13_D: "Win MVPs",
  T_49_META_TYP_190_I14_D: "Lose MVPs",
  T_49_META_TYP_190_I15_D: "Show Match Details",
  T_49_META_TYP_190_I16_D: "Show Map Ratings",
  T_49_META_TYP_190_I17_D: "Show Gift",
  T_49_META_TYP_190_I18_D: "Show Report",
  T_49_META_TYP_190_I19_D: "Show Replay",
  T_49_META_TYP_190_I20_D: "Show Share",
  T_49_META_TYP_190_I21_D: "Show Lobby",
  T_49_META_TYP_190_I22_D: "Show Like",
  T_49_META_TYP_190_I23_D: "Show Add Friend",
  T_49_META_TYP_190_I24_D: "Show Ecconomy",
  T_49_META_TYP_190_I4_D: "Left Team",
  T_49_META_TYP_190_I5_D: "Right Team",
  T_49_META_TYP_190_I6_D: "Player Rank",
  T_49_META_TYP_190_I9_D: "Titles",
  T_49_META_TYP_191_I0_D: "Center Range",
  T_49_META_TYP_191_I4_D: "Center flash duration in milliseconds",
  T_49_META_TYP_191_I5_D: "Edge flash duration in milliseconds",
  T_49_META_TYP_191_I6_D: "Flashbang Hit Effect Switch",
  T_49_META_TYP_192_I3_D: "Duration of effect, in seconds",
  T_49_META_TYP_193_I1_D: "Match Title Left",
  T_49_META_TYP_193_I10_D: "Scores1",
  T_49_META_TYP_193_I11_D: "Scores2",
  T_49_META_TYP_193_I12_D: "Scores3",
  T_49_META_TYP_193_I13_D: "Scores4",
  T_49_META_TYP_193_I14_D: "Scores5",
  T_49_META_TYP_193_I15_D: "Win MVPs",
  T_49_META_TYP_193_I16_D: "Lose MVPs",
  T_49_META_TYP_193_I17_D: "Show Match Details",
  T_49_META_TYP_193_I18_D: "Show Map Ratings",
  T_49_META_TYP_193_I19_D: "Show Gift",
  T_49_META_TYP_193_I2_D: "Match Title Right",
  T_49_META_TYP_193_I20_D: "Show Report",
  T_49_META_TYP_193_I21_D: "Show Replay",
  T_49_META_TYP_193_I22_D: "Show Share",
  T_49_META_TYP_193_I23_D: "Show Lobby",
  T_49_META_TYP_193_I24_D: "Show Like",
  T_49_META_TYP_193_I25_D: "Show Add Friend",
  T_49_META_TYP_193_I26_D: "Show Ecconomy",
  T_49_META_TYP_193_I3_D: "Match result",
  T_49_META_TYP_193_I4_D: "Team Rank",
  T_49_META_TYP_193_I5_D: "Player Rank",
  T_49_META_TYP_193_I6_D: "Name of the team",
  T_49_META_TYP_193_I7_D: "Main Score Title",
  T_49_META_TYP_193_I8_D: "Main Scores",
  T_49_META_TYP_193_I9_D: "Titles",
  T_49_META_TYP_194_I0_D: "Time for the mine to take effect, in seconds",
  T_49_META_TYP_194_I1_D: "Trigger radius",
  T_49_META_TYP_194_I2_D: "Length of time it takes to trigger a mine within the mine's range, in seconds",
  T_49_META_TYP_194_I3_D: "Can Self Trigger",
  T_49_META_TYP_194_I4_D: "Can Teammates Trigger",
  T_49_META_TYP_194_I5_D: "Can Triggered by Vehicle",
  T_49_META_TYP_194_I6_D: "Duration of the mine's existence, which automatically explodes when it ends, from the time it is dropped, in units of seconds",
  T_49_META_TYP_194_I7_D: "Is Attackable",
  T_49_META_TYP_194_I8_D: "Life value",
  T_49_META_TYP_195_I0_D: "Once",
  T_49_META_TYP_195_I2_D: "Reciprocation",
  T_49_META_TYP_197_I0_D: "Whether the wave is playing or not",
  T_49_META_TYP_197_I1_D: "Flag bit",
  T_49_META_TYP_197_I2_D: "If checked, it will be played automatically upon creation.",
  T_49_META_TYP_198_I0_D: "The prop id of the accessory.",
  T_49_META_TYP_199_I0_D: "Max EP",
  T_49_META_TYP_199_I1_D: "Energy Cost",
  T_49_META_TYP_199_I10_D: "Fall Damage Ratio",
  T_49_META_TYP_199_I11_D: "Current Energy",
  T_49_META_TYP_199_I2_D: "UpEnergy Cost",
  T_49_META_TYP_199_I3_D: "Sprint Energy Cost",
  T_49_META_TYP_199_I4_D: "Rush Energy Cost",
  T_49_META_TYP_199_I5_D: "Base Horizontal Speed",
  T_49_META_TYP_199_I6_D: "Sprint Horizontal Speed",
  T_49_META_TYP_199_I7_D: "Base Vertical Speed",
  T_49_META_TYP_199_I8_D: "Sprint Vertical Speed",
  T_49_META_TYP_199_I9_D: "Sprint Distance",
  T_49_META_TYP_200_I0_D: "Area ID",
  T_49_META_TYP_200_I1_D: "Game ID",
  T_49_META_TYP_201_I0_D: "Percentage of slowdown: Percentage of slowdown of movement speed in open water for water objects",
  T_49_META_TYP_203_I0_D: "target entity",
  T_49_META_TYP_203_I1_D: "Prop ID",
  T_49_META_TYP_203_I10_D: "The moment when the game server starts ticking",
  T_49_META_TYP_203_I11_D: "Start Value",
  T_49_META_TYP_203_I12_D: "End Value",
  T_49_META_TYP_203_I13_D: "Percentage passed",
  T_49_META_TYP_203_I4_D: "Tween Style",
  T_49_META_TYP_203_I6_D: "Duration (s)",
  T_49_META_TYP_203_I7_D: "Is Reverse",
  T_49_META_TYP_203_I8_D: "Control Points",
  T_49_META_TYP_203_I9_D: "Forced synchronization of the game server state",
  T_49_META_TYP_204_I0_D: "Max. Double Jump Height",
  T_49_META_TYP_204_I1_D: "Fall Damage Percentage",
  T_49_META_TYP_204_I2_D: "Energy Recovery",
  T_49_META_TYP_204_I3_D: "Energy consumption",
  T_49_META_TYP_204_I4_D: "Max. Energy",
  T_49_META_TYP_205_I0_D: "Min. Fly Height",
  T_49_META_TYP_205_I1_D: "Min. End Height",
  T_49_META_TYP_205_I2_D: "Horizontal Glide Speed",
  T_49_META_TYP_205_I3_D: "Vertical Glide Speed",
  T_49_META_TYP_205_I4_D: "Fall Speed",
  T_49_META_TYP_205_I5_D: "Turning Speed",
  T_49_META_TYP_205_I6_D: "Fly Max. Height",
  T_49_META_TYP_205_I7_D: "Overheight Fall Speed",
  T_49_META_TYP_205_I8_D: "Speed change acceleration",
  T_49_META_TYP_206_I0_D: "Velocity",
  T_49_META_TYP_206_I1_D: "Acceleration",
  T_49_META_TYP_206_I10_D: "Maximum steering angle at high speed",
  T_49_META_TYP_206_I11_D: "Tween base rate of high speed steering angle",
  T_49_META_TYP_206_I2_D: "Sprint Speed",
  T_49_META_TYP_206_I3_D: "Duration of sprint, in seconds",
  T_49_META_TYP_206_I4_D: "Sprint cooldown, in seconds",
  T_49_META_TYP_206_I6_D: "Jump CD, in seconds",
  T_49_META_TYP_206_I7_D: "Sprint CD after boarding, in seconds",
  T_49_META_TYP_206_I8_D: "Get On Boost CD Switch",
  T_49_META_TYP_206_I9_D: "Get on board CD, in seconds",
  T_49_META_TYP_207_I1_D: "Start Index",
  T_49_META_TYP_207_I2_D: "End Position",
  T_49_META_TYP_207_I3_D: "Slide ID",
  T_49_META_TYP_207_I4_D: "Group ID",
  T_49_META_TYP_207_I5_D: "End or not",
  T_49_META_TYP_21_I0_D: "The base level of the UI",
  T_49_META_TYP_210_I1_D: "Initial Velocity",
  T_49_META_TYP_210_I2_D: "Acceleration",
  T_49_META_TYP_210_I3_D: "Max. Displacement",
  T_49_META_TYP_210_I4_D: "InitialWorldPosition",
  T_49_META_TYP_210_I5_D: "Forced synchronization of position information by game server",
  T_49_META_TYP_211_I0_D: "Local Position",
  T_49_META_TYP_211_I1_D: "World Position",
  T_49_META_TYP_212_I0_D: "Self",
  T_49_META_TYP_212_I2_D: "Offset coordinate",
  T_49_META_TYP_213_I0_D: "Self",
  T_49_META_TYP_213_I2_D: "Offset coordinate",
  T_49_META_TYP_215_I0_D: "Victory",
  T_49_META_TYP_215_I1_D: "Defeat",
  T_49_META_TYP_215_I2_D: "Booyah",
  T_49_META_TYP_215_I3_D: "Draw",
  T_49_META_TYP_218_I0_D: "Intensity",
  T_49_META_TYP_218_I1_D: "Range",
  T_49_META_TYP_218_I2_D: "Light color",
  T_49_META_TYP_22_I0_D: "Displayed if on is true, off otherwise",
  T_49_META_TYP_22_I1_D: "Prefab ID",
  T_49_META_TYP_22_I2_D: "The ID of the current largest widget",
  T_49_META_TYP_22_I3_D: "Base level of UI",
  T_49_META_TYP_22_I4_D: "Enable Player View",
  T_49_META_TYP_22_I5_D: "World Position",
  T_49_META_TYP_22_I6_D: "Whether or not it is in the Scene",
  T_49_META_TYP_22_I7_D: "Rotation in the world coordinate system",
  T_49_META_TYP_22_I8_D: "Zoom in the world coordinate system",
  T_49_META_TYP_221_I0_D: "The larger the value, the slower the speed of gear change.",
  T_49_META_TYP_222_I0_D: "Gear switching delay, the larger this value is, the slower the gear changes.",
  T_49_META_TYP_225_I0_D: "Turret Damage",
  T_49_META_TYP_225_I1_D: "Damage Interval (s)",
  T_49_META_TYP_225_I10_D: "Fire only at an angle",
  T_49_META_TYP_225_I11_D: "Damage Reduction Rate",
  T_49_META_TYP_225_I12_D: "Armor Penetration",
  T_49_META_TYP_225_I2_D: "Accuracy",
  T_49_META_TYP_225_I3_D: "Range",
  T_49_META_TYP_225_I4_D: "Angular Speed",
  T_49_META_TYP_225_I5_D: "Angle Up",
  T_49_META_TYP_225_I6_D: "Angle Down",
  T_49_META_TYP_225_I7_D: "Max. HP",
  T_49_META_TYP_225_I8_D: "Life Time (s)",
  T_49_META_TYP_225_I9_D: "Max. Turret Count",
  T_49_META_TYP_226_I0_D: "Turret current life value",
  T_49_META_TYP_226_I1_D: "Enable Attack",
  T_49_META_TYP_227_I0_D: "Simple Widget",
  T_49_META_TYP_227_I1_D: "Image Widget",
  T_49_META_TYP_227_I10_D: "Texture Widget",
  T_49_META_TYP_227_I11_D: "Profile Widget",
  T_49_META_TYP_227_I12_D: "Toggle Widget",
  T_49_META_TYP_227_I13_D: "Touch Pad Widget",
  T_49_META_TYP_227_I14_D: "Joystick Widget",
  T_49_META_TYP_227_I15_D: "Social Button Widget",
  T_49_META_TYP_227_I2_D: "Label Widget",
  T_49_META_TYP_227_I3_D: "Button Widget",
  T_49_META_TYP_227_I4_D: "Input Label Widget",
  T_49_META_TYP_227_I5_D: "Panel",
  T_49_META_TYP_227_I6_D: "Scroll Panel",
  T_49_META_TYP_227_I7_D: "Grid",
  T_49_META_TYP_227_I8_D: "Layout Widget",
  T_49_META_TYP_227_I9_D: "Container Widget",
  T_49_META_TYP_231_I0_D: "Durability Recovery",
  T_49_META_TYP_231_I1_D: "Effective time interval, in seconds",
  T_49_META_TYP_233_I2_D: "Time to expiration, in seconds",
  T_49_META_TYP_233_I4_D: "Icon resource name",
  T_49_META_TYP_234_I0_D: "Trigger time, in seconds",
  T_49_META_TYP_234_I1_D: "Can Self Trigger",
  T_49_META_TYP_234_I10_D: "Current life value",
  T_49_META_TYP_234_I2_D: "Can Teammates Trigger",
  T_49_META_TYP_234_I3_D: "Can Triggered by Vehicle",
  T_49_META_TYP_234_I4_D: "Duration in seconds",
  T_49_META_TYP_234_I5_D: "Is Attackable",
  T_49_META_TYP_234_I6_D: "Life value",
  T_49_META_TYP_235_I0_D: "Maximum life value",
  T_49_META_TYP_235_I2_D: "Max. Count",
  T_49_META_TYP_237_I0_D: "Throw Speed",
  T_49_META_TYP_237_I1_D: "Player Traction Speed",
  T_49_META_TYP_238_I0_D: "Spray Color",
  T_49_META_TYP_239_I0_D: "Initial speed",
  T_49_META_TYP_239_I1_D: "Acceleration speed (e.g. gravity)",
  T_49_META_TYP_24_I0_D: "Melee",
  T_49_META_TYP_24_I1_D: "Gun",
  T_49_META_TYP_24_I10_D: "Airdrop hit damage, monster suicide damage",
  T_49_META_TYP_24_I11_D: "Burning Damage on Vehicle Explosion",
  T_49_META_TYP_24_I12_D: "Oil Drum Explosion",
  T_49_META_TYP_24_I13_D: "Missile-Type Weapon",
  T_49_META_TYP_24_I14_D: "Monster",
  T_49_META_TYP_24_I15_D: "Damage Zone",
  T_49_META_TYP_24_I17_D: "Character Skill",
  T_49_META_TYP_24_I2_D: "Throw Attack",
  T_49_META_TYP_24_I3_D: "Safe Zone",
  T_49_META_TYP_24_I4_D: "Vehicle",
  T_49_META_TYP_24_I5_D: "Falling",
  T_49_META_TYP_24_I6_D: "KillZone",
  T_49_META_TYP_24_I7_D: "Exit",
  T_49_META_TYP_24_I8_D: "Disconnect",
  T_49_META_TYP_24_I9_D: "Vehicle Explosion",
  T_49_META_TYP_241_I0_D: "Traction speed",
  T_49_META_TYP_241_I1_D: "Swing speed",
  T_49_META_TYP_241_I2_D: "Turn on traction button",
  T_49_META_TYP_241_I3_D: "Turn on swing button",
  T_49_META_TYP_241_I4_D: "Motion anchor point",
  T_49_META_TYP_241_I5_D: "Swing Exit Acceleration",
  T_49_META_TYP_242_I2_D: "Left Effect Active",
  T_49_META_TYP_242_I3_D: "Right Effect Active",
  T_49_META_TYP_242_I4_D: "Central Line Active",
  T_49_META_TYP_242_I5_D: "Value",
  T_49_META_TYP_242_I7_D: "UI position, only the XY component is active",
  T_49_META_TYP_242_I8_D: "Position of the median [0,1]",
  T_49_META_TYP_243_I0_D: "Top Wear",
  T_49_META_TYP_243_I1_D: "Bottom Wear",
  T_49_META_TYP_243_I2_D: "Shoes",
  T_49_META_TYP_243_I3_D: "Facepaint",
  T_49_META_TYP_243_I4_D: "Headwear",
  T_49_META_TYP_243_I5_D: "Bodysuit",
  T_49_META_TYP_243_I6_D: "Facepaint",
  T_49_META_TYP_244_I0_D: "Text content to be displayed",
  T_49_META_TYP_244_I10_D: "List of players who can see this entity",
  T_49_META_TYP_244_I11_D: "Display level",
  T_49_META_TYP_244_I2_D: "Follow Target",
  T_49_META_TYP_244_I3_D: "When depth is ignored it can be displayed through the wall, otherwise it won't work",
  T_49_META_TYP_244_I4_D: "Always Facing Camera",
  T_49_META_TYP_244_I5_D: "When set to true, when the position is outside the screen, it will be displayed inside the screen.",
  T_49_META_TYP_244_I6_D: "Font Style",
  T_49_META_TYP_244_I7_D: "Font type",
  T_49_META_TYP_244_I8_D: "Font size",
  T_49_META_TYP_245_I0_D: "Effect Resource Path",
  T_49_META_TYP_245_I11_D: "Display Layers",
  T_49_META_TYP_245_I3_D: "When ignore depth, it can be displayed through the wall, otherwise it won't work.",
  T_49_META_TYP_245_I4_D: "When set to true, when the position is outside the screen, it will be displayed inside the screen.",
  T_49_META_TYP_245_I5_D: "Always Facing Camera",
  T_49_META_TYP_245_I6_D: "Render Type",
  T_49_META_TYP_245_I7_D: "Width",
  T_49_META_TYP_246_I0_D: "Orange",
  T_49_META_TYP_246_I1_D: "Purple",
  T_49_META_TYP_246_I2_D: "Red",
  T_49_META_TYP_246_I3_D: "Green",
  T_49_META_TYP_246_I4_D: "Blue",
  T_49_META_TYP_247_I1_D: "Sprint",
  T_49_META_TYP_247_I14_D: "Emote",
  T_49_META_TYP_247_I15_D: "Quick Chat",
  T_49_META_TYP_247_I16_D: "Pickups",
  T_49_META_TYP_247_I17_D: "Quick Chat Show",
  T_49_META_TYP_247_I18_D: "HP",
  T_49_META_TYP_247_I19_D: "EP",
  T_49_META_TYP_247_I2_D: "Attack",
  T_49_META_TYP_247_I20_D: "Armor",
  T_49_META_TYP_247_I21_D: "Reload",
  T_49_META_TYP_247_I22_D: "Quick Change Button",
  T_49_META_TYP_247_I23_D: "Carrier Speaker Button",
  T_49_META_TYP_247_I24_D: "Enable/disable voice (microphone) button",
  T_49_META_TYP_247_I25_D: "Enable/disable marker button",
  T_49_META_TYP_247_I27_D: "Enable/disable network signal button",
  T_49_META_TYP_247_I28_D: "Active Skill",
  T_49_META_TYP_247_I29_D: "Crosshair",
  T_49_META_TYP_247_I3_D: "Jump",
  T_49_META_TYP_247_I30_D: "Passive Skill",
  T_49_META_TYP_247_I4_D: "Killing Tips",
  T_49_META_TYP_247_I5_D: "Weapon Slot",
  T_49_META_TYP_247_I6_D: "Mini Map",
  T_49_META_TYP_247_I7_D: "Backpack UI",
  T_49_META_TYP_247_I8_D: "Medical Items",
  T_49_META_TYP_247_I9_D: "Displayed when True, otherwise turned off",
  T_49_META_TYP_249_I3_D: "Demolition weapons",
  T_49_META_TYP_249_I5_D: "HeavyWeapon",
  T_49_META_TYP_249_I8_D: "Freeze Bomb",
  T_49_META_TYP_249_I9_D: "DummyGrenade",
  T_49_META_TYP_25_I0_D: "Index of the current phase, corresponding to the index in the flow editor",
  T_49_META_TYP_25_I1_D: "Start time of the current phase, in ms.",
  T_49_META_TYP_25_I2_D: "The end time of the current phase in ms.",
  T_49_META_TYP_25_I3_D: "Duration of the current phase in ms.",
  T_49_META_TYP_250_I1_D: "Special effect color, RGBA four channels, single channel value range 0~255, stored in an Int32.",
  T_49_META_TYP_250_I3_D: "VFX Texture Type",
  T_49_META_TYP_250_I4_D: "Diffuse Alpha",
  T_49_META_TYP_2500_I1_D: "Is Default Spawn Point",
  T_49_META_TYP_2500_I3_D: "Whether or not a player has already been born in the birth point area.",
  T_49_META_TYP_2500_I4_D: "The coordinates of the currently assignable birth point location",
  T_49_META_TYP_2502_I0_D: "Whether it is a death trigger, when it is not a death trigger it is an invincibility trigger. (This is a legacy issue from OB32, please split the function in the future!)",
  T_49_META_TYP_2502_I1_D: "Whether to show trigger border, true for show",
  T_49_META_TYP_2503_I0_D: "Checkpoint ID",
  T_49_META_TYP_2503_I2_D: "Location of checkpoints",
  T_49_META_TYP_2507_I0_D: "Which camp the tower belongs to, if it is the same as the player, it won't attack the player.",
  T_49_META_TYP_2507_I1_D: "HP",
  T_49_META_TYP_2507_I10_D: "Object ID",
  T_49_META_TYP_2507_I2_D: "Max. HP",
  T_49_META_TYP_2507_I3_D: "Attack damage, the damage that can be done to the player by a single attack.",
  T_49_META_TYP_2507_I4_D: "The interval between attacks, in seconds.",
  T_49_META_TYP_2507_I5_D: "Attacks can be made in a radius from the center of the tower.",
  T_49_META_TYP_2507_I6_D: "Damage reduction rate, a decimal number less than 1, the final damage is the damage multiplied by (1 - damage reduction rate)",
  T_49_META_TYP_2507_I7_D: "Attack Target",
  T_49_META_TYP_2507_I8_D: "Angle",
  T_49_META_TYP_2507_I9_D: "Mini Sentry Status",
  T_49_META_TYP_2508_I0_D: "How many zombies will be spawned in each wave",
  T_49_META_TYP_2508_I1_D: "How many waves of zombies will be spawned in total",
  T_49_META_TYP_2508_I2_D: "Whether to spawn continuously, but there will be an upper limit for the same screen.",
  T_49_META_TYP_2508_I3_D: "How many waves will be spawned in the current wave?",
  T_49_META_TYP_2508_I5_D: "What kind of zombies are spawned in the current wave",
  T_49_META_TYP_2508_I6_D: "Whether the AI drops equipment or items when it dies.",
  T_49_META_TYP_2508_I7_D: "Start Spawn Time (s)",
  T_49_META_TYP_2508_I8_D: "The time interval between the next wave and the previous wave.",
  T_49_META_TYP_2509_I0_D: "The number of unit bodies that will be generated in each wave",
  T_49_META_TYP_2509_I1_D: "How many waves of unit generators will be generated in total",
  T_49_META_TYP_2509_I2_D: "How many waves are currently generated",
  T_49_META_TYP_2509_I4_D: "Which entity will be used as a template for each wave of generation",
  T_49_META_TYP_2509_I5_D: "When the units will start generating",
  T_49_META_TYP_2509_I6_D: "Whether or not to spawn consecutively, but there will be an upper limit of the same screen",
  T_49_META_TYP_2509_I7_D: "The time interval between the next wave and the previous wave.",
  T_49_META_TYP_2509_I8_D: "The prefabID of the template",
  T_49_META_TYP_2510_I0_D: "Spawn Point Count",
  T_49_META_TYP_252_I1_D: "Left Icon",
  T_49_META_TYP_252_I2_D: "Left Text",
  T_49_META_TYP_252_I3_D: "Left Score",
  T_49_META_TYP_252_I5_D: "Right Icon",
  T_49_META_TYP_252_I6_D: "Right Text",
  T_49_META_TYP_252_I7_D: "Right Score",
  T_49_META_TYP_252_I8_D: "Progress [0,1]",
  T_49_META_TYP_253_I0_D: "Select Icon",
  T_49_META_TYP_253_I1_D: "Text",
  T_49_META_TYP_253_I2_D: "Show Effect",
  T_49_META_TYP_253_I3_D: "UI position",
  T_49_META_TYP_254_I1_D: "For example, 1.25 means 1.25 times the normal speed.",
  T_49_META_TYP_254_I2_D: "Color",
  T_49_META_TYP_256_I0_D: "Completely stationary. Minimum Performance",
  T_49_META_TYP_256_I1_D: "Normal force application. Least performance",
  T_49_META_TYP_256_I2_D: "Motion can be controlled by scripting and can be considered as mass infinite",
  T_49_META_TYP_257_I0_D: "Functions of different types of rigid bodies",
  T_49_META_TYP_257_I1_D: "Use Gravity",
  T_49_META_TYP_257_I2_D: "Mass (kg), the minimum effective mass is 0.001kg, if it is 0, then it is infinite mass and will not move under force.",
  T_49_META_TYP_257_I3_D: "Position of the center of gravity, local coordinate system",
  T_49_META_TYP_257_I4_D: "Linear velocity of rigid body motion",
  T_49_META_TYP_257_I5_D: "Angular velocity of rigid body motion",
  T_49_META_TYP_257_I6_D: "Coefficient of natural decay of linear velocity, the larger the coefficient, the faster the decay of velocity.",
  T_49_META_TYP_257_I7_D: "Angular velocity natural decay coefficient, the larger the coefficient, the faster the velocity decays.",
  T_49_META_TYP_257_I8_D: "The constraints imposed on the rigid body, a collection of RigidbodyConstrainType.",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "Background",
  T_49_META_TYP_259_I1_D: "Text",
  T_49_META_TYP_259_I2_D: "UI position",
  T_49_META_TYP_259_I4_D: "Text Color",
  T_49_META_TYP_260_I0_D: "Select Icon",
  T_49_META_TYP_260_I1_D: "Progress bar color",
  T_49_META_TYP_260_I2_D: "Value",
  T_49_META_TYP_260_I3_D: "Speed in m/s",
  T_49_META_TYP_260_I4_D: "Whether to display special effects",
  T_49_META_TYP_260_I5_D: "UI position [0,1].",
  T_49_META_TYP_260_I6_D: "Initial progress of the skill, value [0, 1], the progress will be synchronized to the current progress immediately after the UI is created.",
  T_49_META_TYP_260_I7_D: "Effect Color",
  T_49_META_TYP_260_I8_D: "Set the object scaling value",
  T_49_META_TYP_265_I1_D: "Background fill or not",
  T_49_META_TYP_265_I2_D: "Background Name",
  T_49_META_TYP_265_I3_D: "Background Color",
  T_49_META_TYP_265_I5_D: "BgAlpha",
  T_49_META_TYP_265_I6_D: "Crop type",
  T_49_META_TYP_265_I7_D: "Mask type is the name of the image selected for masking",
  T_49_META_TYP_265_I8_D: "Edge softening unit",
  T_49_META_TYP_267_I0_D: "Scroll start point, default is top left corner.",
  T_49_META_TYP_267_I1_D: "Support multiple scrolling directions",
  T_49_META_TYP_267_I10_D: "Horizontal Bar",
  T_49_META_TYP_267_I11_D: "Show position",
  T_49_META_TYP_267_I2_D: "XY direction drag component",
  T_49_META_TYP_267_I3_D: "Support multiple dragging effects",
  T_49_META_TYP_267_I4_D: "Scroll factor, the larger the value, the faster the scrolling.",
  T_49_META_TYP_267_I5_D: "Inertia factor, the larger the value, the larger the inertia when scrolling.",
  T_49_META_TYP_267_I6_D: "If or not the drag is limited to the viewport, default is checked.",
  T_49_META_TYP_267_I7_D: "When checked, the drag will start to move slowly, if unchecked, the drag will start to move at the speed of the mouse.",
  T_49_META_TYP_267_I8_D: "Exit dragging when it fits in the viewport.",
  T_49_META_TYP_267_I9_D: "Vertical Bar",
  T_49_META_TYP_268_I0_D: "Default",
  T_49_META_TYP_268_I1_D: "Close",
  T_49_META_TYP_268_I2_D: "Show",
  T_49_META_TYP_269_I0_D: "Owner",
  T_49_META_TYP_269_I1_D: "Set ID",
  T_49_META_TYP_269_I2_D: "Headwear ID",
  T_49_META_TYP_269_I3_D: "Face ID",
  T_49_META_TYP_269_I4_D: "Makeup ID",
  T_49_META_TYP_269_I5_D: "Upper Body ID",
  T_49_META_TYP_269_I6_D: "Bottom ID",
  T_49_META_TYP_269_I7_D: "Shoe ID",
  T_49_META_TYP_272_I0_D: "Female",
  T_49_META_TYP_272_I1_D: "Male",
  T_49_META_TYP_273_I0_D: "World coordinates of the center of the mini-map",
  T_49_META_TYP_273_I1_D: "Size of the mini-map, same width and height",
  T_49_META_TYP_273_I2_D: "Enable or disable the depth map display mode of the mini-map",
  T_49_META_TYP_274_I1_D: "Zoom size",
  T_49_META_TYP_274_I4_D: "Icon display level",
  T_49_META_TYP_275_I0_D: "Skeleton Scale",
  T_49_META_TYP_275_I1_D: "World coordinates of rig nodes",
  T_49_META_TYP_276_I0_D: "Head",
  T_49_META_TYP_276_I1_D: "Left Arm",
  T_49_META_TYP_276_I2_D: "Left Hand",
  T_49_META_TYP_276_I3_D: "Right Arm",
  T_49_META_TYP_276_I4_D: "Right Hand",
  T_49_META_TYP_276_I5_D: "Torso",
  T_49_META_TYP_276_I6_D: "Left Leg",
  T_49_META_TYP_276_I7_D: "Left Foot",
  T_49_META_TYP_276_I8_D: "Right Leg",
  T_49_META_TYP_276_I9_D: "Right Foot",
  T_49_META_TYP_277_I1_D: "Distance for camera ray detection",
  T_49_META_TYP_277_I2_D: "Collision layer mask for camera ray detection",
  T_49_META_TYP_277_I3_D: "Button position offset",
  T_49_META_TYP_277_I4_D: "Icon resource ID",
  T_49_META_TYP_277_I5_D: "Click area size",
  T_49_META_TYP_277_I6_D: "Whether objects are displayed at the target point",
  T_49_META_TYP_277_I7_D: "Objects displayed at the target point",
  T_49_META_TYP_278_I0_D: "Target entity for generating map pixels",
  T_49_META_TYP_28_I0_D: "Whether or not the team can reset every round.",
  T_49_META_TYP_280_I0_D: "Sphere radius",
  T_49_META_TYP_281_I0_D: "The radius of the hemispheres at both ends of the capsule.",
  T_49_META_TYP_29_I0_D: "Sphere",
  T_49_META_TYP_29_I1_D: "Light Beam",
  T_49_META_TYP_29_I10_D: "A pillar of light under the feet, now used for feedback when entering the finish line",
  T_49_META_TYP_29_I11_D: "Freeze",
  T_49_META_TYP_29_I12_D: "Light",
  T_49_META_TYP_29_I13_D: "Updraft",
  T_49_META_TYP_29_I14_D: "Gas Explosion",
  T_49_META_TYP_29_I15_D: "Hider Eliminated",
  T_49_META_TYP_29_I16_D: "Rampage",
  T_49_META_TYP_29_I17_D: "Clone Death",
  T_49_META_TYP_29_I18_D: "Shooting Feedback",
  T_49_META_TYP_29_I19_D: "Clone Death",
  T_49_META_TYP_29_I2_D: "Boom",
  T_49_META_TYP_29_I20_D: "Clone",
  T_49_META_TYP_29_I21_D: "Portal",
  T_49_META_TYP_29_I22_D: "Flashbang Smoke",
  T_49_META_TYP_29_I23_D: "Fireball",
  T_49_META_TYP_29_I24_D: "Burning in a Loop",
  T_49_META_TYP_29_I25_D: "Poison Gas",
  T_49_META_TYP_29_I26_D: "Heart",
  T_49_META_TYP_29_I29_D: "Door",
  T_49_META_TYP_29_I30_D: "Fireworks",
  T_49_META_TYP_29_I31_D: "Running Shoes VFX",
  T_49_META_TYP_29_I32_D: "Explosion VFX",
  T_49_META_TYP_29_I33_D: "Spawn Point VFX",
  T_49_META_TYP_29_I34_D: "Laser VFX",
  T_49_META_TYP_29_I35_D: "Skill Cast VFX",
  T_49_META_TYP_29_I36_D: "Bullet VFX",
  T_49_META_TYP_29_I37_D: "Bullet Hit VFX",
  T_49_META_TYP_29_I38_D: "Shooting VFX",
  T_49_META_TYP_29_I39_D: "Skill VFX",
  T_49_META_TYP_29_I40_D: "Halo",
  T_49_META_TYP_29_I41_D: "Bubbles",
  T_49_META_TYP_29_I42_D: "Smoke and Dust",
  T_49_META_TYP_29_I43_D: "Flying Debris",
  T_49_META_TYP_29_I44_D: "Lines",
  T_49_META_TYP_29_I45_D: "Flicker",
  T_49_META_TYP_29_I47_D: "Rising Particles",
  T_49_META_TYP_29_I48_D: "Smoke",
  T_49_META_TYP_29_I49_D: "Talisman",
  T_49_META_TYP_29_I50_D: "Frozen Area",
  T_49_META_TYP_29_I51_D: "Fog",
  T_49_META_TYP_29_I52_D: "Snowflake",
  T_49_META_TYP_29_I53_D: "Fire",
  T_49_META_TYP_29_I54_D: "Light Beam",
  T_49_META_TYP_29_I55_D: "Diffusing Poison Gas",
  T_49_META_TYP_29_I56_D: "Poison Gas",
  T_49_META_TYP_29_I57_D: "Explosion Flames",
  T_49_META_TYP_29_I58_D: "Light Effect",
  T_49_META_TYP_29_I59_D: "Star",
  T_49_META_TYP_29_I6_D: "Foot Halo",
  T_49_META_TYP_29_I60_D: "Blazing Bonfire",
  T_49_META_TYP_29_I61_D: "Water Splash",
  T_49_META_TYP_29_I62_D: "Electric Shock",
  T_49_META_TYP_29_I63_D: "Ink VFX",
  T_49_META_TYP_29_I64_D: "Blackhole VFX",
  T_49_META_TYP_29_I65_D: "Blackhole Explosion VFX",
  T_49_META_TYP_29_I66_D: "Crystal Ball VFX",
  T_49_META_TYP_29_I67_D: "Laser bullet effect",
  T_49_META_TYP_29_I68_D: "Drag effects",
  T_49_META_TYP_29_I69_D: "Clouds",
  T_49_META_TYP_29_I7_D: "Ground Marker",
  T_49_META_TYP_29_I8_D: "Smoke",
  T_49_META_TYP_29_I9_D: "Talisman Explosion",
  T_49_META_TYP_290_I0_D: "Refresh interval, the larger the number, the slower the refresh, in milliseconds.",
  T_49_META_TYP_290_I1_D: "Whether to enable debugging",
  T_49_META_TYP_291_I0_D: "Condition Node",
  T_49_META_TYP_291_I1_D: "Action Node",
  T_49_META_TYP_293_I0_D: "Behavior Tree ID",
  T_49_META_TYP_293_I1_D: "Attach Target",
  T_49_META_TYP_294_I1_D: "Layout Type",
  T_49_META_TYP_294_I10_D: "Sort Order",
  T_49_META_TYP_294_I2_D: "Content Origin",
  T_49_META_TYP_294_I3_D: "Alignment direction",
  T_49_META_TYP_294_I4_D: "Width and height of the sub-item grid",
  T_49_META_TYP_294_I5_D: "Cell Space",
  T_49_META_TYP_294_I6_D: "Constraint",
  T_49_META_TYP_294_I7_D: "Constraint Count",
  T_49_META_TYP_294_I8_D: "Vertical offset",
  T_49_META_TYP_294_I9_D: "Horizontal offset",
  T_49_META_TYP_295_I2_D: "Play Speed",
  T_49_META_TYP_296_I1_D: "Clip Length",
  T_49_META_TYP_297_I0_D: "Bound objects",
  T_49_META_TYP_297_I4_D: "Resource ID",
  T_49_META_TYP_298_I0_D: "Default",
  T_49_META_TYP_298_I2_D: "Once",
  T_49_META_TYP_30_I0_D: "Square",
  T_49_META_TYP_30_I1_D: "Quadrilateral",
  T_49_META_TYP_30_I10_D: "Arrow",
  T_49_META_TYP_30_I11_D: "Callout",
  T_49_META_TYP_30_I12_D: "Rock",
  T_49_META_TYP_30_I13_D: "Scissors",
  T_49_META_TYP_30_I14_D: "Paper",
  T_49_META_TYP_30_I15_D: "Like",
  T_49_META_TYP_30_I16_D: "Right",
  T_49_META_TYP_30_I17_D: "Wrong",
  T_49_META_TYP_30_I18_D: "Plus",
  T_49_META_TYP_30_I19_D: "Lightning",
  T_49_META_TYP_30_I2_D: "Right-Angled Trapezoid",
  T_49_META_TYP_30_I20_D: "Hearts",
  T_49_META_TYP_30_I21_D: "Star",
  T_49_META_TYP_30_I22_D: "Moon",
  T_49_META_TYP_30_I23_D: "Sun",
  T_49_META_TYP_30_I24_D: "Glasses",
  T_49_META_TYP_30_I25_D: "Key",
  T_49_META_TYP_30_I26_D: "Trophy",
  T_49_META_TYP_30_I27_D: "Flag",
  T_49_META_TYP_30_I28_D: "Hourglass",
  T_49_META_TYP_30_I29_D: "Folder",
  T_49_META_TYP_30_I3_D: "Trapezoid",
  T_49_META_TYP_30_I30_D: "Open Folder",
  T_49_META_TYP_30_I31_D: "House",
  T_49_META_TYP_30_I32_D: "Rest",
  T_49_META_TYP_30_I33_D: "Refresh",
  T_49_META_TYP_30_I34_D: "Loop",
  T_49_META_TYP_30_I35_D: "Magnifier",
  T_49_META_TYP_30_I36_D: "Trash Can",
  T_49_META_TYP_30_I37_D: "Return",
  T_49_META_TYP_30_I38_D: "Diamond",
  T_49_META_TYP_30_I39_D: "Swim Ring",
  T_49_META_TYP_30_I4_D: "Hexagon",
  T_49_META_TYP_30_I40_D: "Money",
  T_49_META_TYP_30_I41_D: "Lock",
  T_49_META_TYP_30_I42_D: "Settings",
  T_49_META_TYP_30_I43_D: "Exit",
  T_49_META_TYP_30_I44_D: "Dialogue",
  T_49_META_TYP_30_I45_D: "Crosshairs",
  T_49_META_TYP_30_I46_D: "Guns",
  T_49_META_TYP_30_I47_D: "Sword",
  T_49_META_TYP_30_I48_D: "Explosion",
  T_49_META_TYP_30_I49_D: "Aim",
  T_49_META_TYP_30_I5_D: "Circles",
  T_49_META_TYP_30_I50_D: "Cross",
  T_49_META_TYP_30_I51_D: "Defense",
  T_49_META_TYP_30_I52_D: "Zombie",
  T_49_META_TYP_30_I53_D: "Recycle",
  T_49_META_TYP_30_I54_D: "Gift",
  T_49_META_TYP_30_I55_D: "Clothes",
  T_49_META_TYP_30_I56_D: "Game",
  T_49_META_TYP_30_I57_D: "Player",
  T_49_META_TYP_30_I58_D: "Store",
  T_49_META_TYP_30_I59_D: "Exit",
  T_49_META_TYP_30_I6_D: "Triangle",
  T_49_META_TYP_30_I60_D: "Warning",
  T_49_META_TYP_30_I61_D: "Text",
  T_49_META_TYP_30_I62_D: "Timer Objects",
  T_49_META_TYP_30_I63_D: "Bell",
  T_49_META_TYP_30_I64_D: "Pet",
  T_49_META_TYP_30_I65_D: "Bomb",
  T_49_META_TYP_30_I66_D: "Repair",
  T_49_META_TYP_30_I67_D: "Smiling Face",
  T_49_META_TYP_30_I68_D: "Speaker",
  T_49_META_TYP_30_I7_D: "Exclamation Mark",
  T_49_META_TYP_30_I70_D: "Crown",
  T_49_META_TYP_30_I71_D: "Battle",
  T_49_META_TYP_30_I72_D: "Guild",
  T_49_META_TYP_30_I73_D: "Heartbeat",
  T_49_META_TYP_30_I74_D: "Music",
  T_49_META_TYP_30_I75_D: "Vehicle",
  T_49_META_TYP_30_I76_D: "Melee",
  T_49_META_TYP_30_I77_D: "Pistol",
  T_49_META_TYP_30_I78_D: "Rifle",
  T_49_META_TYP_30_I79_D: "Sniper Rifle",
  T_49_META_TYP_30_I8_D: "Question Mark",
  T_49_META_TYP_30_I80_D: "Shotgun",
  T_49_META_TYP_30_I81_D: "SMG",
  T_49_META_TYP_30_I82_D: "Healing Gun",
  T_49_META_TYP_30_I83_D: "Shatter Armor",
  T_49_META_TYP_30_I84_D: "Headshot",
  T_49_META_TYP_30_I85_D: "Skill 1",
  T_49_META_TYP_30_I86_D: "Skill 2",
  T_49_META_TYP_30_I87_D: "Skill 3",
  T_49_META_TYP_30_I88_D: "Skill 4",
  T_49_META_TYP_30_I89_D: "Skill 5",
  T_49_META_TYP_30_I9_D: "Mark",
  T_49_META_TYP_30_I90_D: "Skill 6",
  T_49_META_TYP_30_I91_D: "Skill 7",
  T_49_META_TYP_30_I92_D: "Skill 8",
  T_49_META_TYP_30_I93_D: "Skill 9",
  T_49_META_TYP_30_I94_D: "Skill 10",
  T_49_META_TYP_300_I0_D: "Resource ID",
  T_49_META_TYP_300_I2_D: "Rotation",
  T_49_META_TYP_300_I3_D: "Created Entity",
  T_49_META_TYP_301_I1_D: "Self-Destruct",
  T_49_META_TYP_301_I2_D: "Dash Attack",
  T_49_META_TYP_301_I3_D: "Shock Wave",
  T_49_META_TYP_301_I4_D: "Tornado Attack",
  T_49_META_TYP_301_I5_D: "Jump Attack",
  T_49_META_TYP_301_I6_D: "Shield Up",
  T_49_META_TYP_301_I7_D: "Shield Broken",
  T_49_META_TYP_302_I5_D: "Backpack",
  T_49_META_TYP_302_I7_D: "Skateboard, Camo ....",
  T_49_META_TYP_303_I0_D: "Add Max. Player HP",
  T_49_META_TYP_303_I1_D: "Restore Player HP Continuously",
  T_49_META_TYP_305_I0_D: "Finish",
  T_49_META_TYP_305_I1_D: "Running",
  T_49_META_TYP_307_I0_D: "Exp Per Damage",
  T_49_META_TYP_307_I1_D: "Exp Per Move Mile",
  T_49_META_TYP_307_I2_D: "EXP per Second",
  T_49_META_TYP_307_I3_D: "Chip Exp",
  T_49_META_TYP_307_I4_D: "Charge Max",
  T_49_META_TYP_308_I0_D: "Gel Maker",
  T_49_META_TYP_31_I0_D: "Grenade Explosion",
  T_49_META_TYP_31_I1_D: "Gun Sound",
  T_49_META_TYP_31_I10_D: "Hit Damage Sound",
  T_49_META_TYP_31_I11_D: "Upgrade Sound",
  T_49_META_TYP_31_I12_D: "Weakness hit sound effect",
  T_49_META_TYP_31_I13_D: "Player stepping sound effect",
  T_49_META_TYP_31_I14_D: "Equipment Repair Sound Effect",
  T_49_META_TYP_31_I15_D: "Equipment repair sound effect",
  T_49_META_TYP_31_I16_D: "Missing or lost sound effect",
  T_49_META_TYP_31_I17_D: "Reminder Sound",
  T_49_META_TYP_31_I18_D: "Soccer Ball Landing Sound Effect",
  T_49_META_TYP_31_I19_D: "Cheers Sound Effect",
  T_49_META_TYP_31_I2_D: "Countdown Beep",
  T_49_META_TYP_31_I20_D: "Bomb Alert Sound Effect",
  T_49_META_TYP_31_I21_D: "Bomb Before Explosion Sound Effect",
  T_49_META_TYP_31_I22_D: "Hunter Appearance Sound Effect",
  T_49_META_TYP_31_I23_D: "Final BGM Sound Effect",
  T_49_META_TYP_31_I24_D: "Resupply Box Refresh Sound Effect",
  T_49_META_TYP_31_I25_D: "Accelerator sound effect",
  T_49_META_TYP_31_I26_D: "Disappearing Sound",
  T_49_META_TYP_31_I27_D: "Visual Effects",
  T_49_META_TYP_31_I28_D: "Night Bugs",
  T_49_META_TYP_31_I29_D: "Dull percussion sound effect",
  T_49_META_TYP_31_I3_D: "UI Tap",
  T_49_META_TYP_31_I30_D: "Response Sound Effect",
  T_49_META_TYP_31_I31_D: "Discovery Surprise sound effect",
  T_49_META_TYP_31_I32_D: "Ghosts playing sound effect",
  T_49_META_TYP_31_I33_D: "Phase Start Sound Effect",
  T_49_META_TYP_31_I34_D: "Zombie sound effect",
  T_49_META_TYP_31_I35_D: "Scary sound effect",
  T_49_META_TYP_31_I36_D: "Transformation sound effect",
  T_49_META_TYP_31_I37_D: "Fast Heartbeat Sound Effect",
  T_49_META_TYP_31_I38_D: "Medium Heartbeat",
  T_49_META_TYP_31_I39_D: "Slow heartbeat sound effect",
  T_49_META_TYP_31_I4_D: "Female Screaming on Hit",
  T_49_META_TYP_31_I40_D: "Stampede sound effect",
  T_49_META_TYP_31_I41_D: "Clicking Sound",
  T_49_META_TYP_31_I42_D: "Skill Recovery Sound",
  T_49_META_TYP_31_I43_D: "Join Game Sound Effects",
  T_49_META_TYP_31_I44_D: "Mechanism Echo Sound",
  T_49_META_TYP_31_I45_D: "Mosquito sound effect",
  T_49_META_TYP_31_I46_D: "Clank 1 sound effect",
  T_49_META_TYP_31_I47_D: "Clank 2 sound effect",
  T_49_META_TYP_31_I48_D: "Mechanism opening sound effect",
  T_49_META_TYP_31_I49_D: "Energy Charge 1 sound effect",
  T_49_META_TYP_31_I5_D: "Male Screaming on Hit",
  T_49_META_TYP_31_I50_D: "Footsteps sound effect",
  T_49_META_TYP_31_I51_D: "Mission Success 1 sound effect",
  T_49_META_TYP_31_I52_D: "Danger Tone 1 sound effect",
  T_49_META_TYP_31_I53_D: "Danger tone 2 sound effect",
  T_49_META_TYP_31_I54_D: "Countdown 3 sound effect",
  T_49_META_TYP_31_I55_D: "Show Tips sound effect",
  T_49_META_TYP_31_I56_D: "Crow cawing ambient sound effect",
  T_49_META_TYP_31_I57_D: "Sound effect of teleporting to the wrong area with a teleport point",
  T_49_META_TYP_31_I58_D: "Sound effect of teleporting to the right area with a teleport point",
  T_49_META_TYP_31_I59_D: "Teleport sound effect",
  T_49_META_TYP_31_I6_D: "Gold Pickup Sound",
  T_49_META_TYP_31_I60_D: "Electric shock sound effect",
  T_49_META_TYP_31_I61_D: "Consumable sound effect",
  T_49_META_TYP_31_I62_D: "Electronic Fantasy Cute Background Music Sound Effects",
  T_49_META_TYP_31_I63_D: "Casual Game Background Music Sound Effects",
  T_49_META_TYP_31_I64_D: "Open Box",
  T_49_META_TYP_31_I65_D: "Level Up",
  T_49_META_TYP_31_I66_D: "Max. Level",
  T_49_META_TYP_31_I67_D: "Tap Button",
  T_49_META_TYP_31_I68_D: "Countdown",
  T_49_META_TYP_31_I69_D: "Defeat Enemy",
  T_49_META_TYP_31_I7_D: "Race past the finish line trigger sound effect",
  T_49_META_TYP_31_I70_D: "End",
  T_49_META_TYP_31_I71_D: "Forward",
  T_49_META_TYP_31_I72_D: "Victory",
  T_49_META_TYP_31_I73_D: "Training Base Checkpoints",
  T_49_META_TYP_31_I74_D: "Countdown",
  T_49_META_TYP_31_I75_D: "Game Start",
  T_49_META_TYP_31_I76_D: "Get Big Gold",
  T_49_META_TYP_31_I77_D: "Get Medium Gold",
  T_49_META_TYP_31_I78_D: "Get Small Gold",
  T_49_META_TYP_31_I79_D: "Join the Fray",
  T_49_META_TYP_31_I8_D: "Trigger Trigger Sound",
  T_49_META_TYP_31_I80_D: "Guild Supply",
  T_49_META_TYP_31_I81_D: "Speaker",
  T_49_META_TYP_31_I82_D: "Impeach Guild Leader",
  T_49_META_TYP_31_I83_D: "Save Warehouse",
  T_49_META_TYP_31_I84_D: "Special Gun Sound",
  T_49_META_TYP_31_I85_D: "Bullet Hit",
  T_49_META_TYP_31_I86_D: "Move",
  T_49_META_TYP_31_I87_D: "Tap Disable Button",
  T_49_META_TYP_31_I88_D: "Skill Charge Complete",
  T_49_META_TYP_31_I89_D: "Laser Skill",
  T_49_META_TYP_31_I9_D: "Degradation Sound",
  T_49_META_TYP_31_I90_D: "Get Consumable 2",
  T_49_META_TYP_31_I91_D: "Countdown 3",
  T_49_META_TYP_31_I92_D: "Game Over 2",
  T_49_META_TYP_31_I93_D: "Elimination Prompt",
  T_49_META_TYP_31_I94_D: "Explosion",
  T_49_META_TYP_31_I95_D: "Energy Orb Skill",
  T_49_META_TYP_31_I96_D: "Crimson Pool Skill",
  T_49_META_TYP_311_I1_D: "Max. Damage",
  T_49_META_TYP_311_I3_D: "The speed of the projectile after it is released, in m/s.",
  T_49_META_TYP_311_I4_D: "The time interval between when the projectile is released and when it takes effect, in seconds.",
  T_49_META_TYP_313_I0_D: "Zone Radius",
  T_49_META_TYP_313_I1_D: "Duration of countermeasure area, in seconds",
  T_49_META_TYP_314_I0_D: "Animation controller resource ID.",
  T_49_META_TYP_314_I1_D: "Animation Controller",
  T_49_META_TYP_315_I0_D: "The owner of the backpack.",
  T_49_META_TYP_315_I1_D: "The space of the backpack.",
  T_49_META_TYP_315_I2_D: "Used Capacity",
  T_49_META_TYP_315_I3_D: "All Supplies",
  T_49_META_TYP_316_I0_D: "Texture Resource",
  T_49_META_TYP_316_I1_D: "Shader Name",
  T_49_META_TYP_316_I11_D: "Flip method",
  T_49_META_TYP_316_I2_D: "UV Offset",
  T_49_META_TYP_316_I3_D: "UV Size",
  T_49_META_TYP_316_I4_D: "Fill Type",
  T_49_META_TYP_316_I5_D: "Border Left Right",
  T_49_META_TYP_316_I6_D: "Border Top Bottom",
  T_49_META_TYP_317_I0_D: "None",
  T_49_META_TYP_317_I1_D: "Freeze Position X",
  T_49_META_TYP_317_I2_D: "Freeze Position Y",
  T_49_META_TYP_317_I3_D: "Freeze Position Z",
  T_49_META_TYP_317_I4_D: "Restricted rotation around X-axis",
  T_49_META_TYP_317_I5_D: "Restriction of rotation around the Y-axis",
  T_49_META_TYP_317_I6_D: "Limit rotation around the Z-axis",
  T_49_META_TYP_317_I7_D: "Freeze Position",
  T_49_META_TYP_317_I8_D: "Freeze Rotation",
  T_49_META_TYP_317_I9_D: "Freeze All",
  T_49_META_TYP_318_I0_D: "Range",
  T_49_META_TYP_318_I1_D: "Full Damage Distance",
  T_49_META_TYP_318_I10_D: "Player Aiming Speed Factor",
  T_49_META_TYP_318_I11_D: "Scope Zoom-In Factor",
  T_49_META_TYP_318_I12_D: "FOV Magnification",
  T_49_META_TYP_318_I13_D: "ADS Magnification",
  T_49_META_TYP_318_I14_D: "ADS Magnification Time (s)",
  T_49_META_TYP_318_I15_D: "ADS Recovery Time (s)",
  T_49_META_TYP_318_I16_D: "Scope Min Damage Distance correction factor.",
  T_49_META_TYP_318_I17_D: "Allow ADS Aim Assist",
  T_49_META_TYP_318_I18_D: "Aim Assist Crosshairs Screen Range Attraction Ratio (0-1)",
  T_49_META_TYP_318_I19_D: "Aim Assist Distance Attenuation Coefficient (0-1)",
  T_49_META_TYP_318_I2_D: "Min. Damage Distance",
  T_49_META_TYP_318_I20_D: "Allow Aim Assist Distance First",
  T_49_META_TYP_318_I21_D: "Aim Assist Distance Priority Min. Distance",
  T_49_META_TYP_318_I22_D: "Aim Assist Distance Priority Max. Distance",
  T_49_META_TYP_318_I23_D: "Aim Assist Distance Priority Impact Coefficient (>=1)",
  T_49_META_TYP_318_I24_D: "ADS Rotation Sensitivity",
  T_49_META_TYP_318_I25_D: "Shrink Speed",
  T_49_META_TYP_318_I3_D: "Ammo Clip Size",
  T_49_META_TYP_318_I4_D: "Attack Interval",
  T_49_META_TYP_318_I5_D: "Reload Speed",
  T_49_META_TYP_318_I6_D: "Auto Reload Speed",
  T_49_META_TYP_318_I7_D: "Scatter Speed",
  T_49_META_TYP_318_I8_D: "Scattering rate when crouching and lying down, per 0.1 means 10% range increase per bullet aiming",
  T_49_META_TYP_318_I9_D: "Max. Spread",
  T_49_META_TYP_319_I0_D: "Simple",
  T_49_META_TYP_319_I1_D: "Sliced",
  T_49_META_TYP_319_I2_D: "Tiled",
  T_49_META_TYP_319_I3_D: "Filled",
  T_49_META_TYP_319_I4_D: "Fit",
  T_49_META_TYP_32_I0_D: "Player in normal active state",
  T_49_META_TYP_32_I1_D: "Player is knocked down",
  T_49_META_TYP_32_I2_D: "Player is dead",
  T_49_META_TYP_320_I0_D: "Horizontal",
  T_49_META_TYP_320_I1_D: "Vertical",
  T_49_META_TYP_320_I2_D: "Radial 90°",
  T_49_META_TYP_320_I3_D: "Radial 180°",
  T_49_META_TYP_320_I4_D: "Radial 360°",
  T_49_META_TYP_321_I0_D: "The maximum distance at which the targeting assist will be triggered.",
  T_49_META_TYP_321_I1_D: "The offset of the collimator when triggering targeting, if the offset point is not in the solid, the targeting will be disabled.",
  T_49_META_TYP_322_I0_D: "No",
  T_49_META_TYP_322_I1_D: "Head",
  T_49_META_TYP_322_I2_D: "Body",
  T_49_META_TYP_322_I3_D: "Limb",
  T_49_META_TYP_323_I0_D: "Scale",
  T_49_META_TYP_323_I1_D: "Account ID",
  T_49_META_TYP_323_I2_D: "Player Profile Information",
  T_49_META_TYP_323_I3_D: "Style",
  T_49_META_TYP_323_I4_D: "Show Rank",
  T_49_META_TYP_323_I5_D: "Show Pin",
  T_49_META_TYP_323_I6_D: "Show Nickname",
  T_49_META_TYP_324_I0_D: "Generate a specified amount of force",
  T_49_META_TYP_324_I1_D: "Generate an acceleration of a specified magnitude",
  T_49_META_TYP_324_I2_D: "Generate an impulse of a specified magnitude",
  T_49_META_TYP_324_I3_D: "Generate a specified amount of velocity",
  T_49_META_TYP_326_I0_D: "Account ID",
  T_49_META_TYP_326_I1_D: "Avatar ID",
  T_49_META_TYP_326_I2_D: "Banner ID",
  T_49_META_TYP_326_I3_D: "Pin ID",
  T_49_META_TYP_326_I4_D: "Player's nickname",
  T_49_META_TYP_326_I5_D: "BR Rank",
  T_49_META_TYP_326_I6_D: "Highest BR rank",
  T_49_META_TYP_326_I7_D: "CS Rank",
  T_49_META_TYP_326_I8_D: "Highest CS rank",
  T_49_META_TYP_327_I0_D: "Resource ID",
  T_49_META_TYP_327_I1_D: "Part Mask 1",
  T_49_META_TYP_327_I2_D: "Part Mask 2",
  T_49_META_TYP_327_I3_D: "Part Mask 3",
  T_49_META_TYP_327_I4_D: "Part Mask 4",
  T_49_META_TYP_329_I0_D: "Driver",
  T_49_META_TYP_329_I1_D: "Passenger A",
  T_49_META_TYP_329_I2_D: "Passenger B",
  T_49_META_TYP_329_I3_D: "Passenger C",
  T_49_META_TYP_33_I0_D: "Ascending order ignores zero values, zero values come last",
  T_49_META_TYP_33_I1_D: "Descending order, large to small",
  T_49_META_TYP_33_I2_D: "Ascending, smallest to largest",
  T_49_META_TYP_330_I4_D: "Duration of invincibility effect (in s)",
  T_49_META_TYP_330_I5_D: "Control Points",
  T_49_META_TYP_330_I8_D: "Delta Value",
  T_49_META_TYP_332_I0_D: "Is Loop",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "SimplifiedArabic",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "Supermarket",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "Resource path, default is empty",
  T_49_META_TYP_335_I1_D: "Play count, default is 1",
  T_49_META_TYP_335_I2_D: "Volume, default is 50",
  T_49_META_TYP_335_I3_D: "Max. Distance",
  T_49_META_TYP_335_I4_D: "Min. Distance",
  T_49_META_TYP_335_I5_D: "Whether the music is 3D or not",
  T_49_META_TYP_335_I6_D: "Priority",
  T_49_META_TYP_335_I7_D: "Wait time before start, in seconds",
  T_49_META_TYP_335_I8_D: "Is Playing",
  T_49_META_TYP_338_I0_D: "Movement status",
  T_49_META_TYP_338_I1_D: "Sprint",
  T_49_META_TYP_338_I2_D: "Attack",
  T_49_META_TYP_338_I3_D: "Jump",
  T_49_META_TYP_338_I4_D: "Overrun",
  T_49_META_TYP_338_I5_D: "Enter vehicle (driver)",
  T_49_META_TYP_338_I6_D: "Enter Carrier (Passenger)",
  T_49_META_TYP_338_I7_D: "Exit Vehicle",
  T_49_META_TYP_338_I8_D: "Drive",
  T_49_META_TYP_339_I0_D: "Damage Ratio Limb",
  T_49_META_TYP_339_I1_D: "Headshot DMG Coefficient",
  T_49_META_TYP_339_I2_D: "Max. Durability Multiplier",
  T_49_META_TYP_339_I3_D: "Extra HP Ratio",
  T_49_META_TYP_339_I4_D: "Additional Blast Damage Reduction Factor (%)",
  T_49_META_TYP_339_I5_D: "Extra Backpack Capacity",
  T_49_META_TYP_339_I6_D: "Replacement Priority",
  T_49_META_TYP_34_I0_D: "Default Fist",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "Famas-I",
  T_49_META_TYP_34_I101_D: "Groza-X",
  T_49_META_TYP_34_I102_D: "SVD-Y",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "Shotgun",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "Hand Cannon",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "Shield Gun",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "Shield Gun",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "Kar98K-II",
  T_49_META_TYP_34_I126_D: "Kar98K-III",
  T_49_META_TYP_34_I127_D: "Kar98K-III",
  T_49_META_TYP_34_I128_D: "Kar98K-Ⅲ - Kar98K-III",
  T_49_META_TYP_34_I129_D: "Famas-III",
  T_49_META_TYP_34_I13_D: "Flame Grenade Gun",
  T_49_META_TYP_34_I133_D: "Flashbang",
  T_49_META_TYP_34_I134_D: "Smoke Grenade",
  T_49_META_TYP_34_I135_D: "Freezing Grenade",
  T_49_META_TYP_34_I136_D: "Bulletproof Vest Lv1",
  T_49_META_TYP_34_I137_D: "Body armor Lv2",
  T_49_META_TYP_34_I138_D: "Body armor Lv3",
  T_49_META_TYP_34_I139_D: "Helmet Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "Helmet Lv2",
  T_49_META_TYP_34_I141_D: "Helmet Lv3",
  T_49_META_TYP_34_I142_D: "Explosion-proof Armor",
  T_49_META_TYP_34_I143_D: "Backpack Lv1",
  T_49_META_TYP_34_I144_D: "Backpack Lv2",
  T_49_META_TYP_34_I145_D: "Backpack Lv3",
  T_49_META_TYP_34_I146_D: "Muzzle Lv1",
  T_49_META_TYP_34_I147_D: "Muzzle Lv2",
  T_49_META_TYP_34_I148_D: "Muzzle Lv3",
  T_49_META_TYP_34_I149_D: "Silencer",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "Assault Muzzle",
  T_49_META_TYP_34_I151_D: "Wide Muzzle",
  T_49_META_TYP_34_I152_D: "Magazine Lv1",
  T_49_META_TYP_34_I153_D: "Magazine Lv2",
  T_49_META_TYP_34_I154_D: "Magazine Lv3",
  T_49_META_TYP_34_I155_D: "Double Bundle Magazine",
  T_49_META_TYP_34_I156_D: "Chain Magazine",
  T_49_META_TYP_34_I157_D: "Grip Lv1",
  T_49_META_TYP_34_I158_D: "Grip Lv2",
  T_49_META_TYP_34_I159_D: "Grip Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "Folding Bracket",
  T_49_META_TYP_34_I161_D: "Shooter's Rifle Grip",
  T_49_META_TYP_34_I162_D: "Shotgun Stocks",
  T_49_META_TYP_34_I163_D: "Sniper Stocks",
  T_49_META_TYP_34_I164_D: "Thermal Imaging Scope",
  T_49_META_TYP_34_I165_D: "Stock Lv1",
  T_49_META_TYP_34_I166_D: "Stock Lv2",
  T_49_META_TYP_34_I167_D: "Stock Lv3",
  T_49_META_TYP_34_I168_D: "Shield Expander",
  T_49_META_TYP_34_I169_D: "Full Body Armor",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "Excess Jacket",
  T_49_META_TYP_34_I171_D: "Explosion-proof Jacket",
  T_49_META_TYP_34_I172_D: "Backpack Expander",
  T_49_META_TYP_34_I173_D: "Healing Breather",
  T_49_META_TYP_34_I174_D: "Horizaline",
  T_49_META_TYP_34_I175_D: "MedKit",
  T_49_META_TYP_34_I176_D: "Armor Repair Kit",
  T_49_META_TYP_34_I177_D: "An AI sentry tower made of high-tech materials that actively searches and attacks enemies within a certain range",
  T_49_META_TYP_34_I178_D: "Level 1 Mushroom",
  T_49_META_TYP_34_I179_D: "Level 2 Mushroom",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "Level 3 Mushroom",
  T_49_META_TYP_34_I181_D: "Level 4 Mushroom",
  T_49_META_TYP_34_I182_D: "Personal UAV",
  T_49_META_TYP_34_I184_D: "Sensor Mines",
  T_49_META_TYP_34_I185_D: "Jet Flying Shoes",
  T_49_META_TYP_34_I186_D: "Bouncing Power Shoes",
  T_49_META_TYP_34_I187_D: "Glider",
  T_49_META_TYP_34_I188_D: "Bait Grenade",
  T_49_META_TYP_34_I189_D: "Maglev Skateboard",
  T_49_META_TYP_34_I19_D: "Desert Eagle",
  T_49_META_TYP_34_I190_D: "Bomb Disposal Pliers",
  T_49_META_TYP_34_I191_D: "Gun Upgrader",
  T_49_META_TYP_34_I192_D: "Rifle Ammo",
  T_49_META_TYP_34_I193_D: "Pistol Ammo",
  T_49_META_TYP_34_I194_D: "Sniper Rifle Ammo",
  T_49_META_TYP_34_I195_D: "Shotgun Ammo",
  T_49_META_TYP_34_I196_D: "SMG Ammo",
  T_49_META_TYP_34_I197_D: "Arrows",
  T_49_META_TYP_34_I198_D: "M79 Grenade",
  T_49_META_TYP_34_I199_D: "Flamethrower Bullets",
  T_49_META_TYP_34_I2_D: "CROSSBOW",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "THROWINGKNIFE2",
  T_49_META_TYP_34_I201_D: "Hook",
  T_49_META_TYP_34_I202_D: "Football Gun",
  T_49_META_TYP_34_I203_D: "Boxing",
  T_49_META_TYP_34_I204_D: "Flamethrower",
  T_49_META_TYP_34_I205_D: "MonkeygodCard",
  T_49_META_TYP_34_I206_D: "MadeManACard",
  T_49_META_TYP_34_I207_D: "DjmaleCard",
  T_49_META_TYP_34_I208_D: "GraffitistCard",
  T_49_META_TYP_34_I209_D: "DetectiveCard",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "ProfessorCard",
  T_49_META_TYP_34_I211_D: "BountyHunterCard",
  T_49_META_TYP_34_I212_D: "SuperstarCard",
  T_49_META_TYP_34_I213_D: "XtremeCard",
  T_49_META_TYP_34_I214_D: "MusicBroCard",
  T_49_META_TYP_34_I215_D: "KentaCard",
  T_49_META_TYP_34_I216_D: "TRACKERCard",
  T_49_META_TYP_34_I217_D: "CrazygirlCard",
  T_49_META_TYP_34_I218_D: "RunSpeedUpCard",
  T_49_META_TYP_34_I219_D: "SantinoCard",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "VillainCard",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "SCAR-I",
  T_49_META_TYP_34_I25_D: "SCAR-II",
  T_49_META_TYP_34_I26_D: "SCAR-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "Loot Soccer Shield",
  T_49_META_TYP_34_I30_D: "Superheated Energy Gun",
  T_49_META_TYP_34_I31_D: "Superheated Gun-I",
  T_49_META_TYP_34_I32_D: "Superheat Gun-II",
  T_49_META_TYP_34_I33_D: "Superheat Gun-III",
  T_49_META_TYP_34_I34_D: "PLASMA-X",
  T_49_META_TYP_34_I35_D: "Heal Pistol-Y",
  T_49_META_TYP_34_I36_D: "Heal Sniper",
  T_49_META_TYP_34_I37_D: "Heal Pistol",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "Groza",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "Groza",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "Pan",
  T_49_META_TYP_34_I44_D: "Machete",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "Baseball Bat",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "Samurai Sword",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "Gatling",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "Power Hook Gun",
  T_49_META_TYP_34_I71_D: "FF Knife",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "1887 with 3 bullets",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "Woodpecker",
  T_49_META_TYP_34_I83_D: "VECTOR",
  T_49_META_TYP_34_I84_D: "MAG-7",
  T_49_META_TYP_34_I85_D: "MAG-7",
  T_49_META_TYP_34_I86_D: "Scythe",
  T_49_META_TYP_34_I87_D: "Big Head Hammer",
  T_49_META_TYP_34_I88_D: "Flying Dagger (pickable)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "USP-2",
  T_49_META_TYP_34_I92_D: "Kingfisher",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "MP5-I",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "Kar98K-I",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "Easy",
  T_49_META_TYP_340_I1_D: "Simple",
  T_49_META_TYP_340_I2_D: "Normal",
  T_49_META_TYP_340_I3_D: "Moderate",
  T_49_META_TYP_340_I4_D: "Hard",
  T_49_META_TYP_340_I5_D: "Inferno",
  T_49_META_TYP_342_I0_D: "Start Event",
  T_49_META_TYP_342_I1_D: "Stop Event",
  T_49_META_TYP_342_I2_D: "Pause Event",
  T_49_META_TYP_342_I3_D: "How long to wait after being created to start the timer, in milliseconds",
  T_49_META_TYP_342_I4_D: "Loop Count",
  T_49_META_TYP_342_I5_D: "Events",
  T_49_META_TYP_342_I6_D: "Countdown or positive timing",
  T_49_META_TYP_342_I7_D: "Player Status",
  T_49_META_TYP_342_I8_D: "Timing end time in seconds",
  T_49_META_TYP_345_I10_D: "Hand Cannon",
  T_49_META_TYP_345_I12_D: "Ice Wall Gun",
  T_49_META_TYP_345_I13_D: "Flamethrower",
  T_49_META_TYP_345_I4_D: "Shotgun",
  T_49_META_TYP_345_I6_D: "Special Gun",
  T_49_META_TYP_345_I8_D: "Accumulator",
  T_49_META_TYP_346_I0_D: "Rifle Ammo",
  T_49_META_TYP_346_I1_D: "Pistol Ammo",
  T_49_META_TYP_346_I2_D: "Sniper Rifle Ammo",
  T_49_META_TYP_346_I3_D: "Shotgun Ammo",
  T_49_META_TYP_346_I4_D: "SMG Ammo",
  T_49_META_TYP_346_I5_D: "Arrows",
  T_49_META_TYP_346_I6_D: "M79 Grenade",
  T_49_META_TYP_346_I7_D: "Hook",
  T_49_META_TYP_346_I8_D: "M79 Specialized Grenade",
  T_49_META_TYP_347_I3_D: "Can be combined with Relative Motion if true, must be combined with Absolute Motion if false, otherwise the property will not take effect correctly.",
  T_49_META_TYP_347_I6_D: "Delta Value",
  T_49_META_TYP_350_I0_D: "Sports Car",
  T_49_META_TYP_350_I1_D: "Motorbike",
  T_49_META_TYP_350_I2_D: "Jeep",
  T_49_META_TYP_350_I3_D: "SUV",
  T_49_META_TYP_350_I4_D: "Monster Truck",
  T_49_META_TYP_350_I5_D: "Mutant Truck",
  T_49_META_TYP_352_I1_D: "Unselected Sprite",
  T_49_META_TYP_352_I2_D: "Unchecked image type",
  T_49_META_TYP_352_I3_D: "Unselected Color",
  T_49_META_TYP_352_I4_D: "Selected Sprite",
  T_49_META_TYP_352_I5_D: "Selected Image Type",
  T_49_META_TYP_352_I6_D: "Selected Color",
  T_49_META_TYP_353_I0_D: "HP Recovery Amount",
  T_49_META_TYP_353_I1_D: "HP Recovery Speed (ms)",
  T_49_META_TYP_353_I2_D: "Time Required (ms)",
  T_49_META_TYP_354_I0_D: "EP Recovery Amount",
  T_49_META_TYP_355_I0_D: "HP Recovery Amount",
  T_49_META_TYP_355_I1_D: "EP Recovery Amount",
  T_49_META_TYP_355_I2_D: "Time Required (ms)",
  T_49_META_TYP_356_I0_D: "Drop Items",
  T_49_META_TYP_356_I1_D: "Drop box drop time ms",
  T_49_META_TYP_356_I2_D: "Airdrop State",
  T_49_META_TYP_357_I0_D: "Surface",
  T_49_META_TYP_357_I1_D: "Boundary",
  T_49_META_TYP_359_I0_D: "Whether to use a player controller with physics effects",
  T_49_META_TYP_359_I1_D: "Placed on a slope above this angle, it will slide downward",
  T_49_META_TYP_359_I10_D: "This gravity acceleration is only applied to this player's controller.",
  T_49_META_TYP_359_I11_D: "Mass in kg",
  T_49_META_TYP_359_I12_D: "If the slope exceeds the maximum uphill angle, the capsule will slide downward.",
  T_49_META_TYP_359_I16_D: "When enabled, movement is controlled by server-side blocks or scripts.",
  T_49_META_TYP_359_I17_D: "When enabled, the force applied when the character pushes on a rigid body can be customized.",
  T_49_META_TYP_359_I18_D: "The amount of force applied when the character pushes the rigid body",
  T_49_META_TYP_359_I19_D: "True when the lower part of the body touches the collision body, usually used to determine if the player is on the ground.",
  T_49_META_TYP_359_I2_D: "Only obstacles above this height will have a blocking effect, in the range [0,Height]",
  T_49_META_TYP_359_I20_D: "Customizable physics level, value [0,15].",
  T_49_META_TYP_359_I21_D: "Enable Rotate With Gravity",
  T_49_META_TYP_359_I3_D: "Allows embedding to change the depth of the capsule body. It can prevent the character from getting stuck or shaking, and is not recommended to be changed without special needs. Value range (0,Radius]",
  T_49_META_TYP_359_I4_D: "Minimum movement distance, any movement less than this value will not be executed. If there is no special need, it is recommended to keep it at 0.",
  T_49_META_TYP_359_I5_D: "The offset of the center of the collision box from the local coordinate origin.",
  T_49_META_TYP_359_I6_D: "Radius of the capsule, minimum value 0.01.",
  T_49_META_TYP_359_I7_D: "Total height of the capsule, including the upper and lower hemispheres, min. 2*Radius",
  T_49_META_TYP_359_I8_D: "Current linear velocity, in m/s",
  T_49_META_TYP_360_I0_D: "Left Firing Arc Angle",
  T_49_META_TYP_360_I1_D: "Right Firing Arc Angle",
  T_49_META_TYP_360_I2_D: "Min. Elevation Angle",
  T_49_META_TYP_360_I3_D: "Max. Depression Angle",
  T_49_META_TYP_360_I4_D: "Muzzle Velocity",
  T_49_META_TYP_362_I0_D: "Freeze time caused by hitting the player, in seconds",
  T_49_META_TYP_363_I0_D: "Disable Hud Request Purchase",
  T_49_META_TYP_363_I1_D: "Request help from team to buy",
  T_49_META_TYP_363_I2_D: "Purchase by requesting help from a camp",
  T_49_META_TYP_364_I0_D: "Is Center Position",
  T_49_META_TYP_364_I1_D: "Whether to loop playback",
  T_49_META_TYP_364_I2_D: "Animation name",
  T_49_META_TYP_364_I3_D: "Whether or not to autoplay",
  T_49_META_TYP_364_I4_D: "Use Custom Resource",
  T_49_META_TYP_366_I0_D: "Specifies the UUID of the Batch resource to render.",
  T_49_META_TYP_367_I1_D: "Show Tag",
  T_49_META_TYP_367_I2_D: "Icon style for marker targets",
  T_49_META_TYP_367_I3_D: "Overlay color of icons displayed on marked targets",
  T_49_META_TYP_367_I4_D: "Icon style displayed on a scale",
  T_49_META_TYP_367_I5_D: "Overlay color of the icon displayed on a scale",
  T_49_META_TYP_367_I6_D: "Always Show Mark",
  T_49_META_TYP_370_I0_D: "Main title",
  T_49_META_TYP_370_I1_D: "Subtitle",
  T_49_META_TYP_370_I2_D: "Upper background color",
  T_49_META_TYP_370_I3_D: "Bottom background color",
  T_49_META_TYP_371_I2_D: "Left Score",
  T_49_META_TYP_371_I3_D: "Right Score",
  T_49_META_TYP_371_I4_D: "The last score on the left, used to play the score switching Animation",
  T_49_META_TYP_371_I5_D: "The last score on the right, used to play the score toggle Animation",
  T_49_META_TYP_372_I0_D: "Standing",
  T_49_META_TYP_372_I1_D: "Show Crouch",
  T_49_META_TYP_372_I10_D: "High fall",
  T_49_META_TYP_372_I11_D: "Low fall, e.g. jumping",
  T_49_META_TYP_372_I12_D: "Flying shoes",
  T_49_META_TYP_372_I13_D: "Two jump jumps",
  T_49_META_TYP_372_I14_D: "Sitting on a chair",
  T_49_META_TYP_372_I15_D: "Ejected by catapult",
  T_49_META_TYP_372_I16_D: "Catapult preparation phase",
  T_49_META_TYP_372_I17_D: "Gliding on the consumable",
  T_49_META_TYP_372_I18_D: "Gliding prop drop",
  T_49_META_TYP_372_I19_D: "Bounced by tires",
  T_49_META_TYP_372_I2_D: "Running",
  T_49_META_TYP_372_I20_D: "Bounced by human tires",
  T_49_META_TYP_372_I21_D: "An Animation in the Party Zone",
  T_49_META_TYP_372_I22_D: "Ride a Flying Machine",
  T_49_META_TYP_372_I23_D: "Entering a Cannon",
  T_49_META_TYP_372_I24_D: "This is the state when coming out of a Cannon, Carrier, etc. if the ride object is flying",
  T_49_META_TYP_372_I25_D: "After jumping from a springboard",
  T_49_META_TYP_372_I26_D: "After getting off the zipline",
  T_49_META_TYP_372_I27_D: "Not used",
  T_49_META_TYP_372_I3_D: "Down and Crawl",
  T_49_META_TYP_372_I4_D: "Swimming",
  T_49_META_TYP_372_I5_D: "Falling vertically",
  T_49_META_TYP_372_I6_D: "Over the wall",
  T_49_META_TYP_372_I7_D: "Unused",
  T_49_META_TYP_372_I8_D: "Knocked down but not dead",
  T_49_META_TYP_372_I9_D: "Water Skateboarding",
  T_49_META_TYP_374_I0_D: "Life, level and stroke colors",
  T_49_META_TYP_374_I1_D: "When the life value decreases, the lost portion is briefly shown in this color.",
  T_49_META_TYP_374_I10_D: "Offset relative to the target to be followed",
  T_49_META_TYP_374_I11_D: "The amount of life between each line, if less than or equal to 0, it will not be shown.",
  T_49_META_TYP_374_I12_D: "Total HP",
  T_49_META_TYP_374_I13_D: "Current HP",
  T_49_META_TYP_374_I14_D: "When enabled, blood changes will be colored differently.",
  T_49_META_TYP_374_I15_D: "When enabled, the offset property is transferred to the world coordinate system using the local coordinate system.",
  T_49_META_TYP_374_I2_D: "When the life value increases, the increased part is briefly displayed in this color.",
  T_49_META_TYP_374_I3_D: "The color of the life value border and the bottom of the vignette.",
  T_49_META_TYP_374_I4_D: "Range 0~1, the transparency of the overall UI.",
  T_49_META_TYP_374_I5_D: "Determines the overall UI scaling, and the font will be scaled as well.",
  T_49_META_TYP_374_I6_D: "Indicates the name of the current blood bar owner",
  T_49_META_TYP_374_I8_D: "The length of the bloodstain portion on the screen",
  T_49_META_TYP_374_I9_D: "Must follow an entity with a Transform component.",
  T_49_META_TYP_375_I1_D: "Battle Entity",
  T_49_META_TYP_376_I1_D: "Battle Entity",
  T_49_META_TYP_38_I0_D: "Alpha",
  T_49_META_TYP_382_I0_D: "Default",
  T_49_META_TYP_382_I1_D: "Skip the knockdown state and just die",
  T_49_META_TYP_382_I2_D: "No Skip Knockdown",
  T_49_META_TYP_387_I1_D: "Allow Pressed Outside",
  T_49_META_TYP_389_I0_D: "Default offset of the base",
  T_49_META_TYP_389_I1_D: "Background Sprite",
  T_49_META_TYP_389_I10_D: "Inactivated Alpha",
  T_49_META_TYP_389_I2_D: "Background Radius",
  T_49_META_TYP_389_I3_D: "Joystick Cap Image",
  T_49_META_TYP_389_I4_D: "Joystick Cap Radius",
  T_49_META_TYP_389_I5_D: "Joystick Cap Drag Radius",
  T_49_META_TYP_389_I6_D: "Arrow Sprite",
  T_49_META_TYP_389_I7_D: "Arrow Size",
  T_49_META_TYP_389_I8_D: "Arrow Offset",
  T_49_META_TYP_389_I9_D: "Activated Alpha",
  T_49_META_TYP_39_I1_D: "Sprite Shape",
  T_49_META_TYP_39_I10_D: "Gradient Top",
  T_49_META_TYP_39_I11_D: "Gradient Bottom",
  T_49_META_TYP_39_I12_D: "Top Alpha",
  T_49_META_TYP_39_I13_D: "Bottom Alpha",
  T_49_META_TYP_39_I3_D: "Flip",
  T_49_META_TYP_39_I4_D: "Filled",
  T_49_META_TYP_39_I5_D: "Center Invisible",
  T_49_META_TYP_39_I6_D: "Fill Direction",
  T_49_META_TYP_39_I7_D: "Fill Value",
  T_49_META_TYP_39_I8_D: "Invert Fill",
  T_49_META_TYP_39_I9_D: "Gradient",
  T_49_META_TYP_392_I0_D: "Default is 0, unit is ms.",
  T_49_META_TYP_392_I1_D: "The time it takes to shrink the circle, in ms",
  T_49_META_TYP_392_I10_D: "The end time of the reduced circle, in ms",
  T_49_META_TYP_392_I12_D: "Radius of out-of-zone end circle.",
  T_49_META_TYP_392_I13_D: "Shrinking Start Time",
  T_49_META_TYP_392_I14_D: "Damage Interval (ms)",
  T_49_META_TYP_392_I3_D: "The amount of damage done to players in the out-of-zone in a single turn.",
  T_49_META_TYP_392_I4_D: "List of players in the safe zone",
  T_49_META_TYP_392_I5_D: "Safe zone disappearance time, no safe zone will be generated when the safe zone disappearance time is less than the effective time.",
  T_49_META_TYP_392_I6_D: "Group ID",
  T_49_META_TYP_392_I7_D: "Radius of the out-of-zone starting circle",
  T_49_META_TYP_392_I8_D: "End state",
  T_49_META_TYP_392_I9_D: "Status",
  T_49_META_TYP_394_I0_D: "Value is about 3.1416",
  T_49_META_TYP_394_I1_D: "Value about 2.7183",
  T_49_META_TYP_396_I0_D: "Title",
  T_49_META_TYP_396_I1_D: "Content",
  T_49_META_TYP_396_I2_D: "Options",
  T_49_META_TYP_396_I3_D: "ShowBackground",
  T_49_META_TYP_399_I0_D: "Jump Height",
  T_49_META_TYP_399_I1_D: "The number of consecutive jumps that can be performed before landing",
  T_49_META_TYP_399_I2_D: "How many jumps can be performed before landing",
  T_49_META_TYP_399_I3_D: "Enable Move In Midair",
  T_49_META_TYP_40_I1_D: "Label",
  T_49_META_TYP_40_I10_D: "Line Spacing",
  T_49_META_TYP_40_I11_D: "Overflow method",
  T_49_META_TYP_40_I12_D: "Font Style",
  T_49_META_TYP_40_I13_D: "Is Apply Shadow",
  T_49_META_TYP_40_I14_D: "Shadow Color",
  T_49_META_TYP_40_I15_D: "Shadow Offset",
  T_49_META_TYP_40_I3_D: "Localized Key, can be used in multiple languages",
  T_49_META_TYP_40_I5_D: "Alignment method",
  T_49_META_TYP_40_I6_D: "Alignment Vertical",
  T_49_META_TYP_40_I7_D: "Is Bold",
  T_49_META_TYP_40_I8_D: "Is Italic",
  T_49_META_TYP_40_I9_D: "Is Underline",
  T_49_META_TYP_400_I0_D: "Active",
  T_49_META_TYP_400_I1_D: "Passive",
  T_49_META_TYP_400_I2_D: "No Attack",
  T_49_META_TYP_401_I0_D: "Cannot fire.",
  T_49_META_TYP_401_I1_D: "Can fire continuously",
  T_49_META_TYP_401_I2_D: "Fires once per attack command",
  T_49_META_TYP_401_I3_D: "Three times per attack command.",
  T_49_META_TYP_401_I4_D: "Fires twice per attack command",
  T_49_META_TYP_401_I5_D: "Parry",
  T_49_META_TYP_402_I0_D: "Targets to friend",
  T_49_META_TYP_402_I1_D: "Function Type",
  T_49_META_TYP_402_I2_D: "Style",
  T_49_META_TYP_403_I0_D: "Add Friend",
  T_49_META_TYP_403_I1_D: "Report",
  T_49_META_TYP_404_I0_D: "Light",
  T_49_META_TYP_404_I1_D: "Dark",
  T_49_META_TYP_405_I0_D: "By Hierarchy",
  T_49_META_TYP_405_I1_D: "By Priority High To Low",
  T_49_META_TYP_405_I2_D: "By Priority Low To High",
  T_49_META_TYP_406_I0_D: "Control the distance of player's Animation.",
  T_49_META_TYP_406_I1_D: "Controls the height of the player's body during the move.",
  T_49_META_TYP_407_I0_D: "Local",
  T_49_META_TYP_407_I1_D: "Client",
  T_49_META_TYP_407_I2_D: "Server",
  T_49_META_TYP_407_I3_D: "Both",
  T_49_META_TYP_409_I0_D: "No errors",
  T_49_META_TYP_409_I1_D: "Data storage timeout, mainly for read operations",
  T_49_META_TYP_409_I10_D: "Failed team change - invalid target team",
  T_49_META_TYP_409_I11_D: "Failed team change - Dead player not allowed to change teams",
  T_49_META_TYP_409_I12_D: "Failed team change - not allowed to change team in vehicle",
  T_49_META_TYP_409_I2_D: "Data storage read/write frequency exceeds the limit",
  T_49_META_TYP_409_I3_D: "Parameter exceptions",
  T_49_META_TYP_409_I4_D: "Room creation failed: no valid PersonaIDs available",
  T_49_META_TYP_409_I5_D: "Undefined error status",
  T_49_META_TYP_409_I6_D: "Commercialization service shut down, users can no longer use the developer's service",
  T_49_META_TYP_409_I7_D: "Failed to change team - mode not supported",
  T_49_META_TYP_409_I8_D: "Failed to change team-Currently already in target team",
  T_49_META_TYP_409_I9_D: "Queue change failed-invalid target",
  T_49_META_TYP_41_I0_D: "Sprite Shape",
  T_49_META_TYP_41_I19_D: "Disable collision box",
  T_49_META_TYP_41_I3_D: "Disable Color",
  T_49_META_TYP_41_I4_D: "Pressed Color",
  T_49_META_TYP_41_I5_D: "Fill Type",
  T_49_META_TYP_41_I6_D: "Is FE Button",
  T_49_META_TYP_41_I7_D: "Pressed Sprite",
  T_49_META_TYP_41_I8_D: "Pressed Sprite Type",
  T_49_META_TYP_41_I9_D: "Flip Type",
  T_49_META_TYP_411_I0_D: "Forward Speed",
  T_49_META_TYP_411_I1_D: "Backward Speed",
  T_49_META_TYP_411_I2_D: "Up Speed",
  T_49_META_TYP_411_I3_D: "Down Speed",
  T_49_META_TYP_411_I4_D: "Grenade Min Damage",
  T_49_META_TYP_411_I5_D: "Grenade Max Damage",
  T_49_META_TYP_411_I6_D: "Grenade Range",
  T_49_META_TYP_412_I0_D: "Horsepower gained by the vehicle when using the gas button",
  T_49_META_TYP_412_I1_D: "Horsepower gained by the vehicle when using the reverse/brake button",
  T_49_META_TYP_412_I2_D: "Maximum steering angle at high speed",
  T_49_META_TYP_412_I3_D: "Speed threshold applied to the maximum steering angle at high speeds",
  T_49_META_TYP_412_I4_D: "After reaching the maximum speed, the carrier does not provide any more horsepower, but the carrier may exceed that maximum speed (e.g. through a downhill)",
  T_49_META_TYP_412_I5_D: "When the carrier is not being maneuvered, decelerate the carrier by multiplying IdleBrakeInput by BrakeTorque",
  T_49_META_TYP_412_I6_D: "Damage calculation for crashes, applying the parameters of the damage formula",
  T_49_META_TYP_412_I7_D: "Damage calculation for crashing, damage will not be increased even if the speed is exceeded.",
  T_49_META_TYP_412_I8_D: "Damage calculation for ramming, minimum damage",
  T_49_META_TYP_412_I9_D: "Damage calculation for ramming, maximum damage",
  T_49_META_TYP_413_I0_D: "Player (NPC) transformed costume",
  T_49_META_TYP_414_I1_D: "Wide Range",
  T_49_META_TYP_415_I0_D: "Persona ID",
  T_49_META_TYP_415_I1_D: "Nickname",
  T_49_META_TYP_415_I2_D: "Avatar",
  T_49_META_TYP_416_I1_D: "The Persona to which it is bound.",
  T_49_META_TYP_416_I2_D: "Offset",
  T_49_META_TYP_416_I3_D: "Height",
  T_49_META_TYP_416_I4_D: "Whether to reply to system messages",
  T_49_META_TYP_416_I5_D: "Persona nickname",
  T_49_META_TYP_416_I6_D: "PersonaAvatar",
  T_49_META_TYP_416_I7_D: "Nickname of the user",
  T_49_META_TYP_416_I8_D: "User Avatar",
  T_49_META_TYP_417_I0_D: "Resource ID",
  T_49_META_TYP_418_I0_D: "Membership expiration",
  T_49_META_TYP_418_I1_D: "Become a member",
  T_49_META_TYP_418_I2_D: "Renew membership",
  T_49_META_TYP_42_I0_D: "Default Text",
  T_49_META_TYP_42_I1_D: "Active Text",
  T_49_META_TYP_42_I10_D: "Max Length",
  T_49_META_TYP_42_I14_D: "Pressed Color",
  T_49_META_TYP_42_I16_D: "Localized Key, available in multiple languages",
  T_49_META_TYP_42_I3_D: "Alignment method",
  T_49_META_TYP_42_I4_D: "Alignment Vertical",
  T_49_META_TYP_42_I5_D: "Is Bold",
  T_49_META_TYP_42_I6_D: "Is Italic",
  T_49_META_TYP_42_I7_D: "Is Underline",
  T_49_META_TYP_42_I8_D: "Line Spacing",
  T_49_META_TYP_42_I9_D: "Word Wrap",
  T_49_META_TYP_424_I0_D: "Linear Fog",
  T_49_META_TYP_424_I1_D: "Exponential Fog",
  T_49_META_TYP_424_I2_D: "Exponential Square Fog",
  T_49_META_TYP_426_I0_D: "Intensity",
  T_49_META_TYP_426_I1_D: "Range",
  T_49_META_TYP_426_I2_D: "The angle of the cone in degrees.",
  T_49_META_TYP_426_I3_D: "Light color",
  T_49_META_TYP_428_I0_D: "Weapon Skin IDs",
  T_49_META_TYP_428_I2_D: "Suit ID",
  T_49_META_TYP_428_I3_D: "Headwear ID",
  T_49_META_TYP_428_I4_D: "Face ID",
  T_49_META_TYP_428_I5_D: "Makeup ID",
  T_49_META_TYP_428_I6_D: "Upper Body ID",
  T_49_META_TYP_428_I7_D: "Bottom ID",
  T_49_META_TYP_428_I8_D: "Shoe ID",
  T_49_META_TYP_431_I1_D: "The trajectory of the target entity",
  T_49_META_TYP_431_I3_D: "Movement speed, unit m/s",
  T_49_META_TYP_431_I4_D: `Whether the movement is toward the tangent line of the path or not 
Default is False, the movement of the object will not change the direction 
 If True, the movement of the object will face the path forward direction`,
  T_49_META_TYP_431_I5_D: "Played Percentage",
  T_49_META_TYP_432_I0_D: "Rollover angle, affects the radial rotation of the path from both sides of this point",
  T_49_META_TYP_432_I1_D: "The relative position of the tangent control point to the waypoint, which determines the path tangent.",
  T_49_META_TYP_433_I0_D: "Tween straight lines between path points",
  T_49_META_TYP_433_I1_D: "Tween curves between path points for smooth motion.",
  T_49_META_TYP_433_I2_D: "Supports manual adjustment of tangents to curve points",
  T_49_META_TYP_434_I0_D: "Path type",
  T_49_META_TYP_434_I1_D: "Total length of the path",
  T_49_META_TYP_434_I2_D: "Whether the path begins and ends at the same time",
  T_49_META_TYP_434_I3_D: "Collection of waypoints",
  T_49_META_TYP_437_I3_D: "Left Players",
  T_49_META_TYP_437_I4_D: "Right Players",
  T_49_META_TYP_437_I5_D: "Array of points type names",
  T_49_META_TYP_437_I6_D: "Left points array (List 1D: player; List 2D: points data filled according to customized points type)",
  T_49_META_TYP_437_I7_D: "Array of points on the right (List 1D: players; List 2D: points data filled in according to customized points types)",
  T_49_META_TYP_438_I1_D: "Grouped players array",
  T_49_META_TYP_438_I2_D: "Grouped Ranking Array",
  T_49_META_TYP_438_I3_D: "Array of grouped scores",
  T_49_META_TYP_438_I4_D: "Array of point type names",
  T_49_META_TYP_438_I5_D: "Grouped colors array",
  T_49_META_TYP_438_I6_D: "Array of players' points (corresponding to their order when not grouped)",
  T_49_META_TYP_442_I1_D: "Left Score",
  T_49_META_TYP_442_I10_D: "Right death icon",
  T_49_META_TYP_442_I2_D: "Right Score",
  T_49_META_TYP_442_I3_D: "Number of survivors on the left",
  T_49_META_TYP_442_I4_D: "Survivors on the right",
  T_49_META_TYP_442_I5_D: "Left Dead",
  T_49_META_TYP_442_I6_D: "Right Deaths",
  T_49_META_TYP_442_I7_D: "Left survivor icon",
  T_49_META_TYP_442_I8_D: "Right Survival Icon",
  T_49_META_TYP_442_I9_D: "Left Dead Icon",
  T_49_META_TYP_444_I0_D: "English",
  T_49_META_TYP_444_I1_D: "Simplified Chinese",
  T_49_META_TYP_444_I10_D: "French",
  T_49_META_TYP_444_I11_D: "German",
  T_49_META_TYP_444_I12_D: "Turkish",
  T_49_META_TYP_444_I13_D: "Hindi",
  T_49_META_TYP_444_I14_D: "Japanese",
  T_49_META_TYP_444_I15_D: "Romanian",
  T_49_META_TYP_444_I16_D: "Romanian",
  T_49_META_TYP_444_I17_D: "Burmese",
  T_49_META_TYP_444_I18_D: "Urdu",
  T_49_META_TYP_444_I19_D: "Bengali",
  T_49_META_TYP_444_I2_D: "Traditional Chinese",
  T_49_META_TYP_444_I3_D: "Thai",
  T_49_META_TYP_444_I4_D: "Vietnamese",
  T_49_META_TYP_444_I5_D: "Indonesian",
  T_49_META_TYP_444_I6_D: "Chinese (Simplified)",
  T_49_META_TYP_444_I7_D: "Spanish",
  T_49_META_TYP_444_I8_D: "Russian",
  T_49_META_TYP_444_I9_D: "Korean",
  T_49_META_TYP_51_I0_D: "Normal Zombie",
  T_49_META_TYP_51_I1_D: "Axe Zombie",
  T_49_META_TYP_51_I10_D: "Fly Bomb Bee",
  T_49_META_TYP_51_I11_D: "Zombie Dragon",
  T_49_META_TYP_51_I2_D: "Tossing Zombie",
  T_49_META_TYP_51_I3_D: "Self-Explode Zombie",
  T_49_META_TYP_51_I4_D: "Tyrant Zombie",
  T_49_META_TYP_51_I5_D: "Throw Red Zombie",
  T_49_META_TYP_51_I6_D: "MrV",
  T_49_META_TYP_51_I7_D: "Tank Zombie",
  T_49_META_TYP_51_I8_D: "Drill Zombie",
  T_49_META_TYP_51_I9_D: "Samurai",
  T_49_META_TYP_56_I10_D: "Explosion Delay",
  T_49_META_TYP_56_I11_D: "Explosion Range",
  T_49_META_TYP_56_I12_D: "Explosion Damage",
  T_49_META_TYP_56_I13_D: "Burning Time",
  T_49_META_TYP_56_I14_D: "Burning Damage",
  T_49_META_TYP_56_I15_D: "Burning Damage Interval",
  T_49_META_TYP_56_I17_D: "Vehicle Pilot",
  T_49_META_TYP_56_I18_D: "All passengers on the vehicle",
  T_49_META_TYP_56_I19_D: "Vehicle Skin ID",
  T_49_META_TYP_56_I20_D: "Prioritize Player Configuration",
  T_49_META_TYP_56_I21_D: "Max. HP",
  T_49_META_TYP_56_I22_D: "HP",
  T_49_META_TYP_57_I0_D: "Whether to teleport manually or automatically (default is manual)",
  T_49_META_TYP_58_I0_D: "Type of buff generated",
  T_49_META_TYP_58_I1_D: "The time in seconds from when the buff is picked up to when the next buff is generated.",
  T_49_META_TYP_59_I0_D: "Motion Type",
  T_49_META_TYP_59_I1_D: "Motion Value X",
  T_49_META_TYP_59_I2_D: "Motion Value Y",
  T_49_META_TYP_59_I3_D: "Motion Value Z",
  T_49_META_TYP_59_I4_D: "Movement Duration",
  T_49_META_TYP_59_I5_D: "Stop Duration",
  T_49_META_TYP_59_I6_D: "Disable Reciprocating",
  T_49_META_TYP_60_I0_D: "Loot weapon points",
  T_49_META_TYP_61_I0_D: "Bound Store",
  T_49_META_TYP_61_I1_D: "Setting the trigger range",
  T_49_META_TYP_61_I2_D: "Model Visibility",
  T_49_META_TYP_62_I0_D: "Velocity XZ",
  T_49_META_TYP_62_I1_D: "Velocity Y",
  T_49_META_TYP_64_I0_D: "Music component type",
  T_49_META_TYP_66_I0_D: "InstanceID",
  T_49_META_TYP_66_I1_D: "Path Point",
  T_49_META_TYP_68_I0_D: "AI's current blood level",
  T_49_META_TYP_68_I1_D: "AI's current maximum blood level",
  T_49_META_TYP_68_I10_D: "Whether the AI drops equipment or items when it dies.",
  T_49_META_TYP_68_I11_D: "Whether the AI is currently invincible",
  T_49_META_TYP_68_I12_D: "Percentage of damage dealt to the AI when it takes damage, can be reduced or increased",
  T_49_META_TYP_68_I13_D: "Type of AI",
  T_49_META_TYP_68_I14_D: "Whether to automatically search for enemies",
  T_49_META_TYP_68_I15_D: "0 is auto attack, 1 is defense attack, 2 is no attack at all.",
  T_49_META_TYP_68_I16_D: "Path ID",
  T_49_META_TYP_68_I17_D: "Chase Target",
  T_49_META_TYP_68_I18_D: "Attack Target",
  T_49_META_TYP_68_I19_D: "AI's birth point coordinates",
  T_49_META_TYP_68_I2_D: "Get the entity of the AI's team.",
  T_49_META_TYP_68_I20_D: "The team's camp number",
  T_49_META_TYP_68_I4_D: "Can only modify the attack power of normal attacks, skill attacks don't count.",
  T_49_META_TYP_68_I7_D: "AI's free movement range, can only modify the base value, if there is extra bonus, it will be added on top of that value.",
  T_49_META_TYP_68_I8_D: "AI's range to detect enemies, can only modify the base value, if there is an extra bonus, it will be added on top of that value.",
  T_49_META_TYP_68_I9_D: "True movement speed, if there is a skill acceleration it will be multiplied by it.",
  T_49_META_TYP_70_I0_D: "ID of the target entity that the formula works on, used by internal implementations, invisible to the player.",
  T_49_META_TYP_70_I1_D: "ID of the target entity property on which the formula works, used by internal implementations, not visible to the player",
  T_49_META_TYP_70_I2_D: "Minimum value allowed",
  T_49_META_TYP_70_I3_D: "Maximum value allowed",
  T_49_META_TYP_70_I4_D: "Base Coefficient",
  T_49_META_TYP_70_I5_D: "Pre-Accumulator",
  T_49_META_TYP_70_I6_D: "Multiplier",
  T_49_META_TYP_70_I7_D: "Multiply Accumulate",
  T_49_META_TYP_70_I8_D: "Post-Accumulator",
  T_49_META_TYP_71_I0_D: "Shop item number",
  T_49_META_TYP_71_I1_D: "Price",
  T_49_META_TYP_71_I10_D: "Is Purchasable",
  T_49_META_TYP_71_I2_D: "Money Type",
  T_49_META_TYP_71_I3_D: "Overall limit",
  T_49_META_TYP_71_I4_D: "Current overall limit",
  T_49_META_TYP_71_I5_D: "Shop item name",
  T_49_META_TYP_71_I6_D: "Shop Item Description",
  T_49_META_TYP_71_I7_D: "Shop Item List",
  T_49_META_TYP_71_I8_D: "ItemCounts",
  T_49_META_TYP_71_I9_D: "Resource path, empty by default",
  T_49_META_TYP_72_I1_D: "Shop Items",
  T_49_META_TYP_73_I1_D: "Shelfs",
  T_49_META_TYP_74_I0_D: "Weapon",
  T_49_META_TYP_74_I1_D: "Helmet",
  T_49_META_TYP_74_I2_D: "Vest",
  T_49_META_TYP_74_I3_D: "Grenade",
  T_49_META_TYP_75_I0_D: "One Way",
  T_49_META_TYP_75_I1_D: "Back And Forth",
  T_49_META_TYP_76_I0_D: "Patrols only, no attacks on targets along the way",
  T_49_META_TYP_76_I1_D: "Patrol While Attack",
  T_49_META_TYP_79_I0_D: "Weapon Attack Power",
  T_49_META_TYP_79_I1_D: "Attack Range",
  T_49_META_TYP_79_I10_D: "Bullet Spread Start Count",
  T_49_META_TYP_79_I11_D: "Weapon ID",
  T_49_META_TYP_79_I12_D: "Minimum wait time in seconds between shots, multiple bullets may be fired per shot depending on shot type",
  T_49_META_TYP_79_I13_D: "The player who owns the weapon",
  T_49_META_TYP_79_I14_D: "Is Consume Ammo",
  T_49_META_TYP_79_I15_D: "Dual wielding type (0 not dual wielding 1 and self 2 and any weapon)",
  T_49_META_TYP_79_I16_D: "Armor damage factor",
  T_49_META_TYP_79_I17_D: "Player movement speed effects",
  T_49_META_TYP_79_I18_D: "Damage percentage for hitting the torso",
  T_49_META_TYP_79_I19_D: "Percentage of damage that hits the head",
  T_49_META_TYP_79_I2_D: "The length of time to wait between bullets, in seconds.",
  T_49_META_TYP_79_I20_D: "Damage percentage for hitting limbs",
  T_49_META_TYP_79_I21_D: "Extra Damage Ratio (Vehicle, Oil Drum, Ice Wall)",
  T_49_META_TYP_79_I22_D: "Visible On Back",
  T_49_META_TYP_79_I23_D: "Extra damage for hitting the ground",
  T_49_META_TYP_79_I24_D: "Ammo per Shot",
  T_49_META_TYP_79_I25_D: "Bullet change speed (base speed * factor)",
  T_49_META_TYP_79_I26_D: "Current Ammo Count",
  T_49_META_TYP_79_I27_D: "Gunskin ID",
  T_49_META_TYP_79_I28_D: "When player configuration is prioritized, the gun skin configuration on the player overrides the gun skin property of the weapon itself",
  T_49_META_TYP_79_I29_D: "When writing in the gun skin's properties for a weapon, the weapon's base value is affected by the gun skin",
  T_49_META_TYP_79_I3_D: "Ammo Mag Size",
  T_49_META_TYP_79_I30_D: "Diffusion Increase Speed (0.1 = 10% expansion for each additional burst of collision)",
  T_49_META_TYP_79_I31_D: "Diffusion recovery speed",
  T_49_META_TYP_79_I32_D: "Player speed effect when firing",
  T_49_META_TYP_79_I33_D: "Diffusion size in case of movement (1.5 = 1.5 * basic collimator size)",
  T_49_META_TYP_79_I34_D: "Weapon Type",
  T_49_META_TYP_79_I36_D: "Fire Type",
  T_49_META_TYP_79_I37_D: "Is Single Shot",
  T_49_META_TYP_79_I38_D: "Is Silenced",
  T_49_META_TYP_79_I39_D: "ADS Sensitivity Multiplier",
  T_49_META_TYP_79_I4_D: "Initial Mag Count",
  T_49_META_TYP_79_I5_D: "Armor Penetration",
  T_49_META_TYP_79_I6_D: "Full Damage Distance",
  T_49_META_TYP_79_I7_D: "Min. Damage Distance",
  T_49_META_TYP_79_I8_D: "Min. Damage",
  T_49_META_TYP_79_I9_D: "The number of bullets that can be fired before the scattering begins",
  T_49_META_TYP_80_I1_D: "When true, manual disable is disabled.",
  T_49_META_TYP_80_I2_D: "Bound shop entities",
  T_49_META_TYP_80_I4_D: "Bound Money List",
  T_49_META_TYP_80_I5_D: "Bound Wallet ID",
  T_49_META_TYP_80_I6_D: "The type of the current UI player request target",
  T_49_META_TYP_80_I7_D: "Requested Item List",
  T_49_META_TYP_81_I0_D: "Random Buff",
  T_49_META_TYP_81_I1_D: "HP Buff",
  T_49_META_TYP_81_I2_D: "Bullet Buff",
  T_49_META_TYP_81_I3_D: "Armor Buff",
  T_49_META_TYP_82_I1_D: "Button icon",
  T_49_META_TYP_82_I3_D: "Position relative to the anchor point",
  T_49_META_TYP_83_I1_D: "TriggerPlayerID",
  T_49_META_TYP_83_I2_D: "Passed parameters",
  T_49_META_TYP_86_I0_D: "Min",
  T_49_META_TYP_86_I1_D: "Max",
  T_49_META_TYP_86_I2_D: "Base coefficient, multiplied by the original value before all calculations are performed.",
  T_49_META_TYP_86_I3_D: "Pre-accumulator, accumulates before multiplication, participates in multiplication calculations",
  T_49_META_TYP_86_I4_D: "Consecutive multipliers, for example (reduced to 90%, strengthened to 110%) have the effect of Value*90%*110%.",
  T_49_META_TYP_86_I5_D: "The effect of a multiplication accumulator, e.g. (add 10%, add 5%) is Value*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "Post accumulator, not involved in multiplication calculations, stacked at the end",
  T_49_META_TYP_88_I0_D: "Base type, the most basic in-game currency, the type of pricing for general shop items in the current version",
  T_49_META_TYP_89_I0_D: "Only base currency is available in the current version",
  T_49_META_TYP_89_I1_D: "Amount of currency",
  T_49_META_TYP_89_I2_D: "Currency icon",
  T_49_META_TYP_89_I3_D: "Currency icon color",
  T_49_META_TYP_90_I0_D: "The contents of the wallet are a bunch of currencies",
  T_49_META_TYP_92_I0_D: "Square Wooden Crate",
  T_49_META_TYP_92_I1_D: "Long Wooden Crate",
  T_49_META_TYP_92_I10_D: "Turret",
  T_49_META_TYP_92_I100_D: "Stairs",
  T_49_META_TYP_92_I101_D: "Stair Landing B",
  T_49_META_TYP_92_I102_D: "Stair Landing A",
  T_49_META_TYP_92_I103_D: "Phone Booth",
  T_49_META_TYP_92_I104_D: "BIS Themed Wall",
  T_49_META_TYP_92_I105_D: "BIS Themed Flower Bed",
  T_49_META_TYP_92_I106_D: "Vending Machine",
  T_49_META_TYP_92_I107_D: "Monster Entities",
  T_49_META_TYP_92_I108_D: "Unit Generator",
  T_49_META_TYP_92_I109_D: "Sports Car",
  T_49_META_TYP_92_I11_D: "Guardhouse",
  T_49_META_TYP_92_I110_D: "Tuk Tuk",
  T_49_META_TYP_92_I111_D: "Destructible Wooden Crate",
  T_49_META_TYP_92_I112_D: "SUV",
  T_49_META_TYP_92_I113_D: "Motorbike",
  T_49_META_TYP_92_I114_D: "Monster Truck",
  T_49_META_TYP_92_I115_D: "Coin Generator",
  T_49_META_TYP_92_I116_D: "Stair Landing C",
  T_49_META_TYP_92_I117_D: "Sign",
  T_49_META_TYP_92_I118_D: "Fence",
  T_49_META_TYP_92_I119_D: "Jersey Machine",
  T_49_META_TYP_92_I12_D: "Two-Story House",
  T_49_META_TYP_92_I121_D: "Concrete Pillar",
  T_49_META_TYP_92_I122_D: "Loot Soccer Item Box",
  T_49_META_TYP_92_I123_D: "Oil Drum",
  T_49_META_TYP_92_I124_D: "Low-Gravity Area",
  T_49_META_TYP_92_I125_D: "Weapon",
  T_49_META_TYP_92_I126_D: "Fence B",
  T_49_META_TYP_92_I127_D: "Small House A",
  T_49_META_TYP_92_I128_D: "Damaged Truck",
  T_49_META_TYP_92_I129_D: "Basic Sphere",
  T_49_META_TYP_92_I13_D: "Sand Sculpture",
  T_49_META_TYP_92_I130_D: "Basic Cone",
  T_49_META_TYP_92_I131_D: "Basic Cylinder",
  T_49_META_TYP_92_I132_D: "Consumable Generator",
  T_49_META_TYP_92_I133_D: "Custom Water Body",
  T_49_META_TYP_92_I134_D: "Arrow",
  T_49_META_TYP_92_I135_D: "Dyed Block",
  T_49_META_TYP_92_I136_D: "Dyed Oil Drum",
  T_49_META_TYP_92_I137_D: "Text",
  T_49_META_TYP_92_I138_D: "Icon",
  T_49_META_TYP_92_I139_D: "Ice Doll",
  T_49_META_TYP_92_I14_D: "Fountain",
  T_49_META_TYP_92_I140_D: "Capsule Trigger",
  T_49_META_TYP_92_I141_D: "Sphere Collision Trigger",
  T_49_META_TYP_92_I142_D: "Reflective Solid Color Basic Block 1",
  T_49_META_TYP_92_I143_D: "Bumper Car Manufacturer",
  T_49_META_TYP_92_I144_D: "Checkered Amusement Park Block",
  T_49_META_TYP_92_I145_D: "Large Screen",
  T_49_META_TYP_92_I146_D: "Podium",
  T_49_META_TYP_92_I147_D: "Giant Lollipop",
  T_49_META_TYP_92_I148_D: "Food Truck B",
  T_49_META_TYP_92_I15_D: "Cherry Blossom",
  T_49_META_TYP_92_I16_D: "One-Story House",
  T_49_META_TYP_92_I17_D: "Three-Story House",
  T_49_META_TYP_92_I18_D: "Banana Tree",
  T_49_META_TYP_92_I19_D: "Toilet",
  T_49_META_TYP_92_I2_D: "Bush-Covered Long Wooden Crate",
  T_49_META_TYP_92_I20_D: "Fence",
  T_49_META_TYP_92_I21_D: "Destructible Container",
  T_49_META_TYP_92_I22_D: "Destructible Fence",
  T_49_META_TYP_92_I23_D: "Tire",
  T_49_META_TYP_92_I24_D: "Bumper Car",
  T_49_META_TYP_92_I25_D: "Amphibious Vehicle",
  T_49_META_TYP_92_I26_D: "Jeep",
  T_49_META_TYP_92_I27_D: "Trash Can",
  T_49_META_TYP_92_I28_D: "Medical Tent",
  T_49_META_TYP_92_I29_D: "Garage",
  T_49_META_TYP_92_I3_D: "Haystack",
  T_49_META_TYP_92_I30_D: "Painted Wall",
  T_49_META_TYP_92_I31_D: "Torii",
  T_49_META_TYP_92_I32_D: "Iron Platform",
  T_49_META_TYP_92_I33_D: "Container House",
  T_49_META_TYP_92_I34_D: "Trailer",
  T_49_META_TYP_92_I35_D: "Wall A",
  T_49_META_TYP_92_I36_D: "Musical Notes - Piano",
  T_49_META_TYP_92_I37_D: "Musical Notes - Piano",
  T_49_META_TYP_92_I38_D: "Musical Notes - Drum",
  T_49_META_TYP_92_I39_D: "Musical Notes - Drum",
  T_49_META_TYP_92_I4_D: "Wrecked Car",
  T_49_META_TYP_92_I40_D: "Musical Notes - Synthesizer A",
  T_49_META_TYP_92_I41_D: "Musical Notes - Synthesizer A",
  T_49_META_TYP_92_I42_D: "Musical Notes - Synthesizer B",
  T_49_META_TYP_92_I43_D: "Musical Notes - Synthesizer B",
  T_49_META_TYP_92_I44_D: "Musical Notes - Synthesizer C",
  T_49_META_TYP_92_I45_D: "Musical Notes - Synthesizer C",
  T_49_META_TYP_92_I46_D: "Buff Generator",
  T_49_META_TYP_92_I47_D: "Propeller Mechanisms",
  T_49_META_TYP_92_I48_D: "Pan Loot",
  T_49_META_TYP_92_I49_D: "Cube Loot",
  T_49_META_TYP_92_I5_D: "Wrecked Bus",
  T_49_META_TYP_92_I50_D: "Circle Loot",
  T_49_META_TYP_92_I51_D: "Mallet Machine",
  T_49_META_TYP_92_I52_D: "Moving Board",
  T_49_META_TYP_92_I53_D: "Moving Target",
  T_49_META_TYP_92_I54_D: "Retractable Wall",
  T_49_META_TYP_92_I55_D: "Loot Point Weapon Component",
  T_49_META_TYP_92_I56_D: "Loot Point Bullet Component",
  T_49_META_TYP_92_I57_D: "Loot Point Expendable Item Component",
  T_49_META_TYP_92_I58_D: "Loot Point Thrown Item Component",
  T_49_META_TYP_92_I59_D: "Loot Point Multiplier Component",
  T_49_META_TYP_92_I6_D: "Container A",
  T_49_META_TYP_92_I60_D: "Loot Point Armor Component",
  T_49_META_TYP_92_I61_D: "I Pipe",
  T_49_META_TYP_92_I62_D: "T Pipe",
  T_49_META_TYP_92_I63_D: "Cross Pipe",
  T_49_META_TYP_92_I64_D: "Elbow Pipe",
  T_49_META_TYP_92_I65_D: "Giant Mushroom Cluster",
  T_49_META_TYP_92_I66_D: "Drying Rack",
  T_49_META_TYP_92_I67_D: "Plank Bridge",
  T_49_META_TYP_92_I68_D: "Lattice Screen",
  T_49_META_TYP_92_I69_D: "Concrete Column",
  T_49_META_TYP_92_I7_D: "Shipping Container B",
  T_49_META_TYP_92_I70_D: "Cactus",
  T_49_META_TYP_92_I71_D: "Dead Wood",
  T_49_META_TYP_92_I72_D: "Stone Lantern",
  T_49_META_TYP_92_I73_D: "Streetlight",
  T_49_META_TYP_92_I74_D: "Solar Panel",
  T_49_META_TYP_92_I75_D: "Air Conditioner",
  T_49_META_TYP_92_I76_D: "Square",
  T_49_META_TYP_92_I77_D: "Slope",
  T_49_META_TYP_92_I78_D: "Food Truck",
  T_49_META_TYP_92_I79_D: "Death or Invincibility Trigger",
  T_49_META_TYP_92_I8_D: "Shipping Container C",
  T_49_META_TYP_92_I80_D: "Checkpoint",
  T_49_META_TYP_92_I81_D: "End Position",
  T_49_META_TYP_92_I82_D: "Dice",
  T_49_META_TYP_92_I83_D: "Bench",
  T_49_META_TYP_92_I84_D: "Bus Stop",
  T_49_META_TYP_92_I85_D: "Dog House",
  T_49_META_TYP_92_I86_D: "Ad Board",
  T_49_META_TYP_92_I87_D: "Refinery Tank",
  T_49_META_TYP_92_I88_D: "Graffiti Wall",
  T_49_META_TYP_92_I89_D: "Stable",
  T_49_META_TYP_92_I9_D: "Cabin",
  T_49_META_TYP_92_I90_D: "Stone Arch Bridge",
  T_49_META_TYP_92_I91_D: "Patio Set With Umbrella",
  T_49_META_TYP_92_I92_D: "Finish Banner",
  T_49_META_TYP_92_I93_D: "Fortress",
  T_49_META_TYP_92_I94_D: "Monster Spawn Point",
  T_49_META_TYP_92_I95_D: "Mark",
  T_49_META_TYP_92_I97_D: "Custom Trigger",
  T_49_META_TYP_92_I98_D: "Double Door",
  T_49_META_TYP_92_I99_D: "Barricade",
  T_49_META_TYP_94_I0_D: "Add",
  T_49_META_TYP_94_I1_D: "Multiply",
  T_49_META_TYP_95_I0_D: "Money Type",
  T_49_META_TYP_95_I1_D: "Amount of currency",
  T_49_META_TYP_96_I0_D: "Get Wallet",
  T_49_META_TYP_96_I1_D: "Display position (anchor is top right corner)",
  T_49_META_TYP_97_I0_D: "Position in the world coordinate system",
  T_49_META_TYP_97_I1_D: "Rotation angle in the world coordinate system, XYZ components are pitch, yaw, and roll, respectively, and rotation order YXZ.",
  T_49_META_TYP_97_I10_D: "Local coordinate axis x-axis orientation",
  T_49_META_TYP_97_I11_D: "Local axis z-axis orientation",
  T_49_META_TYP_97_I2_D: "Zoom size in the world coordinate system",
  T_49_META_TYP_97_I3_D: "Parent node of this node",
  T_49_META_TYP_97_I4_D: "Rotation in the world coordinate system, expressed in quaternions",
  T_49_META_TYP_97_I5_D: "Position in local coordinate system",
  T_49_META_TYP_97_I6_D: "Rotation in the local coordinate system, expressed in quaternions",
  T_49_META_TYP_97_I7_D: "Rotation angle in the local coordinate system, with XYZ components for pitch, yaw, and roll, respectively, and rotation order YXZ.",
  T_49_META_TYP_97_I8_D: "Scaling dimension in the local coordinate system",
  T_49_META_TYP_97_I9_D: "Local coordinate axis y-axis orientation",
  T_49_META_TYP_99_I0_D: "Radius of the soccer ball",
  T_49_META_TYP_99_I1_D: "Friction coefficient at normal condition",
  T_49_META_TYP_99_I2_D: "Impact Friction",
  T_49_META_TYP_99_I3_D: "Min. Shooting Angle",
  T_49_META_TYP_99_I4_D: "Min. Elevation Angle",
  T_49_META_TYP_99_I5_D: "Reset Time",
  T_49_META_TYP_99_I6_D: "Max. Shooting Angle",
  T_49_META_TYP_99_I7_D: "Reset Position",
  T_49_META_TYPE_0_D: "Object, the root of the type hierarchy",
  T_49_META_TYPE_1_D: "A container for a set of data in a list",
  T_49_META_TYPE_10_D: "Entity base component, all components will combine this component",
  T_49_META_TYPE_100_D: "JerseyMachine",
  T_49_META_TYPE_101_D: "Morph Object",
  T_49_META_TYPE_1010_D: "Timer Info",
  T_49_META_TYPE_1011_D: "Opening Banner",
  T_49_META_TYPE_1012_D: "Banner entities start in two-team rounds, and modifying entity properties affects the display on the corresponding UI.",
  T_49_META_TYPE_1013_D: "General round start banner entity, modifying entity properties affects display content on corresponding UIs",
  T_49_META_TYPE_1014_D: "Team round score banner entity, modifying entity properties affects the display on the corresponding UI.",
  T_49_META_TYPE_1015_D: "Checkpoint Manager entity, modifying the entity properties will affect the display on the corresponding UI.",
  T_49_META_TYPE_1016_D: "End of round display entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1017_D: "If there are two teams at the start of the round, display the two teams' rivalry banner",
  T_49_META_TYPE_1018_D: "Score of the round between the two teams",
  T_49_META_TYPE_1019_D: "The final result is a tie",
  T_49_META_TYPE_102_D: "Resurrection source type: death, fall down",
  T_49_META_TYPE_1020_D: "Round count entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1021_D: "Phase countdown entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_1022_D: "Match information subheading entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1023_D: "Two teams match information entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_1024_D: "Team match information UI entity, modify the entity property to affect the display content on the corresponding UI",
  T_49_META_TYPE_1027_D: "Describes the type of the type and returns that type when Typeof is used",
  T_49_META_TYPE_1028_D: "Camp information entity, modify the entity properties to affect the display content of the corresponding UI.",
  T_49_META_TYPE_1029_D: "The icon hint information entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_103_D: "Enumeration of item slots",
  T_49_META_TYPE_1030_D: "Short version of the two teams' match information entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_1031_D: "Timing prompt UI entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1032_D: "Floating word prompt entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1033_D: "Round switching entity, including current round settlement and next round start information, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1035_D: "Open scoreboard button UI entity, modifying entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1036_D: "Infected mode, display the UI of current zombie level.",
  T_49_META_TYPE_1037_D: "Add points animation UI entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_1038_D: "Infected mode zombie UI effects",
  T_49_META_TYPE_1039_D: "Countdown prompt entity, modifying the entity properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_104_D: "Jersey Style",
  T_49_META_TYPE_1040_D: "UI Card Selection Panel",
  T_49_META_TYPE_1041_D: "UI Identity Notification",
  T_49_META_TYPE_1042_D: "UI Countdown 5s",
  T_49_META_TYPE_1043_D: "UI Title Banner",
  T_49_META_TYPE_1044_D: "UI Built-In Switch",
  T_49_META_TYPE_1045_D: "UI Skill Button",
  T_49_META_TYPE_105_D: "Football Goal",
  T_49_META_TYPE_106_D: "Aiming aid type",
  T_49_META_TYPE_107_D: "Entities that can be targeted and hit, but not necessarily harmed",
  T_49_META_TYPE_108_D: "Integer types, 64-bit signed integers",
  T_49_META_TYPE_109_D: "The chat channel entity is a container that contains its channel ID and players.",
  T_49_META_TYPE_11_D: "Global entity, unique for the entire game",
  T_49_META_TYPE_110_D: "Idle chat channel",
  T_49_META_TYPE_111_D: "Behavior types",
  T_49_META_TYPE_112_D: "Player Behavior Status Type",
  T_49_META_TYPE_113_D: "Drum Music",
  T_49_META_TYPE_114_D: "Lead1 Music",
  T_49_META_TYPE_115_D: "Lead2 Music",
  T_49_META_TYPE_116_D: "Lead3 Music",
  T_49_META_TYPE_117_D: "Drumbeat music component type",
  T_49_META_TYPE_118_D: "Faction",
  T_49_META_TYPE_119_D: "Attackable options",
  T_49_META_TYPE_12_D: "Combat entities, can attack, take hits, kill, etc.",
  T_49_META_TYPE_120_D: "UI Progress Bar",
  T_49_META_TYPE_121_D: "Interval between waves",
  T_49_META_TYPE_122_D: "Skybox",
  T_49_META_TYPE_123_D: "Enumeration of skybox base types",
  T_49_META_TYPE_124_D: "Claim Range",
  T_49_META_TYPE_125_D: "Can modify the base appearance of objects, such as mapping and transparency",
  T_49_META_TYPE_126_D: "Health Bar",
  T_49_META_TYPE_127_D: "How to move objects",
  T_49_META_TYPE_128_D: "Morphable Object",
  T_49_META_TYPE_129_D: "Loot Ammo Type",
  T_49_META_TYPE_13_D: "UI Widget Entity",
  T_49_META_TYPE_130_D: "Loot Consumable Type",
  T_49_META_TYPE_131_D: "Loot Armor Type",
  T_49_META_TYPE_132_D: "Loot Throwable Type",
  T_49_META_TYPE_133_D: "Loot Scope Type",
  T_49_META_TYPE_134_D: "Loot Weapon Type",
  T_49_META_TYPE_135_D: "Generates ammo drops of the selected type",
  T_49_META_TYPE_136_D: "Generates a consumable drop of the selected type.",
  T_49_META_TYPE_137_D: "Generates a selected type of projectile drop",
  T_49_META_TYPE_138_D: "Spawns a scope drop of the selected type",
  T_49_META_TYPE_139_D: "Generates the selected type of armor drop.",
  T_49_META_TYPE_14_D: "In-game player entities, one per user",
  T_49_META_TYPE_140_D: "Wave",
  T_49_META_TYPE_141_D: "Loot Soccer Type",
  T_49_META_TYPE_142_D: "Loot Soccer Item Box",
  T_49_META_TYPE_143_D: "Lead1 music component type",
  T_49_META_TYPE_144_D: "Lead2 Music Component Type",
  T_49_META_TYPE_145_D: "Lead3 Music Component Type",
  T_49_META_TYPE_146_D: "Key Music Component Type",
  T_49_META_TYPE_147_D: "Multiple preset camera types available, as well as custom camera types",
  T_49_META_TYPE_148_D: "Camera components",
  T_49_META_TYPE_149_D: "Localization Key",
  T_49_META_TYPE_15_D: "In-game team entities, one per team",
  T_49_META_TYPE_150_D: "Oil Drum",
  T_49_META_TYPE_151_D: "Quaternion is a special four-dimensional vector used only to represent rotations",
  T_49_META_TYPE_152_D: "Low-Gravity Area",
  T_49_META_TYPE_153_D: "Entity containers that generate entities of the corresponding type at the location.",
  T_49_META_TYPE_154_D: "Dual-Wield Weapon Type",
  T_49_META_TYPE_155_D: "Helmet entity",
  T_49_META_TYPE_156_D: "Body armor",
  T_49_META_TYPE_157_D: "Camera Transition Type",
  T_49_META_TYPE_158_D: "Text prompt UI",
  T_49_META_TYPE_159_D: "Vector2",
  T_49_META_TYPE_16_D: "Level object entities",
  T_49_META_TYPE_160_D: "Texture Types",
  T_49_META_TYPE_161_D: "Un Replaceable Texture VFX",
  T_49_META_TYPE_162_D: "Type List",
  T_49_META_TYPE_163_D: "Type or Type List",
  T_49_META_TYPE_164_D: "Component is the base class of all entity components or specific component classes.",
  T_49_META_TYPE_165_D: "Collision box component",
  T_49_META_TYPE_166_D: "Emote",
  T_49_META_TYPE_167_D: "Special effect entity represents a displayed special effect (deleted, reusable).",
  T_49_META_TYPE_17_D: "Level Object List",
  T_49_META_TYPE_170_D: "Indicates whether visibility can be set",
  T_49_META_TYPE_171_D: "Mushroom",
  T_49_META_TYPE_172_D: "Ammo",
  T_49_META_TYPE_173_D: "Backpack",
  T_49_META_TYPE_174_D: "Grenade component",
  T_49_META_TYPE_175_D: "Freezing Grenade",
  T_49_META_TYPE_176_D: "Weapon Generator",
  T_49_META_TYPE_177_D: "Motion mode of the camera when there is an obstruction between the camera and the object it is following",
  T_49_META_TYPE_178_D: "Camera's imaging style when rendering a screen",
  T_49_META_TYPE_179_D: "Basic Sphere",
  T_49_META_TYPE_18_D: "(Deprecated, please do not use)",
  T_49_META_TYPE_180_D: "refers to a property of a component",
  T_49_META_TYPE_181_D: "Types used to describe mesh assets",
  T_49_META_TYPE_182_D: "A type used to describe a material asset",
  T_49_META_TYPE_183_D: "A type to describe a texture asset",
  T_49_META_TYPE_184_D: "Bridge rendering component for rendering with built-in model resources",
  T_49_META_TYPE_185_D: "Custom rendering component for rendering with custom model resources",
  T_49_META_TYPE_186_D: "A blank object component that can be used in conjunction with a renderer component, collider component, etc.",
  T_49_META_TYPE_187_D: "Container",
  T_49_META_TYPE_188_D: "Basic Cylinder",
  T_49_META_TYPE_189_D: "List of localized strings",
  T_49_META_TYPE_19_D: "A list template, where the type of content can be specified via T.",
  T_49_META_TYPE_190_D: "Two Team Score Panel",
  T_49_META_TYPE_191_D: "Tactical thrown weapon that blinds enemies within a certain range for a short period of time.",
  T_49_META_TYPE_192_D: "When used, it creates smoke that obscures events, which is a useful tool for interrupting enemy attacks.",
  T_49_META_TYPE_193_D: "Multi-Team Result Panel",
  T_49_META_TYPE_194_D: "Sensor mines that can be placed on the ground and will explode when an enemy approaches, be careful not to step on them yourself",
  T_49_META_TYPE_195_D: "Tween Campaign Playing Style",
  T_49_META_TYPE_197_D: "Playable Components",
  T_49_META_TYPE_198_D: "Item Base",
  T_49_META_TYPE_199_D: "Auxiliary equipment for aerial combat, but you need to keep an eye on the energy consumption at all times",
  T_49_META_TYPE_2_D: "Boolean types, to indicate true, false, or yes/no",
  T_49_META_TYPE_20_D: "A built-in enumeration of UI types, which is automatically generated by the type system.",
  T_49_META_TYPE_200_D: "Jailbreak area",
  T_49_META_TYPE_201_D: "Areas where you can swim after entering",
  T_49_META_TYPE_202_D: "ColliderID",
  T_49_META_TYPE_203_D: "Tween Movement",
  T_49_META_TYPE_204_D: "Shoes fitted with technological power-ups that allow you to jump in the air in two stages",
  T_49_META_TYPE_205_D: "A glider that can fly in the sky, use it to land from a high place to move farther away",
  T_49_META_TYPE_206_D: "Skateboard",
  T_49_META_TYPE_207_D: "Zipline",
  T_49_META_TYPE_208_D: "List of Playables",
  T_49_META_TYPE_209_D: "Playable or List of Playables",
  T_49_META_TYPE_21_D: "Built-in UI entities, which encapsulate specific functionality.",
  T_49_META_TYPE_210_D: "Trajectory Animation is an animation that simulates Trajectory movement.",
  T_49_META_TYPE_211_D: "Coordinate System",
  T_49_META_TYPE_212_D: "One object follows another object",
  T_49_META_TYPE_213_D: "An object's front face is always facing the other object.",
  T_49_META_TYPE_214_D: "An ID that describes a gallery sprite asset",
  T_49_META_TYPE_215_D: "results of a competition",
  T_49_META_TYPE_216_D: "Dictionary data container, the data elements are a pair of Key, Value.",
  T_49_META_TYPE_217_D: "Dictionary data template, can be specified by T1, T2 type of content",
  T_49_META_TYPE_218_D: "A type of light source that emits light of equal intensity in all directions from the position of the light source.",
  T_49_META_TYPE_219_D: "Motorcycle Carrier",
  T_49_META_TYPE_22_D: "Custom UIs, created by the player through the UI editor.",
  T_49_META_TYPE_220_D: "Assault vehicle (tricycle) carrier",
  T_49_META_TYPE_221_D: "Amphibious/Machine Gun Motorcycle Vehicle",
  T_49_META_TYPE_222_D: "Four-wheeled vehicle",
  T_49_META_TYPE_224_D: "Skill Type List",
  T_49_META_TYPE_225_D: "Artificial Intelligence Turret made of high-tech materials that actively searches for and attacks enemies within a certain range.",
  T_49_META_TYPE_226_D: "Turret generated by using turret consumable.",
  T_49_META_TYPE_227_D: "Custom UI widgets type enumeration",
  T_49_META_TYPE_23_D: "An enumeration of the level's object types, which is automatically generated by the system based on the type.",
  T_49_META_TYPE_231_D: "Repair Kit",
  T_49_META_TYPE_233_D: "Progress Circle",
  T_49_META_TYPE_234_D: "Landmine Created",
  T_49_META_TYPE_235_D: "Gloo Wall",
  T_49_META_TYPE_236_D: "Ice Wall Created",
  T_49_META_TYPE_237_D: "Hook Gun",
  T_49_META_TYPE_238_D: "Rainbow Paint Gun",
  T_49_META_TYPE_239_D: "Spray Rifle",
  T_49_META_TYPE_24_D: "Current system-defined damage types",
  T_49_META_TYPE_240_D: "Entities are the carriers of all components, components must be attached to entities to produce instances",
  T_49_META_TYPE_241_D: "Power Hook Gun",
  T_49_META_TYPE_242_D: "Score Bar",
  T_49_META_TYPE_243_D: "Clothing slots",
  T_49_META_TYPE_244_D: "Text entity represents a displayed text",
  T_49_META_TYPE_245_D: "Icon entity represents a displayed icon",
  T_49_META_TYPE_246_D: "Spray Color",
  T_49_META_TYPE_247_D: "Player UI type",
  T_49_META_TYPE_248_D: "General UI switch entity",
  T_49_META_TYPE_249_D: "Switch Equip Slot",
  T_49_META_TYPE_25_D: "Phases of the game, such as game start, game preparation, game end, etc.",
  T_49_META_TYPE_250_D: "Effects entity represents a displayed effect",
  T_49_META_TYPE_2500_D: "The player's birth point",
  T_49_META_TYPE_2501_D: "Triggers for triggering the player's (or other object's) entry and exit events",
  T_49_META_TYPE_2502_D: "Death or invulnerability triggers that control whether the player is dead or invulnerable effects when entering based on properties",
  T_49_META_TYPE_2503_D: "Race mode checkpoints",
  T_49_META_TYPE_2504_D: "Typically used in Race Mode to recognize when a player has entered a specified finish line. This is a specific trigger, custom triggers will be opened later, this endpoint is just a wrapper for custom triggers.",
  T_49_META_TYPE_2505_D: "Fence around the birth point, close it to leave the birth point",
  T_49_META_TYPE_2507_D: "Turret",
  T_49_META_TYPE_2508_D: "Monster Spawn",
  T_49_META_TYPE_2509_D: "Instances of the type can be generated on demand",
  T_49_META_TYPE_251_D: "Effect Container",
  T_49_META_TYPE_2510_D: "Player birth area (rectangle)",
  T_49_META_TYPE_252_D: "Spray Result UI",
  T_49_META_TYPE_253_D: "Hint Button",
  T_49_META_TYPE_254_D: "Heartbeat Effect",
  T_49_META_TYPE_255_D: "Timestamp Localization String",
  T_49_META_TYPE_256_D: "Rigidbody Type",
  T_49_META_TYPE_257_D: "Rigid body components",
  T_49_META_TYPE_258_D: "Timestamp Format Style Type",
  T_49_META_TYPE_259_D: "Tips",
  T_49_META_TYPE_26_D: "Rounds in a game, often a small game with several phases.",
  T_49_META_TYPE_260_D: "Progress Skill Button",
  T_49_META_TYPE_261_D: "Unique ID",
  T_49_META_TYPE_262_D: "Weapon Skin ID",
  T_49_META_TYPE_263_D: "Clothing ID",
  T_49_META_TYPE_264_D: "Consumable ID, when the version only has the weapon ID",
  T_49_META_TYPE_265_D: "UI panel entity",
  T_49_META_TYPE_267_D: "UI scroll view entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_268_D: "A switch with three states, with the option to keep the original logic except for on and off.",
  T_49_META_TYPE_269_D: "The player's equipment.",
  T_49_META_TYPE_270_D: "Entity or Prefab ID",
  T_49_META_TYPE_271_D: "UI panel entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_272_D: "Gender enumeration",
  T_49_META_TYPE_273_D: "Minimap",
  T_49_META_TYPE_274_D: "Icon displayed on the mini-map to follow the target",
  T_49_META_TYPE_275_D: "Individual part nodes in the skeleton",
  T_49_META_TYPE_276_D: "Nodes used to access skinned rigs",
  T_49_META_TYPE_277_D: "Client-side camera ray detection",
  T_49_META_TYPE_278_D: "Pixel blocks displayed on the mini-map, representing the collision size of the object at that location.",
  T_49_META_TYPE_279_D: "Color Drum",
  T_49_META_TYPE_28_D: "Reset at the beginning of each round.",
  T_49_META_TYPE_280_D: "Sphere Trigger",
  T_49_META_TYPE_281_D: "Capsule Trigger",
  T_49_META_TYPE_282_D: "Type describing the asset configuration ID, used to indicate that the parent package comes with the asset configuration ID, which needs to be parsed through the configuration table before loading",
  T_49_META_TYPE_283_D: "Describe the type of asset, used to indicate the identifier of the asset, can be loaded directly.",
  T_49_META_TYPE_284_D: "Indicates a humanoid model resource, which can be replaced with a player character.",
  T_49_META_TYPE_285_D: "A list or dictionary that can be traversed in a loop.",
  T_49_META_TYPE_286_D: "ID to describe the script asset",
  T_49_META_TYPE_287_D: "to describe the ID of a static script asset",
  T_49_META_TYPE_288_D: "to describe the ID of a custom UI asset",
  T_49_META_TYPE_289_D: "ID for describing the body of a preconfigured asset",
  T_49_META_TYPE_29_D: "Special effects",
  T_49_META_TYPE_290_D: "Behavior Tree",
  T_49_META_TYPE_291_D: "Behavior Tree Node Type",
  T_49_META_TYPE_292_D: "Behavior Tree Custom Node",
  T_49_META_TYPE_293_D: "Behavior Tree Attachable",
  T_49_META_TYPE_294_D: "UI layout entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_295_D: "State",
  T_49_META_TYPE_296_D: "Animation Clip",
  T_49_META_TYPE_297_D: "Animation Controller",
  T_49_META_TYPE_298_D: "Loop Type",
  T_49_META_TYPE_3_D: "Integer types, 32-bit signed integers",
  T_49_META_TYPE_30_D: "Icon",
  T_49_META_TYPE_300_D: "UI3DContainer entity, UI edited by the player via the UI Editor",
  T_49_META_TYPE_301_D: "AI Skill Type",
  T_49_META_TYPE_302_D: "Enumeration of equipment slots.",
  T_49_META_TYPE_303_D: "Corresponds to the Id column in BuffData.csv, please check with GPP before adding new items.",
  T_49_META_TYPE_304_D: "Buff Type List",
  T_49_META_TYPE_305_D: "Behavior Tree Node Status",
  T_49_META_TYPE_306_D: "Add buffs, remove buffs, and get a list of buffs already added.",
  T_49_META_TYPE_307_D: "Gloo Maker",
  T_49_META_TYPE_308_D: "Special Item ID Type",
  T_49_META_TYPE_309_D: "Thrown Object Props",
  T_49_META_TYPE_31_D: "Sound Effects",
  T_49_META_TYPE_310_D: "Crossbow",
  T_49_META_TYPE_311_D: "Grenade Base",
  T_49_META_TYPE_312_D: "Throwable props",
  T_49_META_TYPE_313_D: "Grenade DeIce Wall",
  T_49_META_TYPE_314_D: "Managing Animation Controllers and Resources",
  T_49_META_TYPE_315_D: "Player Backpack",
  T_49_META_TYPE_316_D: "UITexture entity, the UI edited by the player through the UI editor",
  T_49_META_TYPE_317_D: "Rigid body motion constraints, each of which can be used in combination",
  T_49_META_TYPE_318_D: "Attachment",
  T_49_META_TYPE_319_D: "Fill type enumeration",
  T_49_META_TYPE_32_D: "Player state type",
  T_49_META_TYPE_320_D: "Fill direction",
  T_49_META_TYPE_321_D: "Entities that can be target-assisted",
  T_49_META_TYPE_322_D: "Damaged Body Part Type",
  T_49_META_TYPE_323_D: "UIProfileInfo entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_324_D: "Several different effects of rigid body forces. Note that this only works for Dynamic types.",
  T_49_META_TYPE_325_D: "to describe the ID of a widget in a custom UI asset",
  T_49_META_TYPE_326_D: "Player profile information",
  T_49_META_TYPE_327_D: "Configure dressing according to each component",
  T_49_META_TYPE_328_D: "Behavior Tree ID",
  T_49_META_TYPE_329_D: "Seat Type",
  T_49_META_TYPE_33_D: "Sort by: ascending ignore zero value, descending, ascending",
  T_49_META_TYPE_330_D: "Self-relative movement",
  T_49_META_TYPE_331_D: "Bezier Curve",
  T_49_META_TYPE_332_D: "Loopable component",
  T_49_META_TYPE_333_D: "Font Type",
  T_49_META_TYPE_334_D: "Vehicle Skin ID",
  T_49_META_TYPE_335_D: "The sound entity represents a playing sound effect.",
  T_49_META_TYPE_336_D: "Sound Effect List",
  T_49_META_TYPE_337_D: "Sound Effect or Sound Effect List",
  T_49_META_TYPE_338_D: "Player behavior property synchronization entity",
  T_49_META_TYPE_339_D: "Equipment Accessory",
  T_49_META_TYPE_34_D: "Item ID",
  T_49_META_TYPE_340_D: "Bot Difficulty Type",
  T_49_META_TYPE_341_D: "Dictionary of integers",
  T_49_META_TYPE_342_D: "Timer objects",
  T_49_META_TYPE_343_D: "Flying Daggers (pickable)",
  T_49_META_TYPE_344_D: "Throwing Knife",
  T_49_META_TYPE_345_D: "Weapon Type",
  T_49_META_TYPE_346_D: "Ammo Type",
  T_49_META_TYPE_347_D: "Frame Self Relative",
  T_49_META_TYPE_348_D: "Function pointer to a function instance, used to implement dummy functions or delegate mechanism.",
  T_49_META_TYPE_349_D: "A handle to a concurrent program, which can be used to perform some handle operations.",
  T_49_META_TYPE_350_D: "Vehicle enumeration",
  T_49_META_TYPE_351_D: "Describes the type of the object",
  T_49_META_TYPE_352_D: "UIToggle entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_353_D: "MedKit",
  T_49_META_TYPE_354_D: "Inhaler",
  T_49_META_TYPE_355_D: "Horizaline",
  T_49_META_TYPE_356_D: "Airdrops, will start dropping from a high place after the preparation time is over",
  T_49_META_TYPE_357_D: "Descriptive colors for objects, such as borders, surfaces, etc. (deleted, reusable)",
  T_49_META_TYPE_358_D: "Refers to an event",
  T_49_META_TYPE_359_D: "Player controller with physics effects to apply forces.",
  T_49_META_TYPE_360_D: "Launch Pad",
  T_49_META_TYPE_361_D: "Folded cannon, when unfolded it can be used to launch people out, be careful not to launch yourself out of the safe zone!",
  T_49_META_TYPE_362_D: "Snowball fight! Punch it!",
  T_49_META_TYPE_363_D: "Shop request purchase",
  T_49_META_TYPE_364_D: "AnimationTrigger",
  T_49_META_TYPE_365_D: "Animation Trigger UI Component",
  T_49_META_TYPE_366_D: "Batch Combine Render",
  T_49_META_TYPE_367_D: "Top Compass",
  T_49_META_TYPE_368_D: "Custom character resource ID",
  T_49_META_TYPE_369_D: "Custom animation resource ID",
  T_49_META_TYPE_370_D: "Information displayed at the start of a round",
  T_49_META_TYPE_371_D: "At the end of each round, the results are displayed.",
  T_49_META_TYPE_372_D: "Player Stance Types",
  T_49_META_TYPE_373_D: "Collection ID, used for resource information collection",
  T_49_META_TYPE_374_D: "Follow Health Bar",
  T_49_META_TYPE_375_D: "Monster target type",
  T_49_META_TYPE_376_D: "Defense tower attack target type",
  T_49_META_TYPE_377_D: "Alias to refer to player entity, vehicle entity type",
  T_49_META_TYPE_378_D: "to describe the ID of an audio asset",
  T_49_META_TYPE_379_D: "ID to describe the configuration table asset",
  T_49_META_TYPE_38_D: "UI Empty Widget entity, UI edited by the player through the UI editor.",
  T_49_META_TYPE_380_D: "ID to describe the effects asset",
  T_49_META_TYPE_381_D: "ID to describe the Animation Controller asset",
  T_49_META_TYPE_382_D: "How knockdown status is handled",
  T_49_META_TYPE_383_D: "Surface or decorations on the map itself",
  T_49_META_TYPE_384_D: "Items",
  T_49_META_TYPE_385_D: "Character Skill ID",
  T_49_META_TYPE_386_D: "Skill ID List",
  T_49_META_TYPE_387_D: "UITouchPad entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_388_D: "Backpack Skin ID",
  T_49_META_TYPE_389_D: "Joystick entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_39_D: "UI image entity, the UI edited by the player through the UI editor.",
  T_49_META_TYPE_390_D: "Hierarchical",
  T_49_META_TYPE_391_D: "Custom UI or Widget",
  T_49_META_TYPE_392_D: "Placeable out-of-zone objects",
  T_49_META_TYPE_393_D: "Entities with PhysicalCCT or Rigidbody component",
  T_49_META_TYPE_394_D: "Mathematical constants",
  T_49_META_TYPE_395_D: "Entities with PhysicalCCT or PlayerCCT components can move along with them.",
  T_49_META_TYPE_396_D: "Mid-Game Exit Configuration",
  T_49_META_TYPE_397_D: "Components used to describe collision shapes",
  T_49_META_TYPE_398_D: "String or Localization String",
  T_49_META_TYPE_399_D: "Character Controller with Physical Effects, for FF characters only.",
  T_49_META_TYPE_4_D: "Floating-point type, 32-bit single-precision floating-point number",
  T_49_META_TYPE_40_D: "UI Text entity, the UI edited by the player through the UI editor.",
  T_49_META_TYPE_400_D: "How to perform the attack behavior",
  T_49_META_TYPE_401_D: "Fire Type",
  T_49_META_TYPE_402_D: "Social Button Widget",
  T_49_META_TYPE_403_D: "Social Button Types",
  T_49_META_TYPE_404_D: "Social Button Styles",
  T_49_META_TYPE_405_D: "Layout Sort Type",
  T_49_META_TYPE_406_D: "Can be triggered to go over obstacles",
  T_49_META_TYPE_407_D: "Platform Type",
  T_49_META_TYPE_408_D: "Base Data Alias",
  T_49_META_TYPE_409_D: "Error code enumeration",
  T_49_META_TYPE_41_D: "UI button entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_410_D: "Alias that refers to a player entity or Transform entity type",
  T_49_META_TYPE_411_D: "Helicopter Carrier",
  T_49_META_TYPE_412_D: "Vehicle component, which is an extension of the Carrier component.",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "Limits the range of camera rotation angles",
  T_49_META_TYPE_415_D: "Persona",
  T_49_META_TYPE_416_D: "Persona Chat Window UI",
  T_49_META_TYPE_417_D: "Particle entity component",
  T_49_META_TYPE_418_D: "Member status enumeration",
  T_49_META_TYPE_419_D: "Gun Skin Type",
  T_49_META_TYPE_42_D: "UI input entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_420_D: "Vehicle Skin Types",
  T_49_META_TYPE_421_D: "Skin",
  T_49_META_TYPE_422_D: "Backpack Skin Types",
  T_49_META_TYPE_423_D: "Persona ID",
  T_49_META_TYPE_424_D: "Fog effect base type",
  T_49_META_TYPE_425_D: "Particle asset ID",
  T_49_META_TYPE_426_D: "A type of light source that emits a cone of light in the negative Y-axis direction from the light source, defaulting to the ground.",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "Clothing information to be retained when the player transforms into another character.",
  T_49_META_TYPE_429_D: "Player or NPC entities",
  T_49_META_TYPE_43_D: "List of element types that must be player entities",
  T_49_META_TYPE_430_D: "Random Number Generator",
  T_49_META_TYPE_431_D: "Motion objects moving along a customized path",
  T_49_META_TYPE_432_D: "Custom Curve Path Waypoints",
  T_49_META_TYPE_433_D: "Custom curve path waypoint types",
  T_49_META_TYPE_434_D: "Custom Curve Paths",
  T_49_META_TYPE_435_D: "List of unique player identifiers",
  T_49_META_TYPE_436_D: "Error code list",
  T_49_META_TYPE_437_D: "Two teams match details UI entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_438_D: "Multi-team match details UI entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_439_D: "Combine",
  T_49_META_TYPE_44_D: "A list of entities whose element types must be team entities",
  T_49_META_TYPE_440_D: "Timeline",
  T_49_META_TYPE_441_D: "Timeline Resource ID",
  T_49_META_TYPE_442_D: "New two-team match information short version entity component, supports fully customizable headcount display",
  T_49_META_TYPE_443_D: "Dialog stream asset ID",
  T_49_META_TYPE_444_D: "Language Type",
  T_49_META_TYPE_45_D: "Bool List",
  T_49_META_TYPE_46_D: "Int List",
  T_49_META_TYPE_47_D: "Float List",
  T_49_META_TYPE_48_D: "String List",
  T_49_META_TYPE_49_D: "Vector3 List",
  T_49_META_TYPE_5_D: "String type, value is text content",
  T_49_META_TYPE_50_D: "A list of entities whose element types must be entities",
  T_49_META_TYPE_51_D: "Zombie Types",
  T_49_META_TYPE_53_D: "Common Level Object",
  T_49_META_TYPE_54_D: "Destructible Object",
  T_49_META_TYPE_55_D: "General Spawn Point",
  T_49_META_TYPE_56_D: "Vehicle",
  T_49_META_TYPE_57_D: "Players can be teleported to a specific location upon entry",
  T_49_META_TYPE_58_D: "Buffs can be generated on demand",
  T_49_META_TYPE_59_D: "Moving Platform",
  T_49_META_TYPE_6_D: "Three-dimensional vectors, which can represent spatial coordinates or spatial directions",
  T_49_META_TYPE_60_D: "Generates a weapon drop of the selected type.",
  T_49_META_TYPE_61_D: "Entering the trigger range opens the Bound Shop.",
  T_49_META_TYPE_62_D: "Bouncy Dice",
  T_49_META_TYPE_63_D: "Players step on them and they will be bounced to a specific location.",
  T_49_META_TYPE_64_D: "Players will make a sound when stepping on them",
  T_49_META_TYPE_65_D: "Basic Scalable",
  T_49_META_TYPE_66_D: "Custom Path",
  T_49_META_TYPE_67_D: "Path Point",
  T_49_META_TYPE_68_D: "AI monster entities, such as zombies",
  T_49_META_TYPE_69_D: "Large numbers are high precision floating point numbers",
  T_49_META_TYPE_7_D: "Numbers are type aliases that refer to integer, 64-bit integer, or floating-point types",
  T_49_META_TYPE_70_D: "Property formulas are used to calculate entity property values, only some player properties and weapon properties are supported for now.",
  T_49_META_TYPE_71_D: "Only used for entities sold in the shop, the concept of shop items is different from that of items purchased.",
  T_49_META_TYPE_72_D: "Contains several shop items.",
  T_49_META_TYPE_73_D: "Contains several shelves.",
  T_49_META_TYPE_74_D: "Item ID",
  T_49_META_TYPE_75_D: "Come Back",
  T_49_META_TYPE_76_D: "Patrol style",
  T_49_META_TYPE_77_D: "A generator entity that can generate and refresh objects.",
  T_49_META_TYPE_78_D: "A unit entity that can be used by the unit generator to absorb and generate units in batches.",
  T_49_META_TYPE_79_D: "Weapon",
  T_49_META_TYPE_8_D: "Conditionals are special Bool types",
  T_49_META_TYPE_80_D: "UI of the shop",
  T_49_META_TYPE_81_D: "Buff Type",
  T_49_META_TYPE_82_D: "UI Heartbeat",
  T_49_META_TYPE_83_D: "Interaction Button",
  T_49_META_TYPE_84_D: "Rankable entity, capable of being ranked",
  T_49_META_TYPE_85_D: "Scoreable entity, has its own score",
  T_49_META_TYPE_86_D: "Property formula factor type",
  T_49_META_TYPE_87_D: "Describes the type of RGBA color, the range of value is 0~255 for each channel.",
  T_49_META_TYPE_88_D: "Currency type, currently only the base currency type",
  T_49_META_TYPE_89_D: "Currency entity, which describes the type and amount of currency.",
  T_49_META_TYPE_9_D: "A set of conditions",
  T_49_META_TYPE_90_D: "Wallet entities are containers for a bunch of currency entities",
  T_49_META_TYPE_91_D: "Indicates an integer or integer array type.",
  T_49_META_TYPE_92_D: "Dynamic Create Level Object Type",
  T_49_META_TYPE_93_D: "Entities with formulable properties",
  T_49_META_TYPE_94_D: "Property modification",
  T_49_META_TYPE_95_D: "Coin Generator",
  T_49_META_TYPE_96_D: "Wallet",
  T_49_META_TYPE_97_D: "Position rotation and scaling, supports parent-child structure",
  T_49_META_TYPE_98_D: "List all available types",
  T_49_META_TYPE_99_D: "Football"
};
export {
  _ as default
};
